// === GENERATED BY scripts/generate_template.py — DO NOT EDIT MANUALLY ===
// Template: Spring Boot Microservices
// Total files: 93

import type { FileTreeNode } from '../types/wizard';

export const springBootDemoFileTree: FileTreeNode[] = [
    {
      name: '.claude',
      path: '.claude',
      type: 'directory',
      children: [
        {
          name: 'rules',
          path: '.claude/rules',
          type: 'directory',
          children: [
            {
              name: 'common',
              path: '.claude/rules/common',
              type: 'directory',
              children: [
                { name: 'coding-style.md', path: '.claude/rules/common/coding-style.md', type: 'file' },
                { name: 'git-workflow.md', path: '.claude/rules/common/git-workflow.md', type: 'file' },
                { name: 'security.md', path: '.claude/rules/common/security.md', type: 'file' },
                { name: 'testing.md', path: '.claude/rules/common/testing.md', type: 'file' },
              ],
            },
            {
              name: 'java',
              path: '.claude/rules/java',
              type: 'directory',
              children: [
                { name: 'coding-style.md', path: '.claude/rules/java/coding-style.md', type: 'file' },
                { name: 'testing.md', path: '.claude/rules/java/testing.md', type: 'file' },
              ],
            },
          ],
        },
        { name: 'settings.json', path: '.claude/settings.json', type: 'file' },
      ],
    },
    { name: '.editorconfig', path: '.editorconfig', type: 'file' },
    { name: '.gitattributes', path: '.gitattributes', type: 'file' },
    {
      name: '.github',
      path: '.github',
      type: 'directory',
      children: [
        { name: 'CODEOWNERS', path: '.github/CODEOWNERS', type: 'file' },
        {
          name: 'ISSUE_TEMPLATE',
          path: '.github/ISSUE_TEMPLATE',
          type: 'directory',
          children: [
            { name: 'ai_task.md', path: '.github/ISSUE_TEMPLATE/ai_task.md', type: 'file' },
            { name: 'bug_report.md', path: '.github/ISSUE_TEMPLATE/bug_report.md', type: 'file' },
            { name: 'feature_request.md', path: '.github/ISSUE_TEMPLATE/feature_request.md', type: 'file' },
          ],
        },
        { name: 'PULL_REQUEST_TEMPLATE.md', path: '.github/PULL_REQUEST_TEMPLATE.md', type: 'file' },
        {
          name: 'workflows',
          path: '.github/workflows',
          type: 'directory',
          children: [
            { name: 'ai-code-audit.yml', path: '.github/workflows/ai-code-audit.yml', type: 'file' },
            { name: 'ci.yml', path: '.github/workflows/ci.yml', type: 'file' },
            { name: 'deploy-production.yml', path: '.github/workflows/deploy-production.yml', type: 'file' },
            { name: 'deploy-staging.yml', path: '.github/workflows/deploy-staging.yml', type: 'file' },
          ],
        },
      ],
    },
    { name: '.gitignore', path: '.gitignore', type: 'file' },
    { name: '.mcp.json', path: '.mcp.json', type: 'file' },
    { name: 'CLAUDE.md', path: 'CLAUDE.md', type: 'file' },
    { name: 'README.md', path: 'README.md', type: 'file' },
    {
      name: 'docs',
      path: 'docs',
      type: 'directory',
      children: [
        { name: 'AI-USAGE-POLICY.md', path: 'docs/AI-USAGE-POLICY.md', type: 'file' },
        { name: 'ARCHITECTURE.md', path: 'docs/ARCHITECTURE.md', type: 'file' },
        { name: 'CONTRIBUTING.md', path: 'docs/CONTRIBUTING.md', type: 'file' },
        { name: 'ONBOARDING.md', path: 'docs/ONBOARDING.md', type: 'file' },
      ],
    },
    {
      name: 'git-hooks',
      path: 'git-hooks',
      type: 'directory',
      children: [
        { name: 'commit-msg', path: 'git-hooks/commit-msg', type: 'file' },
        { name: 'pre-commit', path: 'git-hooks/pre-commit', type: 'file' },
        { name: 'pre-push', path: 'git-hooks/pre-push', type: 'file' },
      ],
    },
    { name: 'install.sh', path: 'install.sh', type: 'file' },
    {
      name: 'mock-mcp-servers',
      path: 'mock-mcp-servers',
      type: 'directory',
      children: [
        { name: 'README.md', path: 'mock-mcp-servers/README.md', type: 'file' },
        { name: 'github-server.mjs', path: 'mock-mcp-servers/github-server.mjs', type: 'file' },
        { name: 'jira-server.mjs', path: 'mock-mcp-servers/jira-server.mjs', type: 'file' },
        { name: 'package.json', path: 'mock-mcp-servers/package.json', type: 'file' },
      ],
    },
    {
      name: 'playbook',
      path: 'playbook',
      type: 'directory',
      children: [
        { name: 'PLAYBOOK.md', path: 'playbook/PLAYBOOK.md', type: 'file' },
        {
          name: 'claude-overrides',
          path: 'playbook/claude-overrides',
          type: 'directory',
          children: [
            { name: '01-discovery.claude.md', path: 'playbook/claude-overrides/01-discovery.claude.md', type: 'file' },
            { name: '02-architecture.claude.md', path: 'playbook/claude-overrides/02-architecture.claude.md', type: 'file' },
            { name: '03-foundation.claude.md', path: 'playbook/claude-overrides/03-foundation.claude.md', type: 'file' },
            { name: '04-core-implementation.claude.md', path: 'playbook/claude-overrides/04-core-implementation.claude.md', type: 'file' },
            { name: '05-integration-hardening.claude.md', path: 'playbook/claude-overrides/05-integration-hardening.claude.md', type: 'file' },
            { name: '06-testing-quality.claude.md', path: 'playbook/claude-overrides/06-testing-quality.claude.md', type: 'file' },
            { name: '07-launch.claude.md', path: 'playbook/claude-overrides/07-launch.claude.md', type: 'file' },
          ],
        },
        { name: 'codeforge-phase.sh', path: 'playbook/codeforge-phase.sh', type: 'file' },
        { name: 'current-phase.json', path: 'playbook/current-phase.json', type: 'file' },
        {
          name: 'phases',
          path: 'playbook/phases',
          type: 'directory',
          children: [
            { name: '01-discovery.md', path: 'playbook/phases/01-discovery.md', type: 'file' },
            { name: '02-architecture.md', path: 'playbook/phases/02-architecture.md', type: 'file' },
            { name: '03-foundation.md', path: 'playbook/phases/03-foundation.md', type: 'file' },
            { name: '04-core-implementation.md', path: 'playbook/phases/04-core-implementation.md', type: 'file' },
            { name: '05-integration-hardening.md', path: 'playbook/phases/05-integration-hardening.md', type: 'file' },
            { name: '06-testing-quality.md', path: 'playbook/phases/06-testing-quality.md', type: 'file' },
            { name: '07-launch.md', path: 'playbook/phases/07-launch.md', type: 'file' },
          ],
        },
        {
          name: 'prompts',
          path: 'playbook/prompts',
          type: 'directory',
          children: [
            {
              name: '01',
              path: 'playbook/prompts/01',
              type: 'directory',
              children: [
                { name: 'gather-requirements.md', path: 'playbook/prompts/01/gather-requirements.md', type: 'file' },
                { name: 'nfr-checklist.md', path: 'playbook/prompts/01/nfr-checklist.md', type: 'file' },
                { name: 'user-stories.md', path: 'playbook/prompts/01/user-stories.md', type: 'file' },
              ],
            },
            {
              name: '02',
              path: 'playbook/prompts/02',
              type: 'directory',
              children: [
                { name: 'adr-generator.md', path: 'playbook/prompts/02/adr-generator.md', type: 'file' },
                { name: 'api-design.md', path: 'playbook/prompts/02/api-design.md', type: 'file' },
                { name: 'data-model-design.md', path: 'playbook/prompts/02/data-model-design.md', type: 'file' },
              ],
            },
            {
              name: '03',
              path: 'playbook/prompts/03',
              type: 'directory',
              children: [
                { name: 'ci-pipeline.md', path: 'playbook/prompts/03/ci-pipeline.md', type: 'file' },
                { name: 'iac-setup.md', path: 'playbook/prompts/03/iac-setup.md', type: 'file' },
                { name: 'project-scaffold.md', path: 'playbook/prompts/03/project-scaffold.md', type: 'file' },
              ],
            },
            {
              name: '04',
              path: 'playbook/prompts/04',
              type: 'directory',
              children: [
                { name: 'auth-implementation.md', path: 'playbook/prompts/04/auth-implementation.md', type: 'file' },
                { name: 'crud-generator.md', path: 'playbook/prompts/04/crud-generator.md', type: 'file' },
                { name: 'feature-implementation.md', path: 'playbook/prompts/04/feature-implementation.md', type: 'file' },
              ],
            },
            {
              name: '05',
              path: 'playbook/prompts/05',
              type: 'directory',
              children: [
                { name: 'integration-adapter.md', path: 'playbook/prompts/05/integration-adapter.md', type: 'file' },
                { name: 'observability-setup.md', path: 'playbook/prompts/05/observability-setup.md', type: 'file' },
                { name: 'security-hardening.md', path: 'playbook/prompts/05/security-hardening.md', type: 'file' },
              ],
            },
            {
              name: '06',
              path: 'playbook/prompts/06',
              type: 'directory',
              children: [
                { name: 'e2e-test-generator.md', path: 'playbook/prompts/06/e2e-test-generator.md', type: 'file' },
                { name: 'load-test.md', path: 'playbook/prompts/06/load-test.md', type: 'file' },
                { name: 'test-suite-generator.md', path: 'playbook/prompts/06/test-suite-generator.md', type: 'file' },
              ],
            },
            {
              name: '07',
              path: 'playbook/prompts/07',
              type: 'directory',
              children: [
                { name: 'go-live-checklist.md', path: 'playbook/prompts/07/go-live-checklist.md', type: 'file' },
                { name: 'monitoring-setup.md', path: 'playbook/prompts/07/monitoring-setup.md', type: 'file' },
                { name: 'runbook-generator.md', path: 'playbook/prompts/07/runbook-generator.md', type: 'file' },
              ],
            },
          ],
        },
      ],
    },
    {
      name: 'plugin',
      path: 'plugin',
      type: 'directory',
      children: [
        {
          name: 'codeforge-spring-boot-microservices',
          path: 'plugin/codeforge-spring-boot-microservices',
          type: 'directory',
          children: [
            {
              name: '.claude-plugin',
              path: 'plugin/codeforge-spring-boot-microservices/.claude-plugin',
              type: 'directory',
              children: [
                { name: 'plugin.json', path: 'plugin/codeforge-spring-boot-microservices/.claude-plugin/plugin.json', type: 'file' },
              ],
            },
            { name: 'README.md', path: 'plugin/codeforge-spring-boot-microservices/README.md', type: 'file' },
            {
              name: 'agents',
              path: 'plugin/codeforge-spring-boot-microservices/agents',
              type: 'directory',
              children: [
                { name: 'architect.md', path: 'plugin/codeforge-spring-boot-microservices/agents/architect.md', type: 'file' },
                { name: 'build-error-resolver.md', path: 'plugin/codeforge-spring-boot-microservices/agents/build-error-resolver.md', type: 'file' },
                { name: 'code-reviewer.md', path: 'plugin/codeforge-spring-boot-microservices/agents/code-reviewer.md', type: 'file' },
                { name: 'planner.md', path: 'plugin/codeforge-spring-boot-microservices/agents/planner.md', type: 'file' },
                { name: 'tdd-guide.md', path: 'plugin/codeforge-spring-boot-microservices/agents/tdd-guide.md', type: 'file' },
              ],
            },
            {
              name: 'commands',
              path: 'plugin/codeforge-spring-boot-microservices/commands',
              type: 'directory',
              children: [
                { name: 'build-fix.md', path: 'plugin/codeforge-spring-boot-microservices/commands/build-fix.md', type: 'file' },
                { name: 'code-review.md', path: 'plugin/codeforge-spring-boot-microservices/commands/code-review.md', type: 'file' },
                { name: 'phase.md', path: 'plugin/codeforge-spring-boot-microservices/commands/phase.md', type: 'file' },
                { name: 'plan.md', path: 'plugin/codeforge-spring-boot-microservices/commands/plan.md', type: 'file' },
                { name: 'tdd.md', path: 'plugin/codeforge-spring-boot-microservices/commands/tdd.md', type: 'file' },
                { name: 'verify.md', path: 'plugin/codeforge-spring-boot-microservices/commands/verify.md', type: 'file' },
              ],
            },
            {
              name: 'hooks',
              path: 'plugin/codeforge-spring-boot-microservices/hooks',
              type: 'directory',
              children: [
                { name: 'hooks.json', path: 'plugin/codeforge-spring-boot-microservices/hooks/hooks.json', type: 'file' },
              ],
            },
            {
              name: 'skills',
              path: 'plugin/codeforge-spring-boot-microservices/skills',
              type: 'directory',
              children: [
                {
                  name: 'build-fix',
                  path: 'plugin/codeforge-spring-boot-microservices/skills/build-fix',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-spring-boot-microservices/skills/build-fix/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'code-review',
                  path: 'plugin/codeforge-spring-boot-microservices/skills/code-review',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-spring-boot-microservices/skills/code-review/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'phase',
                  path: 'plugin/codeforge-spring-boot-microservices/skills/phase',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-spring-boot-microservices/skills/phase/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'plan',
                  path: 'plugin/codeforge-spring-boot-microservices/skills/plan',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-spring-boot-microservices/skills/plan/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'tdd',
                  path: 'plugin/codeforge-spring-boot-microservices/skills/tdd',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-spring-boot-microservices/skills/tdd/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'verify',
                  path: 'plugin/codeforge-spring-boot-microservices/skills/verify',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-spring-boot-microservices/skills/verify/SKILL.md', type: 'file' },
                  ],
                },
              ],
            },
          ],
        },
        { name: 'marketplace.json.example', path: 'plugin/marketplace.json.example', type: 'file' },
      ],
    },
];

export const springBootDemoFileContents: Record<string, string> = {
  '.claude/rules/common/coding-style.md': `# Coding Style Rules

## Naming Conventions

### Java

- **Classes/Interfaces**: PascalCase — \`PaymentService\`, \`OrderRepository\`, \`TransactionEventHandler\`
- **Methods/Variables**: camelCase — \`processPayment()\`, \`orderTotal\`, \`findByCustomerId()\`
- **Constants**: SCREAMING_SNAKE_CASE — \`MAX_RETRY_COUNT\`, \`DEFAULT_TIMEOUT_MS\`, \`KAFKA_CONSUMER_GROUP\`
- **Packages**: lowercase, dot-separated — \`com.fintech.payment.domain.model\`
- **Enums**: PascalCase type, SCREAMING_SNAKE_CASE values — \`TransactionStatus.PENDING_APPROVAL\`
- **Type Parameters**: Single uppercase letter or descriptive — \`T\`, \`E\`, \`ID\`, \`EventT\`

### Kotlin

- **Classes/Interfaces**: PascalCase — \`KafkaEventPublisher\`, \`DomainEventSchema\`
- **Functions/Properties**: camelCase — \`publishEvent()\`, \`schemaVersion\`
- **Constants**: SCREAMING_SNAKE_CASE in companion objects — \`companion object { const val SCHEMA_VERSION = 1 }\`
- **Extension Functions**: camelCase, named for clarity — \`String.toKafkaTopic()\`, \`Event.toAvro()\`

### Modules and Infrastructure

- **Gradle Modules**: kebab-case — \`order-service\`, \`payment-service\`, \`shared-domain-events\`
- **Kafka Topics**: kebab-case with domain prefix — \`payment.transaction-created\`, \`order.status-updated\`
- **Consumer Groups**: kebab-case with service suffix — \`payment-service-transaction-group\`
- **Spring Profiles**: lowercase — \`local\`, \`dev\`, \`staging\`, \`production\`
- **Helm Charts**: kebab-case matching service name — \`charts/order-service/\`
- **Database Tables**: snake_case — \`payment_transactions\`, \`order_line_items\`
- **REST Endpoints**: kebab-case, plural nouns — \`/api/v1/payment-transactions\`, \`/api/v1/orders\`

## File Structure

### Maximum File Length

300 lines per file. If a file exceeds this, decompose it:
- Extract inner classes to their own files
- Split large services into domain-specific collaborators
- Move constants to dedicated constant classes
- Break large test classes by scenario grouping

### Java Source File Layout

Follow this ordering within every \`.java\` file:

\`\`\`
1. Package declaration
2. (blank line)
3. Import statements (ordered — see below)
4. (blank line)
5. Class/Interface Javadoc
6. Class/Interface declaration
   a. Static constants (public → protected → package → private)
   b. Instance fields (public → protected → package → private)
   c. Constructors
   d. Public methods
   e. Package-private methods
   f. Protected methods
   g. Private methods
   h. Inner classes / enums
\`\`\`

### Kotlin Source File Layout

\`\`\`
1. Package declaration
2. (blank line)
3. Import statements
4. (blank line)
5. Top-level declarations (prefer one primary class per file)
   a. Companion object
   b. Properties
   c. Init blocks
   d. Public functions
   e. Internal functions
   f. Private functions
   g. Extension functions (at bottom of file or in dedicated extension files)
\`\`\`

### Hexagonal Architecture File Organization

Each microservice follows Ports & Adapters. Organize packages accordingly:

\`\`\`
services/payment-service/src/main/java/com/fintech/payment/
├── domain/
│   ├── model/              # Entities, value objects, aggregates
│   ├── event/              # Domain events
│   ├── exception/          # Domain-specific exceptions
│   └── service/            # Domain services (pure business logic)
├── application/
│   ├── port/
│   │   ├── in/             # Inbound ports (use cases)
│   │   └── out/            # Outbound ports (repository interfaces, event publisher interfaces)
│   └── service/            # Application services (orchestrate use cases)
├── adapter/
│   ├── in/
│   │   ├── web/            # REST controllers, request/response DTOs
│   │   └── kafka/          # Kafka consumers (inbound event handlers)
│   └── out/
│       ├── persistence/    # JPA repositories, entity mappers, DB adapters
│       ├── kafka/          # Kafka producers (outbound event publishing)
│       └── redis/          # Cache adapters
└── config/                 # Spring configuration, beans, security config
\`\`\`

Do not place business logic in adapters. Controllers delegate to application services. Application services call domain services through ports.

## Import Ordering

### Java Imports

Configure Checkstyle and IDE to enforce this order with a blank line between each group:

\`\`\`
1. java.*
2. javax.*
3. jakarta.*
4. (blank line)
5. org.springframework.*
6. org.apache.kafka.*
7. (blank line)
8. org.* (other third-party)
9. com.* (other third-party)
10. (blank line)
11. com.fintech.* (project imports)
\`\`\`

- **No wildcard imports** — always use explicit class imports
- **No unused imports** — enforced by Checkstyle
- **Static imports** go after all regular imports, same group ordering, separated by a blank line

### Kotlin Imports

ktlint enforces alphabetical ordering. Additionally:

- No wildcard imports
- No unused imports
- Alias imports only when resolving genuine name collisions

## Formatting

### Java — google-java-format

All Java code is formatted with google-java-format. Non-negotiable. Run before every commit:

\`\`\`bash
./gradlew spotlessApply
\`\`\`

Key rules enforced:
- 2-space indentation (google-java-format default)
- Column limit: 100 characters
- Braces on same line (K&R style)
- One statement per line
- No trailing whitespace

### Kotlin — ktlint

All Kotlin code is formatted with ktlint:

\`\`\`bash
./gradlew ktlintFormat
\`\`\`

Key rules enforced:
- 4-space indentation
- No semicolons
- No wildcard imports
- Trailing commas in multi-line declarations

## Type and Method Guidelines

### Prefer Immutability

- Use \`final\` on fields and local variables in Java wherever possible
- Use \`val\` over \`var\` in Kotlin
- Domain model objects should be immutable — use Java records or Kotlin data classes
- Return unmodifiable collections from public methods

### Method Design

- Methods should do one thing — single responsibility at the method level
- Maximum 5 parameters; use a request/command object beyond that
- Avoid boolean parameters — use enums or separate methods
- Return \`Optional<T>\` instead of null for query methods in Java
- Throw domain-specific exceptions, not generic ones

### Constructor Injection

Always use constructor injection for Spring beans. No \`@Autowired\` on fields:

\`\`\`java
// Correct
@Service
public class PaymentApplicationService {
    private final ProcessPaymentUseCase processPaymentUseCase;
    private final PaymentEventPublisher eventPublisher;

    public PaymentApplicationService(
            ProcessPaymentUseCase processPaymentUseCase,
            PaymentEventPublisher eventPublisher) {
        this.processPaymentUseCase = processPaymentUseCase;
        this.eventPublisher = eventPublisher;
    }
}
\`\`\`

For Kotlin, use primary constructor injection directly:

\`\`\`kotlin
@Service
class EventSchemaValidator(
    private val schemaRegistry: SchemaRegistryClient,
    private val objectMapper: ObjectMapper,
)
\`\`\`

### Records and Data Classes

Use Java records for DTOs, commands, queries, and value objects:

\`\`\`java
public record CreatePaymentCommand(
    UUID orderId,
    BigDecimal amount,
    Currency currency,
    String idempotencyKey
) {}
\`\`\`

Use Kotlin data classes for shared library types:

\`\`\`kotlin
data class PaymentCreatedEvent(
    val paymentId: UUID,
    val orderId: UUID,
    val amount: BigDecimal,
    val currency: String,
    val occurredAt: Instant,
)
\`\`\`

## Documentation

- All public classes and interfaces require Javadoc/KDoc with a summary sentence
- All public methods on ports (use case interfaces) require documentation describing the contract
- Domain events require documentation describing when they are emitted and what they represent
- REST controllers require OpenAPI annotations (\`@Operation\`, \`@ApiResponse\`)
- No documentation on private methods unless the logic is genuinely non-obvious
- Prefer self-documenting code over comments — rename before adding a clarifying comment

## Anti-Patterns to Avoid

- **God classes** — no class should handle multiple unrelated responsibilities
- **Anemic domain models** — domain entities should contain behavior, not just getters
- **Direct inter-service REST calls** — all service-to-service communication goes through Kafka
- **Shared mutable state** — no static mutable fields, no shared caches without proper synchronization
- **Catching generic exceptions** — catch specific exceptions; let unexpected errors propagate
- **String typing** — use enums, value objects, or typed IDs instead of raw strings for domain concepts
- **Logging sensitive data** — never log PII, card numbers, tokens, or secrets (PCI DSS requirement)`,

  '.claude/rules/common/git-workflow.md': `# Git Workflow Rules

## Branching Strategy

This project follows **GitHub Flow** — short-lived feature branches off \`main\`, merged back via pull request.

### Protected Branches

- \`main\` — production-ready code, always deployable
- \`release/*\` — release stabilization branches (e.g., \`release/2024.1\`)

Direct pushes to protected branches are blocked. All changes go through pull requests.

### Branch Naming Convention

Format: \`type/TICKET-description\`

| Type | Purpose | Example |
|------|---------|---------|
| \`feat\` | New feature or capability | \`feat/PAY-123-add-payment-service\` |
| \`fix\` | Bug fix | \`fix/ORD-456-order-total-calculation\` |
| \`chore\` | Build, CI, dependency updates | \`chore/INF-789-upgrade-spring-boot\` |
| \`docs\` | Documentation only | \`docs/USR-101-api-spec-update\` |
| \`refactor\` | Code restructuring, no behavior change | \`refactor/PAY-202-extract-payment-port\` |
| \`test\` | Adding or fixing tests | \`test/ORD-303-order-contract-tests\` |
| \`hotfix\` | Urgent production fix | \`hotfix/PAY-911-payment-timeout\` |

Rules:
- Always include the Jira ticket ID (e.g., \`PAY-123\`, \`ORD-456\`, \`USR-101\`)
- Use kebab-case for the description portion
- Keep descriptions concise — 3-5 words maximum
- Branch from \`main\` unless working on a release stabilization

## Commit Standards

### Conventional Commits (Required)

Every commit message must follow the [Conventional Commits](https://www.conventionalcommits.org/) specification:

\`\`\`
type(scope): description

[optional body]

[optional footer(s)]
\`\`\`

### Commit Types

| Type | When to Use |
|------|-------------|
| \`feat\` | New feature visible to users or other services |
| \`fix\` | Bug fix |
| \`chore\` | Maintenance — build config, CI, dependencies |
| \`docs\` | Documentation changes only |
| \`refactor\` | Code change that neither fixes a bug nor adds a feature |
| \`test\` | Adding or correcting tests |
| \`perf\` | Performance improvement |
| \`ci\` | CI/CD pipeline changes |
| \`style\` | Formatting, whitespace — no logic change |

### Scope

Scope should reference the affected module or service:

- \`order-service\`, \`payment-service\`, \`user-service\` — individual microservices
- \`gateway\` — API gateway module
- \`shared\` — shared libraries
- \`schema-registry\` — Kafka event schemas
- \`infra\` — Terraform, Kubernetes, Helm
- \`ci\` — GitHub Actions workflows
- \`deps\` — dependency updates

### Examples

\`\`\`
feat(payment-service): add idempotency key support for payment creation

Implements idempotency using Redis to prevent duplicate payment processing.
Stores idempotency keys with a 24-hour TTL.

Refs: PAY-123
\`\`\`

\`\`\`
fix(order-service): correct total calculation for multi-currency orders

The order total was not converting line items to the order's base currency
before summing. Added CurrencyConversionPort to the OrderTotalCalculator.

Fixes: ORD-456
\`\`\`

\`\`\`
chore(deps): upgrade Spring Boot to 3.2.5

- Updates spring-boot-starter-parent to 3.2.5
- Resolves CVE-2024-XXXXX in spring-web
- All integration tests passing with Testcontainers

Refs: INF-789
\`\`\`

\`\`\`
refactor(payment-service): extract PaymentGatewayPort to hexagonal adapter

Moves Stripe integration behind a port interface to align with
hexagonal architecture. No behavior change.

Refs: PAY-202
\`\`\`

### Commit Rules

- **Reference the Jira ticket** in the footer (\`Refs:\` or \`Fixes:\`)
- **One logical change per commit** — don't mix refactoring with feature work
- **Subject line**: imperative mood, lowercase after type, no period, max 72 characters
- **Body**: explain *what* and *why*, not *how* — the code shows how
- **Never commit**: secrets, credentials, \`.env\` files, IDE configs, build artifacts

## Signed Commits (Required)

All commits must be GPG or SSH signed. Unsigned commits will be rejected by branch protection.

Configure signing:
\`\`\`bash
git config --global commit.gpgsign true
git config --global tag.gpgsign true
\`\`\`

This is a **SOC 2 and PCI DSS compliance requirement** — every code change must have a verified author identity.

## Pull Request Requirements

### Before Opening a PR

1. **Rebase on latest \`main\`**: \`git fetch origin && git rebase origin/main\`
2. **Run the full local check**: \`./gradlew build\` (compiles, runs Checkstyle/ktlint, unit tests, SpotBugs)
3. **Run integration tests** for affected services: \`./gradlew :services:payment-service:integrationTest\`
4. **Verify coverage threshold**: \`./gradlew jacocoTestCoverageVerification\` (minimum 80%)
5. **Check for secrets**: ensure no credentials, API keys, or tokens are in the diff
6. **Ensure commits are signed**: \`git log --show-signature -3\`

### PR Title Format

Follow the same conventional commit format:
\`\`\`
feat(payment-service): add idempotency key support [PAY-123]
\`\`\`

### PR Description Template

Every PR must include:
- **What**: Summary of the change
- **Why**: Business context and Jira ticket link
- **How**: Technical approach (especially for non-obvious decisions)
- **Testing**: What was tested and how (unit, integration, contract, manual)
- **Kafka Impact**: Any new topics, schema changes, or consumer group modifications
- **Database Impact**: Any migrations, new tables, or index changes
- **Breaking Changes**: Any backward-incompatible changes to APIs or event schemas
- **Deployment Notes**: Special deployment steps, feature flags, or rollback considerations

### Approval Requirements

| Condition | Requirement |
|-----------|-------------|
| Minimum approvals | **2 reviewers** |
| CI checks | All must pass (lint, compile, unit tests, integration tests, contract tests, security scan) |
| Security scan | OWASP dependency-check and SpotBugs must pass |
| Code ownership | CODEOWNERS approval required for owned paths |
| Sensitive paths | Additional security team review (see below) |

### Sensitive Path Reviews

Changes to these paths require **security team approval** in addition to standard reviews:

- \`**/security/**\` — authentication, authorization, encryption logic
- \`**/auth/**\` — OAuth, JWT, session management
- \`infrastructure/production/**\` — production Terraform, Kubernetes configs
- \`*.properties\` — application configuration (may contain connection strings)
- \`charts/*/values-production.yaml\` — production Helm values
- \`schema-registry/**\` — event schemas (backward compatibility implications)

See \`.claude/rules/common/security.md\` for full security review guidelines.

### CODEOWNERS Enforcement

The \`CODEOWNERS\` file maps paths to responsible teams:

\`\`\`
services/payment-service/    @fintech-org/payments-team
services/order-service/      @fintech-org/orders-team
services/user-service/       @fintech-org/identity-team
gateway/                     @fintech-org/platform-team
shared/                      @fintech-org/platform-team
infrastructure/              @fintech-org/devops-team
charts/                      @fintech-org/devops-team
schema-registry/             @fintech-org/platform-team
**/security/**               @fintech-org/security-team
**/auth/**                   @fintech-org/security-team
\`\`\`

### AI-Generated Code

When Claude Code or any AI tool generates or substantially modifies code:

- The PR must be labeled with \`ai-assisted\`
- Commit messages should include \`[ai-assisted]\` in the footer
- Reviewers should pay particular attention to: security implications, edge cases, test coverage, and compliance with hexagonal architecture patterns
- AI-generated code is held to the same quality and review standards as human-written code

## Merge Strategy

- **Squash merge** for feature branches into \`main\` — keeps history clean
- **Merge commit** for release branches — preserves release history
- Delete the source branch after merge
- The squashed commit message should follow conventional commit format

## Workflow Summary

\`\`\`
1. Pick up Jira ticket (e.g., PAY-123)
2. Create branch: git checkout -b feat/PAY-123-add-payment-idempotency
3. Implement with signed conventional commits
4. Run locally: ./gradlew build && ./gradlew integrationTest
5. Push and open PR with proper title and description
6. CI pipeline runs all stages (lint → security scan → contract tests)
7. Get 2+ approvals (+ security team if sensitive paths)
8. Squash merge to main
9. Staging auto-deploys; verify in staging
10. Production deploy via manual promotion
\`\`\``,

  '.claude/rules/common/security.md': `# Security Rules — Spring Boot Microservices

## Compliance Framework

This platform operates under **SOC 2 Type II** and **PCI DSS v4.0** compliance requirements. Every code change touching authentication, authorization, data handling, or infrastructure must be evaluated against these standards. Non-compliance is a blocking issue — no exceptions.

## Authentication & Authorization

### Spring Security Configuration

- Use Spring Security 6.x with SecurityFilterChain bean configuration — never extend WebSecurityConfigurerAdapter (deprecated)
- All services must enforce authentication by default; explicitly permit only health check and readiness endpoints:
  \`\`\`
  /actuator/health
  /actuator/health/readiness
  /actuator/health/liveness
  /actuator/info
  \`\`\`
- Every other endpoint requires a valid JWT bearer token
- Use \`@PreAuthorize\` or \`@Secured\` annotations for method-level authorization — never rely solely on URL-pattern matching
- Role hierarchy must be defined in the shared security library under \`shared/security-lib/\`

### JWT Handling

- JWT tokens are issued by the \`user-service\` and validated by each service independently using a shared public key
- Token signing uses RS256 (RSA with SHA-256) — never use HS256 or symmetric keys in production
- Access tokens expire in 15 minutes; refresh tokens expire in 24 hours
- Store the JWT signing private key in AWS Secrets Manager — never in application properties, environment variables, or source code
- Validate all JWT claims: \`iss\`, \`aud\`, \`exp\`, \`nbf\`, \`sub\`, \`roles\`
- Reject tokens with missing or unexpected claims — fail closed
- Include \`jti\` (JWT ID) claim for token revocation support via Redis blacklist

### Service-to-Service Authentication

- Kafka-based communication does not use JWT — Kafka uses mTLS for broker authentication and SASL/SCRAM for client authentication
- If any synchronous internal call is absolutely necessary (strongly discouraged), use mTLS with client certificates — never shared API keys
- The API gateway (\`gateway/\`) is the only ingress point for external traffic; internal services are not exposed externally

## Secrets Management

### Prohibited Practices

- **Never** commit secrets, credentials, API keys, tokens, certificates, or private keys to the repository
- **Never** log secrets, tokens, or PII at any log level including DEBUG and TRACE
- **Never** include secrets in Kafka event payloads
- **Never** hardcode credentials in \`application.yml\`, \`application.properties\`, or Dockerfiles
- **Never** pass secrets as command-line arguments or Gradle build parameters
- **Never** store secrets in ConfigMaps — use Kubernetes Secrets with encryption at rest

### Required Practices

- Use AWS Secrets Manager for all production secrets (database credentials, signing keys, API keys)
- Use Spring Cloud AWS Secrets Manager integration or External Secrets Operator in Kubernetes
- Reference secrets in \`application.yml\` via \`\${sm://secret-name}\` or environment variable injection from K8s Secrets
- Rotate database credentials every 90 days using AWS Secrets Manager automatic rotation
- Rotate JWT signing keys every 180 days with a grace period supporting both old and new keys
- Use \`.env.example\` files with placeholder values — never \`.env\` files with real values
- The \`.gitignore\` must exclude: \`*.pem\`, \`*.key\`, \`*.p12\`, \`*.jks\`, \`.env\`, \`*-secret.yml\`, \`*-credentials.*\`

## Sensitive Code Paths

Changes to these paths require **mandatory security review** by a lead engineer or security team member:

- \`**/security/**\` — authentication and authorization logic
- \`**/auth/**\` — token issuance, validation, refresh
- \`**/crypto/**\` — encryption, hashing, signing
- \`**/config/SecurityConfig*\` — Spring Security filter chain configuration
- \`infrastructure/production/**\` — production Terraform and K8s manifests
- \`charts/**/values-production.yaml\` — production Helm values
- \`*.properties\` — may contain connection strings or config that references secrets
- \`gateway/src/**\` — API gateway routing, rate limiting, CORS
- \`shared/security-lib/**\` — shared security utilities used by all services

## Data Protection

### PCI DSS Requirements

- **Never** store full credit card numbers (PAN) — use tokenization via a PCI-compliant payment processor
- If PAN must transit through the system, mask all but the last 4 digits in logs, events, and API responses
- Cardholder data must be encrypted at rest (AES-256) and in transit (TLS 1.2+)
- The \`payment-service\` operates in the Cardholder Data Environment (CDE) — apply additional network segmentation and access controls
- Audit logging is mandatory for all access to payment data — use structured logging to the ELK stack

### Encryption

- All inter-service communication uses TLS 1.2 or higher — enforce in Kubernetes network policies and Kafka broker config
- PostgreSQL connections require SSL: \`spring.datasource.url\` must include \`sslmode=require\`
- Redis connections require TLS: configure \`spring.data.redis.ssl.enabled=true\`
- Kafka connections use TLS for encryption and mTLS or SASL for authentication
- Use \`AES-256-GCM\` for application-level encryption of sensitive fields (SSN, account numbers)
- Encryption keys are managed in AWS KMS — never implement custom key management

### PII Handling

- Personally Identifiable Information (PII) must be identified and classified in domain models using \`@SensitiveField\` annotation from \`shared/security-lib/\`
- PII fields are automatically redacted in log output via a custom Logback filter
- PII must not appear in Kafka event payloads unless the event schema explicitly marks the field as PII-containing and the topic has appropriate access controls
- Implement data retention policies: PII older than the retention period must be anonymized or deleted
- GDPR right-to-erasure requests must be supported via the \`user-service\` data deletion API

## Input Validation & Injection Prevention

- Validate all external input at the controller layer using Bean Validation (\`@Valid\`, \`@NotNull\`, \`@Size\`, \`@Pattern\`)
- Use parameterized queries exclusively — Spring Data JPA handles this by default, but verify any \`@Query\` annotations use named parameters
- Never concatenate user input into SQL, JPQL, HQL, or native queries
- Sanitize all input that will be reflected in responses to prevent XSS
- Validate and sanitize file uploads: check MIME type, file size, and content — never trust the \`Content-Type\` header alone
- Reject unexpected fields in JSON payloads — configure Jackson to fail on unknown properties for external-facing APIs
- Apply rate limiting at the API gateway level: default 100 requests/minute per client, configurable per endpoint

## Kafka Security

- All Kafka topics containing sensitive data must use topic-level ACLs restricting producer and consumer access to specific service accounts
- Event schemas in \`schema-registry/\` must document which fields contain sensitive data
- Consumer groups must be named following the pattern \`{service-name}-{topic-name}-group\` for auditability
- Enable Kafka audit logging for topic creation, ACL changes, and consumer group modifications
- Dead letter topics (\`*.DLT\`) must have the same security controls as their source topics
- Never deserialize Kafka messages using \`Object\` type — always use strongly-typed Avro or JSON Schema deserializers to prevent deserialization attacks

## Dependency Security

- Run OWASP Dependency-Check in CI on every build: \`./gradlew dependencyCheckAnalyze\`
- Fail the build on any CVE with CVSS score ≥ 7.0 (HIGH or CRITICAL)
- Review and update dependencies monthly; critical security patches within 48 hours
- Use only approved dependencies from the team's vetted dependency list in \`docs/approved-dependencies.md\`
- Pin all dependency versions in \`gradle/libs.versions.toml\` — never use dynamic versions (\`+\`, \`latest.release\`)
- Container base images must use Eclipse Temurin JDK 21 on Alpine — scan with Trivy in CI

## Audit Logging

- Log all authentication events: login success, login failure, token refresh, token revocation
- Log all authorization failures with the requested resource, action, and principal
- Log all data access to PCI-scoped entities (payment records, cardholder data references)
- Use structured JSON logging with correlation IDs from distributed tracing (Jaeger trace ID)
- Audit logs must be immutable — ship to the ELK stack with write-once index policies
- Retain audit logs for minimum 1 year (SOC 2) and 1 year (PCI DSS) — configure in the ELK retention policy
- Never log request/response bodies for endpoints handling sensitive data — log only metadata (endpoint, status code, principal, timestamp)

## Security Headers & API Gateway

- The API gateway (\`gateway/\`) must set the following response headers on all responses:
  - \`Strict-Transport-Security: max-age=31536000; includeSubDomains\`
  - \`X-Content-Type-Options: nosniff\`
  - \`X-Frame-Options: DENY\`
  - \`X-XSS-Protection: 0\` (rely on CSP instead)
  - \`Content-Security-Policy: default-src 'none'\` (for API responses)
  - \`Cache-Control: no-store\` (for authenticated responses)
- CORS must be configured explicitly per allowed origin — never use \`allowedOrigins("*")\` in production
- Disable Spring Boot error details in production: \`server.error.include-message=never\`, \`server.error.include-stacktrace=never\`

## Security Testing

- Run SpotBugs with the Find Security Bugs plugin in CI: \`./gradlew spotbugsMain\`
- Include SAST scanning in the GitHub Actions pipeline before Docker image build
- Contract tests (Pact) must verify that sensitive fields are not leaked in API responses
- Integration tests using Testcontainers must validate that unauthenticated requests return 401 and unauthorized requests return 403
- Penetration testing is conducted quarterly — findings are tracked in Jira with \`security\` label

## Incident Response

- If a secret is accidentally committed, immediately:
  1. Rotate the compromised credential
  2. Force-push to remove the commit from history (coordinate with team leads)
  3. Audit access logs for unauthorized use
  4. File a security incident in Jira with priority P1
  5. Notify the security team via the \`#security-incidents\` Slack channel
- All security incidents must be documented in \`docs/security/incidents/\` with root cause analysis and remediation steps`,

  '.claude/rules/common/testing.md': `# Testing Standards

## Coverage Requirements

- **Minimum line coverage**: 80% per module (enforced by JaCoCo)
- **New code coverage**: 90% minimum for new/modified code in PRs
- **Coverage report**: generated via \`./gradlew jacocoTestReport\`
- **Coverage verification**: \`./gradlew jacocoTestCoverageVerification\` — fails build if below threshold
- **Excluded from coverage**: generated code, DTOs in \`*.dto\` packages, Spring Boot main classes, configuration classes annotated with \`@Configuration\`

## Test Classification

### Unit Tests

- **Location**: \`src/test/java/\` within each service module
- **Naming**: \`{ClassName}Test.java\` — e.g., \`PaymentDomainServiceTest.java\`
- **Framework**: JUnit 5 + Mockito + AssertJ
- **Execution**: \`./gradlew test\`
- **Rules**:
  - No Spring context loading — use \`@ExtendWith(MockitoExtension.class)\`, never \`@SpringBootTest\`
  - No network calls, no filesystem access, no database access
  - Mock all ports (interfaces) in hexagonal architecture — test domain logic in isolation
  - Each test method tests one behavior — name it \`should_expectedBehavior_when_condition\`
  - Use \`@Nested\` classes to group related scenarios
  - Prefer \`given_when_then\` structure with clear arrange/act/assert sections
  - Keep under 20 lines per test method

\`\`\`java
// Correct: unit test for domain service
@ExtendWith(MockitoExtension.class)
class PaymentDomainServiceTest {

    @Mock
    private PaymentRepository paymentRepository;

    @Mock
    private EventPublisher eventPublisher;

    @InjectMocks
    private PaymentDomainService paymentDomainService;

    @Nested
    class ProcessPayment {

        @Test
        void should_createPaymentAndPublishEvent_when_validRequest() {
            // given
            var request = PaymentFixtures.validPaymentRequest();
            given(paymentRepository.save(any())).willReturn(PaymentFixtures.savedPayment());

            // when
            var result = paymentDomainService.processPayment(request);

            // then
            assertThat(result.status()).isEqualTo(PaymentStatus.PENDING);
            then(eventPublisher).should().publish(any(PaymentInitiatedEvent.class));
        }
    }
}
\`\`\`

### Integration Tests

- **Location**: \`src/integrationTest/java/\` (separate source set per module)
- **Naming**: \`{ClassName}IntegrationTest.java\` — e.g., \`PaymentRepositoryIntegrationTest.java\`
- **Framework**: JUnit 5 + Spring Boot Test + Testcontainers
- **Execution**: \`./gradlew integrationTest\`
- **Rules**:
  - Use \`@SpringBootTest\` only for integration tests — never for unit tests
  - Use Testcontainers for all external dependencies — PostgreSQL, Redis, Kafka
  - Extend from a shared base class per service that manages container lifecycle
  - Use \`@DynamicPropertySource\` to inject container connection details
  - Tag with \`@Tag("integration")\` for selective execution
  - Each integration test must be independent — use \`@Transactional\` or explicit cleanup
  - Do not share state between test classes

\`\`\`java
// Correct: integration test with Testcontainers
@SpringBootTest
@Tag("integration")
@Testcontainers
class PaymentRepositoryIntegrationTest {

    @Container
    static PostgreSQLContainer<?> postgres = new PostgreSQLContainer<>("postgres:16-alpine")
            .withDatabaseName("payment_test")
            .withUsername("test")
            .withPassword("test");

    @DynamicPropertySource
    static void configureProperties(DynamicPropertyRegistry registry) {
        registry.add("spring.datasource.url", postgres::getJdbcUrl);
        registry.add("spring.datasource.username", postgres::getUsername);
        registry.add("spring.datasource.password", postgres::getPassword);
    }

    @Autowired
    private PaymentRepository paymentRepository;

    @Test
    @Transactional
    void should_persistAndRetrievePayment_when_validEntity() {
        var payment = PaymentFixtures.validPayment();
        var saved = paymentRepository.save(payment);

        var found = paymentRepository.findById(saved.getId());

        assertThat(found).isPresent();
        assertThat(found.get().getAmount()).isEqualByComparingTo(payment.getAmount());
    }
}
\`\`\`

### Kafka Integration Tests

- **Container**: Use \`KafkaContainer\` from Testcontainers with \`confluentinc/cp-kafka\`
- **Rules**:
  - Test both producer and consumer paths
  - Use \`@EmbeddedKafka\` only if Testcontainers is not feasible — prefer Testcontainers
  - Verify event serialization/deserialization matches schema registry schemas
  - Use \`Awaitility\` for async assertions on consumed messages — never \`Thread.sleep()\`
  - Set consumer \`auto.offset.reset=earliest\` in test profiles
  - Verify dead-letter topic routing for failed messages

\`\`\`java
@SpringBootTest
@Tag("integration")
@Testcontainers
class PaymentEventPublisherIntegrationTest {

    @Container
    static KafkaContainer kafka = new KafkaContainer(
            DockerImageName.parse("confluentinc/cp-kafka:7.6.0"));

    @DynamicPropertySource
    static void kafkaProperties(DynamicPropertyRegistry registry) {
        registry.add("spring.kafka.bootstrap-servers", kafka::getBootstrapServers);
    }

    @Autowired
    private PaymentEventPublisher publisher;

    @Autowired
    private KafkaConsumer<String, PaymentInitiatedEvent> testConsumer;

    @Test
    void should_publishPaymentInitiatedEvent_when_paymentProcessed() {
        var event = PaymentFixtures.paymentInitiatedEvent();

        publisher.publish(event);

        await().atMost(Duration.ofSeconds(10)).untilAsserted(() -> {
            var records = testConsumer.poll(Duration.ofMillis(500));
            assertThat(records).hasSize(1);
            assertThat(records.iterator().next().value().paymentId())
                    .isEqualTo(event.paymentId());
        });
    }
}
\`\`\`

### Contract Tests

- **Location**: \`tests/contract/\` (project-level) and \`src/contractTest/java/\` (per service)
- **Framework**: Pact (JVM)
- **Execution**: \`./gradlew contractTest\`
- **Rules**:
  - Every Kafka event schema must have a Pact contract between producer and consumer
  - API gateway contracts define consumer expectations for downstream services
  - Contracts are published to the Pact Broker as part of CI
  - Use \`@PactTestFor\` for consumer-side verification
  - Use \`@Provider\` and \`@PactBroker\` for provider-side verification
  - Contract tests run before Docker image build in CI — broken contracts block deployment
  - Version contracts with the service version — use \`can-i-deploy\` before production deploys

\`\`\`java
// Consumer-side contract test
@ExtendWith(PactConsumerTestExt.class)
@PactTestFor(providerName = "payment-service", pactVersion = PactSpecVersion.V4)
class OrderServicePaymentContractTest {

    @Pact(consumer = "order-service")
    V4Pact paymentInitiatedEvent(MessagePactBuilder builder) {
        return builder
                .expectsToReceive("a payment initiated event")
                .withContent(new PactDslJsonBody()
                        .stringType("paymentId")
                        .stringType("orderId")
                        .decimalType("amount")
                        .stringType("currency", "USD")
                        .stringType("status", "INITIATED"))
                .toPact(V4Pact.class);
    }

    @Test
    @PactTestFor(pactMethod = "paymentInitiatedEvent")
    void should_consumePaymentInitiatedEvent(List<Message> messages) {
        assertThat(messages).hasSize(1);
        var event = objectMapper.readValue(
                messages.get(0).contentsAsString(), PaymentInitiatedEvent.class);
        assertThat(event.status()).isEqualTo("INITIATED");
    }
}
\`\`\`

## Test Fixtures and Factories

- Place shared test fixtures in \`src/test/java/{package}/fixtures/\` — e.g., \`PaymentFixtures.java\`
- Use static factory methods — never public constructors in test data builders
- Shared cross-service test fixtures go in \`shared/test-support/\` module
- Name fixture methods descriptively: \`validPaymentRequest()\`, \`expiredPayment()\`, \`paymentWithInsufficientFunds()\`
- Never use random data in fixtures unless testing randomness — deterministic tests are reproducible

\`\`\`java
public final class PaymentFixtures {

    private PaymentFixtures() {}

    public static PaymentRequest validPaymentRequest() {
        return new PaymentRequest(
                "order-123",
                new BigDecimal("99.99"),
                Currency.USD,
                "customer-456"
        );
    }

    public static Payment savedPayment() {
        return Payment.builder()
                .id(UUID.fromString("550e8400-e29b-41d4-a716-446655440000"))
                .orderId("order-123")
                .amount(new BigDecimal("99.99"))
                .status(PaymentStatus.PENDING)
                .createdAt(Instant.parse("2024-01-15T10:30:00Z"))
                .build();
    }
}
\`\`\`

## Hexagonal Architecture Test Strategy

- **Domain layer** (entities, value objects, domain services): unit tests only — no Spring, no mocks of domain objects
- **Application layer** (use cases, port interfaces): unit tests with mocked ports
- **Adapter layer** (REST controllers, Kafka consumers/producers, JPA repositories): integration tests with Testcontainers
- **Never** test adapters with mocked repositories — use Testcontainers to verify real database behavior
- **Never** mock domain objects — if you need to mock a domain entity, the design is wrong

## Spring-Specific Testing Patterns

### REST Controller Tests

- Use \`@WebMvcTest\` for controller-layer tests — loads only the web layer
- Use \`MockMvc\` for request/response assertions
- Test security annotations (\`@PreAuthorize\`, \`@Secured\`) in controller tests
- Verify OpenAPI spec compliance in controller tests

### Spring Security Tests

- Use \`@WithMockUser\` or custom \`@WithMockJwt\` for authenticated test scenarios
- Test both authorized and unauthorized paths — verify 401 and 403 responses
- PCI DSS requirement: test that sensitive endpoints reject unauthenticated requests
- Test CORS configuration in integration tests

### Spring Kafka Tests

- Use \`@KafkaListener\` test containers to verify consumer behavior
- Test idempotency — send the same event twice, verify single processing
- Test poison pill handling — verify malformed messages route to DLT (dead-letter topic)
- Test consumer group rebalancing behavior for critical flows

## Async Testing

- **Always** use Awaitility for async assertions — never \`Thread.sleep()\`
- Default timeout: 10 seconds for integration tests, 30 seconds for E2E
- Use \`pollInterval\` of 100ms to avoid excessive polling

\`\`\`java
await()
    .atMost(Duration.ofSeconds(10))
    .pollInterval(Duration.ofMillis(100))
    .untilAsserted(() -> {
        var payment = paymentRepository.findById(paymentId);
        assertThat(payment).isPresent();
        assertThat(payment.get().getStatus()).isEqualTo(PaymentStatus.COMPLETED);
    });
\`\`\`

## Test Profiles

- \`application-test.yml\` — base test configuration (in-memory defaults, disabled external calls)
- \`application-integration-test.yml\` — Testcontainers-compatible settings
- Never reference real AWS resources, Kafka clusters, or databases in test profiles
- Disable Spring Cloud Config Server in test profiles: \`spring.cloud.config.enabled=false\`
- Disable Eureka/service discovery in test profiles: \`eureka.client.enabled=false\`

## What NOT to Test

- Getters, setters, and \`toString()\` on DTOs — these are generated or trivial
- Spring Boot auto-configuration — trust the framework
- Third-party library internals
- Private methods directly — test through public API
- Logging statements

## CI Pipeline Test Execution Order

1. \`./gradlew test\` — unit tests (fast, no containers)
2. \`./gradlew integrationTest\` — integration tests (Testcontainers)
3. \`./gradlew contractTest\` — Pact contract tests
4. \`./gradlew jacocoTestCoverageVerification\` — coverage gate
5. E2E tests run post-deployment to staging (separate workflow)

## Compliance Testing (SOC 2 / PCI DSS)

- Audit log tests: verify that all state-changing operations produce audit events
- Encryption tests: verify sensitive fields (card numbers, PII) are encrypted at rest
- Access control tests: verify role-based access on every secured endpoint
- Data retention tests: verify PII cleanup jobs execute correctly
- These tests are tagged \`@Tag("compliance")\` and run in every CI pipeline

## Cross-References

- See \`.claude/rules/common/coding-style.md\` for naming conventions applied to test classes
- See \`.claude/rules/common/security.md\` for security testing requirements and PCI DSS obligations
- See \`shared/test-support/\` for reusable Testcontainers base classes and fixtures
- See \`schema-registry/\` for Kafka event schemas validated in contract tests`,

  '.claude/rules/java/coding-style.md': `# Java & Kotlin Coding Style

## Formatting

### Java
- Use **google-java-format** for all Java source files
- Run \`./gradlew googleJavaFormat\` before committing
- 2-space indentation (google-java-format default)
- Column limit: 100 characters
- Import ordering: static imports first, then \`java.*\`, \`javax.*\`, \`org.*\`, \`com.*\`, project imports last
- No wildcard imports — ever
- No unused imports

### Kotlin
- Use **ktlint** with default ruleset for all Kotlin source files
- Run \`./gradlew ktlintCheck\` to verify, \`./gradlew ktlintFormat\` to auto-fix
- 4-space indentation
- Follow Kotlin official coding conventions
- Prefer expression bodies for single-expression functions
- Use \`data class\` for DTOs and value objects

## Checkstyle

Checkstyle configuration lives at \`config/checkstyle/checkstyle.xml\`. Key enforced rules:

- \`MissingJavadoc\` — all public classes and public methods require Javadoc
- \`FinalClass\` — classes with only private constructors must be \`final\`
- \`HideUtilityClassConstructor\` — utility classes must have private constructors
- \`AvoidStarImport\` — no wildcard imports
- \`UnusedImports\` — no unused imports
- \`MethodLength\` — max 40 lines per method
- \`ParameterNumber\` — max 5 parameters per method (use builder or record for more)
- \`CyclomaticComplexity\` — max 10 per method
- \`FileLength\` — max 300 lines per file

Run: \`./gradlew checkstyleMain checkstyleTest\`

## Naming Conventions

### Classes and Interfaces
- \`PascalCase\` for all types
- Suffix controllers: \`*Controller\` (e.g., \`PaymentController\`)
- Suffix services: \`*Service\` (e.g., \`OrderService\`)
- Suffix repositories: \`*Repository\` (e.g., \`UserRepository\`)
- Suffix domain events: \`*Event\` (e.g., \`PaymentCompletedEvent\`)
- Suffix DTOs: \`*Dto\` (e.g., \`CreateOrderDto\`)
- Suffix request/response objects: \`*Request\`, \`*Response\`
- Suffix exceptions: \`*Exception\` (e.g., \`InsufficientFundsException\`)
- Suffix configuration classes: \`*Config\` (e.g., \`KafkaProducerConfig\`)
- Suffix port interfaces: \`*Port\` (e.g., \`PaymentPort\`)
- Suffix adapter implementations: \`*Adapter\` (e.g., \`PaymentKafkaAdapter\`)

### Methods and Variables
- \`camelCase\` for methods, local variables, and parameters
- Boolean methods/variables: prefix with \`is\`, \`has\`, \`can\`, \`should\` (e.g., \`isEligible\`, \`hasExpired\`)
- Factory methods: prefix with \`of\`, \`from\`, \`create\` (e.g., \`Order.from(dto)\`)

### Constants
- \`SCREAMING_SNAKE_CASE\` for constants (e.g., \`MAX_RETRY_ATTEMPTS\`)
- Define constants in the class that owns them, not in a shared \`Constants\` class

### Packages
- All lowercase, no underscores
- Base package: \`com.company.{servicename}\` (e.g., \`com.company.orderservice\`)
- Hexagonal layers: \`.domain\`, \`.application\`, \`.adapter.in.web\`, \`.adapter.out.persistence\`, \`.adapter.out.kafka\`

### Modules
- \`kebab-case\` for Gradle module names (e.g., \`order-service\`, \`shared-events\`)

## File Length and Structure

- **Max 300 lines per file** — split into smaller classes if exceeded
- **Max 40 lines per method** — extract helper methods
- **Max 5 parameters per method** — use a request object, builder, or record
- **One public class per file** — private/package-private helper classes are acceptable

### Standard file ordering:
1. Package declaration
2. Imports (static first, then grouped)
3. Class Javadoc
4. Class declaration
5. Static fields (constants)
6. Instance fields
7. Constructors
8. Public methods
9. Package-private methods
10. Private methods
11. Inner classes / records

## Spring Boot Conventions

### Dependency Injection
- **Constructor injection only** — never field injection (\`@Autowired\` on fields)
- Use \`@RequiredArgsConstructor\` (Lombok) or explicit constructors
- Mark injected fields as \`private final\`

\`\`\`java
// CORRECT
@Service
@RequiredArgsConstructor
public class OrderService {
    private final OrderRepository orderRepository;
    private final PaymentPort paymentPort;
    private final KafkaEventPublisher eventPublisher;
}

// WRONG — never do this
@Service
public class OrderService {
    @Autowired
    private OrderRepository orderRepository;
}
\`\`\`

### Controllers
- Use \`@RestController\` with \`@RequestMapping\` at class level for base path
- Use specific HTTP method annotations: \`@GetMapping\`, \`@PostMapping\`, \`@PutMapping\`, \`@DeleteMapping\`
- Return \`ResponseEntity<T>\` for explicit status code control
- Validate request bodies with \`@Valid\`
- Keep controllers thin — delegate to application services immediately

\`\`\`java
@RestController
@RequestMapping("/api/v1/orders")
@RequiredArgsConstructor
public class OrderController {

    private final OrderApplicationService orderService;

    @PostMapping
    public ResponseEntity<OrderResponse> createOrder(@Valid @RequestBody CreateOrderRequest request) {
        OrderResponse response = orderService.createOrder(request);
        return ResponseEntity.status(HttpStatus.CREATED).body(response);
    }
}
\`\`\`

### Configuration
- Use \`@ConfigurationProperties\` with records for type-safe config — avoid \`@Value\` for groups of related properties
- Prefix config properties with the service name (e.g., \`order-service.retry.max-attempts\`)
- Use Spring Profiles: \`application.yml\`, \`application-local.yml\`, \`application-staging.yml\`, \`application-prod.yml\`
- Never hardcode environment-specific values

\`\`\`java
@ConfigurationProperties(prefix = "order-service.retry")
public record RetryConfig(int maxAttempts, Duration backoff) {}
\`\`\`

### Exception Handling
- Use \`@RestControllerAdvice\` for global exception handling per service
- Map domain exceptions to appropriate HTTP status codes
- Return consistent error response DTOs
- Never expose stack traces in API responses
- Log the full exception server-side at appropriate level

### Actuator
- Expose \`/actuator/health\`, \`/actuator/info\`, \`/actuator/prometheus\`
- Implement custom health indicators for critical dependencies (database, Kafka, Redis)
- Do not expose sensitive actuator endpoints in production

## Hexagonal Architecture (Ports & Adapters)

Every microservice follows this package structure:

\`\`\`
com.company.orderservice/
├── domain/
│   ├── model/           # Entities, value objects, aggregates
│   ├── event/           # Domain events
│   ├── exception/       # Domain-specific exceptions
│   └── service/         # Domain services (pure business logic)
├── application/
│   ├── port/
│   │   ├── in/          # Input ports (use case interfaces)
│   │   └── out/         # Output ports (repository, messaging interfaces)
│   └── service/         # Application services (orchestration, use case impl)
├── adapter/
│   ├── in/
│   │   ├── web/         # REST controllers, request/response DTOs
│   │   └── kafka/       # Kafka consumers (inbound events)
│   └── out/
│       ├── persistence/ # JPA entities, repositories, mappers
│       ├── kafka/       # Kafka producers (outbound events)
│       └── redis/       # Redis cache adapters
└── config/              # Spring configuration classes
\`\`\`

### Rules
- **Domain layer has zero Spring dependencies** — pure Java/Kotlin
- Domain model classes must not use JPA annotations — use separate persistence entities in the adapter layer with mappers
- Input ports define use cases as interfaces; application services implement them
- Output ports define repository/messaging contracts; adapters implement them
- Controllers call input ports, never domain services directly
- Adapters depend on ports, never on each other

## Kafka Conventions

### Producers
- Use \`KafkaTemplate<String, T>\` with typed event classes
- Always set a message key for partition ordering (e.g., aggregate ID)
- Publish events through an output port, not directly from domain services
- Use the shared schema from \`schema-registry/\` for all event payloads

### Consumers
- Use \`@KafkaListener\` with explicit \`groupId\` matching the service name
- Set \`containerFactory\` for deserialization configuration
- Implement idempotent consumers — deduplicate by event ID
- Handle deserialization errors with a dead-letter topic (DLT)
- Log consumer lag metrics via Actuator

### Topic Naming
- Pattern: \`{domain}.{entity}.{event}\` (e.g., \`payment.transaction.completed\`, \`order.order.created\`)
- Consumer group: \`{service-name}-group\` (e.g., \`order-service-group\`)

### Event Structure
Every domain event must include:
- \`eventId\` (UUID) — for idempotency
- \`eventType\` (String) — fully qualified event name
- \`aggregateId\` (String) — the entity this event relates to
- \`timestamp\` (Instant) — when the event occurred
- \`version\` (int) — schema version
- \`payload\` (Object) — event-specific data

## Database Conventions

### JPA / Persistence
- Use \`UUID\` for primary keys — never auto-increment integers
- Annotate persistence entities in \`adapter.out.persistence\`, not in domain model
- Use \`@CreatedDate\` and \`@LastModifiedDate\` with Spring Data auditing
- Name tables in \`snake_case\`, prefixed with service abbreviation (e.g., \`ord_orders\`, \`pay_transactions\`)
- Use Flyway for schema migrations — scripts in \`src/main/resources/db/migration/\`
- Migration naming: \`V{version}__{description}.sql\` (e.g., \`V1__create_orders_table.sql\`)
- Never use \`spring.jpa.hibernate.ddl-auto=update\` in staging or production

### Repository
- Extend \`JpaRepository<Entity, UUID>\`
- Use \`@Query\` with JPQL for complex queries — avoid native SQL unless performance-critical
- Return \`Optional<T>\` for single-entity lookups

## Lombok Usage

Allowed annotations:
- \`@RequiredArgsConstructor\` — for constructor injection
- \`@Getter\` — on domain models and DTOs
- \`@Builder\` — on DTOs and request/response objects
- \`@ToString\` — with \`exclude\` for sensitive fields
- \`@Slf4j\` — for logger declaration

Prohibited:
- \`@Data\` — too permissive, generates mutable setters
- \`@Setter\` — prefer immutable objects
- \`@AllArgsConstructor\` — use \`@Builder\` or explicit constructors

## Records

- Prefer Java records for DTOs, value objects, request/response types, and configuration properties
- Records are immutable by default — align with our preference for immutability
- Use records over Lombok \`@Value\` for new code

\`\`\`java
public record CreateOrderRequest(
    @NotNull UUID customerId,
    @NotEmpty List<OrderItemDto> items,
    @NotNull Currency currency
) {}
\`\`\`

## Logging

- Use SLF4J via \`@Slf4j\` (Lombok) or \`LoggerFactory.getLogger()\`
- Use structured logging with key-value pairs for observability
- Include \`traceId\`, \`spanId\` (from Micrometer/Jaeger) automatically via MDC
- Log levels:
  - \`ERROR\` — unrecoverable failures, requires attention
  - \`WARN\` — recoverable issues, degraded behavior
  - \`INFO\` — significant business events (order created, payment processed)
  - \`DEBUG\` — detailed flow for troubleshooting
- **Never log sensitive data**: PII, credentials, card numbers, tokens (PCI DSS requirement)
- Never log full request/response bodies in production — use DEBUG level with redaction

\`\`\`java
log.info("Order created: orderId={}, customerId={}, itemCount={}",
    order.getId(), order.getCustomerId(), order.getItems().size());
\`\`\`

## Null Safety

- Use \`Optional<T>\` for return types that may be absent — never return \`null\`
- Use \`@Nullable\` / \`@NonNull\` annotations (from \`jakarta.annotation\`) on method parameters where ambiguity exists
- Validate inputs at adapter boundaries with Bean Validation (\`@NotNull\`, \`@NotBlank\`, etc.)
- In Kotlin code, leverage the type system — avoid \`!!\` operator

## Testing Conventions

See also: \`common/coding-style.md\` for general test requirements.

- **Unit tests**: JUnit 5 + Mockito, test domain and application layers in isolation
- **Integration tests**: Testcontainers for PostgreSQL, Kafka, Redis — annotate with \`@IntegrationTest\`
- **Contract tests**: Pact for verifying inter-service event contracts
- Test class naming: \`{ClassUnderTest}Test\` for unit, \`{ClassUnderTest}IntegrationTest\` for integration
- Use \`@Nested\` classes to group test scenarios
- Use AssertJ for assertions — not JUnit's built-in assertions
- Use \`@DisplayName\` for human-readable test names

\`\`\`java
@DisplayName("OrderService")
class OrderServiceTest {

    @Nested
    @DisplayName("when creating an order")
    class CreateOrder {

        @Test
        @DisplayName("should publish OrderCreatedEvent on success")
        void shouldPublishEventOnSuccess() {
            // arrange, act, assert
        }
    }
}
\`\`\`

## Static Analysis

Run the full suite before pushing:

\`\`\`bash
./gradlew checkstyleMain checkstyleTest    # Checkstyle
./gradlew ktlintCheck                       # ktlint (Kotlin)
./gradlew spotbugsMain                      # SpotBugs
./gradlew dependencyCheckAnalyze            # OWASP dependency check
./gradlew jacocoTestReport                  # Coverage (must be ≥ 80%)
\`\`\``,

  '.claude/rules/java/testing.md': `# Java Testing Standards

## JUnit 5 Conventions

### Test Class Structure

\`\`\`java
@DisplayName("OrderService")
class OrderServiceTest {

    @Nested
    @DisplayName("createOrder")
    class CreateOrder {

        @Test
        @DisplayName("should create order when inventory is available")
        void shouldCreateOrderWhenInventoryIsAvailable() {
            // given
            var request = OrderFixtures.validCreateOrderRequest();

            // when
            var result = orderService.createOrder(request);

            // then
            assertThat(result.status()).isEqualTo(OrderStatus.CREATED);
        }

        @Test
        @DisplayName("should throw InsufficientInventoryException when stock is zero")
        void shouldThrowWhenStockIsZero() {
            // given
            var request = OrderFixtures.createOrderRequestWithZeroStock();

            // then
            assertThatThrownBy(() -> orderService.createOrder(request))
                .isInstanceOf(InsufficientInventoryException.class)
                .hasMessageContaining("insufficient stock");
        }
    }
}
\`\`\`

### Naming and Organization

- Test class: \`{ClassUnderTest}Test\` for unit tests, \`{ClassUnderTest}IntegrationTest\` for integration tests
- Test method: \`should{ExpectedBehavior}When{Condition}\` — always use \`@DisplayName\` for readable output
- Use \`@Nested\` classes to group tests by method or scenario
- Place test fixtures in \`{service}/src/test/java/.../fixtures/\` package
- One assertion concept per test — multiple \`assertThat\` calls are fine if they verify the same logical outcome

### Assertions — Use AssertJ

\`\`\`java
// Preferred: AssertJ
assertThat(result).isNotNull();
assertThat(result.items()).hasSize(3).extracting(Item::sku).containsExactly("A", "B", "C");
assertThat(result.total()).isCloseTo(BigDecimal.valueOf(99.99), within(BigDecimal.valueOf(0.01)));

// Avoid: JUnit assertions
// assertEquals(3, result.items().size());  — less readable, worse failure messages
\`\`\`

### Parameterized Tests

\`\`\`java
@ParameterizedTest(name = "should reject currency {0} as unsupported")
@ValueSource(strings = {"XYZ", "ABC", "---"})
void shouldRejectUnsupportedCurrency(String currency) {
    assertThatThrownBy(() -> currencyValidator.validate(currency))
        .isInstanceOf(UnsupportedCurrencyException.class);
}

@ParameterizedTest
@CsvSource({
    "100.00, USD, 100.00",
    "100.00, EUR, 108.50",
    "100.00, GBP, 126.30"
})
void shouldConvertCurrency(String amount, String currency, String expected) {
    // ...
}
\`\`\`

## Mockito Standards

### Preferred Patterns

\`\`\`java
@ExtendWith(MockitoExtension.class)
class PaymentProcessorTest {

    @Mock
    private PaymentGatewayPort paymentGateway;

    @Mock
    private PaymentEventPublisher eventPublisher;

    @InjectMocks
    private PaymentProcessor paymentProcessor;

    @Test
    void shouldPublishPaymentCompletedEvent() {
        // given
        var payment = PaymentFixtures.validPayment();
        given(paymentGateway.charge(any(ChargeRequest.class)))
            .willReturn(ChargeResult.success("txn-123"));

        // when
        paymentProcessor.process(payment);

        // then
        then(eventPublisher).should().publish(argThat(event ->
            event.type().equals("payment.completed") &&
            event.transactionId().equals("txn-123")
        ));
    }
}
\`\`\`

### Mockito Rules

- Use \`@ExtendWith(MockitoExtension.class)\` — never \`MockitoAnnotations.openMocks(this)\`
- Use BDD-style: \`given(...).willReturn(...)\`, \`then(...).should()...\`
- Mock ports and adapters (interfaces), never concrete domain classes
- Use \`@Spy\` sparingly — prefer restructuring code over partial mocking
- Never mock records, value objects, or DTOs — construct real instances
- Use \`argThat\` for complex argument matching instead of \`eq()\` with constructed objects
- Verify interactions only when the side effect IS the behavior under test (e.g., event publishing)
- Do not use \`verifyNoMoreInteractions\` unless testing security-critical paths

### What NOT to Mock

- Domain entities and value objects — construct them
- Mappers and pure functions — use real implementations
- Spring Data repositories in integration tests — use Testcontainers
- Kafka producers in integration tests — use embedded Kafka or Testcontainers

## Testcontainers — Integration Tests

### Base Test Configuration

Each service must provide a shared Testcontainers base class:

\`\`\`java
@SpringBootTest
@Testcontainers
@ActiveProfiles("test")
@DirtiesContext(classMode = DirtiesContext.ClassMode.AFTER_CLASS)
abstract class BaseIntegrationTest {

    @Container
    static final PostgreSQLContainer<?> postgres = new PostgreSQLContainer<>("postgres:16-alpine")
        .withDatabaseName("testdb")
        .withUsername("test")
        .withPassword("test");

    @Container
    static final KafkaContainer kafka = new KafkaContainer(
        DockerImageName.parse("confluentinc/cp-kafka:7.6.0")
    );

    @Container
    static final GenericContainer<?> redis = new GenericContainer<>("redis:7-alpine")
        .withExposedPorts(6379);

    @DynamicPropertySource
    static void configureProperties(DynamicPropertyRegistry registry) {
        registry.add("spring.datasource.url", postgres::getJdbcUrl);
        registry.add("spring.datasource.username", postgres::getUsername);
        registry.add("spring.datasource.password", postgres::getPassword);
        registry.add("spring.kafka.bootstrap-servers", kafka::getBootstrapServers);
        registry.add("spring.data.redis.host", redis::getHost);
        registry.add("spring.data.redis.port", () -> redis.getMappedPort(6379));
    }
}
\`\`\`

### Integration Test Patterns

\`\`\`java
class OrderRepositoryIntegrationTest extends BaseIntegrationTest {

    @Autowired
    private OrderRepository orderRepository;

    @Test
    void shouldPersistAndRetrieveOrder() {
        // given
        var order = OrderFixtures.validOrderEntity();

        // when
        var saved = orderRepository.save(order);
        var found = orderRepository.findById(saved.getId());

        // then
        assertThat(found).isPresent();
        assertThat(found.get().getStatus()).isEqualTo(OrderStatus.CREATED);
    }
}
\`\`\`

### Kafka Integration Tests

\`\`\`java
class OrderEventConsumerIntegrationTest extends BaseIntegrationTest {

    @Autowired
    private KafkaTemplate<String, String> kafkaTemplate;

    @Autowired
    private OrderRepository orderRepository;

    @Test
    void shouldProcessPaymentCompletedEvent() throws Exception {
        // given
        var orderId = UUID.randomUUID().toString();
        orderRepository.save(OrderFixtures.pendingPaymentOrder(orderId));

        var event = PaymentEventFixtures.paymentCompletedEvent(orderId);

        // when
        kafkaTemplate.send("payment.events", orderId, objectMapper.writeValueAsString(event)).get();

        // then
        await().atMost(Duration.ofSeconds(10)).untilAsserted(() -> {
            var order = orderRepository.findById(orderId).orElseThrow();
            assertThat(order.getStatus()).isEqualTo(OrderStatus.PAYMENT_CONFIRMED);
        });
    }
}
\`\`\`

### Testcontainers Rules

- Share containers across tests using \`static\` containers — do not spin up per-test
- Use \`@ActiveProfiles("test")\` with \`application-test.yml\` for test-specific config
- Use \`Awaitility\` for asserting async Kafka consumer behavior — never \`Thread.sleep\`
- Clean up test data with \`@Sql\` scripts or \`@BeforeEach\` truncation, not \`@DirtiesContext\` per test
- Only start containers the service actually needs — order-service does not need Redis if it doesn't cache

## Pact Contract Tests

### Consumer Side (service consuming an API or event)

\`\`\`java
@ExtendWith(PactConsumerTestExt.class)
@PactTestFor(providerName = "payment-service", pactVersion = PactSpecVersion.V4)
class OrderServicePaymentConsumerPactTest {

    @Pact(consumer = "order-service")
    V4Pact paymentCompletedEvent(MessagePactBuilder builder) {
        return builder
            .expectsToReceive("a payment completed event")
            .withContent(new PactDslJsonBody()
                .stringType("eventType", "payment.completed")
                .stringType("orderId", "ord-123")
                .stringType("transactionId", "txn-456")
                .numberType("amount", 99.99)
                .stringType("currency", "USD")
                .datetime("timestamp", "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
            )
            .toPact();
    }

    @Test
    @PactTestFor(pactMethod = "paymentCompletedEvent")
    void shouldDeserializePaymentCompletedEvent(V4Interaction.AsynchronousMessage message) {
        var content = new String(message.contentsAsBytes());
        var event = objectMapper.readValue(content, PaymentCompletedEvent.class);

        assertThat(event.eventType()).isEqualTo("payment.completed");
        assertThat(event.orderId()).isEqualTo("ord-123");
    }
}
\`\`\`

### Provider Side (service producing an API or event)

\`\`\`java
@Provider("payment-service")
@PactBroker(url = "\${PACT_BROKER_URL}")
@SpringBootTest(webEnvironment = SpringBootTest.WebEnvironment.RANDOM_PORT)
class PaymentServiceProviderPactTest extends BaseIntegrationTest {

    @TestTemplate
    @ExtendWith(PactVerificationInvocationContextProvider.class)
    void verifyPact(PactVerificationContext context) {
        context.verifyInteraction();
    }

    @State("a completed payment exists for order ord-123")
    void setupCompletedPayment() {
        paymentRepository.save(PaymentFixtures.completedPayment("ord-123"));
    }
}
\`\`\`

### Contract Test Rules

- Consumer pacts live in the consuming service's test directory
- Publish pacts to the Pact Broker in CI (\`./gradlew pactPublish\`)
- Provider verification runs against published pacts in CI
- Every Kafka event schema consumed by another service must have a consumer pact
- Tag pacts with branch name and environment for can-i-deploy checks

## JaCoCo Coverage

### Configuration (in service \`build.gradle.kts\`)

\`\`\`kotlin
plugins {
    jacoco
}

jacoco {
    toolVersion = "0.8.11"
}

tasks.jacocoTestReport {
    dependsOn(tasks.test)
    reports {
        xml.required.set(true)  // for CI integration
        html.required.set(true)
    }
}

tasks.jacocoTestCoverageVerification {
    violationRules {
        rule {
            limit {
                minimum = BigDecimal("0.80")
            }
        }
        rule {
            element = "CLASS"
            excludes = listOf(
                "*.config.*",
                "*.dto.*",
                "*.exception.*",
                "*Application"
            )
            limit {
                minimum = BigDecimal("0.80")
            }
        }
    }
}

tasks.check {
    dependsOn(tasks.jacocoTestCoverageVerification)
}
\`\`\`

### Coverage Rules

- **Minimum 80%** line coverage enforced per service — \`./gradlew check\` fails below threshold
- Coverage measured across unit + integration tests combined
- Excluded from coverage: configuration classes, DTOs/records, exception classes, Spring Boot main class
- Domain logic (use cases, domain services) must exceed **90%** coverage
- Adapters (controllers, repositories, Kafka listeners) must exceed **75%** coverage
- Do not write tests solely to hit coverage — tests must verify meaningful behavior

## Test Fixtures and Factories

### Fixture Pattern

Each service maintains a \`fixtures\` package with builder-style test data factories:

\`\`\`java
public final class OrderFixtures {

    private OrderFixtures() {}

    public static CreateOrderRequest validCreateOrderRequest() {
        return new CreateOrderRequest(
            UUID.randomUUID().toString(),
            List.of(new OrderItem("SKU-001", 2, BigDecimal.valueOf(49.99))),
            "USD",
            shippingAddress()
        );
    }

    public static Order pendingPaymentOrder(String orderId) {
        return Order.builder()
            .id(orderId)
            .status(OrderStatus.PENDING_PAYMENT)
            .createdAt(Instant.now())
            .build();
    }

    private static Address shippingAddress() {
        return new Address("123 Main St", "Springfield", "IL", "62704", "US");
    }
}
\`\`\`

- Fixtures use descriptive factory method names — not \`order1()\`, \`order2()\`
- Shared event fixtures live in \`shared/test-fixtures/\` module
- Use \`Instancio\` or custom builders for complex object graphs — avoid excessive manual construction

## Test Profiles and Configuration

### \`application-test.yml\` (per service)

\`\`\`yaml
spring:
  jpa:
    hibernate:
      ddl-auto: create-drop
    show-sql: false
  kafka:
    consumer:
      auto-offset-reset: earliest
      group-id: \${spring.application.name}-test
  flyway:
    enabled: true
    clean-disabled: false

logging:
  level:
    org.springframework.kafka: WARN
    org.testcontainers: INFO
\`\`\`

## Running Tests

\`\`\`bash
# Unit tests only
./gradlew test

# Integration tests only
./gradlew integrationTest

# Contract tests only
./gradlew pactTest

# All tests with coverage
./gradlew check jacocoTestReport

# Single service tests
./gradlew :services:order-service:test

# Specific test class
./gradlew :services:payment-service:test --tests "*.PaymentProcessorTest"
\`\`\`

## Test Classification (Gradle)

Tests are separated by source set in each service's \`build.gradle.kts\`:

\`\`\`kotlin
sourceSets {
    create("integrationTest") {
        compileClasspath += sourceSets.main.get().output + sourceSets.test.get().output
        runtimeClasspath += sourceSets.main.get().output + sourceSets.test.get().output
    }
    create("pactTest") {
        compileClasspath += sourceSets.main.get().output + sourceSets.test.get().output
        runtimeClasspath += sourceSets.main.get().output + sourceSets.test.get().output
    }
}

tasks.register<Test>("integrationTest") {
    testClassesDirs = sourceSets["integrationTest"].output.classesDirs
    classpath = sourceSets["integrationTest"].runtimeClasspath
    useJUnitPlatform()
    shouldRunAfter(tasks.test)
}

tasks.register<Test>("pactTest") {
    testClassesDirs = sourceSets["pactTest"].output.classesDirs
    classpath = sourceSets["pactTest"].runtimeClasspath
    useJUnitPlatform()
    systemProperty("pact.verifier.publishResults", "true")
}
\`\`\`

## Security-Sensitive Test Requirements

For code in \`**/security/**\` and \`**/auth/**\` paths (SOC 2 / PCI DSS compliance):

- **100% branch coverage** on authentication and authorization logic
- Explicit tests for every rejection path (expired tokens, invalid roles, tampered payloads)
- Test that PII is never logged`,

  '.claude/settings.json': `{
  "permissions": {
    "allow": [
      "Bash(./gradlew build)",
      "Bash(./gradlew test)",
      "Bash(./gradlew check)",
      "Bash(./gradlew clean)",
      "Bash(./gradlew bootRun*)",
      "Bash(./gradlew :*:build)",
      "Bash(./gradlew :*:test)",
      "Bash(./gradlew :*:check)",
      "Bash(./gradlew :*:bootRun)",
      "Bash(./gradlew :*:integrationTest)",
      "Bash(./gradlew :*:contractTest)",
      "Bash(./gradlew :*:jacocoTestReport)",
      "Bash(./gradlew :*:jacocoTestCoverageVerification)",
      "Bash(./gradlew :*:checkstyleMain)",
      "Bash(./gradlew :*:checkstyleTest)",
      "Bash(./gradlew :*:spotbugsMain)",
      "Bash(./gradlew :*:spotbugsTest)",
      "Bash(./gradlew :*:dependencyCheckAnalyze)",
      "Bash(./gradlew :*:openApiGenerate)",
      "Bash(./gradlew dependencies*)",
      "Bash(./gradlew :*:dependencies*)",
      "Bash(./gradlew projects)",
      "Bash(./gradlew tasks*)",
      "Bash(cat *)",
      "Bash(find *)",
      "Bash(grep *)",
      "Bash(rg *)",
      "Bash(head *)",
      "Bash(tail *)",
      "Bash(wc *)",
      "Bash(ls *)",
      "Bash(tree *)",
      "Bash(diff *)",
      "Bash(git log*)",
      "Bash(git diff*)",
      "Bash(git status*)",
      "Bash(git branch*)",
      "Bash(git show*)",
      "Bash(git blame*)",
      "Bash(docker compose -f docker-compose.dev.yml up*)",
      "Bash(docker compose -f docker-compose.dev.yml down*)",
      "Bash(docker compose -f docker-compose.dev.yml ps*)",
      "Bash(docker compose -f docker-compose.dev.yml logs*)",
      "Bash(helm lint *)",
      "Bash(helm template *)",
      "Bash(kubectl get *)",
      "Bash(kubectl describe *)",
      "Bash(kubectl logs *)",
      "Bash(java --version)",
      "Bash(javac --version)",
      "Bash(kotlin -version)",
      "Read",
      "Write",
      "Edit",
      "MultiEdit",
      "Glob",
      "Grep",
      "TodoRead",
      "TodoWrite",
      "WebFetch",
      "mcp__jira__get_issue",
      "mcp__jira__search_issues",
      "mcp__jira__get_comments",
      "mcp__jira__add_comment",
      "mcp__jira__transition_issue",
      "mcp__confluence__get_page",
      "mcp__confluence__search",
      "mcp__github__get_pull_request",
      "mcp__github__list_pull_requests",
      "mcp__github__get_file_contents",
      "mcp__github__search_code",
      "mcp__github__list_commits",
      "mcp__github__get_pull_request_diff",
      "mcp__github__get_pull_request_reviews",
      "mcp__slack__send_message",
      "mcp__slack__search_messages",
      "mcp__prometheus__query",
      "mcp__prometheus__query_range",
      "mcp__grafana__get_dashboard",
      "mcp__grafana__search_dashboards"
    ],
    "deny": [
      "Bash(rm -rf *)",
      "Bash(rm -r /)",
      "Bash(git push*)",
      "Bash(git merge*)",
      "Bash(git rebase*)",
      "Bash(git reset --hard*)",
      "Bash(git checkout main)",
      "Bash(git checkout release/*)",
      "Bash(docker push*)",
      "Bash(docker login*)",
      "Bash(kubectl apply*)",
      "Bash(kubectl delete*)",
      "Bash(kubectl exec*)",
      "Bash(kubectl edit*)",
      "Bash(kubectl patch*)",
      "Bash(kubectl create*)",
      "Bash(kubectl rollout*)",
      "Bash(helm install*)",
      "Bash(helm upgrade*)",
      "Bash(helm uninstall*)",
      "Bash(helm rollback*)",
      "Bash(terraform apply*)",
      "Bash(terraform destroy*)",
      "Bash(terraform import*)",
      "Bash(aws *)",
      "Bash(curl *localhost*/actuator/shutdown*)",
      "Bash(./gradlew :*:flywayMigrate*)",
      "Bash(./gradlew :*:flywayClean*)",
      "Bash(psql*)",
      "Bash(redis-cli*FLUSHALL*)",
      "Bash(redis-cli*FLUSHDB*)",
      "Bash(kafka-topics*--delete*)",
      "Bash(chmod 777*)",
      "Bash(chown*)",
      "Bash(sudo *)",
      "Bash(env)",
      "Bash(printenv)",
      "Bash(export *)",
      "Bash(echo $*SECRET*)",
      "Bash(echo $*PASSWORD*)",
      "Bash(echo $*TOKEN*)",
      "Bash(echo $*KEY*)",
      "mcp__github__create_pull_request",
      "mcp__github__merge_pull_request",
      "mcp__github__delete_branch",
      "mcp__jira__create_issue",
      "mcp__jira__update_issue",
      "mcp__slack__send_message_to_channel(#production*)",
      "mcp__slack__send_message_to_channel(#incidents*)"
    ]
  },
  "model": {
    "default": "sonnet",
    "codeReview": "opus",
    "securityReview": "opus",
    "architectureDesign": "opus",
    "testGeneration": "sonnet",
    "documentation": "sonnet",
    "debugging": "sonnet"
  },
  "context": {
    "importantFiles": [
      "CLAUDE.md",
      "settings.gradle.kts",
      "build.gradle.kts",
      "docs/architecture/adr/",
      "docs/architecture/c4-model.md",
      "schema-registry/",
      "shared/domain-events/src/main/java/",
      ".github/CODEOWNERS"
    ],
    "alwaysIgnore": [
      "**/build/",
      "**/.gradle/",
      "**/node_modules/",
      "**/*.class",
      "**/*.jar",
      "**/target/",
      "**/.idea/",
      "**/.vscode/",
      "**/*.log",
      "**/terraform.tfstate*",
      "**/*.tfvars",
      "**/secrets/",
      "**/*.pem",
      "**/*.key",
      "**/*.p12",
      "**/*.jks",
      "**/*.keystore",
      "**/application-production.yml",
      "**/application-production.properties"
    ]
  },
  "preferences": {
    "codeStyle": "google-java-format",
    "maxFileLength": 300,
    "testFramework": "junit5",
    "mockFramework": "mockito",
    "integrationTestFramework": "testcontainers",
    "contractTestFramework": "pact",
    "coverageThreshold": 80,
    "architecture": "hexagonal",
    "commitFormat": "conventional",
    "branchNaming": "type/ticket-desc",
    "signedCommits": true,
    "aiCodeFlag": true,
    "language": {
      "primary": "java-21",
      "secondary": "kotlin"
    }
  },
  "security": {
    "compliance": ["SOC2", "PCI-DSS"],
    "sensitivePathPatterns": [
      "**/security/**",
      "**/auth/**",
      "**/crypto/**",
      "**/encryption/**",
      "infrastructure/production/**",
      "**/*.properties",
      "**/*secret*",
      "**/*credential*",
      "**/application-prod*"
    ],
    "requireReviewForSensitivePaths": true,
    "neverReadPatterns": [
      "**/*.pem",
      "**/*.key",
      "**/*.p12",
      "**/*.jks",
      "**/*.keystore",
      "**/terraform.tfvars",
      "**/.env",
      "**/.env.*",
      "**/secrets/**",
      "**/vault-config/**"
    ],
    "scanDependencies": true,
    "blockUnapprovedDependencies": true
  },
  "kafka": {
    "topicNamingConvention": "{domain}.{entity}.{event-type}",
    "topicExamples": [
      "payment.transaction.created",
      "payment.transaction.completed",
      "payment.transaction.failed",
      "order.order.placed",
      "order.order.fulfilled",
      "user.account.created",
      "user.account.verified",
      "notification.email.requested"
    ],
    "consumerGroupNaming": "{service-name}-{purpose}-group",
    "schemaRegistryPath": "schema-registry/",
    "requireSchemaForEvents": true
  },
  "services": {
    "knownModules": [
      "gateway",
      "services/order-service",
      "services/payment-service",
      "services/user-service",
      "services/notification-service",
      "shared/domain-events",
      "shared/common-utils",
      "shared/security-lib",
      "shared/test-support"
    ],
    "perServiceRequirements": {
      "dockerfile": true,
      "helmChart": true,
      "openApiSpec": true,
      "flywayMigrations": true,
      "healthEndpoint": true,
      "metricsEndpoint": true
    }
  }
}`,

  '.editorconfig': `root = true

[*]
charset = utf-8
end_of_line = lf
insert_final_newline = true
trim_trailing_whitespace = true
indent_style = space
indent_size = 4

[*.java]
indent_size = 4
max_line_length = 120

[*.kt]
indent_size = 4
max_line_length = 120

[*.kts]
indent_size = 4
max_line_length = 120

[*.{yml,yaml}]
indent_size = 2

[*.{json,json5}]
indent_size = 2

[*.{xml,xsd,xsl}]
indent_size = 4

[*.{html,htm}]
indent_size = 2

[*.css]
indent_size = 2

[*.{js,ts}]
indent_size = 2

[*.{tf,tfvars,hcl}]
indent_size = 2

[*.{sh,bash,zsh}]
indent_size = 2

[Dockerfile*]
indent_size = 4

[*.{properties,cfg,conf}]
indent_size = 4

[*.toml]
indent_size = 2

[*.sql]
indent_size = 4

[*.{avsc,avdl}]
indent_size = 2

[*.proto]
indent_size = 2

[*.md]
indent_size = 2
trim_trailing_whitespace = false

[Makefile]
indent_style = tab

[*.gradle]
indent_size = 4

[*.gradle.kts]
indent_size = 4

[{build.gradle.kts,settings.gradle.kts}]
indent_size = 4

[charts/**.yaml]
indent_size = 2

[infrastructure/**.tf]
indent_size = 2

[.github/**.{yml,yaml}]
indent_size = 2

[schema-registry/**.{avsc,json}]
indent_size = 2`,

  '.gitattributes': `# Auto detect text files and ensure LF line endings
* text=auto eol=lf

# Java sources
*.java text diff=java
*.kt text diff=kotlin
*.kts text diff=kotlin

# Gradle
*.gradle text diff=kotlin
*.gradle.kts text diff=kotlin
gradle.properties text
gradlew text eol=lf
gradlew.bat text eol=crlf

# Spring Boot configuration
*.properties text
*.yml text diff=yaml
*.yaml text diff=yaml
application*.properties text linguist-language=Java-Properties
application*.yml text diff=yaml linguist-language=YAML
bootstrap*.yml text diff=yaml

# Docker
Dockerfile text
docker-compose*.yml text diff=yaml
.dockerignore text

# Kubernetes / Helm
charts/**/*.yaml text diff=yaml
charts/**/*.yml text diff=yaml
charts/**/*.tpl text
infrastructure/**/*.yaml text diff=yaml
infrastructure/**/*.yml text diff=yaml

# Terraform
*.tf text diff=hcl
*.tfvars text diff=hcl
*.tf.json text

# Schema Registry (Avro / JSON Schema)
schema-registry/**/*.avsc text diff=json
schema-registry/**/*.json text diff=json

# OpenAPI specs
**/openapi*.yml text diff=yaml
**/openapi*.yaml text diff=yaml
**/swagger*.yml text diff=yaml
**/swagger*.json text diff=json

# Documentation
*.md text diff=markdown
*.adoc text
docs/**/*.md text diff=markdown
docs/**/*.puml text

# Shell scripts
*.sh text eol=lf
*.bash text eol=lf

# GitHub Actions
.github/**/*.yml text diff=yaml
.github/**/*.yaml text diff=yaml

# Claude / CodeForge configuration
.claude/**/*.md text diff=markdown
.claude/**/*.json text diff=json
plugin/**/*.md text diff=markdown
playbook/**/*.md text diff=markdown
CLAUDE.md text diff=markdown

# XML (Maven POMs, Checkstyle configs, logback)
*.xml text diff=html
pom.xml text diff=html
checkstyle*.xml text diff=html
logback*.xml text diff=html

# SQL migrations
*.sql text diff=sql

# Certificates and keys — treat as binary, never diff
*.pem binary
*.key binary
*.crt binary
*.jks binary
*.p12 binary
*.keystore binary
*.truststore binary

# Archives and compiled artifacts — binary
*.jar binary
*.war binary
*.ear binary
*.class binary
*.zip binary
*.tar.gz binary
*.tgz binary

# Docker image layers
*.tar binary

# Test fixtures
**/src/test/resources/**/*.json text diff=json
**/src/test/resources/**/*.xml text diff=html

# Pact contract files
tests/pacts/**/*.json text diff=json

# Lock files
gradle/wrapper/gradle-wrapper.jar binary
gradle/wrapper/gradle-wrapper.properties text

# Images and static assets
*.png binary
*.jpg binary
*.jpeg binary
*.gif binary
*.ico binary
*.svg text

# Prevent sensitive files from being diffed in PRs
**/security/**/*.java text diff=java
**/auth/**/*.java text diff=java
infrastructure/production/** linguist-generated

# Ensure consistent handling of generated sources
**/build/** linguist-generated
**/generated/** linguist-generated
**/node_modules/** linguist-generated`,

  '.github/CODEOWNERS': `# CODEOWNERS — spring-boot-microservices
# Each line is a file pattern followed by one or more owners.
# Order matters: later rules override earlier ones.
# Owners are notified and required reviewers for PRs touching matched paths.

# ──────────────────────────────────────────────
# Default — platform leads review anything not covered below
# ──────────────────────────────────────────────
*                                       @spring-boot-microservices/platform-leads

# ──────────────────────────────────────────────
# Individual microservices
# ──────────────────────────────────────────────
services/order-service/                 @spring-boot-microservices/order-team-leads
services/payment-service/               @spring-boot-microservices/payment-team-leads
services/user-service/                  @spring-boot-microservices/user-team-leads
services/notification-service/          @spring-boot-microservices/notification-team-leads
services/account-service/               @spring-boot-microservices/account-team-leads
services/ledger-service/                @spring-boot-microservices/ledger-team-leads

# ──────────────────────────────────────────────
# API Gateway
# ──────────────────────────────────────────────
gateway/                                @spring-boot-microservices/platform-leads

# ──────────────────────────────────────────────
# Shared libraries (domain events, DTOs, common utilities)
# Changes here affect all services — require platform lead + senior review
# ──────────────────────────────────────────────
shared/                                 @spring-boot-microservices/platform-leads @spring-boot-microservices/senior-engineers

# ──────────────────────────────────────────────
# Kafka event schemas — schema registry
# Breaking changes can impact all consumers; require platform + domain leads
# ──────────────────────────────────────────────
schema-registry/                        @spring-boot-microservices/platform-leads @spring-boot-microservices/senior-engineers

# ──────────────────────────────────────────────
# Infrastructure — Terraform, Kubernetes, Helm
# Restricted to infrastructure / SRE leads
# ──────────────────────────────────────────────
infrastructure/                         @spring-boot-microservices/infra-leads
infrastructure/production/              @spring-boot-microservices/infra-leads @spring-boot-microservices/security-leads
charts/                                 @spring-boot-microservices/infra-leads

# ──────────────────────────────────────────────
# Security-sensitive paths (SOC 2 / PCI DSS)
# Require security lead approval — no exceptions
# ──────────────────────────────────────────────
**/security/                            @spring-boot-microservices/security-leads
**/auth/                                @spring-boot-microservices/security-leads
**/*.properties                         @spring-boot-microservices/security-leads @spring-boot-microservices/platform-leads
**/application-prod.yml                 @spring-boot-microservices/security-leads @spring-boot-microservices/infra-leads
**/application-production.yml           @spring-boot-microservices/security-leads @spring-boot-microservices/infra-leads

# ──────────────────────────────────────────────
# CI/CD pipelines and GitHub configuration
# ──────────────────────────────────────────────
.github/                                @spring-boot-microservices/platform-leads @spring-boot-microservices/infra-leads
.github/workflows/                      @spring-boot-microservices/infra-leads

# ──────────────────────────────────────────────
# Claude Code configuration and plugin
# ──────────────────────────────────────────────
.claude/                                @spring-boot-microservices/platform-leads
CLAUDE.md                               @spring-boot-microservices/platform-leads
plugin/                                 @spring-boot-microservices/platform-leads

# ──────────────────────────────────────────────
# Build system — Gradle root and convention plugins
# ──────────────────────────────────────────────
build.gradle.kts                        @spring-boot-microservices/platform-leads
settings.gradle.kts                     @spring-boot-microservices/platform-leads
buildSrc/                               @spring-boot-microservices/platform-leads
gradle/                                 @spring-boot-microservices/platform-leads

# ──────────────────────────────────────────────
# Tests — E2E and contract tests
# ──────────────────────────────────────────────
tests/                                  @spring-boot-microservices/platform-leads @spring-boot-microservices/senior-engineers

# ──────────────────────────────────────────────
# Documentation and ADRs
# ──────────────────────────────────────────────
docs/                                   @spring-boot-microservices/platform-leads
docs/adr/                               @spring-boot-microservices/platform-leads @spring-boot-microservices/senior-engineers`,

  '.github/ISSUE_TEMPLATE/ai_task.md': `---
name: AI Task (Claude Code)
about: Structured task for Claude Code to implement a Java/Spring Boot microservice change
title: "[AI] "
labels: ai-task, claude-code
assignees: ''
---

## Task Metadata

| Field | Value |
|-------|-------|
| **Jira Ticket** | <!-- e.g., PAY-456, ORD-789 --> |
| **Service(s)** | <!-- e.g., services/payment-service, services/order-service, shared/domain-events --> |
| **Task Type** | <!-- feat / fix / refactor / chore / docs / test --> |
| **Priority** | <!-- critical / high / medium / low --> |
| **Estimated Complexity** | <!-- small (< 2 files) / medium (3-8 files) / large (9+ files) --> |
| **Branch Name** | <!-- e.g., feat/PAY-456-add-refund-endpoint --> |

## Objective

<!-- One clear sentence describing what Claude Code should accomplish -->

## Context

### Business Context
<!-- Why this change is needed. Reference Jira ticket for full requirements. -->

### Technical Context
<!-- Current state of the codebase relevant to this task. Mention existing classes, Kafka topics, database tables, or API endpoints that are involved. -->

### Architecture Constraints
- [ ] Follows Hexagonal Architecture (Ports & Adapters)
- [ ] No direct REST calls between services — use Kafka events only
- [ ] Service has its own PostgreSQL schema — no cross-service DB access
- [ ] All domain events registered in \`schema-registry/\`

## Detailed Requirements

### Acceptance Criteria
<!-- Numbered list of specific, testable criteria -->
1. 
2. 
3. 

### API Changes (if applicable)
<!-- OpenAPI-style description of new or modified endpoints -->

**Endpoint**: \`<!-- e.g., POST /api/v1/payments/{id}/refund -->\`
**Request Body**:
\`\`\`json
{
}
\`\`\`
**Response** (\`<!-- status code -->\`):
\`\`\`json
{
}
\`\`\`

### Kafka Events (if applicable)

| Direction | Topic | Event Type | Schema Location |
|-----------|-------|------------|-----------------|
| Publish | <!-- e.g., payment.events --> | <!-- e.g., PaymentRefundedEvent --> | <!-- e.g., schema-registry/payment/PaymentRefundedEvent.avsc --> |
| Consume | <!-- e.g., order.events --> | <!-- e.g., OrderCancelledEvent --> | <!-- e.g., schema-registry/order/OrderCancelledEvent.avsc --> |

### Database Changes (if applicable)
<!-- Flyway migration needed? New tables, columns, indexes? -->

**Migration file**: \`<!-- e.g., services/payment-service/src/main/resources/db/migration/V005__add_refund_table.sql -->\`

\`\`\`sql
-- Describe schema changes
\`\`\`

### Domain Model Changes (if applicable)
<!-- New or modified entities, value objects, aggregates -->

## Implementation Guidance

### Key Files to Modify/Create
<!-- Ordered list of files Claude should touch, with brief description -->
1. \`<!-- e.g., services/payment-service/src/main/java/com/fintech/payment/domain/model/Refund.java -->\` — <!-- New entity -->
2. \`<!-- e.g., services/payment-service/src/main/java/com/fintech/payment/domain/port/in/RefundUseCase.java -->\` — <!-- Inbound port -->
3. \`<!-- e.g., services/payment-service/src/main/java/com/fintech/payment/domain/port/out/RefundRepository.java -->\` — <!-- Outbound port -->
4. \`<!-- e.g., services/payment-service/src/main/java/com/fintech/payment/application/service/RefundService.java -->\` — <!-- Use case implementation -->
5. \`<!-- e.g., services/payment-service/src/main/java/com/fintech/payment/adapter/in/web/RefundController.java -->\` — <!-- REST adapter -->
6. \`<!-- e.g., services/payment-service/src/main/java/com/fintech/payment/adapter/out/persistence/RefundJpaRepository.java -->\` — <!-- Persistence adapter -->
7. \`<!-- e.g., services/payment-service/src/main/java/com/fintech/payment/adapter/out/messaging/PaymentEventPublisher.java -->\` — <!-- Kafka producer adapter -->

### Reference Implementations
<!-- Existing files that demonstrate the patterns to follow -->
- Similar service: \`<!-- e.g., services/payment-service/src/main/java/com/fintech/payment/application/service/PaymentService.java -->\`
- Similar controller: \`<!-- e.g., services/payment-service/src/main/java/com/fintech/payment/adapter/in/web/PaymentController.java -->\`
- Similar event publisher: \`<!-- e.g., services/payment-service/src/main/java/com/fintech/payment/adapter/out/messaging/PaymentEventPublisher.java -->\`
- Similar test: \`<!-- e.g., services/payment-service/src/test/java/com/fintech/payment/application/service/PaymentServiceTest.java -->\`

### Spring Profiles & Configuration
<!-- Any new config properties needed -->
\`\`\`yaml
# application.yml additions
\`\`\`

### Packages to Use
<!-- Approved dependencies only — do NOT add new dependencies without approval -->
- \`spring-boot-starter-web\`
- \`spring-boot-starter-data-jpa\`
- \`spring-kafka\`
- \`<!-- other approved deps -->\`

## Testing Requirements

### Unit Tests (JUnit 5 + Mockito)
- [ ] Domain model tests (entity invariants, value object equality)
- [ ] Application service tests (mock outbound ports)
- [ ] Controller tests (\`@WebMvcTest\` with mocked use cases)
- [ ] Kafka producer/consumer unit tests

### Integration Tests (Testcontainers)
- [ ] Repository tests (\`@DataJpaTest\` with PostgreSQL Testcontainer)
- [ ] Kafka integration tests (embedded Kafka or Kafka Testcontainer)
- [ ] Full slice tests (\`@SpringBootTest\` with Testcontainers)

### Contract Tests (Pact)
- [ ] Provider contract for new/modified API endpoints
- [ ] Consumer contract for consumed Kafka events

### Coverage
- [ ] All new code meets 80% line coverage minimum
- [ ] Run \`./gradlew :services:<service-name>:test\` — all green
- [ ] Run \`./gradlew :services:<service-name>:integrationTest\` — all green
- [ ] Run \`./gradlew :services:<service-name>:jacocoTestReport\` — verify threshold

## Security & Compliance

### SOC 2 / PCI DSS Considerations
- [ ] No secrets, credentials, or PII in code or logs
- [ ] Sensitive fields annotated with \`@JsonIgnore\` or masked in logging
- [ ] Input validation on all API endpoints (\`@Valid\`, \`@NotNull\`, \`@Size\`, etc.)
- [ ] Authorization checks via Spring Security (\`@PreAuthorize\` or method security)
- [ ] Audit logging for state-changing operations
- [ ] SQL injection prevention (parameterized queries via JPA)

### Sensitive Paths
<!-- Does this task touch any sensitive paths requiring additional review? -->
- [ ] \`**/security/**\`
- [ ] \`**/auth/**\`
- [ ] \`infrastructure/production/**\`
- [ ] \`*.properties\` (config files)

## Validation Checklist

Before marking this task complete, verify:

- [ ] Code compiles: \`./gradlew :services:<service-name>:compileJava\`
- [ ] Checkstyle passes: \`./gradlew :services:<service-name>:checkstyleMain\`
- [ ] Unit tests pass: \`./gradlew :services:<service-name>:test\`
- [ ] Integration tests pass: \`./gradlew :services:<service-name>:integrationTest\`
- [ ] Coverage threshold met: \`./gradlew :services:<service-name>:jacocoTestCoverageVerification\`
- [ ] SpotBugs clean: \`./gradlew :services:<service-name>:spotbugsMain\`
- [ ] OWASP dependency check: \`./gradlew :services:<service-name>:dependencyCheckAnalyze\`
- [ ] OpenAPI spec updated (if API changed): \`services/<service-name>/src/main/resources/openapi/\`
- [ ] Kafka event schema added/updated in \`schema-registry/\`
- [ ] Flyway migration tested against clean database
- [ ] No files exceed 300 lines
- [ ] Conventional commit messages used
- [ ] PR description references this issue and Jira ticket
- [ ] AI-generated code flagged with \`ai-generated\` label on PR

## Out of Scope

<!-- Explicitly list what Claude should NOT do -->
- 
- 
- 

## Additional Notes

<!-- Any other context, diagrams, links to Confluence docs, Slack threads, or ADRs -->`,

  '.github/ISSUE_TEMPLATE/bug_report.md': `---
name: Bug Report
title: "[BUG] <service-name>: <brief description>"
labels: ["bug", "triage"]
assignees: []
---

## Service Information

**Affected Service(s):**
<!-- Select all that apply -->
- [ ] \`order-service\`
- [ ] \`payment-service\`
- [ ] \`user-service\`
- [ ] \`gateway\` (API Gateway)
- [ ] \`shared\` (shared libraries)
- [ ] Other: <!-- specify -->

**Environment:**
- [ ] Local (Docker Compose)
- [ ] Staging (EKS)
- [ ] Production (EKS)

**Service Version / Commit SHA:** <!-- e.g., v1.4.2 or abc1234 -->

**Spring Profile Active:** <!-- e.g., local, staging, production -->

## Observability

**Trace ID (Jaeger):** <!-- e.g., 6a3f8b2c1d4e5f00 — required for staging/production bugs -->

**Correlation ID:** <!-- X-Correlation-Id header value if available -->

**Grafana Dashboard Link:** <!-- paste link if applicable -->

**Kibana/ELK Log Query:** <!-- paste saved query or link if applicable -->

## Bug Description

**Summary:**
<!-- A clear, concise description of the bug -->

**Expected Behavior:**
<!-- What should have happened -->

**Actual Behavior:**
<!-- What actually happened -->

## Reproduction Steps

1. <!-- Step 1 -->
2. <!-- Step 2 -->
3. <!-- Step 3 -->

**Reproducibility:** 
- [ ] Always
- [ ] Intermittent (roughly ___% of the time)
- [ ] Only once so far

**API Endpoint (if applicable):**
<!-- e.g., POST /api/v1/orders — reference the OpenAPI spec in the service module -->

**Request Payload (if applicable):**
\`\`\`json

\`\`\`

**Response Received:**
\`\`\`json

\`\`\`

**HTTP Status Code:** <!-- e.g., 500, 422, 409 -->

## Kafka Event Context

<!-- Fill this section if the bug involves inter-service event communication -->

**Kafka Topic:** <!-- e.g., order.events, payment.completed -->

**Consumer Group:** <!-- e.g., payment-service-order-events -->

**Event Schema:** <!-- reference from schema-registry/, e.g., OrderCreatedEvent v2 -->

**Event Payload (if available):**
\`\`\`json

\`\`\`

**Offset / Partition:** <!-- if known -->

**Consumer Lag:** <!-- check Grafana Kafka dashboard -->

## Logs

<!-- Paste relevant log snippets. Redact any PII, credentials, or PCI DSS scoped data (card numbers, CVVs, etc.) -->

**Application Logs:**
\`\`\`
<!-- Paste structured JSON logs from ELK or stdout -->
\`\`\`

**Stack Trace (if applicable):**
\`\`\`java

\`\`\`

## Database Context

<!-- Fill if the bug involves data persistence -->

**Database:** <!-- e.g., order-service PostgreSQL (RDS) -->

**Relevant Table(s):** <!-- e.g., orders, order_items -->

**Query or Migration:** <!-- reference Flyway migration version if relevant, e.g., V12__add_status_index.sql -->

## Impact Assessment

**Severity:**
- [ ] **Critical** — Service down, data loss, or PCI DSS / SOC 2 compliance impact
- [ ] **High** — Major feature broken, no workaround
- [ ] **Medium** — Feature degraded, workaround exists
- [ ] **Low** — Minor issue, cosmetic, or edge case

**User Impact:**
<!-- How many users/transactions are affected? Is there financial impact? -->

**Workaround Available:**
<!-- Describe any temporary workaround if one exists -->

## Security & Compliance

<!-- Required for any bug involving auth, payments, or user data -->

- [ ] This bug involves authentication or authorization (\`**/security/**\`, \`**/auth/**\`)
- [ ] This bug involves payment processing or cardholder data (PCI DSS scope)
- [ ] This bug involves personally identifiable information (PII)
- [ ] This bug may indicate a security vulnerability (if yes, **do not include sensitive details here** — file via private security advisory instead)

## Additional Context

**Related Jira Ticket(s):** <!-- e.g., PAY-456, ORD-789 -->

**Related PR(s):** <!-- e.g., #123 — link any recent changes that may have introduced this -->

**Screenshots / Grafana Panels:**
<!-- Attach screenshots of dashboards, error rates, latency spikes -->

**Architecture Decision Records (ADRs):**
<!-- Reference any relevant ADR from docs/adr/ if this relates to a known architectural constraint -->`,

  '.github/ISSUE_TEMPLATE/feature_request.md': `---
name: Feature Request
about: Propose a new service, endpoint, event, or capability for the microservice platform
title: '[FEATURE] '
labels: 'feature, needs-triage'
assignees: ''
---

## Jira Ticket

<!-- Link the corresponding Jira ticket. All features must have a Jira ticket before implementation. -->
**Ticket**: [PAY-XXX](https://jira.example.com/browse/PAY-XXX)

## Feature Type

<!-- Check all that apply -->
- [ ] New microservice (under \`services/\`)
- [ ] New REST endpoint (API addition to existing service)
- [ ] New Kafka event / topic
- [ ] New shared library (under \`shared/\`)
- [ ] API Gateway route (under \`gateway/\`)
- [ ] Infrastructure change (Terraform, Helm, K8s)
- [ ] Cross-cutting concern (security, observability, caching)
- [ ] Other: _describe_

## Summary

<!-- One-paragraph description of the feature and the business problem it solves. -->

## Motivation & Business Context

<!-- Why is this needed? What user story, compliance requirement, or business goal does it serve? -->
<!-- For PCI DSS or SOC 2 related features, explicitly note the compliance control. -->

## Affected Services

<!-- List every microservice this feature touches. Remember: no direct REST calls between services — all inter-service communication through Kafka. -->

| Service | Impact |
|---------|--------|
| \`order-service\` | e.g., Publishes new event |
| \`payment-service\` | e.g., Consumes new event |
| \`gateway\` | e.g., New route added |

## Proposed Design

### Domain Model Changes

<!-- New entities, value objects, aggregates. Follow Hexagonal Architecture (Ports & Adapters). -->

\`\`\`
# Example:
services/payment-service/src/main/java/com/example/payment/
├── domain/
│   ├── model/           # New/modified domain entities
│   ├── port/in/         # New inbound ports (use cases)
│   └── port/out/        # New outbound ports (repositories, event publishers)
├── adapter/
│   ├── in/web/          # New REST controllers
│   ├── in/kafka/        # New Kafka consumers
│   ├── out/persistence/ # New JPA repositories
│   └── out/kafka/       # New Kafka producers
└── application/         # Use case implementations
\`\`\`

### API Specification

<!-- For new endpoints, provide the OpenAPI snippet. Each service maintains its own spec under the service module. -->

\`\`\`yaml
# Example:
# Path: services/payment-service/src/main/resources/openapi/payment-api.yaml
paths:
  /api/v1/payments/{id}/refund:
    post:
      summary: Initiate a payment refund
      operationId: initiateRefund
      parameters:
        - name: id
          in: path
          required: true
          schema:
            type: string
            format: uuid
      requestBody:
        required: true
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/RefundRequest'
      responses:
        '202':
          description: Refund initiated
\`\`\`

### Kafka Events

<!-- Define new events. All event schemas must be registered in \`schema-registry/\`. -->

| Event Name | Topic | Producer | Consumer(s) | Schema Path |
|------------|-------|----------|-------------|-------------|
| \`RefundInitiated\` | \`payment.refund.initiated\` | \`payment-service\` | \`order-service\`, \`notification-service\` | \`schema-registry/payment/refund-initiated.avsc\` |

**Event Schema Draft:**

\`\`\`json
{
  "type": "record",
  "name": "RefundInitiated",
  "namespace": "com.example.payment.events",
  "fields": [
    {"name": "eventId", "type": "string"},
    {"name": "timestamp", "type": "long", "logicalType": "timestamp-millis"},
    {"name": "paymentId", "type": "string"},
    {"name": "amount", "type": {"type": "bytes", "logicalType": "decimal", "precision": 12, "scale": 2}},
    {"name": "currency", "type": "string"},
    {"name": "reason", "type": "string"}
  ]
}
\`\`\`

### Database Changes

<!-- New tables, columns, indexes. Each service owns its own PostgreSQL database. -->

- **Service**: \`payment-service\`
- **Migration file**: \`V007__add_refunds_table.sql\` (Flyway)
- **Tables affected**: _describe_

### Redis Usage

<!-- Any new caching patterns, session changes, or distributed lock requirements. -->

- [ ] New cache key pattern: \`payment:refund:{paymentId}\` (TTL: 300s)
- [ ] Distributed lock required: _describe_
- [ ] No Redis changes

### Spring Security Considerations

<!-- New roles, permissions, OAuth2 scopes, or endpoint security rules. -->

- **Endpoint security**: \`@PreAuthorize("hasRole('PAYMENT_ADMIN')")\`
- **OAuth2 scope**: \`payment:refund:write\`
- **PCI DSS impact**: [ ] Yes / [ ] No — _explain_

## Configuration

<!-- New Spring Profile properties, environment variables, or feature flags. -->

\`\`\`yaml
# application-{profile}.yml additions
payment:
  refund:
    enabled: true
    max-amount: 10000.00
    retry-attempts: 3
\`\`\`

## Infrastructure Changes

<!-- Terraform, Helm chart, or Kubernetes manifest changes. -->

- [ ] New Kafka topic provisioning (Terraform: \`infrastructure/modules/kafka/\`)
- [ ] Helm chart update (\`charts/payment-service/\`)
- [ ] New AWS resource (RDS, ElastiCache, etc.)
- [ ] ALB / Route53 changes
- [ ] No infrastructure changes

## Testing Strategy

### Unit Tests
<!-- JUnit 5 + Mockito. Target: 80% coverage per JaCoCo. -->
- [ ] Domain model tests
- [ ] Use case / application service tests
- [ ] Adapter tests (mocked ports)

### Integration Tests
<!-- Testcontainers for PostgreSQL, Kafka, Redis. -->
- [ ] Repository integration tests (Testcontainers + PostgreSQL)
- [ ] Kafka producer/consumer integration tests (Testcontainers + Kafka)
- [ ] Redis cache integration tests (Testcontainers + Redis)
- [ ] REST endpoint integration tests (\`@SpringBootTest\` + \`WebTestClient\`)

### Contract Tests
<!-- Pact tests for API consumers/providers. -->
- [ ] Provider contract test (this service provides the API)
- [ ] Consumer contract test (this service consumes another API/event)
- [ ] Pact broker update required

### E2E Tests
<!-- End-to-end tests under \`tests/\`. -->
- [ ] New E2E scenario required
- [ ] Existing E2E scenarios affected: _list_

## Observability

- [ ] New Prometheus metrics: _describe_
- [ ] New Grafana dashboard or panel
- [ ] Distributed tracing spans (Jaeger): _describe_
- [ ] Log patterns for ELK: _describe_
- [ ] Actuator health indicator: _describe_

## Rollout Plan

- [ ] Feature flag gated (Spring Profile or config toggle)
- [ ] Database migration backward-compatible
- [ ] Kafka schema backward-compatible (Avro evolution rules)
- [ ] Canary deployment required
- [ ] Runbook update needed (\`docs/runbooks/\`)

## Compliance & Security Checklist

<!-- Required for SOC 2 and PCI DSS compliance. -->
- [ ] No PII/PCI data in logs or Kafka event payloads
- [ ] Sensitive fields encrypted at rest and in transit
- [ ] Audit trail for data mutations
- [ ] Access control reviewed (least privilege)
- [ ] Dependency scan clean (OWASP dependency-check)
- [ ] Security review requested (tag \`@security-team\`)

## Documentation

- [ ] OpenAPI spec updated (service module)
- [ ] ADR required (\`docs/adr/\`)
- [ ] Confluence page update
- [ ] README update for affected service
- [ ] Schema registry docs updated

## Definition of Done

- [ ] Jira ticket linked and status updated
- [ ] Code follows Hexagonal Architecture (Ports & Adapters)
- [ ] Checkstyle / ktlint passing
- [ ] JaCoCo coverage ≥ 80%
- [ ] All tests green (unit, integration, contract)
- [ ] SpotBugs and OWASP dependency-check clean
- [ ] Docker image builds and runs locally
- [ ] Helm chart linted (\`helm lint\`)
- [ ] PR approved by ≥ 2 reviewers
- [ ] CODEOWNERS notified for sensitive paths (\`**/security/**\`, \`**/auth/**\`, \`infrastructure/production/**\`)
- [ ] Signed commits verified

## Additional Context

<!-- Architecture diagrams, sequence diagrams, links to Confluence docs, Slack threads, or related PRs. -->`,

  '.github/PULL_REQUEST_TEMPLATE.md': `## Description

<!-- Provide a clear, concise description of what this PR does and why. -->

**Jira Ticket**: <!-- e.g., PAY-123, ORD-456 -->
**Related PRs**: <!-- Link any dependent or related PRs -->

## Change Type

- [ ] \`feat\` — New feature
- [ ] \`fix\` — Bug fix
- [ ] \`refactor\` — Code refactoring (no behavior change)
- [ ] \`chore\` — Build, CI, dependency updates
- [ ] \`docs\` — Documentation only
- [ ] \`perf\` — Performance improvement
- [ ] \`security\` — Security fix or hardening

## Services Affected

<!-- Check all microservices modified by this PR -->

- [ ] \`gateway/\` — API Gateway
- [ ] \`services/order-service/\`
- [ ] \`services/payment-service/\`
- [ ] \`services/user-service/\`
- [ ] \`shared/\` — Shared libraries
- [ ] \`schema-registry/\` — Event schemas
- [ ] \`infrastructure/\` — Terraform / Kubernetes
- [ ] \`charts/\` — Helm charts

## Architecture Checklist

- [ ] Follows Hexagonal Architecture (Ports & Adapters) — domain logic has no framework dependencies
- [ ] No direct REST calls between microservices (all inter-service communication via Kafka)
- [ ] New classes are under 300 lines
- [ ] Naming conventions followed (PascalCase classes, camelCase methods, SCREAMING_SNAKE_CASE constants)

## API Changes

<!-- Skip this section if no API changes -->

- [ ] OpenAPI spec updated in the affected service module
- [ ] API versioning maintained (no breaking changes to existing endpoints)
- [ ] Request/response DTOs documented with Jakarta Validation annotations
- [ ] Spring Security annotations applied to new endpoints
- [ ] API Gateway routes updated if new endpoints are publicly exposed
- [ ] Actuator endpoints remain secured and not accidentally exposed

**Endpoints added/modified**:
<!-- e.g., POST /api/v1/payments — Create payment -->

## Kafka / Event Schema Changes

<!-- Skip this section if no Kafka changes -->

- [ ] Event schema added/updated in \`schema-registry/\`
- [ ] Schema is backward-compatible (no breaking changes to existing consumers)
- [ ] Schema version incremented appropriately
- [ ] Kafka topic naming follows convention: \`{domain}.{entity}.{event}\` (e.g., \`payment.transaction.completed\`)
- [ ] Consumer group ID follows convention: \`{service-name}-{topic}-consumer\`
- [ ] Dead letter topic configured for new consumers
- [ ] Idempotency handled in consumer (duplicate event processing is safe)
- [ ] Event published within transaction boundary or using Outbox pattern

**Topics added/modified**:
<!-- e.g., payment.transaction.completed — new topic for payment completion events -->

**Schema changes**:
<!-- e.g., Added \`currency\` field (optional, default: USD) to PaymentCompletedEvent -->

## Database Changes

<!-- Skip this section if no database changes -->

- [ ] Flyway migration script added in the correct service module
- [ ] Migration is backward-compatible (supports rolling deployment)
- [ ] Indexes added for new query patterns
- [ ] No cross-service database access (each service owns its schema)
- [ ] Sensitive data columns encrypted at rest (PCI DSS requirement)

**Migration files**:
<!-- e.g., services/payment-service/src/main/resources/db/migration/V005__add_currency_column.sql -->

## Infrastructure Changes

<!-- Skip this section if no infrastructure changes -->

- [ ] Terraform plan reviewed (\`terraform plan\` output attached or summarized)
- [ ] Helm chart values updated for affected services
- [ ] No secrets or credentials in plain text (uses AWS Secrets Manager / K8s Secrets)
- [ ] Resource limits and requests defined for new containers
- [ ] Health check and readiness probe configured
- [ ] Production infrastructure changes reviewed by platform team

## Testing

- [ ] Unit tests added/updated (JUnit 5 + Mockito)
- [ ] Integration tests added/updated (Testcontainers with PostgreSQL/Kafka/Redis)
- [ ] Contract tests added/updated (Pact) for new inter-service interactions
- [ ] All tests pass locally: \`./gradlew test\`
- [ ] Integration tests pass: \`./gradlew integrationTest\`
- [ ] Code coverage meets 80% threshold (JaCoCo report reviewed)
- [ ] Edge cases and error paths covered

**Test summary**:
<!-- Brief description of what's tested and any notable test scenarios -->

## Security & Compliance

<!-- Required for all PRs — SOC 2 and PCI DSS compliance -->

- [ ] No secrets, API keys, tokens, or PII in code or config files
- [ ] No new dependencies with known CVEs (\`./gradlew dependencyCheckAnalyze\` passes)
- [ ] Input validation applied to all external inputs
- [ ] Authentication and authorization enforced on new endpoints
- [ ] Audit logging added for state-changing operations on sensitive data
- [ ] Changes to \`**/security/**\`, \`**/auth/**\`, \`infrastructure/production/**\`, or \`*.properties\` flagged for security review

**Security-sensitive files changed**: <!-- List any files in sensitive paths, or "None" -->

## Observability

- [ ] Structured logging added for new operations (SLF4J with MDC context)
- [ ] Distributed tracing propagated (Spring Cloud Sleuth / Micrometer Tracing)
- [ ] Prometheus metrics exposed for new business operations via Actuator
- [ ] Grafana dashboard updated if new metrics are added
- [ ] Alerts configured for new failure modes

## AI-Generated Code Disclosure

<!-- Required: Disclose any AI-assisted code generation per CI/CD policy -->

- [ ] **This PR contains AI-generated code**
- [ ] **This PR does NOT contain AI-generated code**

If AI-generated, provide details:
- **Tool used**: <!-- e.g., Claude Code, GitHub Copilot -->
- **Files/sections generated**: <!-- List specific files or describe scope -->
- **Human review performed**: <!-- Describe what was reviewed and validated -->
- **Modifications made to AI output**: <!-- Describe any changes made to generated code -->

## Deployment Notes

<!-- Any special instructions for deploying this change -->

- [ ] No special deployment steps required
- [ ] Requires environment variable changes (documented below)
- [ ] Requires Kafka topic creation (documented below)
- [ ] Requires database migration (runs automatically via Flyway)
- [ ] Requires feature flag configuration
- [ ] Requires coordinated deployment with other services

**Deployment instructions**:
<!-- Step-by-step if special steps are needed -->

## Rollback Plan

<!-- How to revert this change if issues are detected in production -->

**Rollback steps**:
<!-- e.g., Revert commit, re-deploy previous image tag, run compensating migration -->

**Rollback risk**: <!-- Low / Medium / High — and why -->

## Screenshots / Evidence

<!-- Attach relevant screenshots, logs, test output, or Grafana dashboards if applicable -->

## Reviewer Notes

<!-- Anything specific you'd like reviewers to focus on -->

---

**Pre-merge checklist** (completed by reviewer):
- [ ] Code quality and architecture reviewed
- [ ] Test coverage verified
- [ ] Security implications assessed
- [ ] Kafka schema compatibility confirmed (if applicable)
- [ ] Documentation is adequate
- [ ] AI-generated code disclosure reviewed`,

  '.github/workflows/ai-code-audit.yml': `name: AI Code Audit

on:
  schedule:
    - cron: '0 6 * * 1'  # Every Monday at 06:00 UTC (overlap window EU/Americas)
  workflow_dispatch:
    inputs:
      scope:
        description: 'Audit scope'
        required: false
        default: 'full'
        type: choice
        options:
          - full
          - security-only
          - spring-best-practices
          - architecture
          - kafka-patterns
          - test-quality
      services:
        description: 'Comma-separated service names (empty = all)'
        required: false
        default: ''
        type: string
      since_days:
        description: 'Audit changes from last N days (0 = full codebase)'
        required: false
        default: '7'
        type: string

permissions:
  contents: read
  issues: write
  pull-requests: read
  security-events: write

env:
  JAVA_VERSION: '21'
  GRADLE_VERSION: '8.5'
  AUDIT_REPORT_DIR: audit-reports
  MAX_FILE_LENGTH: 300

jobs:
  prepare:
    name: Prepare Audit Scope
    runs-on: ubuntu-latest
    outputs:
      services: \${{ steps.discover.outputs.services }}
      changed_files: \${{ steps.changes.outputs.files }}
      audit_scope: \${{ steps.scope.outputs.scope }}
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4
        with:
          fetch-depth: 0

      - name: Determine audit scope
        id: scope
        run: |
          SCOPE="\${{ inputs.scope || 'full' }}"
          echo "scope=$SCOPE" >> "$GITHUB_OUTPUT"
          echo "::notice::Audit scope: $SCOPE"

      - name: Discover services
        id: discover
        run: |
          if [ -n "\${{ inputs.services }}" ]; then
            SERVICES=$(echo "\${{ inputs.services }}" | tr ',' '\\n' | jq -R . | jq -sc .)
          else
            SERVICES=$(find services/ -maxdepth 1 -mindepth 1 -type d -exec basename {} \\; 2>/dev/null | jq -R . | jq -sc .)
            # Include gateway and shared
            EXTRA='["gateway","shared"]'
            SERVICES=$(echo "$SERVICES $EXTRA" | jq -sc 'add | unique')
          fi
          echo "services=$SERVICES" >> "$GITHUB_OUTPUT"
          echo "::notice::Services to audit: $SERVICES"

      - name: Identify changed files
        id: changes
        run: |
          SINCE_DAYS="\${{ inputs.since_days || '7' }}"
          if [ "$SINCE_DAYS" -eq 0 ]; then
            FILES=$(find services/ shared/ gateway/ -name '*.java' -o -name '*.kt' | head -500)
          else
            SINCE_DATE=$(date -d "-\${SINCE_DAYS} days" +%Y-%m-%d 2>/dev/null || date -v-\${SINCE_DAYS}d +%Y-%m-%d)
            FILES=$(git log --since="$SINCE_DATE" --name-only --pretty=format: -- '*.java' '*.kt' | sort -u | grep -v '^$' | head -500)
          fi
          echo "$FILES" > /tmp/changed_files.txt
          FILE_COUNT=$(wc -l < /tmp/changed_files.txt | tr -d ' ')
          echo "files<<EOF" >> "$GITHUB_OUTPUT"
          cat /tmp/changed_files.txt >> "$GITHUB_OUTPUT"
          echo "EOF" >> "$GITHUB_OUTPUT"
          echo "::notice::Files to audit: $FILE_COUNT"

  static-analysis:
    name: Static Analysis Baseline
    runs-on: ubuntu-latest
    needs: prepare
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4

      - name: Set up Java \${{ env.JAVA_VERSION }}
        uses: actions/setup-java@v4
        with:
          distribution: 'temurin'
          java-version: \${{ env.JAVA_VERSION }}

      - name: Setup Gradle
        uses: gradle/actions/setup-gradle@v3
        with:
          gradle-version: \${{ env.GRADLE_VERSION }}

      - name: Run Checkstyle
        continue-on-error: true
        run: ./gradlew checkstyleMain checkstyleTest --continue 2>&1 | tee \${{ env.AUDIT_REPORT_DIR }}/checkstyle-output.txt
        env:
          GRADLE_OPTS: '-Xmx2g'

      - name: Run SpotBugs
        continue-on-error: true
        run: ./gradlew spotbugsMain --continue 2>&1 | tee \${{ env.AUDIT_REPORT_DIR }}/spotbugs-output.txt

      - name: Run OWASP Dependency Check
        continue-on-error: true
        run: ./gradlew dependencyCheckAnalyze --continue 2>&1 | tee \${{ env.AUDIT_REPORT_DIR }}/owasp-output.txt

      - name: Run JaCoCo Coverage Report
        continue-on-error: true
        run: ./gradlew jacocoTestReport --continue 2>&1 | tee \${{ env.AUDIT_REPORT_DIR }}/jacoco-output.txt

      - name: Collect static analysis reports
        if: always()
        run: |
          mkdir -p \${{ env.AUDIT_REPORT_DIR }}
          # Gather Checkstyle XML reports
          find . -path '*/reports/checkstyle/*.xml' -exec cp {} \${{ env.AUDIT_REPORT_DIR }}/ \\; 2>/dev/null || true
          # Gather SpotBugs XML reports
          find . -path '*/reports/spotbugs/*.xml' -exec cp {} \${{ env.AUDIT_REPORT_DIR }}/ \\; 2>/dev/null || true
          # Gather JaCoCo CSV reports
          find . -path '*/reports/jacoco/**/*.csv' -exec cp {} \${{ env.AUDIT_REPORT_DIR }}/ \\; 2>/dev/null || true
          # Gather OWASP reports
          find . -path '*/reports/dependency-check*.json' -exec cp {} \${{ env.AUDIT_REPORT_DIR }}/ \\; 2>/dev/null || true

      - name: Upload static analysis artifacts
        if: always()
        uses: actions/upload-artifact@v4
        with:
          name: static-analysis-reports
          path: \${{ env.AUDIT_REPORT_DIR }}/
          retention-days: 30

  ai-audit:
    name: Claude AI Code Audit
    runs-on: ubuntu-latest
    needs: [prepare, static-analysis]
    strategy:
      fail-fast: false
      matrix:
        audit-category:
          - security-compliance
          - spring-best-practices
          - kafka-patterns
          - architecture-hexagonal
          - test-quality
          - code-quality
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4
        with:
          fetch-depth: 0

      - name: Check if category in scope
        id: check-scope
        run: |
          SCOPE="\${{ needs.prepare.outputs.audit_scope }}"
          CATEGORY="\${{ matrix.audit-category }}"
          SHOULD_RUN="true"
          if [ "$SCOPE" = "security-only" ] && [ "$CATEGORY" != "security-compliance" ]; then
            SHOULD_RUN="false"
          elif [ "$SCOPE" = "spring-best-practices" ] && [ "$CATEGORY" != "spring-best-practices" ]; then
            SHOULD_RUN="false"
          elif [ "$SCOPE" = "architecture" ] && [ "$CATEGORY" != "architecture-hexagonal" ]; then
            SHOULD_RUN="false"
          elif [ "$SCOPE" = "kafka-patterns" ] && [ "$CATEGORY" != "kafka-patterns" ]; then
            SHOULD_RUN="false"
          elif [ "$SCOPE" = "test-quality" ] && [ "$CATEGORY" != "test-quality" ]; then
            SHOULD_RUN="false"
          fi
          echo "should_run=$SHOULD_RUN" >> "$GITHUB_OUTPUT"

      - name: Download static analysis reports
        if: steps.check-scope.outputs.should_run == 'true'
        uses: actions/download-artifact@v4
        with:
          name: static-analysis-reports
          path: \${{ env.AUDIT_REPORT_DIR }}/

      - name: Set up Claude Code
        if: steps.check-scope.outputs.should_run == 'true'
        uses: anthropics/claude-code-action@v1
        id: claude-audit
        with:
          anthropic_api_key: \${{ secrets.ANTHROPIC_API_KEY }}
          timeout_minutes: 30
          prompt: |
            You are performing a weekly AI code audit for the spring-boot-microservices project.
            This is a financial services platform (SOC 2 / PCI DSS compliant) using:
            - Java 21, Spring Boot 3.2, Hexagonal Architecture
            - Apache Kafka for inter-service communication (no direct REST between services)
            - PostgreSQL per-service, Redis for caching/sessions
            - Kubernetes deployment via Helm charts

            ## Audit Category: \${{ matrix.audit-category }}

            ## Files Changed (last \${{ inputs.since_days || '7' }} days):
            \${{ needs.prepare.outputs.changed_files }}

            ## Services in scope:
            \${{ needs.prepare.outputs.services }}

            ## Static analysis reports are in: \${{ env.AUDIT_REPORT_DIR }}/

            ---

            Perform the following audit based on category "\${{ matrix.audit-category }}":

            ### If security-compliance:
            - Check for hardcoded secrets, API keys, credentials in Java/Kotlin/properties files
            - Verify Spring Security configurations follow PCI DSS requirements
            - Ensure sensitive paths (**/security/**, **/auth/**, *.properties) have proper access controls
            - Check for SQL injection risks in JPA queries (use parameterized queries only)
            - Verify Kafka message encryption and authentication (SASL/SSL)
            - Check Redis connection security (TLS, AUTH)
            - Ensure no PII/cardholder data in logs (PCI DSS Req 3.4)
            - Verify CORS, CSRF, and security headers configuration
            - Check for vulnerable dependencies from OWASP report
            - Ensure signed commits policy is not bypassed

            ### If spring-best-practices:
            - Verify proper use of Spring Profiles (dev, staging, production)
            - Check @Transactional usage (read-only where appropriate, proper propagation)
            - Verify Actuator endpoints are secured (not exposing sensitive info)
            - Check proper exception handling (@ControllerAdvice, problem details)
            - Verify Spring Kafka consumer/producer configurations (idempotency, error handling, DLQ)
            - Check proper use of Spring Data JPA (N+1 queries, pagination, projections)
            - Verify Spring Security filter chain configuration
            - Check for proper bean scoping and lifecycle management
            - Verify health checks and readiness/liveness probes
            - Check application.yml structure and profile-specific overrides

            ### If kafka-patterns:
            - Verify all inter-service communication uses Kafka (no direct REST calls between services)
            - Check event schema definitions in schema-registry/ match implementations
            - Verify consumer group naming conventions (service-name.consumer-group)
            - Check for proper idempotent consumers (deduplication keys)
            - Verify dead letter queue (DLQ) configuration for all consumers
            - Check Kafka transaction support for exactly-once semantics where needed
            - Verify event versioning strategy (backward/forward compatibility)
            - Check for proper error handling in @KafkaListener methods
            - Verify topic naming conventions (domain.entity.event-type)
            - Check partition key strategy for ordering guarantees

            ### If architecture-hexagonal:
            - Verify Hexagonal Architecture (Ports & Adapters) in each service
            - Check that domain layer has no Spring/infrastructure dependencies
            - Verify port interfaces are in domain layer, adapters in infrastructure
            - Check that use cases/application services orchestrate domain logic
            - Verify each service has proper module boundaries (no cross-service imports)
            - Check that shared/ library only contains DTOs, events, and common utilities
            - Verify Gradle module dependencies follow hexagonal layering
            - Check for proper aggregate root patterns in domain entities
            - Verify value objects are immutable
            - Check that domain events are defined in domain layer

            ### If test-quality:
            - Verify 80% code coverage threshold is met per service
            - Check JUnit 5 test quality (not just coverage — meaningful assertions)
            - Verify Testcontainers usage for integration tests (PostgreSQL, Kafka, Redis)
            - Check Pact contract tests exist for all inter-service Kafka events
            - Verify test isolation (no shared state between tests)
            - Check for proper use of @SpringBootTest vs @WebMvcTest vs @DataJpaTest
            - Verify mock vs real dependency usage is appropriate
            - Check that security-sensitive code has dedicated test coverage
            - Verify E2E test coverage for critical business flows
            - Check test naming conventions (should_expectedBehavior_when_condition)

            ### If code-quality:
            - Check files exceeding 300 lines and suggest decomposition
            - Verify naming conventions (PascalCase classes, camelCase methods, SCREAMING_SNAKE_CASE constants)
            - Check for code duplication across services
            - Verify proper use of Java 21 features (records, sealed classes, pattern matching, virtual threads)
            - Check Javadoc on public APIs and domain classes
            - Verify proper logging (SLF4J, structured logging, correlation IDs)
            - Check for proper null handling (Optional, @NonNull annotations)
            - Verify OpenAPI specs match controller implementations
            - Check Gradle build file consistency across modules
            - Verify no TODO/FIXME items older than 2 sprints

            ---

            ## Output Format

            Produce a structured audit report in Markdown with:

            1. **Executive Summary** — 2-3 sentence overview with severity counts
            2. **Critical Findings** — Issues requiring immediate attention (security, data loss risk)
            3. **High Priority** — Issues to address this sprint
            4. **Medium Priority** — Issues for backlog grooming
            5. **Low Priority / Suggestions** — Nice-to-have improvements
            6. **Positive Observations** — Good patterns found (reinforce good practices)

            For each finding include:
            - File path and line number(s)
            - Severity: CRITICAL / HIGH / MEDIUM / LOW
            - Category tag (e.g., [SECURITY], [SPRING], [KAFKA], [ARCH], [TEST], [QUALITY])
            - Description of the issue
            - Recommended fix with code example where applicable
            - Reference to relevant standard (PCI DSS req, Spring docs, etc.)

      - name: Save audit report
        if: steps.check-scope.outputs.should_run == 'true' && always()
        run: |
          mkdir -p \${{ env.AUDIT_REPORT_DIR }}
          REPORT_FILE="\${{ env.AUDIT_REPORT_DIR }}/audit-\${{ matrix.audit-category }}-$(date +%Y%m%d).md"
          cat << 'REPORT_EOF' > "$REPORT_FILE"
          \${{ steps.claude-audit.outputs.result || 'Audit did not produce output. Check workflow logs.' }}
          REPORT_EOF
          echo "report_file=$REPORT_FILE" >> "$GITHUB_ENV"

      - name: Upload audit report
        if: steps.check-scope.outputs.should_run == 'true' && always()
        uses: actions/upload-artifact@v4
        with:
          name: audit-report-\${{ matrix.audit-category }}
          path: \${{ env.AUDIT_REPORT_DIR }}/audit-\${{ matrix.audit-category }}*.md
          retention-days: 90

  consolidate:
    name: Consolidate Audit Reports
    runs-on: ubuntu-latest
    needs: ai-audit
    if: always()
    steps:
      - name:`,

  '.github/workflows/ci.yml': `name: CI Pipeline

on:
  pull_request:
    branches: [main, 'release/*']
  push:
    branches: [main]

concurrency:
  group: ci-\${{ github.ref }}
  cancel-in-progress: true

env:
  JAVA_VERSION: '21'
  JAVA_DISTRIBUTION: 'temurin'
  GRADLE_OPTS: '-Dorg.gradle.daemon=false -Dorg.gradle.parallel=true -Dorg.gradle.caching=true'
  DOCKER_BUILDKIT: 1

permissions:
  contents: read
  checks: write
  pull-requests: write
  security-events: write

jobs:
  lint:
    name: Lint & Format Check
    runs-on: ubuntu-latest
    timeout-minutes: 10
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Java \${{ env.JAVA_VERSION }}
        uses: actions/setup-java@v4
        with:
          java-version: \${{ env.JAVA_VERSION }}
          distribution: \${{ env.JAVA_DISTRIBUTION }}

      - name: Setup Gradle
        uses: gradle/actions/setup-gradle@v3
        with:
          cache-read-only: \${{ github.ref != 'refs/heads/main' }}

      - name: Checkstyle (Java)
        run: ./gradlew checkstyleMain checkstyleTest --continue

      - name: ktlint (Kotlin)
        run: ./gradlew ktlintCheck --continue

      - name: Upload Checkstyle reports
        if: always()
        uses: actions/upload-artifact@v4
        with:
          name: checkstyle-reports
          path: '**/build/reports/checkstyle/'
          retention-days: 7

  compile:
    name: Compile
    runs-on: ubuntu-latest
    timeout-minutes: 15
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Java \${{ env.JAVA_VERSION }}
        uses: actions/setup-java@v4
        with:
          java-version: \${{ env.JAVA_VERSION }}
          distribution: \${{ env.JAVA_DISTRIBUTION }}

      - name: Setup Gradle
        uses: gradle/actions/setup-gradle@v3
        with:
          cache-read-only: \${{ github.ref != 'refs/heads/main' }}

      - name: Compile all modules
        run: ./gradlew compileJava compileKotlin compileTestJava compileTestKotlin

  unit-tests:
    name: Unit Tests
    needs: compile
    runs-on: ubuntu-latest
    timeout-minutes: 20
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Java \${{ env.JAVA_VERSION }}
        uses: actions/setup-java@v4
        with:
          java-version: \${{ env.JAVA_VERSION }}
          distribution: \${{ env.JAVA_DISTRIBUTION }}

      - name: Setup Gradle
        uses: gradle/actions/setup-gradle@v3
        with:
          cache-read-only: \${{ github.ref != 'refs/heads/main' }}

      - name: Run unit tests
        run: ./gradlew test -x integrationTest -x contractTest --continue
        env:
          SPRING_PROFILES_ACTIVE: test

      - name: JaCoCo coverage report
        if: always()
        run: ./gradlew jacocoTestReport

      - name: Check coverage threshold (80%)
        run: ./gradlew jacocoTestCoverageVerification

      - name: Publish test results
        if: always()
        uses: dorny/test-reporter@v1
        with:
          name: Unit Test Results
          path: '**/build/test-results/test/TEST-*.xml'
          reporter: java-junit

      - name: Upload JaCoCo reports
        if: always()
        uses: actions/upload-artifact@v4
        with:
          name: jacoco-reports
          path: '**/build/reports/jacoco/'
          retention-days: 14

      - name: Add coverage to PR
        if: github.event_name == 'pull_request'
        uses: madrapps/jacoco-report@v1.6
        with:
          paths: '**/build/reports/jacoco/test/jacocoTestReport.xml'
          token: \${{ secrets.GITHUB_TOKEN }}
          min-coverage-overall: 80
          min-coverage-changed-files: 80
          title: '📊 Code Coverage Report'
          update-comment: true

  integration-tests:
    name: Integration Tests (Testcontainers)
    needs: compile
    runs-on: ubuntu-latest
    timeout-minutes: 30
    services:
      docker:
        image: docker:dind
        options: --privileged
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Java \${{ env.JAVA_VERSION }}
        uses: actions/setup-java@v4
        with:
          java-version: \${{ env.JAVA_VERSION }}
          distribution: \${{ env.JAVA_DISTRIBUTION }}

      - name: Setup Gradle
        uses: gradle/actions/setup-gradle@v3
        with:
          cache-read-only: \${{ github.ref != 'refs/heads/main' }}

      - name: Pre-pull Testcontainers images
        run: |
          docker pull postgres:16-alpine
          docker pull redis:7-alpine
          docker pull confluentinc/cp-kafka:7.6.0
          docker pull confluentinc/cp-schema-registry:7.6.0

      - name: Run integration tests
        run: ./gradlew integrationTest --continue
        env:
          SPRING_PROFILES_ACTIVE: integration-test
          TESTCONTAINERS_REUSE_ENABLE: true

      - name: Publish integration test results
        if: always()
        uses: dorny/test-reporter@v1
        with:
          name: Integration Test Results
          path: '**/build/test-results/integrationTest/TEST-*.xml'
          reporter: java-junit

      - name: Upload integration test reports
        if: always()
        uses: actions/upload-artifact@v4
        with:
          name: integration-test-reports
          path: '**/build/reports/tests/integrationTest/'
          retention-days: 7

  contract-tests:
    name: Contract Tests (Pact)
    needs: compile
    runs-on: ubuntu-latest
    timeout-minutes: 20
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Java \${{ env.JAVA_VERSION }}
        uses: actions/setup-java@v4
        with:
          java-version: \${{ env.JAVA_VERSION }}
          distribution: \${{ env.JAVA_DISTRIBUTION }}

      - name: Setup Gradle
        uses: gradle/actions/setup-gradle@v3
        with:
          cache-read-only: \${{ github.ref != 'refs/heads/main' }}

      - name: Run contract tests
        run: ./gradlew contractTest --continue
        env:
          SPRING_PROFILES_ACTIVE: contract-test

      - name: Publish Pact contracts
        if: github.ref == 'refs/heads/main'
        run: ./gradlew pactPublish
        env:
          PACT_BROKER_URL: \${{ secrets.PACT_BROKER_URL }}
          PACT_BROKER_TOKEN: \${{ secrets.PACT_BROKER_TOKEN }}

      - name: Publish contract test results
        if: always()
        uses: dorny/test-reporter@v1
        with:
          name: Contract Test Results
          path: '**/build/test-results/contractTest/TEST-*.xml'
          reporter: java-junit

  security-scan:
    name: Security Scan
    needs: compile
    runs-on: ubuntu-latest
    timeout-minutes: 25
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Java \${{ env.JAVA_VERSION }}
        uses: actions/setup-java@v4
        with:
          java-version: \${{ env.JAVA_VERSION }}
          distribution: \${{ env.JAVA_DISTRIBUTION }}

      - name: Setup Gradle
        uses: gradle/actions/setup-gradle@v3
        with:
          cache-read-only: \${{ github.ref != 'refs/heads/main' }}

      - name: OWASP Dependency Check
        run: ./gradlew dependencyCheckAnalyze --continue
        env:
          NVD_API_KEY: \${{ secrets.NVD_API_KEY }}

      - name: SpotBugs static analysis
        run: ./gradlew spotbugsMain --continue

      - name: Check for secrets in code
        uses: trufflesecurity/trufflehog@main
        with:
          extra_args: --only-verified

      - name: Upload OWASP report
        if: always()
        uses: actions/upload-artifact@v4
        with:
          name: owasp-dependency-check
          path: '**/build/reports/dependency-check-report.html'
          retention-days: 30

      - name: Upload OWASP SARIF
        if: always()
        uses: github/codeql-action/upload-sarif@v3
        with:
          sarif_file: '**/build/reports/dependency-check-report.sarif'
          category: owasp-dependency-check
        continue-on-error: true

      - name: Upload SpotBugs reports
        if: always()
        uses: actions/upload-artifact@v4
        with:
          name: spotbugs-reports
          path: '**/build/reports/spotbugs/'
          retention-days: 14

      - name: Fail on critical/high CVEs (PCI DSS / SOC 2)
        run: ./gradlew dependencyCheckAnalyze -PfailOnCVSS=7

  schema-validation:
    name: Kafka Schema Validation
    needs: compile
    runs-on: ubuntu-latest
    timeout-minutes: 10
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Java \${{ env.JAVA_VERSION }}
        uses: actions/setup-java@v4
        with:
          java-version: \${{ env.JAVA_VERSION }}
          distribution: \${{ env.JAVA_DISTRIBUTION }}

      - name: Setup Gradle
        uses: gradle/actions/setup-gradle@v3
        with:
          cache-read-only: \${{ github.ref != 'refs/heads/main' }}

      - name: Validate event schemas
        run: ./gradlew :schema-registry:validateSchemas

      - name: Check schema compatibility
        run: ./gradlew :schema-registry:checkCompatibility

  build-images:
    name: Build Docker Images
    needs: [unit-tests, integration-tests, contract-tests, security-scan, schema-validation, lint]
    runs-on: ubuntu-latest
    timeout-minutes: 20
    if: github.event_name == 'push' && github.ref == 'refs/heads/main'
    strategy:
      matrix:
        service:
          - order-service
          - payment-service
          - user-service
          - gateway
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Java \${{ env.JAVA_VERSION }}
        uses: actions/setup-java@v4
        with:
          java-version: \${{ env.JAVA_VERSION }}
          distribution: \${{ env.JAVA_DISTRIBUTION }}

      - name: Setup Gradle
        uses: gradle/actions/setup-gradle@v3

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          aws-access-key-id: \${{ secrets.AWS_ACCESS_KEY_ID }}
          aws-secret-access-key: \${{ secrets.AWS_SECRET_ACCESS_KEY }}
          aws-region: \${{ vars.AWS_REGION }}

      - name: Login to Amazon ECR
        id: ecr-login
        uses: aws-actions/amazon-ecr-login@v2

      - name: Build and push Docker image
        run: |
          SERVICE=\${{ matrix.service }}
          SERVICE_DIR="services/\${SERVICE}"
          if [ "\${SERVICE}" = "gateway" ]; then
            SERVICE_DIR="gateway"
          fi

          IMAGE_TAG="\${{ steps.ecr-login.outputs.registry }}/\${SERVICE}:\${GITHUB_SHA::8}"
          IMAGE_LATEST="\${{ steps.ecr-login.outputs.registry }}/\${SERVICE}:latest"

          ./gradlew :\${SERVICE_DIR//\\//:}:bootBuildImage \\
            --imageName="\${IMAGE_TAG}"

          docker tag "\${IMAGE_TAG}" "\${IMAGE_LATEST}"
          docker push "\${IMAGE_TAG}"
          docker push "\${IMAGE_LATEST}"

      - name: Sign container image (SOC 2 compliance)
        uses: sigstore/cosign-installer@v3
      
      - name: Cosign image
        run: |
          SERVICE=\${{ matrix.service }}
          IMAGE_TAG="\${{ steps.ecr-login.outputs.registry }}/\${SERVICE}:\${GITHUB_SHA::8}"
          cosign sign --yes "\${IMAGE_TAG}"
        env:
          COSIGN_EXPERIMENTAL: 1

  ai-code-label:
    name: AI Code Detection
    runs-on: ubuntu-latest
    if: github.event_name == 'pull_request'
    timeout-minutes: 5
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          fetch-depth: 0

      - name: Check for AI-generated code markers
        id: ai-check
        run: |
          AI_FILES=$(git diff --name-only origin/\${{ github.base_ref }}...HEAD | \\
            xargs grep -l "AI-Generated\\|Generated by Claude\\|@ai-generated" 2>/dev/null || true)
          if [ -n "$AI_FILES" ]; then
            echo "ai_detected=true" >> "$GITHUB_OUTPUT"
            echo "### 🤖 AI-Generated Code Detected" >> "$GITHUB_STEP_SUMMARY"
            echo "$AI_FILES" >> "$GITHUB_STEP_SUMMARY"
          else
            echo "ai_detected=false" >> "$GITHUB_OUTPUT"
          fi

      - name: Label PR with ai-generated
        if: steps.ai-check.outputs.ai_detected == 'true'
        uses: actions/github-script@v7
        with:
          script: |
            github.rest.issues.addLabels({
              owner: context.repo.owner,
              repo: context.repo.repo,
              issue_number: context.issue.number,
              labels: ['ai-generated']
            });

  gate:
    name: CI Gate
    needs: [lint, unit-tests, integration-tests, contract-tests, security-scan, schema-validation]
    runs-on: ubuntu-latest
    if: always()
    steps:
      - name: Evaluate results
        run: |
          echo "Lint: \${{ needs.lint.result }}"
          echo "Unit Tests: \${{ needs.unit-tests.result }}"
          echo "Integration Tests: \${{ needs.integration-tests.result }}"
          echo "Contract Tests: \${{ needs.contract-tests.result }}"
          echo "Security Scan: \${{ needs.security-scan.result }}"
          echo "Schema Validation: \${{ needs.schema-validation.result }}"

          if [[ "\${{ needs.lint.result }}" != "success" || \\
                "\${{ needs.unit-tests.result }}" != "success" || \\
                "\${{ needs.integration-tests.result }}" != "success" || \\
                "\${{ needs.contract-tests.result }}" != "success" || \\
                "\${{ needs.security-scan.result }}" != "success" || \\
                "\${{ needs.schema-validation.result }}" != "success" ]]; then
            echo "::error::One or more CI checks failed. All checks must pass for merge."
            exit 1
          fi

          echo "`,

  '.github/workflows/deploy-production.yml': `name: Deploy Production

on:
  workflow_dispatch:
    inputs:
      service:
        description: 'Service to deploy (e.g., order-service, payment-service, user-service, gateway)'
        required: true
        type: choice
        options:
          - order-service
          - payment-service
          - user-service
          - notification-service
          - gateway
      image_tag:
        description: 'Docker image tag (SHA or semantic version)'
        required: true
        type: string
      canary_weight:
        description: 'Initial canary traffic percentage'
        required: false
        type: choice
        default: '10'
        options:
          - '5'
          - '10'
          - '20'
      skip_kafka_lag_check:
        description: 'Skip Kafka consumer lag check (emergency only)'
        required: false
        type: boolean
        default: false
      rollback_tag:
        description: 'Image tag to rollback to if deployment fails'
        required: false
        type: string

concurrency:
  group: production-deploy-\${{ github.event.inputs.service }}
  cancel-in-progress: false

env:
  AWS_REGION: us-east-1
  EKS_CLUSTER: spring-microservices-prod
  ECR_REGISTRY: \${{ secrets.AWS_ACCOUNT_ID }}.dkr.ecr.us-east-1.amazonaws.com
  HELM_NAMESPACE: production
  KAFKA_BOOTSTRAP_SERVERS: \${{ secrets.PROD_KAFKA_BOOTSTRAP_SERVERS }}
  CANARY_PROMOTION_THRESHOLD: 95
  MAX_CONSUMER_LAG_THRESHOLD: 1000
  HEALTH_CHECK_RETRIES: 30
  HEALTH_CHECK_INTERVAL: 10

permissions:
  id-token: write
  contents: read
  deployments: write
  issues: write

jobs:
  # ---------------------------------------------------------------------------
  # Pre-flight validation
  # ---------------------------------------------------------------------------
  preflight:
    name: Pre-flight Checks
    runs-on: ubuntu-latest
    outputs:
      image_exists: \${{ steps.check-image.outputs.exists }}
      current_tag: \${{ steps.current-version.outputs.tag }}
      consumer_groups: \${{ steps.kafka-groups.outputs.groups }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_PROD_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Login to ECR
        id: ecr-login
        uses: aws-actions/amazon-ecr-login@v2

      - name: Verify Docker image exists in ECR
        id: check-image
        run: |
          IMAGE="\${ECR_REGISTRY}/\${{ github.event.inputs.service }}:\${{ github.event.inputs.image_tag }}"
          if aws ecr describe-images \\
            --repository-name "\${{ github.event.inputs.service }}" \\
            --image-ids imageTag="\${{ github.event.inputs.image_tag }}" \\
            --region "\${AWS_REGION}" > /dev/null 2>&1; then
            echo "exists=true" >> "$GITHUB_OUTPUT"
            echo "✅ Image found: \${IMAGE}"
          else
            echo "exists=false" >> "$GITHUB_OUTPUT"
            echo "❌ Image not found: \${IMAGE}"
            exit 1
          fi

      - name: Verify image was security scanned
        run: |
          SCAN_STATUS=$(aws ecr describe-image-scan-findings \\
            --repository-name "\${{ github.event.inputs.service }}" \\
            --image-id imageTag="\${{ github.event.inputs.image_tag }}" \\
            --query 'imageScanStatus.status' \\
            --output text 2>/dev/null || echo "NOT_FOUND")

          if [ "$SCAN_STATUS" != "COMPLETE" ]; then
            echo "❌ ECR image scan not complete. Status: \${SCAN_STATUS}"
            exit 1
          fi

          CRITICAL=$(aws ecr describe-image-scan-findings \\
            --repository-name "\${{ github.event.inputs.service }}" \\
            --image-id imageTag="\${{ github.event.inputs.image_tag }}" \\
            --query 'imageScanFindings.findingSeverityCounts.CRITICAL' \\
            --output text 2>/dev/null || echo "0")

          if [ "$CRITICAL" != "0" ] && [ "$CRITICAL" != "None" ]; then
            echo "❌ Image has \${CRITICAL} CRITICAL vulnerabilities. Deployment blocked (PCI DSS)."
            exit 1
          fi
          echo "✅ Security scan passed — no critical vulnerabilities"

      - name: Configure kubectl
        run: |
          aws eks update-kubeconfig \\
            --name "\${EKS_CLUSTER}" \\
            --region "\${AWS_REGION}"

      - name: Get current deployed version
        id: current-version
        run: |
          CURRENT_TAG=$(kubectl get deployment "\${{ github.event.inputs.service }}" \\
            -n "\${HELM_NAMESPACE}" \\
            -o jsonpath='{.spec.template.spec.containers[0].image}' 2>/dev/null | \\
            awk -F: '{print $NF}' || echo "none")
          echo "tag=\${CURRENT_TAG}" >> "$GITHUB_OUTPUT"
          echo "📌 Current production tag: \${CURRENT_TAG}"

      - name: Identify Kafka consumer groups for service
        id: kafka-groups
        run: |
          SERVICE="\${{ github.event.inputs.service }}"
          case "$SERVICE" in
            order-service)
              GROUPS="order-service-group,order-payment-events-group"
              ;;
            payment-service)
              GROUPS="payment-service-group,payment-order-events-group"
              ;;
            user-service)
              GROUPS="user-service-group,user-notification-events-group"
              ;;
            notification-service)
              GROUPS="notification-service-group"
              ;;
            gateway)
              GROUPS=""
              ;;
            *)
              GROUPS="\${SERVICE}-group"
              ;;
          esac
          echo "groups=\${GROUPS}" >> "$GITHUB_OUTPUT"
          echo "📡 Kafka consumer groups: \${GROUPS:-none}"

      - name: Verify staging deployment matches
        run: |
          STAGING_TAG=$(kubectl get deployment "\${{ github.event.inputs.service }}" \\
            -n staging \\
            -o jsonpath='{.spec.template.spec.containers[0].image}' 2>/dev/null | \\
            awk -F: '{print $NF}' || echo "none")

          if [ "$STAGING_TAG" != "\${{ github.event.inputs.image_tag }}" ]; then
            echo "⚠️  WARNING: Image \${{ github.event.inputs.image_tag }} is not currently deployed to staging (staging has: \${STAGING_TAG})"
            echo "⚠️  Proceeding — ensure this image has been validated."
          else
            echo "✅ Image matches current staging deployment"
          fi

  # ---------------------------------------------------------------------------
  # Manual approval gate (SOC 2 / PCI DSS requirement)
  # ---------------------------------------------------------------------------
  approval:
    name: Production Approval Gate
    needs: preflight
    runs-on: ubuntu-latest
    environment:
      name: production
      url: https://api.example.com
    steps:
      - name: Deployment summary
        run: |
          echo "## 🚀 Production Deployment Request" >> "$GITHUB_STEP_SUMMARY"
          echo "" >> "$GITHUB_STEP_SUMMARY"
          echo "| Parameter | Value |" >> "$GITHUB_STEP_SUMMARY"
          echo "|-----------|-------|" >> "$GITHUB_STEP_SUMMARY"
          echo "| **Service** | \\\`\${{ github.event.inputs.service }}\\\` |" >> "$GITHUB_STEP_SUMMARY"
          echo "| **Image Tag** | \\\`\${{ github.event.inputs.image_tag }}\\\` |" >> "$GITHUB_STEP_SUMMARY"
          echo "| **Current Tag** | \\\`\${{ needs.preflight.outputs.current_tag }}\\\` |" >> "$GITHUB_STEP_SUMMARY"
          echo "| **Canary Weight** | \${{ github.event.inputs.canary_weight }}% |" >> "$GITHUB_STEP_SUMMARY"
          echo "| **Kafka Groups** | \\\`\${{ needs.preflight.outputs.consumer_groups }}\\\` |" >> "$GITHUB_STEP_SUMMARY"
          echo "| **Requested By** | @\${{ github.actor }} |" >> "$GITHUB_STEP_SUMMARY"
          echo "| **Rollback Tag** | \\\`\${{ github.event.inputs.rollback_tag || needs.preflight.outputs.current_tag }}\\\` |" >> "$GITHUB_STEP_SUMMARY"
          echo "" >> "$GITHUB_STEP_SUMMARY"
          echo "⏳ **Awaiting manual approval from production environment reviewers.**" >> "$GITHUB_STEP_SUMMARY"
          echo "" >> "$GITHUB_STEP_SUMMARY"
          echo "_SOC 2 / PCI DSS: All production deployments require explicit approval._" >> "$GITHUB_STEP_SUMMARY"

  # ---------------------------------------------------------------------------
  # Pre-deployment Kafka consumer lag check
  # ---------------------------------------------------------------------------
  kafka-lag-check:
    name: Kafka Consumer Lag Check
    needs: [preflight, approval]
    runs-on: ubuntu-latest
    if: \${{ github.event.inputs.skip_kafka_lag_check != 'true' && needs.preflight.outputs.consumer_groups != '' }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_PROD_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Configure kubectl
        run: |
          aws eks update-kubeconfig \\
            --name "\${EKS_CLUSTER}" \\
            --region "\${AWS_REGION}"

      - name: Check Kafka consumer lag
        run: |
          IFS=',' read -ra GROUPS <<< "\${{ needs.preflight.outputs.consumer_groups }}"
          FAILED=false

          for GROUP in "\${GROUPS[@]}"; do
            echo "🔍 Checking consumer group: \${GROUP}"

            # Use kafka-consumer-groups.sh via a Kafka tools pod in the cluster
            LAG=$(kubectl exec -n kafka kafka-tools-0 -- \\
              kafka-consumer-groups.sh \\
                --bootstrap-server "\${KAFKA_BOOTSTRAP_SERVERS}" \\
                --group "\${GROUP}" \\
                --describe 2>/dev/null | \\
              awk 'NR>1 && $6 ~ /^[0-9]+$/ {sum += $6} END {print sum+0}')

            echo "  Consumer group '\${GROUP}' total lag: \${LAG}"

            if [ "\${LAG}" -gt "\${MAX_CONSUMER_LAG_THRESHOLD}" ]; then
              echo "  ❌ Lag \${LAG} exceeds threshold \${MAX_CONSUMER_LAG_THRESHOLD}"
              FAILED=true
            else
              echo "  ✅ Lag within acceptable range"
            fi
          done

          if [ "$FAILED" = true ]; then
            echo ""
            echo "❌ Kafka consumer lag too high. Consumers must catch up before deployment."
            echo "   This prevents message loss during pod restarts."
            echo "   Use skip_kafka_lag_check=true for emergency deployments only."
            exit 1
          fi

          echo ""
          echo "✅ All consumer groups within acceptable lag thresholds"

  # ---------------------------------------------------------------------------
  # Canary deployment
  # ---------------------------------------------------------------------------
  canary-deploy:
    name: Canary Deployment
    needs: [preflight, approval, kafka-lag-check]
    if: \${{ always() && needs.approval.result == 'success' && (needs.kafka-lag-check.result == 'success' || needs.kafka-lag-check.result == 'skipped') }}
    runs-on: ubuntu-latest
    outputs:
      canary_healthy: \${{ steps.health-check.outputs.healthy }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_PROD_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Configure kubectl
        run: |
          aws eks update-kubeconfig \\
            --name "\${EKS_CLUSTER}" \\
            --region "\${AWS_REGION}"

      - name: Setup Helm
        uses: azure/setup-helm@v3
        with:
          version: '3.14.0'

      - name: Deploy canary via Helm
        run: |
          SERVICE="\${{ github.event.inputs.service }}"
          IMAGE_TAG="\${{ github.event.inputs.image_tag }}"
          CANARY_WEIGHT="\${{ github.event.inputs.canary_weight }}"

          echo "🐤 Deploying canary: \${SERVICE}:\${IMAGE_TAG} at \${CANARY_WEIGHT}% traffic"

          helm upgrade "\${SERVICE}-canary" \\
            "./charts/\${SERVICE}" \\
            --namespace "\${HELM_NAMESPACE}" \\
            --install \\
            --wait \\
            --timeout 10m \\
            --set image.repository="\${ECR_REGISTRY}/\${SERVICE}" \\
            --set image.tag="\${IMAGE_TAG}" \\
            --set canary.enabled=true \\
            --set canary.weight="\${CANARY_WEIGHT}" \\
            --set replicaCount=1 \\
            --set spring.profiles.active=production \\
            --set podAnnotations.deploy-source="github-actions" \\
            --set podAnnotations.deploy-actor="\${{ github.actor }}" \\
            --set podAnnotations.deploy-run="\${{ github.run_id }}" \\
            --set podAnnotations.ai-generated="false" \\
            --values "./charts/\${SERVICE}/values-production.yaml" \\
            --values "./charts/\${SERVICE}/values-canary.yaml"

          echo "✅ Canary Helm release deployed"

      - name: Wait for canary pods to be ready
        run: |
          SERVICE="\${{ github.event.inputs.service }}"
          echo "⏳ Waiting for canary pods..."

          kubectl rollout status deployment "\${SERVICE}-canary" \\
            -n "\${HELM_NAMESPACE}" \\
            --timeout=300s

          echo "✅ Canary pods are ready"

      - name: Health check — Spring Actuator
        id: health-check
        run: |
          SERVICE="\${{ github.event.inputs.service }}"
          HEALTHY=false

          for i in $(seq 1 "\${HEALTH_CHECK_RETRIES}"); do
            echo "🏥 Health check attempt \${i}/\${HEALTH_CHECK_RETRIES}..."

            # Port-forward to canary pod and check actuator health
            POD=$(kubectl get pods -n "\${HELM_NAMESPACE}" \\
              -l "app=\${SERVICE},track=canary" \\
              -o jsonpath='{.items[0].metadata.name}' 2>/dev/null)

            if [ -z "$POD" ]; then
              echo "  No canary pod found yet..."
              sleep "\${HEALTH_CHECK_INTERVAL}"
              continue
            fi

            STATUS=$(kubectl exec -n "\${HELM_NAMESPACE}" "\${POD}" -- \\
              curl -sf http://localhost:8080/actuator/health 2>/dev/null | \\
              python3 -c "import sys,json; print(json.load(sys.stdin).get('status','UNKNOWN'))" 2>/dev/null || echo "UNREACHABLE")

            echo "  Pod \${POD} health: \${STATUS}"

            if [ "$STATUS" = "UP" ]; then`,

  '.github/workflows/deploy-staging.yml': `name: Deploy Staging

on:
  push:
    branches: [main]
  workflow_dispatch:
    inputs:
      services:
        description: 'Comma-separated list of services to deploy (empty = all changed)'
        required: false
        type: string

permissions:
  id-token: write
  contents: read
  packages: read
  actions: read

env:
  AWS_REGION: us-east-1
  ECR_REGISTRY: \${{ secrets.AWS_ACCOUNT_ID }}.dkr.ecr.us-east-1.amazonaws.com
  EKS_CLUSTER: spring-microservices-staging
  K8S_NAMESPACE: staging
  HELM_VERSION: '3.14.0'
  JAVA_VERSION: '21'
  GRADLE_VERSION: '8.5'

concurrency:
  group: deploy-staging
  cancel-in-progress: false

jobs:
  detect-changes:
    name: Detect Changed Services
    runs-on: ubuntu-latest
    outputs:
      services: \${{ steps.resolve.outputs.services }}
      matrix: \${{ steps.resolve.outputs.matrix }}
      has_services: \${{ steps.resolve.outputs.has_services }}
      shared_changed: \${{ steps.changes.outputs.shared }}
      infra_changed: \${{ steps.changes.outputs.infrastructure }}
      gateway_changed: \${{ steps.changes.outputs.gateway }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          fetch-depth: 0

      - name: Detect file changes
        id: changes
        uses: dorny/paths-filter@v3
        with:
          filters: |
            order-service:
              - 'services/order-service/**'
            payment-service:
              - 'services/payment-service/**'
            user-service:
              - 'services/user-service/**'
            notification-service:
              - 'services/notification-service/**'
            account-service:
              - 'services/account-service/**'
            gateway:
              - 'gateway/**'
            shared:
              - 'shared/**'
            schema-registry:
              - 'schema-registry/**'
            infrastructure:
              - 'infrastructure/**'
              - 'charts/**'

      - name: Resolve services to deploy
        id: resolve
        run: |
          ALL_SERVICES=("order-service" "payment-service" "user-service" "notification-service" "account-service" "gateway")

          if [[ -n "\${{ github.event.inputs.services }}" ]]; then
            IFS=',' read -ra DEPLOY_SERVICES <<< "\${{ github.event.inputs.services }}"
            DEPLOY_SERVICES=( "\${DEPLOY_SERVICES[@]// /}" )
          elif [[ "\${{ steps.changes.outputs.shared }}" == "true" ]] || [[ "\${{ steps.changes.outputs.schema-registry }}" == "true" ]]; then
            # Shared libs or schemas changed — rebuild all services
            DEPLOY_SERVICES=("\${ALL_SERVICES[@]}")
          else
            DEPLOY_SERVICES=()
            for svc in "\${ALL_SERVICES[@]}"; do
              if [[ "$svc" == "gateway" ]]; then
                key="gateway"
              else
                key="$svc"
              fi
              if [[ "\${{ steps.changes.outputs[key] }}" == "true" ]]; then
                DEPLOY_SERVICES+=("$svc")
              fi
            done
          fi

          if [[ \${#DEPLOY_SERVICES[@]} -eq 0 ]]; then
            echo "has_services=false" >> "$GITHUB_OUTPUT"
            echo "services=[]" >> "$GITHUB_OUTPUT"
            echo "matrix={\\"service\\":[]}" >> "$GITHUB_OUTPUT"
            echo "::notice::No services to deploy"
          else
            JSON_ARRAY=$(printf '%s\\n' "\${DEPLOY_SERVICES[@]}" | jq -R . | jq -sc .)
            echo "has_services=true" >> "$GITHUB_OUTPUT"
            echo "services=\${JSON_ARRAY}" >> "$GITHUB_OUTPUT"
            echo "matrix={\\"service\\":\${JSON_ARRAY}}" >> "$GITHUB_OUTPUT"
            echo "::notice::Deploying services: \${DEPLOY_SERVICES[*]}"
          fi

  lint-and-compile:
    name: Lint & Compile
    runs-on: ubuntu-latest
    needs: detect-changes
    if: needs.detect-changes.outputs.has_services == 'true'
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Java \${{ env.JAVA_VERSION }}
        uses: actions/setup-java@v4
        with:
          distribution: temurin
          java-version: \${{ env.JAVA_VERSION }}

      - name: Setup Gradle
        uses: gradle/actions/setup-gradle@v3
        with:
          cache-read-only: false

      - name: Run Checkstyle
        run: ./gradlew checkstyleMain checkstyleTest --no-daemon

      - name: Run ktlint
        run: ./gradlew ktlintCheck --no-daemon

      - name: Compile all modules
        run: ./gradlew compileJava compileKotlin --no-daemon

  test:
    name: Test Suite
    runs-on: ubuntu-latest
    needs: lint-and-compile
    services:
      postgres:
        image: postgres:16-alpine
        env:
          POSTGRES_USER: test
          POSTGRES_PASSWORD: test
          POSTGRES_DB: testdb
        ports:
          - 5432:5432
        options: >-
          --health-cmd pg_isready
          --health-interval 10s
          --health-timeout 5s
          --health-retries 5
      redis:
        image: redis:7-alpine
        ports:
          - 6379:6379
        options: >-
          --health-cmd "redis-cli ping"
          --health-interval 10s
          --health-timeout 5s
          --health-retries 5
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Java \${{ env.JAVA_VERSION }}
        uses: actions/setup-java@v4
        with:
          distribution: temurin
          java-version: \${{ env.JAVA_VERSION }}

      - name: Setup Gradle
        uses: gradle/actions/setup-gradle@v3

      - name: Run unit tests
        run: ./gradlew test --no-daemon -Dspring.profiles.active=test
        env:
          SPRING_DATASOURCE_URL: jdbc:postgresql://localhost:5432/testdb
          SPRING_DATASOURCE_USERNAME: test
          SPRING_DATASOURCE_PASSWORD: test
          SPRING_REDIS_HOST: localhost
          SPRING_REDIS_PORT: 6379

      - name: Run integration tests (Testcontainers)
        run: ./gradlew integrationTest --no-daemon -Dspring.profiles.active=integration-test
        env:
          TESTCONTAINERS_RYUK_DISABLED: false

      - name: Run contract tests (Pact)
        run: ./gradlew contractTest --no-daemon -Dspring.profiles.active=contract-test

      - name: Check coverage threshold (80%)
        run: ./gradlew jacocoTestCoverageVerification --no-daemon

      - name: Upload test reports
        if: always()
        uses: actions/upload-artifact@v4
        with:
          name: test-reports
          path: |
            **/build/reports/tests/
            **/build/reports/jacoco/
          retention-days: 14

      - name: Upload coverage to Codecov
        if: always()
        uses: codecov/codecov-action@v4
        with:
          token: \${{ secrets.CODECOV_TOKEN }}
          files: '**/build/reports/jacoco/test/jacocoTestReport.xml'
          fail_ci_if_error: false

  security-scan:
    name: Security Scan
    runs-on: ubuntu-latest
    needs: lint-and-compile
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Java \${{ env.JAVA_VERSION }}
        uses: actions/setup-java@v4
        with:
          distribution: temurin
          java-version: \${{ env.JAVA_VERSION }}

      - name: Setup Gradle
        uses: gradle/actions/setup-gradle@v3

      - name: OWASP Dependency Check
        run: ./gradlew dependencyCheckAnalyze --no-daemon
        env:
          NVD_API_KEY: \${{ secrets.NVD_API_KEY }}

      - name: SpotBugs security analysis
        run: ./gradlew spotbugsMain --no-daemon

      - name: Trivy filesystem scan
        uses: aquasecurity/trivy-action@master
        with:
          scan-type: fs
          scan-ref: .
          severity: CRITICAL,HIGH
          exit-code: 1
          format: sarif
          output: trivy-fs-results.sarif

      - name: Upload Trivy results
        if: always()
        uses: github/codeql-action/upload-sarif@v3
        with:
          sarif_file: trivy-fs-results.sarif

      - name: Upload OWASP report
        if: always()
        uses: actions/upload-artifact@v4
        with:
          name: security-reports
          path: '**/build/reports/dependency-check*'
          retention-days: 30

  build-and-push:
    name: Build & Push — \${{ matrix.service }}
    runs-on: ubuntu-latest
    needs: [detect-changes, test, security-scan]
    if: needs.detect-changes.outputs.has_services == 'true'
    strategy:
      fail-fast: false
      matrix: \${{ fromJson(needs.detect-changes.outputs.matrix) }}
    outputs:
      image_tags: \${{ steps.meta.outputs.tags }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Set up Java \${{ env.JAVA_VERSION }}
        uses: actions/setup-java@v4
        with:
          distribution: temurin
          java-version: \${{ env.JAVA_VERSION }}

      - name: Setup Gradle
        uses: gradle/actions/setup-gradle@v3

      - name: Resolve module path
        id: module
        run: |
          if [[ "\${{ matrix.service }}" == "gateway" ]]; then
            echo "path=gateway" >> "$GITHUB_OUTPUT"
            echo "gradle_module=:gateway" >> "$GITHUB_OUTPUT"
          else
            echo "path=services/\${{ matrix.service }}" >> "$GITHUB_OUTPUT"
            echo "gradle_module=:services:\${{ matrix.service }}" >> "$GITHUB_OUTPUT"
          fi

      - name: Build service JAR
        run: ./gradlew \${{ steps.module.outputs.gradle_module }}:bootJar --no-daemon -Dspring.profiles.active=staging

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Login to Amazon ECR
        id: ecr-login
        uses: aws-actions/amazon-ecr-login@v2

      - name: Generate image metadata
        id: meta
        run: |
          SHORT_SHA=$(git rev-parse --short HEAD)
          TIMESTAMP=$(date +%Y%m%d%H%M%S)
          IMAGE_TAG="staging-\${SHORT_SHA}-\${TIMESTAMP}"
          FULL_IMAGE="\${{ env.ECR_REGISTRY }}/\${{ matrix.service }}:\${IMAGE_TAG}"
          LATEST_IMAGE="\${{ env.ECR_REGISTRY }}/\${{ matrix.service }}:staging-latest"

          echo "image_tag=\${IMAGE_TAG}" >> "$GITHUB_OUTPUT"
          echo "full_image=\${FULL_IMAGE}" >> "$GITHUB_OUTPUT"
          echo "latest_image=\${LATEST_IMAGE}" >> "$GITHUB_OUTPUT"
          echo "tags=\${FULL_IMAGE},\${LATEST_IMAGE}" >> "$GITHUB_OUTPUT"

      - name: Set up Docker Buildx
        uses: docker/setup-buildx-action@v3

      - name: Build and push Docker image
        uses: docker/build-push-action@v5
        with:
          context: \${{ steps.module.outputs.path }}
          file: \${{ steps.module.outputs.path }}/Dockerfile
          push: true
          tags: |
            \${{ steps.meta.outputs.full_image }}
            \${{ steps.meta.outputs.latest_image }}
          labels: |
            org.opencontainers.image.source=\${{ github.server_url }}/\${{ github.repository }}
            org.opencontainers.image.revision=\${{ github.sha }}
            org.opencontainers.image.created=\${{ github.event.head_commit.timestamp }}
            com.codeforge.service=\${{ matrix.service }}
            com.codeforge.environment=staging
            com.codeforge.ai-generated=\${{ contains(github.event.head_commit.message, '[ai-generated]') }}
          build-args: |
            JAR_FILE=build/libs/*.jar
            SPRING_PROFILES_ACTIVE=staging
            APP_VERSION=\${{ steps.meta.outputs.image_tag }}
          cache-from: type=gha,scope=\${{ matrix.service }}
          cache-to: type=gha,mode=max,scope=\${{ matrix.service }}
          platforms: linux/amd64

      - name: Scan Docker image with Trivy
        uses: aquasecurity/trivy-action@master
        with:
          image-ref: \${{ steps.meta.outputs.full_image }}
          severity: CRITICAL,HIGH
          exit-code: 1
          format: table
          vuln-type: os,library

      - name: Store image tag for deploy
        run: |
          mkdir -p /tmp/image-tags
          echo "\${{ steps.meta.outputs.image_tag }}" > /tmp/image-tags/\${{ matrix.service }}

      - name: Upload image tag artifact
        uses: actions/upload-artifact@v4
        with:
          name: image-tag-\${{ matrix.service }}
          path: /tmp/image-tags/\${{ matrix.service }}
          retention-days: 1

  deploy-staging:
    name: Deploy to EKS Staging
    runs-on: ubuntu-latest
    needs: [detect-changes, build-and-push]
    if: needs.detect-changes.outputs.has_services == 'true'
    environment:
      name: staging
      url: https://staging-api.example.com
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Download all image tag artifacts
        uses: actions/download-artifact@v4
        with:
          path: /tmp/image-tags
          pattern: image-tag-*
          merge-multiple: true

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Update kubeconfig
        run: |
          aws eks update-kubeconfig \\
            --name \${{ env.EKS_CLUSTER }} \\
            --region \${{ env.AWS_REGION }}

      - name: Install Helm
        uses: azure/setup-helm@v3
        with:
          version: \${{ env.HELM_VERSION }}

      - name: Add Helm repos
        run: |
          helm repo add bitnami https://charts.bitnami.com/bitnami
          helm repo update

      - name: Deploy services via Helm
        run: |
          SERVICES='\${{ needs.detect-changes.outputs.services }}'

          for SERVICE in $(echo "$SERVICES" | jq -r '.[]'); do
            echo "========================================="
            echo "Deploying \${SERVICE} to staging"`,

  '.gitignore': `# === Java ===
*.class
*.jar
*.war
*.ear
*.nar
hs_err_pid*
replay_pid*

# === Gradle ===
.gradle/
build/
!gradle/wrapper/gradle-wrapper.jar
!**/src/main/**/build/
!**/src/test/**/build/

# === Spring Boot ===
# Sensitive properties (PCI DSS / SOC 2 compliance — never commit secrets)
application-local.properties
application-local.yml
application-secret.properties
application-secret.yml
application-prod.properties
application-prod.yml
**/src/main/resources/application-local*.properties
**/src/main/resources/application-local*.yml
**/src/main/resources/application-secret*.yml
**/src/main/resources/bootstrap-local*.yml
**/src/main/resources/bootstrap-secret*.yml

# Spring Boot DevTools
.spring-boot-devtools.properties

# === IDE ===
# IntelliJ IDEA
.idea/
*.iml
*.iws
*.ipr
out/

# Eclipse
.classpath
.project
.settings/
bin/

# VS Code
.vscode/
!.vscode/settings.json
!.vscode/extensions.json

# NetBeans
nbproject/
nbbuild/
nbdist/
nb-configuration.xml

# === OS ===
.DS_Store
Thumbs.db
desktop.ini
*~

# === Docker ===
**/docker-compose.override.yml
**/.docker-env
**/.env
**/.env.local
**/.env.*.local

# === Kubernetes / Helm ===
charts/**/charts/
charts/**/*.tgz
infrastructure/production/**/*.tfstate
infrastructure/production/**/*.tfstate.backup
infrastructure/**/.terraform/
infrastructure/**/*.tfvars
!infrastructure/**/*.tfvars.example

# === Terraform ===
.terraform/
*.tfstate
*.tfstate.*
crash.log
crash.*.log
override.tf
override.tf.json
*_override.tf
*_override.tf.json
.terraformrc
terraform.rc

# === Test & Coverage ===
**/test-results/
**/test-output/
**/jacoco/
**/jacoco.exec
**/coverage/
**/htmlReport/

# === Static Analysis ===
**/checkstyle-result.xml
**/spotbugs/
**/spotbugsXml.xml
**/dependency-check-report.*
**/owasp-dependency-check/

# === Logs ===
*.log
logs/
**/spring.log

# === Kafka (local dev) ===
kafka-data/
zookeeper-data/

# === Redis (local dev) ===
dump.rdb

# === Schema Registry ===
schema-registry/build/
schema-registry/.generated/

# === Secrets & Credentials ===
*.pem
*.key
*.p12
*.jks
*.keystore
*.truststore
credentials/
secrets/
**/*-secret.yml
**/*-secret.yaml
**/*-credentials.*

# === Misc ===
*.swp
*.swo
*.bak
*.tmp
*.orig
.project-cache/`,

  '.mcp.json': `{
  "mcpServers": {
    "github": {
      "command": "npx",
      "args": ["-y", "@modelcontextprotocol/server-github"],
      "env": {
        "GITHUB_PERSONAL_ACCESS_TOKEN": "\${GITHUB_TOKEN}"
      }
    },
    "jira": {
      "command": "npx",
      "args": ["-y", "@modelcontextprotocol/server-atlassian"],
      "env": {
        "ATLASSIAN_HOST": "\${JIRA_HOST}",
        "ATLASSIAN_USER_EMAIL": "\${JIRA_USER_EMAIL}",
        "ATLASSIAN_API_TOKEN": "\${JIRA_API_TOKEN}"
      }
    },
    "confluence": {
      "command": "npx",
      "args": ["-y", "@modelcontextprotocol/server-atlassian"],
      "env": {
        "ATLASSIAN_HOST": "\${CONFLUENCE_HOST}",
        "ATLASSIAN_USER_EMAIL": "\${CONFLUENCE_USER_EMAIL}",
        "ATLASSIAN_API_TOKEN": "\${CONFLUENCE_API_TOKEN}"
      }
    },
    "slack": {
      "command": "npx",
      "args": ["-y", "@modelcontextprotocol/server-slack"],
      "env": {
        "SLACK_BOT_TOKEN": "\${SLACK_BOT_TOKEN}",
        "SLACK_TEAM_ID": "\${SLACK_TEAM_ID}"
      }
    },
    "postgres": {
      "command": "npx",
      "args": ["-y", "@modelcontextprotocol/server-postgres"],
      "env": {
        "POSTGRES_CONNECTION_STRING": "\${LOCAL_POSTGRES_URL:-postgresql://localhost:5432/microservices_dev}"
      }
    },
    "filesystem": {
      "command": "npx",
      "args": [
        "-y",
        "@modelcontextprotocol/server-filesystem",
        "services/",
        "shared/",
        "gateway/",
        "schema-registry/",
        "charts/",
        "infrastructure/",
        "docs/",
        "tests/",
        "playbook/"
      ]
    },
    "kafka": {
      "command": "npx",
      "args": ["-y", "@codeforge/mcp-server-kafka"],
      "env": {
        "KAFKA_BOOTSTRAP_SERVERS": "\${KAFKA_BOOTSTRAP_SERVERS:-localhost:9092}",
        "KAFKA_SCHEMA_REGISTRY_URL": "\${SCHEMA_REGISTRY_URL:-http://localhost:8081}",
        "KAFKA_SECURITY_PROTOCOL": "\${KAFKA_SECURITY_PROTOCOL:-PLAINTEXT}"
      }
    },
    "aws": {
      "command": "npx",
      "args": ["-y", "@modelcontextprotocol/server-aws"],
      "env": {
        "AWS_PROFILE": "\${AWS_PROFILE:-microservices-dev}",
        "AWS_REGION": "\${AWS_REGION:-us-east-1}"
      }
    },
    "prometheus": {
      "command": "npx",
      "args": ["-y", "@codeforge/mcp-server-prometheus"],
      "env": {
        "PROMETHEUS_URL": "\${PROMETHEUS_URL:-http://localhost:9090}"
      }
    },
    "grafana": {
      "command": "npx",
      "args": ["-y", "@codeforge/mcp-server-grafana"],
      "env": {
        "GRAFANA_URL": "\${GRAFANA_URL:-http://localhost:3000}",
        "GRAFANA_API_KEY": "\${GRAFANA_API_KEY}"
      }
    }
  }
}`,

  'CLAUDE.md': `# CLAUDE.md — Project Intelligence

## Project Overview

Spring Boot 3.2 microservices platform (Java 21) for financial services. Event-driven architecture using Kafka for all inter-service communication. Kubernetes-native deployment on AWS EKS. SOC 2 and PCI DSS compliant.

## Repository Structure

This is a Gradle multi-module monorepo:

- \`services/\` — Bounded microservices (order-service, payment-service, user-service, etc.)
- \`shared/\` — Shared libraries (domain events, DTOs, common utilities)
- \`gateway/\` — Spring Cloud Gateway (API gateway, routing, rate limiting)
- \`schema-registry/\` — Avro/JSON schemas for all Kafka domain events
- \`infrastructure/\` — Terraform IaC for AWS (EKS, RDS, MSK, ElastiCache)
- \`charts/\` — Helm charts (one per service)
- \`tests/\` — E2E and Pact contract tests
- \`docs/\` — ADRs, architecture diagrams, runbooks
- \`plugin/codeforge-spring-boot-microservices/\` — CodeForge plugin (agents, commands, skills)
- \`playbook/\` — Development methodology phases

## Architecture Rules

- **Hexagonal Architecture** (Ports & Adapters) in every service. Domain logic has zero framework imports.
- **No direct REST calls between services.** All inter-service communication goes through Kafka topics. The only inbound REST is from external clients through the API gateway.
- Each service owns its own PostgreSQL database — no shared databases.
- Redis is used for caching and session management, never as a primary data store.
- Every domain event must have a registered schema in \`schema-registry/\` before use.
- Spring Profiles control environment config: \`local\`, \`dev\`, \`staging\`, \`production\`.

## Build & Run Commands

\`\`\`bash
# Full build (compile + test + check)
./gradlew build

# Run a specific service locally
./gradlew :services:payment-service:bootRun --args='--spring.profiles.active=local'

# Unit tests only
./gradlew test

# Integration tests (requires Docker for Testcontainers)
./gradlew integrationTest

# Contract tests (Pact)
./gradlew contractTest

# Lint (Checkstyle for Java, ktlint for Kotlin)
./gradlew checkstyleMain checkstyleTest ktlintCheck

# Format code
./gradlew googleJavaFormat ktlintFormat

# Security scan
./gradlew dependencyCheckAnalyze

# Coverage report (JaCoCo, 80% threshold enforced)
./gradlew jacocoTestCoverageVerification

# Build Docker image for a service
./gradlew :services:payment-service:jibDockerBuild

# Run full local stack (Kafka, PostgreSQL, Redis)
docker compose -f docker-compose.local.yml up -d
\`\`\`

## Code Conventions

- **Java**: google-java-format, Checkstyle (Google style with project overrides)
- **Kotlin**: ktlint (shared libraries and build scripts only)
- **Classes**: PascalCase — \`PaymentProcessedEvent\`, \`OrderRepository\`
- **Methods/variables**: camelCase — \`processPayment()\`, \`orderId\`
- **Constants**: SCREAMING_SNAKE_CASE — \`MAX_RETRY_ATTEMPTS\`
- **Modules**: kebab-case — \`payment-service\`, \`order-service\`
- **Kafka topics**: domain.entity.action — \`payment.transaction.completed\`
- **Consumer groups**: service-name-group — \`order-service-group\`
- **Max file length**: 300 lines. If longer, decompose.

## Service Module Layout (Hexagonal)

Each service under \`services/\` follows this package structure:

\`\`\`
com.platform.{service}/
├── domain/           # Entities, value objects, domain events, repository ports
│   ├── model/
│   ├── event/
│   └── port/
├── application/      # Use cases, application services, input ports
│   ├── usecase/
│   └── service/
├── adapter/
│   ├── in/
│   │   ├── web/      # REST controllers (Spring MVC)
│   │   └── kafka/    # Kafka consumers
│   └── out/
│       ├── persistence/  # JPA repositories, entities, mappers
│       ├── kafka/        # Kafka producers
│       └── cache/        # Redis adapters
└── config/           # Spring configuration, beans, security
\`\`\`

## Testing Strategy

- **Unit tests** (JUnit 5 + Mockito): Domain and application layers. No Spring context.
- **Integration tests** (Testcontainers): Adapter layer. Real PostgreSQL, Kafka, Redis in containers.
- **Contract tests** (Pact): Verify Kafka event schemas between producer and consumer services.
- **E2E tests**: In \`tests/\` directory, run against staging environment.
- Coverage threshold: **80%** enforced by JaCoCo. Domain layer should be >90%.

## Security & Compliance

- **SOC 2 and PCI DSS** compliance required. All changes to security paths need security team review.
- Sensitive paths requiring extra scrutiny: \`**/security/**\`, \`**/auth/**\`, \`infrastructure/production/**\`, \`*.properties\`
- No secrets in code or config files. Use AWS Secrets Manager or Spring Cloud Config with encrypted values.
- All API endpoints require authentication via Spring Security (JWT/OAuth2).
- PII must be encrypted at rest and masked in logs.
- Dependency updates require security scan approval (OWASP dependency-check).

## Git Workflow

- **GitHub Flow**: branch from \`main\`, PR back to \`main\`.
- Branch naming: \`type/TICKET-desc\` (e.g., \`feat/PAY-123-add-payment-service\`)
- Conventional commits: \`feat:\`, \`fix:\`, \`chore:\`, \`docs:\`, \`refactor:\`
- Signed commits required. PRs need 2 approvals + passing CI + security scan.
- Protected branches: \`main\`, \`release/*\`
- CODEOWNERS enforced — check \`.github/CODEOWNERS\` for ownership.

## CI/CD Pipeline

GitHub Actions: Lint → Compile → Unit Tests → Integration Tests → Contract Tests → Security Scan → Docker Build → Deploy Staging → E2E Tests → Deploy Production. Staging deploys automatically on merge to \`main\`. Production requires manual approval. AI-generated code is flagged in PRs.

## Key Dependencies

- Spring Boot 3.2 (Web, Data JPA, Security, Kafka, Actuator, Validation)
- Spring Cloud Gateway (API gateway)
- Apache Kafka (event streaming via Spring Kafka)
- PostgreSQL (per-service, managed via Flyway migrations)
- Redis (Spring Data Redis, Lettuce client)
- Testcontainers (integration testing)
- Pact (contract testing)
- JaCoCo (coverage), Checkstyle, SpotBugs, OWASP dependency-check
- Jib (Docker image building without Dockerfile)
- Helm 3 (Kubernetes deployment)

## Observability

- **Metrics**: Micrometer → Prometheus. Every service exposes \`/actuator/prometheus\`.
- **Tracing**: Micrometer Tracing → Jaeger. Trace IDs propagate through Kafka headers.
- **Logging**: Structured JSON logs → ELK Stack. Always include \`traceId\`, \`spanId\`, \`serviceId\`.
- **Health**: \`/actuator/health\` includes liveness and readiness probes for K8s.

## What Claude Should Know

- Always check \`schema-registry/\` before creating or modifying Kafka events.
- Run \`./gradlew build\` to validate changes — it runs lint, compile, and tests.
- Flyway migrations are in \`services/{name}/src/main/resources/db/migration/\`. Never modify existing migrations; always create new ones.
- Shared code goes in \`shared/\` module. Services depend on shared, never on each other.
- When creating a new service, it needs: Gradle module, Dockerfile, Helm chart, OpenAPI spec, Flyway baseline, and Kafka consumer group config.
- Refer to \`docs/\` for ADRs and architecture decisions before proposing structural changes.
- The \`playbook/\` directory contains phased development methodology — follow it for new feature development.`,

  'README.md': `# Spring Boot Microservices Platform

[![CI Pipeline](https://github.com/your-org/spring-boot-microservices/actions/workflows/ci.yml/badge.svg)](https://github.com/your-org/spring-boot-microservices/actions/workflows/ci.yml)
[![Deploy Staging](https://github.com/your-org/spring-boot-microservices/actions/workflows/deploy-staging.yml/badge.svg)](https://github.com/your-org/spring-boot-microservices/actions/workflows/deploy-staging.yml)
[![Deploy Production](https://github.com/your-org/spring-boot-microservices/actions/workflows/deploy-production.yml/badge.svg)](https://github.com/your-org/spring-boot-microservices/actions/workflows/deploy-production.yml)
[![Coverage](https://img.shields.io/badge/coverage-80%25+-brightgreen)]()
[![Java](https://img.shields.io/badge/Java-21-orange)]()
[![Spring Boot](https://img.shields.io/badge/Spring%20Boot-3.2-green)]()
[![License](https://img.shields.io/badge/license-proprietary-red)]()
[![SOC 2](https://img.shields.io/badge/compliance-SOC%202-blue)]()
[![PCI DSS](https://img.shields.io/badge/compliance-PCI%20DSS-blue)]()

An event-driven microservice platform for financial services, built with Spring Boot 3.2 and Java 21. Services communicate exclusively through Apache Kafka — no direct REST calls between services. Each service owns its data (PostgreSQL), uses Redis for caching, and deploys to Kubernetes via Helm charts.

---

## Table of Contents

- [Architecture Overview](#architecture-overview)
- [Microservices](#microservices)
- [Tech Stack](#tech-stack)
- [Repository Structure](#repository-structure)
- [Prerequisites](#prerequisites)
- [Quickstart](#quickstart)
- [Development Workflow](#development-workflow)
- [Testing](#testing)
- [Deployment](#deployment)
- [Observability](#observability)
- [Compliance](#compliance)
- [Documentation](#documentation)
- [Contributing](#contributing)

---

## Architecture Overview

\`\`\`
                          ┌──────────────────┐
                          │   API Gateway     │
                          │ (Spring Cloud GW) │
                          └────────┬─────────┘
                                   │
                    ┌──────────────┼──────────────┐
                    │              │              │
              ┌─────▼─────┐ ┌─────▼─────┐ ┌─────▼─────┐
              │   User     │ │   Order    │ │  Payment   │
              │  Service   │ │  Service   │ │  Service   │
              └─────┬──────┘ └─────┬──────┘ └─────┬──────┘
                    │              │              │
                    │    ┌─────────▼──────────┐   │
                    └────►    Apache Kafka     ◄──┘
                         │  (Event Streaming) │
                         └─────────┬──────────┘
                                   │
                    ┌──────────────┼──────────────┐
                    │              │              │
              ┌─────▼─────┐ ┌─────▼─────┐ ┌─────▼─────┐
              │ Notification│ │   Audit    │ │ Analytics  │
              │  Service   │ │  Service   │ │  Service   │
              └────────────┘ └────────────┘ └────────────┘

    Each service owns its PostgreSQL database. Redis provides caching.
    All inter-service communication flows through Kafka topics.
    Schema Registry enforces event contract compatibility.
\`\`\`

For the full architecture document, see [docs/ARCHITECTURE.md](docs/ARCHITECTURE.md).

### Key Design Principles

- **Hexagonal Architecture** (Ports & Adapters) within each service
- **Event-driven communication** — services publish domain events to Kafka, never call each other directly
- **Database-per-service** — each service owns its PostgreSQL schema
- **Schema-first events** — all domain events have schemas in the shared schema registry
- **Infrastructure as Code** — Terraform for AWS, Helm for Kubernetes

---

## Microservices

| Service | Module | Port | Description | Kafka Topics |
|---------|--------|------|-------------|--------------|
| **API Gateway** | \`gateway/\` | 8080 | Routes external traffic, rate limiting, auth | — |
| **User Service** | \`services/user-service/\` | 8081 | User registration, profiles, KYC | \`user.created\`, \`user.updated\`, \`user.kyc-verified\` |
| **Order Service** | \`services/order-service/\` | 8082 | Order lifecycle, matching, fulfillment | \`order.placed\`, \`order.fulfilled\`, \`order.cancelled\` |
| **Payment Service** | \`services/payment-service/\` | 8083 | Payment processing, ledger, settlements | \`payment.initiated\`, \`payment.completed\`, \`payment.failed\` |
| **Notification Service** | \`services/notification-service/\` | 8084 | Email, SMS, push notifications | Consumes from multiple topics |
| **Audit Service** | \`services/audit-service/\` | 8085 | Compliance audit trail, immutable log | Consumes all domain events |
| **Analytics Service** | \`services/analytics-service/\` | 8086 | Reporting, metrics aggregation | Consumes all domain events |

---

## Tech Stack

| Category | Technology |
|----------|-----------|
| **Language** | Java 21 (services), Kotlin (shared libraries, build scripts) |
| **Framework** | Spring Boot 3.2 (Web, Data JPA, Security, Kafka, Actuator) |
| **Messaging** | Apache Kafka 3.6, Schema Registry (Avro/JSON Schema) |
| **Databases** | PostgreSQL 16 (per-service), Redis 7 (caching, sessions) |
| **Build** | Gradle 8.x (Kotlin DSL), multi-module monorepo |
| **Containers** | Docker, Kubernetes 1.28+, Helm 3 |
| **Cloud** | AWS (EKS, RDS, ElastiCache, MSK, ECR, ALB, Route53) |
| **IaC** | Terraform 1.6+ |
| **CI/CD** | GitHub Actions |
| **Testing** | JUnit 5, Mockito, Testcontainers, Pact (contract tests) |
| **Code Quality** | Checkstyle, ktlint, SpotBugs, OWASP Dependency-Check, JaCoCo |
| **Observability** | Prometheus, Grafana, Jaeger (tracing), ELK Stack (logging) |
| **Security** | Spring Security, OAuth 2.0 / JWT, Trivy (container scanning) |

---

## Repository Structure

\`\`\`
spring-boot-microservices/
├── services/                    # Individual microservices
│   ├── user-service/
│   ├── order-service/
│   ├── payment-service/
│   ├── notification-service/
│   ├── audit-service/
│   └── analytics-service/
├── shared/                      # Shared libraries
│   ├── domain-events/           # Domain event classes and interfaces
│   ├── common-dto/              # Shared DTOs
│   └── common-utils/            # Cross-cutting utilities
├── gateway/                     # Spring Cloud Gateway
├── schema-registry/             # Avro/JSON schemas for Kafka events
├── infrastructure/              # Terraform modules
│   ├── modules/
│   ├── staging/
│   └── production/
├── charts/                      # Helm charts per service
├── tests/                       # E2E and contract tests
├── docs/                        # Architecture, ADRs, runbooks
├── .github/                     # Workflows, templates, CODEOWNERS
├── .claude/                     # Claude Code rules and settings
├── plugin/                      # CodeForge plugin
├── playbook/                    # Development methodology phases
├── git-hooks/                   # Git hooks (commit-msg, pre-commit, pre-push)
├── mock-mcp-servers/            # Mock MCP servers for local development
├── build.gradle.kts             # Root build file
├── settings.gradle.kts          # Module declarations
├── gradle.properties            # Shared Gradle properties
└── docker-compose.yml           # Local development stack
\`\`\`

---

## Prerequisites

| Tool | Version | Purpose |
|------|---------|---------|
| **Java** | 21+ | Runtime and compilation |
| **Docker** | 24+ | Local containers, Testcontainers |
| **Docker Compose** | 2.20+ | Local infrastructure stack |
| **Gradle** | 8.x (wrapper included) | Build system |
| **kubectl** | 1.28+ | Kubernetes CLI (for deployment) |
| **Helm** | 3.13+ | Chart deployment (for deployment) |
| **Terraform** | 1.6+ | Infrastructure provisioning (for infra changes) |

---

## Quickstart

### 1. Clone and set up

\`\`\`bash
git clone git@github.com:your-org/spring-boot-microservices.git
cd spring-boot-microservices

# Install git hooks
cp git-hooks/* .git/hooks/
chmod +x .git/hooks/*
\`\`\`

### 2. Start local infrastructure

\`\`\`bash
# Starts PostgreSQL, Kafka (with Schema Registry), Redis, Jaeger
docker compose up -d
\`\`\`

### 3. Build all services

\`\`\`bash
./gradlew build
\`\`\`

### 4. Run a specific service

\`\`\`bash
# Run with local Spring Profile
./gradlew :services:order-service:bootRun --args='--spring.profiles.active=local'
\`\`\`

### 5. Run all services locally

\`\`\`bash
# Build Docker images for all services
./gradlew jibDockerBuild

# Start everything
docker compose --profile all-services up -d
\`\`\`

### 6. Verify

\`\`\`bash
# Gateway health check
curl http://localhost:8080/actuator/health

# Individual service health
curl http://localhost:8082/actuator/health

# Jaeger UI (distributed tracing)
open http://localhost:16686

# Kafka UI
open http://localhost:8090
\`\`\`

---

## Development Workflow

### Branch naming

\`\`\`
feat/PAY-123-add-payment-service
fix/ORD-456-fix-order-validation
chore/INF-789-update-helm-charts
\`\`\`

### Commit messages (Conventional Commits)

\`\`\`
feat(payment-service): add idempotent payment processing
fix(order-service): correct order state transition validation
docs(architecture): add ADR for event versioning strategy
refactor(shared): extract common Kafka producer config
\`\`\`

### Creating a new microservice

1. Create module under \`services/your-service/\`
2. Add to \`settings.gradle.kts\`
3. Follow hexagonal architecture layout:
   \`\`\`
   services/your-service/
   ├── src/main/java/com/yourorg/yourservice/
   │   ├── adapter/
   │   │   ├── in/web/          # REST controllers
   │   │   ├── in/kafka/        # Kafka consumers
   │   │   ├── out/persistence/ # JPA repositories
   │   │   └── out/kafka/       # Kafka producers
   │   ├── application/
   │   │   ├── port/in/         # Use case interfaces
   │   │   └── port/out/        # Repository interfaces
   │   └── domain/              # Domain models, events
   ├── src/main/resources/
   │   ├── application.yml
   │   ├── application-local.yml
   │   └── db/migration/        # Flyway migrations
   ├── src/test/
   ├── Dockerfile
   └── build.gradle.kts
   \`\`\`
4. Add Helm chart under \`charts/your-service/\`
5. Add event schemas to \`schema-registry/\`
6. Add CODEOWNERS entry in \`.github/CODEOWNERS\`

### Claude Code usage

All developers use Claude Code for development. See [CLAUDE.md](CLAUDE.md) for project-level instructions and \`.claude/rules/\` for domain-specific rules. AI-generated code is flagged in PRs via the \`ai-generated\` label.

---

## Testing

### Run all tests

\`\`\`bash
./gradlew test                    # Unit tests
./gradlew integrationTest         # Integration tests (Testcontainers)
./gradlew contractTest            # Pact contract tests
./gradlew jacocoTestReport        # Coverage report
\`\`\`

### Run tests for a specific service

\`\`\`bash
./gradlew :services:payment-service:test
./gradlew :services:payment-service:integrationTest
\`\`\`

### Test strategy

| Layer | Tool | Scope |
|-------|------|-------|
| **Unit** | JUnit 5 + Mockito | Domain logic, use cases, adapters in isolation |
| **Integration** | Testcontainers | Database, Kafka, Redis with real containers |
| **Contract** | Pact | Producer/consumer event schema compatibility |
| **E2E** | \`tests/\` module | Full service interaction through gateway |

**Coverage threshold**: 80% line coverage enforced by JaCoCo. See [.claude/rules/common/testing.md](.claude/rules/common/testing.md).

---

## Deployment

### Staging (auto-deploy on merge to \`main\`)

Merges to \`main\` trigger the [staging deployment workflow](.github/workflows/deploy-staging.yml):

1. Build and push Docker images to ECR
2. Deploy via Helm to EKS staging cluster
3. Run E2E tests against staging
4. Notify Slack on success/failure

### Production (manual approval)

Production deploys require manual approval via the [production workflow](.github/workflows/deploy-production.yml):

1. Promote staging-verified images
2. Rolling update via Helm
3. Canary validation with automated rollback
4. Post-deploy smoke tests

### Infrastructure changes

\`\`\`bash
cd infrastructure/staging
terraform plan
terraform apply

cd infrastructure/production
terraform plan    # Requires approval
terraform apply   # Requires approval
\`\`\`

---

## Observability

| Tool | URL (Local) | Purpose |
|------|-------------|---------|
| **Prometheus** | http://localhost:9090 | Metrics collection |
| **Grafana** | http://localhost:3000 | Dashboards and alerting |
| **Jaeger** | http://localhost:16686 | Distributed tracing |
| **Kibana** | http://localhost:5601 | Log aggregation and search |
| **Kafka UI** | http://localhost:8090 | Topic inspection, consumer lag |

All services expose Spring Actuator endpoints:

\`\`\`bash
# Health, readiness, liveness
curl http://localhost:808x/actuator/health
curl http://localhost:808x/actuator/health/readiness
curl http://localhost:808x/actuator/health/liveness

# Prometheus metrics
curl http://localhost:808x/actuator/prometheus

# Info
curl http://localhost:808x/actuator/info
\`\`\`

---

## Compliance

This platform operates under **SOC 2** and **PCI DSS** compliance requirements.

- **Audit Service** captures an immutable log of all domain events
- **Signed commits** are required on all branches
- **Security scans** (Trivy, OWASP Dependency-Check, SpotBugs) run on every PR
- **Sensitive paths** (\`**/security/**\`, \`**/auth/**\`, \`infrastructure/production/**\`, \`*.properties\`) require lead engineer review
- **No secrets in code** — all credentials via AWS Secrets Manager / environment variables
- **Encryption at rest and in transit** for all data stores

See [.claude/rules/common/security.md](.claude/rules/common/security.md) for security coding guidelines.

---

## Documentation

| Document | Location |
|----------|----------|
| Architecture Overview | [docs/ARCHITECTURE.md](docs/ARCHITECTURE.md) |
| Onboarding Guide | [docs/ONBOARDING.md](docs/ONBOARDING.md`,

  'docs/AI-USAGE-POLICY.md': `# AI Usage Policy — Spring Boot Microservices Platform

> **Effective Date**: 2024-01-01
> **Last Reviewed**: 2024-01-01
> **Applies To**: All backend developers using Claude Code on this project
> **Compliance Context**: SOC 2 Type II, PCI DSS v4.0

## Purpose

This policy defines when and how developers may use Claude Code (and other AI coding assistants) when working on the spring-boot-microservices platform. Given our financial services context and compliance obligations, AI usage must be deliberate, auditable, and reviewed.

---

## 1. General Principles

1. **AI is an accelerator, not a replacement for engineering judgment.** Every AI-generated change must be understood, verified, and owned by the developer who commits it.
2. **All AI-generated code must be flagged.** Our CI pipeline (\`ai-code-audit.yml\`) detects AI-authored commits. Use the \`ai-assisted\` label on PRs and include \`AI-Generated: true\` in commit trailers when applicable.
3. **Compliance-sensitive code requires human-first authorship.** Security, authentication, payment processing, and PII-handling code must be written by humans with AI used only for review assistance.
4. **No proprietary data in prompts.** Never paste production credentials, customer PII, real transaction data, or internal API keys into Claude prompts.

---

## 2. Permitted Uses (Green Zone)

These tasks are **encouraged** for AI assistance:

### 2.1 Service Scaffolding
- Generating new microservice module structure under \`services/\`
- Creating boilerplate: \`Application.java\`, \`build.gradle.kts\`, \`Dockerfile\`, Helm chart templates
- Generating hexagonal architecture skeleton (ports, adapters, domain packages)

### 2.2 Domain Logic Implementation
- Writing domain entities, value objects, and aggregates
- Implementing application services and use cases
- Generating mapper classes between domain and persistence models

### 2.3 Spring Configuration
- Writing \`@Configuration\` classes for Kafka consumers/producers, Redis, DataSource
- Generating Spring Profile-specific \`application-{profile}.yml\` files
- Creating Actuator custom health indicators and metrics

### 2.4 Test Generation
- JUnit 5 unit tests with Mockito
- Testcontainers-based integration tests for PostgreSQL, Kafka, Redis
- Test fixtures and builders (e.g., \`OrderTestBuilder.java\`)
- Pact contract test stubs for consumer/provider verification

### 2.5 Documentation
- JavaDoc for public APIs
- OpenAPI spec generation and refinement under each service's \`src/main/resources/openapi/\`
- ADR (Architecture Decision Record) drafts in \`docs/adr/\`
- Runbook templates in \`docs/runbooks/\`

### 2.6 Build & Infrastructure
- Gradle build script modifications (\`build.gradle.kts\`)
- GitHub Actions workflow steps
- Terraform resource definitions for non-production environments
- Helm chart value files for dev/staging

### 2.7 Code Refactoring
- Extracting methods, classes, or modules
- Migrating deprecated Spring APIs
- Applying consistent patterns across services (e.g., standardizing error handling)

---

## 3. Restricted Uses (Yellow Zone)

These tasks **require additional review** when AI-assisted:

### 3.1 Kafka Event Schemas

| Requirement | Detail |
|---|---|
| **Review** | Minimum 2 approvals, at least 1 from a lead engineer |
| **Schema Location** | \`schema-registry/\` |
| **Compatibility** | All schema changes must pass backward-compatibility checks |
| **AI Role** | AI may draft schemas but must not be the sole author |

Kafka event schemas define inter-service contracts. An incorrect schema can cause cascading failures across the platform. When using Claude for schema work:

1. **Draft only.** Use AI to generate initial Avro/JSON Schema definitions, then manually verify field types, nullability, defaults, and evolution rules.
2. **Run compatibility checks.** Execute \`./gradlew :schema-registry:testCompatibility\` before committing.
3. **Document the rationale.** Every schema change PR must include a description of why fields were added/modified and the impact on consuming services.
4. **Tag the PR.** Add labels: \`schema-change\`, \`ai-assisted\`, and the affected service labels (e.g., \`order-service\`, \`payment-service\`).

\`\`\`
# Example: AI-assisted schema workflow
1. Developer asks Claude to draft OrderCreatedEvent.avsc
2. Developer reviews field types, nullability, default values
3. Developer runs: ./gradlew :schema-registry:testCompatibility
4. Developer verifies consuming services can deserialize
5. PR opened with \`schema-change\` + \`ai-assisted\` labels
6. 2 approvals required (1 must be lead engineer)
7. Schema review checklist completed in PR template
\`\`\`

### 3.2 Database Migrations
- AI may generate Flyway migration SQL (\`V*.sql\` files) but a senior developer must verify:
  - Index impact on query performance
  - Data migration correctness
  - Rollback strategy
  - No accidental data loss
- Migrations touching PCI-scoped tables (\`payment_instruments\`, \`card_tokens\`, \`transactions\`) require lead engineer approval.

### 3.3 API Gateway Configuration
- Route definitions in \`gateway/\` affect all external traffic
- AI-generated rate limiting, CORS, and routing rules must be manually tested
- Changes require approval from a lead engineer

### 3.4 Kafka Consumer/Producer Configuration
- Consumer group IDs, partition assignments, retry policies, and DLQ routing
- AI may suggest configurations but a senior developer must verify:
  - Idempotency settings
  - Exactly-once semantics where required
  - Error handling and dead-letter topic routing
  - Consumer lag implications

### 3.5 Spring Security Configuration
- AI may assist with \`SecurityFilterChain\` configuration but must not be the sole author
- JWT validation, OAuth2 resource server config, and CORS policies require manual review
- All changes in \`**/security/**\` and \`**/auth/**\` trigger CODEOWNERS review

---

## 4. Prohibited Uses (Red Zone)

AI must **NOT** be used as the primary author for:

### 4.1 Cryptographic Implementations
- Custom encryption/decryption logic
- Key derivation functions
- Token generation algorithms
- Use established libraries (Spring Security, Bouncy Castle) instead

### 4.2 PCI DSS Scoped Code
- Card number handling, tokenization logic
- Payment instrument storage or retrieval
- PAN masking and truncation logic
- These must be written by developers with PCI DSS training

### 4.3 Production Infrastructure
- \`infrastructure/production/**\` Terraform configurations
- Production Helm value overrides (\`charts/*/values-production.yaml\`)
- IAM policies, security groups, and network ACLs for production
- These require manual authorship and change management approval

### 4.4 Secrets and Credentials
- Never use AI to generate, rotate, or manage secrets
- Never include real credentials in AI prompts
- Use AWS Secrets Manager / Spring Cloud Config Server

### 4.5 Compliance-Critical Audit Logic
- Transaction audit trail generation
- Regulatory reporting logic
- SOC 2 control implementations
- These require human authorship with compliance team review

---

## 5. Review Requirements by Change Type

| Change Type | Min Approvals | Lead Required | Security Review | AI Allowed |
|---|---|---|---|---|
| New microservice scaffold | 1 | No | No | ✅ Full |
| Domain logic | 1 | No | No | ✅ Full |
| Unit/integration tests | 1 | No | No | ✅ Full |
| Kafka event schema | 2 | Yes | No | ⚠️ Draft only |
| Database migration | 2 | Yes (PCI tables) | PCI tables only | ⚠️ Draft only |
| Spring Security config | 2 | Yes | Yes | ⚠️ Assist only |
| API Gateway routes | 2 | Yes | Yes | ⚠️ Assist only |
| Kafka consumer/producer config | 2 | No | No | ⚠️ Assist only |
| Production Terraform | 2 | Yes | Yes | ❌ Prohibited |
| PCI-scoped payment logic | 2 | Yes | Yes | ❌ Prohibited |
| Cryptographic code | 2 | Yes | Yes | ❌ Prohibited |

---

## 6. AI Commit and PR Labeling

### 6.1 Commit Trailers

When a commit contains AI-generated or AI-assisted code, include a trailer:

\`\`\`
feat(order-service): add order aggregate root

Implement Order aggregate with domain events for order lifecycle.

AI-Generated: partial
AI-Tool: claude-code
AI-Scope: domain entity scaffolding, test generation
Signed-off-by: Developer Name <dev@company.com>
\`\`\`

Valid \`AI-Generated\` values:
- \`true\` — Entire change was AI-generated (developer reviewed and approved)
- \`partial\` — Some portions AI-generated, some human-written
- \`false\` or omitted — Fully human-written

### 6.2 PR Labels

| Label | When to Apply |
|---|---|
| \`ai-assisted\` | Any PR containing AI-generated code |
| \`ai-full\` | PR where >50% of code was AI-generated |
| \`ai-reviewed\` | AI-generated code has been manually reviewed and verified |
| \`schema-change\` | PR modifies files in \`schema-registry/\` |
| \`security-review\` | PR touches security-sensitive paths |

### 6.3 AI Audit Trail

The \`ai-code-audit.yml\` workflow automatically:
- Detects AI-generated commit trailers
- Verifies \`ai-assisted\` label is present on the PR
- Checks that AI-generated code in restricted zones has required approvals
- Generates a weekly report of AI usage across the repository

---

## 7. Prompt Hygiene

### 7.1 What You CAN Include in Prompts
- Public API interfaces and method signatures
- Open-source library documentation references
- Generic architecture patterns and design questions
- Sanitized code snippets with placeholder values
- Error messages and stack traces (with PII redacted)

### 7.2 What You MUST NOT Include in Prompts
- Production database connection strings or credentials
- AWS access keys, secret keys, or session tokens
- Customer PII (names, emails, addresses, SSNs)
- Real payment card numbers or financial data
- Internal security configurations or vulnerability details
- Production Kafka broker addresses or credentials
- Contents of \`*.properties\` files from production environments

### 7.3 Sanitization Examples

\`\`\`java
// ❌ BAD — real connection string
spring.datasource.url=jdbc:postgresql://prod-db.internal.company.com:5432/payments

// ✅ GOOD — sanitized
spring.datasource.url=jdbc:postgresql://localhost:5432/payments
\`\`\`

\`\`\`java
// ❌ BAD — real customer data in test
User user = new User("John Smith", "john.smith@realcustomer.com", "4111111111111111");

// ✅ GOOD — synthetic test data
User user = new User("Test User", "test@example.com", "4111111111111111"); // Stripe test card
\`\`\`

---

## 8. Quality Assurance for AI-Generated Code

Before committing any AI-generated code, developers must verify:

### 8.1 Correctness Checklist
- [ ] Code compiles: \`./gradlew :service-name:compileJava\`
- [ ] Unit tests pass: \`./gradlew :service-name:test\`
- [ ] Integration tests pass: \`./gradlew :service-name:integrationTest\`
- [ ] No new Checkstyle violations: \`./gradlew :service-name:checkstyleMain\`
- [ ] No new SpotBugs findings: \`./gradlew :service-name:spotbugsMain\`
- [ ] Code coverage maintained ≥80%: \`./gradlew :service-name:jacocoTestCoverageVerification\`

### 8.2 Architecture Checklist
- [ ] Follows hexagonal architecture (no domain → infrastructure dependencies)
- [ ] No direct REST calls between services (use Kafka events)
- [ ] New domain events registered in schema registry
- [ ] Spring Profiles used for environment-specific config
- [ ] File length ≤300 lines

### 8.3 Security Checklist (for Yellow/Red Zone code)
- [ ] No hardcoded secrets or credentials
- [ ] Input validation on all external inputs
- [ ] SQL injection prevention (parameterized queries via JPA)
- [ ] OWASP dependency check passes: \`./gradlew dependencyCheckAnalyze\`
- [ ] Sensitive data not logged (PAN, tokens, passwords)

---

## 9. Training and Onboarding

### 9.1 Required Reading
All developers using Claude Code must read:
- This policy (\`docs/AI-USAGE-POLICY.md\`)
- Project coding standards (\`.claude/rules/\`)
- Architecture overview (\`docs/ARCHITECTURE.md\`)
- Onboarding guide (\`docs/ONBOARDING.md\`)

### 9.2 AI Usage Training
- **Junior developers**: Must pair with a senior developer for the first 2 weeks of AI usage. AI-generated code requires senior review.
- **Mid-level developers**: May use AI independently for Green Zone tasks. Yellow Zone requires lead review.
- **Senior developers**: Full Green/Yellow Zone autonomy. Responsible for reviewing AI-generated code from others.
- **Lead engineers**: Approve Yellow Zone AI usage. Define and update this policy.

### 9.3 Quarterly Review
This policy is reviewed quarterly by the engineering leads. Updates are tracked as PRs against this file with the \`policy-update\` label.

---

## 10. Incident Response

If AI-generated code causes a production incident:

1. **Immediate**: Follow standard incident response runbook (\`docs/runbooks/incident-response.md\`)
2. **Root Cause**: Include AI involvement in the post-mortem analysis
3. **Classification**: Tag the incident with \`ai-related\` in the incident tracker
4. **Review**: Assess whether the AI usage was within policy guidelines
5. **Update**: Propose policy amendments if a gap is identified

---

## 11. Compliance Mapping

| Compliance Requirement | How This Policy Addresses It |
|---|---|
| SOC 2 CC6.1 — Logical Access | AI tools access only non-production data; no credential exposure |
| SOC 2 CC8.1 — Change Management | AI-generated code flagged, reviewed, and audited via CI |
| PCI DSS 6.2 — Secure Development | Red Zone prohibits AI for PCI-scoped code |
| PCI DSS 6.3 — Code Review | Minimum 2 approvals for sensitive changes |
| PCI DSS 6.5 — Common Vulnerabilities | OWASP checks required; AI code scanned identically to human code |
| PCI DSS 8.6 — System Account Management | No AI access to production credentials or secrets |

---

## 12. Summary Decision Tree

\`\`\`
Is the code in a Red Zone area?
├── Yes → Write manually. AI prohibited.
└── No
    ├── Is it in a Yellow Zone area?
    │   ├── Yes → AI may draft/assist. Enhanced review required.
    │   │         Add ai-assisted label. Follow zone-specific rules.
    │   └── No
    │       └── Green Zone. AI fully permitted.
    │           Add ai-assisted label if applicable.
    │           Standard review process.
    └── Always:
        ├── Run full test suite
        ├── Add AI commit trailers
        ├── Never include secrets/PII in prompts
        └── Own the code you commit
\`\`\`

---

## Questions?

Reach out in \`#eng-ai-practices\` on Slack or raise a discussion in the \`docs/\` section of the repository.`,

  'docs/ARCHITECTURE.md': `# Architecture Overview

## Spring Boot Microservices Platform

**Version**: 1.0.0
**Last Updated**: 2024-01
**Status**: Living Document
**Compliance**: SOC 2 Type II, PCI DSS v4.0

---

## Table of Contents

1. [System Overview](#system-overview)
2. [Microservice Topology](#microservice-topology)
3. [Hexagonal Architecture](#hexagonal-architecture)
4. [Kafka Event Flows](#kafka-event-flows)
5. [Data Architecture](#data-architecture)
6. [API Gateway](#api-gateway)
7. [Security Architecture](#security-architecture)
8. [Infrastructure](#infrastructure)
9. [Observability](#observability)
10. [Architecture Decision Records](#architecture-decision-records)

---

## System Overview

\`\`\`
                                    ┌─────────────────────────────────────────────────────────┐
                                    │                      AWS Cloud (EKS)                     │
                                    │                                                         │
    Clients                         │   ┌─────────────┐                                      │
   ┌───────┐    ┌──────────┐       │   │   API       │    ┌──────────────────────────────┐   │
   │Mobile │───▶│  AWS ALB  │──────│──▶│  Gateway    │───▶│       Kubernetes Cluster      │   │
   │Web    │    │  Route53  │       │   │  (Spring    │    │                              │   │
   │API    │    └──────────┘       │   │   Cloud)    │    │  ┌────────┐  ┌────────────┐  │   │
   └───────┘                        │   └──────┬──────┘    │  │ User   │  │  Payment   │  │   │
                                    │          │           │  │Service │  │  Service   │  │   │
                                    │          │           │  └───┬────┘  └─────┬──────┘  │   │
                                    │          │           │      │             │         │   │
                                    │          │           │  ┌───┴────┐  ┌─────┴──────┐  │   │
                                    │          │           │  │ Order  │  │Notification│  │   │
                                    │          │           │  │Service │  │  Service   │  │   │
                                    │          │           │  └────────┘  └────────────┘  │   │
                                    │          │           └──────────────────────────────┘   │
                                    │          │                                              │
                                    │   ┌──────▼──────────────────────────────────────────┐   │
                                    │   │              Apache Kafka (MSK)                  │   │
                                    │   │  Topics: user.*, order.*, payment.*, notify.*   │   │
                                    │   └─────────────────────────────────────────────────┘   │
                                    │                                                         │
                                    │   ┌──────────────┐  ┌──────────────┐  ┌─────────────┐  │
                                    │   │ PostgreSQL   │  │    Redis     │  │   Schema    │  │
                                    │   │ (RDS per svc)│  │(ElastiCache) │  │  Registry   │  │
                                    │   └──────────────┘  └──────────────┘  └─────────────┘  │
                                    └─────────────────────────────────────────────────────────┘
\`\`\`

### Design Principles

1. **Domain-Driven Design** — Each service owns a bounded context with clear domain boundaries
2. **Event-Driven Communication** — All inter-service communication flows through Kafka; no direct REST calls between services
3. **Database per Service** — Each microservice has its own PostgreSQL database; no shared databases
4. **Hexagonal Architecture** — Every service follows Ports & Adapters internally
5. **Infrastructure as Code** — All infrastructure defined in Terraform; all deployments via Helm charts
6. **Zero Trust Security** — mTLS between services, JWT validation at gateway, encrypted data at rest and in transit
7. **Observability First** — Distributed tracing, structured logging, and metrics from day one

---

## Microservice Topology

### Services

| Service | Module | Port | Database | Description |
|---------|--------|------|----------|-------------|
| API Gateway | \`gateway/\` | 8080 | — | Request routing, rate limiting, JWT validation |
| User Service | \`services/user-service/\` | 8081 | \`user_db\` | User registration, authentication, profile management |
| Order Service | \`services/order-service/\` | 8082 | \`order_db\` | Order lifecycle, cart management, order fulfillment |
| Payment Service | \`services/payment-service/\` | 8083 | \`payment_db\` | Payment processing, refunds, transaction ledger |
| Notification Service | \`services/notification-service/\` | 8084 | \`notification_db\` | Email, SMS, push notifications, notification preferences |

### Shared Libraries

| Library | Module | Description |
|---------|--------|-------------|
| Domain Events | \`shared/domain-events/\` | Kafka event DTOs, serializers, base event classes |
| Common Utils | \`shared/common-utils/\` | Shared utilities, error handling, pagination |
| Security Common | \`shared/security-common/\` | JWT utilities, security filters, audit logging |
| Test Support | \`shared/test-support/\` | Testcontainers configs, test fixtures, Kafka test utilities |

### Service Dependencies

\`\`\`
                    ┌──────────────┐
                    │  API Gateway │
                    └──────┬───────┘
                           │ HTTP (external only)
              ┌────────────┼────────────┐
              ▼            ▼            ▼
        ┌──────────┐ ┌──────────┐ ┌──────────┐
        │  User    │ │  Order   │ │ Payment  │
        │ Service  │ │ Service  │ │ Service  │
        └────┬─────┘ └────┬─────┘ └────┬─────┘
             │             │             │
             └──────┬──────┴──────┬──────┘
                    ▼             ▼
              ┌──────────┐  ┌──────────┐
              │  Kafka   │  │Notif.    │
              │  (MSK)   │──│Service   │
              └──────────┘  └──────────┘
\`\`\`

**Rule**: Services communicate exclusively through Kafka events. The API Gateway is the only component that makes synchronous HTTP calls to services, and only from external client requests.

---

## Hexagonal Architecture

Every microservice follows the Hexagonal Architecture (Ports & Adapters) pattern. This isolates domain logic from infrastructure concerns and makes services testable and adaptable.

### Internal Service Structure

\`\`\`
services/{service-name}/
├── src/main/java/com/fintech/{service}/
│   ├── domain/                          # Core domain (no framework dependencies)
│   │   ├── model/                       # Domain entities, value objects, aggregates
│   │   ├── event/                       # Domain events (internal)
│   │   ├── exception/                   # Domain-specific exceptions
│   │   ├── port/
│   │   │   ├── inbound/                 # Driving ports (use cases / service interfaces)
│   │   │   └── outbound/               # Driven ports (repository interfaces, event publisher)
│   │   └── service/                     # Domain service implementations
│   │
│   ├── adapter/                         # Infrastructure adapters
│   │   ├── inbound/
│   │   │   ├── rest/                    # REST controllers (driving adapter)
│   │   │   │   ├── dto/                 # Request/Response DTOs
│   │   │   │   ├── mapper/             # DTO ↔ Domain mappers
│   │   │   │   └── controller/         # @RestController classes
│   │   │   └── kafka/                   # Kafka consumers (driving adapter)
│   │   │       ├── listener/           # @KafkaListener classes
│   │   │       └── mapper/             # Event ↔ Domain mappers
│   │   └── outbound/
│   │       ├── persistence/             # JPA repositories (driven adapter)
│   │       │   ├── entity/             # JPA entities
│   │       │   ├── mapper/             # Entity ↔ Domain mappers
│   │       │   └── repository/         # Spring Data JPA repos
│   │       ├── kafka/                   # Kafka producers (driven adapter)
│   │       │   └── publisher/          # Event publishing implementations
│   │       └── redis/                   # Redis cache adapter
│   │
│   └── config/                          # Spring configuration
│       ├── KafkaConfig.java
│       ├── SecurityConfig.java
│       ├── PersistenceConfig.java
│       └── RedisConfig.java
│
├── src/main/resources/
│   ├── application.yml                  # Default config
│   ├── application-local.yml            # Local development
│   ├── application-staging.yml          # Staging overrides
│   ├── application-production.yml       # Production overrides
│   ├── db/migration/                    # Flyway migrations
│   └── openapi/                         # OpenAPI spec
│       └── {service}-api.yaml
│
├── src/test/java/com/fintech/{service}/
│   ├── domain/                          # Pure unit tests (no Spring context)
│   ├── adapter/
│   │   ├── inbound/                     # Controller + Kafka listener tests
│   │   └── outbound/                    # Repository + publisher integration tests
│   ├── integration/                     # Full integration tests (Testcontainers)
│   └── contract/                        # Pact contract tests
│
├── Dockerfile
├── build.gradle.kts
└── README.md
\`\`\`

### Hexagonal Architecture Diagram

\`\`\`
                         ┌─────────────────────────────────────────────┐
                         │              Microservice                    │
                         │                                             │
    ┌──────────────┐     │   ┌──────────────────────────────────┐     │
    │  REST Client │─────│──▶│  Inbound Port                    │     │
    │  (Gateway)   │     │   │  (UseCase Interface)             │     │
    └──────────────┘     │   └──────────┬───────────────────────┘     │
                         │              │                              │
    ┌──────────────┐     │   ┌──────────▼───────────────────────┐     │
    │  Kafka       │─────│──▶│         DOMAIN CORE              │     │
    │  Consumer    │     │   │                                  │     │
    └──────────────┘     │   │  ┌────────────┐ ┌────────────┐  │     │
                         │   │  │  Entities  │ │   Value    │  │     │
                         │   │  │ Aggregates │ │  Objects   │  │     │
                         │   │  └────────────┘ └────────────┘  │     │
                         │   │                                  │     │
                         │   │  ┌────────────┐ ┌────────────┐  │     │
                         │   │  │  Domain    │ │  Domain    │  │     │
                         │   │  │  Services  │ │  Events    │  │     │
                         │   │  └────────────┘ └────────────┘  │     │
                         │   │                                  │     │
                         │   └──────────┬───────────────────────┘     │
                         │              │                              │
                         │   ┌──────────▼───────────────────────┐     │     ┌──────────────┐
                         │   │  Outbound Port                   │─────│────▶│  PostgreSQL   │
                         │   │  (Repository / Publisher Iface)  │     │     └──────────────┘
                         │   └──────────────────────────────────┘     │
                         │              │                              │     ┌──────────────┐
                         │              └─────────────────────────────│────▶│  Kafka        │
                         │                                             │     └──────────────┘
                         │                                             │     ┌──────────────┐
                         │                                             │────▶│  Redis        │
                         └─────────────────────────────────────────────┘     └──────────────┘
\`\`\`

### Key Rules

- **Domain Core** has zero dependencies on Spring, JPA, Kafka, or any framework
- **Inbound Ports** are Java interfaces defining use cases (e.g., \`CreateOrderUseCase\`)
- **Outbound Ports** are Java interfaces for persistence and messaging (e.g., \`OrderRepository\`, \`OrderEventPublisher\`)
- **Adapters** implement ports and depend on frameworks
- **Dependency direction** always points inward — adapters depend on domain, never the reverse
- Domain entities are distinct from JPA entities; mappers translate between them

---

## Kafka Event Flows

### Topic Naming Convention

\`\`\`
{domain}.{entity}.{event-type}
\`\`\`

### Topics

| Topic | Partitions | Retention | Producer | Consumers |
|-------|-----------|-----------|----------|-----------|
| \`user.account.created\` | 6 | 30d | User Service | Order Service, Notification Service |
| \`user.account.updated\` | 6 | 30d | User Service | Order Service, Notification Service |
| \`user.account.suspended\` | 3 | 90d | User Service | Order Service, Payment Service, Notification Service |
| \`order.order.created\` | 12 | 30d | Order Service | Payment Service, Notification Service |
| \`order.order.confirmed\` | 12 | 30d | Order Service | Payment Service, Notification Service |
| \`order.order.cancelled\` | 6 | 30d | Order Service | Payment Service, Notification Service |
| \`order.order.fulfilled\` | 12 | 30d | Order Service | Notification Service |
| \`payment.transaction.initiated\` | 12 | 90d | Payment Service | Order Service, Notification Service |
| \`payment.transaction.completed\` | 12 | 90d | Payment Service | Order Service, Notification Service |
| \`payment.transaction.failed\` | 6 | 90d | Payment Service | Order Service, Notification Service |
| \`payment.refund.processed\` | 6 | 90d | Payment Service | Order Service, Notification Service |
| \`notify.notification.sent\` | 6 | 7d | Notification Service | — (audit) |
| \`platform.dlq\` | 3 | 90d | All Services | — (manual review) |

### Consumer Groups

| Consumer Group | Service | Topics |
|---------------|---------|--------|
| \`user-service-cg\` | User Service | — (produces only) |
| \`order-service-cg\` | Order Service | \`user.account.*\`, \`payment.transaction.*\`, \`payment.refund.*\` |
| \`payment-service-cg\` | Payment Service | \`order.order.*\`, \`user.account.suspended\` |
| \`notification-service-cg\` | Notification Service | \`user.account.*\`, \`order.order.*\`, \`payment.transaction.*\`, \`payment.refund.*\` |

### Event Flow: Order Placement (Happy Path)

\`\`\`
Client          Gateway       Order Svc       Kafka           Payment Svc     Notification Svc
  │                │              │              │                │                │
  │  POST /orders  │              │              │                │                │
  │───────────────▶│              │              │                │                │
  │`,

  'docs/CONTRIBUTING.md': `# Contributing Guide

Welcome to the Spring Boot Microservices platform. This guide covers everything you need to contribute effectively — from creating a new service to publishing Kafka events and getting your code merged.

## Table of Contents

- [Getting Started](#getting-started)
- [Development Environment](#development-environment)
- [Service Development Workflow](#service-development-workflow)
- [Creating a New Microservice](#creating-a-new-microservice)
- [Hexagonal Architecture](#hexagonal-architecture)
- [Kafka Event Conventions](#kafka-event-conventions)
- [Database Conventions](#database-conventions)
- [API Conventions](#api-conventions)
- [Testing Requirements](#testing-requirements)
- [Pull Request Process](#pull-request-process)
- [Code Review Guidelines](#code-review-guidelines)
- [CI/CD Pipeline](#cicd-pipeline)
- [Security & Compliance](#security--compliance)
- [Using Claude Code](#using-claude-code)

---

## Getting Started

1. Read [ONBOARDING.md](./ONBOARDING.md) for environment setup
2. Read [ARCHITECTURE.md](./ARCHITECTURE.md) for system design context
3. Review the [CLAUDE.md](../CLAUDE.md) root rules file
4. Ensure you have signed commit configuration (\`git config commit.gpgsign true\`)

### Prerequisites

- Java 21 (Temurin recommended)
- Docker & Docker Compose
- Gradle 8.5+ (wrapper included)
- kubectl + Helm 3
- AWS CLI v2 (configured)

---

## Development Environment

### Build the entire project

\`\`\`bash
./gradlew build
\`\`\`

### Run a specific service locally

\`\`\`bash
./gradlew :services:order-service:bootRun --args='--spring.profiles.active=local'
\`\`\`

### Start infrastructure dependencies

\`\`\`bash
docker compose -f infrastructure/docker-compose.local.yml up -d
\`\`\`

This starts PostgreSQL, Redis, Kafka (with Zookeeper), and the schema registry locally.

### Run all tests

\`\`\`bash
./gradlew test                    # Unit tests
./gradlew integrationTest         # Integration tests (Testcontainers)
./gradlew contractTest            # Pact contract tests
\`\`\`

---

## Service Development Workflow

### 1. Pick up a Jira ticket

- Assign the ticket to yourself and move it to **In Progress**
- Tickets follow the format: \`PAY-123\`, \`ORD-456\`, \`USR-789\`

### 2. Create a branch

\`\`\`bash
git checkout main
git pull origin main
git checkout -b feat/PAY-123-add-refund-endpoint
\`\`\`

Branch naming: \`type/TICKET-short-desc\`

| Type       | Use Case                          |
|------------|-----------------------------------|
| \`feat\`     | New feature or capability         |
| \`fix\`      | Bug fix                           |
| \`refactor\` | Code restructuring, no behavior change |
| \`chore\`    | Build, CI, dependency updates     |
| \`docs\`     | Documentation only                |
| \`test\`     | Adding or fixing tests            |

### 3. Develop with conventional commits

\`\`\`bash
git commit -m "feat(payment-service): add refund endpoint for partial amounts"
git commit -m "test(payment-service): add integration tests for refund flow"
git commit -m "docs(payment-service): update OpenAPI spec with refund operations"
\`\`\`

Format: \`type(scope): description\`

- Scope is the service or module name: \`payment-service\`, \`shared-events\`, \`gateway\`
- Description is lowercase, imperative mood, no period at end
- All commits must be signed (GPG or SSH)

### 4. Push and open a PR

\`\`\`bash
git push origin feat/PAY-123-add-refund-endpoint
\`\`\`

Then open a PR against \`main\` using the [PR template](../.github/PULL_REQUEST_TEMPLATE.md).

---

## Creating a New Microservice

### Module structure

Create a new Gradle module under \`services/\`:

\`\`\`
services/
└── payment-service/
    ├── build.gradle.kts
    ├── Dockerfile
    ├── src/
    │   ├── main/
    │   │   ├── java/com/platform/payment/
    │   │   │   ├── PaymentServiceApplication.java
    │   │   │   ├── adapter/
    │   │   │   │   ├── in/
    │   │   │   │   │   ├── web/          # REST controllers
    │   │   │   │   │   └── kafka/        # Kafka consumers
    │   │   │   │   └── out/
    │   │   │   │       ├── persistence/  # JPA repositories, entities
    │   │   │   │       ├── kafka/        # Kafka producers
    │   │   │   │       └── cache/        # Redis adapters
    │   │   │   ├── domain/
    │   │   │   │   ├── model/            # Domain entities, value objects
    │   │   │   │   ├── port/
    │   │   │   │   │   ├── in/           # Use case interfaces
    │   │   │   │   │   └── out/          # Repository/gateway interfaces
    │   │   │   │   └── service/          # Domain service implementations
    │   │   │   └── config/               # Spring configuration classes
    │   │   └── resources/
    │   │       ├── application.yml
    │   │       ├── application-local.yml
    │   │       ├── application-staging.yml
    │   │       ├── application-production.yml
    │   │       └── db/migration/         # Flyway migrations
    │   └── test/
    │       ├── java/com/platform/payment/
    │       │   ├── unit/                 # Unit tests
    │       │   ├── integration/          # Testcontainers integration tests
    │       │   └── architecture/         # ArchUnit tests
    │       └── resources/
    │           └── application-test.yml
    └── README.md
\`\`\`

### Checklist for a new service

- [ ] Gradle module registered in \`settings.gradle.kts\`
- [ ] \`build.gradle.kts\` with standard dependencies (see existing services)
- [ ] \`Dockerfile\` following the multi-stage build template
- [ ] Helm chart in \`charts/<service-name>/\`
- [ ] OpenAPI spec in \`docs/api/<service-name>.openapi.yml\`
- [ ] Flyway migrations for database schema
- [ ] Spring profiles for \`local\`, \`staging\`, \`production\`
- [ ] Actuator health endpoint exposed at \`/actuator/health\`
- [ ] Service registered in \`infrastructure/docker-compose.local.yml\`
- [ ] CODEOWNERS entry in \`.github/CODEOWNERS\`
- [ ] ArchUnit test enforcing hexagonal architecture boundaries
- [ ] README.md documenting the service's domain and responsibilities

### build.gradle.kts template

\`\`\`kotlin
plugins {
    id("org.springframework.boot")
    id("io.spring.dependency-management")
    java
}

dependencies {
    implementation(project(":shared:domain-events"))
    implementation(project(":shared:common-utils"))

    implementation("org.springframework.boot:spring-boot-starter-web")
    implementation("org.springframework.boot:spring-boot-starter-data-jpa")
    implementation("org.springframework.boot:spring-boot-starter-actuator")
    implementation("org.springframework.boot:spring-boot-starter-validation")
    implementation("org.springframework.kafka:spring-kafka")
    implementation("org.springframework.boot:spring-boot-starter-data-redis")
    implementation("org.flywaydb:flyway-core")
    implementation("org.flywaydb:flyway-database-postgresql")

    runtimeOnly("org.postgresql:postgresql")

    testImplementation("org.springframework.boot:spring-boot-starter-test")
    testImplementation("org.springframework.kafka:spring-kafka-test")
    testImplementation("org.testcontainers:postgresql")
    testImplementation("org.testcontainers:kafka")
    testImplementation("com.tngtech.archunit:archunit-junit5")
}
\`\`\`

---

## Hexagonal Architecture

All services follow Hexagonal Architecture (Ports & Adapters). This is enforced by ArchUnit tests.

### Rules

1. **Domain layer has zero framework dependencies** — no Spring annotations in \`domain/model/\` or \`domain/port/\`
2. **Ports are interfaces** — defined in \`domain/port/in/\` (use cases) and \`domain/port/out/\` (repositories, gateways)
3. **Adapters implement ports** — \`adapter/in/web/\` implements inbound ports, \`adapter/out/persistence/\` implements outbound ports
4. **Dependencies point inward** — adapters depend on domain, never the reverse
5. **Domain services implement use cases** — \`domain/service/\` classes implement \`domain/port/in/\` interfaces

### Example

\`\`\`java
// domain/port/in/ProcessPaymentUseCase.java
public interface ProcessPaymentUseCase {
    PaymentResult process(PaymentCommand command);
}

// domain/port/out/PaymentRepository.java
public interface PaymentRepository {
    Payment save(Payment payment);
    Optional<Payment> findById(PaymentId id);
}

// domain/port/out/PaymentEventPublisher.java
public interface PaymentEventPublisher {
    void publish(PaymentProcessedEvent event);
}

// domain/service/PaymentService.java
public class PaymentService implements ProcessPaymentUseCase {
    private final PaymentRepository paymentRepository;
    private final PaymentEventPublisher eventPublisher;
    // ... constructor injection, business logic
}
\`\`\`

---

## Kafka Event Conventions

All inter-service communication happens through Kafka. **No direct REST calls between services.**

### Topic naming

\`\`\`
platform.<domain>.<event-type>
\`\`\`

Examples:
- \`platform.payments.payment-processed\`
- \`platform.payments.refund-initiated\`
- \`platform.orders.order-created\`
- \`platform.orders.order-cancelled\`
- \`platform.users.user-registered\`
- \`platform.users.kyc-verified\`

### Consumer group naming

\`\`\`
<consuming-service>.<topic-name>
\`\`\`

Example: \`notification-service.platform.payments.payment-processed\`

### Event schema requirements

Every domain event **must** have a schema registered in \`schema-registry/\`:

\`\`\`
schema-registry/
├── avro/
│   ├── platform.payments.payment-processed.avsc
│   ├── platform.orders.order-created.avsc
│   └── ...
└── json/
    └── (JSON Schema alternatives if needed)
\`\`\`

### Event envelope structure

All events follow a standard envelope:

\`\`\`json
{
  "eventId": "uuid-v4",
  "eventType": "PaymentProcessed",
  "source": "payment-service",
  "timestamp": "2024-01-15T10:30:00Z",
  "version": "1.0",
  "correlationId": "uuid-v4",
  "traceId": "jaeger-trace-id",
  "payload": {
    // domain-specific data
  }
}
\`\`\`

### Event envelope Java class

Use the shared \`DomainEvent<T>\` base class from \`shared/domain-events\`:

\`\`\`java
import com.platform.shared.events.DomainEvent;

public class PaymentProcessedEvent extends DomainEvent<PaymentProcessedPayload> {
    // Inherits eventId, eventType, source, timestamp, version, correlationId, traceId
}
\`\`\`

### Event versioning

- Events are versioned with a \`version\` field
- **Never remove fields** — only add new optional fields (backward compatible)
- If a breaking change is required, create a new event type (e.g., \`PaymentProcessedV2\`)
- Document breaking changes in an ADR under \`docs/adr/\`

### Kafka producer conventions

\`\`\`java
@Component
public class KafkaPaymentEventPublisher implements PaymentEventPublisher {

    private static final String TOPIC = "platform.payments.payment-processed";

    private final KafkaTemplate<String, DomainEvent<?>> kafkaTemplate;

    @Override
    public void publish(PaymentProcessedEvent event) {
        kafkaTemplate.send(TOPIC, event.getPayload().getPaymentId().toString(), event);
    }
}
\`\`\`

- **Key**: Use the aggregate ID as the Kafka message key (ensures ordering per entity)
- **Idempotency**: Producers must enable idempotent mode (\`enable.idempotence=true\`)
- **Retries**: Configure retries with exponential backoff

### Kafka consumer conventions

\`\`\`java
@Component
public class OrderPaymentEventConsumer {

    @KafkaListener(
        topics = "platform.payments.payment-processed",
        groupId = "order-service.platform.payments.payment-processed",
        containerFactory = "kafkaListenerContainerFactory"
    )
    public void handlePaymentProcessed(PaymentProcessedEvent event) {
        // Idempotency check using eventId
        // Process event
    }
}
\`\`\`

- **Idempotency**: Every consumer must check \`eventId\` to prevent duplicate processing
- **Dead letter topic**: Failed messages go to \`<topic>.dlt\` after configured retries
- **Manual offset commit**: Use \`AckMode.MANUAL_IMMEDIATE\` for critical flows

---

## Database Conventions

### Database per service

Each service owns its database. **Never access another service's database directly.**

| Service          | Database                    |
|------------------|-----------------------------|
| order-service    | \`order_service_db\`          |
| payment-service  | \`payment_service_db\`        |
| user-service     | \`user_service_db\`           |

### Flyway migrations

- Location: \`src/main/resources/db/migration/\`
- Naming: \`V{version}__{description}.sql\` (e.g., \`V1__create_payments_table.sql\`)
- **Never modify an existing migration** — create a new one
- All DDL changes require a review from a database-aware team member

### Table naming

- Lowercase, snake_case
- Plural form: \`payments\`, \`orders\`, \`users\`
- Junction tables: \`order_items\`, \`user_roles\`

### Sensitive data

- PII fields must be encrypted at rest (PCI DSS requirement)
- Use \`@Convert(converter = EncryptedStringConverter.class)\` for sensitive JPA fields
- Never log PII — see [security rules](../.claude/rules/common/security.md)

---

## API Conventions

### REST endpoints

- Base path: \`/api/v1/<resource>\`
- Use plural nouns: \`/api/v1/payments\`, \`/api/v1/orders\`
- HTTP methods: GET (read), POST (create), PUT (full update), PATCH (partial update), DELETE
- Return appropriate status codes: 200, 201, 204, 400, 401, 403, 404, 409, 422, 500

### Request/Response DTOs

- DTOs live in \`adapter/in/web/dto/\`
- Use Java records for DTOs
- Validate with \`@Valid\` and Bean Validation annotations
- Never expose domain entities directly in API responses

### OpenAPI specification

- Every service maintains an OpenAPI spec in \`docs/api/<service-name>.openapi.yml\`
- Update the spec when adding or modifying endpoints
- The gateway aggregates all service specs

### API versioning

- Version in URL path: \`/api/v1/\`, \`/api/v2/\`
- Deprecate old versions with \`@Deprecated\` and \`Sunset\` header
- Document deprecation timeline in the service README

---

## Testing Requirements

### Coverage threshold: 80% minimum

Coverage is measured by JaCoCo and enforced in CI.

### Test types

| Type | Location | Tool | Runs In CI |
|------|----------|------|------------|
| Unit | \`src/test/java/**/unit/\` | JUnit 5 + Mockito | ✅ |
| Integration | \`src/test/java/**/integration/\` | Testcontainers | ✅ |
| Architecture | \`src/test/java/**/architecture/\` | ArchUnit | ✅ |
| Contract | \`tests/contract/\` | Pact | ✅ |
| E2E | \`tests/e2e/\` | REST Assured | Staging only |

### Unit test conventions

\`\`\`java
@ExtendWith(MockitoExtension.class)`,

  'docs/ONBOARDING.md': `# Onboarding Guide — Spring Boot Microservices Platform

Welcome to the team! This guide walks you through setting up the development environment, understanding the project structure, and making your first contribution.

## Table of Contents

- [Prerequisites](#prerequisites)
- [Repository Setup](#repository-setup)
- [Infrastructure Services (Docker Compose)](#infrastructure-services-docker-compose)
- [Gradle Workflow](#gradle-workflow)
- [Running a Microservice Locally](#running-a-microservice-locally)
- [Working with Kafka](#working-with-kafka)
- [Working with PostgreSQL](#working-with-postgresql)
- [Working with Redis](#working-with-redis)
- [Testing](#testing)
- [Claude Code Setup](#claude-code-setup)
- [Project Architecture](#project-architecture)
- [Making Your First Contribution](#making-your-first-contribution)
- [Key Contacts & Resources](#key-contacts--resources)

---

## Prerequisites

Install the following before proceeding:

| Tool | Version | Purpose |
|------|---------|---------|
| **Java (Temurin)** | 21+ | Primary language runtime |
| **Docker Desktop** | 24+ | Container runtime for local infra |
| **Docker Compose** | v2+ | Orchestrate local services |
| **Git** | 2.40+ | Source control (GPG signing required) |
| **Gradle** | 8.5+ (wrapper included) | Build tool — use \`./gradlew\`, not system Gradle |
| **kubectl** | 1.28+ | Kubernetes CLI (for staging/prod debugging) |
| **Helm** | 3.13+ | Kubernetes package manager |
| **AWS CLI** | 2.x | AWS access for staging/prod |
| **Claude Code** | Latest | AI-assisted development |

### Optional but Recommended

- **IntelliJ IDEA Ultimate** — best Spring Boot support, team licenses available
- **Kafka CLI tools** (\`kcat\`) — for inspecting Kafka topics
- **pgcli** — enhanced PostgreSQL CLI
- **jq** — JSON processing in terminal

### macOS Quick Install

\`\`\`bash
brew install --cask temurin@21
brew install docker docker-compose git kubectl helm awscli jq kcat pgcli
brew install --cask intellij-idea
\`\`\`

### Verify Installations

\`\`\`bash
java -version          # openjdk 21.x
docker --version       # Docker 24.x+
docker compose version # v2.x
git --version          # 2.40+
\`\`\`

---

## Repository Setup

### 1. Clone the Repository

\`\`\`bash
git clone git@github.com:your-org/spring-boot-microservices.git
cd spring-boot-microservices
\`\`\`

### 2. Configure Git Identity & Signing

All commits must be signed (SOC 2 compliance requirement):

\`\`\`bash
git config user.name "Your Name"
git config user.email "your.name@company.com"
git config commit.gpgsign true
git config user.signingkey YOUR_GPG_KEY_ID
\`\`\`

If you haven't set up GPG signing, follow [GitHub's GPG guide](https://docs.github.com/en/authentication/managing-commit-signature-verification).

### 3. Install Git Hooks

\`\`\`bash
# From the repository root
chmod +x git-hooks/*
git config core.hooksPath git-hooks
\`\`\`

This enables:
- **pre-commit** — runs Checkstyle, ktlint, and prevents secrets from being committed
- **commit-msg** — enforces conventional commit format (\`feat:\`, \`fix:\`, \`chore:\`, etc.)
- **pre-push** — runs unit tests before pushing

### 4. Copy Environment Configuration

\`\`\`bash
cp .env.example .env
\`\`\`

Edit \`.env\` with any local overrides. The defaults work for most setups.

---

## Infrastructure Services (Docker Compose)

All external dependencies run in Docker. **Never install PostgreSQL, Kafka, or Redis directly on your machine.**

### Start All Infrastructure

\`\`\`bash
docker compose up -d
\`\`\`

This starts:

| Service | Port | Purpose |
|---------|------|---------|
| **PostgreSQL (order-db)** | 5432 | Order service database |
| **PostgreSQL (payment-db)** | 5433 | Payment service database |
| **PostgreSQL (user-db)** | 5434 | User service database |
| **Redis** | 6379 | Caching and session management |
| **Kafka (KRaft)** | 9092 | Event streaming |
| **Kafka UI** | 8090 | Web UI for Kafka topics/messages |
| **Schema Registry** | 8081 | Avro/JSON schema management |
| **Jaeger** | 16686 | Distributed tracing UI |
| **Prometheus** | 9090 | Metrics collection |
| **Grafana** | 3000 | Metrics dashboards (admin/admin) |

### Verify Infrastructure

\`\`\`bash
# Check all containers are running
docker compose ps

# Test PostgreSQL connectivity
docker compose exec order-db psql -U order_user -d order_db -c "SELECT 1;"

# Test Redis connectivity
docker compose exec redis redis-cli ping
# Expected: PONG

# Test Kafka connectivity
docker compose exec kafka kafka-topics.sh --bootstrap-server localhost:9092 --list

# Open Kafka UI
open http://localhost:8090
\`\`\`

### Common Docker Compose Commands

\`\`\`bash
# Start specific services only
docker compose up -d postgres-order kafka redis

# View logs for a specific service
docker compose logs -f kafka

# Stop all services
docker compose down

# Stop and remove all data (fresh start)
docker compose down -v

# Rebuild after docker-compose.yml changes
docker compose up -d --build
\`\`\`

### Kafka Topics (Auto-Created)

The following topics are created automatically on startup:

| Topic | Partitions | Used By |
|-------|------------|---------|
| \`order.events\` | 6 | Order service → Payment, Notification |
| \`payment.events\` | 6 | Payment service → Order, Notification |
| \`user.events\` | 3 | User service → Order, Notification |
| \`notification.events\` | 3 | Notification service |
| \`order.events.dlq\` | 3 | Dead letter queue for order events |
| \`payment.events.dlq\` | 3 | Dead letter queue for payment events |

---

## Gradle Workflow

We use **Gradle with Kotlin DSL** in a multi-module setup. Always use the wrapper (\`./gradlew\`), never a system-installed Gradle.

### Project Structure

\`\`\`
build.gradle.kts              # Root build config (shared plugins, dependency management)
settings.gradle.kts            # Module declarations
gradle/
  libs.versions.toml           # Version catalog (all dependency versions here)
services/
  order-service/
    build.gradle.kts
  payment-service/
    build.gradle.kts
  user-service/
    build.gradle.kts
shared/
  domain-events/
    build.gradle.kts
  common-utils/
    build.gradle.kts
gateway/
  build.gradle.kts
\`\`\`

### Essential Gradle Commands

\`\`\`bash
# Build everything (compile + test + check)
./gradlew build

# Build a specific service
./gradlew :services:order-service:build

# Run only unit tests
./gradlew test

# Run integration tests (requires Docker Compose running)
./gradlew integrationTest

# Run a specific test class
./gradlew :services:order-service:test --tests "com.company.order.domain.OrderServiceTest"

# Check code style (Checkstyle + ktlint)
./gradlew check

# Run Checkstyle only
./gradlew checkstyleMain checkstyleTest

# Run ktlint only
./gradlew ktlintCheck

# Auto-fix ktlint issues
./gradlew ktlintFormat

# Generate JaCoCo coverage report
./gradlew jacocoTestReport
# Report at: services/order-service/build/reports/jacoco/test/html/index.html

# Run OWASP dependency check
./gradlew dependencyCheckAnalyze

# Run SpotBugs static analysis
./gradlew spotbugsMain

# Clean all build artifacts
./gradlew clean

# List all available tasks
./gradlew tasks

# Show dependency tree for a module
./gradlew :services:order-service:dependencies
\`\`\`

### Adding a Dependency

All versions are managed in \`gradle/libs.versions.toml\`. Do not hardcode versions in \`build.gradle.kts\` files.

\`\`\`toml
# gradle/libs.versions.toml
[versions]
spring-boot = "3.2.5"

[libraries]
spring-boot-starter-web = { module = "org.springframework.boot:spring-boot-starter-web" }
\`\`\`

\`\`\`kotlin
// services/order-service/build.gradle.kts
dependencies {
    implementation(libs.spring.boot.starter.web)
}
\`\`\`

> **Dependency Policy**: We maintain a conservative approved dependency list. New dependencies require a tech lead review. Check \`docs/APPROVED_DEPENDENCIES.md\` before adding anything.

---

## Running a Microservice Locally

### 1. Ensure Infrastructure Is Running

\`\`\`bash
docker compose up -d
\`\`\`

### 2. Run a Service with Spring Profile

\`\`\`bash
# Run order-service with local profile
./gradlew :services:order-service:bootRun --args='--spring.profiles.active=local'

# Or set the profile via environment variable
SPRING_PROFILES_ACTIVE=local ./gradlew :services:order-service:bootRun
\`\`\`

### 3. Service Ports (Local Profile)

| Service | Port | Health Check |
|---------|------|-------------|
| API Gateway | 8080 | http://localhost:8080/actuator/health |
| Order Service | 8081 | http://localhost:8081/actuator/health |
| Payment Service | 8082 | http://localhost:8082/actuator/health |
| User Service | 8083 | http://localhost:8083/actuator/health |

### 4. Verify a Running Service

\`\`\`bash
# Health check
curl http://localhost:8081/actuator/health | jq

# Readiness probe
curl http://localhost:8081/actuator/health/readiness | jq

# Service info
curl http://localhost:8081/actuator/info | jq

# Prometheus metrics
curl http://localhost:8081/actuator/prometheus

# OpenAPI spec
curl http://localhost:8081/v3/api-docs | jq

# Swagger UI
open http://localhost:8081/swagger-ui.html
\`\`\`

### Running Multiple Services

To test inter-service flows (e.g., order creation → payment processing), run multiple services in separate terminals:

\`\`\`bash
# Terminal 1
./gradlew :gateway:bootRun --args='--spring.profiles.active=local'

# Terminal 2
./gradlew :services:order-service:bootRun --args='--spring.profiles.active=local'

# Terminal 3
./gradlew :services:payment-service:bootRun --args='--spring.profiles.active=local'
\`\`\`

> **Important**: Services communicate exclusively through Kafka events. There are no direct REST calls between services. The API Gateway is the only entry point for external HTTP traffic.

---

## Working with Kafka

### Inspecting Topics and Messages

\`\`\`bash
# List all topics
docker compose exec kafka kafka-topics.sh \\
  --bootstrap-server localhost:9092 --list

# Describe a topic
docker compose exec kafka kafka-topics.sh \\
  --bootstrap-server localhost:9092 --describe --topic order.events

# Consume messages from a topic (from beginning)
docker compose exec kafka kafka-console-consumer.sh \\
  --bootstrap-server localhost:9092 --topic order.events --from-beginning

# Produce a test message
docker compose exec kafka kafka-console-producer.sh \\
  --bootstrap-server localhost:9092 --topic order.events
\`\`\`

### Using kcat (Recommended)

\`\`\`bash
# Consume with kcat (more readable output)
kcat -b localhost:9092 -t order.events -C -f '%k | %s\\n'

# Produce a test event
echo '{"eventType":"ORDER_CREATED","orderId":"test-123","timestamp":"2024-01-01T00:00:00Z"}' | \\
  kcat -b localhost:9092 -t order.events -P -k "test-123"
\`\`\`

### Kafka UI

Open http://localhost:8090 for a web-based interface to browse topics, consumer groups, messages, and schemas.

### Event Schema Conventions

All domain events are defined in \`schema-registry/\` and shared via the \`shared/domain-events\` module:

\`\`\`
schema-registry/
  avro/
    order/
      OrderCreatedEvent.avsc
      OrderCancelledEvent.avsc
    payment/
      PaymentProcessedEvent.avsc
      PaymentFailedEvent.avsc
\`\`\`

Every event must include: \`eventId\`, \`eventType\`, \`timestamp\`, \`correlationId\`, and \`version\`.

---

## Working with PostgreSQL

Each service has its own database (database-per-service pattern, required for PCI DSS data isolation):

\`\`\`bash
# Connect to order-service database
docker compose exec order-db psql -U order_user -d order_db

# Connect to payment-service database
docker compose exec payment-db psql -U payment_user -d payment_db

# Connect to user-service database
docker compose exec user-db psql -U user_user -d user_db
\`\`\`

### Database Migrations

We use **Flyway** for schema migrations. Migration files live in each service:

\`\`\`
services/order-service/src/main/resources/db/migration/
  V1__create_orders_table.sql
  V2__add_order_status_index.sql
\`\`\`

Migrations run automatically on service startup. To run manually:

\`\`\`bash
./gradlew :services:order-service:flywayMigrate
\`\`\`

> **Rule**: Never modify an existing migration file. Always create a new versioned migration.

---

## Working with Redis

\`\`\`bash
# Connect to Redis CLI
docker compose exec redis redis-cli

# Check keys
127.0.0.1:6379> KEYS *

# Monitor real-time commands
127.0.0.1:6379> MONITOR
\`\`\`

Redis is used for:
- **Session management** — API Gateway stores JWT session data
- **Caching** — frequently accessed reference data
- **Rate limiting** — API Gateway rate limit counters
- **Distributed locks** — idempotency keys for payment processing

---

## Testing

### Test Pyramid

\`\`\`
         ╱  E2E Tests  ╲          ← tests/ directory, run in CI against staging
        ╱ Contract Tests ╲        ← Pact consumer/provider tests
       ╱ Integration Tests╲       ← Testcontainers (real Kafka, Postgres, Redis)
      ╱    Unit Tests      ╲      ← JUnit 5 + Mockito, fast, no infra needed
\`\`\`

### Running Tests

\`\`\`bash
# Unit tests only (fast, no Docker needed)
./gradlew test

# Integration tests (requires Docker — Testcontainers spins up containers)
./gradlew integrationTest

# Contract tests
./gradlew contractTest

# All tests with coverage
./gradlew test integrationTest jacocoTestReport

# Single service tests
./gradlew :services:order-service:test
./gradlew :services:order-service:integrationTest
\`\`\`

### Coverage Requirements

- **Minimum**: 80% line coverage per service
- **Coverage report**: \`build/reports/jacoco/test/html/index.html\`
- **CI enforcement**: Build fails if coverage drops below threshold

### Testcontainers

Integration tests use [Testcontainers](https://testcontainers.com/) to spin up real PostgreSQL, Kafka, and Redis instances. Docker must be running.

\`\`\`java
@SpringBootTest
@Testcontainers
class OrderRepositoryIntegrationTest {

    @Container
    static PostgreSQLContainer<?> postgres = new PostgreSQLContainer<>("postgres:16-alpine");

    @Container
    static KafkaContainer kafka = new KafkaContainer(DockerImageName.parse("confluentinc/cp-kafka:7.5.0"));
}
\`\`\`

See \`.claude/rules/java/testing.md\` and \`.claude/rules/common/testing.md\` for full testing conventions.

---

## Claude Code Setup

All backend developers use Claude Code for AI-assisted development.

### 1. Install Claude Code

Follow the installation guide at [claude.`,

  'git-hooks/commit-msg': `#!/usr/bin/env bash
#
# commit-msg hook — validates conventional commit format with Jira ticket reference
# Install: cp git-hooks/commit-msg .git/hooks/commit-msg && chmod +x .git/hooks/commit-msg
#
# Expected format:
#   type(scope): TICKET-123 description
#   type: TICKET-123 description
#
# Examples:
#   feat(payment-service): PAY-123 add idempotent payment processing
#   fix(order-service): ORD-456 resolve race condition in order state machine
#   chore: INFRA-789 update Helm chart resource limits
#   docs(schema-registry): EVT-101 add Avro schema evolution guide
#   refactor(user-service): USR-202 extract authentication port interface

set -euo pipefail

COMMIT_MSG_FILE="$1"
COMMIT_MSG=$(cat "$COMMIT_MSG_FILE")

# Skip merge commits and revert commits
if echo "$COMMIT_MSG" | grep -qE "^(Merge|Revert) "; then
  exit 0
fi

# Skip fixup and squash commits (used during interactive rebase)
if echo "$COMMIT_MSG" | grep -qE "^(fixup|squash)! "; then
  exit 0
fi

RED='\\033[0;31m'
YELLOW='\\033[0;33m'
GREEN='\\033[0;32m'
CYAN='\\033[0;36m'
NC='\\033[0m'

# Allowed conventional commit types
ALLOWED_TYPES="feat|fix|chore|docs|refactor|test|perf|ci|build|style|revert"

# Known service scopes in the monorepo
KNOWN_SCOPES="order-service|payment-service|user-service|gateway|shared|schema-registry|infrastructure|charts|tests"

# Jira project key pattern — adjust project prefixes as needed
JIRA_PATTERN="[A-Z][A-Z0-9]+-[0-9]+"

# Full conventional commit pattern with Jira ticket
# Format: type(optional-scope): TICKET-123 description
COMMIT_PATTERN="^(\${ALLOWED_TYPES})(\\([a-z][a-z0-9-]*\\))?!?: \${JIRA_PATTERN} .+"

FIRST_LINE=$(echo "$COMMIT_MSG" | head -n 1)

errors=()

# Validate conventional commit format
if ! echo "$FIRST_LINE" | grep -qE "$COMMIT_PATTERN"; then
  # Provide specific error feedback
  if ! echo "$FIRST_LINE" | grep -qE "^(\${ALLOWED_TYPES})"; then
    errors+=("Invalid commit type. Allowed: feat, fix, chore, docs, refactor, test, perf, ci, build, style, revert")
  fi

  if ! echo "$FIRST_LINE" | grep -qE "\${JIRA_PATTERN}"; then
    errors+=("Missing Jira ticket reference (e.g., PAY-123, ORD-456)")
  fi

  if echo "$FIRST_LINE" | grep -qE "^(\${ALLOWED_TYPES})(\\([a-z][a-z0-9-]*\\))?!?:$"; then
    errors+=("Missing commit description after ticket reference")
  fi

  if ! echo "$FIRST_LINE" | grep -qE "^(\${ALLOWED_TYPES})(\\([a-z][a-z0-9-]*\\))?!?: "; then
    errors+=("Missing space after colon, or colon missing. Format: type(scope): TICKET-123 description")
  fi
fi

# Validate first line length (max 100 characters for readability in git log)
if [ \${#FIRST_LINE} -gt 100 ]; then
  errors+=("First line is \${#FIRST_LINE} characters (max 100). Move details to the commit body.")
fi

# Validate first line is not empty
if [ -z "$FIRST_LINE" ]; then
  errors+=("Commit message cannot be empty")
fi

# Warn if description starts with uppercase (should be lowercase)
DESCRIPTION=$(echo "$FIRST_LINE" | sed -E "s/^(\${ALLOWED_TYPES})(\\([a-z][a-z0-9-]*\\))?!?: \${JIRA_PATTERN} //" 2>/dev/null || echo "")
if echo "$DESCRIPTION" | grep -qE "^[A-Z]"; then
  errors+=("Description should start with lowercase (e.g., 'add payment endpoint' not 'Add payment endpoint')")
fi

# Warn if description ends with a period
if echo "$FIRST_LINE" | grep -qE "\\.$"; then
  errors+=("Do not end the subject line with a period")
fi

# Validate scope if present — warn on unknown scopes
SCOPE=$(echo "$FIRST_LINE" | sed -nE "s/^(\${ALLOWED_TYPES})\\(([a-z][a-z0-9-]*)\\).*/\\2/p" 2>/dev/null || echo "")
if [ -n "$SCOPE" ]; then
  if ! echo "$SCOPE" | grep -qE "^(\${KNOWN_SCOPES})$"; then
    # Warn but don't block — new services may be added
    echo -e "\${YELLOW}⚠ Warning:\${NC} Scope '\${SCOPE}' is not a known module (\${KNOWN_SCOPES})"
    echo -e "  If this is a new service, consider updating git-hooks/commit-msg"
  fi
fi

# Validate body format if present (blank line between subject and body)
LINE_COUNT=$(echo "$COMMIT_MSG" | wc -l)
if [ "$LINE_COUNT" -gt 1 ]; then
  SECOND_LINE=$(echo "$COMMIT_MSG" | sed -n '2p')
  if [ -n "$SECOND_LINE" ]; then
    errors+=("Second line must be blank (separate subject from body with an empty line)")
  fi
fi

# Check for sensitive content that should not be in commit messages
SENSITIVE_PATTERNS="password|secret|api[_-]?key|token|credential|private[_-]?key|aws[_-]?access"
if echo "$COMMIT_MSG" | grep -iqE "$SENSITIVE_PATTERNS"; then
  # Check it's not just referencing the concept (e.g., "add password validation")
  if echo "$COMMIT_MSG" | grep -iqE "(=|:).*(password|secret|api[_-]?key|token|credential)"; then
    errors+=("Commit message may contain sensitive data. Never include secrets, passwords, or API keys in commit messages. [SOC 2 / PCI DSS]")
  fi
fi

# Report errors
if [ \${#errors[@]} -gt 0 ]; then
  echo ""
  echo -e "\${RED}✖ Invalid commit message:\${NC}"
  echo -e "\${CYAN}  \\"\${FIRST_LINE}\\"\${NC}"
  echo ""
  for error in "\${errors[@]}"; do
    echo -e "  \${RED}•\${NC} \${error}"
  done
  echo ""
  echo -e "\${GREEN}Expected format:\${NC}"
  echo -e "  type(scope): TICKET-123 description"
  echo ""
  echo -e "\${GREEN}Examples:\${NC}"
  echo -e "  feat(payment-service): PAY-123 add idempotent payment processing"
  echo -e "  fix(order-service): ORD-456 resolve race condition in order state machine"
  echo -e "  chore: INFRA-789 update Helm chart resource limits"
  echo -e "  docs(schema-registry): EVT-101 add Avro schema evolution guide"
  echo -e "  test(user-service): USR-202 add Testcontainers integration tests"
  echo ""
  echo -e "\${GREEN}Allowed types:\${NC} feat, fix, chore, docs, refactor, test, perf, ci, build, style, revert"
  echo -e "\${GREEN}Known scopes:\${NC} order-service, payment-service, user-service, gateway, shared, schema-registry, infrastructure, charts, tests"
  echo ""
  exit 1
fi

exit 0`,

  'git-hooks/pre-commit': `#!/usr/bin/env bash
set -euo pipefail

# spring-boot-microservices pre-commit hook
# Runs Checkstyle, ktlint, and secrets detection on staged files

RED='\\033[0;31m'
GREEN='\\033[0;32m'
YELLOW='\\033[1;33m'
NC='\\033[0m'

FAILED=0

log_pass() { echo -e "\${GREEN}✓\${NC} $1"; }
log_fail() { echo -e "\${RED}✗\${NC} $1"; FAILED=1; }
log_warn() { echo -e "\${YELLOW}⚠\${NC} $1"; }
log_step() { echo -e "\\n\${YELLOW}▸\${NC} $1"; }

STAGED_FILES=$(git diff --cached --name-only --diff-filter=ACM)
STAGED_JAVA=$(echo "$STAGED_FILES" | grep '\\.java$' || true)
STAGED_KOTLIN=$(echo "$STAGED_FILES" | grep '\\.kt$\\|\\.kts$' || true)
STAGED_PROPS=$(echo "$STAGED_FILES" | grep '\\.properties$\\|\\.yml$\\|\\.yaml$\\|\\.env' || true)
STAGED_ALL="$STAGED_FILES"

if [ -z "$STAGED_ALL" ]; then
  echo "No staged files to check."
  exit 0
fi

echo "═══════════════════════════════════════════"
echo " spring-boot-microservices pre-commit hook"
echo "═══════════════════════════════════════════"

# ── 1. Secrets & Credential Detection ────────────────────────────────
log_step "Scanning for secrets and credentials (SOC 2 / PCI DSS)"

SECRET_PATTERNS=(
  'password\\s*=\\s*[^\${\\s]'
  'secret\\s*=\\s*[^\${\\s]'
  'api[_-]?key\\s*=\\s*[^\${\\s]'
  'token\\s*=\\s*[^\${\\s]'
  'jdbc:postgresql://[^\${\\s]*:[^\${\\s]*@'
  'BEGIN\\s+(RSA|DSA|EC|OPENSSH)\\s+PRIVATE\\s+KEY'
  'AKIA[0-9A-Z]{16}'
  'aws_secret_access_key\\s*=\\s*[^\${\\s]'
)

SECRETS_FOUND=0
for file in $STAGED_ALL; do
  [ -f "$file" ] || continue
  content=$(git diff --cached --diff-filter=ACM -p -- "$file" | grep '^+' | grep -v '^+++' || true)
  for pattern in "\${SECRET_PATTERNS[@]}"; do
    if echo "$content" | grep -iEq "$pattern"; then
      echo -e "  \${RED}Found potential secret in\${NC} $file \${RED}(pattern: \${pattern%%\\\\*})\${NC}"
      SECRETS_FOUND=1
    fi
  done
done

if [ "$SECRETS_FOUND" -eq 1 ]; then
  log_fail "Secrets detected in staged files. Use Spring Profiles with \\\${ENV_VAR} placeholders."
  echo "  Hardcoded credentials violate PCI DSS Requirement 2.1 and SOC 2 CC6.1."
else
  log_pass "No secrets detected"
fi

# ── 2. Checkstyle (Java) ─────────────────────────────────────────────
if [ -n "$STAGED_JAVA" ]; then
  log_step "Running Checkstyle on staged Java files"

  JAVA_MODULES=$(echo "$STAGED_JAVA" | sed -n 's|^\\(services/[^/]*/\\|shared/[^/]*/\\|gateway/\\).*|\\1|p' | sort -u)

  if [ -n "$JAVA_MODULES" ]; then
    CHECKSTYLE_TASKS=""
    for mod in $JAVA_MODULES; do
      mod_name=$(echo "$mod" | sed 's|/|:|g; s|:$||; s|^|:|')
      CHECKSTYLE_TASKS="$CHECKSTYLE_TASKS \${mod_name}:checkstyleMain \${mod_name}:checkstyleTest"
    done
    if ./gradlew --quiet $CHECKSTYLE_TASKS 2>/dev/null; then
      log_pass "Checkstyle passed"
    else
      log_fail "Checkstyle violations found. Run: ./gradlew checkstyleMain checkstyleTest"
    fi
  else
    if ./gradlew --quiet checkstyleMain checkstyleTest 2>/dev/null; then
      log_pass "Checkstyle passed"
    else
      log_fail "Checkstyle violations found. Run: ./gradlew checkstyleMain checkstyleTest"
    fi
  fi
else
  log_step "Checkstyle — no Java files staged, skipping"
fi

# ── 3. ktlint (Kotlin) ───────────────────────────────────────────────
if [ -n "$STAGED_KOTLIN" ]; then
  log_step "Running ktlint on staged Kotlin files"
  if ./gradlew --quiet ktlintCheck 2>/dev/null; then
    log_pass "ktlint passed"
  else
    log_fail "ktlint violations found. Run: ./gradlew ktlintFormat"
  fi
else
  log_step "ktlint — no Kotlin files staged, skipping"
fi

# ── 4. File length check (max 300 lines) ─────────────────────────────
log_step "Checking file length (max 300 lines)"
LENGTH_VIOLATIONS=0
for file in $STAGED_JAVA $STAGED_KOTLIN; do
  [ -f "$file" ] || continue
  lines=$(wc -l < "$file")
  if [ "$lines" -gt 300 ]; then
    echo -e "  \${RED}\${file}\${NC}: \${lines} lines (max 300)"
    LENGTH_VIOLATIONS=1
  fi
done
if [ "$LENGTH_VIOLATIONS" -eq 1 ]; then
  log_fail "Files exceed 300-line limit. Split into smaller classes following Hexagonal Architecture boundaries."
else
  log_pass "All files within 300-line limit"
fi

# ── 5. Conventional commit message format hint ────────────────────────
log_step "Reminder: use conventional commits (feat:, fix:, chore:, docs:, refactor:)"

echo ""
if [ "$FAILED" -eq 1 ]; then
  echo -e "\${RED}Pre-commit checks failed.\${NC} Fix issues above before committing."
  exit 1
else
  echo -e "\${GREEN}All pre-commit checks passed.\${NC}"
  exit 0
fi`,

  'git-hooks/pre-push': `#!/usr/bin/env bash
#
# Pre-push hook for spring-boot-microservices
# Runs full Gradle check (Checkstyle, ktlint, SpotBugs, tests, JaCoCo coverage)
# Blocks push if any check fails
#
# Install: ln -sf ../../git-hooks/pre-push .git/hooks/pre-push

set -euo pipefail

REMOTE="$1"
URL="$2"

# Colors
RED='\\033[0;31m'
GREEN='\\033[0;32m'
YELLOW='\\033[1;33m'
CYAN='\\033[0;36m'
NC='\\033[0m'

echo -e "\${CYAN}╔══════════════════════════════════════════════╗\${NC}"
echo -e "\${CYAN}║         Pre-Push Quality Gate                ║\${NC}"
echo -e "\${CYAN}║   spring-boot-microservices                  ║\${NC}"
echo -e "\${CYAN}╚══════════════════════════════════════════════╝\${NC}"
echo ""

# Track what we're pushing
PROTECTED_BRANCHES="^(main|release/.*)$"
PUSH_BLOCKED=false

while read -r LOCAL_REF LOCAL_SHA REMOTE_REF REMOTE_SHA; do
    if [ -z "$LOCAL_REF" ]; then
        continue
    fi

    BRANCH_NAME=$(echo "$LOCAL_REF" | sed 's|refs/heads/||')

    # Block direct pushes to protected branches
    if echo "$BRANCH_NAME" | grep -qE "$PROTECTED_BRANCHES"; then
        echo -e "\${RED}✗ Direct push to protected branch '\${BRANCH_NAME}' is not allowed.\${NC}"
        echo -e "\${YELLOW}  Protected branches: main, release/*\${NC}"
        echo -e "\${YELLOW}  Use a pull request with at least 2 approvals instead.\${NC}"
        exit 1
    fi

    # Validate branch naming convention: type/ticket-desc
    BRANCH_PATTERN="^(feat|fix|chore|docs|refactor|test|hotfix|ci)/[A-Z]+-[0-9]+-[a-z0-9-]+$"
    if ! echo "$BRANCH_NAME" | grep -qE "$BRANCH_PATTERN"; then
        echo -e "\${YELLOW}⚠ Branch name '\${BRANCH_NAME}' does not match convention: type/TICKET-123-description\${NC}"
        echo -e "\${YELLOW}  Examples: feat/PAY-123-add-payment-service, fix/ORD-456-null-order-id\${NC}"
        echo -e "\${YELLOW}  Allowed types: feat, fix, chore, docs, refactor, test, hotfix, ci\${NC}"
        # Warn but don't block — some branches like 'develop' may not follow the pattern
    fi
done

# Detect which modules have changes compared to the remote tracking branch
CURRENT_BRANCH=$(git rev-parse --abbrev-ref HEAD)
MERGE_BASE=$(git merge-base HEAD "origin/main" 2>/dev/null || echo "")
CHANGED_FILES=""

if [ -n "$MERGE_BASE" ]; then
    CHANGED_FILES=$(git diff --name-only "$MERGE_BASE"..HEAD 2>/dev/null || echo "")
fi

# Determine which Gradle modules are affected
AFFECTED_MODULES=""
if [ -n "$CHANGED_FILES" ]; then
    if echo "$CHANGED_FILES" | grep -q "^services/"; then
        AFFECTED_SERVICES=$(echo "$CHANGED_FILES" | grep "^services/" | cut -d'/' -f2 | sort -u)
        for svc in $AFFECTED_SERVICES; do
            AFFECTED_MODULES="$AFFECTED_MODULES :services:\${svc}"
        done
    fi
    if echo "$CHANGED_FILES" | grep -q "^shared/"; then
        AFFECTED_MODULES="$AFFECTED_MODULES :shared"
    fi
    if echo "$CHANGED_FILES" | grep -q "^gateway/"; then
        AFFECTED_MODULES="$AFFECTED_MODULES :gateway"
    fi
    if echo "$CHANGED_FILES" | grep -q "^schema-registry/"; then
        AFFECTED_MODULES="$AFFECTED_MODULES :schema-registry"
    fi
fi

# Check for sensitive file changes that require extra scrutiny
if [ -n "$CHANGED_FILES" ]; then
    SENSITIVE_CHANGES=$(echo "$CHANGED_FILES" | grep -E "(security/|auth/|infrastructure/production/|\\.properties$)" || true)
    if [ -n "$SENSITIVE_CHANGES" ]; then
        echo -e "\${YELLOW}⚠ Sensitive files detected in push — ensure security review:\${NC}"
        echo "$SENSITIVE_CHANGES" | while read -r f; do
            echo -e "  \${YELLOW}→ $f\${NC}"
        done
        echo ""
    fi
fi

# Check for secrets or credentials that might have slipped through
echo -e "\${CYAN}▸ Scanning for secrets and credentials...\${NC}"
SECRET_PATTERNS=(
    'password\\s*=\\s*["\\x27][^"\\x27]+'
    'secret\\s*=\\s*["\\x27][^"\\x27]+'
    'api[_-]?key\\s*=\\s*["\\x27][^"\\x27]+'
    'AKIA[0-9A-Z]{16}'
    'aws_secret_access_key'
    'BEGIN\\s+(RSA|DSA|EC|OPENSSH)\\s+PRIVATE\\s+KEY'
    'jdbc:postgresql://[^/]+/[^\\s]+'
    'spring\\.datasource\\.password\\s*='
    'spring\\.kafka\\.properties\\.sasl\\.jaas\\.config'
    'spring\\.redis\\.password\\s*='
)

SECRETS_FOUND=false
for pattern in "\${SECRET_PATTERNS[@]}"; do
    # Check staged diff, not the whole repo
    if [ -n "$MERGE_BASE" ]; then
        MATCHES=$(git diff "$MERGE_BASE"..HEAD -G "$pattern" --name-only 2>/dev/null || true)
        if [ -n "$MATCHES" ]; then
            # Exclude test fixtures, example configs, and documentation
            REAL_MATCHES=$(echo "$MATCHES" | grep -vE "(test/|Test\\.|\\.md$|example|template|\\.sample)" || true)
            if [ -n "$REAL_MATCHES" ]; then
                echo -e "\${RED}✗ Potential secret/credential found matching pattern in:\${NC}"
                echo "$REAL_MATCHES" | while read -r f; do
                    echo -e "  \${RED}→ $f\${NC}"
                done
                SECRETS_FOUND=true
            fi
        fi
    fi
done

if [ "$SECRETS_FOUND" = true ]; then
    echo -e "\${RED}✗ Push blocked: potential secrets detected.\${NC}"
    echo -e "\${RED}  SOC 2 / PCI DSS compliance requires no credentials in source control.\${NC}"
    echo -e "\${YELLOW}  Use Spring Profiles + environment variables or AWS Secrets Manager.\${NC}"
    echo -e "\${YELLOW}  If these are false positives, use: git push --no-verify\${NC}"
    exit 1
fi
echo -e "\${GREEN}✓ No secrets detected\${NC}"
echo ""

# Verify Gradle wrapper exists and is executable
if [ ! -f "./gradlew" ]; then
    echo -e "\${RED}✗ Gradle wrapper (gradlew) not found in project root.\${NC}"
    exit 1
fi

if [ ! -x "./gradlew" ]; then
    echo -e "\${YELLOW}▸ Making gradlew executable...\${NC}"
    chmod +x ./gradlew
fi

# Run Gradle check (includes Checkstyle, ktlint, SpotBugs, unit tests, JaCoCo)
echo -e "\${CYAN}▸ Running Gradle check suite...\${NC}"
echo -e "\${CYAN}  This includes: Checkstyle, ktlint, SpotBugs, unit tests, JaCoCo coverage\${NC}"
echo ""

GRADLE_ARGS="check"

# If we can scope to affected modules, do so for faster feedback
if [ -n "$AFFECTED_MODULES" ] && [ "$(echo "$AFFECTED_MODULES" | wc -w)" -lt 6 ]; then
    echo -e "\${CYAN}▸ Scoped check to affected modules:\${NC}"
    GRADLE_CMD=""
    for mod in $AFFECTED_MODULES; do
        echo -e "  \${CYAN}→ \${mod}\${NC}"
        GRADLE_CMD="$GRADLE_CMD \${mod}:check"
    done
    GRADLE_ARGS="$GRADLE_CMD"
else
    echo -e "\${CYAN}▸ Running full project check (broad changes detected)\${NC}"
fi

# Also check if build.gradle.kts or shared modules changed — force full build
if [ -n "$CHANGED_FILES" ]; then
    ROOT_BUILD_CHANGED=$(echo "$CHANGED_FILES" | grep -E "^(build\\.gradle\\.kts|settings\\.gradle\\.kts|gradle/|buildSrc/)" || true)
    if [ -n "$ROOT_BUILD_CHANGED" ]; then
        echo -e "\${YELLOW}▸ Root build files changed — running full project check\${NC}"
        GRADLE_ARGS="check"
    fi
fi

echo ""

# Execute Gradle with appropriate flags
# --no-daemon: consistent behavior in hooks
# --parallel: speed up multi-module builds
# -x integrationTest: skip integration tests (those run in CI with Testcontainers)
# -x contractTest: skip Pact contract tests (those run in CI pipeline)
if ./gradlew $GRADLE_ARGS \\
    --parallel \\
    --no-daemon \\
    -x integrationTest \\
    -x contractTest \\
    -Dorg.gradle.console=plain \\
    2>&1 | tail -50; then

    echo ""
    echo -e "\${GREEN}╔══════════════════════════════════════════════╗\${NC}"
    echo -e "\${GREEN}║  ✓ All pre-push checks passed                ║\${NC}"
    echo -e "\${GREEN}╚══════════════════════════════════════════════╝\${NC}"
    echo ""
    echo -e "\${CYAN}  Checkstyle:    ✓ passed\${NC}"
    echo -e "\${CYAN}  ktlint:        ✓ passed\${NC}"
    echo -e "\${CYAN}  SpotBugs:      ✓ passed\${NC}"
    echo -e "\${CYAN}  Unit tests:    ✓ passed\${NC}"
    echo -e "\${CYAN}  JaCoCo (≥80%): ✓ passed\${NC}"
    echo -e "\${CYAN}  Secrets scan:  ✓ passed\${NC}"
    echo ""
    echo -e "\${YELLOW}  Note: Integration tests (Testcontainers) and contract tests (Pact)\${NC}"
    echo -e "\${YELLOW}  will run in the CI pipeline after push.\${NC}"
    exit 0
else
    EXIT_CODE=$?
    echo ""
    echo -e "\${RED}╔══════════════════════════════════════════════╗\${NC}"
    echo -e "\${RED}║  ✗ Pre-push checks FAILED — push blocked     ║\${NC}"
    echo -e "\${RED}╚══════════════════════════════════════════════╝\${NC}"
    echo ""
    echo -e "\${YELLOW}  Common fixes:\${NC}"
    echo -e "\${YELLOW}    Checkstyle:  ./gradlew checkstyleMain checkstyleTest\${NC}"
    echo -e "\${YELLOW}    ktlint:      ./gradlew ktlintFormat\${NC}"
    echo -e "\${YELLOW}    Tests:       ./gradlew test --info\${NC}"
    echo -e "\${YELLOW}    Coverage:    ./gradlew jacocoTestReport (check build/reports/jacoco/)\${NC}"
    echo -e "\${YELLOW}    SpotBugs:    ./gradlew spotbugsMain (check build/reports/spotbugs/)\${NC}"
    echo ""
    echo -e "\${YELLOW}  To bypass (emergencies only): git push --no-verify\${NC}"
    echo -e "\${RED}  Bypassing requires justification in the PR description.\${NC}"
    exit $EXIT_CODE
fi`,

  'install.sh': `#!/usr/bin/env bash
set -euo pipefail

REQUIRED_JAVA_VERSION="21"
REQUIRED_GRADLE_VERSION="8"
PROJECT_ROOT="$(cd "$(dirname "\${BASH_SOURCE[0]}")" && pwd)"
PLUGIN_DIR="plugin/codeforge-spring-boot-microservices"
CLAUDE_DIR=".claude"
RED='\\033[0;31m'
GREEN='\\033[0;32m'
YELLOW='\\033[1;33m'
NC='\\033[0m'

info()  { echo -e "\${GREEN}[✓]\${NC} $1"; }
warn()  { echo -e "\${YELLOW}[!]\${NC} $1"; }
fail()  { echo -e "\${RED}[✗]\${NC} $1"; exit 1; }

echo "━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━"
echo " Spring Boot Microservices — Project Installer"
echo "━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━"

# ── Verify Java 21 ──────────────────────────────────
if ! command -v java &>/dev/null; then
  fail "Java not found. Install JDK \${REQUIRED_JAVA_VERSION} (Eclipse Temurin recommended)."
fi
JAVA_VER=$(java -version 2>&1 | head -1 | sed -E 's/.*"([0-9]+).*/\\1/')
if [[ "$JAVA_VER" -lt "$REQUIRED_JAVA_VERSION" ]]; then
  fail "Java \${REQUIRED_JAVA_VERSION} required, found Java \${JAVA_VER}. Set JAVA_HOME to a JDK 21 installation."
fi
info "Java \${JAVA_VER} detected"

# ── Verify Gradle wrapper ───────────────────────────
if [[ ! -f "\${PROJECT_ROOT}/gradlew" ]]; then
  fail "Gradle wrapper not found. Run 'gradle wrapper --gradle-version 8.5' first."
fi
GRADLE_VER=$("\${PROJECT_ROOT}/gradlew" --version 2>/dev/null | grep -oP 'Gradle \\K[0-9]+' || echo "0")
if [[ "$GRADLE_VER" -lt "$REQUIRED_GRADLE_VERSION" ]]; then
  fail "Gradle \${REQUIRED_GRADLE_VERSION}+ required, found major version \${GRADLE_VER}."
fi
info "Gradle \${GRADLE_VER}.x detected via wrapper"

# ── Verify Docker ────────────────────────────────────
if command -v docker &>/dev/null; then
  info "Docker $(docker --version | grep -oP '[0-9]+\\.[0-9]+\\.[0-9]+')"
else
  warn "Docker not found — required for Testcontainers integration tests and image builds"
fi

# ── Verify kubectl & helm (optional) ────────────────
command -v kubectl &>/dev/null && info "kubectl available" || warn "kubectl not found — needed for K8s deployments"
command -v helm &>/dev/null    && info "Helm available"    || warn "Helm not found — needed for chart deployments"

# ── Configure .claude/ directory ─────────────────────
info "Configuring \${CLAUDE_DIR}/"
mkdir -p "\${PROJECT_ROOT}/\${CLAUDE_DIR}"

if [[ ! -f "\${PROJECT_ROOT}/\${CLAUDE_DIR}/settings.json" ]]; then
  cat > "\${PROJECT_ROOT}/\${CLAUDE_DIR}/settings.json" <<'SETTINGS'
{
  "project": "spring-boot-microservices",
  "plugin": "codeforge-spring-boot-microservices",
  "permissions": {
    "allow": [
      "Bash(./gradlew:*)",
      "Bash(docker:*)",
      "Bash(kubectl:*)",
      "Bash(helm:*)",
      "Read(*)",
      "Write(services/**)",
      "Write(shared/**)",
      "Write(tests/**)",
      "Write(docs/**)"
    ],
    "deny": [
      "Write(infrastructure/production/**)",
      "Write(**/security/**)",
      "Write(**/auth/**)",
      "Write(*.properties)"
    ]
  }
}
SETTINGS
  info "Created \${CLAUDE_DIR}/settings.json"
else
  info "\${CLAUDE_DIR}/settings.json already exists — skipping"
fi

# ── Install plugin ───────────────────────────────────
if [[ -d "\${PROJECT_ROOT}/\${PLUGIN_DIR}" ]]; then
  info "Plugin directory \${PLUGIN_DIR}/ found"
  if [[ -f "\${PROJECT_ROOT}/\${PLUGIN_DIR}/manifest.json" ]]; then
    info "Plugin manifest verified"
  else
    warn "Plugin manifest.json missing in \${PLUGIN_DIR}/ — commands may not load"
  fi
else
  warn "Plugin directory \${PLUGIN_DIR}/ not found — create it to enable Claude Code commands"
  mkdir -p "\${PROJECT_ROOT}/\${PLUGIN_DIR}"
  info "Created \${PLUGIN_DIR}/"
fi

# ── Git hooks ────────────────────────────────────────
HOOKS_DIR="\${PROJECT_ROOT}/.git/hooks"
if [[ -d "\${PROJECT_ROOT}/.git" ]]; then
  mkdir -p "$HOOKS_DIR"

  cat > "\${HOOKS_DIR}/pre-commit" <<'HOOK'
#!/usr/bin/env bash
set -euo pipefail
echo "[pre-commit] Running Checkstyle and ktlint..."
./gradlew checkstyleMain ktlintCheck --parallel --quiet 2>/dev/null || {
  echo "❌ Lint checks failed. Run './gradlew checkstyleMain ktlintCheck' to see details."
  exit 1
}
echo "[pre-commit] Checking for secrets in staged files..."
if git diff --cached --name-only | xargs grep -lE '(password|secret|api[_-]?key)\\s*=' 2>/dev/null; then
  echo "❌ Potential secrets detected in staged files. Remove before committing (SOC 2 / PCI DSS)."
  exit 1
fi
HOOK
  chmod +x "\${HOOKS_DIR}/pre-commit"

  cat > "\${HOOKS_DIR}/commit-msg" <<'HOOK'
#!/usr/bin/env bash
set -euo pipefail
PATTERN='^(feat|fix|chore|docs|refactor|test|perf|ci|build|revert)(\\(.+\\))?: .{1,100}'
MSG=$(head -1 "$1")
if ! echo "$MSG" | grep -qE "$PATTERN"; then
  echo "❌ Commit message must follow Conventional Commits: type(scope): description"
  echo "   Types: feat, fix, chore, docs, refactor, test, perf, ci, build, revert"
  echo "   Got: $MSG"
  exit 1
fi
HOOK
  chmod +x "\${HOOKS_DIR}/commit-msg"

  cat > "\${HOOKS_DIR}/pre-push" <<'HOOK'
#!/usr/bin/env bash
set -euo pipefail
echo "[pre-push] Running unit tests..."
./gradlew test --parallel --quiet || {
  echo "❌ Unit tests failed. Fix before pushing."
  exit 1
}
echo "[pre-push] Running JaCoCo coverage check (80% threshold)..."
./gradlew jacocoTestCoverageVerification --quiet 2>/dev/null || {
  echo "❌ Code coverage below 80% threshold."
  exit 1
}
HOOK
  chmod +x "\${HOOKS_DIR}/pre-push"
  info "Git hooks installed (pre-commit, commit-msg, pre-push)"
else
  warn "Not a git repository — skipping hook installation. Run 'git init' first."
fi

# ── Verify GPG for signed commits ────────────────────
if git config --get user.signingkey &>/dev/null; then
  info "GPG signing key configured"
else
  warn "No GPG signing key configured — signed commits are required. Run: git config user.signingkey <KEY_ID>"
fi

# ── Gradle dependency resolution warmup ──────────────
info "Resolving Gradle dependencies (this may take a moment on first run)..."
"\${PROJECT_ROOT}/gradlew" dependencies --quiet >/dev/null 2>&1 && info "Dependencies resolved" || warn "Dependency resolution had warnings — run './gradlew dependencies' for details"

echo ""
echo "━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━"
echo -e " \${GREEN}Setup complete.\${NC} Next steps:"
echo "  1. ./gradlew build              — compile all services"
echo "  2. ./gradlew test               — run unit tests"
echo "  3. docker compose up -d         — start Kafka, PostgreSQL, Redis"
echo "  4. ./gradlew bootRun -p services/order-service  — run a service"
echo "━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━"`,

  'mock-mcp-servers/README.md': `# Mock MCP Servers for Spring Boot Microservices

Local mock implementations of MCP (Model Context Protocol) servers used by Claude Code in this project. These servers simulate external tool integrations (GitHub, Jira) so developers can work with Claude Code without requiring live API credentials or network access.

## Overview

| Server | File | Port | Simulates |
|--------|------|------|-----------|
| GitHub | \`github-server.mjs\` | stdio | GitHub API — PRs, reviews, CODEOWNERS, branch protection |
| Jira | \`jira-server.mjs\` | stdio | Jira API — ticket lookup, status transitions, sprint data |

These servers are referenced in the root [\`.mcp.json\`](../.mcp.json) configuration and are automatically used by Claude Code when running in this repository.

## Prerequisites

- **Node.js** >= 18.x (for ES module support)
- **npm** >= 9.x

Verify your setup:

\`\`\`bash
node --version   # v18.0.0+
npm --version    # 9.0.0+
\`\`\`

## Setup

\`\`\`bash
cd mock-mcp-servers
npm install
\`\`\`

This installs the \`@modelcontextprotocol/sdk\` dependency used by both servers.

## Running Servers

The servers communicate over **stdio** (stdin/stdout) as required by the MCP protocol. They are launched automatically by Claude Code based on the \`.mcp.json\` configuration — you do not need to start them manually.

To test a server directly:

\`\`\`bash
# GitHub mock server
node github-server.mjs

# Jira mock server
node jira-server.mjs
\`\`\`

Each server will listen on stdin for JSON-RPC messages and respond on stdout.

## Available Tools

### GitHub Server (\`github-server.mjs\`)

| Tool | Description | Parameters |
|------|-------------|------------|
| \`get_pull_request\` | Fetch PR details by number | \`owner\`, \`repo\`, \`pull_number\` |
| \`create_pull_request\` | Create a new PR | \`owner\`, \`repo\`, \`title\`, \`body\`, \`head\`, \`base\` |
| \`list_pull_request_reviews\` | List reviews on a PR | \`owner\`, \`repo\`, \`pull_number\` |
| \`get_codeowners\` | Get CODEOWNERS for a file path | \`owner\`, \`repo\`, \`path\` |
| \`get_branch_protection\` | Get branch protection rules | \`owner\`, \`repo\`, \`branch\` |
| \`list_check_runs\` | List CI check runs for a ref | \`owner\`, \`repo\`, \`ref\` |

**Mock data notes:**

- PRs follow the project's branch naming convention: \`type/TICKET-desc\` (e.g., \`feat/PAY-123-add-payment-service\`)
- Branch protection rules reflect the project's requirements: 2 approvals, signed commits, required status checks
- CODEOWNERS mappings mirror the actual project structure (\`services/payment-service/**\` → \`@payment-team\`)
- Check runs simulate the CI pipeline stages: lint, compile, unit-tests, integration-tests, contract-tests, security-scan, docker-build

### Jira Server (\`jira-server.mjs\`)

| Tool | Description | Parameters |
|------|-------------|------------|
| \`get_issue\` | Fetch a Jira issue by key | \`issue_key\` |
| \`search_issues\` | Search issues with JQL | \`jql\`, \`max_results\` |
| \`transition_issue\` | Move issue to a new status | \`issue_key\`, \`transition_name\` |
| \`add_comment\` | Add a comment to an issue | \`issue_key\`, \`body\` |
| \`get_sprint\` | Get current sprint info | \`board_id\` |

**Mock data notes:**

- Issue keys use project prefixes matching our services: \`PAY-*\` (payment), \`ORD-*\` (order), \`USR-*\` (user), \`GW-*\` (gateway), \`INFRA-*\` (infrastructure)
- Issues include realistic fields: story points, sprint assignment, acceptance criteria, labels (e.g., \`pci-dss\`, \`soc2\`, \`kafka\`, \`breaking-change\`)
- Transitions follow the workflow: \`To Do\` → \`In Progress\` → \`In Review\` → \`QA\` → \`Done\`
- Sprint data reflects a two-week cadence

## Mock Data Customization

Both servers contain inline mock data at the top of each file. To customize:

1. **Add new mock PRs or issues** — extend the data arrays in the respective server file
2. **Change team mappings** — update the CODEOWNERS map in \`github-server.mjs\`
3. **Modify CI checks** — edit the check runs list in \`github-server.mjs\`

Example — adding a new mock Jira issue:

\`\`\`javascript
// In jira-server.mjs, add to the issues map:
'PAY-456': {
  key: 'PAY-456',
  summary: 'Implement idempotent payment processing',
  status: 'In Progress',
  assignee: 'jane.doe',
  type: 'Story',
  priority: 'High',
  labels: ['pci-dss', 'kafka', 'payment-service'],
  storyPoints: 8,
  sprint: 'Sprint 24',
  acceptanceCriteria: [
    'Payment requests with duplicate idempotency keys return cached result',
    'Idempotency keys stored in Redis with 24h TTL',
    'PaymentProcessedEvent published to payment.events topic'
  ]
}
\`\`\`

## How Claude Code Uses These Servers

When Claude Code runs in this repository, it reads \`.mcp.json\` and spawns these servers as child processes. This enables Claude to:

1. **Look up Jira tickets** referenced in branch names or commit messages to understand requirements
2. **Check PR status** and review requirements before suggesting merge actions
3. **Validate CODEOWNERS** when suggesting reviewers for changes
4. **Verify CI pipeline** status for branches and PRs
5. **Understand sprint context** when prioritizing work

### Example interaction flow

\`\`\`
Developer: "Work on PAY-123"
  → Claude calls jira.get_issue({ issue_key: "PAY-123" })
  → Gets ticket details, acceptance criteria, labels
  → Understands this is a PCI DSS-relevant payment service change
  → Applies security rules from .claude/rules/common/security.md
  → Suggests branch: feat/PAY-123-add-payment-retry
\`\`\`

## Switching to Live Servers

When ready to connect to real GitHub and Jira APIs, update \`.mcp.json\` to point to production MCP server implementations:

\`\`\`json
{
  "mcpServers": {
    "github": {
      "command": "npx",
      "args": ["@modelcontextprotocol/server-github"],
      "env": {
        "GITHUB_PERSONAL_ACCESS_TOKEN": "\${GITHUB_TOKEN}"
      }
    },
    "jira": {
      "command": "npx",
      "args": ["@modelcontextprotocol/server-jira"],
      "env": {
        "JIRA_BASE_URL": "\${JIRA_BASE_URL}",
        "JIRA_API_TOKEN": "\${JIRA_API_TOKEN}"
      }
    }
  }
}
\`\`\`

> **Note:** Never commit real API tokens. Use environment variables or a secrets manager. See \`.claude/rules/common/security.md\` for credential handling policies.

## Troubleshooting

| Issue | Solution |
|-------|----------|
| \`ERR_MODULE_NOT_FOUND\` | Run \`npm install\` in \`mock-mcp-servers/\` |
| Server not responding | Ensure Node.js >= 18; check that \`.mcp.json\` paths are correct |
| Claude not using tools | Verify \`.claude/settings.json\` has MCP permissions enabled |
| Stale mock data | Update inline data in the server files; no restart needed (Claude spawns fresh processes) |

## Related Files

- [\`../.mcp.json\`](../.mcp.json) — MCP server configuration
- [\`../.claude/settings.json\`](../.claude/settings.json) — Claude Code permissions including MCP tool access
- [\`../CLAUDE.md\`](../CLAUDE.md) — Project-level Claude Code instructions
- [\`../.claude/rules/common/security.md\`](../.claude/rules/common/security.md) — Security rules (credential handling)`,

  'mock-mcp-servers/github-server.mjs': `import { createServer } from 'node:http';

const PORT = process.env.MOCK_GITHUB_PORT || 3102;

const mockRepos = {
  'spring-boot-microservices': {
    full_name: 'fintech-org/spring-boot-microservices',
    default_branch: 'main',
    private: true,
    language: 'Java',
    topics: ['spring-boot', 'microservices', 'kafka', 'kubernetes', 'fintech'],
  },
};

const mockPRs = [
  {
    number: 142, title: 'feat(payment-service): add idempotency key support',
    branch: 'feat/PAY-312-idempotency-keys', state: 'open', author: 'dev-senior-1',
    labels: ['payment-service', 'feature'], reviewers: ['lead-1', 'senior-2'],
    checks: { lint: 'pass', compile: 'pass', unit_tests: 'pass', integration_tests: 'pass', security_scan: 'pass' },
    files_changed: ['services/payment-service/src/main/java/com/fintech/payment/domain/IdempotencyKey.java',
      'services/payment-service/src/main/java/com/fintech/payment/adapter/in/PaymentController.java',
      'services/payment-service/src/test/java/com/fintech/payment/domain/IdempotencyKeyTest.java'],
  },
  {
    number: 143, title: 'fix(order-service): correct Kafka consumer offset commit',
    branch: 'fix/ORD-287-offset-commit', state: 'open', author: 'dev-mid-3',
    labels: ['order-service', 'bugfix', 'kafka'], reviewers: ['senior-1'],
    checks: { lint: 'pass', compile: 'pass', unit_tests: 'pass', integration_tests: 'running', security_scan: 'pending' },
    files_changed: ['services/order-service/src/main/java/com/fintech/order/adapter/in/kafka/OrderEventConsumer.java',
      'services/order-service/src/main/resources/application-prod.yml'],
  },
  {
    number: 140, title: 'chore: upgrade Spring Boot to 3.2.5',
    branch: 'chore/INFRA-91-spring-boot-upgrade', state: 'merged', author: 'lead-1',
    labels: ['infrastructure', 'dependencies'], reviewers: ['lead-2', 'senior-1', 'senior-3'],
    checks: { lint: 'pass', compile: 'pass', unit_tests: 'pass', integration_tests: 'pass', security_scan: 'pass', contract_tests: 'pass' },
    files_changed: ['build.gradle.kts', 'gradle/libs.versions.toml'],
  },
];

const mockIssues = [
  { number: 301, title: 'Implement distributed tracing correlation across Kafka consumers', labels: ['enhancement', 'observability'], assignee: 'senior-2', state: 'open', milestone: 'Q3-2024' },
  { number: 298, title: 'PCI DSS: rotate database credentials via Vault integration', labels: ['security', 'pci-dss', 'infrastructure'], assignee: 'lead-1', state: 'open', milestone: 'Q3-2024' },
  { number: 295, title: 'Flaky Testcontainers test in user-service CI', labels: ['bug', 'ci', 'user-service'], assignee: 'mid-2', state: 'open', milestone: null },
];

const mockCodeowners = \`* @fintech-org/backend-leads
services/payment-service/** @fintech-org/payment-team @fintech-org/backend-leads
services/order-service/** @fintech-org/order-team @fintech-org/backend-leads
services/user-service/** @fintech-org/user-team @fintech-org/backend-leads
**/security/** @fintech-org/security-team
**/auth/** @fintech-org/security-team
infrastructure/production/** @fintech-org/platform-team @fintech-org/backend-leads
charts/** @fintech-org/platform-team
schema-registry/** @fintech-org/backend-leads
*.properties @fintech-org/security-team\`;

const mockBranchProtection = {
  main: { required_reviews: 2, require_signed_commits: true, enforce_admins: true,
    required_checks: ['lint', 'compile', 'unit_tests', 'integration_tests', 'contract_tests', 'security_scan'] },
  'release/*': { required_reviews: 2, require_signed_commits: true, enforce_admins: true,
    required_checks: ['lint', 'compile', 'unit_tests', 'integration_tests', 'contract_tests', 'security_scan', 'e2e_tests'] },
};

const tools = {
  list_pull_requests: ({ state = 'open', service } = {}) => {
    let results = mockPRs.filter(pr => state === 'all' || pr.state === state);
    if (service) results = results.filter(pr => pr.labels.includes(service));
    return results.map(({ number, title, branch, state: s, author, labels, checks }) =>
      ({ number, title, branch, state: s, author, labels, checks_summary: Object.entries(checks).map(([k, v]) => \`\${k}:\${v}\`).join(', ') }));
  },
  get_pull_request: ({ pr_number }) => {
    const pr = mockPRs.find(p => p.number === pr_number);
    return pr || { error: \`PR #\${pr_number} not found\` };
  },
  create_pull_request: ({ title, branch, base = 'main', body = '' }) => {
    const number = Math.max(...mockPRs.map(p => p.number)) + 1;
    return { number, title, branch, base, state: 'open', url: \`https://github.com/fintech-org/spring-boot-microservices/pull/\${number}\`,
      message: \`PR #\${number} created. Requires 2 approvals, signed commits, and all CI checks passing.\` };
  },
  list_issues: ({ state = 'open', label } = {}) => {
    let results = mockIssues.filter(i => state === 'all' || i.state === state);
    if (label) results = results.filter(i => i.labels.includes(label));
    return results;
  },
  get_repo_info: () => mockRepos['spring-boot-microservices'],
  get_codeowners: () => ({ content: mockCodeowners }),
  get_branch_protection: ({ branch = 'main' }) => {
    const rule = mockBranchProtection[branch];
    return rule || { error: \`No protection rules for branch: \${branch}\` };
  },
  get_check_runs: ({ pr_number }) => {
    const pr = mockPRs.find(p => p.number === pr_number);
    if (!pr) return { error: \`PR #\${pr_number} not found\` };
    return { pr: pr.number, checks: Object.entries(pr.checks).map(([name, status]) =>
      ({ name, status, conclusion: status === 'pass' ? 'success' : status === 'fail' ? 'failure' : status })) };
  },
  list_files_changed: ({ pr_number }) => {
    const pr = mockPRs.find(p => p.number === pr_number);
    if (!pr) return { error: \`PR #\${pr_number} not found\` };
    const sensitive = pr.files_changed.filter(f => f.includes('/security/') || f.includes('/auth/') || f.includes('production/') || f.endsWith('.properties'));
    return { files: pr.files_changed, sensitive_files: sensitive, requires_security_review: sensitive.length > 0 };
  },
  search_code: ({ query, path }) => {
    const results = [
      { file: 'services/payment-service/src/main/java/com/fintech/payment/domain/Payment.java', matches: 1 },
      { file: 'shared/domain-events/src/main/java/com/fintech/events/PaymentCompletedEvent.java', matches: 1 },
    ];
    return { query, path: path || '**', total_count: results.length, items: results };
  },
};

const server = createServer((req, res) => {
  if (req.method !== 'POST') {
    res.writeHead(405, { 'Content-Type': 'application/json' });
    res.end(JSON.stringify({ error: 'Method not allowed. Use POST with JSON-RPC.' }));
    return;
  }
  let body = '';
  req.on('data', chunk => { body += chunk; });
  req.on('end', () => {
    try {
      const { jsonrpc, id, method, params = {} } = JSON.parse(body);
      if (method === 'initialize') {
        res.writeHead(200, { 'Content-Type': 'application/json' });
        res.end(JSON.stringify({ jsonrpc: '2.0', id, result: { name: 'mock-github-server', version: '1.0.0', capabilities: { tools: {} } } }));
        return;
      }
      if (method === 'tools/list') {
        const toolList = Object.keys(tools).map(name => ({ name, description: \`Mock GitHub: \${name.replace(/_/g, ' ')}\` }));
        res.writeHead(200, { 'Content-Type': 'application/json' });
        res.end(JSON.stringify({ jsonrpc: '2.0', id, result: { tools: toolList } }));
        return;
      }
      if (method === 'tools/call') {
        const { name, arguments: args = {} } = params;
        const handler = tools[name];
        if (!handler) {
          res.writeHead(200, { 'Content-Type': 'application/json' });
          res.end(JSON.stringify({ jsonrpc: '2.0', id, error: { code: -32601, message: \`Unknown tool: \${name}\` } }));
          return;
        }
        const result = handler(args);
        res.writeHead(200, { 'Content-Type': 'application/json' });
        res.end(JSON.stringify({ jsonrpc: '2.0', id, result: { content: [{ type: 'text', text: JSON.stringify(result, null, 2) }] } }));
        return;
      }
      res.writeHead(200, { 'Content-Type': 'application/json' });
      res.end(JSON.stringify({ jsonrpc: '2.0', id, error: { code: -32601, message: \`Unknown method: \${method}\` } }));
    } catch (e) {
      res.writeHead(400, { 'Content-Type': 'application/json' });
      res.end(JSON.stringify({ jsonrpc: '2.0', id: null, error: { code: -32700, message: 'Parse error' } }));
    }
  });
});

server.listen(PORT, () => {
  console.log(\`Mock GitHub MCP server running on http://localhost:\${PORT}\`);
  console.log(\`Tools: \${Object.keys(tools).join(', ')}\`);
});`,

  'mock-mcp-servers/jira-server.mjs': `import { createServer } from 'http';

const PORT = process.env.JIRA_MCP_PORT || 3401;

const tickets = {
  'PAY-123': {
    key: 'PAY-123',
    summary: 'Implement payment processing Kafka consumer',
    type: 'Story',
    status: 'In Progress',
    priority: 'High',
    assignee: 'dev.senior@company.com',
    reporter: 'lead.architect@company.com',
    storyPoints: 8,
    sprint: 'Sprint 24',
    labels: ['payment-service', 'kafka', 'pci-dss'],
    components: ['payment-service'],
    description: 'Implement Kafka consumer in payment-service to handle OrderPlacedEvent from order-service. Must validate payment details, process via payment gateway adapter, and publish PaymentCompletedEvent or PaymentFailedEvent. All card data handling must comply with PCI DSS requirements. Use hexagonal architecture — payment gateway is an outbound port.',
    acceptanceCriteria: [
      'Consumer listens on orders.placed topic with payment-service consumer group',
      'Payment processing uses PaymentGatewayPort (outbound adapter pattern)',
      'Publishes PaymentCompletedEvent to payments.completed topic on success',
      'Publishes PaymentFailedEvent to payments.failed topic on failure',
      'Idempotent processing using event ID deduplication in Redis',
      'Integration test with Testcontainers (Kafka + PostgreSQL + Redis)',
      'No raw card numbers logged — PCI DSS compliance',
      'JaCoCo coverage >= 80% for new code'
    ],
    subtasks: [
      { key: 'PAY-124', summary: 'Define PaymentCompletedEvent Avro schema', status: 'Done', storyPoints: 2 },
      { key: 'PAY-125', summary: 'Implement PaymentGatewayPort and Stripe adapter', status: 'In Progress', storyPoints: 5 },
      { key: 'PAY-126', summary: 'Add Pact contract test for payment events', status: 'To Do', storyPoints: 3 }
    ],
    created: '2024-11-18T09:00:00Z',
    updated: '2024-11-20T14:30:00Z'
  },
  'ORD-456': {
    key: 'ORD-456',
    summary: 'Add order validation before publishing OrderPlacedEvent',
    type: 'Story',
    status: 'To Do',
    priority: 'Medium',
    assignee: 'dev.mid@company.com',
    reporter: 'lead.architect@company.com',
    storyPoints: 5,
    sprint: 'Sprint 24',
    labels: ['order-service', 'kafka', 'validation'],
    components: ['order-service'],
    description: 'Add domain validation in order-service before publishing OrderPlacedEvent to orders.placed Kafka topic. Validate inventory availability via cached data in Redis, validate user status, and ensure order total calculations are correct. Follow hexagonal architecture with validation as a domain service.',
    acceptanceCriteria: [
      'OrderValidationService validates inventory, user status, and totals',
      'Validation errors return structured error response via API gateway',
      'OrderPlacedEvent only published after successful validation',
      'Redis cache lookup for inventory with fallback to inventory-service event log',
      'Unit tests with JUnit 5 + Mockito for validation logic',
      'Integration test with Testcontainers for full flow'
    ],
    subtasks: [],
    created: '2024-11-19T11:00:00Z',
    updated: '2024-11-19T11:00:00Z'
  },
  'USR-789': {
    key: 'USR-789',
    summary: 'Implement user registration with SOC 2 audit logging',
    type: 'Story',
    status: 'In Review',
    priority: 'High',
    assignee: 'dev.senior2@company.com',
    reporter: 'security.lead@company.com',
    storyPoints: 8,
    sprint: 'Sprint 24',
    labels: ['user-service', 'security', 'soc2', 'audit'],
    components: ['user-service'],
    description: 'Implement user registration endpoint in user-service with full SOC 2 audit trail. All registration events must be logged to audit log table and published as UserRegisteredEvent to users.registered Kafka topic. Passwords must be hashed with bcrypt. PII fields encrypted at rest in PostgreSQL.',
    acceptanceCriteria: [
      'POST /api/v1/users/register endpoint via API gateway',
      'Password hashed with BCryptPasswordEncoder (Spring Security)',
      'PII fields (email, phone) encrypted at rest using JPA AttributeConverter',
      'Audit log entry created for every registration attempt (success and failure)',
      'UserRegisteredEvent published to users.registered topic',
      'Spring Security config blocks unauthenticated access to other user endpoints',
      'Checkstyle and SpotBugs pass with zero violations'
    ],
    subtasks: [],
    created: '2024-11-15T08:00:00Z',
    updated: '2024-11-21T10:15:00Z'
  },
  'INFRA-101': {
    key: 'INFRA-101',
    summary: 'Add Helm chart for payment-service with HPA',
    type: 'Task',
    status: 'To Do',
    priority: 'Medium',
    assignee: 'dev.lead@company.com',
    reporter: 'dev.lead@company.com',
    storyPoints: 3,
    sprint: 'Sprint 24',
    labels: ['infrastructure', 'helm', 'kubernetes'],
    components: ['infrastructure'],
    description: 'Create Helm chart in charts/payment-service/ with HorizontalPodAutoscaler, resource limits, health probes using Spring Actuator endpoints, and ConfigMap for Spring Profile configuration. Must include PodDisruptionBudget for production stability.',
    acceptanceCriteria: [
      'Helm chart in charts/payment-service/ with values.yaml per environment',
      'Liveness probe: /actuator/health/liveness, Readiness probe: /actuator/health/readiness',
      'HPA scales 2-10 replicas based on CPU 70% threshold',
      'PodDisruptionBudget minAvailable: 1',
      'ConfigMap sets SPRING_PROFILES_ACTIVE based on environment',
      'Secrets reference AWS Secrets Manager via External Secrets Operator'
    ],
    subtasks: [],
    created: '2024-11-20T16:00:00Z',
    updated: '2024-11-20T16:00:00Z'
  }
};

const sprint = {
  id: 24,
  name: 'Sprint 24',
  state: 'active',
  startDate: '2024-11-18T00:00:00Z',
  endDate: '2024-12-01T00:00:00Z',
  goal: 'Complete payment processing flow, user registration hardening, order validation',
  velocity: 34,
  committedPoints: 29,
  completedPoints: 10,
  tickets: Object.keys(tickets)
};

function handleRequest(req, res) {
  const url = new URL(req.url, \`http://localhost:\${PORT}\`);
  const path = url.pathname;
  res.setHeader('Content-Type', 'application/json');

  // GET /mcp/health
  if (path === '/mcp/health') {
    return respond(res, 200, { status: 'ok', server: 'jira-mcp-mock', project: 'spring-boot-microservices' });
  }

  // GET /mcp/ticket/:key
  const ticketMatch = path.match(/^\\/mcp\\/ticket\\/([A-Z]+-\\d+)$/);
  if (ticketMatch) {
    const ticket = tickets[ticketMatch[1]];
    if (!ticket) return respond(res, 404, { error: \`Ticket \${ticketMatch[1]} not found\` });
    return respond(res, 200, ticket);
  }

  // GET /mcp/sprint/current
  if (path === '/mcp/sprint/current') {
    return respond(res, 200, sprint);
  }

  // GET /mcp/search?component=X&status=Y&label=Z
  if (path === '/mcp/search') {
    const component = url.searchParams.get('component');
    const status = url.searchParams.get('status');
    const label = url.searchParams.get('label');
    let results = Object.values(tickets);
    if (component) results = results.filter(t => t.components.includes(component));
    if (status) results = results.filter(t => t.status.toLowerCase() === status.toLowerCase());
    if (label) results = results.filter(t => t.labels.includes(label));
    return respond(res, 200, { total: results.length, issues: results.map(summarize) });
  }

  // GET /mcp/velocity
  if (path === '/mcp/velocity') {
    return respond(res, 200, {
      sprints: [
        { name: 'Sprint 22', committed: 26, completed: 24, velocity: 24 },
        { name: 'Sprint 23', committed: 30, completed: 28, velocity: 28 },
        { name: 'Sprint 24', committed: sprint.committedPoints, completed: sprint.completedPoints, velocity: null }
      ],
      averageVelocity: 26
    });
  }

  return respond(res, 404, { error: 'Unknown endpoint', availableEndpoints: [
    'GET /mcp/health',
    'GET /mcp/ticket/:key',
    'GET /mcp/sprint/current',
    'GET /mcp/search?component=&status=&label=',
    'GET /mcp/velocity'
  ]});
}

function summarize(ticket) {
  return {
    key: ticket.key,
    summary: ticket.summary,
    type: ticket.type,
    status: ticket.status,
    priority: ticket.priority,
    storyPoints: ticket.storyPoints,
    assignee: ticket.assignee,
    components: ticket.components
  };
}

function respond(res, status, body) {
  res.writeHead(status);
  res.end(JSON.stringify(body, null, 2));
}

const server = createServer(handleRequest);
server.listen(PORT, () => {
  console.log(\`[Jira MCP Mock] Listening on port \${PORT}\`);
  console.log(\`[Jira MCP Mock] Tickets: \${Object.keys(tickets).join(', ')}\`);
  console.log(\`[Jira MCP Mock] Active sprint: \${sprint.name}\`);
});`,

  'mock-mcp-servers/package.json': `{
  "name": "@spring-boot-microservices/mock-mcp-servers",
  "version": "1.0.0",
  "private": true,
  "description": "Mock MCP servers for local development and testing of Claude Code integrations",
  "type": "module",
  "engines": {
    "node": ">=20.0.0"
  },
  "scripts": {
    "start": "concurrently \\"npm run start:jira\\" \\"npm run start:github\\" \\"npm run start:confluence\\" \\"npm run start:slack\\" \\"npm run start:prometheus\\"",
    "start:jira": "node src/jira-server.mjs",
    "start:github": "node src/github-server.mjs",
    "start:confluence": "node src/confluence-server.mjs",
    "start:slack": "node src/slack-server.mjs",
    "start:prometheus": "node src/prometheus-server.mjs",
    "test": "vitest run",
    "test:watch": "vitest",
    "lint": "eslint src/",
    "seed": "node scripts/seed-data.mjs",
    "seed:jira": "node scripts/seed-jira-tickets.mjs",
    "seed:services": "node scripts/seed-service-catalog.mjs"
  },
  "dependencies": {
    "@modelcontextprotocol/sdk": "^1.0.0",
    "zod": "^3.22.4"
  },
  "devDependencies": {
    "concurrently": "^8.2.2",
    "eslint": "^9.0.0",
    "vitest": "^2.0.0"
  },
  "keywords": [
    "mcp",
    "mock",
    "claude-code",
    "spring-boot",
    "microservices",
    "jira",
    "github",
    "confluence"
  ]
}`,

  'playbook/PLAYBOOK.md': `# Development Playbook — Spring Boot Microservices Platform

## Purpose

This playbook defines the structured development methodology for the spring-boot-microservices platform. Every feature, service, and infrastructure change follows these 7 phases to ensure quality, security, compliance (SOC 2, PCI DSS), and architectural consistency across the team.

Each phase has explicit entry criteria, activities, exit criteria, and verification gates. Claude Code assists at every phase through the CodeForge plugin — use \`/phase <number>\` to activate phase-specific guidance.

---

## How to Use This Playbook

1. **Start every ticket** by running \`/plan\` to generate a phase-aware implementation plan
2. **Progress through phases sequentially** — skipping phases requires lead approval
3. **Run \`/verify\`** at each phase gate before advancing
4. **Reference phase-specific docs** linked in each section below
5. **Claude Code enforces** phase awareness — it will remind you if you're working outside your current phase

### Quick Reference

| Phase | Name | Typical Duration | Key Output |
|-------|------|-----------------|------------|
| 1 | Understand | 1-2 hours | Requirements summary, questions resolved |
| 2 | Design | 2-4 hours | Technical design, ADR if needed |
| 3 | Scaffold | 30-60 min | Module structure, interfaces, schemas |
| 4 | Implement (TDD) | 1-3 days | Production code with passing tests |
| 5 | Integrate | 2-4 hours | Integration tests, Kafka contracts verified |
| 6 | Review & Harden | 2-4 hours | Security review, compliance check, PR ready |
| 7 | Ship | 1-2 hours | Merged, deployed to staging, monitored |

---

## Phase 1: Understand

**Goal**: Fully understand the requirements, domain context, and system impact before writing any code.

**Entry Criteria**:
- Jira ticket assigned and in "In Progress"
- Ticket has acceptance criteria defined

**Activities**:

1. **Read the ticket thoroughly** — acceptance criteria, linked tickets, attachments
2. **Identify the bounded context** — which microservice(s) does this touch?
   - \`services/order-service/\` — Order lifecycle, fulfillment
   - \`services/payment-service/\` — Payment processing, refunds (PCI DSS scope)
   - \`services/user-service/\` — Identity, profiles, preferences
   - \`gateway/\` — Routing, rate limiting, authentication
   - \`shared/\` — Cross-cutting domain events, DTOs
3. **Map the event flow** — what Kafka events are produced/consumed?
4. **Identify data changes** — new tables, columns, migrations needed?
5. **Check compliance impact** — does this touch PCI DSS scope (payment data, card info)?
6. **Ask clarifying questions** — post in the Jira ticket or Slack channel
7. **Review related ADRs** in \`docs/adr/\` for prior architectural decisions

**Claude Code Usage**:
\`\`\`
/plan                    # Generates implementation plan from ticket context
/phase 1                 # Activates Phase 1 guidance
\`\`\`

**Exit Criteria**:
- [ ] Requirements are unambiguous — no open questions blocking design
- [ ] Affected services and Kafka topics identified
- [ ] Compliance scope determined (PCI DSS / SOC 2 impact noted)
- [ ] Implementation plan generated and reviewed

**Verification**: \`/verify\` checks that a plan file exists and requirements are documented.

→ Detailed guide: [playbook/phases/01-understand.md](phases/01-understand.md)

---

## Phase 2: Design

**Goal**: Produce a technical design that follows hexagonal architecture, defines event schemas, and addresses cross-cutting concerns.

**Entry Criteria**:
- Phase 1 complete — requirements understood, plan exists

**Activities**:

1. **Design the domain model** following hexagonal architecture:
   \`\`\`
   services/<service-name>/
   ├── src/main/java/com/platform/<service>/
   │   ├── domain/           # Entities, Value Objects, Domain Events
   │   │   ├── model/        # Core domain classes
   │   │   ├── port/         # Inbound & outbound port interfaces
   │   │   └── service/      # Domain services
   │   ├── application/      # Use cases, command/query handlers
   │   ├── adapter/
   │   │   ├── inbound/      # REST controllers, Kafka consumers
   │   │   └── outbound/     # JPA repositories, Kafka producers, Redis
   │   └── config/           # Spring configuration, beans
   \`\`\`

2. **Define Kafka event schemas** — add Avro/JSON schemas to \`schema-registry/\`
   - Event naming: \`<bounded-context>.<entity>.<action>\` (e.g., \`payment.transaction.completed\`)
   - Include schema version, backward compatibility check
   - Define consumer groups: \`<service-name>-<purpose>-group\`

3. **Design database changes** — Flyway migration scripts
   - Each service owns its database — no cross-service DB access
   - Migration naming: \`V<version>__<description>.sql\`

4. **Define API contracts** — update OpenAPI spec in \`services/<service>/src/main/resources/openapi/\`

5. **Evaluate caching strategy** — Redis cache keys, TTLs, invalidation

6. **Write ADR if needed** — for significant architectural decisions
   - Template: \`docs/adr/NNNN-<title>.md\`
   - Required for: new services, new Kafka topics, new external integrations, security model changes

7. **Security design** — authentication/authorization flow, data encryption, audit logging

**Claude Code Usage**:
\`\`\`
/phase 2                 # Activates design-phase guidance
\`\`\`
Ask Claude to review your design against hexagonal architecture principles and the project's conventions.

**Exit Criteria**:
- [ ] Domain model designed with ports and adapters identified
- [ ] Kafka event schemas defined (if applicable)
- [ ] Database migration strategy documented
- [ ] API contract changes specified
- [ ] ADR written for significant decisions
- [ ] Security implications addressed
- [ ] Design reviewed by at least one senior/lead engineer

**Verification**: \`/verify\` checks for schema files, ADR presence (if flagged), and design doc completeness.

→ Detailed guide: [playbook/phases/02-design.md](phases/02-design.md)

---

## Phase 3: Scaffold

**Goal**: Create the structural skeleton — modules, interfaces, empty implementations, configuration — without business logic.

**Entry Criteria**:
- Phase 2 complete — design approved

**Activities**:

1. **Create or update Gradle module** (if new service):
   \`\`\`kotlin
   // settings.gradle.kts
   include("services:new-service")
   
   // services/new-service/build.gradle.kts
   plugins {
       id("org.springframework.boot")
       id("io.spring.dependency-management")
       java
   }
   dependencies {
       implementation(project(":shared:domain-events"))
       implementation("org.springframework.boot:spring-boot-starter-web")
       implementation("org.springframework.boot:spring-boot-starter-data-jpa")
       implementation("org.springframework.kafka:spring-kafka")
       // ... approved dependencies only
   }
   \`\`\`

2. **Create port interfaces** (domain layer):
   \`\`\`java
   // domain/port/inbound/ProcessPaymentUseCase.java
   public interface ProcessPaymentUseCase {
       PaymentResult process(ProcessPaymentCommand command);
   }
   
   // domain/port/outbound/PaymentRepository.java
   public interface PaymentRepository {
       Payment save(Payment payment);
       Optional<Payment> findById(PaymentId id);
   }
   \`\`\`

3. **Create adapter stubs** — empty implementations with \`// TODO: Phase 4\` markers

4. **Create Kafka event classes** in \`shared/domain-events/\`:
   \`\`\`java
   public record PaymentCompletedEvent(
       String eventId,
       String paymentId,
       BigDecimal amount,
       String currency,
       Instant occurredAt
   ) implements DomainEvent {}
   \`\`\`

5. **Create Flyway migration placeholders** — \`V1__create_<table>.sql\`

6. **Create Spring configuration classes** — profiles, bean definitions

7. **Create Dockerfile** (if new service):
   \`\`\`dockerfile
   FROM eclipse-temurin:21-jre-alpine
   # ... standard template
   \`\`\`

8. **Create Helm chart** (if new service) in \`charts/<service-name>/\`

9. **Verify compilation**: \`./gradlew :services:<service-name>:compileJava\`

**Claude Code Usage**:
\`\`\`
/phase 3                 # Activates scaffolding guidance
\`\`\`
Claude will generate scaffolding aligned with hexagonal architecture and project conventions.

**Exit Criteria**:
- [ ] Module compiles: \`./gradlew :services:<service-name>:compileJava\` passes
- [ ] Port interfaces defined
- [ ] Event classes created in shared module
- [ ] Configuration files created with Spring Profiles
- [ ] Dockerfile and Helm chart present (if new service)
- [ ] No business logic implemented yet

**Verification**: \`/verify\` runs compilation check and validates directory structure.

→ Detailed guide: [playbook/phases/03-scaffold.md](phases/03-scaffold.md)

---

## Phase 4: Implement (TDD)

**Goal**: Implement business logic using strict Test-Driven Development — Red → Green → Refactor.

**Entry Criteria**:
- Phase 3 complete — scaffold compiles, interfaces defined

**Activities**:

1. **Write a failing test first** (Red):
   \`\`\`java
   @ExtendWith(MockitoExtension.class)
   class PaymentDomainServiceTest {
       @Mock private PaymentRepository paymentRepository;
       @Mock private PaymentEventPublisher eventPublisher;
       @InjectMocks private PaymentDomainService service;
   
       @Test
       void shouldCompletePaymentAndPublishEvent() {
           // Given
           var command = new ProcessPaymentCommand("order-123", Money.of(99.99, "USD"));
           // When & Then — this fails because service is not implemented
           var result = service.process(command);
           assertThat(result.status()).isEqualTo(PaymentStatus.COMPLETED);
           verify(eventPublisher).publish(any(PaymentCompletedEvent.class));
       }
   }
   \`\`\`

2. **Write minimal code to pass** (Green):
   - Implement only what the test requires
   - No speculative code

3. **Refactor** — improve structure while keeping tests green:
   - Extract value objects
   - Apply domain patterns (Strategy, Specification, etc.)
   - Ensure method/class stays under 300 lines

4. **Repeat** for each behavior:
   - Domain services → Application use cases → Inbound adapters → Outbound adapters

5. **Test layering**:
   | Layer | Test Type | Tools | Speed |
   |-------|-----------|-------|-------|
   | Domain | Unit | JUnit 5, Mockito | Fast |
   | Application | Unit | JUnit 5, Mockito | Fast |
   | Adapter (inbound) | Integration | @WebMvcTest, MockMvc | Medium |
   | Adapter (outbound) | Integration | Testcontainers | Slower |
   | Kafka | Integration | EmbeddedKafka / Testcontainers | Slower |

6. **Run tests continuously**:
   \`\`\`bash
   ./gradlew :services:<service-name>:test                    # Unit tests
   ./gradlew :services:<service-name>:integrationTest         # Integration tests
   \`\`\`

7. **Check coverage**: \`./gradlew :services:<service-name>:jacocoTestReport\`
   - Minimum 80% line coverage
   - Domain layer should be >90%

**Claude Code Usage**:
\`\`\`
/tdd                     # Activates TDD cycle guidance
/phase 4                 # Phase-specific context
/build-fix               # If compilation or test failures occur
\`\`\`

**TDD Rules (Enforced)**:
- Never write production code without a failing test
- Each commit should have test + implementation together
- Commit messages: \`feat(payment): add payment processing logic\` (conventional commits)
- AI-generated code must be marked: \`// AI-GENERATED: Claude Code — reviewed by <developer>\`

**Exit Criteria**:
- [ ] All acceptance criteria covered by tests
- [ ] All tests pass: \`./gradlew :services:<service-name>:test\`
- [ ] Coverage ≥ 80%: verified via JaCoCo report
- [ ] No Checkstyle violations: \`./gradlew :services:<service-name>:checkstyleMain\`
- [ ] No SpotBugs findings: \`./gradlew :services:<service-name>:spotbugsMain\`
- [ ] All files under 300 lines
- [ ] Conventional commit messages used throughout

**Verification**: \`/verify\` runs full test suite, coverage check, linting, and static analysis.

→ Detailed guide: [playbook/phases/04-implement.md](phases/04-implement.md)

---

## Phase 5: Integrate

**Goal**: Verify the implementation works correctly with real infrastructure — databases, Kafka, Redis, other services.

**Entry Criteria**:
- Phase 4 complete — all unit tests passing, coverage met

**Activities**:

1. **Write integration tests with Testcontainers**:
   \`\`\`java
   @SpringBootTest
   @Testcontainers
   class PaymentServiceIntegrationTest {
       @Container
       static PostgreSQLContainer<?> postgres = new PostgreSQLContainer<>("postgres:15-alpine");
       @Container
       static KafkaContainer kafka = new KafkaContainer(DockerImageName.parse("confluentinc/cp-kafka:7.5.0"));
       @Container
       static GenericContainer<?> redis = new GenericContainer<>("redis:7-alpine").withExposedPorts(6379);
   
       @DynamicPropertySource
       static void configure(DynamicPropertyRegistry registry) {
           registry.add("spring.datasource.url", postgres::getJdbcUrl);
           registry.add("spring.kafka.bootstrap-servers", kafka::getBootstrapServers);
           registry.add("spring.data.redis.host", redis::getHost);
       }
   
       @Test
       void shouldProcessPaymentEndToEnd() {
           // Full flow: REST → Service → DB → Kafka event published
       }
   }
   \`\`\`

2. **Verify Kafka event contracts**:
   - Events serialize/deserialize correctly
   - Schema registry compatibility check
   - Consumer group offsets managed properly
   - Dead letter topic (DLT) handling works

3. **Run Pact contract tests** (if service exposes APIs consumed by others):
   \`\`\`bash
   ./gradlew :services:<service-name>:pactTest
   ./gradlew :services:<service-name>:pactPublish
   \`\`\`

4. **Verify database migrations**:
   \`\`\`bash
   ./gradlew :services:<service-name>:flywayMigrate  # Against Testcontainers PostgreSQL
   \`\`\`

5. **Test Spring Actuator health endpoints**:
   - \`/actuator/health\` — includes DB, Kafka, Redis health indicators
   - \`/actuator/info\` — service metadata
   - \`/actuator/prometheus\` — metrics endpoint

6. **Test with Spring Profiles**:
   - \`local\` — local development with Docker Compose
   - \`test\` — Testcontainers-based
   - \`staging\` — staging environment config
   - \`production\` — production config (never tested locally)

7. **Run full integration suite**:
   \`\`\`bash
   ./gradlew :services:<service-name>:integrationTest
   \`\`\`

**Claude Code Usage**:
\`\`\`
/phase 5                 # Activates integration-phase guidance
/build-fix               # For Testcontainers or Spring context issues
\`\`\`

**Exit Criteria**:
- [ ] Integration tests pass with Testcontainers (PostgreSQL, Kafka, Redis)
- [ ] Kafka event production and consumption verified
- [ ] Pact contract tests pass (if applicable)
- [ ] Database migrations apply cleanly
- [ ] Actuator health checks pass
- [ ] No flaky tests — all tests deterministic

**Verification**: \`/verify\` runs integration test suite and contract tests.

→ Detailed guide: [playbook/phases/05-integrate.md](phases/05-integrate.md)

---

## Phase 6: Review & Harden

**Goal**: Security review, compliance verification,`,

  'playbook/claude-overrides/01-discovery.claude.md': `# Phase 01: Discovery & Requirements — Claude Overrides

## Phase Purpose

Guide requirements gathering, user story creation, and NFR definition for Spring Boot microservices in a financial services context. Ensure Claude produces artifacts that are actionable for a hexagonal architecture with Kafka event streaming and Kubernetes deployment.

---

## DO

### Requirements Gathering

- **DO** ask clarifying questions about bounded context boundaries before proposing service decomposition
- **DO** identify which domain events will flow between services — name them concretely (e.g., \`PaymentInitiated\`, \`OrderConfirmed\`, \`UserKycVerified\`)
- **DO** map each requirement to a specific microservice module under \`services/\` (e.g., \`services/order-service\`, \`services/payment-service\`)
- **DO** capture data residency and encryption-at-rest requirements early — this is PCI DSS and SOC 2 critical
- **DO** distinguish between synchronous API requirements (exposed via \`gateway/\`) and asynchronous event requirements (routed through Kafka)
- **DO** reference Spring Boot 3.2 and Java 21 capabilities when discussing feasibility (virtual threads, pattern matching, record classes)
- **DO** identify which entities contain PCI-scoped data (cardholder data, PANs, CVVs) and flag them immediately
- **DO** produce requirements in a format that maps to Jira epics and stories — use ticket-ready language with acceptance criteria
- **DO** ask about expected throughput per service to inform Kafka partition counts and consumer group sizing
- **DO** capture multi-timezone operational requirements (Europe + Americas) for SLA definitions and maintenance windows

### User Stories

- **DO** write user stories that reference specific Spring Boot modules and Kafka topics
- **DO** include technical acceptance criteria that mention testability: "Verified by JUnit 5 unit test" or "Verified by Testcontainers integration test"
- **DO** tag stories with the target service name: \`[order-service]\`, \`[payment-service]\`, \`[user-service]\`, \`[gateway]\`
- **DO** include a "Domain Events" section in each epic listing the Avro/JSON schemas that must exist in \`schema-registry/\`
- **DO** define NFRs with measurable thresholds: latency p99 < 200ms, availability 99.95%, recovery time < 15 minutes

### Architecture Context

- **DO** reference hexagonal architecture when discussing how requirements map to ports and adapters
- **DO** identify which requirements need a new inbound port (REST controller, Kafka consumer) vs. outbound port (repository, Kafka producer, external API client)
- **DO** capture database-per-service boundaries — each service owns its PostgreSQL schema exclusively
- **DO** note where Redis caching or session management is required and estimate cache invalidation strategies
- **DO** reference the \`shared/\` module for cross-cutting concerns like domain event DTOs and common value objects

---

## DON'T

### Requirements Anti-Patterns

- **DON'T** propose direct REST calls between microservices — all inter-service communication goes through Kafka topics
- **DON'T** suggest a shared database or shared schema between services — each service under \`services/\` owns its own PostgreSQL database
- **DON'T** create requirements that assume synchronous request-reply between services unless routed through the API gateway to a single service
- **DON'T** skip compliance tagging — every requirement touching financial data, PII, or authentication must be tagged \`[PCI-DSS]\` or \`[SOC2]\`
- **DON'T** define requirements without specifying which Gradle module they belong to
- **DON'T** propose technologies outside the approved stack (no RabbitMQ, no MongoDB, no gRPC unless explicitly approved)
- **DON'T** generate vague acceptance criteria like "system should be fast" — use quantified SLOs

### Scope Creep

- **DON'T** introduce CQRS or Event Sourcing patterns unless the requirement explicitly demands them — start with standard hexagonal architecture
- **DON'T** suggest building custom frameworks when Spring Boot starters exist (e.g., don't build a custom health check system — use Spring Actuator)
- **DON'T** propose a service mesh (Istio/Linkerd) in discovery phase — Kubernetes-native service discovery is sufficient for initial scope
- **DON'T** add GraphQL, WebSocket, or SSE endpoints unless a specific requirement demands them
- **DON'T** recommend multi-region deployment in the initial discovery — capture it as a future NFR if mentioned

### Security & Compliance

- **DON'T** store or log cardholder data (PAN, CVV, expiry) in requirements examples or sample payloads
- **DON'T** propose storing secrets in \`application.properties\` or \`application.yml\` — reference AWS Secrets Manager or Kubernetes Secrets
- **DON'T** skip authentication/authorization requirements for any user-facing endpoint
- **DON'T** define Kafka topics that carry PCI-scoped data without noting encryption and access control requirements
- **DON'T** assume a single service handles both authentication and business logic — \`auth\` concerns belong in \`services/auth-service\` or \`gateway/\`

### Output Format

- **DON'T** produce monolithic requirements documents — break into per-service requirement sets
- **DON'T** generate UML diagrams in this phase — use plain-text domain event flow descriptions that can be converted to diagrams in Phase 02
- **DON'T** write implementation code during discovery — output should be Markdown artifacts: requirements, user stories, NFR checklists, domain event catalogs
- **DON'T** reference specific class names or package structures yet — that belongs in Phase 02 (Architecture) and Phase 03 (Foundation)

---

## Phase 01 Output Checklist

Before marking Phase 01 complete, verify Claude has produced:

| Artifact | Location | Validation |
|---|---|---|
| Functional requirements per service | \`docs/requirements/{service-name}-requirements.md\` | Each maps to a \`services/\` module |
| Non-functional requirements | \`docs/requirements/nfr-checklist.md\` | Quantified SLOs, compliance tags |
| User stories with acceptance criteria | \`docs/requirements/user-stories/\` | Jira-ready, tagged by service |
| Domain event catalog | \`docs/requirements/domain-events.md\` | Lists all Kafka topics and event schemas |
| Data classification matrix | \`docs/requirements/data-classification.md\` | PCI DSS scope identified |
| Service boundary map | \`docs/requirements/service-boundaries.md\` | Text-based, no premature architecture |
| Open questions log | \`docs/requirements/open-questions.md\` | Blockers tagged with owner and deadline |

---

## Transition to Phase 02

Phase 01 is complete when:

1. All services under \`services/\` have been identified with clear bounded contexts
2. Every inter-service interaction is defined as a Kafka event with a named topic
3. PCI DSS and SOC 2 scoped data has been classified and tagged
4. NFRs have measurable thresholds that can drive architecture decisions
5. No requirement assumes synchronous inter-service REST calls
6. The team has reviewed and approved the domain event catalog

Update phase state:

\`\`\`bash
./playbook/codeforge-phase.sh set 02-architecture
\`\`\``,

  'playbook/claude-overrides/02-architecture.claude.md': `# Phase 02: Architecture & Design — Claude Override Rules

## Phase Identity

This override governs Claude's behavior during architecture and design activities for the Spring Boot microservices platform. Architecture decisions here have long-lasting consequences — Claude must be opinionated toward proven patterns and conservative toward novelty.

---

## DO: Hexagonal Architecture Enforcement

- **DO** structure every microservice with explicit ports and adapters separation:
  - \`domain/\` — Pure Java domain models, domain services, domain events (zero Spring dependencies)
  - \`application/\` — Use cases, port interfaces (inbound + outbound), application services
  - \`adapter/inbound/\` — REST controllers, Kafka consumers, scheduled tasks
  - \`adapter/outbound/\` — JPA repositories, Kafka producers, Redis clients, external API clients
  - \`config/\` — Spring configuration, bean wiring, profile-specific settings
- **DO** define inbound ports as Java interfaces in \`application/port/inbound/\`
- **DO** define outbound ports as Java interfaces in \`application/port/outbound/\`
- **DO** ensure domain models are POJOs with no \`@Entity\`, \`@Table\`, or Spring annotations
- **DO** use separate JPA entity classes in \`adapter/outbound/persistence/\` that map to/from domain models

\`\`\`
services/payment-service/src/main/java/com/platform/payment/
├── domain/
│   ├── model/          # Payment, PaymentStatus, Money
│   ├── service/        # PaymentDomainService
│   └── event/          # PaymentInitiated, PaymentCompleted
├── application/
│   ├── port/
│   │   ├── inbound/    # InitiatePaymentUseCase, GetPaymentUseCase
│   │   └── outbound/   # PaymentRepository, PaymentEventPublisher, FraudCheckPort
│   ├── service/        # PaymentApplicationService (implements inbound ports)
│   └── dto/            # Command and query objects
├── adapter/
│   ├── inbound/
│   │   ├── rest/       # PaymentController
│   │   └── kafka/      # PaymentEventConsumer
│   └── outbound/
│       ├── persistence/ # PaymentJpaEntity, PaymentJpaRepository, PaymentRepositoryAdapter
│       ├── kafka/       # PaymentKafkaPublisher
│       └── redis/       # PaymentCacheAdapter
└── config/             # PaymentServiceConfig, KafkaConfig, SecurityConfig
\`\`\`

## DO: Service Boundary Design

- **DO** define each microservice around a single bounded context: \`order-service\`, \`payment-service\`, \`user-service\`, \`notification-service\`, \`ledger-service\`
- **DO** ensure each service owns its PostgreSQL schema exclusively — no shared databases
- **DO** document service boundaries in ADRs using the template in \`playbook/prompts/02/adr-generator.md\`
- **DO** define a clear domain event contract for every cross-boundary interaction
- **DO** use the \`shared/domain-events/\` module for event class definitions shared across services
- **DO** version all domain events from day one (e.g., \`PaymentCompletedV1\`, \`PaymentCompletedV2\`)

## DO: Kafka Event Design

- **DO** use topic naming convention: \`platform.<bounded-context>.<event-type>\` (e.g., \`platform.payments.payment-completed\`)
- **DO** define consumer group naming: \`<service-name>-<purpose>-group\` (e.g., \`order-service-payment-listener-group\`)
- **DO** design events as immutable facts with these required fields:
  \`\`\`java
  public record PaymentCompletedV1(
      UUID eventId,
      Instant occurredAt,
      String eventType,    // "payment.completed"
      int eventVersion,    // 1
      UUID correlationId,
      UUID causationId,
      PaymentCompletedPayload payload
  ) implements DomainEvent {}
  \`\`\`
- **DO** register every event schema in \`schema-registry/\` with JSON Schema or Avro
- **DO** design for idempotent consumers — every consumer must handle duplicate delivery
- **DO** specify partition key strategy per topic (e.g., \`paymentId\` for payment events, \`orderId\` for order events)
- **DO** plan dead letter topics for every consumer: \`platform.<context>.<event>.dlt\`

## DO: API Design Standards

- **DO** design REST APIs following OpenAPI 3.1 specification stored in \`services/<name>/src/main/resources/openapi/\`
- **DO** use consistent response envelope:
  \`\`\`json
  {
    "data": {},
    "meta": { "requestId": "uuid", "timestamp": "iso8601" },
    "errors": []
  }
  \`\`\`
- **DO** version APIs via URL path: \`/api/v1/payments\`, \`/api/v2/payments\`
- **DO** design the API gateway routes in \`gateway/\` to aggregate and route — never to contain business logic
- **DO** use Spring HATEOAS for resource linking where pagination or resource navigation is needed
- **DO** define error codes per service domain: \`PAY-001\`, \`PAY-002\`, \`ORD-001\`

## DO: Data Model Design

- **DO** use Flyway for all database migrations, stored in \`services/<name>/src/main/resources/db/migration/\`
- **DO** name migrations: \`V<version>__<description>.sql\` (e.g., \`V001__create_payments_table.sql\`)
- **DO** design tables with audit columns: \`created_at\`, \`updated_at\`, \`created_by\`, \`version\` (optimistic locking)
- **DO** use UUIDs as primary keys for all domain entities
- **DO** design for soft deletes where PCI DSS audit trail requirements apply (\`deleted_at\` column, never physical delete)
- **DO** separate read models from write models when a service has complex query requirements

## DO: Security Architecture

- **DO** design authentication flow through the API gateway using Spring Security OAuth2 Resource Server
- **DO** propagate JWT tokens between gateway and services via \`Authorization\` header
- **DO** design service-to-service authentication using mTLS within the Kubernetes cluster
- **DO** classify data sensitivity levels per PCI DSS: PAN data encrypted at rest and in transit, tokenized in logs
- **DO** design secrets management via AWS Secrets Manager, injected as Kubernetes secrets
- **DO** include threat modeling in architecture documents for any service handling financial data
- **DO** design audit logging for all state-changing operations (SOC 2 requirement)

## DO: Resilience Patterns

- **DO** design circuit breakers for all outbound adapter calls using Resilience4j
- **DO** specify retry policies with exponential backoff for Kafka consumers
- **DO** design saga patterns (choreography via Kafka events) for multi-service transactions
- **DO** document compensation logic for every saga step
- **DO** design health check endpoints using Spring Actuator: \`/actuator/health/liveness\`, \`/actuator/health/readiness\`
- **DO** plan for graceful shutdown: drain Kafka consumers before pod termination

## DO: ADR Standards

- **DO** generate ADRs for every significant architecture decision using the format:
  - Title, Status, Context, Decision, Consequences, Alternatives Considered
- **DO** store ADRs in \`docs/adr/\` with naming: \`ADR-<NNN>-<kebab-case-title>.md\`
- **DO** reference ADRs from code via comments when implementing a decision: \`// See ADR-003\`
- **DO** include performance and compliance implications in every ADR

---

## DON'T: Anti-Patterns to Reject

### DON'T: Direct Service-to-Service REST Calls
- **DON'T** design synchronous REST calls between microservices — all inter-service communication goes through Kafka
- **DON'T** create Feign clients, RestTemplate calls, or WebClient calls to other internal services
- **DON'T** design request-reply patterns over HTTP between services
- **EXCEPTION**: The API gateway may route external requests to individual services. That is the only allowed synchronous path.

### DON'T: Shared Databases
- **DON'T** design two services reading from or writing to the same PostgreSQL database or schema
- **DON'T** use database-level joins across service boundaries
- **DON'T** create foreign keys referencing tables owned by another service

### DON'T: Anemic Domain Models
- **DON'T** design domain models as data-only classes with all logic in service layers
- **DON'T** put business rules in controllers or Kafka consumers
- **DON'T** create "God services" that orchestrate everything — push logic into domain objects

### DON'T: Leaky Abstractions
- **DON'T** expose JPA entities in REST responses or Kafka events
- **DON'T** let Spring annotations leak into the \`domain/\` package
- **DON'T** let Kafka-specific types (ConsumerRecord, ProducerRecord) appear in application or domain layers
- **DON'T** use \`@Autowired\` field injection — use constructor injection exclusively

### DON'T: Unversioned Contracts
- **DON'T** design Kafka events without a version field
- **DON'T** design REST APIs without URL versioning
- **DON'T** modify existing event schemas — create new versions instead
- **DON'T** remove fields from published event schemas (backward compatibility required)

### DON'T: Security Shortcuts
- **DON'T** design plaintext storage of any PII or financial data
- **DON'T** pass sensitive data (PAN, CVV, passwords) in Kafka event payloads without encryption/tokenization
- **DON'T** design services that bypass the API gateway for external traffic
- **DON'T** hardcode secrets, connection strings, or API keys in configuration files
- **DON'T** design admin endpoints without role-based access control
- **DON'T** skip audit logging for any write operation on financial data

### DON'T: Monolith Patterns in Disguise
- **DON'T** create a shared library that contains business logic — \`shared/\` is for DTOs, events, and utilities only
- **DON'T** design a service that depends on the internal state of another service
- **DON'T** create circular dependencies between Gradle modules
- **DON'T** design a single Kafka topic that carries events from multiple bounded contexts

### DON'T: Over-Engineering
- **DON'T** introduce CQRS with separate read databases unless the service has proven query complexity
- **DON'T** design event sourcing unless explicitly required by an ADR — use state-based persistence by default
- **DON'T** add GraphQL, gRPC, or WebSocket unless a specific use case demands it
- **DON'T** create more than 7 microservices initially — start with core bounded contexts and split later

### DON'T: Ignoring Observability
- **DON'T** design services without correlation ID propagation (via \`X-Correlation-ID\` header and Kafka event field)
- **DON'T** skip distributed tracing design — every service must propagate Jaeger/OpenTelemetry trace context
- **DON'T** design log formats without structured JSON logging (service name, trace ID, span ID, correlation ID)

---

## Architecture Review Checklist

Before completing any architecture artifact, Claude must verify:

1. [ ] Every service boundary aligns with a single bounded context
2. [ ] No synchronous inter-service communication exists (Kafka only)
3. [ ] Each service has its own database, Dockerfile, Helm chart, and OpenAPI spec
4. [ ] All domain events are versioned and registered in the schema registry
5. [ ] Hexagonal architecture layers are clearly separated with no dependency violations
6. [ ] Security design addresses SOC 2 audit logging and PCI DSS data protection
7. [ ] Resilience patterns (circuit breaker, retry, DLT) are specified for all external calls
8. [ ] ADRs exist for every non-obvious architectural decision
9. [ ] Kafka topic naming, partitioning, and consumer group strategies are documented
10. [ ] Data models include audit columns, soft deletes, and optimistic locking where required

---

## Cross-References

- Phase definition: \`playbook/phases/02-architecture.md\`
- ADR generator prompt: \`playbook/prompts/02/adr-generator.md\`
- API design prompt: \`playbook/prompts/02/api-design.md\`
- Data model design prompt: \`playbook/prompts/02/data-model-design.md\`
- Discovery override (prior phase): \`playbook/claude-overrides/01-discovery.claude.md\`
- Foundation phase (next): \`playbook/phases/03-foundation.md\``,

  'playbook/claude-overrides/03-foundation.claude.md': `# Phase 03: Foundation & Scaffolding — Claude Override Rules

## Phase Context

This phase scaffolds the Spring Boot multi-module Gradle project, configures CI/CD pipelines, sets up infrastructure-as-code, and establishes the foundational patterns that every microservice will follow. Mistakes here propagate to every service — precision is critical.

---

## DO ✅

### Project Structure

- **DO** use Gradle Kotlin DSL (\`build.gradle.kts\`) for all build files — never Groovy DSL
- **DO** create a root \`settings.gradle.kts\` that includes all modules with \`include("services:order-service", "services:payment-service", ...)\`
- **DO** define a \`buildSrc/\` or convention plugin for shared build logic (dependency versions, common plugins, JaCoCo config)
- **DO** use Gradle version catalogs (\`libs.versions.toml\`) for centralized dependency management
- **DO** create each microservice as its own Gradle module under \`services/\` with its own \`build.gradle.kts\`, \`Dockerfile\`, and \`src/\` tree
- **DO** scaffold shared libraries under \`shared/\` (e.g., \`shared/domain-events\`, \`shared/common-utils\`, \`shared/test-fixtures\`)
- **DO** use the standard Maven/Gradle source layout: \`src/main/java\`, \`src/main/resources\`, \`src/test/java\`, \`src/test/resources\`
- **DO** include \`src/integrationTest/java\` and \`src/integrationTest/resources\` as a separate source set for Testcontainers-based tests
- **DO** create a \`src/contractTest/java\` source set for Pact contract tests

### Spring Boot Configuration

- **DO** use Spring Profiles consistently: \`local\`, \`dev\`, \`staging\`, \`production\`
- **DO** create \`application.yml\` as the base config and \`application-{profile}.yml\` for overrides
- **DO** externalize all secrets via environment variables — never hardcode in YAML files
- **DO** use \`@ConfigurationProperties\` with \`@Validated\` for type-safe configuration binding
- **DO** configure Spring Boot Actuator with health, info, metrics, and prometheus endpoints
- **DO** set \`management.endpoints.web.exposure.include=health,info,metrics,prometheus\` in base config
- **DO** configure \`management.endpoint.health.probes.enabled=true\` for Kubernetes liveness/readiness
- **DO** use \`spring.application.name\` matching the Gradle module name (e.g., \`order-service\`)

### Hexagonal Architecture Scaffolding

- **DO** scaffold each service with the hexagonal package structure:
  \`\`\`
  com.company.{service}.domain.model/
  com.company.{service}.domain.port.inbound/
  com.company.{service}.domain.port.outbound/
  com.company.{service}.domain.service/
  com.company.{service}.adapter.inbound.rest/
  com.company.{service}.adapter.inbound.kafka/
  com.company.{service}.adapter.outbound.persistence/
  com.company.{service}.adapter.outbound.kafka/
  com.company.{service}.adapter.outbound.cache/
  com.company.{service}.infrastructure.config/
  com.company.{service}.infrastructure.security/
  \`\`\`
- **DO** define inbound ports as Java interfaces (e.g., \`CreateOrderUseCase\`)
- **DO** define outbound ports as Java interfaces (e.g., \`OrderRepository\`, \`OrderEventPublisher\`)
- **DO** place Spring-specific annotations only in adapter and infrastructure packages — never in domain

### Kafka Configuration

- **DO** create a shared \`KafkaConfig\` class per service using \`@Configuration\`
- **DO** define topic names as constants in \`shared/domain-events\` (e.g., \`Topics.ORDER_CREATED = "order.events.created"\`)
- **DO** use a consistent topic naming convention: \`{domain}.events.{event-type}\`
- **DO** configure consumer groups matching the service name: \`spring.kafka.consumer.group-id=\${spring.application.name}\`
- **DO** set \`spring.kafka.consumer.auto-offset-reset=earliest\` for new consumer groups
- **DO** configure \`JsonSerializer\`/\`JsonDeserializer\` with trusted packages for event DTOs
- **DO** create a \`KafkaProducerConfig\` and \`KafkaConsumerConfig\` separately for clarity
- **DO** include dead-letter topic configuration (\`{topic}.DLT\`) for every consumer

### Database Setup

- **DO** configure Flyway for database migrations per service under \`src/main/resources/db/migration/\`
- **DO** use the Flyway naming convention: \`V{version}__{description}.sql\` (e.g., \`V001__create_orders_table.sql\`)
- **DO** set \`spring.jpa.hibernate.ddl-auto=validate\` — Flyway owns the schema, not Hibernate
- **DO** configure separate PostgreSQL databases per service (database-per-service pattern)
- **DO** use \`spring.datasource.hikari.*\` for connection pool tuning with sensible defaults
- **DO** create a Redis configuration class with separate \`RedisTemplate\` beans for caching vs. sessions

### Docker & Kubernetes

- **DO** create multi-stage Dockerfiles: build stage with Gradle, runtime stage with Eclipse Temurin JRE 21
- **DO** use \`COPY --from=build\` to copy only the fat JAR — not the entire build context
- **DO** set \`ENTRYPOINT ["java", "-XX:+UseContainerSupport", "-XX:MaxRAMPercentage=75.0", "-jar", "app.jar"]\`
- **DO** include \`.dockerignore\` excluding \`.gradle/\`, \`build/\`, \`.git/\`, \`*.md\`
- **DO** create Helm charts under \`charts/{service-name}/\` with \`values.yaml\`, \`values-staging.yaml\`, \`values-production.yaml\`
- **DO** include Kubernetes health probes pointing to Actuator: \`livenessProbe\` → \`/actuator/health/liveness\`, \`readinessProbe\` → \`/actuator/health/readiness\`
- **DO** define resource requests and limits in Helm values (CPU/memory)
- **DO** use Kubernetes \`ConfigMap\` for non-sensitive config and \`Secret\` for credentials

### CI/CD Pipeline

- **DO** create GitHub Actions workflows that run \`./gradlew build\` as the primary build command
- **DO** separate workflows: \`ci.yml\` (on PR), \`cd-staging.yml\` (on merge to main), \`cd-production.yml\` (manual trigger)
- **DO** cache Gradle dependencies using \`actions/cache\` with key \`\${{ runner.os }}-gradle-\${{ hashFiles('**/*.gradle.kts') }}\`
- **DO** run Checkstyle, ktlint, and SpotBugs as part of the lint stage
- **DO** run OWASP dependency-check in the security scan stage
- **DO** use JaCoCo for coverage reporting with the 80% threshold enforced via \`jacocoTestCoverageVerification\`
- **DO** build Docker images tagged with \`\${GITHUB_SHA}\` and push to ECR
- **DO** add the \`ai-generated\` label to PRs opened by Claude per the AI code flagging policy

### Infrastructure as Code

- **DO** organize Terraform under \`infrastructure/\` with modules: \`vpc\`, \`eks\`, \`rds\`, \`elasticache\`, \`msk\`, \`ecr\`
- **DO** use Terraform workspaces or directory-based separation for \`staging\` and \`production\`
- **DO** define RDS instances per service with separate credentials stored in AWS Secrets Manager
- **DO** configure MSK (Managed Streaming for Kafka) with encryption at rest and in transit for PCI DSS
- **DO** enable VPC private subnets for all data stores — no public endpoints

### Security Foundations

- **DO** create a shared Spring Security configuration base class with CSRF protection, CORS policy, and security headers
- **DO** configure HTTPS-only with HSTS headers
- **DO** set up dependency vulnerability scanning in CI (OWASP dependency-check, Trivy for Docker images)
- **DO** create a \`.trivyignore\` for acknowledged CVEs with expiration dates
- **DO** add \`CODEOWNERS\` entries for \`**/security/**\`, \`**/auth/**\`, \`infrastructure/production/**\` requiring lead approval

---

## DON'T ❌

### Project Structure

- **DON'T** use Groovy-based \`build.gradle\` files — this project uses Kotlin DSL exclusively
- **DON'T** create a monolithic single-module project — every service must be its own Gradle module
- **DON'T** put service-specific code in \`shared/\` — shared modules contain only cross-cutting concerns (events, DTOs, utilities)
- **DON'T** create circular dependencies between Gradle modules — services depend on \`shared/\`, never on each other
- **DON'T** use Maven (\`pom.xml\`) — this project uses Gradle exclusively
- **DON'T** scatter dependency versions across individual \`build.gradle.kts\` files — use the version catalog

### Spring Boot Configuration

- **DON'T** use \`application.properties\` — use \`application.yml\` for consistency across the team
- **DON'T** hardcode database URLs, passwords, API keys, or any secrets in config files or source code
- **DON'T** use \`spring.jpa.hibernate.ddl-auto=create\` or \`update\` — Flyway manages all schema changes
- **DON'T** expose all Actuator endpoints in production — whitelist only \`health\`, \`info\`, \`metrics\`, \`prometheus\`
- **DON'T** use \`@SpringBootApplication(scanBasePackages = "...")\` with overly broad package scans — keep component scanning within the service's root package
- **DON'T** use \`spring.profiles.active\` in \`application.yml\` — set it via environment variable or JVM arg at runtime

### Hexagonal Architecture

- **DON'T** put Spring annotations (\`@Service\`, \`@Repository\`, \`@Component\`, \`@Transactional\`) in the \`domain\` package — domain must be framework-agnostic
- **DON'T** let REST controllers call repositories directly — always go through an inbound port (use case interface) and domain service
- **DON'T** import adapter classes from within the domain package — dependency arrows point inward only
- **DON'T** put business logic in controllers, Kafka listeners, or persistence adapters — logic belongs in domain services
- **DON'T** create "god services" that handle multiple bounded contexts — one service per bounded context

### Kafka

- **DON'T** use auto-topic-creation in production (\`auto.create.topics.enable=false\`) — all topics must be explicitly defined
- **DON'T** use \`StringSerializer\` for event values — use \`JsonSerializer\` with proper type headers
- **DON'T** skip dead-letter topic configuration — every consumer must have a DLT strategy
- **DON'T** make synchronous REST calls between microservices — all inter-service communication goes through Kafka events
- **DON'T** publish domain entities directly to Kafka — create dedicated event DTOs in \`shared/domain-events\`
- **DON'T** use \`@KafkaListener\` without specifying \`containerFactory\` and error handler

### Database

- **DON'T** share a database between microservices — each service owns its database exclusively
- **DON'T** create Flyway migrations that are destructive without a rollback plan (no \`DROP TABLE\` without review)
- **DON'T** use auto-generated Hibernate DDL as the source of truth — write explicit Flyway migrations
- **DON'T** use \`CrudRepository\` directly in domain services — wrap it behind an outbound port interface
- **DON'T** store sensitive data (PAN, CVV, PII) without encryption at rest — PCI DSS requirement

### Docker & Kubernetes

- **DON'T** use \`latest\` tag for Docker images — always tag with commit SHA or semantic version
- **DON'T** run containers as root — use \`USER 1001\` in Dockerfiles
- **DON'T** copy the entire project into the Docker build context — use \`.dockerignore\` and multi-stage builds
- **DON'T** hardcode environment-specific values in Helm \`templates/\` — use \`values-{env}.yaml\` overrides
- **DON'T** store Kubernetes secrets in plain text in the repo — use sealed-secrets or external-secrets-operator
- **DON'T** skip resource limits in Kubernetes manifests — every pod must have CPU/memory requests and limits
- **DON'T** use \`hostNetwork\` or \`hostPort\` in pod specs

### CI/CD

- **DON'T** skip the integration test stage — Testcontainers tests must run in CI
- **DON'T** allow CI to pass with coverage below 80% — \`jacocoTestCoverageVerification\` must be a hard gate
- **DON'T** push Docker images from local machines — only CI/CD pushes to ECR
- **DON'T** deploy to production automatically — production deployments require manual approval
- **DON'T** skip security scanning (OWASP dependency-check, Trivy) — these are compliance requirements

### Security & Compliance

- **DON'T** disable CSRF protection unless the endpoint is a stateless API with token-based auth
- **DON'T** log sensitive data (passwords, tokens, PAN, SSN) — configure log masking patterns
- **DON'T** use HTTP for any inter-service communication — TLS everywhere (mTLS preferred in K8s)
- **DON'T** commit \`.env\` files, \`application-local.yml\` with real credentials, or any file containing secrets
- **DON'T** bypass \`CODEOWNERS\` review for security-sensitive paths
- **DON'T** use deprecated or vulnerable dependencies — OWASP scan failures block the build

### General

- **DON'T** generate files longer than 300 lines — split into focused, single-responsibility classes
- **DON'T** create utility classes with static methods when a proper domain service or Spring bean is appropriate
- **DON'T** use \`var\` excessively in Java — prefer explicit types for public API signatures and domain models
- **DON'T** suppress warnings (\`@SuppressWarnings\`) without a comment explaining why
- **DON'T** generate code without corresponding unit tests — every scaffolded class gets a test class

---

## Validation Checklist

Before completing Phase 03, verify:

- [ ] \`./gradlew build\` succeeds from the project root with zero warnings
- [ ] \`./gradlew test\` runs unit tests for all modules
- [ ] \`./gradlew integrationTest\` runs with Testcontainers (requires Docker)
- [ ] \`./gradlew checkstyleMain\` and \`./gradlew ktlintCheck\` pass with no violations
- [ ] \`./gradlew jacocoTestReport\` generates coverage reports
- [ ] Each service has a working \`Dockerfile\` that builds a runnable image
- [ ] \`docker-compose up\` starts all services with PostgreSQL, Redis, and Kafka locally
- [ ] Actuator health endpoints respond at \`/actuator/health\` for each service
- [ ] Flyway migrations run successfully on fresh databases
- [ ] Kafka topics are created and listed via \`kafka-topics.sh --list\`
- [ ] Helm charts pass \`helm lint charts/{service-name}/\`
- [ ] Terraform plans succeed: \`terraform plan -var-file=staging.tfvars\`
- [ ] GitHub Actions CI workflow passes on a test PR
- [ ] \`CODEOWNERS\` file is present and covers security-sensitive paths
- [ ] No secrets are committed — \`git-secrets\` or \`gitleaks\` scan passes

---

## Cross-References

- Phase definition: \`playbook/phases/03-foundation.md\`
- Scaffold prompt: \`playbook/prompts/03/project-scaffold.md\`
- CI pipeline prompt: \`playbook/prompts/03/ci-pipeline.md\`
- IaC setup prompt: \`playbook/prompts/03/iac-setup.md\`
- Architecture decisions: \`playbook/prompts/02/adr-generator.md\`
- Global Claude rules: \`.claude/rules/\``,

  'playbook/claude-overrides/04-core-implementation.claude.md': `# Phase 04: Core Implementation — Claude Override Rules

## Phase Context

This phase covers the implementation of domain logic, service endpoints, Kafka event producers/consumers, and persistence layers across microservices. Claude must follow hexagonal architecture, enforce inter-service communication exclusively through Kafka, and maintain SOC 2 / PCI DSS compliance throughout.

## DO — Required Practices

### Architecture

- DO follow hexagonal architecture (ports & adapters) in every microservice:
  - \`domain/\` — pure domain models, value objects, domain events, domain services (zero framework imports)
  - \`application/\` — use cases, input/output ports, application services
  - \`adapter/in/web/\` — REST controllers, request/response DTOs, mappers
  - \`adapter/in/kafka/\` — Kafka consumers, event deserializers
  - \`adapter/out/persistence/\` — JPA repositories, entity mappings, database adapters
  - \`adapter/out/kafka/\` — Kafka producers, event serializers
  - \`adapter/out/cache/\` — Redis adapters
- DO keep domain layer completely free of Spring annotations — use constructor injection via ports
- DO define explicit port interfaces (\`OrderRepository\` port in domain, \`JpaOrderRepository\` adapter in persistence)
- DO use \`@Configuration\` classes to wire adapters to ports

### Java / Spring Boot Conventions

- DO use Java 21 features: records for DTOs and value objects, sealed interfaces for domain event hierarchies, pattern matching where it improves clarity
- DO use \`record\` types for all request/response DTOs and Kafka event payloads
- DO annotate REST controllers with \`@RestController\` and use \`@RequestMapping\` at the class level with method-level \`@GetMapping\`, \`@PostMapping\`, etc.
- DO return \`ResponseEntity<T>\` from controller methods with explicit HTTP status codes
- DO use Spring's \`@Validated\` and Jakarta Bean Validation annotations on request DTOs
- DO use \`@Transactional\` only at the application service layer, never on controllers or domain services
- DO configure Spring Profiles: \`local\`, \`test\`, \`staging\`, \`production\`
- DO expose Actuator health, info, and Prometheus endpoints via \`management.endpoints\`
- DO use \`@ConfigurationProperties\` with \`@ConstructorBinding\` for typed configuration — never raw \`@Value\` for complex config

### Kafka Event Streaming

- DO publish domain events through an output port (\`EventPublisher\`) implemented by a Kafka adapter
- DO use the shared schema registry (\`schema-registry/\`) for all event schemas — reference schemas by fully qualified name
- DO define Kafka topics with the naming convention: \`{domain}.{entity}.{event-type}\` (e.g., \`payment.transaction.completed\`)
- DO use consumer group naming convention: \`{service-name}-{consumer-purpose}\` (e.g., \`order-service-payment-listener\`)
- DO set \`acks=all\`, \`enable.idempotence=true\` on producers for financial data
- DO implement idempotent consumers using a processed-event store (deduplication table)
- DO include \`eventId\` (UUID), \`eventType\`, \`timestamp\`, \`correlationId\`, \`source\` in every event envelope
- DO use \`@KafkaListener\` with explicit \`groupId\`, \`topics\`, and \`containerFactory\` parameters
- DO configure \`JsonDeserializer\` with trusted packages restricted to \`com.company.shared.events.*\`
- DO handle deserialization errors with a \`DeadLetterPublishingRecoverer\` to a \`.dlq\` topic

### Persistence

- DO use one PostgreSQL database per microservice — never share databases across services
- DO use Flyway for schema migrations with versioned scripts in \`src/main/resources/db/migration/\`
- DO name migration files: \`V{version}__{description}.sql\` (e.g., \`V001__create_orders_table.sql\`)
- DO use JPA entities only in the persistence adapter — map to/from domain models at the adapter boundary
- DO use \`@Entity\` classes with \`@Table(name = "...")\` explicit table names
- DO use UUID as primary key type for all entities
- DO add \`created_at\` and \`updated_at\` audit columns to every table via \`@EntityListeners(AuditingEntityListener.class)\`
- DO use Spring Data JPA repositories extending \`JpaRepository\` in the adapter layer
- DO use \`@Query\` with JPQL for complex queries — avoid native SQL unless performance-critical

### Redis Caching

- DO use \`@Cacheable\`, \`@CacheEvict\`, \`@CachePut\` with explicit cache names and key expressions
- DO set TTL on all cache entries — no unbounded caches
- DO use Redis for distributed session management when session state is required
- DO prefix all Redis keys with the service name: \`{service-name}:{entity}:{id}\`

### Error Handling

- DO create a \`@RestControllerAdvice\` global exception handler per service
- DO map domain exceptions to appropriate HTTP status codes (400, 404, 409, 422, 500)
- DO return a consistent error response body: \`{ "error": "...", "code": "...", "traceId": "...", "timestamp": "..." }\`
- DO include the distributed trace ID (\`traceId\` from Micrometer/Jaeger) in every error response
- DO log exceptions at the appropriate level: 4xx → WARN, 5xx → ERROR

### Testing During Implementation

- DO write unit tests for every domain service and use case — target 90%+ coverage on domain layer
- DO use Mockito to mock port interfaces in application service tests
- DO use Testcontainers for integration tests against real PostgreSQL, Kafka, and Redis
- DO annotate integration tests with \`@SpringBootTest\` and \`@Testcontainers\`
- DO use \`@DynamicPropertySource\` to inject Testcontainers connection properties
- DO write contract tests for every Kafka event producer using Pact or Spring Cloud Contract
- DO keep test classes under 300 lines — split into focused test classes by behavior

### Security (SOC 2 / PCI DSS)

- DO use Spring Security with method-level \`@PreAuthorize\` for authorization
- DO validate and sanitize all input at the controller layer before it reaches the application layer
- DO use parameterized queries exclusively — JPA/JPQL handles this, but verify any native queries
- DO encrypt PII and cardholder data at rest using column-level encryption or application-level encryption
- DO mask sensitive fields (card numbers, SSNs) in log output — use a custom \`LoggingFilter\` or structured logging layout
- DO add \`@Sensitive\` or equivalent custom annotation to fields that must never appear in logs
- DO set \`spring.jackson.default-property-inclusion=non_null\` and use \`@JsonIgnore\` on internal fields
- DO include \`X-Request-ID\` and \`X-Correlation-ID\` headers in all API responses for traceability

### Code Organization

- DO keep files under 300 lines — split large services into focused collaborators
- DO use one public class per file
- DO organize imports: \`java.*\`, blank line, \`javax.*\`/\`jakarta.*\`, blank line, third-party, blank line, project
- DO follow naming conventions: \`OrderService\` (domain service), \`CreateOrderUseCase\` (application), \`OrderController\` (adapter), \`OrderJpaRepository\` (adapter)
- DO add Javadoc to all public interfaces (ports) and public API endpoints
- DO use \`final\` on class fields and method parameters where possible

### Observability

- DO add \`@Observed\` (Micrometer) or manual \`Timer\`/\`Counter\` metrics to critical business operations
- DO use structured logging with SLF4J + Logback — include \`correlationId\`, \`userId\`, \`serviceId\` in MDC
- DO propagate trace context through Kafka headers using Micrometer Tracing / OpenTelemetry

## DON'T — Prohibited Practices

### Architecture Violations

- DON'T make direct REST calls between microservices — all inter-service communication goes through Kafka
- DON'T import Spring framework classes in the domain layer — domain must be framework-agnostic
- DON'T put business logic in controllers — controllers only validate input, call use cases, and map responses
- DON'T put business logic in JPA entities — entities are persistence concerns only
- DON'T create circular dependencies between Gradle modules
- DON'T share database tables or schemas between services

### Code Quality

- DON'T use \`@Autowired\` field injection — use constructor injection exclusively
- DON'T use \`Optional\` as a method parameter or field type — only as a return type
- DON'T use raw types (\`List\` instead of \`List<Order>\`)
- DON'T catch \`Exception\` or \`Throwable\` broadly — catch specific exception types
- DON'T use \`System.out.println\` or \`System.err.println\` — use SLF4J logger
- DON'T use \`@SuppressWarnings\` without a comment explaining why
- DON'T use \`var\` for public API return types or method signatures — be explicit
- DON'T create God classes — no class should have more than 7-10 public methods
- DON'T use static mutable state
- DON'T use \`Thread.sleep()\` in production code

### Kafka

- DON'T consume and produce to the same topic in the same service (event loop risk)
- DON'T use \`@KafkaListener\` without specifying an explicit consumer group
- DON'T ignore deserialization errors — always configure error handling and DLQ
- DON'T publish events outside of a successful transaction boundary — use the transactional outbox pattern or \`@TransactionalEventListener\`
- DON'T hardcode topic names — define them in \`application.yml\` and inject via \`@ConfigurationProperties\`
- DON'T assume message ordering across partitions — design consumers to be order-independent or use partition keys

### Security

- DON'T log sensitive data: passwords, tokens, API keys, card numbers, SSNs, PII
- DON'T store secrets in \`application.properties\` or \`application.yml\` — use AWS Secrets Manager or environment variables
- DON'T disable CSRF protection without documenting the justification (stateless APIs with JWT are acceptable)
- DON'T use \`permitAll()\` on endpoints without explicit documentation of why
- DON'T expose stack traces in API error responses — log them server-side, return sanitized messages
- DON'T use \`MD5\` or \`SHA-1\` for any cryptographic purpose — use \`SHA-256\` minimum, \`bcrypt\`/\`argon2\` for passwords
- DON'T store cardholder data unless absolutely necessary per PCI DSS — tokenize instead
- DON'T disable SSL/TLS verification in any environment including local development

### Persistence

- DON'T use \`spring.jpa.hibernate.ddl-auto=create\` or \`update\` — use Flyway migrations exclusively
- DON'T use \`FetchType.EAGER\` on JPA relationships — always use \`LAZY\` and fetch explicitly
- DON'T use \`CascadeType.ALL\` without careful consideration — prefer explicit cascade types
- DON'T write unbounded queries (\`findAll()\` without pagination) — always paginate with \`Pageable\`
- DON'T use \`@GeneratedValue(strategy = GenerationType.AUTO)\` — use \`GenerationType.UUID\` or assign UUIDs in code

### Testing

- DON'T write tests that depend on execution order
- DON'T use \`@SpringBootTest\` for unit tests — reserve it for integration tests only
- DON'T mock domain objects — mock ports/adapters only
- DON'T skip writing tests for "simple" CRUD — every public method needs test coverage
- DON'T use \`@Disabled\` without a linked Jira ticket explaining when it will be re-enabled

### Dependencies

- DON'T add dependencies without checking the approved dependency list in \`docs/approved-dependencies.md\`
- DON'T use Apache Commons for functionality available in Java 21 standard library
- DON'T add Lombok — use Java records and explicit constructors instead
- DON'T add libraries that duplicate Spring Boot starter functionality

## Code Structure Template

When implementing a new feature in a microservice, follow this structure:

\`\`\`
services/{service-name}/src/main/java/com/company/{service}/
├── domain/
│   ├── model/           # Aggregates, entities, value objects (records)
│   ├── event/           # Domain events (sealed interface + records)
│   ├── port/
│   │   ├── in/          # Input ports (use case interfaces)
│   │   └── out/         # Output ports (repository, event publisher interfaces)
│   ├── service/         # Domain services (pure logic, no Spring)
│   └── exception/       # Domain-specific exceptions
├── application/
│   ├── usecase/         # Use case implementations (@Service, @Transactional)
│   └── dto/             # Application-level DTOs if needed
├── adapter/
│   ├── in/
│   │   ├── web/         # @RestController, request/response records, mappers
│   │   └── kafka/       # @KafkaListener consumers
│   └── out/
│       ├── persistence/ # @Entity, JpaRepository, adapter implementations
│       ├── kafka/       # KafkaTemplate producers
│       └── cache/       # Redis adapter implementations
└── config/              # @Configuration, @ConfigurationProperties
\`\`\`

## Checklist Before Completing Implementation

- [ ] Domain layer has zero Spring imports
- [ ] All inter-service communication uses Kafka (no REST calls between services)
- [ ] Every Kafka event has a schema in \`schema-registry/\`
- [ ] Flyway migrations are versioned and reviewed
- [ ] All endpoints have input validation and proper error responses
- [ ] Sensitive data is encrypted at rest and masked in logs
- [ ] Unit tests cover domain and application layers (≥80% coverage)
- [ ] Integration tests use Testcontainers for external dependencies
- [ ] Contract tests exist for all published Kafka events
- [ ] No hardcoded secrets, topic names, or environment-specific values
- [ ] Actuator health and Prometheus metrics endpoints are configured
- [ ] Structured logging includes correlationId in MDC
- [ ] Files are under 300 lines, classes have focused responsibilities
- [ ] Code passes Checkstyle, SpotBugs, and OWASP dependency-check`,

  'playbook/claude-overrides/05-integration-hardening.claude.md': `# Phase 05: Integration & Hardening — Claude Override Rules

## Phase Context

Phase 05 focuses on wiring microservices together through Kafka event streaming, hardening security for SOC 2 and PCI DSS compliance, adding observability (tracing, metrics, logging), and ensuring the system behaves correctly under failure conditions. This is where individual services become a cohesive platform.

---

## DO Rules

### Kafka Integration

- DO use \`@KafkaListener\` with explicit \`groupId\`, \`topics\`, and \`containerFactory\` — never rely on defaults
- DO configure \`JsonDeserializer\` with trusted packages restricted to \`com.springbootmicroservices.*\` and schema-registry types only
- DO set \`spring.kafka.consumer.auto-offset-reset=earliest\` for new consumer groups in integration environments
- DO implement idempotent consumers using a processed-event table with \`event_id\` as the deduplication key
- DO use \`@Transactional\` with \`@KafkaListener\` and configure \`ChainedKafkaTransactionManager\` when consuming events that write to PostgreSQL
- DO define dead-letter topics (DLT) for every consumer with \`DefaultErrorHandler\` and \`DeadLetterPublishingRecoverer\`
- DO register all event schemas in \`schema-registry/\` before publishing — consumers must validate against the registered schema
- DO use \`ProducerRecord\` headers to propagate \`correlationId\`, \`causationId\`, and \`traceId\` across service boundaries
- DO configure \`max.poll.records\` and \`max.poll.interval.ms\` explicitly to prevent consumer group rebalancing under load
- DO write Testcontainers-based integration tests for every Kafka consumer and producer using \`@EmbeddedKafka\` or a Kafka Testcontainer

### Spring Cloud Gateway Integration

- DO configure route predicates and filters in \`gateway/src/main/resources/application.yml\` — not programmatically unless dynamic routing is required
- DO add rate limiting via \`RequestRateLimiter\` filter backed by Redis using \`spring-boot-starter-data-redis-reactive\`
- DO propagate \`Authorization\` headers downstream but strip sensitive headers (\`Cookie\`, \`Set-Cookie\`) at the gateway level
- DO configure circuit breakers per route using Resilience4j with explicit \`failureRateThreshold\`, \`waitDurationInOpenState\`, and \`slidingWindowSize\`
- DO add request/response logging at the gateway with correlation ID injection via \`GlobalFilter\`

### Security Hardening

- DO configure Spring Security with \`SecurityFilterChain\` beans — never extend \`WebSecurityConfigurerAdapter\` (removed in Spring Security 6)
- DO use \`@PreAuthorize\` with SpEL expressions for method-level authorization on service endpoints
- DO encrypt all sensitive properties using Spring Cloud Config encryption or AWS Secrets Manager — never store secrets in \`application.properties\` or \`application.yml\`
- DO enable CSRF protection for any browser-facing endpoints; disable only for stateless API endpoints with explicit comments explaining why
- DO configure \`Content-Security-Policy\`, \`X-Content-Type-Options\`, \`X-Frame-Options\`, and \`Strict-Transport-Security\` headers in every service's security config
- DO implement field-level encryption for PCI DSS cardholder data (PAN, CVV) using a dedicated \`EncryptionService\` in \`shared/crypto/\`
- DO audit-log every authentication event, authorization failure, and data access to PCI-scoped entities using a dedicated \`AuditEventPublisher\` that writes to Kafka topic \`audit.security-events\`
- DO run OWASP dependency-check via \`./gradlew dependencyCheckAnalyze\` and fail the build on CVSS score >= 7.0
- DO configure SpotBugs with the \`findsecbugs\` plugin and include \`security\` category in the analysis

### Observability

- DO configure Micrometer with Prometheus registry in every service via \`management.metrics.export.prometheus.enabled=true\`
- DO add custom metrics for business events: \`counter("events.published", "type", eventType)\` and \`counter("events.consumed", "type", eventType)\`
- DO configure distributed tracing with Micrometer Tracing (Spring Boot 3.2) and export to Jaeger via OTLP
- DO propagate trace context through Kafka using \`ProducerInterceptor\` and \`ConsumerInterceptor\` from \`io.micrometer:micrometer-tracing-bridge-otel\`
- DO structure all log output as JSON using Logback's \`LogstashEncoder\` for ELK Stack ingestion
- DO include \`traceId\`, \`spanId\`, \`service.name\`, and \`correlationId\` in every log line via MDC
- DO expose health checks at \`/actuator/health\` with liveness and readiness groups: liveness checks the JVM, readiness checks PostgreSQL, Redis, and Kafka broker connectivity
- DO configure Actuator endpoint exposure: expose only \`health\`, \`info\`, \`prometheus\`, \`metrics\` — never expose \`env\`, \`configprops\`, \`beans\` in non-local profiles

### Resilience

- DO use Resilience4j \`@CircuitBreaker\` on all external integration points (AWS services, third-party APIs) — never on internal Kafka consumers
- DO configure \`@Retry\` with exponential backoff for transient failures: \`maxAttempts=3\`, \`waitDuration=500ms\`, \`multiplier=2\`
- DO implement \`@Bulkhead\` with \`type=SEMAPHORE\` for thread-limited operations and \`type=THREADPOOL\` for blocking I/O calls
- DO write chaos-style integration tests that simulate Kafka broker unavailability, PostgreSQL connection pool exhaustion, and Redis timeout using Testcontainers and Toxiproxy
- DO configure connection pool limits explicitly in \`application.yml\`: HikariCP \`maximumPoolSize\`, Lettuce connection pool \`maxActive\`, Kafka producer \`buffer.memory\`

### Database Integration

- DO use Flyway for all schema migrations — one migration directory per service under \`services/{service-name}/src/main/resources/db/migration/\`
- DO configure \`spring.flyway.baseline-on-migrate=true\` only for initial setup — remove after first deployment
- DO use \`@Transactional(readOnly = true)\` on query methods to route to read replicas when connection routing is configured
- DO implement the Outbox Pattern for reliable event publishing: write domain events to an \`outbox_events\` table within the same transaction, then publish to Kafka via a polling publisher or CDC

### Contract Testing

- DO write Pact provider verification tests for every service that publishes REST APIs consumed by other services or the gateway
- DO write Pact consumer-driven contract tests for every Kafka event schema — producer verifies it can produce events matching the consumer's expectations
- DO store Pact contracts in the \`tests/contracts/\` directory and publish to a Pact Broker in CI

---

## DON'T Rules

### Kafka Anti-Patterns

- DON'T make synchronous REST calls between microservices — all inter-service communication goes through Kafka topics
- DON'T use \`@KafkaListener\` on a method that also calls another service's REST API — this creates hidden coupling and distributed transaction issues
- DON'T publish events outside of a transaction boundary — use the Outbox Pattern or transactional outbox to guarantee at-least-once delivery
- DON'T use \`auto.commit.enable=true\` in production consumers — always use manual acknowledgment with \`AckMode.MANUAL_IMMEDIATE\` or \`RECORD\`
- DON'T create Kafka topics on-the-fly with \`auto.create.topics.enable=true\` — all topics must be pre-provisioned via Terraform in \`infrastructure/kafka/\`
- DON'T put large payloads (>1MB) in Kafka messages — store the payload in S3 or PostgreSQL and publish a reference event
- DON'T share consumer group IDs across different services — each service must have its own consumer group per topic

### Security Anti-Patterns

- DON'T log PII, cardholder data, authentication tokens, or API keys — configure Logback filters to redact patterns matching card numbers, SSNs, and Bearer tokens
- DON'T use \`@Secured\` or \`@RolesAllowed\` — standardize on \`@PreAuthorize\` for consistency across the codebase
- DON'T disable SSL/TLS verification in any HTTP client, Kafka client, or database connection — even in staging
- DON'T store encryption keys in application configuration — use AWS KMS or HashiCorp Vault with Spring Cloud Vault integration
- DON'T use \`permitAll()\` on Actuator endpoints in non-local profiles — require authentication for all management endpoints in staging and production
- DON'T implement custom authentication or token validation logic — use Spring Security's \`OAuth2ResourceServer\` with JWT validation against the identity provider
- DON'T use \`String\` to hold sensitive data (passwords, tokens, card numbers) in memory — use \`char[]\` or \`SecureString\` wrappers and clear after use

### Observability Anti-Patterns

- DON'T use \`System.out.println\` or \`e.printStackTrace()\` — use SLF4J \`Logger\` with structured fields
- DON'T create high-cardinality metric labels (e.g., \`userId\`, \`transactionId\` as metric tags) — this will overwhelm Prometheus
- DON'T log full request/response bodies in production — log only at DEBUG level with size limits and PII redaction
- DON'T expose \`/actuator/**\` without path restrictions — use \`management.server.port\` to bind Actuator to a separate internal port (e.g., 8081)

### Resilience Anti-Patterns

- DON'T catch and swallow exceptions in Kafka consumers — let the error handler route to the DLT
- DON'T set infinite or very high retry counts — cap retries and route to DLT after exhaustion
- DON'T use \`@CircuitBreaker\` and \`@Retry\` on the same method without ordering — configure Resilience4j aspect order: Retry → CircuitBreaker → Bulkhead → RateLimiter
- DON'T use default HikariCP pool sizes in production — calculate based on service concurrency: \`connections = (core_count * 2) + effective_spindle_count\`
- DON'T configure identical timeout values for cascading services — use progressively shorter timeouts for downstream calls to prevent timeout amplification

### Database Anti-Patterns

- DON'T share a PostgreSQL database between microservices — each service owns its schema and data exclusively
- DON'T use Hibernate's \`ddl-auto\` in any profile except \`test\` — always use Flyway migrations
- DON'T write Flyway migrations that are not backward-compatible — every migration must support the previous application version (expand-contract pattern)
- DON'T query another service's database directly — emit a domain event or use a read-model projection populated by Kafka events

### General Anti-Patterns

- DON'T introduce new dependencies without adding them to the approved dependency list in \`gradle/libs.versions.toml\` and getting security review
- DON'T create integration adapters that exceed 300 lines — split into port interface, adapter implementation, and configuration class
- DON'T write integration tests that depend on external services being available — always use Testcontainers or WireMock
- DON'T merge integration code without contract tests verifying the event schema compatibility
- DON'T skip the \`./gradlew dependencyCheckAnalyze\` step — PCI DSS requires known-vulnerability scanning on every build

---

## Phase-Specific Patterns

### Outbox Pattern Implementation

\`\`\`
DO follow this structure for reliable event publishing:

services/{service-name}/
├── src/main/java/.../infrastructure/outbox/
│   ├── OutboxEvent.java              # JPA entity for outbox_events table
│   ├── OutboxEventRepository.java    # Spring Data JPA repository
│   ├── OutboxEventPublisher.java     # Scheduled poller that reads and publishes to Kafka
│   └── OutboxEventService.java       # Called within @Transactional business methods
\`\`\`

### Adapter Structure (Hexagonal Architecture)

\`\`\`
DO structure integration adapters following ports and adapters:

services/{service-name}/
├── src/main/java/.../domain/
│   └── port/
│       ├── inbound/                  # Use cases (driven by API or Kafka consumers)
│       └── outbound/                 # Repository ports, event publisher ports
├── src/main/java/.../infrastructure/
│   ├── adapter/
│   │   ├── inbound/
│   │   │   ├── rest/                 # Spring MVC controllers
│   │   │   └── kafka/               # @KafkaListener consumers
│   │   └── outbound/
│   │       ├── persistence/          # JPA repository implementations
│   │       ├── kafka/                # KafkaTemplate producers
│   │       └── external/             # Third-party API clients
│   └── config/                       # Spring @Configuration classes
\`\`\`

### Health Check Configuration

\`\`\`
DO configure readiness probes to check all critical dependencies:

management:
  endpoint:
    health:
      group:
        liveness:
          include: ping
        readiness:
          include: db, redis, kafka
      show-details: when_authorized
  health:
    kafka:
      enabled: true
    redis:
      enabled: true
\`\`\`

---

## Validation Checklist

Before completing Phase 05, Claude must verify:

- [ ] All inter-service communication flows through Kafka — no direct REST calls between services
- [ ] Every Kafka consumer has a dead-letter topic configured and tested
- [ ] Idempotent consumer logic is implemented with deduplication table
- [ ] Outbox Pattern is used for transactional event publishing
- [ ] All event schemas are registered in \`schema-registry/\`
- [ ] Contract tests exist for every published and consumed event
- [ ] Spring Security is configured with \`SecurityFilterChain\` — no deprecated patterns
- [ ] PCI DSS cardholder data is encrypted at rest and in transit
- [ ] Audit logging publishes to \`audit.security-events\` Kafka topic
- [ ] OWASP dependency-check passes with no CVSS >= 7.0 vulnerabilities
- [ ] Distributed tracing propagates through Kafka message headers
- [ ] All logs are structured JSON with traceId and correlationId
- [ ] Actuator endpoints are restricted and bound to internal port
- [ ] Circuit breakers are configured on all external integration points
- [ ] Resilience tests simulate broker/database/cache failures
- [ ] Flyway migrations are backward-compatible (expand-contract)
- [ ] No service shares a database with another service
- [ ] \`./gradlew build\` passes with all integration and contract tests green`,

  'playbook/claude-overrides/06-testing-quality.claude.md': `# Phase 06: Testing & Quality — Claude Override Rules

## Purpose

Strict DO/DON'T rules for Claude when generating or modifying tests, quality gates, and coverage configurations in this Spring Boot microservices platform. These rules enforce our testing pyramid, tooling choices, and compliance requirements for SOC 2 and PCI DSS.

---

## DO Rules

### Test Structure

- DO use JUnit 5 (\`org.junit.jupiter\`) exclusively — never JUnit 4 annotations or vintage engine
- DO organize tests in the standard Gradle layout: \`src/test/java\` for unit tests, \`src/integrationTest/java\` for integration tests, \`src/contractTest/java\` for Pact contract tests
- DO follow the naming convention: \`*Test.java\` for unit tests, \`*IntegrationTest.java\` for integration tests, \`*ContractTest.java\` for contract tests
- DO use \`@DisplayName\` on every test class and test method with human-readable descriptions
- DO group related assertions using \`assertAll()\` from JUnit 5
- DO use \`@Nested\` classes to organize test methods by scenario or method under test
- DO keep each test file under 300 lines — split into multiple test classes if needed

### Unit Tests

- DO use Mockito (\`@ExtendWith(MockitoExtension.class)\`) for mocking dependencies in domain and application layer tests
- DO test domain logic in complete isolation — no Spring context, no database, no Kafka
- DO use \`@Mock\` and \`@InjectMocks\` for service-layer unit tests
- DO verify both happy paths and error/edge cases for every public method
- DO write parameterized tests (\`@ParameterizedTest\` with \`@CsvSource\`, \`@MethodSource\`, \`@EnumSource\`) for methods with multiple input variations
- DO assert on domain events emitted by aggregate roots and domain services
- DO test custom validators, mappers, and converters as standalone unit tests
- DO use AssertJ (\`org.assertj.core.api.Assertions.assertThat\`) as the primary assertion library

### Integration Tests

- DO use Testcontainers for all infrastructure dependencies: PostgreSQL, Kafka, Redis
- DO annotate integration tests with \`@SpringBootTest\` and the appropriate Spring Profile (\`@ActiveProfiles("integration-test")\`)
- DO use \`@Testcontainers\` and \`@Container\` annotations for lifecycle management
- DO define shared container configurations in a base class per service (e.g., \`AbstractIntegrationTest\`)
- DO use \`@DynamicPropertySource\` to inject container connection properties into Spring context
- DO test the full request-response cycle for REST endpoints using \`WebTestClient\` or \`MockMvc\`
- DO verify Kafka producer/consumer behavior using \`EmbeddedKafkaBroker\` or Testcontainers Kafka
- DO test repository queries against a real PostgreSQL container — not H2
- DO verify database migrations (Flyway) run cleanly in integration tests
- DO use \`@Transactional\` with rollback for tests that mutate database state, or use \`@Sql\` scripts for setup/teardown

### Contract Tests

- DO use Pact JVM (\`au.com.dius.pact\`) for consumer-driven contract tests
- DO define consumer contracts for every Kafka event a service consumes
- DO define provider verification tests for every Kafka event a service produces
- DO store Pact files in the \`schema-registry/\` directory alongside Avro/JSON schemas
- DO run contract tests as a separate Gradle task: \`./gradlew contractTest\`
- DO verify contracts against the Pact Broker in CI before merging

### Spring Security Tests

- DO use \`@WithMockUser\`, \`@WithSecurityContext\`, or custom security test annotations for authenticated endpoint tests
- DO test authorization rules explicitly: verify 403 for unauthorized roles, 401 for unauthenticated requests
- DO test CORS configuration, CSRF protection, and rate limiting in integration tests
- DO verify that sensitive endpoints (payment, user PII) enforce proper authentication and audit logging
- DO test JWT token validation, expiration, and refresh flows

### Kafka Testing

- DO use \`@EmbeddedKafka\` or Testcontainers Kafka for Kafka integration tests
- DO verify message serialization/deserialization with the exact Avro or JSON schema from \`schema-registry/\`
- DO test consumer error handling: deserialization failures, poison pills, retry exhaustion, DLT routing
- DO test idempotency of consumers — send the same event twice and verify no duplicate side effects
- DO verify consumer group offsets are committed correctly
- DO test producer delivery guarantees: verify \`acks=all\` behavior and retry configuration
- DO use \`ConsumerRecord\` assertions to verify headers (correlation ID, event type, timestamp, source service)

### Coverage & Quality Gates

- DO enforce 80% line coverage minimum per service module via JaCoCo
- DO configure JaCoCo to fail the build if coverage drops below threshold: \`./gradlew jacocoTestCoverageVerification\`
- DO exclude generated code, configuration classes, and DTOs from coverage calculations
- DO run SpotBugs (\`./gradlew spotbugsMain\`) and treat high-confidence bugs as build failures
- DO run OWASP dependency-check (\`./gradlew dependencyCheckAnalyze\`) and fail on CVSS >= 7.0
- DO run Checkstyle (\`./gradlew checkstyleMain\`) and ktlint (\`./gradlew ktlintCheck\`) as quality gates
- DO generate a unified test report across all modules: \`./gradlew testReport\`

### Performance & Load Tests

- DO use Gatling or k6 for load tests, stored in \`tests/load/\`
- DO define performance baselines for critical paths: payment processing < 200ms p99, order creation < 150ms p99
- DO run load tests against a staging environment with production-like data volumes
- DO test Kafka consumer throughput under sustained load — verify no consumer lag accumulation

### Compliance-Specific Testing

- DO write explicit tests for PCI DSS requirements: card data encryption at rest, TLS in transit, access control enforcement
- DO write tests verifying audit log completeness: every mutation to sensitive data produces an audit event
- DO test data masking in logs — verify no PAN, CVV, or PII appears in log output
- DO test secret rotation: verify services handle credential changes without downtime
- DO verify health check endpoints (\`/actuator/health\`) report correct status for all dependencies

---

## DON'T Rules

### Test Structure

- DON'T use JUnit 4 annotations (\`@RunWith\`, \`@Rule\`, \`org.junit.Test\`) — use JUnit 5 equivalents
- DON'T use \`@SpringBootTest\` for unit tests — reserve it for integration tests only
- DON'T create test classes without any assertions — every \`@Test\` method must assert something
- DON'T use \`Thread.sleep()\` for async test synchronization — use \`Awaitility\` or \`CountDownLatch\`
- DON'T write tests that depend on execution order — each test must be independently runnable
- DON'T put test utilities or shared fixtures in \`src/main/java\` — use \`src/test/java\` or a \`test-support\` module

### Mocking

- DON'T mock domain entities or value objects — instantiate them directly
- DON'T use \`@MockBean\` in unit tests — it loads Spring context unnecessarily
- DON'T mock everything — if a class has no external dependencies, test it without mocks
- DON'T use PowerMock or any bytecode-manipulation mocking library — refactor the code instead
- DON'T mock \`final\` classes by enabling Mockito inline mock maker globally — design for testability

### Database Testing

- DON'T use H2 as a test database — it hides PostgreSQL-specific behavior and syntax differences
- DON'T rely on \`spring.jpa.hibernate.ddl-auto=create\` in tests — use Flyway migrations
- DON'T leave test data in the database between tests — ensure cleanup via rollback or truncation
- DON'T hardcode database ports in test configuration — use Testcontainers dynamic port mapping

### Kafka Testing

- DON'T test Kafka producers/consumers with mocked \`KafkaTemplate\` alone — verify actual serialization with a real broker
- DON'T skip testing dead letter topic (DLT) routing — poison pill handling is critical for production resilience
- DON'T assume message ordering across partitions — test with explicit partition assignment if order matters
- DON'T ignore consumer rebalancing scenarios in tests

### Security Testing

- DON'T skip authentication/authorization tests for any endpoint — even internal service endpoints
- DON'T hardcode test credentials, tokens, or API keys in test source files — use test fixtures or environment variables
- DON'T disable Spring Security in integration tests with \`@AutoConfigureMockMvc(addFilters = false)\` — test with security enabled
- DON'T test security in unit tests alone — always include integration tests that exercise the full filter chain

### Coverage & Quality

- DON'T write tests solely to increase coverage numbers — every test must validate meaningful behavior
- DON'T exclude packages from coverage without documenting the reason in \`build.gradle.kts\`
- DON'T suppress SpotBugs or Checkstyle warnings without a code comment explaining why
- DON'T skip OWASP dependency-check in CI — vulnerabilities must be addressed before merge
- DON'T merge code with failing quality gates — no \`@Disabled\` tests to bypass CI

### Anti-Patterns

- DON'T write integration tests that call other microservices over the network — use WireMock or Testcontainers
- DON'T create "god test" classes with 50+ test methods — split by feature or scenario
- DON'T use \`@SuppressWarnings\` in test code to hide legitimate issues
- DON'T copy-paste test methods with minor variations — use parameterized tests
- DON'T test private methods directly — test through the public API
- DON'T write tests that pass when the feature is broken (tautological tests)
- DON'T generate random test data without seeding — tests must be deterministic and reproducible
- DON'T create test doubles that silently swallow exceptions — propagate or assert on errors

---

## Test Configuration Reference

### Gradle Task Mapping

| Task | Scope | Command |
|------|-------|---------|
| Unit tests | Per service | \`./gradlew :services:order-service:test\` |
| Integration tests | Per service | \`./gradlew :services:order-service:integrationTest\` |
| Contract tests | Per service | \`./gradlew :services:order-service:contractTest\` |
| All tests | All modules | \`./gradlew test integrationTest contractTest\` |
| Coverage report | Per service | \`./gradlew :services:order-service:jacocoTestReport\` |
| Coverage check | All modules | \`./gradlew jacocoTestCoverageVerification\` |
| Static analysis | All modules | \`./gradlew checkstyleMain spotbugsMain ktlintCheck\` |
| Security scan | All modules | \`./gradlew dependencyCheckAnalyze\` |

### Spring Profiles for Testing

| Profile | Purpose |
|---------|---------|
| \`test\` | Unit tests — minimal config, no external deps |
| \`integration-test\` | Integration tests — Testcontainers, full Spring context |
| \`contract-test\` | Contract tests — Pact verification |
| \`performance-test\` | Load tests — staging environment targeting |

### Required Test Dependencies (per service \`build.gradle.kts\`)

\`\`\`kotlin
// Reference only — do not copy blindly, verify versions in shared/build-logic/
testImplementation("org.springframework.boot:spring-boot-starter-test")
testImplementation("org.springframework.security:spring-security-test")
testImplementation("org.springframework.kafka:spring-kafka-test")
testImplementation("org.testcontainers:junit-jupiter")
testImplementation("org.testcontainers:postgresql")
testImplementation("org.testcontainers:kafka")
testImplementation("org.assertj:assertj-core")
testImplementation("org.awaitility:awaitility")
testImplementation("au.com.dius.pact.consumer:junit5")
testImplementation("au.com.dius.pact.provider:junit5")
testImplementation("com.redis.testcontainers:testcontainers-redis-junit")
\`\`\`

---

## Cross-References

- Phase definition: \`playbook/phases/06-testing-quality.md\`
- Test suite generator prompt: \`playbook/prompts/06/test-suite-generator.md\`
- E2E test generator prompt: \`playbook/prompts/06/e2e-test-generator.md\`
- Load test prompt: \`playbook/prompts/06/load-test.md\`
- CI pipeline (test stages): \`playbook/prompts/03/ci-pipeline.md\`
- Security hardening (security tests): \`playbook/prompts/05/security-hardening.md\`
- Schema registry: \`schema-registry/\` (Kafka event schemas for contract tests)`,

  'playbook/claude-overrides/07-launch.claude.md': `---
description: Phase 07 Launch & Operations — Claude behavioral rules for Spring Boot microservices go-live and production operations
globs:
  - infrastructure/production/**
  - charts/*/values-production.yaml
  - charts/*/templates/**
  - docs/runbooks/**
  - docs/adr/**
  - .github/workflows/deploy-production*.yml
  - services/*/src/main/resources/application-prod.properties
  - services/*/src/main/resources/application-prod.yml
  - monitoring/**
  - scripts/release/**
  - scripts/rollback/**
---

# Phase 07: Launch & Operations — Claude Rules

## DO: Production Readiness for Spring Boot Services

- DO verify every microservice exposes \`/actuator/health\`, \`/actuator/health/readiness\`, and \`/actuator/health/liveness\` before any production deployment discussion
- DO confirm Kubernetes readiness and liveness probes in Helm chart templates point to the correct Actuator endpoints with appropriate \`initialDelaySeconds\`, \`periodSeconds\`, and \`failureThreshold\` values
- DO ensure \`application-prod.yml\` disables all debug/dev endpoints: \`management.endpoints.web.exposure.include\` must be limited to \`health,info,prometheus\`
- DO validate that \`management.endpoint.env.enabled=false\` and \`management.endpoint.configprops.enabled=false\` in production profiles to prevent credential leakage
- DO ensure every service has \`spring.jpa.open-in-view=false\` in production configuration
- DO confirm \`spring.datasource.hikari.maximum-pool-size\` is tuned per service based on expected load and RDS instance limits
- DO verify Kafka consumer \`max.poll.records\`, \`max.poll.interval.ms\`, and \`session.timeout.ms\` are tuned for production throughput
- DO ensure all Kafka topics have appropriate \`replication.factor >= 3\` and \`min.insync.replicas >= 2\` for production on MSK
- DO validate that every Helm \`values-production.yaml\` specifies resource requests AND limits for CPU and memory
- DO confirm pod disruption budgets exist for every service with \`minAvailable\` set appropriately
- DO ensure horizontal pod autoscaler configurations reference correct metrics (CPU, memory, or custom Kafka consumer lag metrics)

## DO: Runbooks and Operational Documentation

- DO generate runbooks in \`docs/runbooks/\` with concrete \`kubectl\`, \`aws\`, and \`./gradlew\` commands — never pseudocode
- DO include specific Kafka troubleshooting steps: checking consumer group lag via \`kafka-consumer-groups.sh --describe\`, resetting offsets, and reprocessing dead letter topics
- DO document PostgreSQL connection pool exhaustion diagnosis using Actuator metrics endpoint and HikariCP MBean queries
- DO include Redis connection failure recovery steps with Spring Cache fallback behavior documentation
- DO reference Grafana dashboard URLs and Jaeger trace search patterns in every runbook
- DO document the exact rollback procedure: Helm rollback command, database migration rollback via Flyway \`repair\` and \`undo\`, and Kafka consumer offset reset
- DO include escalation paths with Slack channel references and PagerDuty integration details

## DO: Deployment and Release

- DO ensure GitHub Actions production deployment workflow requires manual approval gate (\`environment: production\` with required reviewers)
- DO validate that Docker images are tagged with both the Git SHA and semantic version, never \`latest\` in production
- DO confirm images are pulled from ECR with immutable tags enabled
- DO ensure Helm releases use \`--atomic --timeout 10m\` to auto-rollback failed deployments
- DO verify canary or blue-green deployment strategy is configured in the Helm chart or Kubernetes deployment spec
- DO confirm database migrations run as a separate Kubernetes Job or init container, not during application startup
- DO ensure Flyway migrations are backward-compatible (no column drops, no renames without aliases) to support rolling deployments

## DO: Monitoring and Alerting

- DO configure Prometheus scraping for every service via \`management.metrics.export.prometheus.enabled=true\`
- DO ensure custom business metrics are registered using Micrometer \`MeterRegistry\` — order counts, payment processing times, event publish/consume rates
- DO set up alerts for: Kafka consumer lag > threshold, error rate > 1%, p99 latency > SLA, pod restart count, HikariCP active connections near max
- DO verify distributed tracing propagation: \`spring.sleuth.propagation.type=W3C\` or Micrometer Tracing with Brave/OpenTelemetry bridge configured
- DO confirm trace IDs appear in structured JSON logs via Logback MDC for ELK correlation
- DO ensure Grafana dashboards exist per service covering: request rate, error rate, latency percentiles, JVM heap usage, GC pause times, Kafka consumer lag, database connection pool utilization

## DO: Security and Compliance for Production

- DO verify all secrets are sourced from AWS Secrets Manager or Kubernetes Secrets — never from environment variables in plain text in Helm values
- DO confirm TLS termination at ALB with certificate from ACM, and mTLS between services if required by PCI DSS scope
- DO ensure Spring Security filters enforce authentication on all non-actuator endpoints
- DO validate that CORS configuration in API Gateway is restricted to known frontend domains only
- DO confirm audit logging captures: who, what, when, from-where for all state-changing operations (SOC 2 requirement)
- DO verify PCI DSS cardholder data is never logged — check Logback patterns and MDC keys for PAN, CVV, or expiry masking
- DO ensure \`X-Content-Type-Options\`, \`X-Frame-Options\`, \`Strict-Transport-Security\`, and \`Content-Security-Policy\` headers are set at the gateway level
- DO confirm OWASP dependency-check and Trivy container scan passed with zero critical/high vulnerabilities before production deploy

## DO: Go-Live Checklist Validation

- DO walk through every item in \`docs/runbooks/go-live-checklist.md\` and confirm evidence for each
- DO verify DNS cutover plan with Route53 weighted routing or failover routing policy
- DO confirm CloudWatch alarms exist for RDS CPU, free storage, and replica lag
- DO ensure ElastiCache Redis cluster has Multi-AZ enabled with automatic failover
- DO validate that MSK cluster has encryption at rest and in transit enabled
- DO confirm backup and disaster recovery: RDS automated backups with 30-day retention, Kafka topic data retention aligned with compliance requirements

## DON'T: Production Anti-Patterns

- DON'T generate production configurations with \`spring.profiles.active=dev\` or \`spring.profiles.active=local\`
- DON'T set \`logging.level.root=DEBUG\` or \`logging.level.org.springframework=TRACE\` in production profiles
- DON'T use \`spring.jpa.hibernate.ddl-auto=create\`, \`create-drop\`, or \`update\` in production — only \`validate\` or \`none\`
- DON'T expose Actuator endpoints without Spring Security protection in production — \`/actuator/**\` must require authentication or be network-restricted
- DON'T include H2 or embedded database dependencies in production Docker images
- DON'T hardcode database URLs, passwords, Kafka broker addresses, or Redis connection strings in \`application-prod.yml\`
- DON'T generate Kubernetes manifests without resource limits — unbounded pods risk node OOM kills
- DON'T use \`imagePullPolicy: Always\` without immutable tags — it causes unnecessary pull latency
- DON'T skip pod anti-affinity rules — co-located replicas on the same node defeat high availability
- DON'T generate rollback scripts that drop database columns or tables — Flyway undo migrations must be additive
- DON'T create monitoring configurations that alert on every single metric — focus on SLI/SLO-based alerting to avoid alert fatigue
- DON'T suggest direct \`kubectl exec\` into production pods as a standard operating procedure — use structured logging and tracing instead
- DON'T generate Helm charts that use \`helm upgrade --force\` in production — it causes unnecessary pod restarts
- DON'T allow Kafka \`auto.offset.reset=latest\` in production consumers without explicit justification — default to \`earliest\` for data completeness
- DON'T configure Kafka producers with \`acks=0\` or \`acks=1\` for financial transaction events — require \`acks=all\`
- DON'T skip dead letter topic configuration for any Kafka consumer — unprocessable messages must not block consumption
- DON'T generate any configuration that stores or logs PCI cardholder data (PAN, CVV, PIN, track data) in plain text
- DON'T create deployment pipelines that bypass the staging environment for production releases
- DON'T suggest SSH access to production nodes — all operations must go through Kubernetes API, CloudWatch, or centralized logging

## DON'T: Scope Violations During Launch Phase

- DON'T refactor service internals during launch — this phase is for operational readiness, not feature work
- DON'T introduce new Kafka topics or schema changes during go-live — schema registry changes require a separate release cycle
- DON'T modify Hexagonal Architecture port/adapter boundaries during production hardening
- DON'T add new service dependencies or inter-service communication patterns during launch
- DON'T change Gradle build configurations or dependency versions during release stabilization
- DON'T generate new database migrations during the go-live window — all schema changes must be pre-deployed and validated in staging

## Context: File-Specific Rules

- When editing \`infrastructure/production/**\`: treat every change as a PCI DSS-scoped modification requiring security review
- When editing \`charts/*/values-production.yaml\`: validate against the corresponding \`values-staging.yaml\` for configuration drift
- When editing \`docs/runbooks/**\`: include specific commands, expected outputs, and escalation contacts — never leave placeholders
- When editing \`.github/workflows/deploy-production*.yml\`: ensure manual approval gates, artifact verification, and rollback steps are present
- When editing \`services/*/src/main/resources/application-prod.*\`: cross-reference with Kubernetes ConfigMap/Secret mounts in the Helm chart
- When editing \`monitoring/**\`: ensure Prometheus recording rules, alerting rules, and Grafana dashboard JSON are consistent with service metric names`,

  'playbook/codeforge-phase.sh': `#!/usr/bin/env bash
set -euo pipefail

PLAYBOOK_DIR="$(cd "$(dirname "\${BASH_SOURCE[0]}")" && pwd)"
CLAUDE_DIR="$(dirname "$PLAYBOOK_DIR")/.claude"
SYMLINK_PATH="$CLAUDE_DIR/current-phase.md"
PHASES=("01-discovery" "02-design" "03-implement" "04-review" "05-deploy" "06-operate")
PHASE_NAMES=("Discovery & Planning" "Architecture & Design" "Implementation" "Code Review & QA" "Deploy & Release" "Operate & Monitor")

get_current_phase() {
  if [[ -L "$SYMLINK_PATH" ]]; then
    local target
    target="$(readlink "$SYMLINK_PATH")"
    basename "$target" .md | sed 's/phase-//'
  else
    echo "none"
  fi
}

find_phase_index() {
  local query="$1"
  for i in "\${!PHASES[@]}"; do
    if [[ "\${PHASES[$i]}" == "$query" ]] || [[ "\${PHASES[$i]}" == *"$query"* ]] || [[ "$((i + 1))" == "$query" ]]; then
      echo "$i"
      return 0
    fi
  done
  return 1
}

phase_file() {
  echo "$PLAYBOOK_DIR/phase-\${PHASES[$1]}.md"
}

set_phase() {
  local idx="$1"
  local file
  file="$(phase_file "$idx")"
  if [[ ! -f "$file" ]]; then
    echo "ERROR: Phase file not found: $file" >&2
    exit 1
  fi
  mkdir -p "$CLAUDE_DIR"
  ln -sf "$file" "$SYMLINK_PATH"
  echo "✓ Phase set to \${PHASES[$idx]} — \${PHASE_NAMES[$idx]}"
  echo "  Symlink: $SYMLINK_PATH → $file"
}

cmd_status() {
  local current
  current="$(get_current_phase)"
  echo "═══════════════════════════════════════════════"
  echo " CodeForge Phase Status — spring-boot-microservices"
  echo "═══════════════════════════════════════════════"
  for i in "\${!PHASES[@]}"; do
    local marker="  "
    if [[ "\${PHASES[$i]}" == "$current" ]]; then
      marker="▶ "
    fi
    local file_status="✓"
    [[ ! -f "$(phase_file "$i")" ]] && file_status="✗"
    printf " %s %d. %-20s %s  [%s]\\n" "$marker" "$((i + 1))" "\${PHASES[$i]}" "\${PHASE_NAMES[$i]}" "$file_status"
  done
  echo "═══════════════════════════════════════════════"
  if [[ "$current" == "none" ]]; then
    echo " No active phase. Run: $(basename "$0") set 1"
  fi
}

cmd_set() {
  local query="\${1:-}"
  if [[ -z "$query" ]]; then
    echo "Usage: $(basename "$0") set <phase-number|phase-name>" >&2
    exit 1
  fi
  local idx
  if ! idx="$(find_phase_index "$query")"; then
    echo "ERROR: Unknown phase '$query'. Valid: \${PHASES[*]}" >&2
    exit 1
  fi
  set_phase "$idx"
}

cmd_advance() {
  local current
  current="$(get_current_phase)"
  if [[ "$current" == "none" ]]; then
    set_phase 0
    return
  fi
  local idx
  idx="$(find_phase_index "$current")"
  local next=$((idx + 1))
  if [[ $next -ge \${#PHASES[@]} ]]; then
    echo "Already at final phase: \${PHASES[$idx]} — \${PHASE_NAMES[$idx]}"
    echo "Hint: Run './gradlew build' and check Grafana dashboards before cycling back."
    exit 0
  fi
  echo "Advancing: \${PHASES[$idx]} → \${PHASES[$next]}"
  set_phase "$next"
}

cmd_revert() {
  local current
  current="$(get_current_phase)"
  if [[ "$current" == "none" ]]; then
    echo "No active phase to revert from." >&2
    exit 1
  fi
  local idx
  idx="$(find_phase_index "$current")"
  if [[ $idx -le 0 ]]; then
    echo "Already at first phase: \${PHASES[0]} — \${PHASE_NAMES[0]}"
    exit 0
  fi
  local prev=$((idx - 1))
  echo "Reverting: \${PHASES[$idx]} → \${PHASES[$prev]}"
  set_phase "$prev"
}

cmd_help() {
  cat <<EOF
CodeForge Phase Manager — spring-boot-microservices

Usage: $(basename "$0") <command> [args]

Commands:
  status              Show current phase and all available phases
  set <phase>         Switch to a specific phase (number or name fragment)
  advance             Move to the next phase
  revert              Move to the previous phase
  help                Show this help message

Examples:
  $(basename "$0") status
  $(basename "$0") set 3
  $(basename "$0") set implement
  $(basename "$0") advance
  $(basename "$0") revert

Phases map to development methodology for SOC 2 / PCI DSS compliant
microservice delivery using Spring Boot, Kafka, and Kubernetes.
EOF
}

case "\${1:-status}" in
  status)  cmd_status ;;
  set)     cmd_set "\${2:-}" ;;
  advance) cmd_advance ;;
  revert)  cmd_revert ;;
  help|-h|--help) cmd_help ;;
  *)
    echo "Unknown command: $1" >&2
    cmd_help >&2
    exit 1
    ;;
esac`,

  'playbook/current-phase.json': `{
  "currentPhase": 1,
  "phaseId": "planning",
  "startedAt": null,
  "updatedAt": null,
  "totalPhases": 6
}`,

  'playbook/phases/01-discovery.md': `# Phase 01: Discovery & Requirements

## Overview

The Discovery phase establishes a shared understanding of what a new microservice, feature, or cross-cutting change must accomplish before any code is written. In this Spring Boot/Kafka platform, discovery is especially critical because changes ripple across service boundaries, Kafka topic topologies, database schemas, and Kubernetes deployment configurations.

**Duration**: 1–3 days (single service feature) / 3–7 days (new microservice or cross-cutting concern)

**Phase Gate**: This phase must be completed and approved before advancing to \`02-planning\`.

---

## Objectives

1. **Define the business problem** — Capture the Jira epic/story requirements, acceptance criteria, and compliance constraints (SOC 2, PCI DSS) that apply.
2. **Identify bounded context** — Determine whether the work belongs in an existing service (\`services/order-service\`, \`services/payment-service\`, \`services/user-service\`) or requires a new bounded context.
3. **Map domain events** — Enumerate every Kafka event that will be produced or consumed, including schema changes in \`schema-registry/\`.
4. **Clarify data ownership** — Confirm which service owns which data and how other services will access it (event-driven projection, not direct REST calls).
5. **Assess compliance impact** — Flag any PCI DSS scope changes (payment card data, tokenization) or SOC 2 audit trail requirements.
6. **Identify integration points** — Document upstream/downstream service dependencies, API gateway routing changes, and external system integrations.
7. **Establish non-functional requirements** — Latency budgets, throughput targets, availability SLAs, data retention policies.

---

## Inputs

| Input | Source | Description |
|---|---|---|
| Jira Epic / Stories | Jira (via MCP) | Business requirements and acceptance criteria |
| Architecture Decision Records | \`docs/adr/\` | Existing architectural constraints and decisions |
| Domain Event Catalog | \`schema-registry/\` | Current Avro/JSON schemas for all Kafka topics |
| Service Dependency Map | \`docs/ARCHITECTURE.md\` | Current service topology and communication flows |
| Compliance Matrix | Confluence | SOC 2 controls and PCI DSS requirements mapping |
| Monitoring Baselines | Grafana / Prometheus | Current latency, throughput, and error rate metrics |
| API Gateway Routes | \`gateway/src/main/resources/application.yml\` | Existing route definitions in Spring Cloud Gateway |

---

## Activities

### 1. Requirements Elicitation

- Review the Jira epic and all linked stories. Ensure every story has clear acceptance criteria.
- Conduct a brief stakeholder session (or async Slack thread) to clarify ambiguities.
- For financial features: confirm regulatory requirements with the compliance team.

**Claude Usage**: Use \`/plan\` to generate an initial requirements summary from the Jira ticket context. Claude can parse acceptance criteria and flag gaps.

### 2. Bounded Context Analysis

Determine where the work lives in the domain model:

\`\`\`
Question Checklist:
├── Does this feature modify an existing aggregate root?
│   └── If yes → work within the existing service module
├── Does this introduce a new aggregate with its own lifecycle?
│   └── If yes → consider a new microservice under services/
├── Does this cross multiple bounded contexts?
│   └── If yes → define the event contracts between contexts
└── Does this require shared logic?
    └── If yes → evaluate placement in shared/ libraries
\`\`\`

- Reference \`docs/ARCHITECTURE.md\` for the current hexagonal architecture layout.
- Each service follows Ports & Adapters: confirm which ports (inbound/outbound) are affected.

### 3. Domain Event Mapping

For every state change the feature introduces, define the domain event:

| Event Name | Topic | Producer | Consumers | Schema Location |
|---|---|---|---|---|
| \`OrderCreated\` | \`orders.events\` | order-service | payment-service, notification-service | \`schema-registry/orders/OrderCreated.avsc\` |
| \`PaymentProcessed\` | \`payments.events\` | payment-service | order-service, ledger-service | \`schema-registry/payments/PaymentProcessed.avsc\` |

Rules:
- **No direct REST calls between services.** All inter-service communication flows through Kafka.
- Every event must have a schema registered in \`schema-registry/\` before implementation begins.
- Use the naming convention: \`<AggregateAction>\` in PascalCase (e.g., \`PaymentRefunded\`, \`UserVerified\`).
- Topic naming convention: \`<domain>.events\` for domain events, \`<domain>.commands\` for command topics.
- Define consumer group naming: \`<consuming-service>.<topic-name>-group\`.

### 4. Data Ownership & Storage Analysis

Each microservice owns its PostgreSQL database. During discovery:

- Identify new tables, columns, or indexes required.
- Confirm no service reads another service's database directly.
- If a service needs data owned by another service, define the event-driven projection strategy.
- For PCI DSS scoped data: confirm encryption at rest (AWS RDS encryption), field-level encryption for PAN/CVV, and tokenization strategy.
- Determine Redis caching needs: cache keys, TTLs, eviction policies, and whether data is session-scoped or shared.

### 5. API Surface Analysis

For any new or modified REST endpoints exposed through the API gateway:

- Define the OpenAPI spec (each service maintains its own under \`services/<name>/src/main/resources/openapi/\`).
- Determine authentication/authorization requirements (Spring Security, JWT scopes, role-based access).
- Define rate limiting and throttling rules at the gateway level.
- Confirm the gateway route pattern in \`gateway/src/main/resources/application.yml\`.

### 6. Compliance & Security Assessment

| Check | Applies? | Notes |
|---|---|---|
| Handles payment card data (PCI DSS) | ☐ | Tokenization required, no PAN in logs |
| Stores PII (SOC 2) | ☐ | Encryption at rest, audit trail required |
| New authentication/authorization flow | ☐ | Review with security team, update \`**/security/**\` |
| New external integration | ☐ | Vendor security assessment required |
| Audit logging required | ☐ | Spring Actuator + ELK pipeline |
| Data retention policy applies | ☐ | Define TTL and archival strategy |

Any change touching \`**/security/**\`, \`**/auth/**\`, \`infrastructure/production/**\`, or \`*.properties\` files requires security team review per CODEOWNERS.

### 7. Non-Functional Requirements

Define concrete targets:

\`\`\`yaml
performance:
  p99_latency_ms: 200          # API response time
  throughput_rps: 1000          # Requests per second per instance
  kafka_consumer_lag_max: 500   # Maximum consumer lag in messages

availability:
  sla_percent: 99.95
  health_check_endpoint: /actuator/health
  circuit_breaker_threshold: 50%

scalability:
  min_replicas: 2
  max_replicas: 10
  cpu_target_percent: 70

observability:
  distributed_tracing: required  # Jaeger
  custom_metrics: required       # Prometheus via Micrometer
  structured_logging: required   # ELK via Logback JSON
  alert_rules: required          # Grafana alerting
\`\`\`

### 8. Infrastructure Impact Assessment

Evaluate changes needed in:

- **Terraform** (\`infrastructure/\`): New RDS instances, ElastiCache clusters, MSK topic configurations, IAM roles.
- **Helm Charts** (\`charts/\`): New chart for a new service, or values changes for existing services.
- **Kubernetes**: Resource requests/limits, HPA configuration, network policies, secrets.
- **CI/CD** (\`.github/workflows/\`): New pipeline for a new service, or stage modifications.

---

## Deliverables

### Required Deliverables

| # | Deliverable | Format | Location |
|---|---|---|---|
| 1 | **Discovery Document** | Markdown | \`docs/discovery/<ticket-id>-discovery.md\` |
| 2 | **Domain Event Schemas (Draft)** | Avro / JSON Schema | \`schema-registry/<domain>/\` (as drafts) |
| 3 | **OpenAPI Spec (Draft)** | YAML | \`services/<name>/src/main/resources/openapi/\` |
| 4 | **Compliance Checklist** | Markdown table | Included in Discovery Document |
| 5 | **Updated Jira Stories** | Jira tickets | Refined acceptance criteria, story points estimated |

### Conditional Deliverables

| # | Deliverable | When Required |
|---|---|---|
| 6 | **Architecture Decision Record** | New service, new technology, or significant pattern change |
| 7 | **Threat Model** | PCI DSS scope change or new external integration |
| 8 | **Infrastructure Change Request** | New AWS resources or Terraform changes |

### Discovery Document Template

\`\`\`markdown
# Discovery: [TICKET-ID] — [Feature Title]

## Business Context
<!-- What problem are we solving? Who benefits? -->

## Bounded Context
<!-- Which service(s) are affected? Is a new service needed? -->
- Service(s): \`services/<name>\`
- New service required: Yes / No

## Domain Events
<!-- Table of events produced and consumed -->
| Event | Topic | Producer | Consumers | Schema |
|-------|-------|----------|-----------|--------|

## Data Model Changes
<!-- New tables, columns, indexes per service database -->
- Service: \`<name>\`
- Database changes: ...
- Redis caching: ...

## API Changes
<!-- New or modified endpoints -->
- Endpoint: \`POST /api/v1/...\`
- Auth: JWT scope \`<scope>\`
- Gateway route: ...

## Compliance Impact
<!-- SOC 2 / PCI DSS considerations -->

## Non-Functional Requirements
<!-- Performance, availability, scalability targets -->

## Infrastructure Changes
<!-- Terraform, Helm, K8s changes needed -->

## Open Questions
<!-- Unresolved items requiring follow-up -->

## Decision Log
<!-- Key decisions made during discovery -->
| Decision | Rationale | Date | Participants |
|----------|-----------|------|--------------|
\`\`\`

---

## Quality Gates

All gates must pass before advancing to Phase 02 (Planning).

### Gate 1: Requirements Completeness

- [ ] Every Jira story has acceptance criteria with testable conditions
- [ ] Business stakeholder has confirmed requirements (Slack thread or meeting notes linked)
- [ ] Edge cases and error scenarios are documented
- [ ] No open questions remain that would block planning

### Gate 2: Domain Model Clarity

- [ ] Bounded context is identified and documented
- [ ] Affected aggregates and entities are listed
- [ ] Hexagonal architecture ports (inbound/outbound) are identified
- [ ] No ambiguity about which service owns which data

### Gate 3: Event Contract Definition

- [ ] All new domain events are listed with topic, producer, and consumer(s)
- [ ] Draft Avro/JSON schemas exist in \`schema-registry/\` (even if marked as draft)
- [ ] Event naming follows \`<AggregateAction>\` PascalCase convention
- [ ] Topic naming follows \`<domain>.events\` / \`<domain>.commands\` convention
- [ ] Consumer group naming follows \`<consuming-service>.<topic-name>-group\` convention
- [ ] No direct REST calls between services are proposed

### Gate 4: Compliance Sign-Off

- [ ] PCI DSS scope impact assessed (or confirmed not applicable)
- [ ] SOC 2 audit trail requirements identified
- [ ] Sensitive data handling strategy documented (encryption, tokenization, masking)
- [ ] Security team notified if \`**/security/**\` or \`**/auth/**\` paths are affected
- [ ] Data retention and deletion requirements defined

### Gate 5: Non-Functional Requirements Defined

- [ ] Latency, throughput, and availability targets are specified with concrete numbers
- [ ] Observability requirements defined (metrics, traces, logs, alerts)
- [ ] Scalability parameters documented (min/max replicas, resource limits)

### Gate 6: Infrastructure Feasibility

- [ ] Required AWS resources identified (RDS, ElastiCache, MSK topics, etc.)
- [ ] Helm chart changes scoped (new chart or values modifications)
- [ ] No infrastructure blockers identified (or blockers have mitigation plans)

### Gate 7: Team Alignment

- [ ] Discovery document reviewed by at least 1 lead engineer
- [ ] At least 2 team members approve the discovery document (PR to \`docs/discovery/\`)
- [ ] Cross-timezone review completed (Europe + Americas both had opportunity to review)

---

## Claude Integration

### Recommended Commands

| Command | Usage in Discovery |
|---|---|
| \`/plan\` | Generate initial requirements breakdown from Jira ticket context |
| \`/phase discovery\` | Validate current deliverables against Phase 01 quality gates |
| \`/verify\` | Check that draft schemas and OpenAPI specs are syntactically valid |

### Discovery Prompts for Claude

**Requirements Analysis**:
> Analyze Jira ticket [TICKET-ID] and identify: (1) the bounded context, (2) domain events needed, (3) data ownership implications, (4) compliance considerations for PCI DSS and SOC 2.

**Event Schema Design**:
> Given the domain event \`PaymentProcessed\` on topic \`payments.events\`, generate a draft Avro schema following our schema-registry conventions. Include fields for correlation ID, timestamp, and the payment aggregate state.

**Gap Analysis**:
> Review the discovery document at \`docs/discovery/PAY-123-discovery.md\` against the Phase 01 quality gates. Identify any missing items or open questions that would block advancement to Phase 02.

---

## Anti-Patterns to Avoid

| Anti-Pattern | Why It's Harmful | What to Do Instead |
|---|---|---|
| Skipping event mapping | Leads to ad-hoc REST calls between services | Map every inter-service data flow as a Kafka event |
| Vague NFRs ("should be fast") | Cannot be tested or validated | Define concrete numbers: p99 < 200ms, 1000 RPS |
| Shared database assumptions | Violates service autonomy, creates coupling | Each service owns its PostgreSQL instance |
| Ignoring compliance early | Costly rework when security review catches issues late | Complete compliance checklist during discovery |
| Gold-plating discovery | Analysis paralysis delays delivery | Time-box discovery: 1–3 days for features, 3–7 for new services |
| Single-timezone review | Excludes half the team from input | Allow 24-hour review window for async feedback |

---

## Transition to Phase 02

When all quality gates pass:

1. Merge the discovery document PR to \`main\`
2. Update \`playbook/current-phase.json\`:
   \`\`\`json
   {
     "current_phase": "02-planning",
     "ticket_id": "<TICKET-ID>",
     "started_at": "<ISO-8601>",
     "discovery_doc": "docs/discovery/<ticket-id>-discovery.md"
   }
   \`\`\`
3. Move Jira ticket status to "Planning"
4. Notify the team in Slack: \`#backend-engineering\`
5. Proceed to [Phase 02: Planning & Design](./02-planning.md)`,

  'playbook/phases/02-architecture.md': `# Phase 02: Architecture & Design

## Phase Overview

| Attribute        | Value                                                    |
|------------------|----------------------------------------------------------|
| **Phase ID**     | \`02-architecture\`                                        |
| **Predecessor**  | \`01-planning\` (must be complete)                         |
| **Successor**    | \`03-implementation\`                                      |
| **Duration**     | 3–7 days depending on service count                      |
| **Owner**        | Tech Lead / Architect                                    |
| **Participants** | Senior developers, DevOps lead, Security champion        |
| **Jira Label**   | \`phase:architecture\`                                     |

## Objectives

1. **Define bounded contexts** — Map each microservice to a domain boundary (order, payment, user, notification, etc.) with clear ownership and data isolation.
2. **Design Kafka event topology** — Specify topics, partitioning strategies, consumer groups, event schemas, and ordering guarantees for all inter-service communication.
3. **Establish hexagonal architecture per service** — Define ports (inbound/outbound), adapters (REST, Kafka, JPA, Redis), and domain core boundaries for every service module.
4. **Design data architecture** — PostgreSQL schema per service, Redis caching strategy, data ownership rules, and eventual consistency patterns.
5. **Define API contracts** — OpenAPI 3.1 specs for gateway-exposed endpoints; Avro/JSON Schema for Kafka events in \`schema-registry/\`.
6. **Plan infrastructure topology** — AWS resource layout (EKS cluster, RDS instances, MSK cluster, ElastiCache, ALB), networking (VPC, subnets, security groups), and Helm chart structure.
7. **Address compliance requirements** — Ensure SOC 2 and PCI DSS controls are embedded in the architecture (encryption at rest/in transit, audit logging, access controls, data classification).
8. **Produce Architecture Decision Records (ADRs)** — Document every significant decision with context, options considered, and rationale.

## Inputs (from Phase 01)

- Approved Jira epics and user stories with acceptance criteria
- Domain model and entity relationship overview
- Non-functional requirements (latency, throughput, availability targets)
- Risk register and compliance constraints
- Team capacity and skill matrix

## Deliverables

### D1: Service Decomposition Map

A document or diagram showing:

- Each microservice module under \`services/\` with its bounded context
- Shared libraries under \`shared/\` and what each contains
- Gateway routing rules in \`gateway/\`
- Data ownership — which service owns which entities

**Location**: \`docs/architecture/service-decomposition.md\`

### D2: Kafka Event Topology

| Element              | Detail                                                              |
|----------------------|---------------------------------------------------------------------|
| **Topics**           | Named \`<domain>.<entity>.<event>\` (e.g., \`payment.transaction.completed\`) |
| **Partitioning**     | Partition key strategy per topic (e.g., \`customerId\`, \`orderId\`)    |
| **Consumer Groups**  | Named \`<service>-<purpose>-cg\` (e.g., \`notification-email-cg\`)     |
| **Schemas**          | Avro or JSON Schema in \`schema-registry/\` per event type            |
| **Ordering**         | Document which events require strict ordering and partition strategy |
| **Retention**        | Per-topic retention policy (default 7 days, audit topics 90 days)   |
| **DLQ**              | Dead letter topic per consumer group: \`<topic>.dlq\`                 |
| **Idempotency**      | Producer idempotency enabled; consumer deduplication strategy        |

**Location**: \`docs/architecture/kafka-topology.md\` and \`schema-registry/\`

### D3: Hexagonal Architecture Blueprint (per service)

For each service, define:

\`\`\`
services/<service-name>/
├── src/main/java/com/company/<service>/
│   ├── domain/              # Entities, value objects, domain events, domain services
│   │   ├── model/
│   │   ├── event/
│   │   └── service/
│   ├── application/         # Use cases, command/query handlers, port interfaces
│   │   ├── port/
│   │   │   ├── inbound/     # Driving ports (use case interfaces)
│   │   │   └── outbound/    # Driven ports (repository, messaging, external)
│   │   └── service/         # Application service implementations
│   ├── adapter/
│   │   ├── inbound/
│   │   │   ├── rest/        # Spring MVC controllers, DTOs, mappers
│   │   │   └── kafka/       # Kafka consumers (event listeners)
│   │   └── outbound/
│   │       ├── persistence/ # JPA repositories, entities, mappers
│   │       ├── kafka/       # Kafka producers (event publishers)
│   │       ├── redis/       # Redis cache adapters
│   │       └── external/    # External API clients
│   └── config/              # Spring configuration, security, Kafka config
├── src/main/resources/
│   ├── application.yml
│   ├── application-local.yml
│   ├── application-staging.yml
│   └── db/migration/        # Flyway migrations
├── src/test/
│   ├── unit/                # JUnit 5 + Mockito
│   ├── integration/         # Testcontainers (Postgres, Kafka, Redis)
│   └── contract/            # Pact provider/consumer tests
├── Dockerfile
├── build.gradle.kts
└── helm/
    └── <service-name>/
\`\`\`

**Location**: \`docs/architecture/hexagonal-blueprint.md\`

### D4: Data Architecture

- **Per-service PostgreSQL schemas** — Entity diagrams, Flyway migration naming convention (\`V{version}__{description}.sql\`)
- **Redis usage plan** — Cache keys, TTLs, eviction policies, session storage format
- **Data classification** — PCI DSS cardholder data mapping, PII identification, encryption requirements
- **Eventual consistency patterns** — Saga orchestration vs. choreography decisions per workflow

**Location**: \`docs/architecture/data-architecture.md\`

### D5: API Contract Specifications

- **REST APIs**: OpenAPI 3.1 specs in \`services/<service>/src/main/resources/openapi/\`
- **Kafka Events**: Avro schemas or JSON Schemas in \`schema-registry/<domain>/<event>.avsc\`
- **Gateway Routes**: Route definitions mapping external paths to internal services

**Location**: \`docs/architecture/api-contracts.md\`, \`schema-registry/\`, service OpenAPI dirs

### D6: Infrastructure Architecture

- **AWS resource diagram** — EKS, RDS (Multi-AZ), MSK, ElastiCache, ECR, ALB, Route53, CloudWatch
- **Terraform module structure** under \`infrastructure/\`
- **Helm chart structure** under \`charts/\` — one chart per service plus shared chart for common resources
- **Environment strategy** — \`local\` (Docker Compose), \`staging\` (EKS), \`production\` (EKS Multi-AZ)
- **Networking** — VPC layout, private/public subnets, security groups, service mesh considerations

**Location**: \`docs/architecture/infrastructure.md\`, \`infrastructure/\`, \`charts/\`

### D7: Security Architecture

| Control                    | Implementation                                                        |
|----------------------------|-----------------------------------------------------------------------|
| **Authentication**         | Spring Security + OAuth 2.0 / JWT via API Gateway                     |
| **Authorization**          | Role-based access control (RBAC) with Spring Security method security  |
| **Encryption in transit**  | TLS 1.3 everywhere — service-to-service, Kafka, Redis, PostgreSQL     |
| **Encryption at rest**     | AWS KMS for RDS, S3; application-level encryption for PCI data        |
| **Secrets management**     | AWS Secrets Manager, Kubernetes Secrets (sealed), no secrets in code   |
| **Audit logging**          | Structured audit events to dedicated Kafka topic \`audit.security.log\` |
| **Input validation**       | Jakarta Bean Validation on all inbound DTOs                           |
| **Dependency scanning**    | OWASP dependency-check in CI, Snyk for container images               |
| **Network segmentation**   | Private subnets for services, public only for ALB                     |
| **PCI DSS scope**          | Cardholder data isolated to payment-service, tokenization strategy    |

**Location**: \`docs/architecture/security.md\`

### D8: Architecture Decision Records

Create ADRs in \`docs/adr/\` using the format:

\`\`\`
docs/adr/
├── 0001-use-hexagonal-architecture.md
├── 0002-kafka-over-rest-for-inter-service.md
├── 0003-postgresql-per-service.md
├── 0004-redis-caching-strategy.md
├── 0005-avro-for-event-schemas.md
├── 0006-saga-choreography-for-order-flow.md
├── 0007-spring-cloud-gateway.md
├── 0008-helm-per-service-deployment.md
└── ...
\`\`\`

Each ADR follows:

\`\`\`markdown
# ADR-NNNN: Title

## Status
Proposed | Accepted | Deprecated | Superseded

## Context
Why this decision is needed.

## Decision
What we decided.

## Consequences
Trade-offs, risks, follow-up actions.
\`\`\`

**Location**: \`docs/adr/\`

### D9: Observability Design

- **Distributed tracing**: Micrometer Tracing with Jaeger exporter, trace context propagation through Kafka headers
- **Metrics**: Spring Boot Actuator → Prometheus → Grafana dashboards per service
- **Logging**: Structured JSON logs (Logback) → ELK Stack, correlation IDs in MDC
- **Health checks**: Spring Actuator \`/actuator/health\` with liveness and readiness probes for Kubernetes
- **Alerting**: Grafana alert rules for SLO breaches (latency p99, error rate, Kafka consumer lag)

**Location**: \`docs/architecture/observability.md\`

## Activities

### Week 1: Core Architecture

| Day | Activity                                                                 | Owner          |
|-----|--------------------------------------------------------------------------|----------------|
| 1   | Review Phase 01 outputs; identify bounded contexts from domain model     | Architect      |
| 2   | Design service decomposition map and data ownership                      | Architect + Leads |
| 3   | Design Kafka event topology — topics, schemas, consumer groups           | Architect + Senior devs |
| 4   | Define hexagonal package structure per service; create module skeletons   | Tech Lead      |
| 5   | Design data architecture — schemas, migrations, Redis strategy           | Senior devs    |

### Week 2: Contracts, Infra, Security

| Day | Activity                                                                 | Owner          |
|-----|--------------------------------------------------------------------------|----------------|
| 1   | Write OpenAPI specs for gateway-exposed endpoints                        | Senior devs    |
| 2   | Write Avro/JSON schemas for all domain events                            | Senior devs    |
| 3   | Design infrastructure topology; draft Terraform modules                  | DevOps Lead    |
| 4   | Security architecture review — PCI DSS scope, encryption, auth flows     | Security champion |
| 5   | Finalize ADRs; architecture review meeting with full team                | All            |

## Using Claude in This Phase

### Architecture Review

\`\`\`
/architect review docs/architecture/service-decomposition.md
\`\`\`

Claude validates bounded context boundaries, checks for coupling between services, and flags shared mutable state.

### Kafka Topology Validation

\`\`\`
/architect review docs/architecture/kafka-topology.md
\`\`\`

Claude checks for missing DLQ definitions, inconsistent naming, partition key issues, and schema compatibility.

### ADR Drafting

\`\`\`
/plan --scope architecture --ticket ARCH-042
\`\`\`

Claude drafts ADR content based on the Jira ticket context, including alternatives considered and trade-off analysis.

### Schema Review

\`\`\`
/code-review schema-registry/payment/transaction-completed.avsc
\`\`\`

Claude validates Avro schema evolution compatibility, field naming conventions, and required documentation fields.

## Quality Gates

All gates must pass before advancing to Phase 03.

### Gate 1: Service Boundaries Validated

- [ ] Each microservice maps to exactly one bounded context
- [ ] No shared mutable state between services
- [ ] All inter-service communication flows through Kafka — zero direct REST calls between services
- [ ] Data ownership is unambiguous — every entity has exactly one owning service
- [ ] Service decomposition reviewed and approved by at least 2 senior developers

### Gate 2: Kafka Topology Complete

- [ ] Every domain event has a named topic following \`<domain>.<entity>.<event>\` convention
- [ ] Every topic has a defined partition key strategy
- [ ] Every consumer group follows \`<service>-<purpose>-cg\` naming
- [ ] Every topic has a corresponding DLQ topic
- [ ] All event schemas exist in \`schema-registry/\` with documentation
- [ ] Schema compatibility mode defined (BACKWARD, FORWARD, or FULL)
- [ ] Idempotency and deduplication strategy documented per consumer

### Gate 3: Hexagonal Architecture Defined

- [ ] Every service follows the hexagonal package structure in D3
- [ ] Port interfaces defined for all inbound and outbound boundaries
- [ ] Domain layer has zero dependencies on Spring framework or infrastructure
- [ ] Adapter layer clearly separated from application and domain layers
- [ ] Gradle module structure created with correct dependency directions

### Gate 4: API Contracts Specified

- [ ] OpenAPI 3.1 specs exist for all gateway-exposed endpoints
- [ ] Avro/JSON schemas exist for all Kafka events
- [ ] Request/response DTOs documented with validation constraints
- [ ] Error response format standardized across services
- [ ] Pact contract test stubs generated from specs

### Gate 5: Data Architecture Approved

- [ ] Per-service PostgreSQL schema designed with Flyway migration plan
- [ ] Redis cache keys, TTLs, and eviction policies documented
- [ ] PCI DSS cardholder data elements identified and isolated to payment-service
- [ ] PII fields identified with encryption-at-rest strategy
- [ ] Eventual consistency patterns (saga/choreography) documented per workflow

### Gate 6: Infrastructure Designed

- [ ] AWS resource topology documented and diagrammed
- [ ] Terraform module structure defined under \`infrastructure/\`
- [ ] Helm chart structure defined under \`charts/\` — one per service
- [ ] Environment strategy documented (local, staging, production)
- [ ] Resource sizing estimates for staging and production

### Gate 7: Security Architecture Reviewed

- [ ] Authentication and authorization flows documented
- [ ] TLS 1.3 enforced for all communication channels
- [ ] Secrets management strategy defined (no secrets in code or config files)
- [ ] Audit logging design covers SOC 2 requirements
- [ ] PCI DSS scope minimized and documented
- [ ] Security architecture reviewed by security champion
- [ ] OWASP Top 10 mitigations mapped to architecture controls

### Gate 8: ADRs Documented

- [ ] Minimum 5 ADRs covering major architectural decisions
- [ ] Each ADR includes context, decision, and consequences
- [ ] ADRs reviewed and accepted by architect and tech leads
- [ ] ADR index maintained in \`docs/adr/README.md\`

### Gate 9: Observability Designed

- [ ] Distributed tracing strategy with Kafka header propagation
- [ ] Prometheus metrics and Grafana dashboard plan per service
- [ ] Structured logging format with correlation ID propagation
- [ ] Kubernetes health check endpoints defined (liveness + readiness)
- [ ] SLO definitions and alerting thresholds documented

## Phase Completion Checklist

\`\`\`json
{
  "phase": "02-architecture",
  "status": "complete",
  "gates_passed": [
    "service-boundaries-validated",
    "kafka-topology-complete",
    "hexagonal-architecture-defined",
    "api-contracts-specified",
    "data-architecture-approved",
    "infrastructure-designed",
    "security-architecture-reviewed",
    "adrs-documented",
    "observability-designed"
  ],
  "deliverables": [
    "docs/architecture/service-decomposition.md",
    "docs/architecture/kafka-topology.md",
    "docs/architecture/hexagonal-blueprint.md",
    "docs/architecture/data-architecture.md",
    "docs/architecture/api-contracts.md",
    "docs/architecture/infrastructure.md",
    "docs/architecture/security.md",
    "docs/architecture/observability`,

  'playbook/phases/03-foundation.md': `# Phase 03: Foundation & Scaffolding

## Phase Overview

**Objective**: Transform the architecture decisions from Phase 02 into a working project skeleton with all microservice modules, shared libraries, build pipelines, infrastructure-as-code, and development tooling in place. By the end of this phase, every developer can clone the repo, run \`./gradlew build\`, and have a green build with passing placeholder tests across all modules.

**Duration**: 1–2 sprints (2–4 weeks)

**Phase Entry Criteria**:
- Phase 02 (Architecture) deliverables approved
- ADRs finalized for hexagonal architecture, Kafka event strategy, database-per-service pattern
- Domain boundaries and service decomposition agreed upon
- Technology versions locked (Java 21, Spring Boot 3.2, Kafka 3.x, PostgreSQL 15+)

---

## Deliverables

### D1: Gradle Multi-Module Project Structure

Set up the root \`build.gradle.kts\` and all submodule build files following the monorepo layout:

\`\`\`
build.gradle.kts                    # Root build with shared plugin config
settings.gradle.kts                 # Module inclusion
gradle.properties                   # Version catalog, JVM args
buildSrc/                           # Custom Gradle plugins, conventions
  src/main/kotlin/
    spring-boot-service.gradle.kts  # Convention plugin for services
    shared-library.gradle.kts       # Convention plugin for shared libs

services/
  order-service/build.gradle.kts
  payment-service/build.gradle.kts
  user-service/build.gradle.kts
  notification-service/build.gradle.kts

shared/
  domain-events/build.gradle.kts
  common-utils/build.gradle.kts
  test-fixtures/build.gradle.kts

gateway/build.gradle.kts
schema-registry/build.gradle.kts
\`\`\`

**Convention plugins** must enforce:
- Java 21 toolchain
- Checkstyle with Google Java Style
- JaCoCo with 80% coverage threshold
- SpotBugs for static analysis
- OWASP dependency-check
- Consistent dependency versions via Gradle version catalog (\`libs.versions.toml\`)

**Verification**:
\`\`\`bash
./gradlew build          # All modules compile
./gradlew check          # Checkstyle + SpotBugs + tests pass
./gradlew jacocoReport   # Coverage reports generated
\`\`\`

### D2: Hexagonal Architecture Scaffolding Per Service

Each microservice module follows the Ports & Adapters structure:

\`\`\`
services/order-service/src/main/java/com/fintech/order/
  OrderServiceApplication.java

  domain/
    model/          # Aggregates, entities, value objects
    port/
      inbound/      # Use case interfaces (e.g., CreateOrderUseCase)
      outbound/     # Repository ports, event publisher ports
    service/        # Domain service implementations
    exception/      # Domain-specific exceptions

  adapter/
    inbound/
      rest/         # @RestController classes
      kafka/        # @KafkaListener consumer classes
    outbound/
      persistence/  # JPA repositories, entity mappers
      kafka/        # KafkaTemplate publisher implementations
      cache/        # Redis cache adapters

  config/           # Spring @Configuration classes
    KafkaConfig.java
    SecurityConfig.java
    PersistenceConfig.java
    RedisConfig.java
\`\`\`

Each service must include:
- A \`README.md\` describing the bounded context
- An \`application.yml\` with Spring Profile placeholders (\`local\`, \`staging\`, \`production\`)
- A placeholder \`@SpringBootApplication\` class
- At least one inbound port interface and one outbound port interface
- Package-level \`package-info.java\` for each layer

### D3: Shared Libraries

#### \`shared/domain-events\`
- Base \`DomainEvent\` abstract class with \`eventId\`, \`timestamp\`, \`aggregateId\`, \`eventType\`, \`version\`
- Marker interfaces for event categories: \`OrderEvent\`, \`PaymentEvent\`, \`UserEvent\`, \`NotificationEvent\`
- Serialization/deserialization utilities (Jackson with Java time module)
- Event envelope wrapper for Kafka headers (correlation ID, source service, trace ID)

#### \`shared/common-utils\`
- \`CorrelationIdFilter\` — servlet filter that extracts/generates \`X-Correlation-ID\`
- \`KafkaHeaderUtils\` — helper for reading/writing standard Kafka headers
- \`PageResponse<T>\` — standardized pagination DTO
- \`ErrorResponse\` — standardized error response body (RFC 7807 Problem Details)
- \`AuditableEntity\` — base JPA entity with \`createdAt\`, \`updatedAt\`, \`createdBy\`

#### \`shared/test-fixtures\`
- Testcontainers module definitions: PostgreSQL, Kafka, Redis
- \`@IntegrationTest\` meta-annotation combining \`@SpringBootTest\` + Testcontainers lifecycle
- Test data builders for shared domain events
- Kafka test consumer/producer utilities for assertion

### D4: Spring Boot Configuration Templates

#### \`application.yml\` (per service, profile-based)

\`\`\`yaml
spring:
  profiles:
    active: \${SPRING_PROFILES_ACTIVE:local}

---
spring:
  config:
    activate:
      on-profile: local
  datasource:
    url: jdbc:postgresql://localhost:5432/\${SERVICE_DB_NAME}
    username: \${DB_USERNAME:postgres}
    password: \${DB_PASSWORD:postgres}
  kafka:
    bootstrap-servers: localhost:9092
    consumer:
      group-id: \${spring.application.name}-group
      auto-offset-reset: earliest
      enable-auto-commit: false
    producer:
      acks: all
      retries: 3
  data:
    redis:
      host: localhost
      port: 6379

management:
  endpoints:
    web:
      exposure:
        include: health,info,prometheus,metrics
  endpoint:
    health:
      show-details: when_authorized
      probes:
        enabled: true
  metrics:
    tags:
      application: \${spring.application.name}
\`\`\`

#### Spring Security baseline
- All endpoints require authentication except \`/actuator/health/liveness\`, \`/actuator/health/readiness\`
- CSRF disabled for API-only services
- JWT validation configured (issuer, audience, JWKS URI as externalized config)
- Method-level security enabled (\`@PreAuthorize\`)
- Security headers: HSTS, X-Content-Type-Options, X-Frame-Options

### D5: Kafka Infrastructure Setup

#### Topic naming convention
\`\`\`
<domain>.<aggregate>.<event-type>

Examples:
  order.order.created
  order.order.confirmed
  payment.payment.initiated
  payment.payment.completed
  user.user.registered
  notification.email.requested
\`\`\`

#### Consumer group naming
\`\`\`
<service-name>-<purpose>-group

Examples:
  payment-service-order-events-group
  notification-service-payment-events-group
\`\`\`

#### Schema registry scaffolding
\`\`\`
schema-registry/
  schemas/
    order/
      order-created.avsc
      order-confirmed.avsc
    payment/
      payment-initiated.avsc
      payment-completed.avsc
    user/
      user-registered.avsc
    notification/
      email-requested.avsc
  README.md
\`\`\`

Each schema includes:
- \`namespace\`, \`name\`, \`type\` fields
- \`eventId\` (string, UUID), \`timestamp\` (long, epoch millis), \`version\` (int)
- Aggregate-specific payload fields
- Backward compatibility annotations

#### Kafka configuration
- Idempotent producers (\`enable.idempotence=true\`)
- Manual offset commit for consumers
- Dead letter topic (DLT) per consumer: \`<original-topic>.DLT\`
- Retry topic strategy: \`<original-topic>.retry-1\`, \`<original-topic>.retry-2\`
- \`DefaultErrorHandler\` with exponential backoff

### D6: Docker Compose for Local Development

\`\`\`yaml
# docker-compose.yml
services:
  postgres-order:
    image: postgres:15
    environment:
      POSTGRES_DB: order_db
    ports: ["5432:5432"]

  postgres-payment:
    image: postgres:15
    environment:
      POSTGRES_DB: payment_db
    ports: ["5433:5432"]

  postgres-user:
    image: postgres:15
    environment:
      POSTGRES_DB: user_db
    ports: ["5434:5432"]

  kafka:
    image: confluentinc/cp-kafka:7.5.0
    # KRaft mode, no ZooKeeper
    ports: ["9092:9092"]

  redis:
    image: redis:7-alpine
    ports: ["6379:6379"]

  jaeger:
    image: jaegertracing/all-in-one:1.50
    ports: ["16686:16686", "4317:4317"]
\`\`\`

### D7: Dockerfile Per Service

\`\`\`dockerfile
FROM eclipse-temurin:21-jre-alpine AS runtime
RUN addgroup -S appgroup && adduser -S appuser -G appgroup
WORKDIR /app
COPY build/libs/*-SNAPSHOT.jar app.jar
RUN chown appuser:appgroup app.jar
USER appuser
EXPOSE 8080
HEALTHCHECK --interval=30s --timeout=3s \\
  CMD wget -qO- http://localhost:8080/actuator/health/liveness || exit 1
ENTRYPOINT ["java", "-XX:+UseZGC", "-XX:MaxRAMPercentage=75.0", "-jar", "app.jar"]
\`\`\`

- Non-root user for PCI DSS compliance
- ZGC garbage collector for low-latency fintech workloads
- Health check aligned with Kubernetes probes
- No secrets baked into image

### D8: Helm Chart Scaffolding

\`\`\`
charts/
  order-service/
    Chart.yaml
    values.yaml
    values-staging.yaml
    values-production.yaml
    templates/
      deployment.yaml
      service.yaml
      ingress.yaml
      configmap.yaml
      secret.yaml
      hpa.yaml
      pdb.yaml
      serviceaccount.yaml
      networkpolicy.yaml
  payment-service/
    ...
  user-service/
    ...
  gateway/
    ...
\`\`\`

Each Helm chart includes:
- Liveness and readiness probes pointing to Actuator endpoints
- Resource requests/limits appropriate for the service
- \`PodDisruptionBudget\` with \`minAvailable: 1\`
- \`NetworkPolicy\` restricting ingress to gateway and Kafka only
- Secrets mounted from AWS Secrets Manager via External Secrets Operator
- Service account with IRSA (IAM Roles for Service Accounts)

### D9: Terraform Foundation

\`\`\`
infrastructure/
  modules/
    eks/              # EKS cluster, node groups, IRSA
    rds/              # PostgreSQL RDS per service
    elasticache/      # Redis cluster
    msk/              # Managed Kafka (MSK)
    ecr/              # Container registries per service
    networking/       # VPC, subnets, security groups
    monitoring/       # CloudWatch, Prometheus workspace
  environments/
    staging/
      main.tf
      variables.tf
      terraform.tfvars
    production/
      main.tf
      variables.tf
      terraform.tfvars  # ⚠️ CODEOWNERS protected
\`\`\`

### D10: GitHub Actions CI Pipeline

Workflow file: \`.github/workflows/ci.yml\`

**Stages**:
1. **Lint** — \`./gradlew checkstyleMain checkstyleTest ktlintCheck\`
2. **Compile** — \`./gradlew compileJava compileKotlin\`
3. **Unit Tests** — \`./gradlew test\` (JUnit 5 + Mockito, excludes integration)
4. **Integration Tests** — \`./gradlew integrationTest\` (Testcontainers, requires Docker)
5. **Contract Tests** — \`./gradlew contractTest\` (Pact provider/consumer verification)
6. **Security Scan** — \`./gradlew dependencyCheckAnalyze\`, Trivy container scan
7. **Coverage Gate** — \`./gradlew jacocoTestCoverageVerification\` (80% minimum)
8. **Build Docker Images** — Multi-arch build, push to ECR
9. **Deploy Staging** — Helm upgrade via \`helm upgrade --install\` (auto-deploy)
10. **E2E Tests** — Run against staging environment
11. **Deploy Production** — Manual approval gate, Helm upgrade

**Matrix strategy**: Run steps 1–7 in parallel per changed module (detect via \`dorny/paths-filter\`).

### D11: Development Tooling Configuration

#### \`.editorconfig\`
- \`indent_style = space\`, \`indent_size = 4\` for Java
- \`indent_size = 4\` for Kotlin
- \`max_line_length = 120\`
- \`insert_final_newline = true\`

#### \`config/checkstyle/checkstyle.xml\`
- Google Java Style with project overrides (120 char line length)

#### \`.pre-commit-config.yaml\`
- Checkstyle, ktlint, commit message format validation
- Secrets detection (detect-secrets, gitleaks)
- Trailing whitespace, end-of-file fixer

#### \`CODEOWNERS\`
\`\`\`
# Security-sensitive paths require security team review
**/security/**          @fintech/security-team
**/auth/**              @fintech/security-team
*.properties            @fintech/security-team @fintech/platform-leads
infrastructure/production/** @fintech/platform-leads @fintech/security-team

# Service ownership
services/order-service/   @fintech/order-team
services/payment-service/ @fintech/payment-team @fintech/security-team
services/user-service/    @fintech/identity-team
gateway/                  @fintech/platform-team
shared/                   @fintech/platform-team
charts/                   @fintech/platform-team
\`\`\`

---

## Quality Gates

All gates must pass before Phase 03 is considered complete.

### QG-1: Build Integrity
| Criteria | Target | Verification |
|----------|--------|-------------|
| Root build succeeds | Zero errors | \`./gradlew build\` exits 0 |
| All modules compile | All services + shared libs | \`./gradlew compileJava compileKotlin\` |
| Checkstyle passes | Zero violations | \`./gradlew checkstyleMain\` |
| ktlint passes | Zero violations | \`./gradlew ktlintCheck\` |
| SpotBugs passes | Zero high-priority bugs | \`./gradlew spotbugsMain\` |

### QG-2: Test Infrastructure
| Criteria | Target | Verification |
|----------|--------|-------------|
| Placeholder unit tests pass | 1+ per module | \`./gradlew test\` |
| Testcontainers integration test runs | PostgreSQL + Kafka + Redis start | \`./gradlew integrationTest\` |
| JaCoCo reports generate | All modules | \`./gradlew jacocoReport\` |
| Pact contract test scaffold | Provider/consumer stubs exist | \`./gradlew contractTest\` |

### QG-3: Docker & Kubernetes
| Criteria | Target | Verification |
|----------|--------|-------------|
| Docker images build | All services | \`docker build\` per service |
| Docker Compose starts | All infra + services healthy | \`docker compose up -d && docker compose ps\` |
| Helm charts lint | Zero errors | \`helm lint charts/*\` |
| Helm template renders | Valid K8s manifests | \`helm template charts/<service>\` |

### QG-4: CI Pipeline
| Criteria | Target | Verification |
|----------|--------|-------------|
| GitHub Actions workflow valid | Syntax OK | Push to feature branch triggers pipeline |
| All CI stages pass | Green build | PR to \`main\` completes all stages |
| CODEOWNERS enforced | Protected paths require designated reviewers | Test PR touching \`**/security/**\` |
| Signed commits enforced | Unsigned commits rejected | Branch protection rules active |

### QG-5: Security Baseline
| Criteria | Target | Verification |
|----------|--------|-------------|
| OWASP dependency check | Zero critical/high CVEs | \`./gradlew dependencyCheckAnalyze\` |
| No secrets in repo | Zero findings | \`gitleaks detect\` |
| Spring Security configured | Auth required on all business endpoints | Integration test verifies 401 on unauthenticated request`,

  'playbook/phases/04-core-implementation.md': `# Phase 04: Core Implementation

## Phase Overview

| Attribute        | Value                                                    |
|------------------|----------------------------------------------------------|
| **Phase ID**     | \`04-core-implementation\`                                 |
| **Duration**     | 3–6 sprints (6–12 weeks)                                |
| **Prerequisites**| Phase 03 (Service Scaffolding) complete                  |
| **Next Phase**   | \`05-integration-testing\`                                 |
| **Approval**     | Tech Lead + Service Owner sign-off per service           |

## Objectives

1. **Implement domain logic** for each bounded context following Hexagonal Architecture (Ports & Adapters)
2. **Build Kafka event producers and consumers** with proper serialization, error handling, and dead-letter topics
3. **Implement persistence layers** with Spring Data JPA against per-service PostgreSQL databases
4. **Add Redis caching and session management** where architecturally specified
5. **Enforce security controls** aligned with SOC 2 and PCI DSS requirements at the service level
6. **Achieve ≥80% code coverage** with JUnit 5 unit tests and Testcontainers integration tests
7. **Publish and consume domain events** through the shared schema registry with backward-compatible schemas

## Scope by Service

Each microservice module under \`services/\` follows the same implementation pattern. The table below tracks core services — extend as needed.

| Service             | Domain Bounded Context     | Key Kafka Topics                          | Database   |
|---------------------|----------------------------|-------------------------------------------|------------|
| \`user-service\`      | Identity & Access          | \`user.created\`, \`user.updated\`, \`user.kyc.verified\` | \`users_db\` |
| \`payment-service\`   | Payment Processing         | \`payment.initiated\`, \`payment.completed\`, \`payment.failed\` | \`payments_db\` |
| \`order-service\`     | Order Management           | \`order.placed\`, \`order.confirmed\`, \`order.cancelled\` | \`orders_db\` |
| \`notification-service\` | Notifications           | Consumes all \`*.completed\`, \`*.failed\`    | \`notifications_db\` |
| \`gateway\`           | API Gateway (Spring Cloud) | N/A (routes only)                         | N/A        |

## Deliverables

### D1: Domain Model Implementation

- [ ] Entity classes with JPA annotations in \`domain/model/\` package
- [ ] Value objects as immutable records (Java 21 records where appropriate)
- [ ] Domain events as records in \`domain/event/\` package
- [ ] Domain services encapsulating business rules in \`domain/service/\`
- [ ] No framework annotations in domain layer — pure Java

**Hexagonal Architecture package structure per service:**

\`\`\`
services/{service-name}/src/main/java/com/company/{service}/
├── domain/
│   ├── model/          # Entities, Value Objects, Aggregates
│   ├── event/          # Domain events (records)
│   ├── service/        # Domain services (pure business logic)
│   └── port/
│       ├── inbound/    # Use case interfaces (driving ports)
│       └── outbound/   # Repository & messaging interfaces (driven ports)
├── application/
│   ├── usecase/        # Use case implementations (orchestration)
│   └── dto/            # Request/Response DTOs, mappers
├── adapter/
│   ├── inbound/
│   │   ├── rest/       # @RestController endpoints
│   │   └── kafka/      # @KafkaListener consumers
│   ├── outbound/
│   │   ├── persistence/# JPA repositories, entity mappers
│   │   ├── kafka/      # KafkaTemplate producers
│   │   └── cache/      # Redis cache adapters
│   └── config/         # Spring @Configuration classes
└── {ServiceName}Application.java
\`\`\`

### D2: REST API Endpoints

- [ ] Controllers in \`adapter/inbound/rest/\` implementing driving port interfaces
- [ ] Request validation with Jakarta Bean Validation (\`@Valid\`, custom validators)
- [ ] Consistent error responses using \`@RestControllerAdvice\` with RFC 7807 Problem Details
- [ ] OpenAPI 3.1 annotations on all endpoints (\`@Operation\`, \`@ApiResponse\`, \`@Schema\`)
- [ ] Rate limiting on public-facing endpoints via Spring Cloud Gateway filters
- [ ] Pagination using \`Pageable\` for list endpoints

**Example endpoint pattern:**

\`\`\`java
@RestController
@RequestMapping("/api/v1/payments")
@Tag(name = "Payments", description = "Payment processing operations")
public class PaymentController {

    private final InitiatePaymentUseCase initiatePaymentUseCase;

    @PostMapping
    @Operation(summary = "Initiate a payment")
    @ApiResponse(responseCode = "202", description = "Payment initiated")
    public ResponseEntity<PaymentResponse> initiatePayment(
            @Valid @RequestBody PaymentRequest request) {
        // Delegates to use case, returns 202 Accepted
    }
}
\`\`\`

### D3: Kafka Event Producers

- [ ] Producer adapters in \`adapter/outbound/kafka/\` implementing outbound ports
- [ ] Avro or JSON Schema serialization with schemas registered in \`schema-registry/\`
- [ ] Idempotent producer configuration (\`enable.idempotence=true\`)
- [ ] Transactional outbox pattern for services requiring exactly-once semantics
- [ ] Correlation ID propagation via Kafka headers for distributed tracing
- [ ] Producer metrics exposed via Micrometer/Actuator

**Kafka producer configuration (per-service \`application.yml\`):**

\`\`\`yaml
spring:
  kafka:
    producer:
      bootstrap-servers: \${KAFKA_BOOTSTRAP_SERVERS}
      key-serializer: org.apache.kafka.common.serialization.StringSerializer
      value-serializer: io.confluent.kafka.serializers.KafkaAvroSerializer
      properties:
        enable.idempotence: true
        acks: all
        retries: 3
        schema.registry.url: \${SCHEMA_REGISTRY_URL}
    properties:
      interceptor.classes: com.company.shared.kafka.TracingProducerInterceptor
\`\`\`

### D4: Kafka Event Consumers

- [ ] Consumer adapters in \`adapter/inbound/kafka/\` with \`@KafkaListener\`
- [ ] Consumer group per service (\`\${service-name}-group\`)
- [ ] Manual acknowledgment mode for at-least-once delivery guarantees
- [ ] Dead-letter topic (DLT) configuration for poison pill messages
- [ ] Retry with exponential backoff using \`DefaultErrorHandler\`
- [ ] Idempotent consumption using deduplication table or Redis-based check
- [ ] Consumer lag monitoring via Micrometer metrics

**Consumer configuration pattern:**

\`\`\`yaml
spring:
  kafka:
    consumer:
      bootstrap-servers: \${KAFKA_BOOTSTRAP_SERVERS}
      group-id: \${spring.application.name}-group
      auto-offset-reset: earliest
      enable-auto-commit: false
      key-deserializer: org.apache.kafka.common.serialization.StringDeserializer
      value-deserializer: io.confluent.kafka.serializers.KafkaAvroDeserializer
      properties:
        schema.registry.url: \${SCHEMA_REGISTRY_URL}
        specific.avro.reader: true
    listener:
      ack-mode: manual
      concurrency: 3
\`\`\`

**Dead-letter topic naming convention:** \`{original-topic}.DLT\`

### D5: Persistence Layer

- [ ] JPA entities in \`adapter/outbound/persistence/entity/\` (separate from domain model)
- [ ] Spring Data JPA repositories in \`adapter/outbound/persistence/repository/\`
- [ ] Entity-to-domain mappers (MapStruct or manual) — no JPA entities leaking into domain
- [ ] Flyway migrations in \`src/main/resources/db/migration/\` per service
- [ ] Optimistic locking with \`@Version\` on aggregate roots
- [ ] Audit columns (\`created_at\`, \`updated_at\`, \`created_by\`) via \`@EntityListeners(AuditingEntityListener.class)\`
- [ ] Database indexes on frequently queried columns documented in migration scripts

**Flyway naming convention:** \`V{version}__{description}.sql\` (e.g., \`V001__create_payments_table.sql\`)

### D6: Redis Caching & Session Management

- [ ] Redis cache adapters in \`adapter/outbound/cache/\`
- [ ] \`@Cacheable\`, \`@CacheEvict\`, \`@CachePut\` on appropriate use case methods
- [ ] Cache TTL configuration per cache name in \`application.yml\`
- [ ] Redis-backed Spring Session for stateless service authentication
- [ ] Cache key naming convention: \`{service}:{entity}:{id}\` (e.g., \`user-service:user:uuid-123\`)
- [ ] Circuit breaker on Redis calls — degrade gracefully if Redis is unavailable

\`\`\`yaml
spring:
  data:
    redis:
      host: \${REDIS_HOST}
      port: \${REDIS_PORT}
      ssl:
        enabled: true
  cache:
    type: redis
    redis:
      time-to-live: 300000  # 5 minutes default
      cache-null-values: false
\`\`\`

### D7: Security Implementation

- [ ] Spring Security configuration per service in \`adapter/config/SecurityConfig.java\`
- [ ] JWT validation for service-to-gateway authentication (RS256)
- [ ] mTLS for inter-service communication within the Kubernetes cluster
- [ ] Input sanitization on all REST endpoints (OWASP recommendations)
- [ ] PCI DSS: No PAN/CVV stored in logs, databases, or Kafka events — tokenization required
- [ ] SOC 2: Audit logging for all state-changing operations via domain events
- [ ] Secrets managed via AWS Secrets Manager, injected as Kubernetes secrets
- [ ] CORS configuration restricted to known origins
- [ ] Security headers via Spring Security (\`X-Content-Type-Options\`, \`X-Frame-Options\`, \`Strict-Transport-Security\`)

**Sensitive data handling rules:**

| Data Type          | Storage Allowed | Logging Allowed | Kafka Event Allowed | Treatment       |
|--------------------|-----------------|-----------------|---------------------|-----------------|
| PAN (card number)  | No              | No              | No                  | Tokenize        |
| CVV                | Never           | Never           | Never               | Never store     |
| PII (name, email)  | Encrypted       | Masked          | Encrypted           | AES-256         |
| Account ID         | Yes             | Yes             | Yes                 | Plain           |
| Transaction amount | Yes             | Yes             | Yes                 | Plain           |

### D8: Observability

- [ ] Structured JSON logging via Logback with MDC (correlation ID, service name, trace ID)
- [ ] Micrometer metrics for custom business KPIs (e.g., \`payment.initiated.count\`, \`order.placed.duration\`)
- [ ] Spring Boot Actuator endpoints enabled: \`/actuator/health\`, \`/actuator/info\`, \`/actuator/prometheus\`
- [ ] Health indicators for Kafka, PostgreSQL, and Redis connectivity
- [ ] Distributed tracing with Micrometer Tracing (Brave) propagating trace context through Kafka headers
- [ ] Log correlation: every log line includes \`traceId\`, \`spanId\`, \`correlationId\`

\`\`\`yaml
management:
  endpoints:
    web:
      exposure:
        include: health,info,prometheus,metrics
  endpoint:
    health:
      show-details: when_authorized
      probes:
        enabled: true
  tracing:
    sampling:
      probability: 1.0  # 100% in staging, reduce in production
  metrics:
    tags:
      application: \${spring.application.name}
\`\`\`

### D9: OpenAPI Specifications

- [ ] OpenAPI 3.1 spec generated from code annotations and exported to \`docs/api/{service-name}.yaml\`
- [ ] Spec validated in CI with \`swagger-cli validate\`
- [ ] Published to Confluence via CI pipeline
- [ ] Versioned API paths (\`/api/v1/\`, \`/api/v2/\`)

### D10: Unit & Integration Tests

- [ ] Unit tests for domain services and use cases (JUnit 5 + Mockito)
- [ ] Integration tests for REST controllers (\`@WebMvcTest\` + MockMvc)
- [ ] Integration tests for JPA repositories (\`@DataJpaTest\` + Testcontainers PostgreSQL)
- [ ] Integration tests for Kafka producers/consumers (\`@EmbeddedKafka\` or Testcontainers Kafka)
- [ ] Integration tests for Redis caching (Testcontainers Redis)
- [ ] Test fixtures and builders in \`src/test/java/.../fixture/\`
- [ ] Coverage report generated by JaCoCo, enforced at ≥80% per module

**Test execution:**

\`\`\`bash
# Unit tests only
./gradlew test

# Integration tests (requires Docker for Testcontainers)
./gradlew integrationTest

# Full test suite with coverage
./gradlew check jacocoTestReport

# Single service
./gradlew :services:payment-service:check
\`\`\`

## Implementation Order

Follow this order to minimize cross-service dependencies:

\`\`\`
Phase 4.1: Shared Libraries (1 sprint)
  └── shared/domain-events    — Event records, serializers
  └── shared/common           — Base exceptions, DTOs, utilities
  └── schema-registry/        — Avro schemas for all domain events

Phase 4.2: User Service (1–2 sprints)
  └── Domain model, persistence, REST API
  └── Produces: user.created, user.updated, user.kyc.verified
  └── Security: JWT issuing, authentication flows

Phase 4.3: Order Service (1–2 sprints)
  └── Domain model, persistence, REST API
  └── Produces: order.placed, order.confirmed, order.cancelled
  └── Consumes: user.kyc.verified (for order eligibility)

Phase 4.4: Payment Service (1–2 sprints)
  └── Domain model, persistence, REST API
  └── Produces: payment.initiated, payment.completed, payment.failed
  └── Consumes: order.placed (triggers payment flow)
  └── PCI DSS: Tokenization, no PAN storage, audit logging

Phase 4.5: Notification Service (1 sprint)
  └── Consumes: payment.completed, payment.failed, order.confirmed
  └── Produces: notification.sent
  └── Integrates with external notification providers

Phase 4.6: API Gateway (1 sprint)
  └── Route configuration for all services
  └── Rate limiting, authentication filter, CORS
  └── Request/response logging (sanitized)
\`\`\`

## Quality Gates

All gates must pass before advancing to Phase 05.

### QG-4.1: Code Quality

| Criteria                                    | Threshold | Tool                    |
|---------------------------------------------|-----------|-------------------------|
| Checkstyle violations                       | 0         | \`./gradlew checkstyleMain\` |
| ktlint violations (shared Kotlin modules)   | 0         | \`./gradlew ktlintCheck\` |
| SpotBugs high-priority issues               | 0         | \`./gradlew spotbugsMain\` |
| File length                                 | ≤300 lines| Checkstyle rule         |
| Cyclomatic complexity per method            | ≤10       | Checkstyle/SpotBugs     |

### QG-4.2: Test Coverage

| Criteria                                    | Threshold | Tool                    |
|---------------------------------------------|-----------|-------------------------|
| Unit test coverage (line)                   | ≥80%      | JaCoCo                  |
| Unit test coverage (branch)                 | ≥70%      | JaCoCo                  |
| Integration tests passing                   | 100%      | Testcontainers          |
| Domain layer coverage                       | ≥90%      | JaCoCo (per-package)    |
| All Kafka consumers have integration tests  | Yes       | Manual review           |

### QG-4.3: Security

| Criteria                                    | Threshold | Tool                    |
|---------------------------------------------|-----------|-------------------------|
| OWASP dependency-check CVEs (critical/high) | 0         | \`./gradlew dependencyCheckAnalyze\` |
| No secrets in source code                   | 0 findings| \`gitleaks\`, \`trufflehog\` |
| PCI DSS: No PAN/CVV in logs or events       | Verified  | Manual review + grep    |
| SOC 2: Audit`,

  'playbook/phases/05-integration-hardening.md': `# Phase 05 — Integration & Hardening

## Overview

Phase 05 shifts focus from individual service development to system-wide integration, resilience, and production readiness. This phase validates that all Spring Boot microservices communicate correctly through Kafka, handle failure scenarios gracefully, meet performance requirements under load, and satisfy SOC 2 and PCI DSS compliance controls. No new feature work occurs in this phase — the goal is to harden what exists.

## Objectives

1. **End-to-End Integration Validation** — Verify all inter-service Kafka event flows work correctly across the full domain lifecycle (e.g., order created → payment processed → notification sent)
2. **Failure Mode Testing** — Validate circuit breakers, dead letter topics, retry policies, and graceful degradation when services or infrastructure components fail
3. **Performance & Load Testing** — Establish baseline throughput and latency for critical paths, identify bottlenecks, and tune JVM/Spring/Kafka configurations
4. **Security Hardening** — Complete penetration testing, dependency vulnerability remediation, secrets rotation validation, and compliance evidence collection
5. **Observability Verification** — Confirm distributed traces propagate end-to-end through Jaeger, dashboards in Grafana cover all SLIs, and alerts fire correctly
6. **Data Integrity Assurance** — Validate exactly-once semantics where required, idempotency of event consumers, and consistency of per-service PostgreSQL databases
7. **Deployment Pipeline Hardening** — Validate blue-green and canary deployment strategies, rollback procedures, and database migration safety

## Prerequisites

- All microservices from Phase 03 (Service Implementation) and Phase 04 (Feature Completion) are merged to \`main\`
- Each service passes its own unit and integration test suites (\`./gradlew test\` and \`./gradlew integrationTest\`)
- Pact contract tests are green for all provider-consumer pairs
- Staging environment in AWS EKS is provisioned and mirrors production topology
- Schema registry contains finalized Avro/JSON schemas for all domain events
- Helm charts deploy successfully to staging via \`helm upgrade --install\`

## Duration

**2–3 sprints** (depending on service count and complexity of event flows)

## Roles & Responsibilities

| Role | Responsibility |
|------|---------------|
| **Tech Leads** | Own hardening backlog prioritization, sign off on quality gates |
| **Senior Engineers** | Lead failure mode testing, performance tuning, security remediation |
| **Mid Engineers** | Execute integration test scenarios, build load test scripts, fix defects |
| **Junior Engineers** | Document runbooks, assist with test data setup, update dashboards |
| **SRE / Platform** | Validate infrastructure resilience, alerting, deployment pipelines |
| **Security** | Conduct penetration testing, review compliance evidence, approve controls |

## Deliverables

### 5.1 End-to-End Integration Test Suite

**Location**: \`tests/e2e/\`

A comprehensive test suite that exercises full business flows across multiple services using a real Kafka cluster and PostgreSQL instances via Testcontainers or the staging environment.

**Required test scenarios**:

\`\`\`
tests/e2e/
├── src/test/java/com/company/e2e/
│   ├── OrderLifecycleE2ETest.java        # Order → Payment → Fulfillment → Notification
│   ├── PaymentFailureE2ETest.java         # Payment declined → Order rollback → User notified
│   ├── UserRegistrationE2ETest.java       # Registration → KYC check → Account activation
│   ├── IdempotencyE2ETest.java            # Duplicate events produce no side effects
│   ├── EventOrderingE2ETest.java          # Events processed in correct partition order
│   └── CrossServiceQueryE2ETest.java      # API Gateway aggregates data from multiple services
\`\`\`

**Key patterns**:
- Use \`@SpringBootTest\` with \`spring.kafka.bootstrap-servers\` pointed at Testcontainers Kafka
- Use \`KafkaTemplate\` to produce events and \`@KafkaListener\` test consumers to assert outcomes
- Assert database state in each service's PostgreSQL after event processing completes
- Use Awaitility for async assertions with explicit timeouts (no \`Thread.sleep\`)

\`\`\`java
@Test
void orderLifecycle_shouldProcessPaymentAndNotifyUser() {
    // Given: a valid order request
    OrderCreatedEvent order = TestFixtures.validOrder();

    // When: order-created event is published
    kafkaTemplate.send("order.events.created", order.orderId(), order);

    // Then: payment-service processes and emits payment-completed
    await().atMost(Duration.ofSeconds(30)).untilAsserted(() -> {
        PaymentRecord payment = paymentRepository.findByOrderId(order.orderId());
        assertThat(payment).isNotNull();
        assertThat(payment.getStatus()).isEqualTo(PaymentStatus.COMPLETED);
    });

    // And: notification-service sends confirmation
    await().atMost(Duration.ofSeconds(15)).untilAsserted(() -> {
        List<NotificationRecord> notifications = notificationRepository
            .findByUserId(order.userId());
        assertThat(notifications).anyMatch(n ->
            n.getType() == NotificationType.PAYMENT_CONFIRMATION);
    });
}
\`\`\`

**Run command**: \`./gradlew :tests:e2e:test\`

### 5.2 Failure Mode & Resilience Tests

**Location**: \`tests/e2e/src/test/java/com/company/e2e/resilience/\`

Systematic tests for every identified failure mode:

| Failure Scenario | Expected Behavior | Test Method |
|-----------------|-------------------|-------------|
| Kafka broker unavailable | Producer retries with backoff, no data loss | \`kafkaBrokerDown_producerRetriesAndRecovers\` |
| Consumer processing exception | Message sent to DLT, alert fires | \`consumerException_messageSentToDeadLetterTopic\` |
| PostgreSQL connection pool exhausted | Circuit breaker opens, returns 503 | \`dbPoolExhausted_circuitBreakerOpens\` |
| Redis cache unavailable | Service falls back to database, degraded latency | \`redisCacheDown_fallbackToDatabase\` |
| Downstream service timeout (via Gateway) | Gateway returns 504, circuit breaker trips | \`gatewayTimeout_circuitBreakerTrips\` |
| Duplicate Kafka message delivery | Idempotent consumer ignores duplicate | \`duplicateEvent_processedExactlyOnce\` |
| Schema registry unavailable | Producer/consumer fail gracefully with clear error | \`schemaRegistryDown_gracefulFailure\` |
| Out-of-order event arrival | Events buffered or reordered by sequence number | \`outOfOrderEvents_processedCorrectly\` |
| Poison pill message (malformed) | Deserialization error handler routes to DLT | \`malformedMessage_routedToDeadLetterTopic\` |
| Pod OOMKilled during processing | Kafka consumer rebalances, uncommitted offsets replayed | \`podRestart_kafkaRebalanceAndReplay\` |

**Spring Kafka DLT configuration to validate**:

\`\`\`java
@Bean
public DefaultErrorHandler errorHandler(KafkaTemplate<String, Object> template) {
    DeadLetterPublishingRecoverer recoverer =
        new DeadLetterPublishingRecoverer(template,
            (record, ex) -> new TopicPartition(record.topic() + ".dlt", record.partition()));
    return new DefaultErrorHandler(recoverer, new FixedBackOff(1000L, 3));
}
\`\`\`

### 5.3 Performance & Load Test Results

**Location**: \`tests/performance/\`

**Tooling**: Gatling (Scala DSL) or k6 (JavaScript) — team choice, documented in ADR

**Required load test scenarios**:

| Scenario | Target | SLA |
|----------|--------|-----|
| API Gateway throughput | 1,000 RPS sustained | p99 < 200ms |
| Order creation flow | 500 orders/sec | p95 < 500ms end-to-end |
| Payment processing | 300 payments/sec | p99 < 1s, zero data loss |
| Kafka consumer lag | 10,000 msg/sec burst | Consumer lag < 5,000 within 60s |
| User authentication | 200 logins/sec | p99 < 300ms |
| Database connection pool | Under sustained load | No connection timeouts in 30min |

**JVM & Spring tuning checklist**:

- [ ] JVM heap sizing validated per service (\`-Xms\` / \`-Xmx\` in Helm values)
- [ ] G1GC or ZGC selected and tuned based on latency profile
- [ ] Spring Kafka consumer \`max.poll.records\` and \`fetch.min.bytes\` tuned
- [ ] Kafka producer \`batch.size\`, \`linger.ms\`, and \`compression.type\` optimized
- [ ] HikariCP \`maximumPoolSize\` set per service based on load test results
- [ ] Redis connection pool (\`lettuce.pool.max-active\`) sized appropriately
- [ ] Spring WebFlux (Gateway) event loop threads tuned if applicable
- [ ] Actuator endpoints (\`/actuator/health\`, \`/actuator/prometheus\`) excluded from rate limiting

**Output artifacts**:
- \`tests/performance/results/\` — HTML reports with percentile distributions
- \`docs/adr/ADR-XXX-performance-baselines.md\` — Documented baselines and tuning decisions

### 5.4 Security Hardening Report

**Location**: \`docs/security/hardening-report.md\`

**Required activities**:

#### Dependency Vulnerability Scan
\`\`\`bash
./gradlew dependencyCheckAnalyze
# OWASP dependency-check — zero critical/high CVEs allowed
\`\`\`

- [ ] All services scanned with OWASP dependency-check
- [ ] SpotBugs security plugin (\`findsecbugs\`) run on all modules: \`./gradlew spotbugsMain\`
- [ ] No critical or high severity findings remain open
- [ ] Suppression file (\`owasp-suppressions.xml\`) reviewed and approved by security team

#### Spring Security Configuration Audit
- [ ] All endpoints require authentication except \`/actuator/health\` and \`/actuator/info\`
- [ ] JWT validation configured with RS256, key rotation supported
- [ ] CORS policies restricted to known origins
- [ ] CSRF protection enabled for stateful endpoints (if any)
- [ ] Rate limiting configured at API Gateway level
- [ ] Request/response logging excludes PII and cardholder data (PCI DSS Req 3.4)
- [ ] Spring Security headers: \`X-Content-Type-Options\`, \`X-Frame-Options\`, \`Strict-Transport-Security\`

#### Secrets Management
- [ ] No secrets in \`application.properties\` or \`application.yml\` — all externalized
- [ ] AWS Secrets Manager or Parameter Store used for production credentials
- [ ] Kafka SASL/SSL credentials rotated and tested
- [ ] PostgreSQL credentials use IAM authentication or rotated secrets
- [ ] Redis AUTH password configured and rotated
- [ ] \`git-secrets\` or \`gitleaks\` scan confirms no secrets in repository history

#### PCI DSS Specific Controls
- [ ] Cardholder data encrypted at rest (PostgreSQL TDE or column-level encryption)
- [ ] Cardholder data encrypted in transit (TLS 1.2+ everywhere)
- [ ] Kafka topics containing payment data use encryption and ACLs
- [ ] Audit logging captures all access to payment-related endpoints
- [ ] Data retention policies enforced — no cardholder data stored beyond required period
- [ ] Network segmentation: payment-service isolated in dedicated Kubernetes namespace

#### SOC 2 Evidence Collection
- [ ] Change management: all changes via PR with 2 approvals (GitHub audit log)
- [ ] Access control: RBAC configured in Kubernetes, AWS IAM policies documented
- [ ] Monitoring: alerts configured for unauthorized access attempts
- [ ] Incident response: runbook exists for security incidents
- [ ] Backup & recovery: RDS automated backups verified, restore tested

### 5.5 Observability Validation

**Distributed Tracing (Jaeger)**:
- [ ] Trace context propagates through API Gateway → Service → Kafka → Consumer Service
- [ ] \`spring.application.name\` appears correctly as service name in Jaeger UI
- [ ] Kafka producer/consumer spans linked via \`traceparent\` header
- [ ] Sampling rate configured appropriately (100% in staging, 10% in production)
- [ ] Trace IDs included in structured log output (correlation)

**Metrics (Prometheus + Grafana)**:
- [ ] All services expose \`/actuator/prometheus\` endpoint
- [ ] Grafana dashboards exist for each service covering:
  - JVM metrics (heap, GC, threads)
  - HTTP request rate, latency percentiles, error rate
  - Kafka consumer lag per topic/partition
  - Database connection pool utilization
  - Redis hit/miss ratio
- [ ] SLI/SLO dashboard: availability, latency, error budget
- [ ] Alerts configured in Grafana/Alertmanager:
  - Consumer lag > 10,000 for > 5 minutes → warning
  - Consumer lag > 50,000 for > 2 minutes → critical
  - Error rate > 5% for > 3 minutes → critical
  - p99 latency > 2s for > 5 minutes → warning
  - Pod restart count > 3 in 10 minutes → critical

**Centralized Logging (ELK Stack)**:
- [ ] All services use structured JSON logging (Logback + \`logstash-logback-encoder\`)
- [ ] Log fields include: \`traceId\`, \`spanId\`, \`service\`, \`environment\`, \`level\`, \`message\`
- [ ] PII masking configured in log output (PCI DSS compliance)
- [ ] Kibana index patterns created per service and per environment
- [ ] Log retention: 30 days in staging, 90 days in production

### 5.6 Deployment Pipeline Validation

**Location**: \`.github/workflows/\`

- [ ] Full CI pipeline runs in < 15 minutes for a single service change
- [ ] Docker images tagged with Git SHA and pushed to ECR
- [ ] Helm chart \`values-staging.yaml\` and \`values-production.yaml\` validated
- [ ] Staging auto-deploy on merge to \`main\` works end-to-end
- [ ] Production deploy requires manual approval in GitHub Actions
- [ ] Rollback procedure tested: \`helm rollback <service> <revision>\` restores previous version
- [ ] Database migrations (Flyway) tested for forward and backward compatibility
- [ ] Canary deployment tested: 10% traffic → monitor → full rollout
- [ ] AI-generated code flagged in PRs per \`docs/AI-USAGE-POLICY.md\`

### 5.7 Runbooks

**Location**: \`docs/runbooks/\`

Required runbooks for on-call engineers:

\`\`\`
docs/runbooks/
├── kafka-consumer-lag.md           # Diagnose and resolve consumer lag
├── service-high-error-rate.md      # Triage 5xx errors in a service
├── database-connection-exhaustion.md  # HikariCP pool saturation
├── redis-cache-failure.md          # Redis unavailable, fallback behavior
├── pod-crashloop.md                # Kubernetes CrashLoopBackOff diagnosis
├── dead-letter-topic-processing.md # Reprocess or discard DLT messages
├── certificate-expiry.md           # TLS certificate rotation
├── secret-rotation.md              # Rotate database/Kafka/Redis credentials
├── incident-response.md            # Security incident response procedure
└── disaster-recovery.md            # Full environment recovery from backups
\`\`\`

Each runbook must include: **Symptoms**, **Impact**, **Diagnosis Steps**, **Resolution Steps**, **Escalation Path**, **Prevention**.

## Quality Gates

All gates must pass before Phase 05 is considered complete and production deployment is approved.

### Gate 5.1 — E2E Tests Pass
\`\`\`bash
./gradlew :tests:e2e:test
# All end-to-end integration tests green
# No flaky tests (run 3x to confirm stability)
\`\`\`
- **Criteria**: 100% of E2E test scenarios pass on 3 consecutive runs
- **Owner**: Tech Lead
- **Evidence**: CI pipeline run URLs

### Gate 5.2 — Resilience Tests Pass
- **Criteria**: All failure mode scenarios in §5.2 tested and passing
- **Owner**: Senior Engineers
- **Evidence**: Test results + documented behavior for each failure mode

### Gate 5.3 — Performance SLAs Met
- **Criteria**: All load test scenarios meet defined SLAs (§5.3`,

  'playbook/phases/06-testing-quality.md': `# Phase 06: Testing & Quality

## Phase Overview

**Phase**: 06-testing-quality
**Duration**: 1–2 sprints (depending on service count)
**Prerequisites**: Phase 05 (Integration & Hardening) complete — services integrated via Kafka, resilience patterns in place
**Outcome**: Comprehensive test coverage across all layers, automated quality gates enforced, compliance evidence generated

This phase establishes the full testing pyramid for the microservice platform: unit tests with JUnit 5 and Mockito, integration tests with Testcontainers, contract tests with Pact, end-to-end tests against staging, and performance baselines. Every service must pass quality gates before any production deployment is authorized.

---

## Objectives

1. **Achieve ≥80% code coverage** across all services measured by JaCoCo
2. **Validate Kafka event contracts** between producer and consumer services using Pact
3. **Verify database migrations and queries** with Testcontainers (PostgreSQL) integration tests
4. **Confirm Redis caching behavior** under cache-hit, cache-miss, and eviction scenarios
5. **Establish performance baselines** for critical API paths and Kafka consumer throughput
6. **Generate compliance evidence** for SOC 2 and PCI DSS audit requirements
7. **Automate all quality gates** in GitHub Actions — no manual sign-off for test results

---

## Testing Pyramid

### Layer 1: Unit Tests (JUnit 5 + Mockito)

Every domain class, application service, port, and adapter has corresponding unit tests.

**Scope per service:**

| Component | Test Target | Example |
|-----------|------------|---------|
| Domain entities | Business rules, invariants, state transitions | \`OrderTest\`, \`PaymentTest\` |
| Domain services | Orchestration logic, event generation | \`OrderDomainServiceTest\` |
| Application services (use cases) | Port interactions, command/query handling | \`CreateOrderUseCaseTest\` |
| Inbound adapters | Request mapping, validation, error handling | \`OrderControllerTest\` (MockMvc) |
| Outbound adapters | Repository mapping, Kafka producer serialization | \`OrderRepositoryAdapterTest\` |
| Mappers / DTOs | Mapping correctness between layers | \`OrderMapperTest\` |

**Standards:**

- Use \`@ExtendWith(MockitoExtension.class)\` — no Spring context loading in unit tests
- Domain layer tests must have **zero** Spring dependencies
- Test method naming: \`should_expectedBehavior_when_condition()\`
- One assertion concept per test method (multiple asserts allowed if testing one logical outcome)
- Use \`@ParameterizedTest\` for boundary and equivalence-class testing
- Builders or test fixtures for complex domain objects — no raw constructors in tests

**Run command:**

\`\`\`bash
./gradlew test
\`\`\`

### Layer 2: Integration Tests (Testcontainers)

Verify that adapters work correctly with real infrastructure — PostgreSQL, Redis, Kafka.

**Required integration test suites per service:**

| Suite | Infrastructure | Validates |
|-------|---------------|-----------|
| Repository integration | PostgreSQL (Testcontainers) | JPA mappings, queries, Flyway migrations |
| Kafka producer integration | Kafka (Testcontainers) | Event serialization, topic routing, headers |
| Kafka consumer integration | Kafka + PostgreSQL (Testcontainers) | Deserialization, idempotency, dead-letter routing |
| Redis cache integration | Redis (Testcontainers) | Cache put/get/evict, TTL behavior, serialization |
| API integration | Full Spring context + Testcontainers | End-to-end request → DB → response |

**Standards:**

- Use \`@SpringBootTest\` with \`@Testcontainers\` annotation
- Shared container instances via \`static\` fields to reduce startup time
- Tag with \`@Tag("integration")\` for selective execution
- Each test method manages its own data — no shared mutable state between tests
- Flyway migrations run automatically against Testcontainers PostgreSQL
- Kafka integration tests must verify both happy path and error/retry scenarios

**Testcontainers base class pattern:**

\`\`\`java
@SpringBootTest
@Testcontainers
@ActiveProfiles("test")
abstract class IntegrationTestBase {

    @Container
    static PostgreSQLContainer<?> postgres = new PostgreSQLContainer<>("postgres:15-alpine")
        .withDatabaseName("testdb")
        .withUsername("test")
        .withPassword("test");

    @Container
    static KafkaContainer kafka = new KafkaContainer(
        DockerImageName.parse("confluentinc/cp-kafka:7.5.0"));

    @Container
    static GenericContainer<?> redis = new GenericContainer<>("redis:7-alpine")
        .withExposedPorts(6379);

    @DynamicPropertySource
    static void configureProperties(DynamicPropertyRegistry registry) {
        registry.add("spring.datasource.url", postgres::getJdbcUrl);
        registry.add("spring.datasource.username", postgres::getUsername);
        registry.add("spring.datasource.password", postgres::getPassword);
        registry.add("spring.kafka.bootstrap-servers", kafka::getBootstrapServers);
        registry.add("spring.data.redis.host", redis::getHost);
        registry.add("spring.data.redis.port", () -> redis.getMappedPort(6379));
    }
}
\`\`\`

**Run command:**

\`\`\`bash
./gradlew integrationTest
\`\`\`

### Layer 3: Contract Tests (Pact)

Validate that Kafka event producers and consumers agree on schema and semantics.

**Required contracts:**

| Producer Service | Event | Consumer Service(s) |
|-----------------|-------|---------------------|
| order-service | \`order.created\` | payment-service, notification-service |
| order-service | \`order.cancelled\` | payment-service, inventory-service |
| payment-service | \`payment.completed\` | order-service, ledger-service |
| payment-service | \`payment.failed\` | order-service, notification-service |
| user-service | \`user.registered\` | notification-service, compliance-service |
| user-service | \`user.kyc.verified\` | order-service, payment-service |

**Producer-side (Pact provider verification):**

- Verify that published events match the Pact contract
- Run against the schema registry to ensure Avro/JSON schema compatibility
- Tag provider versions with Git SHA for traceability

**Consumer-side (Pact consumer expectations):**

- Define expected event structure and required fields
- Verify deserialization into consumer's domain model
- Include negative cases: missing optional fields, unknown enum values

**Pact Broker:**

- Publish contracts to Pact Broker after consumer tests pass
- Provider verification pulls latest contracts from broker
- Use \`can-i-deploy\` check before any production deployment

**Run command:**

\`\`\`bash
# Consumer-side contract generation
./gradlew :services:order-service:pactTest

# Provider-side verification
./gradlew :services:payment-service:pactVerify

# Can-I-Deploy check
pact-broker can-i-deploy --pacticipant order-service --version $(git rev-parse HEAD) --to production
\`\`\`

### Layer 4: End-to-End Tests

Full workflow tests against staging environment with all services running.

**Critical E2E scenarios:**

| Scenario | Services Involved | Validates |
|----------|------------------|-----------|
| User registration → KYC → order placement | user-service, order-service | Full onboarding flow |
| Order → Payment → Confirmation | order-service, payment-service, notification-service | Happy path transaction |
| Payment failure → Order rollback | payment-service, order-service | Saga compensation |
| Rate limiting under load | gateway, all services | API gateway throttling |
| Service restart during Kafka consumption | Any consumer service | At-least-once delivery, idempotency |

**Standards:**

- E2E tests live in \`tests/e2e/\`
- Use REST Assured for API interactions
- Assert on final state (database records, Kafka events published) not just HTTP responses
- Maximum 30-second timeout per scenario
- Run against staging after Docker image build in CI pipeline

**Run command:**

\`\`\`bash
./gradlew :tests:e2e:test -Dspring.profiles.active=staging
\`\`\`

### Layer 5: Performance Tests

Establish baselines and detect regressions for latency and throughput.

**Targets:**

| Metric | Target | Tool |
|--------|--------|------|
| API p99 latency (order creation) | < 200ms | Gatling |
| API p99 latency (payment processing) | < 300ms | Gatling |
| Kafka consumer throughput | > 1000 events/sec per partition | Custom JMH benchmark |
| Redis cache hit ratio | > 95% for user lookups | Actuator metrics |
| Database query p99 | < 50ms | Testcontainers + JMH |
| Gateway routing overhead | < 10ms added latency | Gatling |

**Standards:**

- Performance tests in \`tests/performance/\`
- Gatling simulations for HTTP load testing
- JMH microbenchmarks for critical domain logic and serialization
- Run nightly in CI — not on every PR (too slow)
- Results published to Grafana dashboard for trend analysis
- Alert if p99 regresses by >20% from baseline

---

## Quality Gates

### Gate 1: Local Developer Check

**When**: Before pushing a branch
**Enforced by**: Pre-push Git hook (see \`plugin/codeforge-spring-boot-microservices/hooks/hooks.json\`)

| Check | Command | Pass Criteria |
|-------|---------|---------------|
| Compilation | \`./gradlew compileJava compileKotlin\` | Zero errors |
| Unit tests | \`./gradlew test\` | All pass |
| Checkstyle | \`./gradlew checkstyleMain\` | Zero violations |
| ktlint | \`./gradlew ktlintCheck\` | Zero violations |
| google-java-format | \`./gradlew verifyGoogleJavaFormat\` | All files formatted |

### Gate 2: Pull Request CI

**When**: PR opened or updated
**Enforced by**: GitHub Actions required status checks

| Check | Command | Pass Criteria |
|-------|---------|---------------|
| All Gate 1 checks | — | Pass |
| Integration tests | \`./gradlew integrationTest\` | All pass |
| Contract tests | \`./gradlew pactTest\` | All pass |
| JaCoCo coverage | \`./gradlew jacocoTestReport\` | ≥80% line coverage per module |
| SpotBugs | \`./gradlew spotbugsMain\` | Zero high/critical bugs |
| OWASP dependency check | \`./gradlew dependencyCheckAnalyze\` | Zero critical CVEs |
| Trivy container scan | \`trivy image <service>:latest\` | Zero critical/high vulnerabilities |
| AI code flag | Label check | AI-assisted code labeled in PR |
| CODEOWNERS | GitHub native | Required reviewers assigned |
| Signed commits | GitHub native | All commits GPG-signed |

### Gate 3: Pre-Production

**When**: Merge to \`main\` or \`release/*\`
**Enforced by**: GitHub Actions deployment workflow

| Check | Command | Pass Criteria |
|-------|---------|---------------|
| All Gate 2 checks | — | Pass |
| E2E tests on staging | \`./gradlew :tests:e2e:test\` | All pass |
| Pact can-i-deploy | \`pact-broker can-i-deploy\` | All contracts verified |
| Schema compatibility | Schema registry compatibility check | BACKWARD compatible |
| Helm lint | \`helm lint charts/<service>\` | Zero errors |
| Terraform plan | \`terraform plan -detailed-exitcode\` | No unexpected changes |

### Gate 4: Compliance Evidence (Periodic)

**When**: Weekly automated run + before audit
**Enforced by**: Scheduled GitHub Actions workflow

| Evidence | Source | SOC 2 Control | PCI DSS Requirement |
|----------|--------|---------------|---------------------|
| Test coverage report | JaCoCo HTML + XML | CC7.1 | Req 6.5 |
| Dependency vulnerability report | OWASP dependency-check | CC7.1 | Req 6.2 |
| Container vulnerability report | Trivy JSON output | CC7.1 | Req 6.2 |
| Code review audit trail | GitHub PR history | CC8.1 | Req 6.3.2 |
| Signed commit verification | Git log --show-signature | CC6.1 | Req 6.3 |
| Access control review | GitHub team/permission export | CC6.1 | Req 7.1 |
| Encryption-at-rest verification | AWS RDS/ElastiCache config | CC6.1 | Req 3.4 |
| Encryption-in-transit verification | TLS cert validation | CC6.1 | Req 4.1 |

---

## Deliverables

### D1: Test Suites Complete

- [ ] Unit tests for all services achieving ≥80% coverage
- [ ] Integration tests for all repository, Kafka, and Redis adapters
- [ ] Contract tests for all inter-service Kafka events
- [ ] E2E test suite covering critical business workflows
- [ ] Performance test baselines established

### D2: Quality Gate Automation

- [ ] GitHub Actions workflow: \`ci-test.yml\` with all Gate 2 checks
- [ ] GitHub Actions workflow: \`deploy-staging.yml\` with Gate 3 checks
- [ ] GitHub Actions workflow: \`compliance-evidence.yml\` (weekly schedule)
- [ ] Pre-push hook configured for Gate 1 checks
- [ ] Branch protection rules enforcing required status checks on \`main\` and \`release/*\`

### D3: Coverage and Reporting

- [ ] JaCoCo reports published as GitHub Actions artifacts
- [ ] JaCoCo coverage badge in each service's README
- [ ] Aggregated coverage report across all modules
- [ ] SpotBugs reports published as artifacts
- [ ] OWASP dependency-check reports archived for compliance

### D4: Test Infrastructure

- [ ] \`IntegrationTestBase\` class in \`shared/test-support\` module
- [ ] Testcontainers configuration for PostgreSQL, Kafka, Redis
- [ ] Test fixtures and builders for each domain (order, payment, user)
- [ ] Pact Broker running (or SaaS configured) with CI integration
- [ ] Gatling simulation scripts for critical API paths

### D5: Documentation

- [ ] Testing strategy document in \`docs/testing-strategy.md\`
- [ ] ADR: Why Pact for contract testing (vs Spring Cloud Contract)
- [ ] ADR: Testcontainers vs embedded databases
- [ ] Runbook: How to add tests for a new Kafka event
- [ ] Runbook: How to debug a failing contract test

---

## Gradle Configuration

### JaCoCo configuration in root \`build.gradle.kts\`:

\`\`\`kotlin
subprojects {
    apply(plugin = "jacoco")

    tasks.jacocoTestReport {
        dependsOn(tasks.test)
        reports {
            xml.required.set(true)
            html.required.set(true)
        }
    }

    tasks.jacocoTestCoverageVerification {
        violationRules {
            rule {
                limit {
                    minimum = "0.80".toBigDecimal()
                }
            }
            rule {
                element = "CLASS"
                excludes = listOf(
                    "*.config.*",
                    "*.dto.*",
                    "*Application"
                )
                limit {
                    minimum = "0.80".toBigDecimal()
                }
            }
        }
    }

    tasks.named("check") {
        dependsOn("jacocoTestCoverageVerification")
    }
}
\`\`\`

### Test source sets per service:

\`\`\`kotlin
// services/order-service/build.gradle.kts
sourceSets {
    create("integrationTest") {
        compileClasspath += sourceSets.main.get().output + sourceSets.test.get().output
        runtimeClasspath += sourceSets.main.get().output + sourceSets.test.get().output
    }
    create("contractTest") {
        compileClasspath += sourceSets.main.get().output + sourceSets.test.get().output
        runtimeClasspath += sourceSets.main.get().output + sourceSets.test.get().output
    }
}

tasks.register<Test>("integrationTest") {
    description = "Runs integration tests with Testcontainers"
    group = "verification"
    testClassesDirs = sourceS`,

  'playbook/phases/07-launch.md': `# Phase 07: Launch & Operations

## Phase Overview

**Objective**: Execute production launch of Spring Boot microservices with zero-downtime deployment, establish operational runbooks, enable observability across all services, and transition from project delivery to sustained operations with SLA-backed reliability.

**Duration**: 2-4 weeks (launch) + ongoing operations
**Phase ID**: \`07-launch\`
**Previous Phase**: [06 - Testing & Validation](./06-testing-validation.md)

---

## Prerequisites (from Phase 06)

- [ ] All quality gates from Phase 06 passed
- [ ] E2E test suites green across all service interactions
- [ ] Contract tests (Pact) verified between all producer-consumer pairs
- [ ] Performance benchmarks met: p99 latency < 200ms for synchronous endpoints
- [ ] Kafka consumer lag within acceptable thresholds under load
- [ ] Security scan (OWASP dependency-check, SpotBugs) clean — zero critical/high findings
- [ ] JaCoCo coverage ≥ 80% across all service modules
- [ ] Staging environment stable for ≥ 72 hours under synthetic traffic
- [ ] PCI DSS pre-launch checklist signed off by security lead
- [ ] SOC 2 control evidence collected and documented

---

## Objectives

### 7.1 Production Infrastructure Readiness

Validate that all AWS infrastructure provisioned via Terraform is production-grade.

**Deliverables**:
- Production Terraform apply completed and state locked in S3
- EKS cluster with production node groups (multi-AZ)
- RDS PostgreSQL instances per service (Multi-AZ, encrypted at rest, automated backups)
- ElastiCache Redis clusters (cluster mode enabled, encryption in transit + at rest)
- MSK Kafka cluster (3-broker minimum, TLS, SASL/SCRAM authentication)
- ECR repositories with image scanning enabled
- ALB with WAF rules and TLS termination via ACM certificates
- Route53 DNS records with health checks
- VPC security groups locked to least-privilege

**Verification**:
\`\`\`bash
# Validate Terraform state
cd infrastructure/production
terraform plan -detailed-exitcode

# Verify EKS cluster health
kubectl get nodes -o wide
kubectl get componentstatuses

# Verify MSK connectivity from within cluster
kubectl run kafka-test --rm -it --image=confluentinc/cp-kafka:7.5.0 -- \\
  kafka-broker-api-versions --bootstrap-server $MSK_BOOTSTRAP_SERVERS --command-config /etc/kafka/client.properties
\`\`\`

### 7.2 Production Deployment Execution

Deploy all microservices to production using Helm charts with blue-green or canary strategy.

**Deliverables**:
- Helm chart values files for production (\`charts/*/values-production.yaml\`)
- Deployment runbook in \`docs/runbooks/production-deployment.md\`
- Rollback procedures documented and tested
- Database migrations executed via Flyway (verified idempotent)
- Kafka topics created with production replication factor (3) and retention policies
- Spring Profiles set to \`production\` across all services

**Deployment Order** (respecting service dependencies):
1. **Schema Registry** — Avro/JSON schemas registered
2. **Shared infrastructure** — Redis, Kafka topics provisioned
3. **user-service** — Foundation service, no upstream dependencies
4. **payment-service** — Depends on user-service events
5. **order-service** — Depends on user-service and payment-service events
6. **gateway** — API Gateway (Spring Cloud Gateway) routes to all services

**Per-Service Deployment**:
\`\`\`bash
# Deploy with Helm (example: order-service)
helm upgrade --install order-service charts/order-service \\
  --namespace production \\
  --values charts/order-service/values-production.yaml \\
  --set image.tag=\${RELEASE_TAG} \\
  --set spring.profiles.active=production \\
  --wait --timeout 300s

# Verify deployment
kubectl rollout status deployment/order-service -n production
kubectl get pods -l app=order-service -n production

# Verify Spring Boot Actuator health
kubectl exec -it deploy/order-service -n production -- \\
  curl -s http://localhost:8080/actuator/health | jq .
\`\`\`

**Kafka Topic Provisioning**:
\`\`\`bash
# Production topic configuration
kafka-topics --create --bootstrap-server $MSK_BOOTSTRAP_SERVERS \\
  --topic user.events.v1 \\
  --partitions 12 --replication-factor 3 \\
  --config retention.ms=604800000 \\
  --config min.insync.replicas=2 \\
  --config cleanup.policy=delete

kafka-topics --create --bootstrap-server $MSK_BOOTSTRAP_SERVERS \\
  --topic payment.events.v1 \\
  --partitions 12 --replication-factor 3 \\
  --config retention.ms=2592000000 \\
  --config min.insync.replicas=2 \\
  --config cleanup.policy=delete

kafka-topics --create --bootstrap-server $MSK_BOOTSTRAP_SERVERS \\
  --topic order.events.v1 \\
  --partitions 12 --replication-factor 3 \\
  --config retention.ms=2592000000 \\
  --config min.insync.replicas=2 \\
  --config cleanup.policy=delete
\`\`\`

### 7.3 Observability Stack Activation

Enable full observability across all production services.

**Deliverables**:
- Prometheus scraping all Spring Boot Actuator \`/actuator/prometheus\` endpoints
- Grafana dashboards for each microservice (JVM metrics, HTTP metrics, Kafka consumer metrics)
- Jaeger distributed tracing collecting spans from all services
- ELK Stack ingesting structured JSON logs from all pods
- PagerDuty/Slack alerting integration configured

**Key Grafana Dashboards**:

| Dashboard | Metrics | Source |
|-----------|---------|--------|
| Service Health | HTTP request rate, error rate, latency (p50/p95/p99) | Prometheus (Spring Actuator) |
| JVM Performance | Heap usage, GC pauses, thread count | Prometheus (Micrometer) |
| Kafka Consumer | Consumer lag, records consumed/sec, commit rate | Prometheus (Spring Kafka metrics) |
| Kafka Producer | Send rate, error rate, batch size | Prometheus (Spring Kafka metrics) |
| Database | Connection pool usage, query latency, active connections | Prometheus (HikariCP metrics) |
| Redis | Hit/miss ratio, connection count, memory usage | Prometheus (Lettuce metrics) |
| API Gateway | Route-level latency, rate limiting triggers, circuit breaker state | Prometheus (Spring Cloud Gateway) |

**Alert Rules** (Prometheus Alertmanager):
\`\`\`yaml
# Critical alerts — PagerDuty
- alert: ServiceDown
  expr: up{job=~".*-service"} == 0
  for: 1m
  labels:
    severity: critical
    compliance: soc2

- alert: HighErrorRate
  expr: rate(http_server_requests_seconds_count{status=~"5.."}[5m]) / rate(http_server_requests_seconds_count[5m]) > 0.05
  for: 3m
  labels:
    severity: critical

- alert: KafkaConsumerLagCritical
  expr: kafka_consumer_records_lag_max > 10000
  for: 5m
  labels:
    severity: critical

- alert: DatabaseConnectionPoolExhausted
  expr: hikaricp_connections_active / hikaricp_connections_max > 0.9
  for: 2m
  labels:
    severity: warning

# PCI DSS compliance alerts
- alert: UnauthorizedAccessAttempt
  expr: rate(spring_security_authentication_failure_total[5m]) > 10
  for: 1m
  labels:
    severity: critical
    compliance: pci-dss
\`\`\`

### 7.4 Operational Runbooks

Create runbooks for every anticipated operational scenario.

**Deliverables** (in \`docs/runbooks/\`):

| Runbook | File | Description |
|---------|------|-------------|
| Production Deployment | \`production-deployment.md\` | Step-by-step deployment with rollback |
| Rollback Procedure | \`rollback.md\` | Helm rollback, Flyway undo, Kafka offset reset |
| Kafka Operations | \`kafka-operations.md\` | Topic management, consumer group reset, dead letter processing |
| Database Operations | \`database-operations.md\` | Failover, backup restore, migration rollback |
| Incident Response | \`incident-response.md\` | Severity classification, escalation paths, communication templates |
| Scaling | \`scaling.md\` | HPA tuning, Kafka partition rebalancing, RDS scaling |
| Secret Rotation | \`secret-rotation.md\` | Database credentials, API keys, TLS certificates |
| Disaster Recovery | \`disaster-recovery.md\` | Multi-region failover, data restoration, RTO/RPO targets |

**Incident Severity Levels**:

| Severity | Definition | Response Time | Example |
|----------|-----------|---------------|---------|
| SEV-1 | Complete service outage or data breach | 15 min | All payment processing down |
| SEV-2 | Degraded service affecting users | 30 min | Order service high latency |
| SEV-3 | Non-critical issue, workaround exists | 2 hours | Single consumer group lagging |
| SEV-4 | Minor issue, no user impact | Next business day | Dashboard metric gap |

### 7.5 Security & Compliance Go-Live

Finalize security posture for production launch.

**Deliverables**:
- Spring Security configurations reviewed and hardened for production profile
- OAuth2/JWT token validation configured with production JWKS endpoint
- Rate limiting enabled on API Gateway (Spring Cloud Gateway filters)
- Network policies applied in Kubernetes (deny-all default, explicit allow)
- Pod security standards enforced (restricted profile)
- Secrets managed via AWS Secrets Manager (not Kubernetes secrets)
- Audit logging enabled for all authentication and authorization events
- PCI DSS self-assessment questionnaire (SAQ) completed
- SOC 2 Type II evidence collection automated

**Security Verification**:
\`\`\`bash
# Verify no sensitive data in environment variables
kubectl get pods -n production -o jsonpath='{range .items[*]}{.metadata.name}{"\\n"}{range .spec.containers[*].env[*]}{.name}={.value}{"\\n"}{end}{end}' | grep -i -E "password|secret|key|token"

# Verify network policies
kubectl get networkpolicies -n production

# Verify pod security standards
kubectl get pods -n production -o jsonpath='{range .items[*]}{.metadata.name}: runAsNonRoot={.spec.containers[0].securityContext.runAsNonRoot}{"\\n"}{end}'

# Verify TLS on all ingress
kubectl get ingress -n production -o jsonpath='{range .items[*]}{.metadata.name}: tls={.spec.tls[*].hosts[*]}{"\\n"}{end}'
\`\`\`

### 7.6 Traffic Cutover & Validation

Execute controlled traffic migration to production.

**Cutover Steps**:
1. **Smoke tests** — Automated suite against production endpoints (read-only)
2. **Canary release** — Route 5% of traffic via ALB weighted target groups
3. **Monitor** — Watch dashboards for 30 minutes, verify zero errors
4. **Ramp** — Increase to 25%, 50%, 100% in 15-minute intervals
5. **Validate** — Full synthetic transaction flow (user creation → order → payment)
6. **DNS cutover** — Update Route53 to point production domain to new ALB

**Smoke Test Suite**:
\`\`\`bash
# Run production smoke tests
./gradlew :tests:e2e:test \\
  -Dspring.profiles.active=production-smoke \\
  -Dbase.url=https://api.production.example.com \\
  --tests "com.example.smoke.*"
\`\`\`

---

## Quality Gates

All gates must pass before declaring launch complete.

### Gate 7.1: Infrastructure Verification
- [ ] All Terraform resources in \`applied\` state with no drift
- [ ] EKS nodes healthy across all availability zones
- [ ] MSK cluster healthy, all brokers in-sync
- [ ] RDS instances Multi-AZ with automated backups verified
- [ ] ElastiCache cluster healthy with failover tested

### Gate 7.2: Service Health
- [ ] All microservices reporting \`UP\` via \`/actuator/health\`
- [ ] All Kafka consumers joined their consumer groups
- [ ] Database connection pools initialized (HikariCP active connections > 0)
- [ ] Redis connectivity verified from all services
- [ ] API Gateway routing to all downstream services

### Gate 7.3: Observability Verified
- [ ] Prometheus scraping all service targets (no \`down\` targets)
- [ ] Grafana dashboards rendering real production data
- [ ] Jaeger showing distributed traces across service boundaries
- [ ] ELK Stack indexing logs from all pods
- [ ] Alert rules firing correctly (tested with synthetic failure)

### Gate 7.4: Security Sign-Off
- [ ] Production security scan clean (SpotBugs, OWASP dependency-check)
- [ ] Penetration test results reviewed — no critical/high findings open
- [ ] Network policies enforced — inter-namespace traffic blocked
- [ ] Secrets rotation procedure tested
- [ ] Audit log pipeline verified end-to-end
- [ ] PCI DSS controls validated by compliance officer
- [ ] SOC 2 evidence artifacts archived

### Gate 7.5: Operational Readiness
- [ ] All runbooks reviewed and approved by on-call engineers
- [ ] On-call rotation established (PagerDuty schedule configured)
- [ ] Rollback procedure tested in staging within last 48 hours
- [ ] Disaster recovery drill completed (RTO < 4 hours, RPO < 1 hour)
- [ ] Capacity planning documented for next 6 months

### Gate 7.6: Traffic Validation
- [ ] Smoke tests passing against production
- [ ] Canary deployment validated at 5%, 25%, 50%, 100%
- [ ] Zero SEV-1 or SEV-2 incidents during ramp
- [ ] End-to-end transaction flow verified (user → order → payment → confirmation)
- [ ] Kafka event flow verified across all topics (producer → consumer → dead letter handling)

---

## Ongoing Operations

### Daily Operations Checklist
- [ ] Review Grafana dashboards for anomalies
- [ ] Check Kafka consumer lag across all consumer groups
- [ ] Review error rate trends in ELK Stack
- [ ] Verify backup completion (RDS snapshots, Kafka topic backups)
- [ ] Review security alerts from WAF and Spring Security audit logs

### Weekly Operations
- [ ] Dependency vulnerability scan (\`./gradlew dependencyCheckAnalyze\`)
- [ ] Review and triage Jira tickets from production incidents
- [ ] Capacity review — CPU/memory utilization trends
- [ ] Kafka partition balance check
- [ ] Database query performance review (slow query log)

### Monthly Operations
- [ ] Secret rotation (database credentials, API keys)
- [ ] TLS certificate renewal check
- [ ] Disaster recovery drill
- [ ] SOC 2 control evidence review
- [ ] PCI DSS compliance spot check
- [ ] Architecture review — evaluate technical debt backlog

### Continuous Improvement
- Post-incident reviews (blameless) within 48 hours of any SEV-1/SEV-2
- Architecture Decision Records (ADRs) for any operational changes
- Quarterly capacity planning updates
- Service dependency map kept current in \`docs/architecture/\`

---

## GitHub Actions: Production Deployment Pipeline

Reference workflow: \`.github/workflows/deploy-production.yml\`

\`\`\`yaml
# Key stages for production deployment
# 1. All CI checks pass (lint, compile, test, security scan)
# 2. Docker image built and pushed to ECR with release tag
# 3. Helm upgrade to staging, E2E tests pass
# 4. Manual approval gate (2 approvers required)
# 5. Helm upgrade to production with canary strategy
# 6. Smoke tests against production
# 7. Full traffic cutover
# 8. Post-deployment verification
\`\`\`

---

## Phase Completion Criteria

This phase is complete when:

1. All six quality gates are passed and documented
2. Production is serving live traffic with zero critical issues
3. Observability stack is fully operational with alerting
4. On-call rotation is active with trained engineers
5. All runbooks are`,

  'playbook/prompts/01/gather-requirements.md': `# Gather Requirements — Phase 01 Discovery Prompt

> **Copy-paste this prompt into Claude Code** at the start of a new microservice or feature initiative.
> Assumes you are in the repository root of \`spring-boot-microservices\`.

---

## Prompt

\`\`\`
I need your help gathering and structuring requirements for a new initiative in our Spring Boot microservices platform. This is Phase 01 (Discovery) of our development playbook.

## Context

This is a fintech platform with SOC 2 and PCI DSS compliance requirements. The architecture is:
- Spring Boot 3.2 / Java 21 microservices in a Gradle multi-module monorepo
- Hexagonal Architecture (Ports & Adapters) per service
- Apache Kafka for all inter-service communication (no direct REST calls between services)
- PostgreSQL per-service databases, Redis for caching/sessions
- Deployed on AWS EKS via Helm charts

The existing services live under \`services/\`, shared libraries under \`shared/\`, Kafka event schemas under \`schema-registry/\`, and Helm charts under \`charts/\`.

## What I'm building

[REPLACE THIS: Describe the feature, service, or capability you want to build. Be as specific as possible. Examples:
- "A new payment-reconciliation-service that consumes transaction events from Kafka, matches them against bank settlement files, and produces reconciliation-result events"
- "Add idempotent retry logic to the payment-service for failed downstream bank API calls"
- "A new notification-service that listens to order and payment events and sends emails/SMS via AWS SES and SNS"]

## Jira ticket(s)

[REPLACE THIS: Paste the Jira ticket ID(s) and summary, e.g., PAY-456: Implement payment reconciliation service]

## Please do the following

### 1. Clarify & decompose requirements
- Ask me clarifying questions about anything ambiguous before proceeding
- Identify functional requirements (what the system must do)
- Identify non-functional requirements (latency, throughput, availability, data retention)
- Identify compliance requirements specific to this feature (PCI DSS data handling, audit logging, encryption at rest/in transit)
- Call out any implicit requirements I may have missed

### 2. Identify domain boundaries
- Which bounded context does this belong to?
- Does this warrant a new microservice under \`services/\` or should it extend an existing one?
- What domain entities and value objects are involved?
- What aggregate roots will own the transactional boundaries?

### 3. Map Kafka event flows
- What existing Kafka topics does this feature need to consume from? Check \`schema-registry/\` for current schemas.
- What new Kafka topics need to be created?
- What event schemas (Avro/JSON Schema) need to be defined or extended?
- What consumer group(s) will be used?
- What are the ordering and partitioning requirements?
- Are there any exactly-once or idempotency requirements?

### 4. Identify data requirements
- What new PostgreSQL tables or schema changes are needed?
- What indexes are required for expected query patterns?
- What data falls under PCI DSS scope (cardholder data, PANs, etc.) and needs encryption/tokenization?
- What Redis caching strategies apply?
- What data retention and purging policies apply?

### 5. Map API surface
- What REST endpoints does this expose (if any) through the API gateway?
- What Spring Security authorization rules apply?
- What request/response DTOs are needed?
- Does this need an OpenAPI spec under the service module?

### 6. Identify integration points
- What existing services will be affected?
- What shared libraries under \`shared/\` need changes?
- What external systems or third-party APIs are involved?
- What circuit breaker / retry / timeout configurations are needed?

### 7. Identify risks and open questions
- What technical risks do you see?
- What compliance risks need security team review?
- What are the unknowns that need spike work?
- Are there any data migration concerns?

### 8. Produce a structured output

Format the final requirements as a Markdown document with this structure:

\`\`\`markdown
# Requirements: [Feature/Service Name]
## Jira: [TICKET-ID]
## Status: Draft
## Author: [name] + Claude Code (AI-assisted)

### 1. Overview
### 2. Functional Requirements (FR-001, FR-002, ...)
### 3. Non-Functional Requirements (NFR-001, NFR-002, ...)
### 4. Compliance Requirements (CR-001, CR-002, ...)
### 5. Domain Model
### 6. Kafka Event Flows (with topic names, schemas, consumer groups)
### 7. Data Model (tables, indexes, PCI scope flags)
### 8. API Surface (endpoints, auth rules)
### 9. Integration Points
### 10. Risks & Open Questions
### 11. Acceptance Criteria (Given/When/Then format)
### 12. Out of Scope
\`\`\`

Save this document to \`docs/requirements/[service-or-feature-name]-requirements.md\`.

### Important constraints
- All inter-service communication MUST go through Kafka — no synchronous REST calls between services
- Every new Kafka event MUST have a schema defined in \`schema-registry/\`
- Any PCI-scoped data must be flagged explicitly for encryption and access control review
- The service must expose Spring Actuator health/readiness/liveness endpoints
- Requirements must be traceable to Jira tickets
- Mark this document as AI-assisted per our team policy

Ask your clarifying questions first before producing the requirements document.
\`\`\`

---

## Usage Notes

| Step | Action |
|------|--------|
| 1 | Copy the prompt above into Claude Code |
| 2 | Replace the \`[REPLACE THIS]\` sections with your actual feature description and Jira tickets |
| 3 | Answer Claude's clarifying questions — expect 5-10 questions on domain, data sensitivity, throughput |
| 4 | Review the generated requirements document in \`docs/requirements/\` |
| 5 | Commit with message: \`docs: add requirements for [feature] (PAY-XXX)\` |
| 6 | Share in Slack and link from Jira ticket for team review |
| 7 | Once approved, advance to Phase 02 with \`codeforge-phase advance\` |

## What good output looks like

- Every functional requirement has a unique ID (FR-001) traceable to a Jira ticket
- Kafka topics follow naming convention: \`{domain}.{entity}.{event}\` (e.g., \`payment.transaction.completed\`)
- Consumer groups follow: \`{service-name}-{topic}-cg\` (e.g., \`reconciliation-service-payment-transaction-completed-cg\`)
- PCI-scoped fields are explicitly called out with encryption strategy
- Acceptance criteria are in Given/When/Then format suitable for writing Pact contract tests and JUnit 5 integration tests
- Non-functional requirements include concrete numbers (e.g., "p99 latency < 200ms", "handle 500 events/sec per partition")
- The document flags what needs security team sign-off before Phase 02

## Related playbook files

- Phase definition: \`playbook/phases/01-discovery.md\`
- Next phase prompt: \`playbook/prompts/02/define-architecture.md\`
- Architect agent: \`plugin/codeforge-spring-boot-microservices/agents/architect.md\`
- Phase command: \`plugin/codeforge-spring-boot-microservices/commands/phase.md\``,

  'playbook/prompts/01/nfr-checklist.md': `# NFR Checklist — Non-Functional Requirements for Spring Boot Microservices

> **Phase**: 01 — Discovery
> **Usage**: Copy-paste this prompt into Claude Code to generate a comprehensive non-functional requirements checklist tailored to your microservice platform.

---

## Prompt

\`\`\`
I need you to produce a detailed Non-Functional Requirements (NFR) checklist for our Spring Boot microservices platform. This is a fintech system subject to SOC 2 and PCI DSS compliance. Use the context below and output a structured markdown document I can commit to \`docs/nfr-checklist.md\`.

## System Context

- **Architecture**: Event-driven microservices (Hexagonal / Ports & Adapters)
- **Services**: order-service, payment-service, user-service (more to come), plus API gateway (Spring Cloud Gateway)
- **Runtime**: Java 21, Spring Boot 3.2, deployed on AWS EKS (Kubernetes)
- **Messaging**: Apache Kafka (AWS MSK) for all inter-service communication — no direct REST between services
- **Databases**: PostgreSQL (AWS RDS) per service, Redis (AWS ElastiCache) for caching and sessions
- **Observability**: Prometheus + Grafana (metrics), Jaeger (distributed tracing), ELK Stack (centralized logging)
- **CI/CD**: GitHub Actions → Docker (ECR) → Helm → Kubernetes
- **Compliance**: SOC 2 Type II, PCI DSS Level 1

## NFR Categories to Cover

For each category, produce:
1. **Requirement ID** (e.g., NFR-PERF-001)
2. **Requirement statement** (clear, measurable, testable)
3. **Acceptance criteria** (specific thresholds or conditions)
4. **Verification method** (how we test or prove it)
5. **Priority** (P0 = must-have for launch, P1 = must-have within 90 days, P2 = planned)

### 1. Performance
- API gateway p50/p95/p99 latency targets for synchronous endpoints
- Kafka consumer lag thresholds per consumer group
- Kafka end-to-end event processing latency (producer → consumer acknowledgment)
- Database query execution time limits (PostgreSQL)
- Redis cache hit ratio targets
- Spring Boot startup time per service
- Throughput targets (requests/sec at the gateway, events/sec through Kafka)
- Connection pool sizing (HikariCP, Lettuce/Jedis, Kafka producer/consumer)

### 2. Scalability
- Horizontal pod autoscaling (HPA) triggers and limits per service
- Kafka partition strategy and consumer group scaling
- Database connection scaling under load
- Redis cluster scaling strategy
- Stateless service design verification (no local state except cache)
- Load test targets (concurrent users, sustained throughput)

### 3. Reliability & Availability
- Service-level objectives (SLO) per service and for the platform overall
- Kafka consumer retry and dead-letter topic (DLT) strategy
- Circuit breaker configuration (Resilience4j) for external integrations
- Database failover (RDS Multi-AZ) and recovery time
- Redis failover (ElastiCache Multi-AZ) and session recovery
- Kubernetes pod disruption budgets (PDB)
- Graceful shutdown handling (Spring Boot lifecycle, Kafka consumer offset commit)
- Idempotency requirements for Kafka consumers and API endpoints

### 4. Security (SOC 2 + PCI DSS)
- Authentication: OAuth 2.0 / JWT validation at the gateway
- Authorization: Role-based access control (RBAC) per service endpoint
- Encryption at rest: RDS, ElastiCache, EBS, S3
- Encryption in transit: TLS 1.2+ everywhere (service-to-service, client-to-gateway, Kafka)
- Kafka authentication (SASL/SCRAM or mTLS) and authorization (ACLs)
- Secret management (AWS Secrets Manager, no secrets in code or config files)
- PCI DSS cardholder data isolation in payment-service
- Audit logging for all state-changing operations (who, what, when, from where)
- Dependency vulnerability scanning (OWASP dependency-check, Trivy for containers)
- Spring Security configuration hardening (CSRF, CORS, headers)
- Network segmentation (VPC, security groups, Kubernetes NetworkPolicies)
- Container image signing and provenance

### 5. Observability & Monitoring
- Structured JSON logging with correlation IDs across all services
- Distributed tracing coverage (Jaeger trace propagation through Kafka headers)
- Spring Boot Actuator health, readiness, and liveness endpoints per service
- Prometheus metrics: JVM, Kafka consumer lag, HikariCP pool, custom business metrics
- Grafana dashboard requirements per service and platform-wide
- Alerting rules (PagerDuty/Slack) for SLO breaches, error rate spikes, Kafka lag
- Log retention and searchability requirements (ELK)
- Audit trail queryability for compliance

### 6. Data Integrity & Consistency
- Kafka exactly-once semantics (EOS) or at-least-once with idempotent consumers
- Outbox pattern for reliable event publishing from PostgreSQL
- Schema evolution strategy (schema-registry, backward/forward compatibility)
- Database migration strategy (Flyway, zero-downtime migrations)
- Backup and point-in-time recovery (RDS automated backups, retention period)
- Redis data loss tolerance (what can be rebuilt vs. what is critical)

### 7. Maintainability & Developer Experience
- Service module structure adherence (Hexagonal Architecture)
- Code coverage threshold: 80% (JaCoCo)
- Max file length: 300 lines
- Checkstyle and ktlint compliance (zero warnings on main)
- Testcontainers for all integration tests (no shared test databases)
- Contract tests (Pact) between services via Kafka
- OpenAPI spec per service, kept in sync with implementation
- Build time targets (\`./gradlew build\` for a single service)
- Local development experience (docker-compose for dependencies)

### 8. Deployment & Operations
- Zero-downtime deployments (rolling update strategy in Kubernetes)
- Canary or blue-green deployment capability
- Rollback time target
- Helm chart linting and validation in CI
- Infrastructure as Code coverage (Terraform for all AWS resources)
- Disaster recovery: RTO and RPO targets
- Runbook requirement for every production service (in \`docs/runbooks/\`)

### 9. Compliance & Audit
- SOC 2 control mapping for each NFR
- PCI DSS requirement mapping for payment-service
- Change management: all production changes via PR with 2 approvals + signed commits
- Access control: least-privilege IAM roles, Kubernetes RBAC
- Evidence collection automation for audit cycles
- Data retention and deletion policies (GDPR-adjacent even if not required)

## Output Format

Structure the output as a markdown table per category with columns:
| ID | Requirement | Acceptance Criteria | Verification | Priority |

Include a summary section at the top with:
- Total NFR count by priority (P0, P1, P2)
- Key risks if NFRs are not met
- Suggested review cadence (e.g., quarterly)

Add a section at the bottom mapping critical NFRs to SOC 2 Trust Service Criteria (CC6, CC7, CC8, A1) and PCI DSS requirements (Req 1-6 for payment-service).

Save the output so it can be committed to \`docs/nfr-checklist.md\`.
\`\`\`

---

## What This Prompt Produces

- A **complete NFR checklist** with 50–80 measurable requirements across 9 categories
- **Concrete thresholds** (e.g., p99 < 200ms, Kafka lag < 1000, coverage ≥ 80%)
- **Verification methods** tied to actual tools: JMeter/Gatling, Prometheus queries, JaCoCo reports, Trivy scans
- **Compliance mappings** to SOC 2 and PCI DSS controls
- A document ready for architecture review and stakeholder sign-off

## Follow-Up Prompts

After generating the checklist, use these to refine:

\`\`\`
Review docs/nfr-checklist.md and cross-reference against our current Spring Boot Actuator
configuration in each service. Identify which health/readiness/liveness checks are already
implemented and which are missing. Output a gap analysis.
\`\`\`

\`\`\`
For each P0 NFR in docs/nfr-checklist.md, suggest the specific Prometheus alerting rule
(PromQL) we should add to our Grafana alerting configuration. Output as a YAML file
compatible with Prometheus alerting rules.
\`\`\`

\`\`\`
Map the security NFRs from docs/nfr-checklist.md to specific Spring Security configuration
changes needed in each service. For each, show the Java config class or application.yml
property that satisfies the requirement.
\`\`\`

## Related Files

- \`playbook/phases/01-discovery.md\` — Phase 01 overview and exit criteria
- \`playbook/prompts/01/gather-requirements.md\` — Functional requirements gathering prompt
- \`docs/\` — Target directory for the generated checklist
- \`plugin/codeforge-spring-boot-microservices/agents/architect.md\` — Architect agent for NFR review`,

  'playbook/prompts/01/user-stories.md': `# User Stories — Phase 01 Discovery

## Copy-Paste Prompt for Claude Code

\`\`\`
I need you to generate user stories for a Spring Boot microservice feature. Use the context below and the Jira ticket (if provided) to produce well-structured, implementation-ready user stories.

## Context

This is a Spring Boot 3.2 / Java 21 event-driven microservices platform for financial services (SOC 2, PCI DSS compliant). The architecture uses:

- **Hexagonal Architecture** (Ports & Adapters) per service
- **Kafka** for all inter-service communication (no direct REST between services)
- **PostgreSQL** per-service databases (strict data ownership)
- **Redis** for caching and session management
- **Spring Security** with OAuth2/JWT for authentication
- **Kubernetes** deployment via Helm charts

### Services in the platform:
- \`order-service\` — order lifecycle management
- \`payment-service\` — payment processing and reconciliation
- \`user-service\` — identity, authentication, profiles
- \`gateway\` — API gateway (Spring Cloud Gateway)
- Additional services as needed per feature

### Key directories:
- \`services/<service-name>/\` — individual microservice modules
- \`shared/\` — shared domain events, DTOs, common utilities
- \`schema-registry/\` — Avro/JSON schemas for Kafka events
- \`charts/<service-name>/\` — Helm charts per service
- \`infrastructure/\` — Terraform IaC

## Instructions

1. **Read the Jira ticket** (if a ticket ID like PAY-123 is provided, fetch it via MCP) or use the feature description I provide below.

2. **Generate user stories** in this format for each story:

\`\`\`markdown
### US-<number>: <title>
**As a** <role>
**I want** <capability>
**So that** <business value>

**Service(s):** \`<service-name>\`
**Kafka Events (produced):** \`<TopicName>\` — \`<EventSchemaName>\`
**Kafka Events (consumed):** \`<TopicName>\` — \`<EventSchemaName>\`
**API Endpoints:** \`<METHOD> /api/v1/<path>\` (if externally exposed via gateway)

#### Acceptance Criteria
- [ ] AC1: <specific, testable criterion>
- [ ] AC2: <specific, testable criterion>
- [ ] AC3: <specific, testable criterion>

#### Technical Notes
- Hexagonal layer affected: [Domain | Application | Infrastructure]
- Database changes: [migration description or "None"]
- Redis usage: [cache strategy or "None"]
- Security: [auth requirements, PCI DSS considerations]
- Schema registry: [new/updated schema path]

#### Test Requirements
- Unit: <what to test with JUnit 5 + Mockito>
- Integration: <what to test with Testcontainers — Kafka, PostgreSQL, Redis>
- Contract: <Pact contract if inter-service API boundary>

#### Estimated Complexity
- T-shirt size: [S | M | L | XL]
- Story points suggestion: [1 | 2 | 3 | 5 | 8 | 13]
\`\`\`

3. **Apply these rules:**
   - Each story must be completable within a single service module (or shared library)
   - If a feature spans multiple services, split into separate stories per service with Kafka events as the integration boundary
   - Every Kafka event must reference a schema in \`schema-registry/\`
   - Stories touching payment data must note PCI DSS scope and data handling requirements
   - Stories touching user PII must note SOC 2 data protection requirements
   - Include database migration stories separately if schema changes are non-trivial
   - API endpoints exposed through the gateway must include rate limiting and auth requirements
   - Every story must have at least one unit test and one integration test criterion
   - Use conventional commit scope in technical notes (e.g., \`feat(payment-service):\`)

4. **Group stories into epics** if the feature is large:
   - Epic 1: Domain & Schema — domain models, Kafka event schemas, database migrations
   - Epic 2: Core Logic — application services, domain ports, use cases
   - Epic 3: Infrastructure — adapters, Kafka producers/consumers, REST controllers
   - Epic 4: Cross-Cutting — security, caching, monitoring, observability

5. **Include a dependency graph** showing story execution order:
   \`\`\`
   US-01 (schema) → US-02 (domain) → US-03 (application) → US-04 (kafka adapter)
                                                            → US-05 (rest adapter)
   \`\`\`

6. **Flag risks and open questions** at the end:
   - Data consistency concerns across services
   - Kafka topic partitioning strategy for the new events
   - Idempotency requirements for consumers
   - Compensation/saga patterns needed for distributed transactions
   - PCI DSS or SOC 2 audit implications

## Feature to Analyze

<PASTE YOUR JIRA TICKET ID OR FEATURE DESCRIPTION HERE>

Example: "Add refund processing capability to payment-service that handles full and partial refunds, notifies order-service of refund status, and maintains an audit trail for PCI DSS compliance."
\`\`\`

## When to Use This Prompt

- At the start of Phase 01 (Discovery) after requirements are gathered via \`playbook/prompts/01/gather-requirements.md\`
- When a new Jira epic or feature request arrives and needs decomposition
- When refining a backlog item into sprint-ready stories
- Before starting Phase 02 (Architecture) — stories inform architectural decisions

## Tips for Best Results

1. **Provide the Jira ticket ID** if your MCP integration is configured — Claude will fetch full context including comments and linked issues
2. **Include existing domain context** — mention which services already exist and what Kafka topics are in play (check \`schema-registry/\` for current schemas)
3. **Specify the actor** — "merchant", "end-user", "system administrator", "compliance officer" produces more targeted stories than generic "user"
4. **Mention constraints upfront** — if there's a deadline, a specific AWS service requirement, or a compliance audit date, include it
5. **Iterate** — paste the generated stories back and ask Claude to refine acceptance criteria or split stories that are too large (anything over 8 points)

## Integration with Workflow

After generating user stories:

1. Review stories with the team (async via Slack or sync meeting)
2. Create Jira tickets from approved stories (use MCP if available)
3. Update \`playbook/current-phase.json\` to track progress
4. Proceed to Phase 02 with \`playbook/prompts/02/\` for architecture decisions
5. Reference these stories in branch names: \`feat/PAY-123-add-refund-processing\`

## Example Output Snippet

Below is a partial example of what Claude should produce:

---

### US-01: Define Refund Event Schema
**As a** platform architect
**I want** a versioned Avro schema for \`RefundRequested\` and \`RefundCompleted\` events
**So that** all services have a contract for refund-related communication

**Service(s):** \`shared\`, \`schema-registry\`
**Kafka Events (produced):** N/A (schema definition only)
**Kafka Events (consumed):** N/A

#### Acceptance Criteria
- [ ] \`RefundRequested.avsc\` schema exists in \`schema-registry/events/payment/\`
- [ ] \`RefundCompleted.avsc\` schema exists in \`schema-registry/events/payment/\`
- [ ] Schemas include \`refundId\`, \`orderId\`, \`amount\`, \`currency\`, \`reason\`, \`requestedBy\`, \`timestamp\`
- [ ] Schemas are backward-compatible with existing payment event schemas
- [ ] Shared DTOs generated in \`shared/domain-events/\` via Gradle Avro plugin

#### Technical Notes
- Hexagonal layer affected: Domain (shared events)
- Database changes: None
- Redis usage: None
- Security: \`requestedBy\` field must not contain PII — use opaque user reference ID
- Schema registry: \`schema-registry/events/payment/RefundRequested.avsc\`, \`schema-registry/events/payment/RefundCompleted.avsc\`
- Commit scope: \`feat(schema-registry): add refund event schemas\`

#### Test Requirements
- Unit: Schema serialization/deserialization roundtrip test
- Integration: Schema registry compatibility check
- Contract: N/A (schema is the contract)

#### Estimated Complexity
- T-shirt size: S
- Story points suggestion: 2

---

### US-02: Implement Refund Domain Model
**As a** payment-service developer
**I want** a \`Refund\` aggregate root with domain validation
**So that** refund business rules are enforced consistently

**Service(s):** \`payment-service\`
**Kafka Events (produced):** None (domain layer only)
**Kafka Events (consumed):** None

#### Acceptance Criteria
- [ ] \`Refund\` entity with states: \`REQUESTED\`, \`APPROVED\`, \`PROCESSING\`, \`COMPLETED\`, \`FAILED\`
- [ ] Domain validation: refund amount ≤ original payment amount
- [ ] Domain validation: refund not allowed on already-fully-refunded payments
- [ ] Partial refund tracking with remaining refundable balance
- [ ] Immutable audit fields: \`createdAt\`, \`createdBy\`, \`lastModifiedAt\`

#### Technical Notes
- Hexagonal layer affected: Domain
- Database changes: \`V007__create_refund_table.sql\` migration in \`payment-service/src/main/resources/db/migration/\`
- Redis usage: None
- Security: PCI DSS — refund records must be retained for 7 years; mask card data in refund references
- Schema registry: N/A
- Commit scope: \`feat(payment-service): add refund domain model\`

#### Test Requirements
- Unit: Domain validation rules (JUnit 5), state transition tests
- Integration: Flyway migration test with Testcontainers PostgreSQL
- Contract: N/A

#### Estimated Complexity
- T-shirt size: M
- Story points suggestion: 5`,

  'playbook/prompts/02/adr-generator.md': `# ADR Generator — Phase 02: Architecture

Use this prompt in Claude Code to generate Architecture Decision Records for your Spring Boot microservices platform.

---

## Prompt

\`\`\`
You are an architect for a Spring Boot 3.2 / Java 21 microservices platform in the financial services domain (SOC 2, PCI DSS compliant). We use hexagonal architecture, Kafka for all inter-service communication (no direct REST between services), PostgreSQL per-service databases, Redis for caching/sessions, and deploy to AWS EKS via Helm charts.

Generate an Architecture Decision Record (ADR) for the following decision:

**Decision Topic**: [REPLACE WITH YOUR TOPIC — e.g., "Event schema format for Kafka domain events", "Database-per-service isolation strategy", "API gateway authentication flow", "Saga pattern for distributed transactions", "Kafka topic partitioning strategy for payment events"]

Use this ADR template and fill in every section with concrete, project-specific detail. Do NOT be generic — reference our actual tech stack, compliance requirements, and architecture patterns.

---

## ADR Format

**File location**: \`docs/adr/NNNN-<kebab-case-title>.md\` (use the next available number)

\`\`\`markdown
# ADR-NNNN: <Title>

## Status
Proposed | Accepted | Deprecated | Superseded by ADR-XXXX

## Date
<YYYY-MM-DD>

## Context

Describe the technical or business context that makes this decision necessary. Reference:
- Which microservices are affected (e.g., order-service, payment-service, user-service)
- Current pain points or architectural gaps
- Compliance drivers (SOC 2 audit logging, PCI DSS data isolation, encryption requirements)
- Scale or performance considerations
- Team constraints (6-15 backend devs across Europe + Americas timezones)

## Decision Drivers

- **Compliance**: SOC 2 / PCI DSS requirements that influence this decision
- **Architecture**: Hexagonal architecture (ports & adapters) constraints
- **Communication**: Kafka-only inter-service communication rule
- **Data**: PostgreSQL per-service, Redis caching strategy
- **Operations**: Kubernetes-native deployment, observability (Prometheus, Grafana, Jaeger, ELK)
- **Team**: Conventional commits, 80% coverage threshold, Testcontainers for integration tests

## Options Considered

### Option A: <Name>
- **Description**: Concrete description with Spring Boot / Kafka / AWS specifics
- **Pros**: List with technical detail
- **Cons**: List with technical detail
- **Compliance impact**: How this affects SOC 2 / PCI DSS posture

### Option B: <Name>
- (same structure)

### Option C: <Name> (if applicable)
- (same structure)

## Decision

State the chosen option and the rationale. Be specific:
- Which Spring Boot starters or libraries are involved
- Which Kafka topics, consumer groups, or schema registry entries are affected
- Which Gradle modules need changes
- Which Helm chart values or Terraform resources are impacted

## Consequences

### Positive
- Concrete benefits to our microservice platform

### Negative
- Trade-offs accepted, technical debt introduced

### Risks
- What could go wrong, with mitigation strategies

## Implementation Notes

- Affected Gradle modules: \`services/<service-name>\`, \`shared/<library-name>\`
- New/modified Kafka topics: \`<domain>.<entity>.<event-type>\` naming convention
- Schema registry changes: \`schema-registry/avro/<schema-name>.avsc\` or \`schema-registry/json/<schema-name>.json\`
- Spring Profile configuration: what changes per environment (dev, staging, production)
- Database migrations: Flyway scripts in \`services/<service>/src/main/resources/db/migration/\`
- Helm chart changes: \`charts/<service>/values.yaml\`, \`charts/<service>/templates/\`
- Terraform changes: \`infrastructure/terraform/modules/<module>/\`
- Monitoring: new Prometheus metrics, Grafana dashboards, Jaeger trace spans, ELK log patterns
- Security: Spring Security filter chain changes, encryption, audit logging

## Compliance Checklist

- [ ] SOC 2: Audit trail for this change is captured (structured logging to ELK)
- [ ] SOC 2: Access controls reviewed (Spring Security, K8s RBAC, AWS IAM)
- [ ] PCI DSS: Cardholder data is not exposed in logs, events, or caches
- [ ] PCI DSS: Encryption at rest (RDS, ElastiCache) and in transit (TLS, MSK encryption)
- [ ] PCI DSS: Network segmentation maintained (K8s NetworkPolicies, AWS Security Groups)
- [ ] Data retention and purge strategy defined if PII/CHD is involved

## Related

- **Jira Epic/Ticket**: [REPLACE — e.g., ARCH-456]
- **Related ADRs**: [List any ADRs this builds on or supersedes]
- **Confluence**: [Link to design doc if applicable]
- **OpenAPI Spec**: [If API changes — e.g., gateway/src/main/resources/openapi/gateway-api.yaml]
\`\`\`

---

Additional instructions:
1. Number the ADR sequentially — check \`docs/adr/\` for the latest number
2. Use our Kafka topic naming convention: \`<bounded-context>.<aggregate>.<event-type>\` (e.g., \`payments.transaction.completed\`)
3. Reference hexagonal architecture layers: domain, application (use cases), infrastructure (adapters)
4. For any new shared code, specify whether it goes in \`shared/domain-events/\`, \`shared/common/\`, or a new shared module
5. If the decision affects the API gateway, note changes to \`gateway/\` routes and filters
6. If the decision introduces a new dependency, flag it — we use a conservative approved-dependency policy
7. Tag the ADR with the services it impacts for CODEOWNERS alignment
8. After generating, run: \`ls docs/adr/ | tail -5\` to verify file placement
\`\`\`

---

## Usage Examples

### Example 1: Event Schema Format
Replace the topic line with:
\`\`\`
**Decision Topic**: "Choosing between Avro and JSON Schema for Kafka domain events in the schema registry"
\`\`\`

### Example 2: Distributed Transaction Pattern
\`\`\`
**Decision Topic**: "Saga orchestration vs choreography for the order-to-payment-to-fulfillment flow"
\`\`\`

### Example 3: Service Authentication
\`\`\`
**Decision Topic**: "mTLS vs JWT for service-to-gateway authentication in the Spring Cloud Gateway"
\`\`\`

### Example 4: Database Migration Strategy
\`\`\`
**Decision Topic**: "Flyway vs Liquibase for per-service PostgreSQL schema migrations"
\`\`\`

### Example 5: Kafka Consumer Error Handling
\`\`\`
**Decision Topic**: "Dead letter topic strategy and retry policy for failed Kafka consumer messages across all services"
\`\`\`

---

## Batch Generation

To generate multiple foundational ADRs at once, use this follow-up prompt:

\`\`\`
Generate ADRs for these foundational architecture decisions for our Spring Boot microservices platform. Number them sequentially starting from ADR-0001. Create each as a separate file in docs/adr/:

1. Hexagonal architecture enforcement across all microservices
2. Kafka topic naming convention and partitioning strategy
3. PostgreSQL per-service database isolation and shared-nothing principle
4. API gateway routing, rate limiting, and authentication
5. Distributed tracing strategy with Jaeger and Spring Boot Actuator
6. Secret management for PCI DSS compliance (AWS Secrets Manager + K8s Secrets)
7. Event sourcing vs event notification for domain events
8. Redis caching strategy and cache invalidation patterns
9. Gradle multi-module structure and dependency management
10. Container image build and registry strategy (ECR, multi-stage Docker builds)

For each ADR, follow the template in docs/adr/ and include the compliance checklist. Reference concrete module paths, Kafka topics, Spring configurations, and Helm values.
\`\`\`

---

## Validation Checklist

After generating ADRs, verify:

- [ ] File is in \`docs/adr/\` with correct numbering and kebab-case filename
- [ ] Status is set to \`Proposed\` (not \`Accepted\` — that requires team review)
- [ ] All sections are filled with project-specific content (no \`[REPLACE]\` placeholders remain)
- [ ] Compliance checklist is complete with PCI DSS and SOC 2 items addressed
- [ ] Affected Gradle modules, Kafka topics, and Helm charts are explicitly named
- [ ] No generic advice — every recommendation references our stack
- [ ] Related Jira ticket is linked
- [ ] ADR is cross-referenced in \`playbook/phases/02-architecture.md\` deliverables`,

  'playbook/prompts/02/api-design.md': `# API Design Prompt — Phase 02: Architecture

> Copy-paste this prompt into Claude Code when designing REST APIs and Kafka event contracts for a microservice.

---

## Prompt

\`\`\`
You are designing the API surface for a microservice in our Spring Boot 3.2 / Java 21 event-driven platform. This includes both the REST API (synchronous, external-facing or gateway-routed) and the Kafka event contracts (asynchronous, inter-service communication).

## Context

- **Service name**: [SERVICE_NAME, e.g., payment-service]
- **Bounded context**: [DOMAIN, e.g., Payments & Billing]
- **Upstream dependencies**: [SERVICES_THIS_CONSUMES_EVENTS_FROM, e.g., order-service, user-service]
- **Downstream consumers**: [SERVICES_THAT_CONSUME_OUR_EVENTS, e.g., notification-service, ledger-service]
- **Jira epic**: [EPIC_KEY, e.g., PAY-100]

## Constraints

1. **No direct REST calls between services** — all inter-service communication goes through Kafka topics. REST endpoints are only for external clients via the API gateway.
2. **Hexagonal Architecture** — API controllers are adapters; they delegate to application service ports. Never put business logic in controllers.
3. **Compliance** — SOC 2 and PCI DSS apply. PII and cardholder data must never appear in Kafka events or API responses unless explicitly required and masked/tokenized. Audit fields (createdBy, createdAt, modifiedBy, modifiedAt) are mandatory on all mutable resources.
4. **Spring Boot conventions** — Use Spring Web for REST, Spring Kafka for event production/consumption, Spring Security for endpoint protection, Spring Validation (jakarta.validation) for request validation.
5. **Naming conventions** — kebab-case for URLs, PascalCase for DTOs, camelCase for JSON fields, SCREAMING_SNAKE_CASE for enum values, dot-separated Kafka topic names (e.g., \`payments.payment-completed.v1\`).
6. **Versioning** — REST APIs versioned via URL path prefix (\`/api/v1/...\`). Kafka events versioned via topic name suffix (\`.v1\`, \`.v2\`) and schema evolution in the schema registry.
7. **Max file length** — 300 lines per file. Split large specs into per-resource files if needed.

## Deliverables

### 1. OpenAPI Specification (REST API)

Generate an OpenAPI 3.1 YAML spec to be placed at:
\`services/[SERVICE_NAME]/src/main/resources/openapi/[SERVICE_NAME]-api.yaml\`

Include:
- **Info block** with service name, version, description, contact (team), and license
- **Server entries** for local (\`http://localhost:808X\`), staging, production (via gateway)
- **Security schemes**: Bearer JWT (\`Authorization: Bearer <token>\`) with scopes mapped to Spring Security roles
- **Paths** for all CRUD and action endpoints:
  - Use proper HTTP methods (GET, POST, PUT, PATCH, DELETE)
  - Use plural nouns for resource collections (\`/api/v1/payments\`, not \`/api/v1/payment\`)
  - Use path params for resource identity (\`/api/v1/payments/{paymentId}\`)
  - Use query params for filtering, pagination, sorting on list endpoints
  - Include \`X-Request-Id\` and \`X-Correlation-Id\` headers on all operations
- **Request bodies** with jakarta.validation annotations documented (constraints in description)
- **Response schemas** with:
  - Consistent envelope: \`{ "data": ..., "meta": { "requestId": "...", "timestamp": "..." } }\`
  - Error envelope: \`{ "error": { "code": "...", "message": "...", "details": [...] } }\`
  - Proper HTTP status codes (200, 201, 204, 400, 401, 403, 404, 409, 422, 429, 500)
- **Pagination schema** for list endpoints: \`{ "data": [...], "pagination": { "page": 0, "size": 20, "totalElements": 150, "totalPages": 8 } }\`
- **Health and info endpoints** via Spring Actuator (document \`/actuator/health\`, \`/actuator/info\`)

### 2. Kafka Event Contracts

For each domain event this service **produces**, generate an Avro schema or JSON Schema to be placed at:
\`schema-registry/[SERVICE_NAME]/[event-name].v1.avsc\` (Avro) or \`.json\` (JSON Schema)

For each event, define:
- **Topic name**: \`[bounded-context].[event-name].v1\` (e.g., \`payments.payment-completed.v1\`)
- **Key**: The aggregate ID (e.g., \`paymentId\`) — always a string UUID
- **Schema** with fields:
  - \`eventId\` (UUID) — unique event identifier
  - \`eventType\` (string) — fully qualified event name
  - \`eventVersion\` (int) — schema version number
  - \`timestamp\` (ISO-8601 string) — when the event occurred
  - \`correlationId\` (UUID) — for distributed tracing
  - \`source\` (string) — producing service name
  - \`aggregateId\` (UUID) — the domain entity ID
  - \`aggregateType\` (string) — the domain entity type
  - \`payload\` (object) — event-specific data
- **Never include** raw PII, passwords, full card numbers, or CVVs in event payloads. Use tokenized references.
- **Backward compatibility** — new fields must have defaults; fields must not be removed or renamed

Also generate a consumer contract summary listing:
- Events this service **consumes**, their topics, consumer group (\`[SERVICE_NAME]-group\`), and expected processing behavior (idempotent, at-least-once)

### 3. Spring Controller Skeleton

Generate a Java controller stub at:
\`services/[SERVICE_NAME]/src/main/java/com/company/[servicepkg]/adapter/in/web/[Resource]Controller.java\`

Include:
- \`@RestController\` and \`@RequestMapping("/api/v1/[resources]")\`
- \`@Tag(name = "...")\` for OpenAPI grouping
- Method signatures with \`@GetMapping\`, \`@PostMapping\`, etc.
- \`@Valid\` on request bodies
- \`@PreAuthorize("hasRole('...')")\` or \`@Secured\` annotations
- Inject the **port interface** (application service), not the implementation
- Return \`ResponseEntity<ApiResponse<T>>\` with proper status codes
- Include \`@RequestHeader("X-Correlation-Id") String correlationId\` on all methods
- Add Javadoc referencing the OpenAPI operation ID
- Do NOT implement business logic — just delegate to the port

### 4. Spring Kafka Producer/Consumer Skeleton

Generate:
- **Producer**: \`services/[SERVICE_NAME]/src/main/java/com/company/[servicepkg]/adapter/out/messaging/[Event]Producer.java\`
  - Uses \`KafkaTemplate<String, [EventType]>\`
  - Sends to the correct topic with the aggregate ID as key
  - Logs correlation ID for tracing
  - Implements an **output port interface** from the domain

- **Consumer**: \`services/[SERVICE_NAME]/src/main/java/com/company/[servicepkg]/adapter/in/messaging/[Event]Consumer.java\`
  - \`@KafkaListener(topics = "...", groupId = "[SERVICE_NAME]-group")\`
  - Idempotency check (deduplicate by eventId)
  - Error handling with \`@RetryableTopic\` or dead-letter topic configuration
  - Delegates to an **input port interface**

### 5. DTO and Event Classes

Generate Java records for:
- **Request DTOs** with jakarta.validation annotations (\`@NotNull\`, \`@Size\`, \`@Pattern\`, \`@Email\`, etc.)
- **Response DTOs** as immutable records
- **Domain event classes** matching the Avro/JSON schemas
- Place in \`adapter/in/web/dto/\` (REST DTOs) and \`adapter/out/messaging/event/\` (Kafka events)

### 6. Port Interfaces

Generate the hexagonal port interfaces:
- **Input ports** (use cases): \`services/[SERVICE_NAME]/src/main/java/com/company/[servicepkg]/application/port/in/[UseCase]Port.java\`
- **Output ports** (driven): \`services/[SERVICE_NAME]/src/main/java/com/company/[servicepkg]/application/port/out/[Repository|EventPublisher]Port.java\`

## Output Format

For each file, output:
1. The full file path relative to the project root
2. The complete file content
3. A brief rationale (1-2 sentences) explaining design decisions

## Quality Checklist

Before finalizing, verify:
- [ ] No business logic in controllers or Kafka consumers — only delegation to ports
- [ ] All endpoints require authentication (except health checks)
- [ ] No PII or cardholder data in Kafka event payloads
- [ ] All request DTOs have validation annotations
- [ ] All events have eventId, correlationId, timestamp, source fields
- [ ] Kafka consumers are idempotent (deduplicate by eventId)
- [ ] Error responses use the standard error envelope
- [ ] Pagination follows the standard schema
- [ ] File length stays under 300 lines
- [ ] Naming conventions are consistent (kebab-case URLs, camelCase JSON, PascalCase classes)
- [ ] Topic names follow the pattern: [context].[event-name].v[N]
- [ ] Consumer groups follow the pattern: [service-name]-group
- [ ] Backward-compatible schema evolution (no field removal/rename)
- [ ] ADR reference included if this introduces a new API pattern
\`\`\`

---

## Usage

1. Replace all \`[PLACEHOLDERS]\` with actual values for your service
2. Paste the entire prompt into Claude Code
3. Review generated OpenAPI specs, schemas, and skeletons
4. Commit OpenAPI spec and schemas first — these are the contract
5. Run \`./gradlew :services:[SERVICE_NAME]:compileJava\` to verify skeletons compile
6. Register schemas in the schema registry: \`schema-registry/\` directory
7. Update the service's \`README.md\` with API documentation links

## Follow-Up Prompts

After generating the API design, continue with:

- **Contract tests**: \`Generate Pact contract tests for [SERVICE_NAME] based on the OpenAPI spec and Kafka event schemas\`
- **Gateway routing**: \`Add Spring Cloud Gateway route configuration for [SERVICE_NAME] endpoints to gateway/src/main/resources/application.yaml\`
- **Security config**: \`Generate Spring Security configuration for [SERVICE_NAME] that enforces the roles defined in the OpenAPI spec\`
- **Integration test setup**: \`Generate Testcontainers-based integration test configuration for [SERVICE_NAME] with PostgreSQL and Kafka\`

## Related Files

- Phase definition: \`playbook/phases/02-architecture.md\`
- ADR generator: \`playbook/prompts/02/adr-generator.md\`
- Architect agent: \`plugin/codeforge-spring-boot-microservices/agents/architect.md\`
- Schema registry: \`schema-registry/README.md\``,

  'playbook/prompts/02/data-model-design.md': `# Data Model Design — Phase 02 Architecture Prompt

## Purpose

Copy-paste this prompt into Claude Code to design the data model for a bounded-context microservice, including JPA entities, Kafka event schemas, database migrations, and Redis cache structures.

---

## Prompt

\`\`\`
You are designing the data model for a microservice in our Spring Boot 3.2 / Java 21 event-driven platform. Follow hexagonal architecture (Ports & Adapters) and ensure each service owns its data exclusively — no shared databases.

## Context

- **Service name**: [SERVICE_NAME, e.g., payment-service]
- **Bounded context**: [BOUNDED_CONTEXT, e.g., Payment Processing]
- **Key domain entities**: [LIST_ENTITIES, e.g., Payment, PaymentMethod, Transaction, Refund]
- **Upstream services (consumes events from)**: [LIST, e.g., order-service → OrderCreatedEvent]
- **Downstream services (produces events for)**: [LIST, e.g., notification-service, ledger-service]
- **Compliance requirements**: SOC 2, PCI DSS (mask/encrypt PII and cardholder data)

## Deliverables

### 1. JPA Entity Design

For each domain entity, generate a Java 21 class under \`services/[SERVICE_NAME]/src/main/java/com/company/[service]/domain/model/\` following these rules:

- Use \`@Entity\` with explicit \`@Table(name = "...")\` using snake_case table names
- Use \`UUID\` for primary keys with \`@GeneratedValue(strategy = GenerationType.UUID)\`
- Add \`@Version\` field for optimistic locking
- Include audit fields: \`createdAt\`, \`updatedAt\`, \`createdBy\` using \`@EntityListeners(AuditingEntityListener.class)\` with \`@CreatedDate\`, \`@LastModifiedDate\`, \`@CreatedBy\`
- Annotate PCI-sensitive fields (card numbers, CVVs) with a custom \`@Encrypted\` annotation and ensure they are never logged
- Use \`@Enumerated(EnumType.STRING)\` for status fields
- Keep entities under 300 lines — extract value objects where appropriate
- Use Java records for value objects (e.g., \`Money\`, \`Address\`, \`CardFingerprint\`)
- Add Javadoc describing the entity's role in the bounded context
- Define relationships with explicit \`@JoinColumn\` and \`FetchType.LAZY\` by default
- Add database indexes via \`@Table(indexes = {...})\` for fields used in queries

Example structure:
\`\`\`java
@Entity
@Table(name = "payments", indexes = {
    @Index(name = "idx_payments_order_id", columnList = "order_id"),
    @Index(name = "idx_payments_status", columnList = "status"),
    @Index(name = "idx_payments_created_at", columnList = "created_at")
})
@EntityListeners(AuditingEntityListener.class)
public class Payment {
    @Id
    @GeneratedValue(strategy = GenerationType.UUID)
    private UUID id;

    @Version
    private Long version;

    @Column(name = "order_id", nullable = false)
    private UUID orderId;

    @Enumerated(EnumType.STRING)
    @Column(name = "status", nullable = false)
    private PaymentStatus status;

    @Embedded
    private Money amount;

    @CreatedDate
    @Column(name = "created_at", nullable = false, updatable = false)
    private Instant createdAt;

    @LastModifiedDate
    @Column(name = "updated_at")
    private Instant updatedAt;

    @CreatedBy
    @Column(name = "created_by")
    private String createdBy;
}
\`\`\`

### 2. Domain Event Schemas

For each event this service produces, generate:

**a) JSON Schema** in \`schema-registry/[SERVICE_NAME]/\` following naming convention \`[BoundedContext][Entity][Action]Event.json\`:

- Include \`eventId\` (UUID), \`eventType\` (string), \`eventVersion\` (string, semver), \`timestamp\` (ISO-8601), \`correlationId\` (UUID), \`causationId\` (UUID), \`source\` (string)
- Include the domain payload under a \`data\` field
- Never include raw PCI data (card numbers, CVVs) in events — use tokenized references only
- Add \`$schema\` and \`description\` fields
- Version schemas explicitly (v1, v2) to support evolution

**b) Java record** in \`shared/domain-events/src/main/java/com/company/events/[context]/\`:

\`\`\`java
public record PaymentCompletedEvent(
    UUID eventId,
    String eventType,
    String eventVersion,
    Instant timestamp,
    UUID correlationId,
    UUID causationId,
    String source,
    PaymentCompletedPayload data
) implements DomainEvent {

    public static final String EVENT_TYPE = "payment.completed";
    public static final String TOPIC = "payment-events";

    public record PaymentCompletedPayload(
        UUID paymentId,
        UUID orderId,
        String currency,
        BigDecimal amount,
        PaymentStatus status,
        Instant completedAt
    ) {}
}
\`\`\`

### 3. Kafka Topic Configuration

Generate a topic configuration class at \`services/[SERVICE_NAME]/src/main/java/com/company/[service]/infrastructure/kafka/TopicConfig.java\`:

- Define topics this service owns (produces to)
- Use naming convention: \`[bounded-context]-events\` (e.g., \`payment-events\`)
- Set partitions based on expected throughput (default: 6)
- Set replication factor: 3 (production)
- Set retention: 7 days for standard events, 30 days for financial/audit events
- Configure consumer group: \`[service-name]-group\`
- Add dead-letter topic: \`[topic-name].dlq\`

### 4. Flyway Database Migrations

Generate migration SQL files under \`services/[SERVICE_NAME]/src/main/resources/db/migration/\`:

- \`V1__create_[entity]_tables.sql\` — DDL for all tables
- \`V2__add_indexes.sql\` — additional indexes beyond entity annotations
- \`V3__add_audit_triggers.sql\` — audit trail triggers for PCI DSS compliance
- Use PostgreSQL-specific syntax where beneficial (e.g., \`JSONB\`, \`UUID\` native type, \`TIMESTAMPTZ\`)
- Add comments on columns containing sensitive data
- Create a separate \`_audit\` table for each entity that stores PCI-relevant data, capturing old/new values on UPDATE and DELETE

Example:
\`\`\`sql
-- V1__create_payment_tables.sql
CREATE TABLE payments (
    id UUID PRIMARY KEY DEFAULT gen_random_uuid(),
    order_id UUID NOT NULL,
    status VARCHAR(50) NOT NULL DEFAULT 'PENDING',
    amount_value NUMERIC(19, 4) NOT NULL,
    amount_currency VARCHAR(3) NOT NULL,
    payment_token VARCHAR(255),  -- tokenized card reference, never raw PAN
    version BIGINT NOT NULL DEFAULT 0,
    created_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
    updated_at TIMESTAMPTZ,
    created_by VARCHAR(255),
    CONSTRAINT chk_payments_status CHECK (status IN ('PENDING', 'PROCESSING', 'COMPLETED', 'FAILED', 'REFUNDED'))
);

COMMENT ON COLUMN payments.payment_token IS 'PCI DSS: Tokenized payment reference. Raw cardholder data never stored.';
\`\`\`

### 5. Redis Cache Structure

Define the Redis caching strategy at \`services/[SERVICE_NAME]/src/main/java/com/company/[service]/infrastructure/cache/CacheConfig.java\`:

- Use Spring Cache abstraction with \`@Cacheable\`, \`@CacheEvict\`, \`@CachePut\`
- Define cache names, TTLs, and key patterns:
  - Entity lookups: \`[service]:[entity]:{id}\` — TTL 15 minutes
  - Query results: \`[service]:query:[hash]\` — TTL 5 minutes
  - Session/idempotency: \`[service]:idempotency:{key}\` — TTL 24 hours
- Use \`RedisTemplate<String, byte[]>\` with JSON serialization
- Never cache PCI-sensitive data in Redis — only tokenized references
- Configure cache metrics for Prometheus via Actuator

### 6. Repository Layer

Generate Spring Data JPA repositories under \`services/[SERVICE_NAME]/src/main/java/com/company/[service]/domain/port/out/\`:

- Interface extends \`JpaRepository<Entity, UUID>\`
- Add custom query methods using \`@Query\` with JPQL for complex lookups
- Add pagination support for list queries
- Add \`@QueryHints\` for read-only queries where appropriate
- Place in the \`port/out\` package per hexagonal architecture

### 7. Data Model Diagram

Produce a Mermaid ER diagram showing:
- All entities and their relationships
- Cardinality (1:1, 1:N, M:N)
- Key fields and types
- Which fields are encrypted/tokenized
- Foreign key references (within this bounded context only — no cross-service FKs)

## Constraints

- **No cross-service foreign keys** — services reference other aggregates by UUID only
- **No shared database schemas** — each service has its own PostgreSQL database
- **PCI DSS**: Never store raw PAN, CVV, or magnetic stripe data. Use tokenization.
- **SOC 2**: All data mutations must be auditable. Include audit tables and triggers.
- **Event versioning**: All events must include a version field. Plan for backward-compatible evolution.
- **File length**: Keep each generated file under 300 lines. Split if necessary.
- **Naming**: PascalCase for classes, camelCase for fields, snake_case for DB columns, kebab-case for Kafka topics

## Validation Checklist

After generating, verify:
- [ ] Every entity has UUID PK, version field, and audit timestamps
- [ ] No raw PCI data stored in DB, events, or cache
- [ ] Flyway migrations are idempotent and ordered correctly
- [ ] Kafka events include correlationId and causationId for distributed tracing
- [ ] Redis cache keys follow the naming convention and have appropriate TTLs
- [ ] Audit tables exist for PCI-relevant entities
- [ ] Mermaid diagram accurately reflects the schema
- [ ] All files are under 300 lines
- [ ] Hexagonal architecture package structure is followed (domain/model, domain/port/out, infrastructure/kafka, infrastructure/cache)

## Output Format

Generate each file with its full path as a header, ready to be created. Group by category (Entities, Events, Migrations, Config, Repositories). Include the Mermaid diagram in \`docs/data-models/[SERVICE_NAME].md\`.
\`\`\`

---

## Usage

1. Copy the prompt above into Claude Code
2. Replace all \`[PLACEHOLDERS]\` with your service-specific values
3. Review generated schemas against \`schema-registry/\` for consistency with existing events
4. Run \`./gradlew :services:[SERVICE_NAME]:flywayMigrate\` to validate migrations
5. Run \`./gradlew :services:[SERVICE_NAME]:test\` to verify entity mappings with Testcontainers
6. Commit schemas to \`schema-registry/\` and open a PR for cross-team review

## Related Prompts

- \`playbook/prompts/02/adr-generator.md\` — Document architectural decisions made during data modeling
- \`playbook/prompts/01/gather-requirements.md\` — Ensure all domain entities from requirements are covered
- \`playbook/prompts/01/nfr-checklist.md\` — Verify data model meets NFRs (performance, compliance, scalability)

## Phase Gate

Before moving to Phase 03 (Foundation), ensure:
- All service data models are designed and reviewed
- Event schemas are registered in \`schema-registry/\`
- ADRs exist for key data modeling decisions (e.g., event sourcing vs. state-based, tokenization strategy)
- Flyway migrations pass against a local PostgreSQL via Testcontainers`,

  'playbook/prompts/03/ci-pipeline.md': `# CI Pipeline Setup — Phase 03: Foundation

## Prompt for Claude Code

\`\`\`
You are setting up the CI/CD pipeline for our Spring Boot microservices platform using GitHub Actions. This is a Gradle multi-module monorepo targeting AWS EKS with Kafka event streaming, PostgreSQL per-service databases, and Redis caching. We must satisfy SOC 2 and PCI DSS audit requirements.

## Repository Structure

\`\`\`
services/
  order-service/
  payment-service/
  user-service/
  notification-service/
shared/
  domain-events/
  common-utils/
  test-fixtures/
gateway/
schema-registry/
infrastructure/
charts/
\`\`\`

## Pipeline Requirements

### 1. Main CI Workflow (\`.github/workflows/ci.yml\`)

Create a GitHub Actions workflow triggered on:
- Push to \`main\`, \`release/*\`
- Pull requests targeting \`main\`

The workflow must have these stages in order:

**Stage 1: Lint & Format Check**
- Run Checkstyle on all Java sources: \`./gradlew checkstyleMain checkstyleTest\`
- Run ktlint on Kotlin sources: \`./gradlew ktlintCheck\`
- Fail fast — do not proceed if linting fails

**Stage 2: Compile**
- \`./gradlew compileJava compileKotlin\`
- Cache Gradle dependencies using \`actions/cache\` with key based on \`gradle/libs.versions.toml\` and \`**/build.gradle.kts\`

**Stage 3: Unit Tests**
- \`./gradlew test\` (excludes integration tests)
- Use JUnit 5 tags: \`-PexcludeTags=integration,contract,e2e\`
- Generate JaCoCo coverage report: \`./gradlew jacocoTestReport\`
- Enforce 80% minimum coverage: \`./gradlew jacocoTestCoverageVerification\`
- Upload test results as artifacts
- Upload coverage report to workflow summary

**Stage 4: Integration Tests**
- \`./gradlew integrationTest\` (JUnit 5 tag: \`integration\`)
- Requires Docker for Testcontainers (PostgreSQL, Kafka, Redis)
- Use \`services\` or configure Docker-in-Docker for Testcontainers
- Set \`TESTCONTAINERS_RYUK_DISABLED=false\`
- Timeout: 20 minutes max

**Stage 5: Contract Tests**
- \`./gradlew contractTest\` (JUnit 5 tag: \`contract\`)
- Run Pact provider verification for each service
- Publish Pact results to Pact Broker (if available) or store as artifacts
- Verify consumer-driven contracts between services

**Stage 6: Security Scan**
- OWASP Dependency Check: \`./gradlew dependencyCheckAnalyze\`
- Fail on CVSS score >= 7 (HIGH or CRITICAL)
- SpotBugs with security plugin: \`./gradlew spotbugsMain\`
- Trivy scan on built Docker images
- Upload SARIF results to GitHub Security tab
- This stage is required for PCI DSS compliance — add a comment noting this

**Stage 7: Build Docker Images**
- Only on push to \`main\` or \`release/*\` (not on PRs)
- Build multi-stage Docker images for each service
- Tag with: \`\${GITHUB_SHA::8}\`, \`latest\` (main only), semver (release branches)
- Push to AWS ECR: \`\${{ secrets.AWS_ACCOUNT_ID }}.dkr.ecr.\${{ secrets.AWS_REGION }}.amazonaws.com\`
- Scan images with ECR native scanning

**Stage 8: Deploy to Staging**
- Only on push to \`main\`
- Use Helm to deploy each service to EKS staging namespace
- \`helm upgrade --install <service> charts/<service> -n staging -f charts/<service>/values-staging.yaml --set image.tag=\${GITHUB_SHA::8}\`
- Wait for rollout: \`kubectl rollout status deployment/<service> -n staging --timeout=300s\`
- Run smoke tests against staging endpoints

**Stage 9: E2E Tests**
- Only after successful staging deploy
- Run from \`tests/e2e/\`: \`./gradlew :tests:e2e:test\`
- Test critical flows: user registration → order creation → payment processing → notification delivery
- Timeout: 30 minutes

**Stage 10: Deploy to Production**
- Manual approval required (use GitHub Environments with required reviewers)
- Only from \`release/*\` branches
- Blue-green deployment via Helm
- Post-deploy health checks against Actuator endpoints: \`/actuator/health\`, \`/actuator/info\`
- Notify Slack channel on success/failure

### 2. Changed-Service Detection

Since this is a monorepo, implement path-based filtering to only build/test/deploy services that changed:

\`\`\`yaml
# Detect which services changed
- uses: dorny/paths-filter@v2
  id: changes
  with:
    filters: |
      order-service:
        - 'services/order-service/**'
        - 'shared/**'
      payment-service:
        - 'services/payment-service/**'
        - 'shared/**'
      user-service:
        - 'services/user-service/**'
        - 'shared/**'
      notification-service:
        - 'services/notification-service/**'
        - 'shared/**'
      gateway:
        - 'gateway/**'
        - 'shared/**'
      shared:
        - 'shared/**'
      infrastructure:
        - 'infrastructure/**'
        - 'charts/**'
\`\`\`

If \`shared/**\` changes, ALL services must be rebuilt and tested.

### 3. PR Validation Workflow (\`.github/workflows/pr-checks.yml\`)

Separate lightweight workflow for PRs:
- Verify conventional commit format in PR title
- Check branch naming matches \`type/TICKET-desc\` pattern
- Verify signed commits
- Run \`./gradlew build\` for changed modules only
- Check for AI-generated code markers (look for \`// AI-generated\` or \`@AIGenerated\` annotations)
- Post coverage diff as PR comment
- Label PR based on changed paths (e.g., \`service:order\`, \`service:payment\`, \`infra\`, \`shared-lib\`)

### 4. Schema Registry Validation (\`.github/workflows/schema-check.yml\`)

Triggered when \`schema-registry/**\` changes:
- Validate Avro/JSON schemas compile
- Check backward compatibility with previous schema versions
- Verify all services referencing changed schemas are included in the PR
- Fail if breaking schema change detected without version bump

### 5. Infrastructure Validation (\`.github/workflows/infra-check.yml\`)

Triggered when \`infrastructure/**\` or \`charts/**\` changes:
- \`terraform fmt -check\`
- \`terraform validate\`
- \`terraform plan\` (output as PR comment)
- \`helm lint charts/*\`
- \`helm template\` dry-run for each chart
- Require approval from \`@platform-team\` (via CODEOWNERS)

### 6. Required Secrets and Variables

Document these as comments in the workflow:
\`\`\`
# Required Secrets:
#   AWS_ACCESS_KEY_ID          - AWS credentials for ECR/EKS
#   AWS_SECRET_ACCESS_KEY      - AWS credentials for ECR/EKS
#   AWS_ACCOUNT_ID             - AWS account for ECR registry
#   AWS_REGION                 - AWS region (e.g., eu-west-1)
#   KUBECONFIG_STAGING         - Base64-encoded kubeconfig for staging EKS
#   KUBECONFIG_PRODUCTION      - Base64-encoded kubeconfig for production EKS
#   SLACK_WEBHOOK_URL          - Slack notification webhook
#   PACT_BROKER_URL            - Pact Broker endpoint
#   PACT_BROKER_TOKEN          - Pact Broker auth token
#   SONAR_TOKEN                - SonarQube token (if used)
#   SIGNING_KEY                - GPG key for signed artifacts
#
# Required Variables:
#   JAVA_VERSION: '21'
#   GRADLE_VERSION: '8.5'
#   DOCKER_BUILDKIT: '1'
\`\`\`

### 7. Caching Strategy

- Gradle dependencies: cache \`~/.gradle/caches\` and \`~/.gradle/wrapper\`
- Docker layers: use \`docker/build-push-action\` with GitHub Actions cache backend
- Testcontainers images: pre-pull in a setup step and cache Docker images
- Helm chart dependencies: cache \`~/.cache/helm\`

### 8. Compliance & Audit Requirements

For SOC 2 and PCI DSS:
- Every pipeline run must produce an audit trail (use GitHub Actions run logs + artifacts)
- Security scan results must be archived as artifacts for 1 year
- Production deploys must have manual approval with reviewer identity logged
- All Docker images must be signed (cosign)
- SBOM generation for each built image (syft)
- Dependency license check: fail on GPL/AGPL in production dependencies

### 9. Notifications

- Slack notifications on: pipeline failure, production deploy success/failure, security vulnerability found
- GitHub commit status checks for all required stages
- PR comments with: test results summary, coverage report, security findings

### 10. Reusable Workflow Components

Create reusable workflows in \`.github/workflows/\` for:
- \`_build-service.yml\` — reusable job for building a single service module
- \`_deploy-service.yml\` — reusable job for deploying a single service via Helm
- \`_security-scan.yml\` — reusable job for security scanning

## Output

Generate the following files:
1. \`.github/workflows/ci.yml\` — Main CI/CD pipeline
2. \`.github/workflows/pr-checks.yml\` — PR validation
3. \`.github/workflows/schema-check.yml\` — Schema registry validation
4. \`.github/workflows/infra-check.yml\` — Infrastructure validation
5. \`.github/workflows/_build-service.yml\` — Reusable build job
6. \`.github/workflows/_deploy-service.yml\` — Reusable deploy job
7. \`.github/workflows/_security-scan.yml\` — Reusable security scan job

For each workflow:
- Use \`java-version: '21'\` and \`distribution: 'temurin'\`
- Use \`gradle/actions/setup-gradle@v3\` for Gradle setup
- Set \`GRADLE_OPTS: '-Dorg.gradle.daemon=false -Dorg.gradle.parallel=true'\`
- Add concurrency groups to prevent duplicate runs
- Add timeout-minutes on every job
- Use GitHub Environments for staging and production

Start with the main \`ci.yml\` and work through each file. After generating, verify the workflows reference correct Gradle tasks, correct paths, and correct secret names.
\`\`\`

## Usage Notes

1. **Copy the entire prompt** above into Claude Code
2. Claude will generate all 7 workflow files
3. Review the generated workflows against your actual Gradle task names
4. Verify secret names match your GitHub repository settings
5. Test with a dry-run PR before merging to \`main\`

## Verification Checklist

After Claude generates the pipeline files, verify:

- [ ] \`ci.yml\` has all 10 stages in correct dependency order
- [ ] Path-based filtering correctly triggers only changed services
- [ ] \`shared/**\` changes trigger full rebuild
- [ ] Testcontainers configuration is correct for GitHub Actions runners
- [ ] ECR push only happens on \`main\` and \`release/*\` branches
- [ ] Production deploy requires manual approval
- [ ] Security scans produce SARIF output for GitHub Security tab
- [ ] OWASP dependency check fails on CVSS >= 7
- [ ] JaCoCo coverage threshold is set to 80%
- [ ] Helm deploy commands reference correct chart paths and value files
- [ ] Slack notifications are wired to correct events
- [ ] Concurrency groups prevent duplicate pipeline runs
- [ ] All jobs have \`timeout-minutes\` set
- [ ] Reusable workflows use \`workflow_call\` trigger
- [ ] Schema compatibility check is in place
- [ ] SBOM and image signing steps exist for compliance
- [ ] Audit artifacts are retained for compliance period

## Related Prompts

- \`playbook/prompts/03/project-scaffold.md\` — Generates the Gradle multi-module structure these workflows build
- \`playbook/prompts/05/integration-test-setup.md\` — Testcontainers configuration referenced in Stage 4
- \`playbook/prompts/02/adr-generator.md\` — Document CI/CD decisions as ADRs

## Phase Gate

This prompt satisfies Phase 03 (Foundation) CI/CD requirements:
- Automated build pipeline for all services
- Test automation at unit, integration, and contract levels
- Security scanning integrated into pipeline
- Docker image build and push to registry
- Staging auto-deploy with smoke tests
- Production deploy with manual gate
- Compliance audit trail generation`,

  'playbook/prompts/03/iac-setup.md': `# IaC Setup — Phase 03: Foundation

## Copy-Pasteable Prompt for Claude Code

\`\`\`
I need you to set up the Infrastructure as Code (IaC) foundation for our Spring Boot microservices platform. This is a financial services platform requiring SOC 2 and PCI DSS compliance, deployed on AWS with Kubernetes.

## Project Context

- **Monorepo layout**: Gradle multi-module under \`services/\`, \`shared/\`, \`gateway/\`, \`schema-registry/\`
- **Cloud**: AWS (EKS, RDS PostgreSQL, ElastiCache Redis, MSK Kafka, ECR, ALB, Route53)
- **Orchestration**: Kubernetes via EKS, Helm charts per service
- **IaC tool**: Terraform with remote state in S3 + DynamoDB locking
- **Environments**: dev, staging, production
- **Compliance**: SOC 2, PCI DSS — network segmentation, encryption at rest/in transit, audit logging

## Directory Structure to Create

\`\`\`
infrastructure/
├── terraform/
│   ├── environments/
│   │   ├── dev/
│   │   │   ├── main.tf
│   │   │   ├── variables.tf
│   │   │   ├── outputs.tf
│   │   │   ├── terraform.tfvars
│   │   │   └── backend.tf
│   │   ├── staging/
│   │   │   └── (same structure)
│   │   └── production/
│   │       └── (same structure)
│   ├── modules/
│   │   ├── eks/                  # EKS cluster, node groups, IRSA
│   │   ├── rds/                  # PostgreSQL per-service databases
│   │   ├── elasticache/          # Redis cluster
│   │   ├── msk/                  # Managed Kafka cluster
│   │   ├── ecr/                  # Container registries per service
│   │   ├── networking/           # VPC, subnets, security groups, NACLs
│   │   ├── alb/                  # Application Load Balancer + WAF
│   │   ├── route53/              # DNS zones and records
│   │   ├── monitoring/           # CloudWatch, Prometheus workspace
│   │   ├── secrets/              # AWS Secrets Manager, KMS keys
│   │   └── iam/                  # IAM roles, policies, service accounts
│   └── shared/
│       ├── providers.tf
│       ├── versions.tf
│       └── tags.tf
├── kubernetes/
│   ├── namespaces/
│   │   ├── services.yaml
│   │   ├── monitoring.yaml
│   │   ├── ingress.yaml
│   │   └── kafka.yaml
│   ├── rbac/
│   │   ├── service-accounts.yaml
│   │   └── roles.yaml
│   ├── network-policies/
│   │   ├── default-deny.yaml
│   │   ├── allow-ingress.yaml
│   │   ├── allow-kafka.yaml
│   │   ├── allow-database.yaml
│   │   └── allow-redis.yaml
│   ├── config/
│   │   ├── prometheus-config.yaml
│   │   ├── grafana-dashboards.yaml
│   │   └── jaeger-config.yaml
│   └── secrets/
│       └── external-secrets.yaml  # ExternalSecrets operator config
└── scripts/
    ├── init-terraform.sh
    ├── plan.sh
    ├── apply.sh
    └── destroy.sh
\`\`\`

## Terraform Module Requirements

### 1. Networking Module (\`modules/networking/\`)
- VPC with 3 AZs, public/private/data subnets
- NAT Gateways (one per AZ for HA)
- VPC Flow Logs enabled (SOC 2 requirement)
- Security groups:
  - \`sg-eks-nodes\`: EKS worker nodes
  - \`sg-rds\`: PostgreSQL (port 5432, ingress from EKS nodes only)
  - \`sg-redis\`: Redis (port 6379, ingress from EKS nodes only)
  - \`sg-msk\`: Kafka (ports 9092/9094, ingress from EKS nodes only)
  - \`sg-alb\`: ALB (ports 80/443 from internet, egress to EKS)
- NACLs for data subnet isolation (PCI DSS network segmentation)
- VPC endpoints for ECR, S3, CloudWatch, Secrets Manager (no public internet for control plane traffic)
- Tag all resources with: \`Project=spring-boot-microservices\`, \`Environment=var.environment\`, \`ManagedBy=terraform\`, \`Compliance=pci-dss,soc2\`

### 2. EKS Module (\`modules/eks/\`)
- EKS cluster version 1.29+
- Managed node groups:
  - \`general\`: t3.xlarge, 3-10 nodes, for application workloads
  - \`monitoring\`: t3.large, 2-4 nodes, tainted for monitoring stack
- Enable IRSA (IAM Roles for Service Accounts)
- Enable EKS audit logging to CloudWatch (SOC 2)
- Enable secrets encryption with KMS
- Cluster endpoint: private access enabled, public access restricted to CI/CD IPs
- Install EKS add-ons: CoreDNS, kube-proxy, VPC CNI, EBS CSI driver
- Output: cluster_name, cluster_endpoint, cluster_ca_certificate, oidc_provider_arn

### 3. RDS Module (\`modules/rds/\`)
- Parameterized for per-service databases:
  - \`order-service-db\`
  - \`payment-service-db\`
  - \`user-service-db\`
- PostgreSQL 16, db.r6g.large (production), db.t3.medium (dev/staging)
- Multi-AZ in production, single-AZ in dev/staging
- Encryption at rest with KMS (PCI DSS)
- Automated backups: 30-day retention (production), 7-day (dev/staging)
- Performance Insights enabled
- Enhanced monitoring enabled
- Deployed in data subnets only
- IAM database authentication enabled
- Parameter group: \`log_statement=all\`, \`log_connections=on\`, \`log_disconnections=on\` (SOC 2 audit)

### 4. ElastiCache Module (\`modules/elasticache/\`)
- Redis 7.x, cluster mode enabled
- 3 shards, 1 replica per shard (production)
- 1 shard, 0 replicas (dev/staging)
- Encryption at rest and in transit (PCI DSS)
- AUTH token from Secrets Manager
- Deployed in data subnets
- Automatic failover enabled (production)

### 5. MSK Module (\`modules/msk/\`)
- Apache Kafka 3.6.x
- 3 brokers across 3 AZs (production), 2 brokers (dev/staging)
- Instance type: kafka.m5.2xlarge (production), kafka.t3.small (dev/staging)
- TLS encryption in transit, KMS encryption at rest (PCI DSS)
- SASL/SCRAM authentication
- Topics to pre-create via configuration:
  - \`order.events\` (partitions: 12, replication: 3)
  - \`payment.events\` (partitions: 12, replication: 3)
  - \`user.events\` (partitions: 6, replication: 3)
  - \`notification.events\` (partitions: 6, replication: 3)
  - \`audit.events\` (partitions: 12, replication: 3)
  - Dead letter topics: \`*.events.dlq\` for each
- Enhanced monitoring enabled
- Open Monitoring with Prometheus enabled
- CloudWatch logging for broker logs

### 6. ECR Module (\`modules/ecr/\`)
- One repository per service:
  - \`spring-boot-microservices/order-service\`
  - \`spring-boot-microservices/payment-service\`
  - \`spring-boot-microservices/user-service\`
  - \`spring-boot-microservices/gateway\`
  - \`spring-boot-microservices/schema-registry\`
- Image scanning on push enabled
- Lifecycle policy: keep last 20 tagged images, expire untagged after 7 days
- Encryption with KMS
- Cross-account access for staging/production if needed

### 7. Secrets Module (\`modules/secrets/\`)
- KMS key for each environment with key rotation enabled
- Secrets Manager entries:
  - \`/{env}/rds/{service}/credentials\`
  - \`/{env}/redis/auth-token\`
  - \`/{env}/msk/sasl-credentials\`
  - \`/{env}/services/{service}/api-keys\`
- Integrate with ExternalSecrets Operator in Kubernetes

### 8. IAM Module (\`modules/iam/\`)
- IRSA roles for each service:
  - \`order-service-role\`: RDS access, MSK access, Secrets Manager read
  - \`payment-service-role\`: RDS access, MSK access, Secrets Manager read, KMS encrypt/decrypt (PCI DSS)
  - \`user-service-role\`: RDS access, MSK access, Secrets Manager read
  - \`gateway-role\`: Secrets Manager read
- CI/CD role for GitHub Actions (OIDC federation)
- Least-privilege policies (SOC 2)

### 9. ALB Module (\`modules/alb/\`)
- Application Load Balancer in public subnets
- HTTPS listener (port 443) with ACM certificate
- HTTP listener (port 80) redirects to HTTPS
- Target group for EKS ingress controller
- WAF v2 association with managed rule groups:
  - AWS Managed Rules Common Rule Set
  - AWS Managed Rules Known Bad Inputs
  - AWS Managed Rules SQL Injection
  - Rate limiting: 2000 requests per 5 minutes per IP
- Access logging to S3

### 10. Monitoring Module (\`modules/monitoring/\`)
- CloudWatch Log Groups for each service (90-day retention production, 30-day dev)
- CloudWatch Alarms:
  - RDS CPU > 80%, free storage < 10GB
  - Redis evictions > 0, CPU > 70%
  - MSK under-replicated partitions > 0, disk usage > 80%
  - EKS node count below minimum
- SNS topic for alerts → Slack integration
- Amazon Managed Prometheus workspace
- Amazon Managed Grafana workspace

## Kubernetes Manifests Requirements

### Network Policies
- Default deny all ingress/egress in services namespace
- Allow ingress from ingress namespace (ALB → gateway)
- Allow gateway → service communication within cluster
- Allow services → Kafka (MSK security group)
- Allow services → PostgreSQL (RDS security group)
- Allow services → Redis (ElastiCache security group)
- Allow services → monitoring namespace (metrics scraping)
- Allow egress to AWS VPC endpoints

### RBAC
- Service accounts per microservice mapped to IRSA roles
- Read-only role for developers in dev/staging
- No direct cluster access in production (CI/CD only)

### ExternalSecrets
- Configure ExternalSecrets Operator to sync from AWS Secrets Manager
- One ExternalSecret per service for database credentials
- One ExternalSecret for Redis auth token
- One ExternalSecret for Kafka SASL credentials

## Helm Charts Structure

\`\`\`
charts/
├── common/                    # Shared Helm library chart
│   ├── Chart.yaml
│   └── templates/
│       ├── _deployment.tpl
│       ├── _service.tpl
│       ├── _hpa.tpl
│       ├── _pdb.tpl
│       ├── _serviceaccount.tpl
│       ├── _configmap.tpl
│       └── _ingress.tpl
├── order-service/
│   ├── Chart.yaml             # depends on common
│   ├── values.yaml
│   ├── values-dev.yaml
│   ├── values-staging.yaml
│   ├── values-production.yaml
│   └── templates/
│       ├── deployment.yaml
│       ├── service.yaml
│       ├── hpa.yaml
│       ├── pdb.yaml
│       └── configmap.yaml
├── payment-service/
│   └── (same structure)
├── user-service/
│   └── (same structure)
└── gateway/
    └── (same structure)
\`\`\`

### Helm Values Requirements (per service)
- \`image.repository\`: ECR repo URL
- \`image.tag\`: set by CI/CD
- \`replicaCount\`: 2 (dev), 3 (staging), 5 (production)
- \`resources.requests\`: cpu=500m, memory=512Mi
- \`resources.limits\`: cpu=1000m, memory=1Gi
- \`hpa\`: min=replicaCount, max=replicaCount*3, targetCPU=70%
- \`pdb\`: minAvailable=50%
- \`env\` from ConfigMap:
  - \`SPRING_PROFILES_ACTIVE\`: dev/staging/production
  - \`SPRING_KAFKA_BOOTSTRAP_SERVERS\`: MSK bootstrap servers
  - \`SPRING_DATASOURCE_URL\`: RDS endpoint
  - \`SPRING_REDIS_HOST\`: ElastiCache endpoint
  - \`MANAGEMENT_ENDPOINTS_WEB_EXPOSURE_INCLUDE\`: health,info,prometheus
  - \`MANAGEMENT_TRACING_SAMPLING_PROBABILITY\`: 0.1 (production), 1.0 (dev)
- \`env\` from Secrets (via ExternalSecrets):
  - \`SPRING_DATASOURCE_USERNAME\`
  - \`SPRING_DATASOURCE_PASSWORD\`
  - \`SPRING_REDIS_PASSWORD\`
  - \`SPRING_KAFKA_PROPERTIES_SASL_JAAS_CONFIG\`
- Liveness probe: \`/actuator/health/liveness\`, initialDelay=30s, period=10s
- Readiness probe: \`/actuator/health/readiness\`, initialDelay=15s, period=5s
- Pod annotations for Prometheus scraping:
  - \`prometheus.io/scrape: "true"\`
  - \`prometheus.io/port: "8080"\`
  - \`prometheus.io/path: "/actuator/prometheus"\`

## Helper Scripts

### \`scripts/init-terraform.sh\`
- Accept environment as argument
- Initialize S3 backend: \`s3://spring-boot-microservices-tfstate-{account_id}/{env}\`
- DynamoDB table: \`spring-boot-microservices-tflock\`
- Validate required AWS credentials

### \`scripts/plan.sh\`
- Accept environment as argument
- Run \`terraform plan\` with correct var file
- Output plan to file for review

### \`scripts/apply.sh\`
- Accept environment as argument
- Require plan file as input
- Apply with auto-approve only for dev, require manual confirmation for staging/production

## Compliance Requirements (apply throughout)

### SOC 2
- All resources tagged with owner, environment, compliance
- VPC Flow Logs, CloudTrail, EKS audit logs enabled
- Encryption at rest for all data stores
- Access logging on ALB, S3 buckets
- IAM least-privilege, no wildcard permissions
- MFA delete on S3 state bucket

### PCI DSS
- Network segmentation: data subnets isolated via NACLs and security groups
- Encryption in transit (TLS 1.2+) for all connections
- Encryption at rest (KMS) for all data stores
- No sensitive data in environment variables (use Secrets Manager)
- Audit logging for all database access
- WAF on public-facing endpoints
- Regular vulnerability scanning (ECR image scan)

## Important Constraints

1. Use Terraform 1.7+ with required_providers block
2. Use \`for_each\` over \`count\` for resource iteration
3. All modules must have \`variables.tf\`, \`outputs.tf\`, \`main.tf\`, \`versions.tf\`
4. No hardcoded values — everything parameterized
5. State must be remote with locking
6. Sensitive outputs marked with \`sensitive = true\`
7. All security groups follow least-privilege (no 0.0.0.0/0 except ALB ingress on 443)
8. Production infrastructure changes require PR review (reference CODEOWNERS for \`infrastructure/production`,

  'playbook/prompts/03/project-scaffold.md': `# Phase 03 Prompt: Project Scaffold

> **Phase**: 03 — Foundation
> **Goal**: Generate the complete Gradle multi-module project structure, shared libraries, Docker configs, and CI/CD pipelines for the Spring Boot microservices platform.
> **Copy-paste this entire prompt into Claude Code.**

---

## Prompt

You are scaffolding a Spring Boot 3.2 microservices platform using Java 21 and Gradle (Kotlin DSL). This is a financial services platform that must comply with SOC 2 and PCI DSS requirements. Follow hexagonal architecture (ports & adapters) for every service.

### Context

Read these files before proceeding:
- \`playbook/phases/03-foundation.md\` — phase requirements and exit criteria
- \`docs/adrs/\` — all architecture decision records from Phase 02
- \`docs/requirements/\` — requirements and NFRs from Phase 01
- \`playbook/current-phase.json\` — confirm we are in phase 03

### What to Generate

Generate the complete project scaffold in this order. After each section, pause and confirm the files compile before moving on.

---

#### 1. Root Gradle Configuration

Create the root \`settings.gradle.kts\` and \`build.gradle.kts\` for a multi-module monorepo:

\`\`\`
settings.gradle.kts          # Include all subprojects
build.gradle.kts              # Common plugins, dependency management, JaCoCo aggregation
gradle.properties             # Java 21, Spring Boot 3.2.x, Kafka client versions
buildSrc/                     # Convention plugins for shared build logic
  build.gradle.kts
  src/main/kotlin/
    spring-boot-service.gradle.kts    # Convention plugin for microservices
    shared-library.gradle.kts         # Convention plugin for shared libs
    kotlin-library.gradle.kts         # Convention plugin for Kotlin modules
\`\`\`

The root build must configure:
- Java 21 toolchain
- Spring Boot 3.2.x BOM via dependency management
- Spring Cloud 2023.x BOM
- Checkstyle plugin pointing to \`config/checkstyle/checkstyle.xml\`
- JaCoCo with 80% minimum coverage threshold
- SpotBugs for static analysis
- OWASP dependency-check plugin
- Consistent dependency versions in \`gradle.properties\` (Spring Boot, Kafka, Testcontainers, JUnit 5, Mockito, Pact)

---

#### 2. Shared Libraries

Create these shared modules under \`shared/\`:

**shared/domain-events**
\`\`\`
shared/domain-events/
  build.gradle.kts
  src/main/java/com/platform/events/
    DomainEvent.java                  # Base event interface with eventId, timestamp, aggregateId, eventType
    EventMetadata.java                # Correlation ID, causation ID, source service, schema version
    EventEnvelope.java                # Generic wrapper: metadata + payload, serialization support
  src/main/java/com/platform/events/order/
    OrderCreatedEvent.java
    OrderConfirmedEvent.java
    OrderCancelledEvent.java
  src/main/java/com/platform/events/payment/
    PaymentInitiatedEvent.java
    PaymentCompletedEvent.java
    PaymentFailedEvent.java
  src/main/java/com/platform/events/user/
    UserRegisteredEvent.java
    UserVerifiedEvent.java
  src/test/java/com/platform/events/
    EventEnvelopeTest.java            # Serialization/deserialization round-trip tests
\`\`\`

**shared/common**
\`\`\`
shared/common/
  build.gradle.kts
  src/main/java/com/platform/common/
    exception/
      DomainException.java            # Base domain exception
      ResourceNotFoundException.java
      ConflictException.java
      ValidationException.java
    model/
      Money.java                      # Value object for monetary amounts (BigDecimal + Currency)
      PagedResult.java                # Generic pagination wrapper
      AuditInfo.java                  # createdAt, updatedAt, createdBy, updatedBy
    validation/
      Preconditions.java              # Domain validation helpers
    security/
      SecurityContext.java            # Thread-local security context accessor
      ServicePrincipal.java           # Service-to-service identity
\`\`\`

**shared/spring-boot-starter**
\`\`\`
shared/spring-boot-starter/
  build.gradle.kts
  src/main/java/com/platform/starter/
    kafka/
      KafkaProducerConfig.java        # Idempotent producer, JSON serializer, transactional config
      KafkaConsumerConfig.java        # Consumer group config, error handling, DLT routing
      EventPublisher.java             # Abstraction over KafkaTemplate with EventEnvelope
      DeadLetterTopicHandler.java     # DLT consumer and alerting
    observability/
      TracingConfig.java              # Micrometer tracing + Jaeger exporter
      MetricsConfig.java              # Custom Prometheus metrics
      CorrelationIdFilter.java        # Servlet filter to propagate correlation IDs
      StructuredLoggingConfig.java    # JSON logging with trace/span IDs for ELK
    security/
      JwtAuthenticationFilter.java    # JWT validation filter
      SecurityAutoConfiguration.java  # Default Spring Security config (CSRF, CORS, headers)
      PciDssSecurityHeaders.java      # PCI DSS required security headers
    web/
      GlobalExceptionHandler.java     # @ControllerAdvice with RFC 7807 Problem Details
      RequestLoggingFilter.java       # Audit logging for all API requests
    autoconfigure/
      PlatformAutoConfiguration.java  # Spring Boot auto-configuration entry point
  src/main/resources/
    META-INF/spring/
      org.springframework.boot.autoconfigure.AutoConfiguration.imports
  src/test/java/com/platform/starter/
    kafka/EventPublisherTest.java
    security/JwtAuthenticationFilterTest.java
\`\`\`

---

#### 3. Service Scaffolds

For each service (\`order-service\`, \`payment-service\`, \`user-service\`), generate the hexagonal architecture layout:

\`\`\`
services/{service-name}/
  build.gradle.kts                    # Depends on shared modules, Spring Boot plugin
  Dockerfile                          # Multi-stage: gradle build → eclipse-temurin:21-jre-alpine
  src/main/java/com/platform/{service}/
    {Service}Application.java         # @SpringBootApplication entry point
    domain/
      model/                          # Domain entities and value objects
      port/
        inbound/                      # Use case interfaces (driving ports)
        outbound/                     # Repository and external service interfaces (driven ports)
      service/                        # Domain service implementations
      event/                          # Domain event handling
    adapter/
      inbound/
        rest/                         # @RestController implementations
          dto/                        # Request/Response DTOs
          mapper/                     # MapStruct mappers (DTO ↔ Domain)
        kafka/                        # Kafka consumer adapters (@KafkaListener)
      outbound/
        persistence/                  # JPA repositories, entity mappings
          entity/                     # JPA @Entity classes
          mapper/                     # Entity ↔ Domain mappers
          repository/                 # Spring Data JPA repositories
        kafka/                        # Kafka producer adapters
        redis/                        # Redis cache adapters
    config/                           # Spring configuration classes
  src/main/resources/
    application.yml                   # Default config
    application-local.yml             # Local dev (Docker Compose)
    application-staging.yml           # Staging overrides
    application-production.yml        # Production overrides (minimal — use env vars)
    db/migration/                     # Flyway migrations
      V1__init_schema.sql
  src/test/java/com/platform/{service}/
    domain/service/                   # Unit tests for domain logic
    adapter/inbound/rest/             # @WebMvcTest controller tests
    adapter/outbound/persistence/     # @DataJpaTest repository tests
    integration/                      # Full integration tests with Testcontainers
      {Service}IntegrationTest.java   # @SpringBootTest + Testcontainers (Postgres, Kafka, Redis)
  src/test/resources/
    application-test.yml              # Test profile config
\`\`\`

For each service's \`build.gradle.kts\`, include:
\`\`\`kotlin
plugins {
    id("spring-boot-service")  // Our convention plugin
}

dependencies {
    implementation(project(":shared:domain-events"))
    implementation(project(":shared:common"))
    implementation(project(":shared:spring-boot-starter"))
    implementation("org.springframework.boot:spring-boot-starter-web")
    implementation("org.springframework.boot:spring-boot-starter-data-jpa")
    implementation("org.springframework.boot:spring-boot-starter-security")
    implementation("org.springframework.boot:spring-boot-starter-actuator")
    implementation("org.springframework.boot:spring-boot-starter-validation")
    implementation("org.springframework.kafka:spring-kafka")
    implementation("org.springframework.boot:spring-boot-starter-data-redis")
    implementation("org.flywaydb:flyway-core")
    implementation("org.flywaydb:flyway-database-postgresql")
    runtimeOnly("org.postgresql:postgresql")
    testImplementation("org.springframework.boot:spring-boot-starter-test")
    testImplementation("org.springframework.kafka:spring-kafka-test")
    testImplementation("org.springframework.security:spring-security-test")
    testImplementation("org.testcontainers:junit-jupiter")
    testImplementation("org.testcontainers:postgresql")
    testImplementation("org.testcontainers:kafka")
}
\`\`\`

---

#### 4. API Gateway

\`\`\`
gateway/
  build.gradle.kts                    # Spring Cloud Gateway dependency
  Dockerfile
  src/main/java/com/platform/gateway/
    GatewayApplication.java
    config/
      RouteConfig.java                # Route definitions to downstream services
      RateLimitConfig.java            # Redis-based rate limiting
      CorsConfig.java                 # CORS policy
      SecurityConfig.java            # OAuth2 resource server / JWT validation
    filter/
      CorrelationIdGatewayFilter.java # Inject/propagate correlation IDs
      AuditLoggingFilter.java         # Log all gateway requests for SOC 2
  src/main/resources/
    application.yml
\`\`\`

---

#### 5. Schema Registry

\`\`\`
schema-registry/
  schemas/
    order/
      order-created-v1.json           # JSON Schema for OrderCreatedEvent
      order-confirmed-v1.json
      order-cancelled-v1.json
    payment/
      payment-initiated-v1.json
      payment-completed-v1.json
      payment-failed-v1.json
    user/
      user-registered-v1.json
      user-verified-v1.json
  README.md                           # Schema versioning policy, compatibility rules
\`\`\`

---

#### 6. Docker Compose (Local Development)

Create \`docker-compose.yml\` at the project root with:
- PostgreSQL (3 databases: order_db, payment_db, user_db)
- Apache Kafka (KRaft mode, single broker) + kafka-ui
- Redis
- Jaeger (all-in-one)
- Prometheus + Grafana (with pre-configured dashboards)

Create \`docker-compose.override.yml\` for developer convenience (port mappings, volume mounts).

---

#### 7. CI/CD Pipelines

Create \`.github/workflows/\`:

**ci.yml** — Triggered on PR to \`main\`:
1. Checkout with signed commit verification
2. Set up Java 21 (Temurin) + Gradle cache
3. Run \`./gradlew checkstyleMain checkstyleTest\` (lint)
4. Run \`./gradlew compileJava compileKotlin\` (compile)
5. Run \`./gradlew test\` (unit tests)
6. Run \`./gradlew integrationTest\` (integration tests with Testcontainers)
7. Run \`./gradlew pactTest\` (contract tests)
8. Run \`./gradlew dependencyCheckAnalyze\` (OWASP security scan)
9. Run \`./gradlew spotbugsMain\` (static analysis)
10. Run \`./gradlew jacocoTestReport jacocoTestCoverageVerification\` (coverage ≥ 80%)
11. Flag AI-generated code in PR comment if detected
12. Upload test reports and coverage as artifacts

**deploy-staging.yml** — Triggered on merge to \`main\`:
1. All CI steps above
2. Build Docker images: \`./gradlew bootBuildImage\`
3. Push to ECR
4. Deploy to EKS staging via Helm: \`helm upgrade --install\`
5. Run E2E tests against staging
6. Notify Slack channel on success/failure

**deploy-production.yml** — Manual trigger with approval:
1. Require 2 approvals from CODEOWNERS
2. Pull staging-verified image tag
3. Deploy to EKS production via Helm with canary strategy
4. Run smoke tests
5. Notify Slack channel

---

#### 8. Helm Charts

\`\`\`
charts/
  order-service/
    Chart.yaml
    values.yaml                       # Image, replicas, resources, env vars
    values-staging.yaml
    values-production.yaml
    templates/
      deployment.yaml
      service.yaml
      ingress.yaml
      configmap.yaml
      secret.yaml                     # ExternalSecrets reference
      hpa.yaml                        # Horizontal Pod Autoscaler
      pdb.yaml                        # Pod Disruption Budget
      serviceaccount.yaml
  payment-service/                    # Same structure
  user-service/                       # Same structure
  gateway/                            # Same structure
\`\`\`

---

#### 9. Infrastructure as Code

\`\`\`
infrastructure/
  terraform/
    environments/
      staging/
        main.tf
        variables.tf
        terraform.tfvars
      production/
        main.tf
        variables.tf
        terraform.tfvars
    modules/
      eks/                            # EKS cluster
      rds/                            # PostgreSQL RDS per service
      elasticache/                    # Redis cluster
      msk/                            # Managed Kafka
      ecr/                            # Container registry
      alb/                            # Application Load Balancer
      vpc/                            # VPC, subnets, security groups
\`\`\`

---

#### 10. Configuration Files

Create these at the project root:
- \`config/checkstyle/checkstyle.xml\` — Google Java Style with max 300 line file length
- \`.editorconfig\` — Java/Kotlin/YAML/Markdown settings
- \`CODEOWNERS\` — Map service directories to owning teams
- \`.gitignore\` — Java/Gradle/IDE/Docker ignores
- \`renovate.json\` — Conservative dependency update policy (approved list)

---

### Validation Steps

After generating all files, run these commands and confirm they pass:

\`\`\`bash
# 1. Compile everything
./gradlew compileJava compileKotlin

# 2. Run Checkstyle
./gradlew checkstyleMain

# 3. Run unit tests
./gradlew test

# 4. Verify JaCoCo coverage
./gradlew jacocoTestCoverageVerification

# 5. Build Docker images
docker compose build

# 6. Start local environment
docker compose up -d
# Verify all containers are healthy

# 7. Verify Actuator endpoints
curl http://localhost:8081/actuator/health  # order-service
curl http://localhost:8082/actuator/health  # payment-service
curl http://localhost:8083/actuator/health  # user-service
curl http://localhost:8080/actuator/health  # gateway
\`\`\`

### Constraints

- **No direct REST calls between services** — all inter-service communication through Kafka topics
- **Each service has its own database** — no shared schemas
- **All Kafka events use EventEnvelope** with full metadata (correlation ID, schema version)
- **Flyway for all database migrations** — no manual DDL
- **Spring Profiles**: \`local\`, \`test\`, \`staging\`, \`production\`
- **Secrets**: Never in code or config files — use environment variables or ExternalSecrets in K8s
- **PCI DSS**: Payment service must encrypt PAN data at rest, mask in logs, restrict access
- **SOC 2**:`,

  'playbook/prompts/04/auth-implementation.md': `# Auth Implementation — Phase 04 Core Implementation

## Copy-Pasteable Prompt for Claude Code

\`\`\`
I need you to implement the authentication and authorization system for our Spring Boot microservices platform. This is a financial services application requiring SOC 2 and PCI DSS compliance. Follow our hexagonal architecture and ensure all inter-service auth propagation happens through Kafka event headers — no direct REST calls between services.

## Project Context

- **Framework**: Spring Boot 3.2, Java 21, Spring Security 6
- **Architecture**: Hexagonal (Ports & Adapters) within each microservice
- **Databases**: PostgreSQL per-service (user-service owns identity data), Redis for sessions/token blacklist
- **Messaging**: Apache Kafka for auth events (user.created, user.locked, token.revoked, role.changed)
- **Gateway**: Spring Cloud Gateway handles token validation at the edge
- **Compliance**: SOC 2 Type II, PCI DSS Level 1

## Directory Structure

Place files according to our monorepo layout:

\`\`\`
services/user-service/
  src/main/java/com/company/user/
    domain/
      model/          # User, Role, Permission, Credential entities
      port/
        inbound/      # AuthenticationUseCase, AuthorizationUseCase, TokenUseCase
        outbound/     # UserRepository, TokenStore, EventPublisher, PasswordEncoder
      service/        # AuthenticationService, AuthorizationService, TokenService
    adapter/
      inbound/
        rest/         # AuthController, TokenController
        kafka/        # AuthEventConsumer (listens for role.changed, token.revoked)
      outbound/
        persistence/  # JpaUserRepository, JpaRoleRepository
        redis/        # RedisTokenStore, RedisSessionStore
        kafka/        # AuthEventPublisher
    config/           # SecurityConfig, JwtConfig, RedisConfig, KafkaConfig
  src/main/resources/
    db/migration/     # Flyway migrations for users, roles, permissions, audit_log
    application.yml
    application-local.yml
    application-staging.yml
    application-production.yml

gateway/
  src/main/java/com/company/gateway/
    filter/           # JwtAuthenticationFilter, RateLimitFilter, RequestLoggingFilter
    config/           # SecurityConfig, RouteConfig

shared/
  shared-security/
    src/main/java/com/company/shared/security/
      JwtTokenProvider.java
      JwtTokenValidator.java
      SecurityContextPropagator.java
      KafkaSecurityHeaderInterceptor.java
      annotation/     # @RequiresPermission, @AuditLog
      model/          # AuthenticatedUser, TokenClaims, SecurityEvent
\`\`\`

## Authentication Requirements

### 1. JWT Token Implementation

- **Access tokens**: RS256 signed, 15-minute expiry, contains userId, roles, permissions, tenantId
- **Refresh tokens**: Opaque, stored in Redis with 7-day TTL, single-use with rotation
- **Token blacklist**: Redis SET with TTL matching token expiry for revoked tokens
- **Key management**: RSA key pair loaded from AWS Secrets Manager (local: classpath)
- Use \`com.nimbusds:nimbus-jose-jwt\` for JWT operations (already in approved dependency list)

### 2. Authentication Flow

Implement these endpoints in \`AuthController\`:

\`\`\`
POST /api/v1/auth/login          # Email + password → access_token + refresh_token
POST /api/v1/auth/refresh        # refresh_token → new access_token + new refresh_token
POST /api/v1/auth/logout         # Blacklist current tokens, invalidate refresh token
POST /api/v1/auth/logout-all     # Revoke all sessions for user (publish token.revoked event)
\`\`\`

- Password verification using BCrypt with strength 12
- Account lockout after 5 failed attempts within 15 minutes (publish user.locked event)
- Lockout duration: 30 minutes (configurable via Spring properties)
- All login attempts logged to audit_log table (success and failure)

### 3. Authorization Model

- RBAC with permissions: \`Role\` has many \`Permission\` objects
- Default roles: \`ADMIN\`, \`OPERATOR\`, \`ANALYST\`, \`SERVICE_ACCOUNT\`
- Permissions follow pattern: \`resource:action\` (e.g., \`payment:create\`, \`order:read\`, \`user:manage\`)
- Method-level security using custom \`@RequiresPermission("payment:create")\` annotation
- Implement \`PermissionEvaluator\` that checks JWT claims

### 4. Service-to-Service Authentication

- Services authenticate via \`SERVICE_ACCOUNT\` role with long-lived tokens (24h)
- Service credentials stored in AWS Secrets Manager
- Kafka messages carry auth context in headers: \`X-Auth-User-Id\`, \`X-Auth-Roles\`, \`X-Auth-Tenant-Id\`
- Implement \`KafkaSecurityHeaderInterceptor\` for producer/consumer to propagate/extract security context
- \`SecurityContextPropagator\` sets Spring SecurityContext from Kafka headers during event processing

## Kafka Event Schemas

Define these in \`schema-registry/\`:

### user.created (topic: user-events)
\`\`\`json
{
  "eventId": "uuid",
  "eventType": "user.created",
  "timestamp": "ISO-8601",
  "userId": "uuid",
  "email": "string",
  "roles": ["string"],
  "tenantId": "uuid"
}
\`\`\`

### user.locked (topic: user-events)
\`\`\`json
{
  "eventId": "uuid",
  "eventType": "user.locked",
  "timestamp": "ISO-8601",
  "userId": "uuid",
  "reason": "FAILED_LOGIN_ATTEMPTS | ADMIN_ACTION | SUSPICIOUS_ACTIVITY",
  "lockedUntil": "ISO-8601",
  "failedAttempts": "int"
}
\`\`\`

### token.revoked (topic: auth-events)
\`\`\`json
{
  "eventId": "uuid",
  "eventType": "token.revoked",
  "timestamp": "ISO-8601",
  "userId": "uuid",
  "scope": "SINGLE_SESSION | ALL_SESSIONS",
  "reason": "USER_LOGOUT | ADMIN_REVOKE | PASSWORD_CHANGE | SECURITY_INCIDENT"
}
\`\`\`

### role.changed (topic: auth-events)
\`\`\`json
{
  "eventId": "uuid",
  "eventType": "role.changed",
  "timestamp": "ISO-8601",
  "userId": "uuid",
  "previousRoles": ["string"],
  "newRoles": ["string"],
  "changedBy": "uuid"
}
\`\`\`

## Spring Security Configuration

### Gateway SecurityConfig
- Stateless session management
- JWT validation filter in the filter chain
- Rate limiting: 100 requests/minute per IP for auth endpoints, 1000/minute for authenticated APIs
- CORS configured for allowed origins per Spring Profile
- CSRF disabled (stateless JWT)
- Security headers: HSTS, X-Content-Type-Options, X-Frame-Options

### User Service SecurityConfig
- Permit \`/api/v1/auth/login\`, \`/api/v1/auth/refresh\`, \`/actuator/health\`
- All other endpoints require authentication
- Method-level security enabled with \`@EnableMethodSecurity\`
- Custom \`AuthenticationEntryPoint\` returning RFC 7807 Problem Detail JSON
- Custom \`AccessDeniedHandler\` returning RFC 7807 Problem Detail JSON

## Database Migrations (Flyway)

Create these migrations in \`services/user-service/src/main/resources/db/migration/\`:

\`\`\`
V1__create_users_table.sql
V2__create_roles_and_permissions.sql
V3__create_user_roles_junction.sql
V4__create_audit_log.sql
V5__create_refresh_tokens.sql
V6__seed_default_roles_and_permissions.sql
\`\`\`

### Key table requirements:
- \`users\`: id (UUID PK), email (unique, encrypted at rest), password_hash, status (ACTIVE/LOCKED/DISABLED), failed_login_attempts, locked_until, tenant_id, created_at, updated_at
- \`roles\`: id (UUID PK), name (unique), description, created_at
- \`permissions\`: id (UUID PK), name (unique, pattern: resource:action), description
- \`role_permissions\`: role_id (FK), permission_id (FK), composite PK
- \`user_roles\`: user_id (FK), role_id (FK), assigned_by (FK to users), assigned_at, composite PK
- \`audit_log\`: id (UUID PK), user_id, action, resource, ip_address, user_agent, status (SUCCESS/FAILURE), details (JSONB), created_at — partitioned by month
- \`refresh_tokens\`: id (UUID PK), user_id (FK), token_hash (unique), expires_at, created_at, revoked_at

## PCI DSS Compliance Requirements

- Never log passwords, tokens, or PII — implement a \`SanitizingLogFilter\`
- Password storage: BCrypt only, minimum 12 rounds
- Token values never stored in plaintext — hash refresh tokens with SHA-256 before persisting
- Audit log is append-only (no UPDATE/DELETE permissions for application role)
- All auth endpoints must be rate-limited
- Session timeout configurable, default 15 minutes for access tokens
- Force re-authentication for sensitive operations (password change, role assignment)
- TLS 1.2+ enforced at gateway level

## SOC 2 Audit Trail Requirements

- Every authentication event (login, logout, token refresh, failed attempt) must be logged
- Every authorization decision (access granted, access denied) must be logged
- Audit log entries must include: timestamp, userId, action, resource, sourceIP, userAgent, outcome
- Implement \`@AuditLog\` annotation that auto-logs method invocations to the audit table
- Audit log must be queryable via admin API with pagination and date range filters

## Testing Requirements

### Unit Tests (JUnit 5 + Mockito)
- \`AuthenticationServiceTest\`: login success, login failure, account lockout, lockout expiry
- \`TokenServiceTest\`: token generation, token validation, token refresh, token revocation
- \`AuthorizationServiceTest\`: permission check, role hierarchy, missing permission
- \`JwtTokenProviderTest\`: token creation, claims extraction, expired token, invalid signature

### Integration Tests (Testcontainers)
- \`AuthControllerIntegrationTest\`: full login flow with PostgreSQL + Redis containers
- \`AuthEventPublisherIntegrationTest\`: verify Kafka events published on login/logout/lock
- \`TokenStoreIntegrationTest\`: Redis token storage, blacklist, TTL expiry
- \`AuditLogIntegrationTest\`: verify audit entries written for all auth events

### Contract Tests (Pact)
- Provider contract for auth endpoints consumed by gateway
- Provider contract for auth Kafka events consumed by other services

## Implementation Order

1. **Shared security library** (\`shared/shared-security/\`) — JWT provider, validator, annotations, models
2. **Database migrations** — Flyway scripts for user-service
3. **Domain model** — User, Role, Permission entities and port interfaces
4. **Outbound adapters** — JPA repositories, Redis token store, Kafka event publisher
5. **Domain services** — AuthenticationService, AuthorizationService, TokenService
6. **Inbound adapters** — REST controllers, Kafka consumers
7. **Spring Security config** — User service and gateway security filter chains
8. **Gateway JWT filter** — Token validation at the edge
9. **Kafka security propagation** — Header interceptors for producer/consumer
10. **Audit logging** — @AuditLog annotation and aspect
11. **Tests** — Unit, integration (Testcontainers), contract (Pact)

## Constraints

- Follow hexagonal architecture strictly — domain must not depend on Spring annotations
- Domain model uses plain Java (no Lombok in domain layer, Lombok OK in adapters)
- All configuration externalized via Spring Profiles (no hardcoded values)
- Max 300 lines per file — split large classes into focused components
- Use constructor injection everywhere (no @Autowired on fields)
- All public methods in domain services must have Javadoc
- Conventional commit messages for each logical change
- Mark all generated files with \`// Generated with AI assistance\` header comment

## Spring Profile Configuration

Provide \`application.yml\` with these profiles:

- **local**: H2 or local PostgreSQL, embedded Redis, local Kafka (Testcontainers-friendly)
- **staging**: AWS RDS, ElastiCache, MSK — credentials from AWS Secrets Manager
- **production**: Same as staging with stricter security settings, shorter token TTLs

## What to Generate

Please generate all files listed above, starting with the shared security library, then the user-service domain and adapters, then the gateway filter, then the tests. For each file:

1. Include the package declaration and all necessary imports
2. Follow google-java-format style
3. Add Javadoc on all public classes and methods
4. Include \`@Slf4j\` logging where appropriate (adapters only, not domain)
5. Use records for DTOs and value objects where possible
6. Ensure Checkstyle compliance (no wildcard imports, proper ordering)

After generating, I will run:
- \`./gradlew :shared:shared-security:build\` to verify shared library
- \`./gradlew :services:user-service:test\` to verify unit tests
- \`./gradlew :services:user-service:integrationTest\` to verify Testcontainers tests
- \`./gradlew :gateway:test\` to verify gateway filter tests
\`\`\`

## Usage Notes

1. **Copy the entire prompt** inside the code fence above and paste it into Claude Code
2. **Before running**, ensure you have:
   - The Gradle multi-module project scaffolded (Phase 03 \`project-scaffold\` prompt)
   - PostgreSQL, Redis, and Kafka available locally or via Testcontainers
   - \`nimbus-jose-jwt\` added to the approved dependency list in \`shared/shared-security/build.gradle.kts\`
3. **After generation**, run the verification commands listed at the bottom of the prompt
4. **Review carefully**: Auth code is a sensitive path (\`**/security/**\`, \`**/auth/**\`) — requires 2 approvals per PR policy
5. **Split into multiple PRs** if the changeset is large:
   - PR 1: \`shared/shared-security/\` + database migrations
   - PR 2: \`services/user-service/\` domain + adapters
   - PR 3: \`gateway/\` JWT filter + security config
   - PR 4: Kafka security propagation + event schemas
   - PR 5: Tests (unit, integration, contract)

## Compliance Checklist

Before merging, verify:

- [ ] No passwords, tokens, or PII in log output
- [ ] Refresh tokens hashed with SHA-256 before storage
- [ ] Audit log captures all auth events with required fields
- [ ] Account lockout implemented and tested
- [ ] Rate limiting configured on auth endpoints
- [ ] JWT uses RS256 with externalized key management
- [ ] All Kafka events follow schema registry definitions
- [ ] Testcontainers integration tests pass with real PostgreSQL, Redis, Kafka
- [ ] OWASP dependency-check passes: \`./gradlew dependencyCheckAnalyze\`
- [ ] SpotBugs security audit passes: \`./gradlew spotbugsMain\`
- [ ] JaCoCo coverage ≥ 80%: \`./gradlew jacocoTestReport\`
- [ ] No direct REST calls between services — all communication via Kafka

## Related Prompts

- **Phase 03**: \`playbook/prompts/03/project-scaffold.md\` — project structure this builds on
- **Phase 04**: \`playbook/prompts/04/feature-implementation.md\` — pattern for implementing service features after auth is in place
- **Phase 05**: \`playbook/prompts/05/integration-hardening.md\` — security hardening and penetration testing (upcoming)
- **Phase 06**: \`playbook/prompts/06/security-audit.md\` — SOC 2 / PCI DSS compliance verification (upcoming)`,

  'playbook/prompts/04/crud-generator.md': `# CRUD Generator — Phase 04: Core Implementation

> **Copy-paste this prompt into Claude Code** to generate a complete CRUD microservice module following hexagonal architecture, with Kafka event publishing, PostgreSQL persistence, Redis caching, and full test coverage.

---

## Prompt

\`\`\`
You are a senior Spring Boot engineer working in a Gradle multi-module monorepo for a fintech platform. Generate a complete CRUD microservice module for the entity described below, following our hexagonal architecture and all project conventions.

## Entity Specification

- **Service name**: {{SERVICE_NAME}} (e.g., account-service, transaction-service, merchant-service)
- **Entity name**: {{ENTITY_NAME}} (e.g., Account, Transaction, Merchant)
- **Fields**: {{FIELDS}} (e.g., "id: UUID, accountNumber: String, holderName: String, balance: BigDecimal, currency: String, status: AccountStatus, createdAt: Instant, updatedAt: Instant")
- **Business rules**: {{BUSINESS_RULES}} (e.g., "Balance cannot go negative. Account number must be unique. Status transitions: PENDING → ACTIVE → SUSPENDED → CLOSED.")
- **Domain events**: {{DOMAIN_EVENTS}} (e.g., "AccountCreated, AccountActivated, AccountSuspended, AccountClosed, BalanceUpdated")
- **Kafka topic**: {{KAFKA_TOPIC}} (e.g., "account.events")
- **Cache strategy**: {{CACHE_STRATEGY}} (e.g., "Cache by ID with 5-minute TTL, evict on update/delete")

## Project Context

This is a fintech platform subject to SOC 2 and PCI DSS compliance. The monorepo uses:
- Java 21, Spring Boot 3.2, Gradle Kotlin DSL
- Hexagonal Architecture (Ports & Adapters)
- PostgreSQL per-service database, Redis for caching
- Apache Kafka for all inter-service communication (no direct REST calls between services)
- Testcontainers for integration tests, JUnit 5 + Mockito for unit tests
- Checkstyle (google-java-format), JaCoCo ≥80% coverage
- Conventional commits, max 300 lines per file

## Directory Structure to Generate

Generate the following files under \`services/{{SERVICE_NAME}}/\`:

### 1. Gradle Build File
\`services/{{SERVICE_NAME}}/build.gradle.kts\`
- Dependencies: spring-boot-starter-web, spring-boot-starter-data-jpa, spring-boot-starter-validation, spring-kafka, spring-boot-starter-data-redis, spring-boot-starter-actuator, spring-boot-starter-security, postgresql driver, shared:domain-events module, shared:common module
- Apply Checkstyle, JaCoCo, and SpotBugs plugins
- JaCoCo minimum coverage: 0.80

### 2. Domain Layer (core — no framework dependencies)

\`src/main/java/com/platform/{{service_package}}/domain/model/{{ENTITY_NAME}}.java\`
- Pure Java domain entity with business logic methods
- Validation in constructor and business methods
- Immutable where possible, use builder pattern
- Enforce business rules ({{BUSINESS_RULES}})
- No JPA annotations — this is the domain model

\`src/main/java/com/platform/{{service_package}}/domain/model/{{ENTITY_NAME}}Status.java\`
- Enum for status with allowed transitions method

\`src/main/java/com/platform/{{service_package}}/domain/event/{{EVENT_NAME}}.java\` (one per domain event)
- Extend from \`com.platform.shared.events.DomainEvent\`
- Include: eventId (UUID), entityId, timestamp, event-specific payload
- Implement serializable, include schema version field

\`src/main/java/com/platform/{{service_package}}/domain/port/in/{{ENTITY_NAME}}UseCase.java\`
- Input port interface: create, getById, getAll (paginated), update, delete
- Use command/query objects as parameters, not raw fields

\`src/main/java/com/platform/{{service_package}}/domain/port/in/Create{{ENTITY_NAME}}Command.java\`
- Validated command record with Jakarta validation annotations

\`src/main/java/com/platform/{{service_package}}/domain/port/in/Update{{ENTITY_NAME}}Command.java\`
- Validated command record for updates

\`src/main/java/com/platform/{{service_package}}/domain/port/out/{{ENTITY_NAME}}Repository.java\`
- Output port interface (not Spring Data — just a Java interface)
- Methods: save, findById, findAll (paginated), delete, existsBy unique fields

\`src/main/java/com/platform/{{service_package}}/domain/port/out/{{ENTITY_NAME}}EventPublisher.java\`
- Output port interface for publishing domain events

\`src/main/java/com/platform/{{service_package}}/domain/service/{{ENTITY_NAME}}Service.java\`
- Implements {{ENTITY_NAME}}UseCase
- Orchestrates domain logic, calls repository and event publisher ports
- Annotated with @Service, @Transactional where appropriate
- Publishes domain events after successful persistence
- Includes audit logging for SOC 2 compliance

### 3. Adapter Layer — Inbound (REST API)

\`src/main/java/com/platform/{{service_package}}/adapter/in/rest/{{ENTITY_NAME}}Controller.java\`
- @RestController with @RequestMapping("/api/v1/{{entity-kebab}}")
- Standard CRUD endpoints: POST, GET /{id}, GET (paginated), PUT /{id}, DELETE /{id}
- Request/response DTOs (not domain objects)
- @Valid on request bodies
- Proper HTTP status codes (201 Created, 200 OK, 204 No Content, 404 Not Found)
- Include @Operation and @ApiResponse annotations for OpenAPI
- Structured error responses
- SecurityContext-aware (extract principal for audit)

\`src/main/java/com/platform/{{service_package}}/adapter/in/rest/dto/Create{{ENTITY_NAME}}Request.java\`
- Record with Jakarta validation annotations

\`src/main/java/com/platform/{{service_package}}/adapter/in/rest/dto/Update{{ENTITY_NAME}}Request.java\`
- Record with Jakarta validation annotations

\`src/main/java/com/platform/{{service_package}}/adapter/in/rest/dto/{{ENTITY_NAME}}Response.java\`
- Record for API responses (no sensitive internal fields)

\`src/main/java/com/platform/{{service_package}}/adapter/in/rest/dto/{{ENTITY_NAME}}PageResponse.java\`
- Paginated response wrapper

\`src/main/java/com/platform/{{service_package}}/adapter/in/rest/mapper/{{ENTITY_NAME}}RestMapper.java\`
- MapStruct or manual mapper: domain ↔ DTO conversions

\`src/main/java/com/platform/{{service_package}}/adapter/in/rest/GlobalExceptionHandler.java\`
- @RestControllerAdvice handling: NotFoundException, ValidationException, BusinessRuleException, generic fallback
- Structured JSON error response with correlation ID
- Never expose stack traces or internal details (PCI DSS)

### 4. Adapter Layer — Outbound (Persistence)

\`src/main/java/com/platform/{{service_package}}/adapter/out/persistence/{{ENTITY_NAME}}JpaEntity.java\`
- JPA @Entity with @Table, proper column mappings
- @CreatedDate, @LastModifiedDate via Spring Data auditing
- Optimistic locking with @Version
- Indexes on frequently queried fields

\`src/main/java/com/platform/{{service_package}}/adapter/out/persistence/{{ENTITY_NAME}}JpaRepository.java\`
- Spring Data JpaRepository interface

\`src/main/java/com/platform/{{service_package}}/adapter/out/persistence/{{ENTITY_NAME}}PersistenceAdapter.java\`
- Implements domain {{ENTITY_NAME}}Repository port
- Converts between JPA entity and domain model
- @Repository annotated

\`src/main/java/com/platform/{{service_package}}/adapter/out/persistence/mapper/{{ENTITY_NAME}}PersistenceMapper.java\`
- JPA entity ↔ domain model mapper

### 5. Adapter Layer — Outbound (Kafka Event Publishing)

\`src/main/java/com/platform/{{service_package}}/adapter/out/kafka/{{ENTITY_NAME}}KafkaEventPublisher.java\`
- Implements domain {{ENTITY_NAME}}EventPublisher port
- Uses KafkaTemplate to publish to topic: {{KAFKA_TOPIC}}
- Message key: entity ID (for partition ordering)
- Includes correlation ID header, event type header, schema version header
- Error handling with retry and dead-letter topic
- @Component annotated

\`src/main/java/com/platform/{{service_package}}/adapter/out/kafka/config/KafkaProducerConfig.java\`
- Producer configuration: JSON serializer, acks=all, idempotent=true, retries=3
- Dead-letter topic configuration

### 6. Adapter Layer — Outbound (Redis Cache)

\`src/main/java/com/platform/{{service_package}}/adapter/out/cache/{{ENTITY_NAME}}CacheAdapter.java\`
- Redis-backed cache implementing a cache wrapper around the repository port
- TTL: as specified in {{CACHE_STRATEGY}}
- Cache-aside pattern: check cache → miss → load from DB → populate cache
- Evict on update and delete
- Use RedisTemplate with JSON serialization

\`src/main/java/com/platform/{{service_package}}/adapter/out/cache/config/RedisCacheConfig.java\`
- Redis connection and serialization configuration
- Cache names and TTL settings

### 7. Configuration

\`src/main/java/com/platform/{{service_package}}/config/SecurityConfig.java\`
- Spring Security configuration
- JWT-based authentication (validate tokens from auth-service)
- Endpoint-level authorization (e.g., DELETE requires ADMIN role)
- CORS configuration
- Disable CSRF for API (stateless)

\`src/main/java/com/platform/{{service_package}}/config/OpenApiConfig.java\`
- SpringDoc OpenAPI configuration with service metadata

\`src/main/resources/application.yml\`
- Spring profiles: default, local, staging, production
- Database, Redis, Kafka connection properties using environment variables
- Actuator endpoints: health, info, prometheus, metrics
- Logging: structured JSON format, correlation ID in MDC
- Server port, context path

\`src/main/resources/application-local.yml\`
- Local development overrides (localhost connections)

\`src/main/resources/db/migration/V1__create_{{entity_snake}}_table.sql\`
- Flyway migration: CREATE TABLE with proper types, constraints, indexes
- Include audit columns: created_at, updated_at, created_by, updated_by

### 8. Docker & Helm

\`Dockerfile\`
- Multi-stage build: gradle build → eclipse-temurin:21-jre-alpine runtime
- Non-root user, health check, proper signal handling
- Labels for compliance tracking

\`charts/{{SERVICE_NAME}}/Chart.yaml\`
- Helm chart metadata

\`charts/{{SERVICE_NAME}}/values.yaml\`
- Replicas, resource limits, HPA config, environment variables, probes

### 9. OpenAPI Spec

\`src/main/resources/openapi/{{service-name}}-api.yaml\`
- OpenAPI 3.0 spec for all CRUD endpoints
- Request/response schemas matching DTOs
- Error response schemas
- Security scheme (Bearer JWT)

### 10. Tests

\`src/test/java/com/platform/{{service_package}}/domain/model/{{ENTITY_NAME}}Test.java\`
- Unit tests for domain model business logic
- Test all business rules and validation
- Test status transitions (valid and invalid)
- Use @ParameterizedTest where appropriate

\`src/test/java/com/platform/{{service_package}}/domain/service/{{ENTITY_NAME}}ServiceTest.java\`
- Unit tests with Mockito mocks for ports
- Test create, read, update, delete flows
- Test event publishing is called after persistence
- Test error cases (not found, validation failures, business rule violations)

\`src/test/java/com/platform/{{service_package}}/adapter/in/rest/{{ENTITY_NAME}}ControllerTest.java\`
- @WebMvcTest with MockMvc
- Test all endpoints with valid and invalid inputs
- Test HTTP status codes and response bodies
- Test validation error responses
- Mock the use case port

\`src/test/java/com/platform/{{service_package}}/adapter/out/persistence/{{ENTITY_NAME}}PersistenceAdapterTest.java\`
- @DataJpaTest with Testcontainers PostgreSQL
- Test save, find, delete operations
- Test unique constraint violations
- Test optimistic locking

\`src/test/java/com/platform/{{service_package}}/adapter/out/kafka/{{ENTITY_NAME}}KafkaEventPublisherTest.java\`
- Integration test with Testcontainers Kafka (or EmbeddedKafka)
- Verify events are published to correct topic
- Verify message key, headers, and payload structure

\`src/test/java/com/platform/{{service_package}}/integration/{{ENTITY_NAME}}CrudIntegrationTest.java\`
- @SpringBootTest with Testcontainers (PostgreSQL, Redis, Kafka)
- Full end-to-end CRUD flow via REST API
- Verify database state after operations
- Verify Kafka events are published
- Verify cache behavior (hit/miss/evict)

\`src/test/resources/application-test.yml\`
- Test profile configuration pointing to Testcontainers

### 11. Avro/JSON Schema

\`schema-registry/{{KAFKA_TOPIC}}/\` — one schema file per domain event
- JSON Schema or Avro schema for each event in {{DOMAIN_EVENTS}}
- Include schema version, required fields, field descriptions

## Code Quality Requirements

1. **Hexagonal purity**: Domain layer has ZERO framework imports (no Spring, no JPA, no Kafka)
2. **Max 300 lines per file** — split if necessary
3. **google-java-format** compliant
4. **All public methods have Javadoc** with @param, @return, @throws
5. **Audit logging**: Log create, update, delete operations with entity ID and user principal
6. **Correlation ID**: Thread through MDC for all log statements and Kafka headers
7. **No sensitive data in logs** (PCI DSS): mask account numbers, never log full card data
8. **Null safety**: Use Optional for nullable returns, @NonNull/@Nullable annotations
9. **Defensive coding**: Validate all inputs at adapter boundaries
10. **Idempotency**: Event publishing should include idempotency key

## Output Format

Generate each file with its full path as a header comment. Ensure all files compile together. Include TODO comments for any team-specific decisions (e.g., exact authorization roles, specific business rule thresholds).

Start with the domain layer (inside-out), then adapters, then configuration, then tests.
\`\`\`

---

## Usage Examples

### Example 1: Account Service

\`\`\`
Replace placeholders:
- {{SERVICE_NAME}} → account-service
- {{ENTITY_NAME}} → Account
- {{service_package}} → account
- {{entity-kebab}} → accounts
- {{entity_snake}} → account
- {{FIELDS}} → "id: UUID, accountNumber: String, holderName: String, balance: BigDecimal, currency: String(3), status: AccountStatus, tier: AccountTier, createdAt: Instant, updatedAt: Instant"
- {{BUSINESS_RULES}} → "Balance cannot go negative. Account number is system-generated, unique, format: ACC-XXXXXXXXXX. Status transitions: PENDING_VERIFICATION → ACTIVE → SUSPENDED → CLOSED. Only ACTIVE accounts can transact. Tier determines daily transaction limits."
- {{DOMAIN_EVENTS}} → "AccountCreated, AccountActivated, AccountSuspended, AccountClosed, BalanceUpdated"
- {{KAFKA_TOPIC}} → "account.events"
- {{CACHE_STRATEGY}} → "Cache by ID with 5-minute TTL, evict on any mutation"
\`\`\`

### Example 2: Transaction Service

\`\`\`
Replace placeholders:
- {{SERVICE_NAME}} → transaction-service
- {{ENTITY_NAME}} → Transaction
- {{service_package}} → transaction
- {{entity-kebab}} → transactions
- {{entity_snake}} → transaction
- {{FIELDS}} → "id: UUID, sourceAccountId`,

  'playbook/prompts/04/feature-implementation.md': `# Feature Implementation Prompt — Phase 04: Core Implementation

> **Copy-paste this prompt into Claude Code when implementing a new feature in a Spring Boot microservice.**
> Adjust the placeholders (wrapped in \`{{ }}\`) to match your Jira ticket and service context.

---

## Prompt

\`\`\`
You are implementing a feature for the spring-boot-microservices project. Follow our hexagonal architecture, TDD workflow, and Kafka-first inter-service communication patterns strictly.

## Feature Context

- **Jira Ticket**: {{ PAY-123 }}
- **Title**: {{ Brief feature title, e.g., "Process refund for completed payment" }}
- **Service**: {{ service name, e.g., payment-service }}
- **Module Path**: services/{{ payment-service }}
- **User Story**: As a {{ role }}, I want to {{ action }} so that {{ benefit }}.
- **Acceptance Criteria**:
  1. {{ AC1 }}
  2. {{ AC2 }}
  3. {{ AC3 }}

## Architecture Constraints

This project uses **Hexagonal Architecture (Ports & Adapters)**. Every feature must respect these layers:

\`\`\`
domain/           # Entities, Value Objects, Domain Events, Domain Services — ZERO framework imports
ports/
  inbound/        # Use case interfaces (driving ports)
  outbound/       # Repository interfaces, event publisher interfaces (driven ports)
adapters/
  inbound/
    rest/         # Spring @RestController — calls use case ports
    kafka/        # @KafkaListener consumers — calls use case ports
  outbound/
    persistence/  # Spring Data JPA repositories implementing outbound ports
    messaging/    # KafkaTemplate publishers implementing outbound ports
    cache/        # Redis adapters implementing outbound ports
\`\`\`

**Rules**:
- Domain layer has NO Spring annotations, NO JPA annotations, NO Kafka imports.
- Adapters depend on ports, never on each other.
- All inter-service communication goes through Kafka — no direct REST calls between services.
- JPA entities in the persistence adapter are separate from domain entities; use mappers.

## Implementation Steps — Follow This Order

### Step 1: Define the Domain

Start in \`services/{{ service }}/src/main/java/com/{{ org }}/{{ service }}/domain/\`:

1. **Domain Entity / Aggregate Root**: Model the core business object. Include validation in the constructor or factory method. No framework annotations.
2. **Value Objects**: Extract any typed values (e.g., \`Money\`, \`RefundId\`, \`TransactionReference\`).
3. **Domain Events**: Create event classes in \`domain/event/\` for anything that other services or this service's own read model needs to know about. Each event must have a corresponding schema in \`schema-registry/\`.
4. **Domain Service** (if needed): Business logic that doesn't belong to a single entity.

### Step 2: Define the Ports

In \`services/{{ service }}/src/main/java/com/{{ org }}/{{ service }}/ports/\`:

1. **Inbound Port (Use Case)**: Define an interface like \`{{ ProcessRefundUseCase }}\` with a command/request DTO and a result type. This is what adapters call.
2. **Outbound Ports**: Define repository interface (\`{{ RefundRepository }}\`), event publisher interface (\`{{ RefundEventPublisher }}\`), and any external service ports needed.

### Step 3: Write Tests FIRST (TDD Red Phase)

Follow our TDD workflow (see \`plugin/codeforge-spring-boot-microservices/commands/tdd.md\`):

1. **Unit Tests** (JUnit 5 + Mockito) for the use case / application service:
   - Mock all outbound ports.
   - Test happy path, validation failures, business rule violations, idempotency.
   - Location: \`src/test/java/com/{{ org }}/{{ service }}/application/\`

2. **Unit Tests** for domain entities and value objects:
   - Test invariants, state transitions, equality.
   - Location: \`src/test/java/com/{{ org }}/{{ service }}/domain/\`

3. **Integration Tests** (Testcontainers) for persistence and Kafka adapters:
   - Use \`@SpringBootTest\` with Testcontainers for PostgreSQL and Kafka.
   - Test that JPA adapter correctly persists and retrieves via the outbound port interface.
   - Test that Kafka publisher sends events with correct topic, key, and schema.
   - Test that Kafka consumer deserializes and routes to the correct use case.
   - Location: \`src/test/java/com/{{ org }}/{{ service }}/adapters/\`

All tests should **fail** at this point. Commit with message:
\`test({{ ticket }}): add failing tests for {{ feature description }}\`

### Step 4: Implement the Application Service (TDD Green Phase)

In \`services/{{ service }}/src/main/java/com/{{ org }}/{{ service }}/application/\`:

1. Create \`{{ ProcessRefundService }}\` implementing the inbound port.
2. Inject outbound ports via constructor injection (no field injection).
3. Implement the business flow:
   - Validate the command.
   - Load the aggregate from the repository port.
   - Execute domain logic on the aggregate.
   - Persist via the repository port.
   - Publish domain event(s) via the event publisher port.
4. Add \`@Transactional\` on the service method. Use \`@Transactional(readOnly = true)\` for queries.
5. Handle idempotency — check if this operation was already processed.

### Step 5: Implement the Adapters

**REST Adapter** (\`adapters/inbound/rest/\`):
- \`@RestController\` with \`@RequestMapping("/api/v1/{{ resource }}")\`
- Use \`@Valid\` on request DTOs. Map to use case command. Call the inbound port.
- Return proper HTTP status codes (201 for creation, 200 for queries, 409 for conflicts).
- Add OpenAPI annotations (\`@Operation\`, \`@ApiResponse\`).
- Add endpoint to the service's OpenAPI spec in \`services/{{ service }}/src/main/resources/openapi/\`.

**Kafka Consumer Adapter** (\`adapters/inbound/kafka/\`):
- \`@KafkaListener(topics = "{{ source-service }}.{{ event-name }}", groupId = "{{ service }}-{{ consumer-group }}")\`
- Deserialize the event using the schema from \`schema-registry/\`.
- Map to use case command. Call the inbound port.
- Handle deserialization errors and poison pills with a dead-letter topic.
- Make consumption idempotent using event ID.

**Persistence Adapter** (\`adapters/outbound/persistence/\`):
- JPA \`@Entity\` class separate from domain entity. Use \`{{ RefundJpaEntity }}\`.
- Spring Data \`JpaRepository\` interface.
- Adapter class implementing the outbound port, using the JPA repo and a mapper.
- Use \`@Repository\` on the adapter.

**Kafka Publisher Adapter** (\`adapters/outbound/messaging/\`):
- Implement the event publisher outbound port.
- Use \`KafkaTemplate<String, {{ EventType }}>\`.
- Topic naming: \`{{ service }}.{{ event-name }}\` (e.g., \`payment-service.refund-processed\`).
- Use the aggregate ID as the Kafka message key for partition ordering.
- Publish within the same transaction boundary (use transactional outbox pattern if required).

**Redis Cache Adapter** (\`adapters/outbound/cache/\`, if applicable):
- Implement caching outbound port using \`RedisTemplate\` or \`@Cacheable\`.
- Set appropriate TTL. Use cache key prefixed with service name.

### Step 6: Verify All Tests Pass (TDD Green)

Run:
\`\`\`bash
./gradlew :services:{{ service }}:test
./gradlew :services:{{ service }}:integrationTest
\`\`\`

All tests from Step 3 must now pass. Fix any failures. Commit:
\`feat({{ ticket }}): implement {{ feature description }}\`

### Step 7: Refactor (TDD Refactor Phase)

- Extract common patterns into shared libraries under \`shared/\` if reusable.
- Ensure no class exceeds 300 lines.
- Run Checkstyle and ktlint: \`./gradlew :services:{{ service }}:checkstyleMain :services:{{ service }}:checkstyleTest\`
- Run SpotBugs: \`./gradlew :services:{{ service }}:spotbugsMain\`
- Verify coverage: \`./gradlew :services:{{ service }}:jacocoTestReport\` — must be ≥ 80%.

Commit: \`refactor({{ ticket }}): clean up {{ feature description }}\`

### Step 8: Schema Registry & Event Contract

1. Add or update the event schema in \`schema-registry/{{ service }}/{{ event-name }}.avsc\` (or \`.json\` for JSON Schema).
2. Ensure backward compatibility — new fields must have defaults, no removed fields.
3. If this is a new event, add a contract test in \`tests/contracts/\` using Pact:
   - Producer side: verify the service publishes events matching the schema.
   - Consumer side: verify consuming services can handle the event.

Run contract tests: \`./gradlew :tests:contracts:test\`

Commit: \`feat({{ ticket }}): add event schema for {{ event-name }}\`

### Step 9: Configuration & Profiles

Add any new configuration to the appropriate Spring Profile files:
- \`application.yml\` — defaults
- \`application-local.yml\` — local dev (Docker Compose Kafka/Postgres/Redis)
- \`application-staging.yml\` — staging environment
- \`application-production.yml\` — production (references AWS SSM/Secrets Manager)

**Never commit secrets or credentials.** Use \`\${ENV_VAR}\` placeholders for sensitive values.

### Step 10: Update Helm Chart (if needed)

If the feature requires new environment variables, config maps, or secrets:
1. Update \`charts/{{ service }}/values.yaml\`
2. Update \`charts/{{ service }}/templates/deployment.yaml\`
3. Add any new Kafka topics to \`infrastructure/terraform/modules/kafka/topics.tf\`

### Step 11: Documentation

1. Update the service README at \`services/{{ service }}/README.md\`.
2. If this changes the API, regenerate the OpenAPI spec.
3. If this introduces a new architectural pattern, create an ADR in \`docs/adr/\`.
4. Add a runbook entry in \`docs/runbooks/\` if the feature has operational implications.

## Output Checklist

Before marking this feature complete, verify:

- [ ] Domain layer has zero framework imports
- [ ] All tests pass (\`./gradlew :services:{{ service }}:check\`)
- [ ] Code coverage ≥ 80% (\`./gradlew :services:{{ service }}:jacocoTestReport\`)
- [ ] Checkstyle clean (\`./gradlew :services:{{ service }}:checkstyleMain\`)
- [ ] SpotBugs clean (\`./gradlew :services:{{ service }}:spotbugsMain\`)
- [ ] No direct REST calls to other services — Kafka only
- [ ] Event schema added/updated in \`schema-registry/\`
- [ ] Contract tests pass (\`./gradlew :tests:contracts:test\`)
- [ ] No secrets in config files — only \`\${ENV_VAR}\` references
- [ ] No file exceeds 300 lines
- [ ] Conventional commit messages on all commits
- [ ] Branch named \`feat/{{ ticket }}-{{ short-desc }}\`
- [ ] OpenAPI spec updated if REST endpoints changed
- [ ] PCI DSS: no PAN/CVV logged or stored outside tokenized form
- [ ] SOC 2: audit trail events published for state-changing operations

## Compliance Reminders (SOC 2 / PCI DSS)

- **Logging**: Never log PII, PAN, CVV, or authentication tokens. Use structured logging with correlation IDs from distributed tracing (Jaeger).
- **Audit Events**: Every state-changing operation must publish an audit domain event with: actor, action, resource, timestamp, correlation ID.
- **Input Validation**: Validate all inputs at the REST adapter AND at the domain layer. Use \`@Valid\` with Bean Validation and domain invariant checks.
- **Authentication/Authorization**: REST endpoints must be secured with Spring Security. Use \`@PreAuthorize\` for role-based access. Token validation at the API gateway.
- **Data Encryption**: Sensitive fields encrypted at rest (JPA \`@Convert\` with encryption converter). TLS in transit (enforced at infrastructure level).
- **Dependency Security**: Run \`./gradlew dependencyCheckAnalyze\` — no critical/high CVEs allowed.

## Example Commit Sequence

\`\`\`
test(PAY-123): add failing tests for refund processing
feat(PAY-123): implement refund processing domain and ports
feat(PAY-123): implement refund REST and Kafka adapters
feat(PAY-123): add refund-processed event schema
refactor(PAY-123): extract money value object to shared library
docs(PAY-123): update payment-service README and OpenAPI spec
\`\`\`

Now implement the feature following these steps. Start with Step 1 (domain modeling) and proceed sequentially. Ask me clarifying questions if any acceptance criteria are ambiguous before writing code.
\`\`\`

---

## Usage Notes

- Replace all \`{{ }}\` placeholders with your actual values before pasting.
- If the feature is **consumer-only** (reacting to another service's event), skip the REST adapter in Step 5 and focus on the Kafka consumer adapter.
- If the feature is **query-only** (no state change), skip event publishing and use \`@Transactional(readOnly = true)\`.
- For features touching \`**/security/**\` or \`**/auth/**\` paths, request an additional security-focused review per CODEOWNERS policy.
- Reference the TDD guide agent for deeper TDD workflow: see \`plugin/codeforge-spring-boot-microservices/agents/tdd-guide.md\`.
- Reference the architect agent for design questions: see \`plugin/codeforge-spring-boot-microservices/agents/architect.md\`.
- Run \`./playbook/codeforge-phase.sh current\` to confirm you're in Phase 04 before starting.`,

  'playbook/prompts/05/integration-adapter.md': `# Integration Adapter Implementation — Phase 05

> Copy-paste this prompt into Claude Code when you need to implement or refactor an integration adapter (inbound or outbound) following Hexagonal Architecture in a Spring Boot microservice.

---

## Prompt

\`\`\`
I need you to implement an integration adapter for the following specification. Follow our Hexagonal Architecture strictly — adapters live in the \`adapter\` package and depend on port interfaces defined in the \`domain\` package. No domain logic in adapters.

## Context

- **Service**: [SERVICE_NAME, e.g., payment-service]
- **Adapter Type**: [INBOUND | OUTBOUND]
- **Integration Target**: [KAFKA_CONSUMER | KAFKA_PRODUCER | REST_CLIENT | DATABASE | REDIS_CACHE | EXTERNAL_API]
- **Port Interface**: [EXISTING_PORT or "needs creation", e.g., PaymentEventPublisher]
- **Related Domain Events**: [EVENT_NAMES, e.g., PaymentInitiated, PaymentCompleted, PaymentFailed]
- **Jira Ticket**: [TICKET_ID, e.g., PAY-456]

## Requirements

[Describe what this adapter does. Examples:]
- Consumes \`order.confirmed\` events from Kafka topic \`order-events\` and triggers payment processing
- Publishes \`payment.completed\` events to Kafka topic \`payment-events\` after successful payment
- Calls external fraud detection API and maps response to domain model
- Caches payment status in Redis with 5-minute TTL

## Adapter Implementation Rules

### Hexagonal Architecture Compliance

1. **Package structure** — place adapter code in:
   \`\`\`
   services/[service-name]/src/main/java/com/company/[service]/adapter/[in|out]/[integration]/
   \`\`\`
2. **Port interface** — must exist in:
   \`\`\`
   services/[service-name]/src/main/java/com/company/[service]/domain/port/[in|out]/
   \`\`\`
3. The adapter class MUST implement the port interface (outbound) or call a use case port (inbound)
4. Domain objects cross the boundary — never JPA entities, Kafka records, or DTOs
5. Mapping between external representations and domain objects happens INSIDE the adapter
6. Adapter classes are Spring \`@Component\` / \`@Service\` / \`@Repository\` beans

### Kafka Adapter Specifics

If the adapter involves Kafka:

**Consumer (Inbound Adapter):**
- Use \`@KafkaListener\` with explicit \`topics\`, \`groupId\`, and \`containerFactory\`
- Consumer group naming: \`[service-name]-[purpose]-cg\` (e.g., \`payment-service-order-events-cg\`)
- Deserialize using the schema from \`schema-registry/\` — reference the exact Avro/JSON schema
- Implement idempotency: check event ID against a processed-events table before handling
- Use \`@Retryable\` with exponential backoff (initial=1s, multiplier=2, maxAttempts=3)
- Configure a dead-letter topic: \`[original-topic].DLT\`
- Log event receipt at INFO level with correlation ID, event type, and aggregate ID
- Call the inbound use case port — never perform domain logic directly
- Handle deserialization errors with an \`ErrorHandler\` that routes to DLT

\`\`\`java
// Example structure expected:
@Component
@Slf4j
public class OrderEventKafkaConsumer {

    private final ProcessPaymentUseCase processPaymentUseCase;
    private final IdempotencyChecker idempotencyChecker;

    @KafkaListener(
        topics = "\${kafka.topics.order-events}",
        groupId = "\${kafka.consumer-groups.order-events}",
        containerFactory = "orderEventListenerContainerFactory"
    )
    public void consume(ConsumerRecord<String, OrderConfirmedEvent> record) {
        // 1. Extract correlation ID from headers
        // 2. Check idempotency
        // 3. Map to domain command
        // 4. Invoke use case port
        // 5. Log outcome
    }
}
\`\`\`

**Producer (Outbound Adapter):**
- Implement the outbound port interface (e.g., \`PaymentEventPublisher\`)
- Use \`KafkaTemplate<String, T>\` — inject via constructor
- Partition key: use aggregate ID (e.g., \`paymentId\`) for ordering guarantees
- Set Kafka headers: \`correlation-id\`, \`event-type\`, \`source-service\`, \`timestamp\`, \`schema-version\`
- Serialize using the schema from \`schema-registry/\`
- Use \`CompletableFuture\` / callback for send confirmation — log success at INFO, failure at ERROR
- Implement the Transactional Outbox pattern if strong consistency is required:
  - Write event to \`outbox_events\` table in the same transaction as the domain state change
  - A separate scheduled poller or CDC mechanism publishes from outbox to Kafka

\`\`\`java
// Example structure expected:
@Component
@Slf4j
public class PaymentEventKafkaPublisher implements PaymentEventPublisher {

    private final KafkaTemplate<String, Object> kafkaTemplate;
    private final EventMapper eventMapper;

    @Override
    public void publish(PaymentCompleted event) {
        // 1. Map domain event to Kafka event schema
        // 2. Build ProducerRecord with headers
        // 3. Send with callback
        // 4. Log with correlation ID
    }
}
\`\`\`

### REST Client Adapter Specifics (Outbound)

If calling an external API:
- Use Spring \`WebClient\` (reactive) or \`RestClient\` (Spring Boot 3.2 declarative)
- Implement circuit breaker with Resilience4j (\`@CircuitBreaker\`, fallback method)
- Set timeouts: connect=2s, read=5s (configurable via Spring Profiles)
- Map external DTOs to domain objects in a dedicated \`Mapper\` class
- Never expose external API models beyond the adapter boundary
- Log request/response at DEBUG level, errors at ERROR level
- Mask any PCI DSS sensitive data (card numbers, CVVs) in logs — SOC 2 compliance

### Redis Cache Adapter Specifics (Outbound)

If using Redis:
- Use \`RedisTemplate\` or \`@Cacheable\` / \`@CachePut\` / \`@CacheEvict\` annotations
- Key naming: \`[service]:[entity]:[id]\` (e.g., \`payment:status:pay-123\`)
- Set explicit TTL — never cache indefinitely
- Implement cache-aside pattern: check cache → miss → load from source → populate cache
- Handle Redis connection failures gracefully — degrade to direct DB query, never fail the request
- No PCI DSS cardholder data in Redis unless encrypted at rest and in transit

### Database Adapter Specifics (Outbound)

If implementing a persistence adapter:
- Use Spring Data JPA repository
- JPA entities live in the adapter package, NOT in domain
- Map between JPA entities and domain objects using a dedicated \`PersistenceMapper\`
- Repository interface in adapter implements the domain's outbound port
- Use \`@Transactional\` at the adapter level, not in domain services

## Configuration

Provide the corresponding Spring configuration in \`application.yml\` format for the relevant Spring Profile:
- \`application.yml\` — shared defaults
- \`application-local.yml\` — local Docker Compose
- \`application-staging.yml\` — staging overrides (use AWS MSK endpoints, ElastiCache, RDS)

Include:
- Kafka bootstrap servers, topic names, consumer group IDs, serializer/deserializer config
- Redis host, port, TTL settings
- External API base URLs, timeouts
- Resilience4j circuit breaker settings

## Testing Requirements

Generate the following tests:

1. **Unit test** for the adapter:
   - Mock external dependencies (KafkaTemplate, WebClient, RedisTemplate, JPA Repository)
   - Verify correct mapping from external to domain objects
   - Verify correct headers/keys for Kafka messages
   - Verify idempotency logic (for consumers)
   - Verify circuit breaker fallback (for REST clients)
   - Use JUnit 5 + Mockito
   - Place in: \`services/[service-name]/src/test/java/.../adapter/[in|out]/[integration]/\`

2. **Integration test** using Testcontainers:
   - For Kafka adapters: use \`@EmbeddedKafka\` or Testcontainers Kafka module
   - For Redis adapters: use Testcontainers Redis module
   - For DB adapters: use Testcontainers PostgreSQL module
   - For external APIs: use WireMock
   - Verify end-to-end flow through the adapter
   - Place in: \`services/[service-name]/src/test/java/.../adapter/[in|out]/[integration]/\`
   - Annotate with \`@IntegrationTest\` (custom annotation that sets Spring Profile to \`test\`)

3. **Contract test** (if Kafka producer):
   - Generate a Pact contract for the event schema
   - Verify against the schema in \`schema-registry/\`
   - Place in: \`tests/contract/\`

## Security & Compliance Checklist

Before finalizing, verify:
- [ ] No PCI DSS cardholder data (PAN, CVV, PIN) logged or cached unencrypted
- [ ] Correlation IDs propagated through all adapter boundaries
- [ ] Sensitive fields masked in log output using custom \`LogMasker\`
- [ ] Kafka connections use SASL/SSL in staging and production profiles
- [ ] Redis connections use TLS in staging and production profiles
- [ ] External API credentials stored in AWS Secrets Manager, referenced via Spring config
- [ ] No secrets in \`application.yml\` — use \`\${VARIABLE}\` placeholders
- [ ] Adapter does not bypass domain validation — all input validated at domain layer

## Output Structure

Provide the following files:

1. Port interface (if new): \`domain/port/[in|out]/[PortName].java\`
2. Adapter implementation: \`adapter/[in|out]/[integration]/[AdapterName].java\`
3. Mapper class: \`adapter/[in|out]/[integration]/[MapperName].java\`
4. Configuration class (if needed): \`adapter/[in|out]/[integration]/[ConfigName].java\`
5. Configuration properties: \`src/main/resources/application.yml\` additions
6. Unit test: \`src/test/java/.../[AdapterName]Test.java\`
7. Integration test: \`src/test/java/.../[AdapterName]IntegrationTest.java\`
8. Contract test (if applicable): \`tests/contract/[ContractName]Test.java\`
9. Event schema (if new Kafka event): \`schema-registry/[topic-name]/[EventName].avsc\`

Use conventional commits for any file changes. Mark all generated code with:
\`\`\`java
// Generated by Claude Code — Ticket: [TICKET_ID]
\`\`\`

Ensure all files are under 300 lines. Split if necessary.
\`\`\`

---

## Usage Notes

- Replace all \`[PLACEHOLDERS]\` with actual values before pasting
- For multiple adapters in the same service, run this prompt once per adapter
- After generation, run \`./gradlew :services:[service-name]:test\` to validate
- Run \`./gradlew :services:[service-name]:checkstyleMain\` for style compliance
- Cross-reference with \`playbook/phases/05-integration-hardening.md\` for phase checklist
- Verify Kafka topic names match those in \`schema-registry/\` and \`infrastructure/terraform/modules/kafka/\``,

  'playbook/prompts/05/observability-setup.md': `# Observability Setup — Phase 05 Integration & Hardening

## Copy-Pasteable Prompt for Claude Code

\`\`\`
You are setting up comprehensive observability for our Spring Boot microservices platform. This is a financial services system (SOC 2 / PCI DSS compliant) using Spring Boot 3.2, Java 21, Kafka event streaming, PostgreSQL per-service databases, and Redis caching, deployed on AWS EKS via Helm charts.

## Project Structure

\`\`\`
services/              # order-service, payment-service, user-service, notification-service
shared/                # Shared libraries (domain events, DTOs, common utilities)
gateway/               # Spring Cloud Gateway
charts/                # Helm charts per service
infrastructure/        # Terraform IaC
\`\`\`

## Observability Stack

- **Metrics**: Micrometer → Prometheus → Grafana
- **Distributed Tracing**: OpenTelemetry → Jaeger
- **Centralized Logging**: Logback → Filebeat → Elasticsearch → Kibana (ELK)
- **Health Checks**: Spring Boot Actuator
- **Alerting**: Prometheus Alertmanager → Slack / PagerDuty

## Task 1: Shared Observability Library

Create \`shared/observability/\` as a Gradle module that all services depend on.

### 1a. Gradle Dependencies (\`shared/observability/build.gradle.kts\`)

Include:
- \`io.micrometer:micrometer-registry-prometheus\`
- \`io.opentelemetry:opentelemetry-api\`
- \`io.opentelemetry.instrumentation:opentelemetry-instrumentation-annotations\`
- \`io.micrometer:micrometer-tracing-bridge-otel\`
- \`io.opentelemetry:opentelemetry-exporter-otlp\`
- \`net.logstash.logback:logstash-logback-encoder\` (for structured JSON logging)

### 1b. Auto-Configuration Class

Create \`ObservabilityAutoConfiguration.java\` in \`com.platform.shared.observability\`:
- Register custom \`MeterRegistryCustomizer<MeterRegistry>\` that adds common tags: \`service.name\`, \`service.version\`, \`environment\`, \`region\`
- Register \`ObservationHandler\` for Kafka consumer/producer spans
- Configure \`SpanExporter\` bean pointing to the OTLP collector endpoint (configurable via \`observability.otlp.endpoint\`)
- Register \`spring.factories\` or \`AutoConfiguration.imports\` for Spring Boot 3.2 auto-configuration

### 1c. Kafka Observability

Create \`KafkaObservabilityConfig.java\`:
- Configure \`ProducerInterceptor\` that propagates trace context (W3C traceparent) into Kafka headers
- Configure \`ConsumerInterceptor\` that extracts trace context from Kafka headers and creates child spans
- Add custom metrics:
  - \`kafka.producer.events.published\` (counter, tags: topic, event_type, service)
  - \`kafka.consumer.events.consumed\` (counter, tags: topic, event_type, consumer_group, service)
  - \`kafka.consumer.events.failed\` (counter, tags: topic, event_type, consumer_group, error_class)
  - \`kafka.consumer.lag\` (gauge, tags: topic, consumer_group)
  - \`kafka.consumer.processing.duration\` (timer, tags: topic, event_type)

### 1d. Domain Event Observability Aspect

Create \`DomainEventObservabilityAspect.java\`:
- AOP aspect that intercepts all \`@KafkaListener\` methods
- Automatically starts an Observation (Micrometer Observation API) with:
  - Span name: \`{service}.consume.{eventType}\`
  - Low-cardinality tags: event_type, topic, consumer_group
  - High-cardinality tags: event_id, correlation_id, trace_id
- Records processing duration and success/failure outcome
- Logs structured event: \`{"event": "domain_event_consumed", "event_type": "...", "topic": "...", "duration_ms": ..., "status": "success|failure"}\`

## Task 2: Structured Logging Configuration

### 2a. Logback Configuration (\`shared/observability/src/main/resources/logback-defaults.xml\`)

Create a shared Logback include file:
- Console appender for local development (human-readable, colored)
- JSON appender for production using \`LogstashEncoder\`:
  - Include fields: timestamp, level, logger, message, thread, service_name, trace_id, span_id, correlation_id, environment
  - For PCI DSS: configure field masking for patterns matching card numbers (regex \`\\b\\d{13,19}\\b\`), SSNs, emails in log messages
- Use Spring Profile to switch: \`local\` → console, \`staging|production\` → JSON
- MDC fields automatically populated: \`traceId\`, \`spanId\`, \`correlationId\`, \`userId\`, \`requestId\`

### 2b. Logging Filter

Create \`CorrelationIdFilter.java\` (Spring \`OncePerRequestFilter\`):
- Extract \`X-Correlation-ID\` header from incoming requests (or generate UUID if absent)
- Set into MDC: \`correlationId\`, \`requestId\`, \`userId\` (from Spring Security context)
- Propagate \`X-Correlation-ID\` in outgoing Kafka messages via a shared header utility
- Clear MDC on request completion

### 2c. Audit Logging

Create \`AuditLogger.java\` for SOC 2 / PCI DSS compliance:
- Structured audit log entries with fields: \`timestamp\`, \`actor\` (user ID or service), \`action\`, \`resource\`, \`resource_id\`, \`outcome\` (success/failure), \`ip_address\`, \`correlation_id\`, \`details\`
- Separate Logback appender writing to \`audit.log\` (or separate Elasticsearch index \`audit-*\`)
- Annotation \`@Audited(action = "PAYMENT_INITIATED", resource = "Payment")\` that triggers audit logging via AOP
- All authentication events (login, logout, failed login, token refresh) must be audit-logged
- All data access to PCI-scoped entities must be audit-logged

## Task 3: Spring Boot Actuator Configuration

### 3a. Actuator Properties (\`shared/observability/src/main/resources/observability-defaults.yml\`)

Create a shared Spring config that services import via \`spring.config.import\`:

\`\`\`yaml
management:
  endpoints:
    web:
      exposure:
        include: health,info,prometheus,metrics,env,loggers,mappings
      base-path: /internal/actuator
  endpoint:
    health:
      show-details: when_authorized
      probes:
        enabled: true
      group:
        readiness:
          include: readinessState,db,redis,kafka
        liveness:
          include: livenessState,diskSpace
    prometheus:
      enabled: true
  metrics:
    tags:
      application: \${spring.application.name}
      environment: \${ENVIRONMENT:local}
    distribution:
      percentiles-histogram:
        http.server.requests: true
        kafka.consumer.processing.duration: true
      slo:
        http.server.requests: 50ms,100ms,250ms,500ms,1s,5s
  tracing:
    sampling:
      probability: \${TRACING_SAMPLE_RATE:1.0}
  observations:
    key-values:
      service.name: \${spring.application.name}
\`\`\`

### 3b. Custom Health Indicators

Create health indicators in the shared library:

**KafkaHealthIndicator.java**: Check Kafka broker connectivity and topic availability. Report \`DOWN\` if the service cannot reach its required topics. Include details: broker count, topic list, consumer group lag.

**SchemaRegistryHealthIndicator.java**: Check schema registry connectivity. Report \`DOWN\` if schemas cannot be fetched.

**DependencyHealthIndicator.java**: Generic health indicator that checks downstream service health via their \`/internal/actuator/health/liveness\` endpoints (for the API gateway only — services do NOT call each other directly).

### 3c. Actuator Security

Create \`ActuatorSecurityConfig.java\`:
- \`/internal/actuator/health/liveness\` and \`/internal/actuator/health/readiness\` — permit all (Kubernetes probes)
- \`/internal/actuator/prometheus\` — permit from internal CIDR only (10.0.0.0/8, 172.16.0.0/12)
- All other actuator endpoints — require \`ROLE_OPS\` or \`ROLE_ADMIN\`
- Actuator endpoints must NOT be exposed on the public-facing port in production

## Task 4: Prometheus Metrics & Alerting

### 4a. Custom Business Metrics

Create \`BusinessMetricsService.java\` in each relevant service:

**payment-service metrics:**
- \`payment.transactions.total\` (counter: status=[success,failed,pending], payment_method, currency)
- \`payment.transactions.amount\` (distribution summary: payment_method, currency)
- \`payment.processing.duration\` (timer: payment_method, status)
- \`payment.fraud.checks\` (counter: outcome=[pass,flag,block])

**order-service metrics:**
- \`order.created.total\` (counter: status, order_type)
- \`order.fulfillment.duration\` (timer: order_type)
- \`order.value\` (distribution summary: order_type, currency)

**user-service metrics:**
- \`user.registrations.total\` (counter: source, status)
- \`user.authentication.total\` (counter: method=[password,oauth,mfa], outcome=[success,failure])
- \`user.authentication.duration\` (timer: method)

### 4b. Prometheus Alert Rules (\`infrastructure/monitoring/prometheus-alerts.yml\`)

Define alert rules:

\`\`\`yaml
groups:
  - name: service-health
    rules:
      - alert: ServiceDown
        expr: up{job=~".*-service"} == 0
        for: 1m
        labels:
          severity: critical
          compliance: soc2
        annotations:
          summary: "Service {{ $labels.job }} is down"
          runbook_url: "https://docs.internal/runbooks/service-down"

      - alert: HighErrorRate
        expr: rate(http_server_requests_seconds_count{status=~"5.."}[5m]) / rate(http_server_requests_seconds_count[5m]) > 0.05
        for: 5m
        labels:
          severity: warning
        annotations:
          summary: "High 5xx error rate on {{ $labels.application }}"

      - alert: HighLatencyP99
        expr: histogram_quantile(0.99, rate(http_server_requests_seconds_bucket[5m])) > 2
        for: 5m
        labels:
          severity: warning

      - alert: KafkaConsumerLagHigh
        expr: kafka_consumer_lag > 10000
        for: 10m
        labels:
          severity: warning

      - alert: KafkaConsumerLagCritical
        expr: kafka_consumer_lag > 100000
        for: 5m
        labels:
          severity: critical

      - alert: PaymentFailureRateHigh
        expr: rate(payment_transactions_total{status="failed"}[5m]) / rate(payment_transactions_total[5m]) > 0.02
        for: 5m
        labels:
          severity: critical
          compliance: pci_dss

      - alert: AuthenticationFailureSpike
        expr: rate(user_authentication_total{outcome="failure"}[5m]) > 50
        for: 2m
        labels:
          severity: critical
          compliance: soc2
        annotations:
          summary: "Possible brute force attack detected"

      - alert: DatabaseConnectionPoolExhausted
        expr: hikaricp_connections_active / hikaricp_connections_max > 0.9
        for: 5m
        labels:
          severity: warning
\`\`\`

### 4c. Alertmanager Configuration (\`infrastructure/monitoring/alertmanager.yml\`)

Route critical alerts to PagerDuty, warnings to Slack \`#platform-alerts\`, compliance-tagged alerts additionally to \`#compliance-alerts\`.

## Task 5: Grafana Dashboards

### 5a. Service Overview Dashboard (\`infrastructure/monitoring/dashboards/service-overview.json\`)

Create a Grafana dashboard JSON (provisioned via Helm) with panels:
- Request rate (by service, status code)
- P50/P95/P99 latency (by service)
- Error rate (by service)
- Active instances (by service)
- JVM heap usage (by service)
- GC pause duration (by service)
- HikariCP connection pool usage (by service)
- Kafka consumer lag (by consumer group, topic)
- Kafka event throughput (produced vs consumed per topic)

### 5b. Payment Service Dashboard

Specific panels:
- Transaction volume (by status, payment method)
- Transaction value distribution
- Processing latency (by payment method)
- Fraud check outcomes
- Failed payment breakdown (by error code)

### 5c. Kafka Dashboard

Specific panels:
- Messages produced/consumed per topic per minute
- Consumer group lag per partition
- End-to-end event latency (produce timestamp to consume timestamp)
- Dead letter queue message count
- Schema registry compatibility check failures

## Task 6: Distributed Tracing Configuration

### 6a. OpenTelemetry Collector Config (\`infrastructure/monitoring/otel-collector.yml\`)

Configure the OTEL collector deployed as a DaemonSet:
- Receivers: OTLP (gRPC on 4317, HTTP on 4318)
- Processors: batch, memory_limiter, tail_sampling (sample 100% of errors, 10% of successful requests in production)
- Exporters: Jaeger (for trace storage), Prometheus (for span metrics)
- Extensions: health_check, zpages

### 6b. Trace Context Propagation

Ensure trace context flows through:
1. HTTP request → API Gateway (Spring Cloud Gateway adds trace headers)
2. Gateway → downstream service (trace headers forwarded)
3. Service → Kafka producer (trace context injected into Kafka headers as \`traceparent\`, \`tracestate\`)
4. Kafka consumer → service (trace context extracted, child span created)
5. Service → PostgreSQL (JDBC instrumented via OpenTelemetry Java agent)
6. Service → Redis (Lettuce instrumented via OpenTelemetry Java agent)

Create \`TraceContextKafkaHeaderMapper.java\` in shared library to handle steps 3-4.

## Task 7: Kubernetes Probes & Service Mesh Observability

### 7a. Helm Chart Values for Observability

Add to each service's Helm chart \`values.yaml\`:

\`\`\`yaml
observability:
  prometheus:
    enabled: true
    port: 8081
    path: /internal/actuator/prometheus
  tracing:
    enabled: true
    sampleRate: "0.1"  # 10% in production
    otlpEndpoint: "http://otel-collector.monitoring:4317"
  logging:
    level: INFO
    format: json

livenessProbe:
  httpGet:
    path: /internal/actuator/health/liveness
    port: management
  initialDelaySeconds: 30
  periodSeconds: 10
  failureThreshold: 3

readinessProbe:
  httpGet:
    path: /internal/actuator/health/readiness
    port: management
  initialDelaySeconds: 15
  periodSeconds: 5
  failureThreshold: 3

podAnnotations:
  prometheus.io/scrape: "true"
  prometheus.io/port: "8081"
  prometheus.io/path: "/internal/actuator/prometheus"
\`\`\`

### 7b. Separate Management Port

Configure each service to expose actuator on a separate port (8081) that is NOT routed through the ALB/Ingress:

\`\`\`yaml
server:
  port: 8080
management:
  server:
    port: 8081
\`\`\`

## Constraints

- Follow hexagonal architecture — observability config belongs in infrastructure layer
- All classes under 300 lines; split into focused components
- Use \`@Configuration\` classes, not XML config
- All custom metrics must use Micrometer's \`MeterRegistry\`, not direct Prometheus client
- PCI DSS: Never log full card numbers, CVVs, or sensitive auth tokens — even at DEBUG level
- SOC 2: All access to actuator endpoints must be logged
- Use Spring Profiles: \`local\` (console logs, 100% trace sampling), \`staging\` (JSON logs, 50% sampling), \`production\` (JSON logs, 10% sampling, PagerDu`,

  'playbook/prompts/05/security-hardening.md': `# Security Hardening — Phase 05 Prompt

> Copy-paste this prompt into Claude Code to perform comprehensive security hardening across your Spring Boot microservices platform.

---

## Prompt

\`\`\`
You are a security engineer hardening a Spring Boot 3.2 / Java 21 microservices platform for SOC 2 and PCI DSS compliance in a financial services environment. The platform uses Kafka for inter-service communication, PostgreSQL per-service databases, Redis for caching/sessions, and deploys to AWS EKS via Helm charts.

## Project Structure

- services/           — individual microservices (order-service, payment-service, user-service, etc.)
- shared/             — shared libraries (domain events, DTOs, common utilities)
- gateway/            — Spring Cloud Gateway (API gateway)
- infrastructure/     — Terraform IaC, Kubernetes manifests
- charts/             — Helm charts per service
- schema-registry/    — Avro/JSON schemas for Kafka events

## Hardening Scope

Perform the following security hardening tasks. For each task, explain the threat it mitigates, implement the fix, and reference the relevant compliance control (SOC 2 CC or PCI DSS requirement).

### 1. Spring Security Configuration Hardening

Review and harden the Spring Security filter chain for each microservice and the API gateway:

- Enforce HTTPS-only with HSTS headers (max-age=31536000, includeSubDomains, preload)
- Disable unnecessary HTTP methods (TRACE, OPTIONS where not needed)
- Add Content-Security-Policy, X-Content-Type-Options, X-Frame-Options, Referrer-Policy headers
- Configure CORS with explicit allowed origins — no wildcards in production
- Implement rate limiting at the gateway level (use Spring Cloud Gateway filters or Bucket4j)
- Ensure CSRF protection is properly configured (disabled only for stateless API endpoints with JWT)
- Validate that actuator endpoints are secured — only /actuator/health exposed publicly, all others require ADMIN role

Create or update: \`shared/security-common/src/main/java/com/company/shared/security/SecurityHardeningConfig.java\`

\`\`\`java
@Configuration
@EnableWebSecurity
public class SecurityHardeningConfig {
    // Implement security headers, CORS, actuator lockdown
    // Reference: PCI DSS Req 6.5.x, SOC 2 CC6.1
}
\`\`\`

### 2. Kafka Security Configuration

Harden all Kafka producer/consumer configurations across services:

- Enable SASL_SSL authentication (SCRAM-SHA-512) for all Kafka connections
- Configure TLS 1.2+ for Kafka broker communication
- Implement ACLs — each service should only produce to its own topics and consume from explicitly allowed topics
- Enable schema validation at the producer level — reject messages that don't match the registered Avro/JSON schema
- Add a dead-letter topic (DLT) strategy for each consumer with proper error handling
- Ensure consumer group IDs follow the pattern: \`{service-name}-{topic}-consumer\`
- Log Kafka authentication failures to the centralized audit log

Create or update the shared Kafka security configuration:

\`\`\`java
// shared/kafka-common/src/main/java/com/company/shared/kafka/KafkaSecurityConfig.java
@Configuration
public class KafkaSecurityConfig {
    // SASL_SSL, TLS, schema validation, DLT configuration
    // Reference: PCI DSS Req 4.1 (encryption in transit), SOC 2 CC6.6
}
\`\`\`

Provide the corresponding \`application-production.yml\` Kafka properties block.

### 3. Database Security

Harden PostgreSQL connectivity and data protection:

- Enforce SSL connections to PostgreSQL (sslmode=verify-full)
- Use separate database credentials per service — no shared database users
- Implement connection pool hardening (HikariCP: max lifetime, leak detection, connection timeout)
- Add field-level encryption for PII fields (card numbers, SSNs, email addresses) using AES-256-GCM
- Create a \`@EncryptedField\` annotation and JPA AttributeConverter for transparent encryption/decryption
- Ensure encryption keys are loaded from AWS Secrets Manager, not application properties
- Implement database audit logging — track all reads/writes to PCI-scoped tables

\`\`\`java
// shared/security-common/src/main/java/com/company/shared/security/crypto/EncryptedFieldConverter.java
@Converter
public class EncryptedFieldConverter implements AttributeConverter<String, String> {
    // AES-256-GCM encryption/decryption
    // Key sourced from AWS Secrets Manager
    // Reference: PCI DSS Req 3.4 (render PAN unreadable), SOC 2 CC6.1
}
\`\`\`

### 4. Secret Management

Eliminate all hardcoded secrets and implement proper secret management:

- Scan the entire codebase for hardcoded secrets, API keys, passwords, tokens
- Replace all secrets with references to AWS Secrets Manager or Kubernetes Secrets
- Configure Spring Cloud AWS Secrets Manager integration for automatic secret injection
- Implement secret rotation support — services must handle rotated credentials without restart
- Add a pre-commit hook that scans for secrets using gitleaks patterns
- Ensure .properties and .yml files in **/production/** never contain plaintext secrets

Provide the \`bootstrap-production.yml\` configuration for AWS Secrets Manager integration:

\`\`\`yaml
spring:
  config:
    import: aws-secretsmanager:/spring-boot-microservices/\${spring.application.name}/
\`\`\`

### 5. Authentication & Authorization Hardening

Harden the JWT-based authentication flow:

- Validate JWT signature using RS256 with key rotation support (JWKS endpoint)
- Enforce token expiration — access tokens max 15 minutes, refresh tokens max 8 hours
- Implement token revocation via Redis blacklist for compromised tokens
- Add audience (aud) and issuer (iss) claim validation
- Implement method-level authorization using \`@PreAuthorize\` with custom SpEL expressions
- Create a custom \`PciDssAuditAspect\` that logs all access to PCI-scoped endpoints
- Ensure failed authentication attempts are rate-limited and logged

\`\`\`java
// shared/security-common/src/main/java/com/company/shared/security/jwt/JwtValidationConfig.java
public class JwtValidationConfig {
    // RS256 validation, JWKS, claim validation, token blacklist
    // Reference: PCI DSS Req 8.x (authentication), SOC 2 CC6.1, CC6.2
}
\`\`\`

### 6. API Gateway Hardening

Harden the Spring Cloud Gateway:

- Implement request size limits (max 1MB body, max 8KB headers)
- Add request/response logging with PII masking (mask card numbers, SSNs in logs)
- Configure circuit breakers per downstream service (Resilience4j)
- Implement IP-based rate limiting with Redis backend
- Add request ID propagation (X-Request-ID) for distributed tracing correlation
- Block common attack patterns (SQL injection, XSS, path traversal) via custom filters
- Validate Content-Type headers — reject unexpected content types

\`\`\`java
// gateway/src/main/java/com/company/gateway/filter/SecurityGatewayFilterFactory.java
public class SecurityGatewayFilterFactory extends AbstractGatewayFilterFactory<Config> {
    // Request validation, PII masking, attack pattern detection
    // Reference: PCI DSS Req 6.6 (WAF), SOC 2 CC6.6
}
\`\`\`

### 7. Audit Logging & Monitoring

Implement comprehensive audit logging for compliance:

- Create a centralized \`AuditEvent\` domain object published to Kafka topic \`platform.audit.events\`
- Log all authentication events (login, logout, failed attempts, token refresh)
- Log all authorization decisions (access granted, access denied, privilege escalation)
- Log all data access to PCI-scoped entities (cardholder data, payment records)
- Log all administrative actions (config changes, user management, role changes)
- Ensure audit logs are tamper-evident — include HMAC signature per log entry
- Configure log retention: audit logs retained for 1 year minimum (SOC 2), PCI logs for 1 year with 3 months immediately available (PCI DSS Req 10.7)

\`\`\`java
// shared/audit-common/src/main/java/com/company/shared/audit/AuditEventPublisher.java
@Component
public class AuditEventPublisher {
    // Publish structured audit events to Kafka
    // Include: who, what, when, where, outcome, HMAC signature
    // Reference: PCI DSS Req 10.x, SOC 2 CC7.x
}
\`\`\`

### 8. Container & Kubernetes Hardening

Review and harden Helm charts and Dockerfiles:

- Ensure all Docker images use non-root users (run as UID 1000)
- Use distroless or Eclipse Temurin slim base images — no shell in production
- Set read-only root filesystem in Kubernetes SecurityContext
- Drop all Linux capabilities, add only NET_BIND_SERVICE if needed
- Implement NetworkPolicies — each service can only communicate with its own database and Kafka
- Set resource limits (CPU, memory) on all containers
- Enable PodSecurityStandards (restricted profile)
- Ensure no privileged containers, no hostPath mounts, no hostNetwork

Provide a hardened SecurityContext block for Helm chart values:

\`\`\`yaml
securityContext:
  runAsNonRoot: true
  runAsUser: 1000
  runAsGroup: 1000
  fsGroup: 1000
  readOnlyRootFilesystem: true
  allowPrivilegeEscalation: false
  capabilities:
    drop: ["ALL"]
\`\`\`

### 9. Dependency Security

Audit and harden the dependency supply chain:

- Run OWASP dependency-check: \`./gradlew dependencyCheckAnalyze\`
- Identify and remediate all CVEs with CVSS >= 7.0
- Pin all dependency versions — no dynamic versions (no \`latest\`, no \`+\`)
- Configure Gradle dependency verification (checksums in \`gradle/verification-metadata.xml\`)
- Add Snyk or Trivy scanning to the CI pipeline for Docker images
- Ensure only approved dependencies are used (reference the team's approved dependency list)
- Check for vulnerable transitive dependencies and exclude them explicitly

### 10. Redis Security

Harden Redis connectivity and usage:

- Enable TLS for all Redis connections (Lettuce client with SSL)
- Use AUTH with strong passwords (loaded from AWS Secrets Manager)
- Set key expiration on all cached data — no indefinite TTLs
- Implement key namespace isolation per service: \`{service-name}:{key-type}:{id}\`
- Ensure session data is encrypted at rest in Redis
- Configure Redis connection pool limits to prevent resource exhaustion

## Output Format

For each hardening task:

1. **Threat**: What attack or compliance gap this addresses
2. **Compliance**: Specific PCI DSS requirement or SOC 2 control
3. **Implementation**: Complete Java/Kotlin code, YAML config, or Helm values
4. **Test**: A test that verifies the hardening is effective (JUnit 5 or integration test)
5. **Verification**: Command to verify the hardening (e.g., \`./gradlew dependencyCheckAnalyze\`, \`curl\` commands)

## Constraints

- Follow hexagonal architecture — security concerns belong in the infrastructure/adapter layer
- Use Spring Boot 3.2 security APIs (not deprecated Spring Security 5 patterns)
- All inter-service communication through Kafka only — no direct REST between services
- Shared security code goes in \`shared/security-common/\` module
- Use Testcontainers for integration tests that verify security configurations
- Maximum 300 lines per file — split into focused classes
- Follow naming conventions: PascalCase classes, camelCase methods, SCREAMING_SNAKE_CASE constants
- Mark all AI-generated code with \`// Generated by Claude Code — security hardening\`
\`\`\`

---

## Usage Notes

- Run this prompt after completing Phase 04 (core implementation) and the integration adapter work in Phase 05
- Before running, ensure you have the current security baseline: \`./gradlew dependencyCheckAnalyze\`
- After hardening, validate with: \`./gradlew test --tests '*Security*' --tests '*Audit*'\`
- Follow up with the Phase 06 testing prompts to add penetration test scenarios
- Review all changes in \`**/security/**\` and \`**/auth/**\` paths — these require 2 approvals per CODEOWNERS
- Cross-reference with \`playbook/prompts/04/auth-implementation.md\` for the base auth setup this builds upon

## Compliance Checklist

After running this prompt, verify these controls are addressed:

| Control | PCI DSS | SOC 2 | Status |
|---------|---------|-------|--------|
| Encryption in transit | Req 4.1 | CC6.6 | ☐ |
| Encryption at rest (PAN) | Req 3.4 | CC6.1 | ☐ |
| Access control | Req 7.x | CC6.2, CC6.3 | ☐ |
| Authentication | Req 8.x | CC6.1 | ☐ |
| Audit logging | Req 10.x | CC7.1, CC7.2 | ☐ |
| Secure development | Req 6.x | CC8.1 | ☐ |
| Network segmentation | Req 1.x | CC6.6 | ☐ |
| Vulnerability management | Req 6.1 | CC7.1 | ☐ |
| Secret management | Req 2.x | CC6.1 | ☐ |
| Container security | Req 6.5 | CC6.6 | ☐ |`,

  'playbook/prompts/06/e2e-test-generator.md': `# E2E Test Generator — Phase 06: Testing & Quality

## Prompt: Generate End-to-End Tests for Spring Boot Microservice Flows

Copy and paste the following prompt into Claude Code. Replace placeholders (\`{{...}}\`) with your actual values.

---

## Prompt

\`\`\`
You are an E2E test engineer for a Spring Boot 3.2 / Java 21 microservice platform in the financial services domain (SOC 2, PCI DSS compliant). Generate comprehensive end-to-end tests for the following business flow.

## Business Flow Under Test

- **Flow name**: {{FLOW_NAME}} (e.g., "Customer places order and payment is processed")
- **Entry point**: {{ENTRY_POINT}} (e.g., "POST /api/v1/orders via API gateway")
- **Services involved**: {{SERVICES}} (e.g., "gateway → order-service → payment-service → notification-service")
- **Kafka topics traversed**: {{KAFKA_TOPICS}} (e.g., "order.created → payment.requested → payment.completed → notification.requested")
- **Expected final state**: {{FINAL_STATE}} (e.g., "Order status=COMPLETED, Payment status=CAPTURED, Email sent")
- **Estimated flow duration**: {{DURATION}} (e.g., "< 5 seconds end-to-end")

## Project Context

### Repository Structure
\`\`\`
services/
  order-service/        # Manages order lifecycle
  payment-service/      # Processes payments, PCI DSS scoped
  user-service/         # User accounts and profiles
  notification-service/ # Email, SMS, push notifications
shared/
  domain-events/        # Avro/JSON schemas for Kafka events
  test-fixtures/        # Shared test data builders
gateway/                # Spring Cloud Gateway
tests/
  e2e/                  # E2E test suite (this is where output goes)
    src/test/java/com/{{ORG}}/e2e/
    src/test/resources/
    build.gradle.kts
schema-registry/        # Event schemas (Avro)
\`\`\`

### Tech Stack
- **Java 21**, **Spring Boot 3.2**, **Spring Kafka**
- **Testcontainers** for PostgreSQL, Kafka, Redis, Schema Registry
- **REST Assured** for HTTP assertions
- **Awaitility** for async event assertions
- **JUnit 5** with \`@TestMethodOrder(MethodOrderer.OrderAnnotation.class)\`
- **Docker Compose** via Testcontainers for multi-service orchestration
- **WireMock** for external third-party API stubs (payment gateways, email providers)
- **Gradle Kotlin DSL** (\`./gradlew :tests:e2e:test\`)

### Kafka Configuration
- Topics follow pattern: \`{{DOMAIN}}.{{EVENT_NAME}}\` (e.g., \`order.created\`, \`payment.completed\`)
- Events use schemas from \`schema-registry/\` directory
- Consumer groups: \`{{SERVICE_NAME}}-group\` (e.g., \`payment-service-group\`)
- All events include: \`eventId\`, \`eventType\`, \`timestamp\`, \`correlationId\`, \`payload\`

### Authentication
- JWT-based auth via gateway
- Test tokens generated with known signing key for E2E environment
- Roles: \`ROLE_CUSTOMER\`, \`ROLE_ADMIN\`, \`ROLE_SERVICE\`

## Requirements

### 1. Test Infrastructure Setup

Generate a \`E2ETestInfrastructure.java\` class that:
- Uses **Testcontainers** to spin up:
  - PostgreSQL containers (one per service with separate databases)
  - Single Kafka broker + Schema Registry
  - Redis container
- Starts each microservice as a Spring Boot application on random ports using \`SpringApplication.run()\` with test profiles
- Configures a shared Kafka broker URL, database URLs, and Redis URL across all services
- Implements \`@BeforeAll\` / \`@AfterAll\` lifecycle for container management
- Exposes service base URLs for REST Assured
- Creates Kafka topics programmatically before tests run
- Uses \`spring.profiles.active=e2e\` for all services

### 2. Test Data Builders

Generate test data builders following the Builder pattern:
- \`TestUserBuilder\` — creates user registration payloads and JWT tokens
- \`TestOrderBuilder\` — creates order request payloads with line items
- \`TestPaymentBuilder\` — creates payment method and billing info
- Each builder produces both the HTTP request DTO and the expected Kafka event
- Include realistic but synthetic PII data (no real customer data — PCI DSS compliance)
- Use \`java.util.UUID\` for all IDs, \`Instant.now()\` for timestamps

### 3. Kafka Test Utilities

Generate a \`KafkaTestConsumer.java\` utility that:
- Subscribes to specified topics with a dedicated test consumer group (\`e2e-test-group\`)
- Collects received events in a thread-safe \`ConcurrentHashMap<String, List<ConsumerRecord>>\` keyed by topic
- Provides assertion methods:
  - \`awaitEvent(String topic, String correlationId, Duration timeout)\` — returns the matching event or fails
  - \`awaitEventCount(String topic, int count, Duration timeout)\` — waits for N events on a topic
  - \`assertEventPayload(String topic, String correlationId, Consumer<JsonNode> assertions)\` — validates event content
- Uses **Awaitility** internally with configurable poll intervals
- Deserializes events using the schema registry or JSON deserializer
- Logs all received events for debugging

### 4. E2E Test Class

Generate the main E2E test class \`{{FLOW_NAME}}E2ETest.java\` with:

#### Test Methods (ordered execution):

\`\`\`java
@Test @Order(1) void shouldSetupTestUser()
// Register or ensure test user exists, obtain JWT token
// Assert: 201 Created or 200 OK, valid JWT returned

@Test @Order(2) void shouldInitiateFlow()
// POST to the entry endpoint via gateway with JWT auth
// Assert: 202 Accepted (or 201 Created), response contains correlationId
// Store correlationId for subsequent assertions

@Test @Order(3) void shouldPublishInitialDomainEvent()
// Verify the first Kafka event is published to the expected topic
// Assert: event correlationId matches, payload contains expected fields
// Assert: event schema matches schema-registry definition

@Test @Order(4) void shouldProcessIntermediateSteps()
// For each intermediate service/topic in the flow:
//   - Await the event on the next topic
//   - Verify correlationId propagation
//   - Verify payload transformation is correct
//   - Verify timing (event received within SLA)

@Test @Order(5) void shouldReachFinalState()
// Query each service's REST API to verify final state
// GET /api/v1/orders/{id} → status=COMPLETED
// GET /api/v1/payments/{id} → status=CAPTURED
// Assert all state transitions are consistent

@Test @Order(6) void shouldHaveDistributedTracingCorrelation()
// Verify all events share the same correlationId
// Verify trace headers (X-B3-TraceId or traceparent) are propagated
// Query Actuator /actuator/health on each service to confirm they're still healthy

@Test @Order(7) void shouldMeetPerformanceSLA()
// Assert total flow duration < configured SLA threshold
// Log timing breakdown per service hop
\`\`\`

#### Error Scenario Tests:

\`\`\`java
@Test @Order(10) void shouldHandlePaymentDecline()
// Configure WireMock to return payment decline from external gateway
// Verify: payment.failed event published, order status=PAYMENT_FAILED
// Verify: compensation/rollback events if applicable

@Test @Order(11) void shouldHandleServiceTimeout()
// Stop one downstream service container
// Verify: Kafka consumer retries, DLT (Dead Letter Topic) receives failed event
// Verify: upstream service handles gracefully (circuit breaker)

@Test @Order(12) void shouldHandleDuplicateEvents()
// Publish the same event twice with the same eventId
// Verify: idempotent processing — no duplicate side effects
// Verify: database state is consistent (exactly-once semantics)

@Test @Order(13) void shouldRejectUnauthorizedRequests()
// Send request without JWT → 401
// Send request with expired JWT → 401
// Send request with wrong role → 403
// Verify: no Kafka events published for rejected requests
\`\`\`

### 5. Gradle Configuration

Generate \`tests/e2e/build.gradle.kts\` with:
- Dependencies: JUnit 5, REST Assured, Testcontainers (kafka, postgresql, toxiproxy), Awaitility, WireMock, Jackson, Spring Kafka Test
- Task configuration: longer timeouts (10 min), forked JVM with 2GB heap
- System properties for container reuse (\`testcontainers.reuse.enable=true\`)
- Integration with JaCoCo (even though E2E coverage is supplementary)
- Task dependency: \`dependsOn(":services:order-service:bootJar", ":services:payment-service:bootJar", ...)\`

### 6. Test Configuration

Generate \`tests/e2e/src/test/resources/application-e2e.yml\` with:
- Placeholder database URLs (overridden by Testcontainers)
- Kafka bootstrap servers placeholder
- Redis connection placeholder
- Logging at DEBUG for \`com.{{ORG}}\` and \`org.apache.kafka\`
- Shorter timeouts for faster test feedback
- WireMock port configuration
- JWT test signing key

### 7. Docker Compose for Local E2E (Optional)

Generate \`tests/e2e/docker-compose.e2e.yml\` for running E2E tests locally without Testcontainers:
- All services built from local Dockerfiles
- Kafka + Zookeeper (or KRaft)
- PostgreSQL instances per service
- Redis
- Schema Registry
- Health check wait conditions

## Output Format

For each file, output:
1. Full file path relative to repository root
2. Complete file content
3. Brief inline comments explaining non-obvious decisions

## Constraints

- **No real PII or credentials** in test data — use synthetic data only (PCI DSS)
- **No direct REST calls between services** — all inter-service communication via Kafka
- **Idempotency keys** must be tested — financial transactions require exactly-once semantics
- **Correlation IDs** must propagate through the entire flow for distributed tracing
- **Test isolation** — each test class gets fresh database state (Testcontainers or truncation)
- **Deterministic** — tests must not depend on wall-clock time; use Awaitility with explicit timeouts
- **CI-compatible** — tests must run in GitHub Actions with Docker-in-Docker support
- Follow hexagonal architecture: tests interact only through ports (REST API, Kafka topics)
- Max file length: 300 lines per file — split into multiple files if needed
- Use conventional commits when describing changes: \`test: add E2E tests for {{FLOW_NAME}}\`
\`\`\`

---

## Usage Notes

### Before Running

1. Ensure all service \`bootJar\` tasks produce runnable JARs:
   \`\`\`bash
   ./gradlew :services:order-service:bootJar :services:payment-service:bootJar
   \`\`\`

2. Verify Docker is running (Testcontainers requirement):
   \`\`\`bash
   docker info
   \`\`\`

3. Confirm schema registry schemas are up to date:
   \`\`\`bash
   ls schema-registry/avro/
   \`\`\`

### Running E2E Tests

\`\`\`bash
# Run all E2E tests
./gradlew :tests:e2e:test

# Run a specific flow test
./gradlew :tests:e2e:test --tests "*OrderPaymentFlowE2ETest"

# Run with verbose Kafka logging
./gradlew :tests:e2e:test -Dlogging.level.org.apache.kafka=DEBUG

# Run with container reuse (faster subsequent runs)
TESTCONTAINERS_REUSE_ENABLE=true ./gradlew :tests:e2e:test
\`\`\`

### Running via Docker Compose (Alternative)

\`\`\`bash
cd tests/e2e
docker compose -f docker-compose.e2e.yml up -d --wait
./gradlew :tests:e2e:test -Dspring.profiles.active=e2e-docker
docker compose -f docker-compose.e2e.yml down -v
\`\`\`

### CI Integration

E2E tests run in the GitHub Actions pipeline at the **E2E Tests** stage after staging deployment. See \`.github/workflows/\` and \`playbook/prompts/03/ci-pipeline.md\` for pipeline configuration.

The CI stage uses \`services:\` blocks for Docker-in-Docker and caches Testcontainers images between runs.

### Extending for New Flows

1. Copy the generated test class as a template
2. Update \`{{FLOW_NAME}}\`, \`{{SERVICES}}\`, \`{{KAFKA_TOPICS}}\`
3. Add/remove ordered test methods to match the new flow's event chain
4. Register new Kafka topics in \`E2ETestInfrastructure.java\`
5. Add test data builders for new domain entities in \`shared/test-fixtures/\`

### Troubleshooting

| Symptom | Cause | Fix |
|---|---|---|
| \`KafkaTestConsumer\` times out | Consumer group not subscribed before event published | Increase \`awaitEvent\` timeout or add startup delay |
| Port conflicts | Previous test containers not cleaned up | Run \`docker ps\` and stop orphans, or enable container reuse |
| Schema deserialization error | Schema registry not populated | Ensure schemas are registered in \`@BeforeAll\` |
| \`Connection refused\` on service URL | Service failed to start | Check service logs in Testcontainers output |
| Flaky ordering | Events processed out of order | Use \`correlationId\` matching instead of topic ordering |

## Related Prompts

- \`playbook/prompts/06/test-suite-generator.md\` — Unit and integration test generation
- \`playbook/prompts/05/integration-adapter.md\` — Kafka adapter implementation (what E2E tests validate)
- \`playbook/prompts/05/observability-setup.md\` — Distributed tracing setup (validated by E2E tracing tests)
- \`playbook/prompts/03/ci-pipeline.md\` — CI pipeline where E2E tests execute
- \`playbook/prompts/05/security-hardening.md\` — Auth/authz rules tested in error scenarios`,

  'playbook/prompts/06/load-test.md': `# Load Test — Phase 06: Testing & Quality

## Prompt

\`\`\`
You are a performance engineer working on our Spring Boot microservices platform (Java 21, Spring Boot 3.2, Kafka, PostgreSQL, Redis) in a financial services environment requiring SOC 2 and PCI DSS compliance. Generate comprehensive load testing infrastructure and test scenarios.

## Context

Review the current project structure and service landscape:

1. Read \`services/\` to identify all microservices and their REST endpoints
2. Read \`gateway/\` to understand API gateway routing and rate limiting
3. Read \`schema-registry/\` to identify Kafka event flows between services
4. Read \`infrastructure/\` for current resource limits and scaling policies
5. Read \`docs/\` for NFRs, SLAs, and performance baselines

## Load Testing Framework Setup

### 1. Gatling Test Module

Create \`tests/load/build.gradle.kts\`:

\`\`\`kotlin
plugins {
    java
    id("io.gatling.gradle") version "3.10.3"
}

dependencies {
    gatling("io.gatling.highcharts:gatling-charts-highcharts:3.10.3")
    gatling("io.gatling:gatling-http-java:3.10.3")
    gatling("com.fasterxml.jackson.core:jackson-databind:2.16.1")
    gatling("org.apache.kafka:kafka-clients:3.6.1")
    gatling("io.confluent:kafka-avro-serializer:7.5.3")
}

gatling {
    logLevel = "WARN"
    logHttp = io.gatling.gradle.LogHttp.FAILURES
    enterprise.closureOf<Any> { }
}
\`\`\`

### 2. Base Simulation Configuration

Create \`tests/load/src/gatling/java/com/company/loadtest/config/BaseSimulation.java\`:

- Read environment config from system properties or \`load-test.properties\`
- Configure base URL pointing to API gateway (default: \`http://localhost:8080\`)
- Set up authentication token provider (OAuth2 client credentials flow)
- Configure common HTTP protocol settings:
  - Accept: application/json
  - Content-Type: application/json
  - Connection: keep-alive
  - Appropriate timeouts for financial transactions
- Create reusable feeders for test data (user IDs, account numbers, payment amounts)
- Implement PCI DSS-compliant test data generation (no real card numbers, use test PANs)

### 3. Test Data Feeders

Create \`tests/load/src/gatling/java/com/company/loadtest/feeders/\`:

- \`UserFeeder.java\` — generates synthetic user profiles with UUIDs
- \`PaymentFeeder.java\` — generates test payment payloads with:
  - Randomized amounts within configurable ranges (e.g., $0.01–$10,000)
  - Test card numbers from PCI DSS test ranges (4111111111111111, etc.)
  - Random merchant IDs, currency codes (USD, EUR, GBP)
- \`OrderFeeder.java\` — generates order payloads with line items
- \`AccountFeeder.java\` — generates account lookup parameters

All feeders must use \`Iterator<Map<String, Object>>\` pattern and be thread-safe.

## Load Test Scenarios

### 4. API Gateway Load Test

Create \`tests/load/src/gatling/java/com/company/loadtest/simulations/GatewaySimulation.java\`:

Test the Spring Cloud Gateway under load:
- **Health check flood**: GET \`/actuator/health\` — verify gateway stays responsive
- **Route resolution**: Requests to each service route — measure routing overhead
- **Rate limiting**: Exceed configured rate limits — verify 429 responses
- **Circuit breaker**: Simulate backend failures — verify fallback responses

Injection profile:
\`\`\`
setUp(
    healthCheck.injectOpen(constantUsersPerSec(100).during(Duration.ofMinutes(5))),
    routeResolution.injectOpen(rampUsersPerSec(10).to(200).during(Duration.ofMinutes(3))),
    rateLimitTest.injectOpen(constantUsersPerSec(500).during(Duration.ofMinutes(2)))
).protocols(httpProtocol)
 .assertions(
     global().responseTime().percentile(95).lt(500),
     global().successfulRequests().percent().gt(99.0)
 );
\`\`\`

### 5. Order Service Load Test

Create \`tests/load/src/gatling/java/com/company/loadtest/simulations/OrderServiceSimulation.java\`:

Simulate realistic order lifecycle:
- **Create order**: POST \`/api/v1/orders\` with order payload from feeder
- **Get order**: GET \`/api/v1/orders/{orderId}\` — verify read-after-write consistency
- **List orders**: GET \`/api/v1/orders?page=0&size=20\` — paginated listing
- **Update order**: PATCH \`/api/v1/orders/{orderId}\` — status transitions
- **Cancel order**: DELETE \`/api/v1/orders/{orderId}\` — cancellation flow

Chain these into a realistic user journey:
\`\`\`
scenario("Order Lifecycle")
    .exec(createOrder)
    .pause(Duration.ofSeconds(1), Duration.ofSeconds(3))
    .exec(getOrder)
    .pause(Duration.ofMillis(500))
    .exec(listOrders)
    .randomSwitch().on(
        Choice.withWeight(70, exec(/* proceed to payment */)),
        Choice.withWeight(30, exec(cancelOrder))
    );
\`\`\`

Assertions:
- P95 response time for order creation < 800ms
- P99 response time for order retrieval < 500ms
- Error rate < 0.1%
- Throughput sustains 500 orders/minute

### 6. Payment Service Load Test

Create \`tests/load/src/gatling/java/com/company/loadtest/simulations/PaymentServiceSimulation.java\`:

Financial transaction load testing (PCI DSS compliant):
- **Process payment**: POST \`/api/v1/payments\` — full payment processing
- **Payment status**: GET \`/api/v1/payments/{paymentId}\` — status polling
- **Refund**: POST \`/api/v1/payments/{paymentId}/refund\` — refund processing
- **Payment history**: GET \`/api/v1/payments?accountId={id}&from={date}&to={date}\`

Critical assertions for financial services:
- P99 response time for payment processing < 2000ms
- Zero data loss (every payment request gets a deterministic response)
- Idempotency verification (replay same idempotency key — same response)
- Error rate < 0.01% under normal load

Include idempotency test:
\`\`\`
exec(
    http("Process Payment")
        .post("/api/v1/payments")
        .header("Idempotency-Key", "#{idempotencyKey}")
        .body(StringBody("#{paymentPayload}"))
        .check(status().is(201), jsonPath("$.paymentId").saveAs("paymentId"))
).exec(
    http("Replay Payment (Idempotent)")
        .post("/api/v1/payments")
        .header("Idempotency-Key", "#{idempotencyKey}")
        .body(StringBody("#{paymentPayload}"))
        .check(status().is(201), jsonPath("$.paymentId").is("#{paymentId}"))
);
\`\`\`

### 7. User Service Load Test

Create \`tests/load/src/gatling/java/com/company/loadtest/simulations/UserServiceSimulation.java\`:

- **Authentication**: POST \`/api/v1/auth/token\` — token generation under load
- **Profile retrieval**: GET \`/api/v1/users/{userId}\` — with Redis cache hit/miss patterns
- **Profile update**: PUT \`/api/v1/users/{userId}\` — write-through cache invalidation
- **Search**: GET \`/api/v1/users?query={term}\` — search performance

Test Redis caching effectiveness:
- First request (cache miss) vs subsequent requests (cache hit)
- Measure cache hit ratio via Actuator metrics during test
- Verify cache invalidation on writes

### 8. Kafka Throughput Test

Create \`tests/load/src/gatling/java/com/company/loadtest/simulations/KafkaLoadSimulation.java\`:

Test Kafka event pipeline end-to-end:
- Produce events to \`order.created\` topic at increasing rates
- Measure consumer lag on downstream services (payment-service, notification-service)
- Verify event ordering within partition keys
- Test dead letter queue handling under load

Use a custom Kafka protocol (not HTTP):
\`\`\`java
public class KafkaProducerAction {
    private final KafkaProducer<String, GenericRecord> producer;

    public void sendEvent(String topic, String key, GenericRecord event) {
        ProducerRecord<String, GenericRecord> record =
            new ProducerRecord<>(topic, key, event);
        producer.send(record, (metadata, exception) -> {
            if (exception != null) {
                // Record failure metric
            }
        });
    }
}
\`\`\`

Scenarios:
- **Steady state**: 1,000 events/sec for 10 minutes
- **Burst**: Ramp from 1,000 to 10,000 events/sec over 2 minutes
- **Recovery**: Pause consumers, accumulate lag, resume — measure catch-up time

### 9. Database Stress Test

Create \`tests/load/src/gatling/java/com/company/loadtest/simulations/DatabaseStressSimulation.java\`:

Test PostgreSQL connection pool behavior under load:
- Concurrent read-heavy workload (80% reads, 20% writes)
- Connection pool exhaustion scenarios
- Long-running transaction impact
- Monitor via Spring Actuator \`/actuator/metrics/hikaricp.connections.active\`

Verify HikariCP pool settings hold under load:
- Maximum pool size not exceeded
- Connection wait time < 500ms at P99
- No connection leaks (active connections return to pool)

### 10. Soak Test

Create \`tests/load/src/gatling/java/com/company/loadtest/simulations/SoakTestSimulation.java\`:

Extended duration test for memory leaks and resource exhaustion:
- Moderate load (50% of peak capacity) for 4 hours
- Monitor JVM heap usage via \`/actuator/metrics/jvm.memory.used\`
- Monitor thread count via \`/actuator/metrics/jvm.threads.live\`
- Monitor database connection pool metrics
- Monitor Kafka consumer lag trends

Assertions:
- No OOM errors
- GC pause time < 200ms at P99
- Response time degradation < 10% over test duration
- No monotonically increasing resource consumption (leak indicator)

## Supporting Infrastructure

### 11. Metrics Collection During Tests

Create \`tests/load/src/gatling/java/com/company/loadtest/metrics/ActuatorMetricsCollector.java\`:

Poll Spring Actuator endpoints during test execution:
- \`/actuator/metrics/http.server.requests\` — request latency histograms
- \`/actuator/metrics/jvm.memory.used\` — heap and non-heap memory
- \`/actuator/metrics/hikaricp.connections.active\` — DB pool utilization
- \`/actuator/metrics/spring.kafka.listener.seconds\` — Kafka consumer processing time
- \`/actuator/metrics/cache.gets\` — Redis cache hit/miss ratio
- \`/actuator/prometheus\` — full Prometheus scrape for Grafana dashboards

Write metrics to \`tests/load/build/reports/metrics/\` as CSV for post-analysis.

### 12. Load Test Profiles

Create \`tests/load/src/gatling/resources/load-test-profiles.conf\`:

Define named profiles:
\`\`\`hocon
profiles {
    smoke {
        users = 10
        duration = "2m"
        rampUp = "30s"
        description = "Quick validation — run in CI on every PR"
    }
    baseline {
        users = 100
        duration = "10m"
        rampUp = "2m"
        description = "Establish performance baseline"
    }
    stress {
        users = 500
        duration = "15m"
        rampUp = "5m"
        description = "Find breaking point"
    }
    spike {
        peakUsers = 1000
        spikeDuration = "30s"
        recoveryDuration = "5m"
        description = "Sudden traffic spike — Black Friday simulation"
    }
    soak {
        users = 200
        duration = "4h"
        rampUp = "10m"
        description = "Long-running stability test"
    }
    pci-compliance {
        users = 300
        duration = "30m"
        rampUp = "5m"
        description = "PCI DSS performance validation — payment paths only"
    }
}
\`\`\`

### 13. Docker Compose for Local Load Testing

Create \`tests/load/docker-compose.load-test.yml\`:

- Gatling runner container
- InfluxDB for real-time Gatling metrics
- Grafana with pre-configured Gatling dashboard
- Prometheus for Actuator metrics collection
- All services under test (using existing docker-compose as base)

### 14. CI Integration

Create \`.github/workflows/load-test.yml\`:

\`\`\`yaml
name: Load Test
on:
  schedule:
    - cron: '0 2 * * 1-5'  # Nightly on weekdays
  workflow_dispatch:
    inputs:
      profile:
        description: 'Load test profile'
        required: true
        default: 'baseline'
        type: choice
        options: [smoke, baseline, stress, spike, soak, pci-compliance]
      target_env:
        description: 'Target environment'
        required: true
        default: 'staging'
        type: choice
        options: [staging, performance]
\`\`\`

Steps:
1. Deploy services to performance environment
2. Run selected Gatling profile
3. Collect Actuator metrics during test
4. Generate Gatling HTML report
5. Compare against baseline thresholds
6. Upload report as GitHub Actions artifact
7. Post summary to Slack channel
8. Fail pipeline if SLA thresholds breached

### 15. Performance Baseline Document

Create \`tests/load/PERFORMANCE_BASELINE.md\`:

Document expected performance characteristics per service:
| Service | Endpoint | P50 | P95 | P99 | Max RPS | Error Rate |
|---------|----------|-----|-----|-----|---------|------------|
| gateway | routing | 15ms | 50ms | 100ms | 5000 | < 0.01% |
| order-service | POST /orders | 120ms | 400ms | 800ms | 500 | < 0.1% |
| payment-service | POST /payments | 250ms | 800ms | 2000ms | 300 | < 0.01% |
| user-service | GET /users/{id} | 5ms | 20ms | 50ms | 2000 | < 0.01% |

Include Kafka throughput baselines:
| Topic | Target Throughput | Max Consumer Lag | Partition Count |
|-------|-------------------|------------------|-----------------|
| order.created | 1000 events/sec | < 100 | 12 |
| payment.processed | 500 events/sec | < 50 | 6 |
| notification.send | 2000 events/sec | < 200 | 12 |

## Output Requirements

For each file generated:
1. Follow hexagonal architecture — load tests interact only through public APIs and Kafka topics
2. Use PCI DSS test card numbers only — never real financial data
3. Include SOC 2 audit trail — log test execution metadata (who, when, what profile, results)
4. Make all thresholds configurable via properties/HOCON — no hardcoded magic numbers
5. Ensure tests are idempotent — can run repeatedly without data pollution (use unique correlation IDs)
6. Add \`@DisplayName\` annotations and clear Javadoc explaining each scenario's purpose
7. Reference Prometheus/Grafana dashboards in \`docs/runbooks/\` for monitoring during tests
8. Tag all generated files with \`// Generated by Claude Code — load-test prompt\` header comment

## Verification

After generating, verify:
- \`./gradlew :tests:load:gatlingClasses\` compiles successfully
- \`./gradlew :tests:load:gatlingRun-com.company.loadtest.simulations.GatewaySimulation -Dprofile=smoke\` executes
- Gatling HTML report`,

  'playbook/prompts/06/test-suite-generator.md': `# Test Suite Generator — Phase 06: Testing & Quality

> **Copy-paste this prompt into Claude Code** to generate comprehensive test suites for a Spring Boot microservice, covering unit tests, integration tests (Testcontainers), contract tests (Pact), and Kafka event tests.

---

## Prompt

\`\`\`
You are a senior test engineer working on a Spring Boot 3.2 / Java 21 microservice platform in a Gradle multi-module monorepo. The architecture follows Hexagonal Architecture (Ports & Adapters) with Kafka for all inter-service communication — no direct REST calls between services. The project must meet 80% code coverage (JaCoCo) and comply with SOC 2 and PCI DSS requirements.

## Context

I need you to generate a comprehensive test suite for the following service/component:

- **Service module**: services/<SERVICE_NAME>
- **Package base**: com.platform.<SERVICE_NAME_DOTTED>
- **Classes/components to test**: <LIST_CLASSES_OR_DESCRIBE_DOMAIN>
- **Kafka topics produced**: <TOPICS_PRODUCED>
- **Kafka topics consumed**: <TOPICS_CONSUMED>
- **Database tables**: <TABLES_USED>
- **External adapters**: <REDIS_CACHE, EXTERNAL_APIS, ETC>
- **Existing test gaps** (optional): <DESCRIBE_KNOWN_GAPS>

## Test Categories to Generate

### 1. Unit Tests (JUnit 5 + Mockito)

Generate unit tests for every layer of the hexagonal architecture:

**Domain layer tests:**
- Domain entity validation, invariants, and business rules
- Value object equality, creation constraints, and edge cases
- Domain event creation and payload correctness
- Domain service orchestration logic

**Application layer tests (use case / port tests):**
- Input port (use case) implementations with mocked output ports
- Command and query handler logic
- Validation of input DTOs and command objects
- Error handling paths — every exception type the use case can throw
- Idempotency checks where applicable (PCI DSS requirement for payment flows)

**Adapter layer tests:**
- REST controller tests using \`@WebMvcTest\` with \`MockMvc\`
  - Happy path for each endpoint
  - Validation error responses (400)
  - Authentication/authorization failures (401, 403)
  - Not found cases (404)
  - Request/response serialization correctness
- Kafka producer adapter tests — verify correct topic, key, headers, and serialized payload
- Kafka consumer adapter tests — verify deserialization and delegation to use case
- Repository adapter tests — verify query construction and mapping

**Naming convention**: \`<ClassUnderTest>Test.java\` in \`src/test/java/\`

**Structure each test class as:**
\`\`\`java
@ExtendWith(MockitoExtension.class)
class <ClassUnderTest>Test {

    // @Mock dependencies
    // @InjectMocks subject

    @Nested
    @DisplayName("<method or scenario group>")
    class <ScenarioGroup> {

        @Test
        @DisplayName("should <expected behavior> when <condition>")
        void should<Behavior>_when<Condition>() {
            // Arrange
            // Act
            // Assert
        }
    }
}
\`\`\`

### 2. Integration Tests (Testcontainers)

Generate integration tests that spin up real infrastructure:

**Database integration tests:**
- Use \`@DataJpaTest\` or \`@SpringBootTest\` with Testcontainers PostgreSQL
- Test repository queries against real PostgreSQL with Flyway migrations applied
- Test transactional behavior — commit, rollback, isolation
- Test database constraints — unique, foreign key, not null
- Use \`@Testcontainers\` and \`@Container\` annotations

\`\`\`java
@SpringBootTest
@Testcontainers
@ActiveProfiles("integration-test")
class <Repository>IntegrationTest {

    @Container
    static PostgreSQLContainer<?> postgres = new PostgreSQLContainer<>("postgres:15-alpine")
        .withDatabaseName("testdb")
        .withUsername("test")
        .withPassword("test");

    @DynamicPropertySource
    static void configureProperties(DynamicPropertyRegistry registry) {
        registry.add("spring.datasource.url", postgres::getJdbcUrl);
        registry.add("spring.datasource.username", postgres::getUsername);
        registry.add("spring.datasource.password", postgres::getPassword);
    }
}
\`\`\`

**Kafka integration tests:**
- Use Testcontainers Kafka (\`KafkaContainer\`) or \`@EmbeddedKafka\`
- Test full produce → consume round-trip for each event type
- Verify consumer group offsets, deserialization, and dead-letter topic routing
- Test consumer retry and error handling (DLT behavior)
- Verify event ordering guarantees where required

\`\`\`java
@SpringBootTest
@Testcontainers
@ActiveProfiles("integration-test")
class <EventFlow>IntegrationTest {

    @Container
    static KafkaContainer kafka = new KafkaContainer(
        DockerImageName.parse("confluentinc/cp-kafka:7.5.0")
    );

    @DynamicPropertySource
    static void kafkaProperties(DynamicPropertyRegistry registry) {
        registry.add("spring.kafka.bootstrap-servers", kafka::getBootstrapServers);
    }
}
\`\`\`

**Redis integration tests:**
- Use Testcontainers Redis (\`GenericContainer\` with redis image)
- Test cache hit/miss behavior
- Test cache eviction and TTL
- Test session storage if applicable

**Full-slice integration tests:**
- Test complete request flow: REST → Use Case → DB → Kafka event published
- Verify the entire adapter chain works together
- Use \`@SpringBootTest(webEnvironment = WebEnvironment.RANDOM_PORT)\` with \`TestRestTemplate\`

**Naming convention**: \`<Component>IntegrationTest.java\` in \`src/integrationTest/java/\`

### 3. Contract Tests (Pact)

Generate Pact contract tests for:

**Provider (REST API) contracts:**
- For each REST endpoint this service exposes
- Define provider states and verify against consumer pacts
- Use \`@PactVerification\` with Spring Boot test context

\`\`\`java
@Provider("<SERVICE_NAME>")
@PactBroker(url = "\${pact.broker.url}")
@SpringBootTest(webEnvironment = WebEnvironment.RANDOM_PORT)
class <ServiceName>ProviderContractTest {

    @TestTemplate
    @ExtendWith(PactVerificationInvocationContextProvider.class)
    void verifyPact(PactVerificationContext context) {
        context.verifyInteraction();
    }

    @State("<provider state description>")
    void setupState() {
        // seed test data
    }
}
\`\`\`

**Consumer (Kafka event) contracts:**
- For each Kafka topic this service consumes
- Define expected event schema and verify deserialization
- Use Pact message contract testing

\`\`\`java
@ExtendWith(PactConsumerTestExt.class)
@PactTestFor(providerName = "<PRODUCING_SERVICE>", providerType = ProviderType.ASYNCH)
class <EventName>ConsumerContractTest {

    @Pact(consumer = "<SERVICE_NAME>", provider = "<PRODUCING_SERVICE>")
    MessagePact createPact(MessagePactBuilder builder) {
        return builder
            .expectsToReceive("<event description>")
            .withContent(new PactDslJsonBody()
                .stringType("eventId")
                .stringType("eventType", "<EVENT_TYPE>")
                .timestamp("occurredAt", "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
                // ... payload fields
            )
            .toPact();
    }

    @Test
    @PactTestFor(pactMethod = "createPact")
    void shouldDeserializeEvent(List<Message> messages) {
        // verify deserialization
    }
}
\`\`\`

### 4. Security Tests

Generate security-focused tests for SOC 2 / PCI DSS compliance:

- Authentication enforcement — every endpoint requires valid JWT unless explicitly public
- Authorization — role-based access control for each endpoint
- Input sanitization — SQL injection, XSS, command injection attempts
- Sensitive data handling — PII/PCI fields are masked in logs, not exposed in error responses
- Rate limiting verification (if applicable)
- CORS configuration validation
- Audit logging — verify security events are logged (login, access denied, data access)

\`\`\`java
@WebMvcTest(<Controller>.class)
@Import(SecurityConfig.class)
class <Controller>SecurityTest {

    @Autowired
    private MockMvc mockMvc;

    @Test
    @DisplayName("should return 401 when no authentication token provided")
    void shouldReturn401WhenNoToken() throws Exception {
        mockMvc.perform(get("/api/v1/<resource>"))
            .andExpect(status().isUnauthorized());
    }

    @Test
    @WithMockUser(roles = "USER")
    @DisplayName("should return 403 when user lacks required role")
    void shouldReturn403WhenInsufficientRole() throws Exception {
        mockMvc.perform(delete("/api/v1/<resource>/1"))
            .andExpect(status().isForbidden());
    }
}
\`\`\`

### 5. Test Fixtures and Utilities

Generate shared test infrastructure:

- **Test data builders** (Builder pattern) for each domain entity and DTO
- **Mother objects** for common test scenarios (valid payment, expired card, etc.)
- **Custom assertions** using AssertJ for domain-specific validation
- **Kafka test utilities** — helper to publish test events and await consumption
- **Database test utilities** — helper to seed and clean test data
- **Shared Testcontainers configuration** — reusable container definitions via \`@SharedContainerConfig\`

\`\`\`java
public final class <Entity>TestBuilder {

    private <field> = <sensible_default>;

    public static <Entity>TestBuilder a<Entity>() {
        return new <Entity>TestBuilder();
    }

    public <Entity>TestBuilder with<Field>(<Type> value) {
        this.<field> = value;
        return this;
    }

    public <Entity> build() {
        return new <Entity>(<fields>);
    }

    public <Entity> buildAndPersist(JpaRepository<<Entity>, ?> repository) {
        return repository.save(build());
    }
}
\`\`\`

## Output Requirements

1. **Generate complete, compilable Java test files** — not pseudocode or snippets
2. **Use JUnit 5** (\`@Test\`, \`@Nested\`, \`@DisplayName\`, \`@ParameterizedTest\` where appropriate)
3. **Use AssertJ** for assertions (\`assertThat(...).isEqualTo(...)\`)
4. **Use Mockito** for mocking (\`@Mock\`, \`@InjectMocks\`, \`when().thenReturn()\`, \`verify()\`)
5. **Use Testcontainers** for integration tests — PostgreSQL 15, Kafka (Confluent 7.5), Redis 7
6. **Use Spring test annotations** — \`@WebMvcTest\`, \`@DataJpaTest\`, \`@SpringBootTest\`, \`@ActiveProfiles\`
7. **Follow the project's naming conventions** — PascalCase classes, camelCase methods
8. **Keep each test file under 300 lines** — split into multiple files if needed
9. **Target 80%+ coverage** — test happy paths, error paths, edge cases, boundary conditions
10. **Include \`@Tag\` annotations** for test categorization: \`"unit"\`, \`"integration"\`, \`"contract"\`, \`"security"\`
11. **Add comments for PCI DSS / SOC 2 relevant test cases** explaining the compliance requirement being verified

## Gradle Test Configuration

Also generate or update the Gradle test configuration if needed:

\`\`\`kotlin
// In the service's build.gradle.kts
tasks.test {
    useJUnitPlatform {
        includeTags("unit")
    }
}

tasks.register<Test>("integrationTest") {
    useJUnitPlatform {
        includeTags("integration")
    }
    shouldRunAfter(tasks.test)
}

tasks.register<Test>("contractTest") {
    useJUnitPlatform {
        includeTags("contract")
    }
    shouldRunAfter(tasks.named("integrationTest"))
}

tasks.register<Test>("securityTest") {
    useJUnitPlatform {
        includeTags("security")
    }
}

tasks.jacocoTestReport {
    dependsOn(tasks.test, tasks.named("integrationTest"))
    reports {
        xml.required.set(true)
        html.required.set(true)
    }
}

tasks.jacocoTestCoverageVerification {
    violationRules {
        rule {
            limit {
                minimum = "0.80".toBigDecimal()
            }
        }
    }
}
\`\`\`

## File Placement

Place generated files according to this structure:
\`\`\`
services/<SERVICE_NAME>/
├── src/
│   ├── test/java/com/platform/<service>/
│   │   ├── domain/           # Domain unit tests
│   │   ├── application/      # Use case unit tests
│   │   ├── adapter/
│   │   │   ├── in/web/       # Controller unit tests
│   │   │   ├── in/kafka/     # Kafka consumer unit tests
│   │   │   ├── out/persistence/  # Repository unit tests
│   │   │   └── out/kafka/    # Kafka producer unit tests
│   │   ├── security/         # Security tests
│   │   └── fixtures/         # Test builders, mothers, utilities
│   └── integrationTest/java/com/platform/<service>/
│       ├── persistence/      # DB integration tests
│       ├── kafka/            # Kafka integration tests
│       ├── cache/            # Redis integration tests
│       └── e2e/              # Full-slice integration tests
├── src/contractTest/java/com/platform/<service>/
│   ├── provider/             # Pact provider verification
│   └── consumer/             # Pact consumer contract tests
└── build.gradle.kts          # Test task configuration
\`\`\`

Now generate the complete test suite. Start with the test fixtures, then unit tests layer by layer, then integration tests, then contract tests, then security tests. List each file with its full path and complete content.
\`\`\`

---

## Usage

1. **Replace placeholders** before pasting:
   - \`<SERVICE_NAME>\` — e.g., \`payment-service\`
   - \`<SERVICE_NAME_DOTTED>\` — e.g., \`payment\`
   - \`<LIST_CLASSES_OR_DESCRIBE_DOMAIN>\` — e.g., \`Payment, PaymentCommand, ProcessPaymentUseCase, PaymentController, PaymentKafkaProducer, PaymentRepository\`
   - \`<TOPICS_PRODUCED>\` — e.g., \`payment.completed, payment.failed\`
   - \`<TOPICS_CONSUMED>\` — e.g., \`order.created\`
   - \`<TABLES_USED>\` — e.g., \`payments, payment_methods, payment_audit_log\`
   - \`<REDIS_CACHE, EXTERNAL_APIS, ETC>\` — e.g., \`Redis (idempotency cache), Stripe API adapter\`

2. **Run the generated tests**:
   \`\`\`bash
   # Unit tests only
   ./gradlew :services:payment-service:test

   # Integration tests
   ./gradlew :services:payment-service:integrationTest

   # Contract tests
   ./gradlew :services:payment-service:contractTest

   # Security tests
   ./gradlew :services:payment-service:securityTest

   # All tests with coverage
   ./gradlew :services:payment-service:check jacocoTestReport jacocoTestCoverageVerification
   \`\`\`

3. **Verify coverage** meets the 80% threshold:
   \`\`\`bash
   ./gradlew :services:payment-service:jacocoTestCoverageVerification
   \`\`\`
   Report at: \`services/payment-service/build/reports/jacoco/test/html/index.html\`

4. **Publish contract tests** to the Pact broker:
   \`\`\`bash
   ./gradlew :services:payment-service:pactPublish
   \`\`\`

## Example: Payment Service

\`\`\`
Service module: services/payment-service
Package base: com.platform.payment
Classes to test: Payment (entity), Money (value object), PaymentStatus (enum),
  ProcessPaymentUseCase, RefundPaymentUseCase, Payment`,

  'playbook/prompts/07/go-live-checklist.md': `# Go-Live Checklist — Phase 07: Launch

> **Copy-paste this prompt into Claude Code** to generate a comprehensive go-live readiness checklist for your Spring Boot microservices platform, covering infrastructure, security, observability, data, and operational readiness.

---

## Prompt

\`\`\`
You are a senior SRE and release engineer preparing a Spring Boot microservices platform for production launch. This is a financial services application subject to SOC 2 and PCI DSS compliance requirements.

## Platform Context

Our platform uses:
- **Services**: Spring Boot 3.2 / Java 21 microservices in \`services/\` (order-service, payment-service, user-service)
- **Gateway**: Spring Cloud Gateway in \`gateway/\`
- **Messaging**: Apache Kafka (AWS MSK) for all inter-service communication — no direct REST calls between services
- **Databases**: PostgreSQL (AWS RDS) per-service with isolated schemas
- **Caching**: Redis (AWS ElastiCache) for sessions and caching
- **Infrastructure**: AWS EKS, deployed via Helm charts in \`charts/\`, provisioned by Terraform in \`infrastructure/\`
- **CI/CD**: GitHub Actions with stages: Lint → Compile → Unit Tests → Integration Tests → Contract Tests → Security Scan → Docker Build → Deploy Staging → E2E Tests → Deploy Production
- **Observability**: Prometheus + Grafana (metrics), Jaeger (distributed tracing), ELK Stack (centralized logging)
- **Schema Registry**: Avro/JSON schemas for all Kafka events in \`schema-registry/\`

## Task

Generate a comprehensive go-live checklist as a Markdown file at \`docs/go-live-checklist.md\`. The checklist must be actionable, with each item being a verifiable yes/no gate. Organize it into the following sections:

### 1. Infrastructure Readiness
- [ ] All Terraform plans applied to production (\`infrastructure/production/\`)
- [ ] EKS cluster node groups sized for expected load (document target: ___ pods per service)
- [ ] RDS instances provisioned with Multi-AZ enabled for each service database
- [ ] ElastiCache Redis cluster provisioned with replication and failover
- [ ] MSK Kafka cluster provisioned with 3+ brokers across AZs
- [ ] ALB + Route53 DNS entries configured and verified
- [ ] ECR repositories exist for every service image
- [ ] TLS certificates provisioned and attached (ACM) for all public endpoints
- [ ] VPC security groups restrict traffic to least-privilege (no 0.0.0.0/0 ingress)
- [ ] NAT gateways configured for outbound traffic from private subnets
- [ ] EBS/EFS storage classes configured for any stateful workloads
- Include verification commands: \`terraform plan -no-color\`, \`kubectl get nodes\`, \`aws rds describe-db-instances\`

### 2. Kubernetes & Helm Deployment
- [ ] All Helm charts in \`charts/\` render without errors (\`helm template\` for each service)
- [ ] Production \`values-production.yaml\` exists for every chart with correct resource limits
- [ ] CPU and memory requests/limits set for every container (no unbounded pods)
- [ ] Horizontal Pod Autoscaler (HPA) configured for each service with appropriate thresholds
- [ ] Pod Disruption Budgets (PDB) configured (minAvailable >= 2 for critical services)
- [ ] Liveness and readiness probes configured using Spring Actuator:
  - Readiness: \`/actuator/health/readiness\`
  - Liveness: \`/actuator/health/liveness\`
- [ ] Startup probes configured for services with slow initialization
- [ ] Kubernetes Secrets created for all sensitive config (DB passwords, API keys, Kafka credentials)
- [ ] No secrets in ConfigMaps or environment variable literals
- [ ] Network Policies applied to restrict pod-to-pod traffic
- [ ] Service accounts with minimal RBAC permissions
- [ ] Anti-affinity rules ensure pods spread across nodes/AZs
- Include verification: \`helm lint charts/<service>\`, \`kubectl get hpa\`, \`kubectl get pdb\`

### 3. Database Readiness
- [ ] All Flyway/Liquibase migrations applied to production databases
- [ ] Database connection pools configured appropriately (HikariCP settings per service)
- [ ] Read replicas configured for read-heavy services
- [ ] Automated backups enabled with appropriate retention (minimum 30 days for PCI DSS)
- [ ] Point-in-time recovery tested and documented
- [ ] Database credentials rotated from any used during development/staging
- [ ] Connection encryption enforced (SSL/TLS required, \`sslmode=verify-full\`)
- [ ] Per-service database users with least-privilege grants (no superuser access)
- [ ] Slow query logging enabled
- [ ] \`pg_stat_statements\` extension enabled for query performance monitoring
- Include verification: \`./gradlew :services:<service>:flywayInfo\`, connection test commands

### 4. Kafka & Event Streaming Readiness
- [ ] All production Kafka topics created with correct partition counts and replication factor (≥3)
- [ ] Topic naming convention verified: \`<domain>.<entity>.<event>\` (e.g., \`payment.transaction.completed\`)
- [ ] Consumer group IDs follow convention: \`<service>-<topic>-consumer\`
- [ ] Dead letter topics (DLT) configured for every consumer
- [ ] Schema registry contains all production event schemas from \`schema-registry/\`
- [ ] Schema compatibility mode set to BACKWARD for all subjects
- [ ] Kafka ACLs configured — each service can only produce/consume its authorized topics
- [ ] Consumer lag monitoring configured in Prometheus (kafka_consumer_group_lag)
- [ ] Idempotent producers enabled (\`enable.idempotence=true\`)
- [ ] Consumer \`auto.offset.reset\` set to \`earliest\` for critical topics, \`latest\` for non-critical
- [ ] Message retention configured per topic (minimum 7 days, 90 days for audit topics)
- [ ] Kafka Connect connectors verified (if applicable)
- Include verification: \`kafka-topics.sh --describe\`, \`kafka-consumer-groups.sh --describe\`

### 5. Security & Compliance (SOC 2 / PCI DSS)
- [ ] Spring Security configured with OAuth2/JWT for all service endpoints
- [ ] API Gateway enforces authentication before routing to downstream services
- [ ] CORS policy explicitly configured (no wildcard origins in production)
- [ ] Rate limiting configured on API Gateway
- [ ] OWASP dependency-check scan passing with no critical/high CVEs
  - \`./gradlew dependencyCheckAnalyze\`
- [ ] SpotBugs security audit passing
  - \`./gradlew spotbugsMain\`
- [ ] Container image vulnerability scan passing (Trivy/Snyk)
- [ ] No secrets, credentials, or PII in application logs
- [ ] PCI DSS cardholder data fields encrypted at rest and in transit
- [ ] Audit logging enabled for all authentication events, data access, and admin actions
- [ ] Audit log retention meets compliance requirements (≥1 year for SOC 2, ≥1 year for PCI DSS)
- [ ] WAF rules configured on ALB for OWASP Top 10 protection
- [ ] Penetration test completed and findings remediated
- [ ] Security review of all files in \`**/security/**\` and \`**/auth/**\` completed
- [ ] Signed commits enforced on \`main\` and \`release/*\` branches
- [ ] CODEOWNERS file covers all sensitive paths
- [ ] AWS IAM roles follow least-privilege principle
- [ ] KMS encryption keys configured for RDS, ElastiCache, MSK, S3
- Include verification: scan report locations, compliance evidence artifacts

### 6. Observability & Alerting
- [ ] Prometheus scraping all Spring Actuator \`/actuator/prometheus\` endpoints
- [ ] Grafana dashboards deployed for:
  - Service health (request rate, error rate, latency — RED metrics)
  - JVM metrics (heap, GC, threads) per service
  - Kafka consumer lag per consumer group
  - Database connection pool utilization
  - Redis hit/miss ratio and connection count
  - Infrastructure (node CPU, memory, disk, network)
- [ ] Jaeger distributed tracing operational — traces flowing across service boundaries
- [ ] Trace context propagated through Kafka message headers
- [ ] ELK Stack ingesting logs from all services (structured JSON format)
- [ ] Log correlation IDs (traceId, spanId) present in all log entries
- [ ] Alerting rules configured in Prometheus/Alertmanager:
  - Service down (pod not ready > 2 minutes)
  - Error rate > 1% sustained for 5 minutes
  - P99 latency > 2 seconds sustained for 5 minutes
  - Kafka consumer lag > 10,000 messages sustained for 10 minutes
  - Database connection pool exhaustion (> 90% utilization)
  - Disk usage > 80%
  - Certificate expiry < 30 days
- [ ] Alert routing configured (PagerDuty/Slack/email) with escalation policy
- [ ] Runbooks linked to each alert in \`docs/runbooks/\`
- Include verification: \`curl <service>:8080/actuator/prometheus\`, Grafana dashboard URLs

### 7. Performance & Capacity
- [ ] Load testing completed with realistic traffic patterns (document tool: k6/Gatling/JMeter)
- [ ] Performance targets met:
  - P50 latency: < 100ms
  - P99 latency: < 500ms
  - Throughput: ___ requests/second per service
  - Kafka event processing: < 200ms end-to-end
- [ ] JVM tuning applied (heap size, GC algorithm, container-aware flags):
  - \`-XX:+UseG1GC -XX:MaxRAMPercentage=75.0 -XX:+UseContainerSupport\`
- [ ] HikariCP pool sizes validated under load
- [ ] Redis connection pool sizes validated under load
- [ ] Kafka producer/consumer tuning validated (batch.size, linger.ms, fetch.min.bytes)
- [ ] No memory leaks observed during sustained load test (≥1 hour)
- [ ] Graceful shutdown configured (\`spring.lifecycle.timeout-per-shutdown-phase=30s\`)
- Include: load test report location, performance baseline document

### 8. Data & Migration
- [ ] Production seed data loaded (reference data, configuration data)
- [ ] Data migration from legacy systems completed and verified (if applicable)
- [ ] Data integrity checks passed (row counts, checksums, business rule validation)
- [ ] GDPR/data privacy: PII inventory documented, retention policies configured
- [ ] Backup and restore procedure tested end-to-end
- [ ] Database rollback plan documented for each migration

### 9. Operational Readiness
- [ ] Runbooks created in \`docs/runbooks/\` for:
  - Service restart procedure
  - Database failover procedure
  - Kafka consumer reset procedure
  - Rollback deployment procedure
  - Incident response procedure
  - Scaling procedure (manual and auto)
- [ ] On-call rotation established with contact information
- [ ] Incident communication plan documented (status page, Slack channels)
- [ ] Feature flags configured for gradual rollout (if applicable)
- [ ] Canary/blue-green deployment strategy configured and tested
- [ ] Rollback procedure tested — can revert to previous version within 5 minutes
- [ ] Disaster recovery plan documented and tested (RTO: ___, RPO: ___)
- [ ] Chaos engineering tests executed (pod kill, network partition, AZ failure)
- [ ] Team briefed on architecture, runbooks, and escalation procedures
- [ ] War room / launch channel created in Slack

### 10. CI/CD Pipeline Verification
- [ ] Full pipeline executes successfully for every service:
  - \`./gradlew clean build\` (includes Checkstyle, ktlint, unit tests)
  - \`./gradlew integrationTest\` (Testcontainers)
  - \`./gradlew contractTest\` (Pact)
  - \`./gradlew dependencyCheckAnalyze\` (OWASP)
  - \`./gradlew spotbugsMain\` (SpotBugs)
  - \`./gradlew jacocoTestReport\` (coverage ≥ 80%)
  - Docker image build and push to ECR
  - Helm deploy to staging
  - E2E tests against staging
  - Helm deploy to production
- [ ] AI-generated code flagged in PRs per team policy
- [ ] CODEOWNERS enforced — all sensitive paths require designated reviewers
- [ ] Branch protection rules active on \`main\` and \`release/*\`
- [ ] Signed commits enforced
- [ ] At least 2 approvals required for merge

### 11. Documentation
- [ ] Architecture Decision Records (ADRs) up to date in \`docs/adrs/\`
- [ ] OpenAPI specs generated and published for each service
- [ ] Kafka event catalog documented (topic, schema, producer, consumers)
- [ ] API Gateway routing table documented
- [ ] Environment configuration documented (Spring Profiles: dev, staging, production)
- [ ] Onboarding guide for new developers
- [ ] Compliance evidence package assembled (SOC 2 / PCI DSS artifacts)

### 12. Final Sign-offs
- [ ] Engineering Lead sign-off
- [ ] Security Team sign-off
- [ ] QA Lead sign-off
- [ ] DevOps/SRE sign-off
- [ ] Product Owner sign-off
- [ ] Compliance Officer sign-off (SOC 2 / PCI DSS)

## Output Format

Generate the checklist as a single Markdown file with:
1. A header with project name, target launch date placeholder, and version
2. Each section as an H2 with items as GitHub-flavored Markdown checkboxes \`- [ ]\`
3. Verification commands in fenced code blocks under relevant items
4. A "Status" column approach where each item has: checkbox, description, owner placeholder, date placeholder
5. A summary table at the top showing section completion status
6. A "Launch Decision" section at the bottom with GO / NO-GO criteria

Make every item specific to our Spring Boot / Kafka / AWS / Kubernetes stack. Do not include generic items — every checkbox should reference a concrete tool, command, endpoint, or configuration from our platform.

Place the output at: docs/go-live-checklist.md
\`\`\`

---

## Usage Notes

- **When to use**: At the start of Phase 07 (Launch), before any production deployment
- **Prerequisites**: Phases 01–06 completed; staging environment fully operational
- **Related prompts**: \`05/security-hardening.md\`, \`05/observability-setup.md\`, \`03/iac-setup.md\`
- **Related playbook phase**: \`playbook/phases/07-launch.md\`
- **Output**: \`docs/go-live-checklist.md\` — a living document tracked in Git, updated as items are verified
- **Review process**: Checklist should be reviewed in a dedicated go-live readiness meeting with all sign-off stakeholders

## Customization Points

Before running, update the prompt with:
1. **Actual service names** — replace \`order-service, payment-service, user-service\` with your real services
2. **Performance targets** — fill in throughput numbers based on load testing
3. **RTO/RPO targets** — set disaster recovery objectives per business requirements
4. **Pod counts** — set target pod counts per service based on capacity planning
5. **Launch date** — set the target date for the checklist header
6. **Additional compliance requirements** — add any organization-specific gates`,

  'playbook/prompts/07/monitoring-setup.md': `# Monitoring Setup — Phase 07 Launch Prompt

> Copy-paste this prompt into Claude Code to set up production-grade monitoring, alerting, and dashboards for the Spring Boot microservices platform.

---

## Prompt

\`\`\`
You are setting up production monitoring, alerting, and observability dashboards for our Spring Boot microservices platform. This is a financial services platform subject to SOC 2 and PCI DSS compliance, so monitoring must cover security events, SLA tracking, and audit trail integrity.

## Platform Context

- **Services**: order-service, payment-service, user-service, gateway (Spring Cloud Gateway)
- **Infrastructure**: AWS EKS, RDS PostgreSQL (per-service), ElastiCache Redis, MSK (Kafka)
- **Observability Stack**: Prometheus (metrics), Grafana (dashboards), Jaeger (distributed tracing), ELK Stack (centralized logging)
- **Framework**: Spring Boot 3.2 with Actuator, Micrometer, Spring Kafka
- **Compliance**: SOC 2 Type II, PCI DSS Level 1

## Task 1: Prometheus Configuration

Create \`infrastructure/monitoring/prometheus/prometheus.yml\` with:

- Scrape configs for all Spring Boot Actuator endpoints (\`/actuator/prometheus\`)
- Service discovery via Kubernetes \`kubernetes_sd_configs\` targeting pods with annotation \`prometheus.io/scrape: "true"\`
- Scrape intervals: 15s for application metrics, 30s for infrastructure metrics
- Relabeling rules to extract service name, namespace, pod name
- Separate scrape jobs for:
  - \`spring-boot-services\` — all microservices on port 8080
  - \`kafka-exporters\` — Kafka JMX exporter on port 9308
  - \`postgres-exporters\` — PostgreSQL exporter on port 9187
  - \`redis-exporters\` — Redis exporter on port 9121
  - \`node-exporters\` — Kubernetes node metrics
  - \`kube-state-metrics\` — cluster state metrics
- Remote write config placeholder for long-term storage (Thanos/Cortex)
- Global external labels: \`cluster\`, \`environment\`, \`region\`

## Task 2: Alerting Rules

Create \`infrastructure/monitoring/prometheus/alerts/\` with these rule files:

### \`service-alerts.yml\`
- **HighErrorRate**: HTTP 5xx rate > 1% over 5 minutes per service
- **HighLatencyP99**: p99 latency > 500ms for any service over 5 minutes
- **HighLatencyP95**: p95 latency > 200ms for any service over 5 minutes
- **ServiceDown**: Spring Boot health endpoint down for > 1 minute
- **HighMemoryUsage**: JVM heap usage > 85% for 5 minutes
- **HighCPUUsage**: Container CPU > 80% for 5 minutes
- **ThreadPoolExhaustion**: Tomcat thread pool active threads > 90% of max
- **CircuitBreakerOpen**: Resilience4j circuit breaker in OPEN state
- **HighGCPause**: JVM GC pause time > 500ms

### \`kafka-alerts.yml\`
- **ConsumerLag**: Consumer group lag > 10000 messages for 5 minutes
- **ConsumerLagGrowing**: Consumer lag increasing for 10 minutes
- **UnderReplicatedPartitions**: Under-replicated partitions > 0 for 5 minutes
- **OfflinePartitions**: Offline partitions > 0
- **BrokerDown**: Kafka broker count < expected (3)
- **TopicMessageRateAnomaly**: Message production rate drops > 50% vs 1-hour average
- **DeadLetterQueueGrowing**: Messages in any \`.dlq\` topic increasing for 15 minutes
- **ProducerErrorRate**: Kafka producer error rate > 0.1% over 5 minutes
- **SchemaRegistryDown**: Schema registry health check failing

### \`database-alerts.yml\`
- **PostgresConnectionPoolExhaustion**: HikariCP active connections > 80% of max
- **PostgresSlowQueries**: Queries exceeding 1s threshold
- **PostgresReplicationLag**: RDS replica lag > 5 seconds
- **PostgresDiskUsage**: RDS storage > 80%
- **RedisMemoryUsage**: Redis memory > 80% of maxmemory
- **RedisConnectionCount**: Redis connections > 80% of max
- **RedisCacheHitRate**: Cache hit rate < 70% over 15 minutes
- **RedisEvictions**: Redis evictions > 0 for 5 minutes

### \`security-alerts.yml\` (SOC 2 / PCI DSS)
- **AuthenticationFailureSpike**: Failed auth attempts > 50 in 5 minutes per source IP
- **BruteForceDetected**: Failed auth attempts > 10 in 1 minute for same user
- **PrivilegedAccessAnomaly**: Admin API calls outside business hours
- **UnauthorizedAccessAttempts**: HTTP 403 rate > 5% over 5 minutes
- **TLSCertificateExpiringSoon**: Certificate expiry < 30 days
- **TLSCertificateCritical**: Certificate expiry < 7 days
- **AuditLogGap**: No audit log entries for > 5 minutes (indicates logging failure)
- **SensitiveDataAccessSpike**: Access to PCI-scoped endpoints > 200% of baseline
- **SecurityScanFinding**: New critical/high vulnerability detected

### \`sla-alerts.yml\`
- **SLAAvailabilityBreach**: Service availability < 99.9% over rolling 1 hour
- **SLALatencyBreach**: p95 latency > SLA threshold over rolling 1 hour
- **ErrorBudgetBurning**: Error budget consumption rate > 2x normal
- **PaymentProcessingDelay**: Payment event processing time > 30 seconds

Each alert must include:
- \`severity\` label: \`critical\`, \`warning\`, or \`info\`
- \`team\` label: \`platform\`, \`payments\`, \`identity\`, or \`orders\`
- \`runbook_url\` annotation pointing to \`docs/runbooks/{{ $labels.alertname }}.md\`
- \`summary\` and \`description\` annotations with template variables
- \`pci_relevant\` label where applicable (set to \`"true"\`)

## Task 3: Alertmanager Configuration

Create \`infrastructure/monitoring/alertmanager/alertmanager.yml\` with:

- Route tree:
  - \`critical\` + \`pci_relevant: "true"\` → PagerDuty (immediate) + Slack #incidents-security
  - \`critical\` → PagerDuty (immediate) + Slack #incidents-platform
  - \`warning\` → Slack #alerts-platform (grouped, 5-min wait)
  - \`info\` → Slack #monitoring-info (grouped, 15-min wait)
- Group by: \`alertname\`, \`service\`, \`namespace\`
- Repeat interval: 4 hours for critical, 12 hours for warning
- Inhibition rules:
  - ServiceDown inhibits all other alerts for that service
  - KafkaBrokerDown inhibits ConsumerLag alerts
  - PostgresConnectionPoolExhaustion inhibits PostgresSlowQueries
- Receivers with placeholder webhook URLs for PagerDuty, Slack, and email
- Time-based muting for planned maintenance windows

## Task 4: Grafana Dashboards

Create Grafana dashboard JSON files in \`infrastructure/monitoring/grafana/dashboards/\`:

### \`platform-overview.json\`
- Row 1: Service health matrix (up/down status for all services)
- Row 2: Request rate, error rate, p50/p95/p99 latency (RED metrics) across all services
- Row 3: Kafka cluster health — broker count, partition count, consumer lag summary
- Row 4: Database connections (HikariCP), Redis hit rate, cache size
- Row 5: JVM metrics summary — heap usage, GC rate, thread count per service
- Row 6: Kubernetes — pod count, restarts, CPU/memory per namespace
- Variables: \`$namespace\`, \`$service\`, \`$time_range\`

### \`service-detail.json\` (parameterized by service)
- Row 1: HTTP request rate by endpoint, status code distribution
- Row 2: Latency histograms — p50, p95, p99 by endpoint
- Row 3: JVM deep dive — heap (eden, survivor, old gen), GC pauses, class loading
- Row 4: Tomcat thread pool — active, idle, max, queue size
- Row 5: HikariCP — active connections, idle, pending, connection acquire time
- Row 6: Spring Kafka — producer send rate, consumer poll rate, consumer lag
- Row 7: Resilience4j — circuit breaker state, retry count, rate limiter
- Row 8: Custom business metrics (use \`custom_\` prefix placeholder)
- Variables: \`$service\`, \`$namespace\`, \`$endpoint\`, \`$time_range\`

### \`kafka-detail.json\`
- Row 1: Cluster overview — broker count, controller, ISR shrink rate
- Row 2: Topic metrics — messages in/out per second by topic
- Row 3: Consumer group lag — per group, per topic, per partition
- Row 4: Producer metrics — send rate, error rate, batch size, request latency
- Row 5: Consumer metrics — poll rate, commit rate, rebalance rate
- Row 6: Dead letter queues — message count per DLQ topic, growth rate
- Variables: \`$topic\`, \`$consumer_group\`, \`$broker_id\`

### \`security-compliance.json\` (SOC 2 / PCI DSS)
- Row 1: Authentication — success/failure rate, failure by reason, by source IP
- Row 2: Authorization — 403 rate by endpoint, by user role
- Row 3: Audit trail — events per second, gap detection, log volume
- Row 4: TLS certificate expiry countdown per service
- Row 5: Sensitive data access — PCI-scoped endpoint access patterns
- Row 6: Security scan results — vulnerability count by severity over time
- Variables: \`$namespace\`, \`$service\`, \`$time_range\`

### \`sla-tracking.json\`
- Row 1: Availability SLI/SLO — current availability vs target (99.9%)
- Row 2: Latency SLI/SLO — p95 latency vs target per service
- Row 3: Error budget — remaining budget, burn rate, projected exhaustion date
- Row 4: Payment processing SLA — end-to-end processing time distribution
- Row 5: Monthly/weekly SLA report summary (stat panels)
- Variables: \`$service\`, \`$slo_window\`

Each dashboard must:
- Use Micrometer metric names (\`http_server_requests_seconds_*\`, \`jvm_memory_used_bytes\`, \`spring_kafka_*\`, \`hikaricp_*\`, \`resilience4j_*\`)
- Include proper Prometheus datasource reference
- Have auto-refresh set to 30s for operational dashboards, 5m for SLA dashboards
- Use consistent color scheme (green/yellow/red thresholds)
- Include links to related dashboards and runbooks

## Task 5: Grafana Dashboard Provisioning

Create \`infrastructure/monitoring/grafana/provisioning/\`:

- \`datasources.yml\` — Prometheus, Jaeger, Elasticsearch datasources
- \`dashboards.yml\` — auto-provision dashboards from the dashboards directory
- \`notifiers.yml\` — Slack and PagerDuty notification channels

## Task 6: Spring Boot Actuator & Micrometer Configuration

Create \`shared/monitoring-config/src/main/java/com/platform/monitoring/\` with:

### \`MonitoringAutoConfiguration.java\`
- Auto-configuration class that registers custom \`MeterBinder\` beans
- Configures common tags: \`service\`, \`environment\`, \`version\`, \`region\`
- Registers custom metrics:
  - \`business.events.published\` — counter by event type
  - \`business.events.consumed\` — counter by event type and consumer group
  - \`business.events.processing.duration\` — timer by event type
  - \`business.events.dlq\` — counter for dead-letter events
  - \`security.auth.attempts\` — counter by result (success/failure) and method
  - \`security.auth.active_sessions\` — gauge
  - \`pci.sensitive_data.access\` — counter by endpoint and user role

### \`KafkaMetricsInterceptor.java\`
- Spring Kafka \`ProducerInterceptor\` and \`ConsumerInterceptor\`
- Records: message count, payload size, processing duration, error count
- Tags: topic, consumer group, partition
- Tracks end-to-end event latency using event timestamp headers

### \`SecurityMetricsFilter.java\`
- Spring Security filter that records authentication/authorization metrics
- Tracks: login attempts, failures by reason, token validation time
- Records PCI-scoped endpoint access with user context (anonymized)
- Integrates with audit logging

### \`HealthIndicatorConfig.java\`
- Custom \`HealthIndicator\` beans for:
  - Kafka connectivity (producer/consumer)
  - Schema registry availability
  - Redis connectivity and memory status
  - Downstream service health (via Actuator)
- Aggregated health groups: \`liveness\`, \`readiness\`, \`startup\`

### \`application-monitoring.yml\` (Spring Profile)
\`\`\`yaml
# Include this profile in all services: spring.profiles.include=monitoring
management:
  endpoints:
    web:
      exposure:
        include: health,info,prometheus,metrics,loggers
  endpoint:
    health:
      show-details: when-authorized
      group:
        liveness:
          include: livenessState,diskSpace
        readiness:
          include: readinessState,db,redis,kafka
  metrics:
    tags:
      application: \${spring.application.name}
      environment: \${ENVIRONMENT:local}
      region: \${AWS_REGION:us-east-1}
    distribution:
      percentiles-histogram:
        http.server.requests: true
        spring.kafka.listener: true
      slo:
        http.server.requests: 50ms,100ms,200ms,500ms,1s,5s
    enable:
      jvm: true
      process: true
      system: true
      tomcat: true
      hikaricp: true
      spring.kafka: true
  prometheus:
    metrics:
      export:
        enabled: true
\`\`\`

## Task 7: Kubernetes Monitoring Resources

Create \`infrastructure/monitoring/kubernetes/\`:

### \`servicemonitor.yml\`
- ServiceMonitor CRD for Prometheus Operator targeting all Spring Boot services
- Match labels: \`app.kubernetes.io/part-of: spring-boot-platform\`
- Endpoint: \`/actuator/prometheus\` on port \`http\`
- Scrape interval: 15s

### \`podmonitor.yml\`
- PodMonitor for Kafka exporters and sidecar containers

### \`prometheusrule.yml\`
- PrometheusRule CRD wrapping all alert rules from Task 2

### \`grafana-configmap.yml\`
- ConfigMap for Grafana dashboard provisioning in Kubernetes

## Task 8: Runbook Templates

Create \`docs/runbooks/\` with markdown runbook templates for the top 5 critical alerts:
- \`HighErrorRate.md\`
- \`ConsumerLag.md\`
- \`PostgresConnectionPoolExhaustion.md\`
- \`AuthenticationFailureSpike.md\`
- \`PaymentProcessingDelay.md\`

Each runbook must include:
1. **Alert Description** — what triggers it, thresholds
2. **Impact** — user-facing impact, SLA implications
3. **Investigation Steps** — specific commands, Grafana dashboard links, log queries
4. **Remediation Steps** — ordered actions to resolve
5. **Escalation** — when and who to escalate to
6. **Prevention** — long-term fixes to prevent recurrence
7. **Compliance Notes** — SOC 2/PCI DSS implications if applicable

Reference specific tools:
- \`kubectl logs\`, \`kubectl top\`, \`kubectl describe\`
- Grafana dashboard URLs (use placeholders)
- Kibana/Elasticsearch log queries
- Jaeger trace search
- \`./gradlew\` commands for local reproduction
- AWS CLI commands for RDS/ElastiCache/MSK inspection

## Constraints

- All Prometheus queries must use Micrometer metric naming conventions
- Alert thresholds must be tunable via ConfigMap or Prometheus recording rules
- Grafana dashboards must be version-controlled JSON (not created via UI)
- Security monitoring must satisfy SOC 2 CC7.2 (monitoring) and PCI DSS Requirement`,

  'playbook/prompts/07/runbook-generator.md': `# Runbook Generator — Phase 07 (Launch)

> Copy-paste this prompt into Claude Code to generate operational runbooks for each Spring Boot microservice, covering startup/shutdown procedures, Kafka consumer management, incident response, and common failure scenarios.

---

## Prompt

You are an SRE engineer generating production runbooks for the **spring-boot-microservices** platform. This is a financial services platform subject to **SOC 2** and **PCI DSS** compliance requirements. Every runbook must be precise, actionable, and assume the operator may be on-call at 3 AM.

### Platform Context

- **Services**: \`order-service\`, \`payment-service\`, \`user-service\`, \`gateway\` (Spring Cloud Gateway)
- **Runtime**: Java 21, Spring Boot 3.2, deployed on AWS EKS via Helm charts
- **Messaging**: Apache Kafka (AWS MSK) for all inter-service communication — no direct REST between services
- **Databases**: PostgreSQL (AWS RDS) per service, Redis (AWS ElastiCache) for caching/sessions
- **Observability**: Prometheus + Grafana (metrics), Jaeger (distributed tracing), ELK Stack (centralized logging)
- **Infrastructure**: Terraform-managed AWS resources, Kubernetes with Helm charts in \`charts/\`
- **Profiles**: \`dev\`, \`staging\`, \`production\` (Spring Profiles)
- **Actuator endpoints**: \`/actuator/health\`, \`/actuator/info\`, \`/actuator/prometheus\`, \`/actuator/env\`, \`/actuator/loggers\`

### Generate the Following Runbooks

Create each runbook as a separate Markdown file under \`docs/runbooks/\`. Each runbook must follow this structure:

\`\`\`
## Title
## Severity / Priority
## Symptoms (what alerts fire, what users see)
## Diagnosis Steps (exact commands, queries, dashboards)
## Resolution Steps (numbered, copy-pasteable commands)
## Verification (how to confirm the fix worked)
## Escalation Path
## Post-Incident (what to document, who to notify)
\`\`\`

---

### Runbook 1: \`docs/runbooks/service-startup-shutdown.md\`

**Service Lifecycle Management**

Cover startup and graceful shutdown for each microservice:

- **Startup sequence**: Order matters — \`user-service\` → \`payment-service\` → \`order-service\` → \`gateway\`
- **Kubernetes commands**: \`kubectl rollout restart\`, \`kubectl scale\`, \`helm upgrade\`
- **Health check verification**: Poll \`/actuator/health\` and confirm \`UP\` status including sub-checks (\`db\`, \`redis\`, \`kafka\`, \`diskSpace\`)
- **Graceful shutdown**: Spring Boot graceful shutdown config (\`server.shutdown=graceful\`), Kubernetes \`terminationGracePeriodSeconds\`, draining Kafka consumers before pod termination
- **Rolling restart procedure**: Zero-downtime restart via Helm with \`maxUnavailable: 0\`, \`maxSurge: 1\`
- **Environment-specific commands**:
  \`\`\`bash
  # Staging
  helm upgrade order-service charts/order-service -f charts/order-service/values-staging.yaml -n staging
  # Production (requires approval)
  helm upgrade order-service charts/order-service -f charts/order-service/values-production.yaml -n production
  \`\`\`
- **Readiness vs liveness probe** behavior and what happens when each fails
- **Spring Profile verification**: \`curl /actuator/env | jq '.activeProfiles'\`

---

### Runbook 2: \`docs/runbooks/kafka-consumer-lag.md\`

**Kafka Consumer Lag / Message Processing Delays**

- **Alert trigger**: Consumer lag > 10,000 messages for > 5 minutes (Prometheus alert: \`kafka_consumer_lag_high\`)
- **Kafka topics to check**: \`order.events\`, \`payment.events\`, \`user.events\`, \`order.payment.requests\`, \`payment.order.responses\`
- **Consumer groups**: \`order-service-group\`, \`payment-service-group\`, \`user-service-group\`
- **Diagnosis commands**:
  \`\`\`bash
  # Check consumer lag via kafka CLI
  kafka-consumer-groups.sh --bootstrap-server $MSK_BROKER --describe --group payment-service-group
  # Check via Prometheus/Grafana
  # Dashboard: "Kafka Consumer Lag" → filter by consumer_group
  \`\`\`
- **Common causes**: Slow database queries in consumer handler, Redis connection pool exhaustion, poison pill messages, consumer rebalancing storms
- **Resolution for each cause**:
  - Slow DB: Identify query via Jaeger trace, add index or optimize
  - Redis pool: Scale ElastiCache, increase \`spring.data.redis.lettuce.pool.max-active\`
  - Poison pill: Send to dead-letter topic (\`*.dlq\`), investigate schema mismatch in \`schema-registry/\`
  - Rebalance storm: Check \`session.timeout.ms\`, \`heartbeat.interval.ms\`, \`max.poll.interval.ms\` in consumer config
- **Scaling consumers**: \`kubectl scale deployment payment-service --replicas=5 -n production\` (ensure topic partition count >= replica count)
- **Dead letter queue processing**: How to inspect and replay DLQ messages
- **PCI DSS note**: Payment event messages contain tokenized card references — never log full message payloads in production

---

### Runbook 3: \`docs/runbooks/database-incidents.md\`

**PostgreSQL Database Incidents**

Cover per-service database issues:

- **Connection pool exhaustion**: HikariCP metrics via \`/actuator/metrics/hikaricp.connections.active\`, max pool size in \`spring.datasource.hikari.maximum-pool-size\`
- **Slow queries**: Enable \`pg_stat_statements\`, check \`pg_stat_activity\` for long-running queries
- **Replication lag** (RDS read replicas): CloudWatch \`ReplicaLag\` metric
- **Failover procedure**: RDS Multi-AZ automatic failover, Spring Boot reconnection behavior, HikariCP connection validation (\`spring.datasource.hikari.connection-test-query\`)
- **Migration failures**: Flyway migration stuck — how to check \`flyway_schema_history\`, manually mark as resolved, rollback procedure
  \`\`\`bash
  # Check migration status
  ./gradlew :services:order-service:flywayInfo
  # Repair failed migration
  ./gradlew :services:order-service:flywayRepair
  \`\`\`
- **Disk space alerts**: RDS \`FreeStorageSpace\` metric, emergency storage scaling
- **Backup verification**: RDS automated snapshots, point-in-time recovery procedure
- **SOC 2 note**: All database access must be audited. Do not connect directly to production databases without creating an access request ticket in Jira and logging the session.

---

### Runbook 4: \`docs/runbooks/redis-failures.md\`

**Redis / ElastiCache Incidents**

- **Connection failures**: Spring Data Redis connection factory errors, Lettuce client reconnection behavior
- **Memory pressure**: ElastiCache \`DatabaseMemoryUsagePercentage\`, eviction policy (\`allkeys-lru\`), key TTL audit
- **Session invalidation**: If Redis cluster fails, all user sessions are lost — document the user impact and communication template
- **Cache stampede**: Multiple services hitting DB simultaneously after cache expiry — implement \`@Cacheable\` with \`sync=true\`
- **Cluster failover**: ElastiCache automatic failover, DNS propagation delay, Spring Boot reconnection
- **Diagnosis**:
  \`\`\`bash
  # Check Redis connectivity from pod
  kubectl exec -it deployment/order-service -n production -- curl -s localhost:8080/actuator/health | jq '.components.redis'
  # Check ElastiCache metrics
  aws elasticache describe-cache-clusters --cache-cluster-id spring-boot-ms-prod
  \`\`\`

---

### Runbook 5: \`docs/runbooks/api-gateway-incidents.md\`

**API Gateway (Spring Cloud Gateway) Incidents**

- **High latency / timeouts**: Check route-level metrics, circuit breaker state (\`/actuator/circuitbreakers\`), rate limiter state
- **502/503 errors**: Upstream service health, Kubernetes service DNS resolution, pod readiness
- **Rate limiting triggers**: Redis-backed rate limiter (\`RequestRateLimiter\` filter), how to temporarily increase limits
- **Circuit breaker open**: Resilience4j circuit breaker states, how to force-close for emergency, half-open transition
- **TLS certificate expiry**: ALB certificate via ACM, internal mTLS certificates
- **Route configuration issues**: Verify routes via \`/actuator/gateway/routes\`

---

### Runbook 6: \`docs/runbooks/incident-response.md\`

**General Incident Response Procedure**

- **Severity levels**:
  - **SEV1**: Payment processing down, data breach suspected → page on-call lead + engineering manager
  - **SEV2**: Single service degraded, elevated error rates → page on-call engineer
  - **SEV3**: Non-critical feature broken, performance degradation → Slack alert, next business day
  - **SEV4**: Cosmetic issue, minor bug → Jira ticket
- **Communication templates**: Slack channel \`#incidents\`, status page updates, customer communication for payment-affecting incidents
- **PCI DSS incident response**: If cardholder data exposure is suspected, immediately notify the security team and compliance officer. Preserve all logs. Do not attempt to "fix" evidence.
- **War room setup**: Zoom link, shared Grafana dashboard, Jaeger trace correlation
- **Post-incident review**: Template for blameless postmortem, Jira ticket for follow-up actions, Confluence page for documentation
- **Rollback procedure**:
  \`\`\`bash
  # Rollback to previous Helm release
  helm rollback order-service 0 -n production
  # Verify rollback
  helm history order-service -n production
  kubectl rollout status deployment/order-service -n production
  \`\`\`
- **Log collection for forensics**:
  \`\`\`bash
  # Export logs for specific time window
  kubectl logs deployment/payment-service -n production --since=1h > payment-service-incident.log
  # Query ELK for correlated logs
  # Kibana: service.name:"payment-service" AND level:"ERROR" AND @timestamp:[now-1h TO now]
  \`\`\`

---

### Runbook 7: \`docs/runbooks/kafka-cluster-recovery.md\`

**Kafka / MSK Cluster Recovery**

- **Broker failure**: MSK automatic recovery, partition reassignment, under-replicated partitions
- **Topic configuration issues**: Retention policy, partition count changes, replication factor
- **Schema registry failures**: Impact on producers/consumers, fallback behavior, schema compatibility checks
- **Full cluster recovery**: MSK cluster replacement via Terraform, topic recreation from \`schema-registry/\` definitions, consumer offset reset procedure
  \`\`\`bash
  # Reset consumer offsets to specific timestamp
  kafka-consumer-groups.sh --bootstrap-server $MSK_BROKER --group order-service-group --topic order.events --reset-offsets --to-datetime 2024-01-15T10:00:00.000 --execute
  \`\`\`
- **Data reconciliation**: After recovery, how to verify event consistency between services using the reconciliation job in \`services/order-service\`

---

### Formatting Requirements

- Use consistent heading levels across all runbooks
- Every command must be copy-pasteable — use actual namespace names (\`staging\`, \`production\`), actual service names, actual topic names
- Include Grafana dashboard names and Prometheus alert names where referenced
- Add \`⚠️ COMPLIANCE\` callout boxes for any step that has SOC 2 or PCI DSS implications
- Add \`🔒 REQUIRES APPROVAL\` markers for any production-impacting action
- Add estimated time-to-resolution for each runbook scenario
- Cross-reference related runbooks (e.g., Kafka consumer lag runbook should link to database incidents if slow queries are the cause)
- Include a \`Last Updated\` date field and \`Owner\` field at the top of each runbook
- Reference the Jira project for follow-up tickets and the Confluence space for postmortems

### Additional Context

- Helm chart values files: \`charts/<service>/values-staging.yaml\`, \`charts/<service>/values-production.yaml\`
- Terraform state: \`infrastructure/production/\`
- GitHub Actions workflows: \`.github/workflows/deploy-*.yml\`
- CODEOWNERS for \`infrastructure/production/**\` requires lead engineer approval
- All production changes must be logged in \`#deployments\` Slack channel
- On-call rotation managed via PagerDuty

Generate all seven runbooks now. Ensure they are thorough enough that a mid-level engineer on their first on-call rotation can follow them successfully at 3 AM.`,

  'plugin/codeforge-spring-boot-microservices/.claude-plugin/plugin.json': `{
  "name": "codeforge-spring-boot-microservices",
  "version": "1.0.0",
  "description": "CodeForge plugin for Spring Boot 3.2 microservice development with Kafka event streaming, hexagonal architecture, and Kubernetes-native deployment targeting financial services compliance (SOC 2, PCI DSS).",
  "author": "Platform Engineering Team",
  "license": "PROPRIETARY",
  "engine": {
    "claude": ">=1.0.0"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/org/spring-boot-microservices"
  },
  "keywords": [
    "spring-boot",
    "microservices",
    "kafka",
    "kubernetes",
    "hexagonal-architecture",
    "java-21",
    "fintech",
    "event-driven"
  ],
  "capabilities": {
    "agents": true,
    "commands": true,
    "skills": true,
    "rules": true,
    "hooks": false,
    "mcp": true
  },
  "agents": {
    "directory": "agents/",
    "definitions": [
      {
        "id": "service-scaffolder",
        "name": "Service Scaffolder",
        "description": "Scaffolds a new Spring Boot microservice module with hexagonal architecture, Dockerfile, Helm chart, OpenAPI spec, Kafka consumer/producer config, and Testcontainers integration test setup.",
        "entrypoint": "agents/service-scaffolder.md"
      },
      {
        "id": "kafka-event-designer",
        "name": "Kafka Event Designer",
        "description": "Designs domain events, generates Avro/JSON schemas for the schema registry, creates Kafka topic configurations, and wires producer/consumer bindings into Spring Kafka.",
        "entrypoint": "agents/kafka-event-designer.md"
      },
      {
        "id": "api-reviewer",
        "name": "API Reviewer",
        "description": "Reviews REST API endpoints for consistency with OpenAPI specs, Spring Security configuration, input validation, PCI DSS data handling, and hexagonal architecture port/adapter separation.",
        "entrypoint": "agents/api-reviewer.md"
      },
      {
        "id": "database-migrator",
        "name": "Database Migrator",
        "description": "Generates Flyway migration scripts for PostgreSQL, validates schema changes against existing migrations, and ensures per-service database isolation.",
        "entrypoint": "agents/database-migrator.md"
      },
      {
        "id": "security-auditor",
        "name": "Security Auditor",
        "description": "Audits code changes for SOC 2 and PCI DSS compliance, reviews Spring Security configurations, checks for sensitive data exposure, and validates authentication/authorization patterns.",
        "entrypoint": "agents/security-auditor.md"
      },
      {
        "id": "test-generator",
        "name": "Test Generator",
        "description": "Generates JUnit 5 unit tests, Testcontainers integration tests, and Pact contract tests for service endpoints and Kafka event flows.",
        "entrypoint": "agents/test-generator.md"
      }
    ]
  },
  "commands": {
    "directory": "commands/",
    "definitions": [
      {
        "id": "new-service",
        "name": "/new-service",
        "description": "Create a new microservice module with full hexagonal architecture scaffolding",
        "entrypoint": "commands/new-service.md",
        "arguments": [
          {
            "name": "service-name",
            "type": "string",
            "required": true,
            "description": "Kebab-case service name (e.g., payment-service)"
          },
          {
            "name": "domain",
            "type": "string",
            "required": true,
            "description": "Business domain (e.g., payments, orders, users)"
          },
          {
            "name": "port",
            "type": "integer",
            "required": false,
            "default": 8080,
            "description": "Default server port for local development"
          }
        ]
      },
      {
        "id": "new-event",
        "name": "/new-event",
        "description": "Define a new domain event with schema, topic, and producer/consumer wiring",
        "entrypoint": "commands/new-event.md",
        "arguments": [
          {
            "name": "event-name",
            "type": "string",
            "required": true,
            "description": "PascalCase event name (e.g., PaymentCompleted)"
          },
          {
            "name": "source-service",
            "type": "string",
            "required": true,
            "description": "Service that produces this event"
          },
          {
            "name": "consumer-services",
            "type": "string[]",
            "required": false,
            "description": "Services that consume this event"
          }
        ]
      },
      {
        "id": "new-endpoint",
        "name": "/new-endpoint",
        "description": "Add a REST endpoint following hexagonal architecture with port, adapter, use case, and tests",
        "entrypoint": "commands/new-endpoint.md",
        "arguments": [
          {
            "name": "service",
            "type": "string",
            "required": true,
            "description": "Target microservice module"
          },
          {
            "name": "method",
            "type": "string",
            "required": true,
            "enum": ["GET", "POST", "PUT", "PATCH", "DELETE"],
            "description": "HTTP method"
          },
          {
            "name": "path",
            "type": "string",
            "required": true,
            "description": "API path (e.g., /api/v1/payments/{id})"
          }
        ]
      },
      {
        "id": "new-migration",
        "name": "/new-migration",
        "description": "Generate a Flyway migration script for a service's PostgreSQL database",
        "entrypoint": "commands/new-migration.md",
        "arguments": [
          {
            "name": "service",
            "type": "string",
            "required": true,
            "description": "Target microservice module"
          },
          {
            "name": "description",
            "type": "string",
            "required": true,
            "description": "Migration description (e.g., add-transaction-status-column)"
          }
        ]
      },
      {
        "id": "check-compliance",
        "name": "/check-compliance",
        "description": "Run SOC 2 and PCI DSS compliance checks against staged or changed files",
        "entrypoint": "commands/check-compliance.md",
        "arguments": [
          {
            "name": "scope",
            "type": "string",
            "required": false,
            "default": "staged",
            "enum": ["staged", "branch", "all"],
            "description": "Scope of files to check"
          }
        ]
      },
      {
        "id": "generate-tests",
        "name": "/generate-tests",
        "description": "Generate unit, integration, and contract tests for a class or module",
        "entrypoint": "commands/generate-tests.md",
        "arguments": [
          {
            "name": "target",
            "type": "string",
            "required": true,
            "description": "Fully qualified class name or module path"
          },
          {
            "name": "type",
            "type": "string",
            "required": false,
            "default": "all",
            "enum": ["unit", "integration", "contract", "all"],
            "description": "Type of tests to generate"
          }
        ]
      },
      {
        "id": "review-pr",
        "name": "/review-pr",
        "description": "Perform comprehensive PR review including architecture, security, testing, and compliance",
        "entrypoint": "commands/review-pr.md",
        "arguments": [
          {
            "name": "pr-number",
            "type": "integer",
            "required": false,
            "description": "GitHub PR number (defaults to current branch PR)"
          }
        ]
      },
      {
        "id": "explain-service",
        "name": "/explain-service",
        "description": "Generate a comprehensive explanation of a microservice's architecture, events, and dependencies",
        "entrypoint": "commands/explain-service.md",
        "arguments": [
          {
            "name": "service",
            "type": "string",
            "required": true,
            "description": "Service module name to explain"
          }
        ]
      }
    ]
  },
  "skills": {
    "directory": "skills/",
    "definitions": [
      {
        "id": "hexagonal-architecture",
        "name": "Hexagonal Architecture",
        "description": "Knowledge of ports & adapters pattern as applied in this project: domain layer, application ports, infrastructure adapters, Spring configuration wiring.",
        "entrypoint": "skills/hexagonal-architecture.md"
      },
      {
        "id": "spring-kafka-patterns",
        "name": "Spring Kafka Patterns",
        "description": "Kafka producer/consumer configuration, dead letter topics, retry policies, idempotent consumers, transactional outbox pattern, schema evolution.",
        "entrypoint": "skills/spring-kafka-patterns.md"
      },
      {
        "id": "spring-security-fintech",
        "name": "Spring Security for Fintech",
        "description": "OAuth2/JWT configuration, method-level security, PCI DSS compliant data handling, audit logging, sensitive field encryption.",
        "entrypoint": "skills/spring-security-fintech.md"
      },
      {
        "id": "testcontainers-patterns",
        "name": "Testcontainers Patterns",
        "description": "Integration testing with Testcontainers for PostgreSQL, Kafka, and Redis. Shared container lifecycle, test data builders, slice test configuration.",
        "entrypoint": "skills/testcontainers-patterns.md"
      },
      {
        "id": "kubernetes-helm-deployment",
        "name": "Kubernetes & Helm Deployment",
        "description": "Helm chart structure per service, values overrides per environment, health probes mapping to Actuator, resource limits, HPA configuration.",
        "entrypoint": "skills/kubernetes-helm-deployment.md"
      },
      {
        "id": "gradle-multi-module",
        "name": "Gradle Multi-Module",
        "description": "Kotlin DSL build scripts, shared dependency versions via version catalogs, convention plugins, per-service build configuration.",
        "entrypoint": "skills/gradle-multi-module.md"
      },
      {
        "id": "observability",
        "name": "Observability Stack",
        "description": "Micrometer metrics for Prometheus, distributed tracing with Jaeger via OpenTelemetry, structured logging for ELK, Spring Actuator endpoint configuration.",
        "entrypoint": "skills/observability.md"
      },
      {
        "id": "pci-dss-compliance",
        "name": "PCI DSS Compliance",
        "description": "Cardholder data handling rules, encryption at rest and in transit, audit trail requirements, access control patterns, log redaction for sensitive fields.",
        "entrypoint": "skills/pci-dss-compliance.md"
      }
    ]
  },
  "rules": {
    "directory": "rules/",
    "definitions": [
      {
        "id": "architecture-rules",
        "name": "Architecture Rules",
        "description": "Hexagonal architecture enforcement, dependency direction validation, no direct inter-service REST calls",
        "entrypoint": "rules/architecture.md",
        "scope": "always"
      },
      {
        "id": "security-rules",
        "name": "Security Rules",
        "description": "SOC 2 and PCI DSS coding rules, sensitive data handling, authentication/authorization patterns",
        "entrypoint": "rules/security.md",
        "scope": "always"
      },
      {
        "id": "kafka-rules",
        "name": "Kafka Rules",
        "description": "Event naming conventions, schema registry requirements, consumer group naming, topic partitioning guidelines",
        "entrypoint": "rules/kafka.md",
        "scope": "always"
      },
      {
        "id": "testing-rules",
        "name": "Testing Rules",
        "description": "80% coverage threshold, required test types per layer, Testcontainers usage, Pact contract test requirements",
        "entrypoint": "rules/testing.md",
        "scope": "always"
      }
    ]
  },
  "mcp_integrations": [
    {
      "server": "github",
      "usage": "PR management, code review, branch operations, CODEOWNERS validation"
    },
    {
      "server": "jira",
      "usage": "Ticket lookup for context, status updates, acceptance criteria extraction"
    },
    {
      "server": "slack",
      "usage": "Deployment notifications, review requests, incident alerts"
    }
  ],
  "project_context": {
    "monorepo": true,
    "service_modules": [
      "services/order-service",
      "services/payment-service",
      "services/user-service",
      "services/notification-service",
      "gateway/"
    ],
    "shared_modules": [
      "shared/domain-events",
      "shared/common-dto",
      "shared/test-utils",
      "shared/security-commons"
    ],
    "build_commands": {
      "compile": "./gradlew compileJava",
      "test": "./gradlew test",
      "integration_test": "./gradlew integrationTest",
      "contract_test": "./gradlew contractTest",
      "lint": "./gradlew checkstyleMain ktlintCheck",
      "format": "./gradlew googleJavaFormat ktlintFormat",
      "security_scan": "./gradlew dependencyCheckAnalyze spotbugsMain",
      "coverage": "./gradlew jacocoTestReport",
      "build": "./gradlew build",
      "docker_build": "./gradlew bootBuildImage",
      "run_service": "./gradlew :services:{service-name}:bootRun --args='--spring.profiles.active=local'"
    },
    "kafka_topics_prefix": "fintech.platform",
    "schema_registry_path": "schema-registry/",
    "helm_charts_path": "charts/",
    "terraform_path": "infrastructure/terraform/",
    "flyway_locations": "services/{service-name}/src/main/resources/db/migration/"
  }
}`,

  'plugin/codeforge-spring-boot-microservices/README.md': `# CodeForge Spring Boot Microservices Plugin

A Claude Code plugin purpose-built for the **spring-boot-microservices** platform — an event-driven fintech architecture using Spring Boot 3.2, Java 21, Kafka, PostgreSQL, and Kubernetes.

## Overview

This plugin provides specialized agents, commands, skills, and hooks that encode the team's development methodology, hexagonal architecture patterns, compliance requirements (SOC 2, PCI DSS), and CI/CD practices directly into Claude Code workflows.

## Installation

### Quick Install

From the repository root:

\`\`\`bash
./install.sh
\`\`\`

This script copies plugin rules into \`.claude/\` and registers commands, agents, and hooks.

### Manual Install

1. Clone the repository (if not already):
   \`\`\`bash
   git clone git@github.com:<org>/spring-boot-microservices.git
   cd spring-boot-microservices
   \`\`\`

2. Ensure the plugin directory exists:
   \`\`\`bash
   ls plugin/codeforge-spring-boot-microservices/.claude-plugin/plugin.json
   \`\`\`

3. Run the installer:
   \`\`\`bash
   chmod +x install.sh && ./install.sh
   \`\`\`

4. Restart Claude Code to pick up the new configuration.

### Verify Installation

\`\`\`bash
# Check plugin manifest
cat plugin/codeforge-spring-boot-microservices/.claude-plugin/plugin.json

# Confirm hooks are registered
cat plugin/codeforge-spring-boot-microservices/hooks/hooks.json

# Test a command
# In Claude Code, type: /plan
\`\`\`

## Available Commands

Commands are slash-invocable actions within Claude Code.

| Command | Description | Usage |
|---------|-------------|-------|
| \`/plan\` | Generate an implementation plan from a Jira ticket or feature description | \`/plan PAY-456 add idempotency to payment processing\` |
| \`/tdd\` | Run a full TDD cycle — write failing test, implement, refactor | \`/tdd PaymentService.processRefund\` |
| \`/build-fix\` | Diagnose and fix Gradle build failures, test failures, or dependency issues | \`/build-fix\` (auto-detects from \`./gradlew build\` output) |
| \`/code-review\` | Perform a structured code review against team standards | \`/code-review services/payment-service/src/...\` |

### Command Details

#### \`/plan\`

Generates a phased implementation plan following the project's playbook methodology:

- Parses Jira ticket context (title, description, acceptance criteria)
- Identifies affected microservices and shared modules
- Plans Kafka event schema changes in \`schema-registry/\`
- Outputs a checklist with Gradle module paths, test strategy, and Helm chart updates
- Flags any changes to sensitive paths (\`**/security/**\`, \`**/auth/**\`, \`*.properties\`)

#### \`/tdd\`

Drives test-driven development with Spring Boot conventions:

1. **Red** — Writes a failing JUnit 5 test (unit or Testcontainers integration test)
2. **Green** — Implements the minimum code to pass
3. **Refactor** — Cleans up while maintaining green tests
4. Validates coverage with JaCoCo against the 80% threshold
5. Runs \`./gradlew test\` and \`./gradlew integrationTest\` as appropriate

#### \`/build-fix\`

Resolves build and test failures:

- Runs \`./gradlew build --stacktrace\` and parses output
- Identifies common issues: dependency conflicts, Checkstyle violations, ktlint errors, SpotBugs findings
- Fixes compilation errors, missing beans, Spring context issues
- Re-runs verification after each fix attempt
- Handles multi-module dependency resolution across \`services/\`, \`shared/\`, and \`gateway/\`

#### \`/code-review\`

Performs a structured review checking:

- Hexagonal architecture compliance (ports & adapters boundaries)
- No direct REST calls between services (Kafka-only inter-service communication)
- Spring Profile usage for environment configuration
- Conventional commit message format
- File length ≤ 300 lines
- Naming conventions (PascalCase classes, camelCase methods, SCREAMING_SNAKE_CASE constants)
- SOC 2 / PCI DSS compliance for security-sensitive changes
- Test coverage and Testcontainers usage for integration tests
- Kafka event schema backward compatibility

## Agents

Agents are specialized personas that Claude adopts for extended workflows.

### Planner Agent (\`agents/planner.md\`)

**Purpose**: Breaks down features into actionable implementation plans.

**Capabilities**:
- Reads Jira tickets via MCP integration
- Maps features to affected Gradle modules
- Identifies Kafka topic and schema changes
- Produces phased plans aligned with the playbook methodology
- Estimates complexity and flags cross-service dependencies

**Activation**: Automatically engaged by \`/plan\` or invoke directly:
> "Act as the planner agent and break down ticket PAY-789"

### TDD Guide Agent (\`agents/tdd-guide.md\`)

**Purpose**: Coaches developers through red-green-refactor cycles.

**Capabilities**:
- Writes JUnit 5 + Mockito unit tests
- Writes Testcontainers integration tests with PostgreSQL, Kafka, and Redis
- Writes Pact contract tests for API boundaries
- Enforces test-first discipline
- Validates JaCoCo coverage thresholds

**Activation**: Automatically engaged by \`/tdd\` or invoke directly:
> "Act as the TDD guide and help me test the OrderCreatedEvent handler"

### Code Reviewer Agent (\`agents/code-reviewer.md\`)

**Purpose**: Reviews code changes against team standards and compliance requirements.

**Capabilities**:
- Checks hexagonal architecture layer violations
- Validates Kafka event schema compatibility
- Flags PCI DSS violations (credential handling, data exposure)
- Verifies Spring Security configuration
- Checks for missing tests and coverage gaps
- Reviews Dockerfile and Helm chart changes

**Activation**: Automatically engaged by \`/code-review\` or invoke directly:
> "Act as the code reviewer and review my changes in payment-service"

### Architect Agent (\`agents/architect.md\`)

**Purpose**: Provides architectural guidance and design decisions.

**Capabilities**:
- Designs new microservice boundaries and module structure
- Plans Kafka topic topology and event schemas
- Reviews infrastructure changes (Terraform, Helm, Kubernetes manifests)
- Writes Architecture Decision Records (ADRs) in \`docs/\`
- Evaluates trade-offs for database-per-service patterns
- Advises on Spring Cloud Gateway routing

**Activation**: Invoke directly:
> "Act as the architect agent and design the notification service"

### Build Error Resolver Agent (\`agents/build-error-resolver.md\`)

**Purpose**: Diagnoses and fixes build pipeline failures.

**Capabilities**:
- Parses Gradle build output and stacktraces
- Resolves dependency version conflicts in multi-module builds
- Fixes Checkstyle, ktlint, and SpotBugs violations
- Resolves Testcontainers startup failures
- Fixes Spring context loading issues
- Handles Docker build failures

**Activation**: Automatically engaged by \`/build-fix\` or invoke directly:
> "Act as the build error resolver — my CI pipeline is failing"

## Skills

Skills are reusable knowledge modules that agents and commands draw upon.

| Skill | File | Description |
|-------|------|-------------|
| Plan | \`skills/plan/SKILL.md\` | Implementation planning methodology for microservice features |
| TDD | \`skills/tdd/SKILL.md\` | Test-driven development patterns for Spring Boot + Kafka |
| Build Fix | \`skills/build-fix/SKILL.md\` | Gradle multi-module build diagnosis and repair |
| Code Review | \`skills/code-review/SKILL.md\` | Review checklist for hexagonal architecture and compliance |
| Verify | \`skills/verify/SKILL.md\` | Full verification pipeline: lint, test, coverage, security scan |
| Phase | \`skills/phase/SKILL.md\` | Playbook phase management and progression |

## Hooks

Hooks run automatically at specific points in the Claude Code workflow. Configured in \`hooks/hooks.json\`.

| Hook | Trigger | Action |
|------|---------|--------|
| Pre-commit validation | Before commit | Runs Checkstyle, ktlint, and verifies conventional commit format |
| Build verification | After code generation | Runs \`./gradlew check\` on affected modules |
| Security scan | Before PR | Runs OWASP dependency-check and SpotBugs security audit |
| Schema compatibility | On schema changes | Validates Avro/JSON schema backward compatibility |
| AI code marking | After generation | Ensures AI-generated code is flagged per \`AI-USAGE-POLICY.md\` |

## Project Structure Reference

The plugin is aware of and operates within this project layout:

\`\`\`
services/                    # Microservices (each a Gradle subproject)
  ├── order-service/
  ├── payment-service/
  ├── user-service/
  └── notification-service/
shared/                      # Shared libraries
  ├── domain-events/         # Kafka event DTOs and interfaces
  ├── common-utils/          # Cross-cutting utilities
  └── test-support/          # Shared test fixtures and Testcontainers configs
gateway/                     # Spring Cloud Gateway
schema-registry/             # Avro/JSON event schemas
charts/                      # Helm charts (one per service)
infrastructure/              # Terraform modules for AWS
tests/                       # E2E and contract tests (Pact)
docs/                        # ADRs, architecture docs, runbooks
playbook/                    # Development methodology phases
\`\`\`

## Configuration

The plugin reads project configuration from:

- **\`plugin.json\`** — Plugin metadata, version, capabilities
- **\`hooks/hooks.json\`** — Automated hook definitions
- **\`.claude/\`** — Claude Code rules and settings (generated by \`install.sh\`)
- **\`gradle.properties\`** — Build configuration and dependency versions
- **Spring Profiles** — \`application-{profile}.yml\` for environment-specific config

## MCP Integrations

The plugin leverages MCP servers for external tool access:

| Tool | MCP Server | Usage |
|------|------------|-------|
| Jira | Jira MCP | Read tickets, update status, log implementation plans |
| Confluence | Confluence MCP | Read/write architecture docs and runbooks |
| GitHub | GitHub MCP | Create PRs, read reviews, manage branches |
| Slack | Slack MCP | Post build notifications, request reviews |
| AWS | AWS MCP | Check service health, read CloudWatch logs |

## Compliance Notes

This plugin enforces SOC 2 and PCI DSS compliance throughout all workflows:

- **Sensitive path protection**: Changes to \`**/security/**\`, \`**/auth/**\`, \`infrastructure/production/**\`, and \`*.properties\` trigger mandatory security review
- **Credential handling**: Never generates, logs, or exposes secrets — references AWS Secrets Manager or Spring Vault
- **Audit trail**: All AI-generated code is marked with \`@Generated("claude-code")\` annotations
- **Data classification**: Plugin agents flag PII and cardholder data handling in code reviews
- **Dependency policy**: Only approved dependencies from the allow-list in \`gradle/allowed-dependencies.txt\`

## Troubleshooting

### Plugin not loading
\`\`\`bash
# Re-run installation
./install.sh

# Verify plugin manifest
cat plugin/codeforge-spring-boot-microservices/.claude-plugin/plugin.json
\`\`\`

### Commands not recognized
Restart Claude Code after installation. Commands require the plugin to be fully registered.

### Hooks not firing
\`\`\`bash
# Verify hooks configuration
cat plugin/codeforge-spring-boot-microservices/hooks/hooks.json

# Check that hook scripts are executable
find plugin/ -name "*.sh" -exec chmod +x {} \\;
\`\`\`

### Build commands failing
\`\`\`bash
# Ensure Gradle wrapper is present and executable
chmod +x ./gradlew
./gradlew --version

# Verify Java 21
java -version
\`\`\`

## Contributing to the Plugin

1. Create a branch: \`feat/PLAT-xxx-plugin-improvement\`
2. Edit files under \`plugin/codeforge-spring-boot-microservices/\`
3. Test changes by re-running \`./install.sh\`
4. Submit a PR with at least 2 approvals (CODEOWNERS enforced)
5. Follow conventional commit format: \`feat(plugin): add new skill for database migration\`

## Version

- **Plugin**: 1.0.0
- **Slug**: \`codeforge-spring-boot-microservices\`
- **Compatible with**: Claude Code 1.x+
- **Target project**: spring-boot-microservices (Spring Boot 3.2, Java 21)`,

  'plugin/codeforge-spring-boot-microservices/agents/architect.md': `# Architect Agent — Spring Boot Microservices Platform

## Identity

You are the **Architect Agent** for the Spring Boot Microservices platform. You specialize in distributed systems design, hexagonal architecture enforcement, Kafka event-driven patterns, Kubernetes-native deployment, and SOC 2 / PCI DSS compliance for financial services. You make structural decisions that affect the entire platform and ensure consistency across all bounded contexts.

## Activation

This agent activates when the user asks about:
- System architecture, service boundaries, or domain modeling
- New microservice creation or decomposition of existing services
- Kafka topic design, event schemas, consumer group strategy
- Database schema design, data ownership, or cross-service data access
- API gateway routing, security policies, or rate limiting
- Infrastructure decisions (Kubernetes, Helm, Terraform, AWS)
- Hexagonal architecture compliance (ports, adapters, domain isolation)
- Performance, scalability, resilience, or fault tolerance
- Compliance architecture (SOC 2, PCI DSS data flow)
- Architecture Decision Records (ADRs)

## Context Loading

Before responding, read and internalize:

1. **Architecture documentation**: \`docs/ARCHITECTURE.md\`
2. **Existing ADRs**: \`docs/adr/\` directory (all files)
3. **Service catalog**: List all directories under \`services/\` to understand current bounded contexts
4. **Shared schemas**: \`schema-registry/\` for current event contracts
5. **Helm charts**: \`charts/\` for deployment topology
6. **Infrastructure**: \`infrastructure/\` for Terraform modules and K8s manifests
7. **Gateway config**: \`gateway/src/main/resources/application.yml\` for current routing
8. **Build structure**: Root \`settings.gradle.kts\` and \`build.gradle.kts\` for module dependencies
9. **AI usage policy**: \`docs/AI-USAGE-POLICY.md\`
10. **Contributing guide**: \`docs/CONTRIBUTING.md\`

## Core Principles

### Hexagonal Architecture Enforcement

Every microservice MUST follow this package structure:

\`\`\`
services/{service-name}/src/main/java/com/platform/{service}/
├── domain/                  # Pure domain logic — NO framework dependencies
│   ├── model/               # Entities, Value Objects, Aggregates
│   ├── event/               # Domain events (published via ports)
│   ├── exception/           # Domain-specific exceptions
│   ├── port/
│   │   ├── inbound/         # Use case interfaces (driving ports)
│   │   └── outbound/        # Repository, messaging, external service interfaces (driven ports)
│   └── service/             # Domain service implementations of inbound ports
├── application/             # Application layer — orchestration, DTOs, mappers
│   ├── dto/                 # Request/Response DTOs
│   ├── mapper/              # Domain ↔ DTO mappers (MapStruct)
│   └── usecase/             # Use case orchestrators (if needed beyond domain services)
├── adapter/
│   ├── inbound/
│   │   ├── rest/            # Spring MVC controllers (REST adapter)
│   │   └── kafka/           # Kafka consumers (event adapter)
│   └── outbound/
│       ├── persistence/     # Spring Data JPA repositories, JPA entities, mappers
│       ├── kafka/           # Kafka producers
│       ├── redis/           # Redis cache adapters
│       └── client/          # External API clients (rare — prefer events)
└── config/                  # Spring configuration, beans, security
\`\`\`

**Rules**:
- \`domain/\` package MUST have zero imports from \`org.springframework\`, \`javax.persistence\`, or any framework
- Domain models are NOT JPA entities — separate persistence models live in \`adapter/outbound/persistence/\`
- All cross-layer communication goes through port interfaces
- Adapters depend on domain, never the reverse

### Event-Driven Communication

**Absolute rule**: No direct REST calls between microservices. All inter-service communication flows through Kafka.

When designing events:
- Use the shared schema registry at \`schema-registry/\`
- Event naming: \`{bounded-context}.{aggregate}.{past-tense-verb}\` (e.g., \`payment.transaction.completed\`)
- Topic naming: \`platform.{bounded-context}.{aggregate}.events\` (e.g., \`platform.payment.transaction.events\`)
- Consumer group naming: \`{consuming-service}-{topic-short-name}-cg\` (e.g., \`order-service-payment-transaction-cg\`)
- Every event schema includes: \`eventId\` (UUID), \`eventType\`, \`timestamp\` (ISO 8601), \`version\`, \`correlationId\`, \`payload\`
- Events are immutable facts — never commands disguised as events
- Use event versioning from day one: \`v1\`, \`v2\` with backward compatibility

### Data Ownership

- Each service owns its PostgreSQL database exclusively
- No shared databases, no cross-service JOINs, no database-level integration
- If a service needs data from another service, it maintains a local read projection via Kafka events
- Redis is used for caching within a service boundary and for API gateway session management

### Compliance Architecture (SOC 2 / PCI DSS)

- PII and cardholder data (CHD) must be identified in every design
- CHD must be encrypted at rest (AES-256) and in transit (TLS 1.3)
- Kafka events containing PII must use field-level encryption or tokenization
- Audit logging is mandatory for all state-changing operations
- Access control follows least-privilege principle at service, database, and Kafka topic level
- Sensitive configuration (credentials, keys) must use AWS Secrets Manager or Kubernetes Secrets — never in properties files
- Data retention policies must be defined per aggregate

## Decision Framework

When making architectural decisions, evaluate against these criteria in order:

1. **Security & Compliance**: Does it maintain SOC 2 / PCI DSS compliance?
2. **Domain Integrity**: Does it respect bounded context boundaries and hexagonal architecture?
3. **Resilience**: What happens when this component fails? Is there a fallback?
4. **Data Consistency**: Is eventual consistency acceptable? Do we need sagas or outbox pattern?
5. **Operational Complexity**: Can the team (6-15 developers, mixed seniority) operate this?
6. **Performance**: Does it meet latency and throughput requirements?
7. **Cost**: Is the AWS resource usage justified?

## Response Patterns

### New Service Design

When asked to design a new microservice:

1. **Define the bounded context** — What aggregate roots does it own? What domain events does it produce and consume?
2. **Specify the data model** — PostgreSQL schema, Redis cache strategy
3. **Design the event contracts** — Kafka topics, event schemas (add to \`schema-registry/\`)
4. **Define the API surface** — OpenAPI spec for the REST adapter (gateway-facing only)
5. **Specify infrastructure** — Helm chart values, resource requests/limits, HPA config
6. **Identify compliance concerns** — PII fields, encryption requirements, audit events
7. **Write the ADR** — Document the decision in \`docs/adr/\` following the template

Provide the Gradle module setup:

\`\`\`kotlin
// settings.gradle.kts addition
include("services:{service-name}")

// services/{service-name}/build.gradle.kts
plugins {
    id("org.springframework.boot")
    id("io.spring.dependency-management")
    java
}

dependencies {
    implementation(project(":shared:domain-events"))
    implementation(project(":shared:common"))
    implementation("org.springframework.boot:spring-boot-starter-web")
    implementation("org.springframework.boot:spring-boot-starter-data-jpa")
    implementation("org.springframework.boot:spring-boot-starter-kafka")
    implementation("org.springframework.boot:spring-boot-starter-actuator")
    implementation("org.springframework.boot:spring-boot-starter-security")
    implementation("org.springframework.boot:spring-boot-starter-validation")
    implementation("org.springframework.boot:spring-boot-starter-data-redis")
    runtimeOnly("org.postgresql:postgresql")
    
    testImplementation("org.springframework.boot:spring-boot-starter-test")
    testImplementation("org.testcontainers:postgresql")
    testImplementation("org.testcontainers:kafka")
    testImplementation("org.testcontainers:junit-jupiter")
    testImplementation("au.com.dius.pact.consumer:junit5")
}
\`\`\`

### Service Decomposition

When asked to split a service:

1. Identify the aggregate boundaries being violated
2. Map the current data model to proposed bounded contexts
3. Design the event bridge — what events replace the current in-process calls?
4. Plan the migration — dual-write, strangler fig, or big bang?
5. Assess the blast radius — what other services are affected?
6. Estimate the operational cost — new database, new Kafka topics, new Helm chart

### Kafka Topology Review

When reviewing or designing Kafka topology:

1. Verify topic partitioning strategy (partition key = aggregate ID for ordering guarantees)
2. Check consumer group isolation (each service has its own consumer group per topic)
3. Validate idempotency — consumers must handle duplicate events
4. Confirm dead letter topic (DLT) strategy: \`platform.{context}.{aggregate}.events.dlt\`
5. Review retention policies against compliance requirements
6. Check for event ordering dependencies across topics (potential saga coordination)

### Architecture Review

When reviewing existing architecture or PRs with structural changes:

1. Verify hexagonal architecture compliance — no domain layer framework leakage
2. Check for direct inter-service REST calls (violation)
3. Validate event schema backward compatibility
4. Ensure new endpoints are registered in the API gateway
5. Confirm Helm chart and Dockerfile are updated
6. Verify Testcontainers integration tests exist for new adapters
7. Check that sensitive paths (\`**/security/**\`, \`**/auth/**\`) have appropriate review

## ADR Template

When creating Architecture Decision Records, use this format and save to \`docs/adr/NNNN-title.md\`:

\`\`\`markdown
# NNNN. Title

**Date**: YYYY-MM-DD
**Status**: Proposed | Accepted | Deprecated | Superseded by [NNNN]
**Deciders**: [team members involved]
**Ticket**: [Jira ticket if applicable]

## Context

[What is the issue that we're seeing that is motivating this decision?]

## Decision

[What is the change that we're proposing and/or doing?]

## Consequences

### Positive
- [benefit]

### Negative
- [tradeoff]

### Risks
- [risk and mitigation]

## Compliance Impact

[SOC 2 / PCI DSS implications, if any]

## Alternatives Considered

### Alternative 1: [name]
- Pros: ...
- Cons: ...
- Rejected because: ...
\`\`\`

## Infrastructure Guidance

### Kubernetes Resource Defaults

For new services, start with these baseline values in \`charts/{service-name}/values.yaml\`:

- **Replicas**: 2 (staging), 3 (production)
- **CPU request**: 250m, limit: 1000m
- **Memory request**: 512Mi, limit: 1Gi
- **HPA**: min 3, max 10, target CPU 70%
- **Liveness probe**: \`/actuator/health/liveness\`, initial delay 30s
- **Readiness probe**: \`/actuator/health/readiness\`, initial delay 15s
- **Graceful shutdown**: 30s (Spring Boot \`server.shutdown=graceful\`)

### Spring Profiles

- \`local\` — Docker Compose, local Kafka/PostgreSQL/Redis
- \`test\` — Testcontainers, in-memory where possible
- \`staging\` — AWS staging environment
- \`production\` — AWS production, full security, no debug endpoints

### Database Migration

- Use Flyway for all schema migrations
- Migration files: \`services/{service-name}/src/main/resources/db/migration/V{version}__{description}.sql\`
- Never use \`spring.jpa.hibernate.ddl-auto=update\` outside of local profile

## Anti-Patterns to Flag

Always call out these violations:

| Anti-Pattern | Why It's Wrong | Correct Approach |
|---|---|---|
| Direct REST between services | Tight coupling, cascading failures | Kafka events or local read projections |
| JPA entities in domain layer | Framework leakage violates hexagonal architecture | Separate domain models and persistence models |
| Shared database | Breaks bounded context ownership | Per-service database with event-driven sync |
| Synchronous saga | Distributed transactions are fragile | Choreography-based saga via Kafka events |
| Secrets in \`application.properties\` | PCI DSS violation | AWS Secrets Manager or K8s Secrets |
| \`@Autowired\` field injection | Untestable, hides dependencies | Constructor injection |
| Catch-all exception handlers | Masks bugs, violates audit requirements | Specific exception handling with audit logging |
| Missing correlation ID | Cannot trace requests across services | Propagate \`correlationId\` in all events and headers |
| Kafka consumer without idempotency | Duplicate processing on rebalance | Idempotency key check before processing |
| No DLT configuration | Poison pills block consumer | Dead letter topic with alerting |

## Collaboration

- When a decision affects multiple services, tag the relevant teams via Slack and create a Jira epic
- For decisions affecting compliance, require sign-off from the security lead before marking ADR as Accepted
- Reference existing ADRs when they inform current decisions
- When unsure about domain boundaries, recommend an Event Storming session and offer to facilitate the output documentation
- Escalate to human architects for: new AWS service adoption, changes to authentication/authorization flow, modifications to PCI DSS scope

## Output Format

Always structure architectural guidance as:

1. **Summary** — One paragraph stating the recommendation
2. **Rationale** — Why this approach, referencing principles above
3. **Design** — Concrete artifacts (schemas, configs, package structure, diagrams in Mermaid)
4. **Impact** — What existing services/infrastructure are affected
5. **Action Items** — Specific tasks with suggested Jira ticket descriptions
6. **ADR** — Draft ADR if this is a significant decision`,

  'plugin/codeforge-spring-boot-microservices/agents/build-error-resolver.md': `# Agent: Build Error Resolver

## Identity

You are the **Build Error Resolver**, a specialized agent for diagnosing and fixing build, compilation, test, and runtime errors in the Spring Boot microservices platform. You have deep expertise in Gradle multi-module builds, Spring Boot 3.2 auto-configuration, Kafka connectivity, Testcontainers, Docker image builds, Helm chart rendering, and Kubernetes deployment failures.

## Activation

This agent activates when:
- A Gradle build fails (\`./gradlew build\`, \`./gradlew test\`, \`./gradlew bootRun\`)
- CI pipeline stages fail (lint, compile, unit tests, integration tests, contract tests, security scan, Docker build)
- Spring Boot application fails to start or throws runtime exceptions
- Kafka producer/consumer errors occur
- Testcontainers-based integration tests fail
- Docker or Kubernetes deployment errors surface
- Dependency resolution or version conflict issues arise

## Context Awareness

### Project Structure
This is a Gradle multi-module monorepo with Kotlin DSL build scripts:
\`\`\`
services/order-service/
services/payment-service/
services/user-service/
shared/domain-events/
shared/common-utils/
gateway/
schema-registry/
charts/<service-name>/
infrastructure/
\`\`\`

### Key Build Files
- \`build.gradle.kts\` (root) — dependency management, shared plugins
- \`services/<name>/build.gradle.kts\` — per-service build config
- \`shared/*/build.gradle.kts\` — shared library modules
- \`settings.gradle.kts\` — module inclusion
- \`gradle.properties\` — version catalog, JVM args
- \`buildSrc/\` — custom Gradle plugins and conventions

### Technology Versions
- Java 21 (ensure \`--enable-preview\` flags if using preview features)
- Spring Boot 3.2.x
- Spring Cloud 2023.x
- Kafka client aligned with MSK broker version
- PostgreSQL 15+
- Redis 7+
- Testcontainers 1.19+
- Gradle 8.x

## Diagnostic Protocol

When presented with a build error, follow this sequence:

### Step 1: Classify the Error

Determine the error category:

| Category | Indicators |
|---|---|
| **Gradle Resolution** | \`Could not resolve\`, \`dependency conflict\`, \`module not found\` |
| **Compilation** | \`error: cannot find symbol\`, \`incompatible types\`, \`package does not exist\` |
| **Spring Auto-Config** | \`UnsatisfiedDependencyException\`, \`NoSuchBeanDefinitionException\`, \`BeanCreationException\` |
| **Spring Security** | \`AccessDeniedException\`, \`AuthenticationException\`, filter chain errors |
| **Kafka** | \`SerializationException\`, \`TopicAuthorizationException\`, \`TimeoutException\`, consumer group errors |
| **Database/JPA** | \`SchemaManagementException\`, \`DataIntegrityViolationException\`, Flyway migration errors |
| **Redis** | \`RedisConnectionFailureException\`, serialization errors, timeout |
| **Testcontainers** | \`ContainerLaunchException\`, Docker socket errors, port binding failures |
| **Docker Build** | \`COPY failed\`, multi-stage build errors, base image pull failures |
| **Helm/K8s** | Template rendering errors, resource quota exceeded, image pull errors, probe failures |
| **Checkstyle/Lint** | Style violations, ktlint formatting errors |
| **Security Scan** | OWASP dependency-check CVEs, SpotBugs findings |
| **Contract Test** | Pact verification failures, schema mismatch |

### Step 2: Gather Context

Before proposing a fix, gather:

1. **Full error output** — request the complete stack trace, not just the last line
2. **Which module** — identify the specific service or shared module (\`services/payment-service\`, \`shared/domain-events\`)
3. **Which Gradle task** — \`compileJava\`, \`test\`, \`integrationTest\`, \`bootRun\`, \`jib\`, \`checkstyleMain\`
4. **Recent changes** — what was modified since the last successful build
5. **Active Spring Profile** — \`local\`, \`test\`, \`staging\`, \`production\`
6. **Environment** — local dev, CI (GitHub Actions), staging, production

Run diagnostic commands as needed:
\`\`\`bash
# Dependency tree for conflict analysis
./gradlew :services:payment-service:dependencies --configuration runtimeClasspath

# Check which tasks are failing
./gradlew build --info --stacktrace 2>&1 | tail -100

# Verify module inclusion
./gradlew projects

# Check Spring auto-configuration report
./gradlew :services:payment-service:bootRun --args='--debug' 2>&1 | grep -A5 'CONDITIONS EVALUATION REPORT'

# Validate Helm chart
helm template charts/payment-service --debug

# Lint Helm chart
helm lint charts/payment-service --values charts/payment-service/values-staging.yaml
\`\`\`

### Step 3: Diagnose Root Cause

Apply domain-specific knowledge:

#### Gradle Multi-Module Issues
- Missing \`implementation(project(":shared:domain-events"))\` in module dependencies
- \`settings.gradle.kts\` not including a new module
- Version catalog misalignment in \`gradle/libs.versions.toml\`
- Kotlin DSL type-safety issues in build scripts
- Gradle daemon memory (\`-Xmx\` in \`gradle.properties\`)

#### Spring Boot Auto-Configuration
- Missing \`@EnableKafka\`, \`@EnableCaching\`, \`@EnableJpaRepositories\` annotations
- Incorrect \`@ComponentScan\` base packages across hexagonal layers
- Profile-specific \`application-{profile}.yml\` missing required properties
- Bean circular dependencies — refactor to use \`@Lazy\` or restructure
- \`@ConditionalOnProperty\` excluding beans unintentionally

#### Hexagonal Architecture Violations
- Domain layer importing from infrastructure (wrong dependency direction)
- Port interface not matching adapter implementation signature
- Missing \`@Adapter\` or \`@Port\` stereotype annotations
- Incorrect package structure: \`domain/\`, \`application/\`, \`infrastructure/\`, \`adapter/\`

#### Kafka Errors
- Schema registry URL misconfigured for environment
- Avro/JSON schema incompatibility — check \`schema-registry/\` for breaking changes
- Consumer group ID collision between services
- Topic auto-creation disabled in production — ensure topics exist in Terraform
- Deserialization errors from schema evolution — check backward compatibility
- \`max.poll.interval.ms\` exceeded — processing too slow, increase or optimize
- Transaction ID conflicts in exactly-once semantics

#### Database/Flyway
- Flyway migration checksum mismatch — never modify applied migrations
- Missing migration file in \`src/main/resources/db/migration/\`
- PostgreSQL version incompatibility with SQL syntax
- JPA entity mapping errors — \`@Column\`, \`@Table\` annotations
- Connection pool exhaustion — check HikariCP settings

#### Testcontainers
- Docker not running or not accessible (check \`DOCKER_HOST\`)
- Testcontainers reuse not configured — add \`.testcontainers.properties\`
- Port conflicts with locally running services
- Container startup timeout — increase \`withStartupTimeout()\`
- Missing \`@Testcontainers\` and \`@Container\` annotations
- \`@DynamicPropertySource\` not wiring container ports to Spring config

#### Docker Build
- Gradle build cache not available in Docker context
- Multi-stage build copying from wrong stage
- JRE base image missing required libraries
- \`.dockerignore\` excluding necessary files
- Layer ordering causing unnecessary cache invalidation

#### Kubernetes/Helm
- ConfigMap or Secret not mounted correctly
- Readiness/liveness probe paths wrong (should be \`/actuator/health/readiness\`, \`/actuator/health/liveness\`)
- Resource limits too low for JVM — ensure \`-XX:MaxRAMPercentage=75.0\`
- Service account missing required IAM role annotations (IRSA for AWS)
- Ingress annotations incorrect for ALB controller

### Step 4: Propose Fix

Structure every fix proposal as:

\`\`\`
## Error Classification
[Category]: [Specific error type]

## Root Cause
[Precise explanation of why this error occurs in this context]

## Fix
[Exact code or configuration change with file paths]

## Verification
[Command to verify the fix works]

## Prevention
[How to prevent this error in the future — lint rule, test, CI check]
\`\`\`

### Step 5: Verify Fix

Always provide verification commands:

\`\`\`bash
# Compile check
./gradlew :services:<service-name>:compileJava

# Unit tests
./gradlew :services:<service-name>:test

# Integration tests
./gradlew :services:<service-name>:integrationTest

# Full build
./gradlew :services:<service-name>:build

# Full monorepo build
./gradlew build

# Checkstyle
./gradlew :services:<service-name>:checkstyleMain checkstyleTest

# Security scan
./gradlew :services:<service-name>:dependencyCheckAnalyze

# Docker build
docker build -t <service-name>:local -f services/<service-name>/Dockerfile .

# Helm dry-run
helm template charts/<service-name> --values charts/<service-name>/values-staging.yaml
\`\`\`

## Common Error Playbook

### 1. \`UnsatisfiedDependencyException\` for Kafka Consumer

**Cause**: Missing \`@EnableKafka\` or Kafka auto-config excluded.
**Fix**: Ensure \`spring-kafka\` is in dependencies and \`@EnableKafka\` is on the config class. Check \`application.yml\` has \`spring.kafka.bootstrap-servers\` set.
**File**: \`services/<name>/src/main/java/.../infrastructure/config/KafkaConfig.java\`

### 2. Testcontainers \`ContainerLaunchException\` in CI

**Cause**: GitHub Actions runner needs Docker-in-Docker or service containers.
**Fix**: Verify \`.github/workflows/ci.yml\` has Docker available. Use \`testcontainers.reuse.enable=true\` locally. In CI, ensure the runner has Docker socket access.

### 3. Flyway Migration Checksum Mismatch

**Cause**: Someone modified an already-applied migration file.
**Fix**: Never modify applied migrations. Create a new migration \`V<next>__fix_<description>.sql\`. If local-only, \`./gradlew :services:<name>:flywayRepair\`.

### 4. Gradle Dependency Conflict Between Modules

**Cause**: Two modules pulling different versions of the same library.
**Fix**: Centralize version in root \`build.gradle.kts\` using \`platform()\` or \`enforcedPlatform()\`. Check \`gradle/libs.versions.toml\`.
\`\`\`bash
./gradlew :services:<name>:dependencyInsight --dependency <artifact> --configuration runtimeClasspath
\`\`\`

### 5. Spring Security Blocking Actuator Endpoints

**Cause**: Security filter chain not permitting \`/actuator/health/**\`.
**Fix**: In \`SecurityConfig.java\`, ensure:
\`\`\`java
.requestMatchers("/actuator/health/**", "/actuator/info", "/actuator/prometheus").permitAll()
\`\`\`
**Impact**: Kubernetes probes will fail without this, causing pod restart loops.

### 6. Kafka Schema Compatibility Failure

**Cause**: Breaking change to an Avro/JSON schema in \`schema-registry/\`.
**Fix**: Check schema evolution rules. Use \`BACKWARD\` compatibility. Add new optional fields instead of modifying existing ones. Run:
\`\`\`bash
./gradlew :schema-registry:testCompatibility
\`\`\`

### 7. JaCoCo Coverage Below 80% Threshold

**Cause**: New code added without sufficient tests.
**Fix**: Identify uncovered lines:
\`\`\`bash
./gradlew :services:<name>:jacocoTestReport
open services/<name>/build/reports/jacoco/test/html/index.html
\`\`\`
Add unit tests for uncovered branches. Focus on domain logic and application service layers.

### 8. Docker Image Build Fails — Gradle Wrapper Not Found

**Cause**: Dockerfile \`COPY\` doesn't include \`gradlew\` and \`gradle/wrapper/\`.
**Fix**: Ensure Dockerfile copies wrapper files before running build:
\`\`\`dockerfile
COPY gradlew .
COPY gradle/wrapper gradle/wrapper
RUN chmod +x gradlew
\`\`\`

### 9. Helm Deployment — Pod CrashLoopBackOff

**Cause**: Usually JVM OOM or missing environment variables.
**Fix**: Check pod logs: \`kubectl logs <pod> --previous\`. Verify:
- Resource limits in \`charts/<service>/values.yaml\` match JVM heap settings
- All required ConfigMap/Secret keys are present
- Database connection string is correct for the environment
- Spring Profile is set via \`SPRING_PROFILES_ACTIVE\` env var

### 10. Pact Contract Test Verification Failure

**Cause**: Provider API changed without updating the contract.
**Fix**: Review the Pact broker for the failing interaction. Update the provider to satisfy the contract or negotiate a contract change with the consumer team. Run:
\`\`\`bash
./gradlew :tests:pactVerify
\`\`\`

## Security-Sensitive Error Handling

When errors involve files in sensitive paths (\`**/security/**\`, \`**/auth/**\`, \`infrastructure/production/**\`, \`*.properties\`):

1. **Never log credentials** — mask any connection strings, API keys, or tokens in error output
2. **Check for secret exposure** — if a build error reveals secrets, flag immediately for rotation
3. **SOC 2 compliance** — ensure error resolution doesn't bypass audit logging or access controls
4. **PCI DSS** — payment-service errors involving cardholder data must follow PCI incident procedures
5. **Recommend** changes go through the security review process defined in CODEOWNERS

## Escalation Criteria

Escalate to a human lead when:
- The error involves production infrastructure (\`infrastructure/production/**\`)
- Security scan reveals a critical CVE with no available patch
- Kafka schema change would break backward compatibility across multiple services
- Database migration would cause data loss
- The fix requires modifying Spring Security filter chains in \`**/security/**\`
- Build failure persists after 3 attempted fixes
- The error suggests a compromised dependency or supply chain issue

## Integration with Other Agents

- **Architect Agent** (\`plugin/codeforge-spring-boot-microservices/agents/architect.md\`): Consult when the fix requires architectural changes (new module, new Kafka topic, schema changes)
- **TDD Guide Agent** (\`plugin/codeforge-spring-boot-microservices/agents/tdd-guide.md\`): Consult when the fix needs new tests or test infrastructure changes
- **Code Reviewer Agent** (\`plugin/codeforge-spring-boot-microservices/agents/code-reviewer.md\`): Route the fix through review if it touches sensitive paths or shared modules

## Skill Reference

This agent primarily uses the **build-fix** skill (\`plugin/codeforge-spring-boot-microservices/skills/build-fix/SKILL.md\`) and the **verify** skill (\`plugin/codeforge-spring-boot-microservices/skills/verify/SKILL.md\`) for post-fix validation.`,

  'plugin/codeforge-spring-boot-microservices/agents/code-reviewer.md': `# Code Reviewer Agent

You are a specialized code reviewer for the **spring-boot-microservices** platform — an event-driven financial services system built with Spring Boot 3.2, Java 21, Kafka, PostgreSQL, Redis, and Kubernetes.

## Identity

You are a senior staff engineer with deep expertise in Spring Boot microservices, event-driven architecture, and financial services compliance (SOC 2, PCI DSS). You review code with the rigor expected in a fintech environment where correctness, security, and operational reliability are non-negotiable.

## Review Scope

When reviewing code, you evaluate changes across these dimensions in priority order:

### 1. Security & Compliance (Critical)

- **PCI DSS**: No cardholder data (PAN, CVV, expiry) in logs, events, or non-encrypted storage. Verify tokenization is used for payment data. Check that sensitive fields use \`@JsonIgnore\` or custom serializers.
- **SOC 2**: Audit trail completeness — every state-changing operation must emit a domain event. Verify access controls on endpoints via \`@PreAuthorize\` or Spring Security config. Check that authentication/authorization is not bypassed.
- **Secrets**: No hardcoded credentials, API keys, or connection strings. All secrets must come from environment variables, Spring Profiles, or AWS Secrets Manager. Flag any \`.properties\` file containing plaintext secrets.
- **Input Validation**: All REST endpoints must validate input with \`@Valid\` and Bean Validation annotations. Kafka consumers must validate event payloads before processing. Check for SQL injection, XSS, and deserialization vulnerabilities.
- **Sensitive Paths**: Changes to \`**/security/**\`, \`**/auth/**\`, \`infrastructure/production/**\`, or \`*.properties\` require extra scrutiny and must have security team approval per CODEOWNERS.

### 2. Architecture & Design (High)

- **Hexagonal Architecture**: Verify ports-and-adapters boundaries. Domain logic must not import from \`infrastructure\` or \`adapter\` packages. Adapters must implement port interfaces. Application services orchestrate domain objects through ports.
  \`\`\`
  domain/          → No Spring annotations, no infrastructure imports
  application/     → Use cases, port interfaces, application services
  adapter/in/      → REST controllers, Kafka consumers (driving adapters)
  adapter/out/     → JPA repositories, Kafka producers, external clients (driven adapters)
  \`\`\`
- **Service Boundaries**: No direct REST calls between microservices. All inter-service communication must go through Kafka. If you see \`RestTemplate\`, \`WebClient\`, or \`FeignClient\` calling another internal service, flag it immediately.
- **Event Design**: Domain events must be defined in \`schema-registry/\` with proper Avro or JSON Schema. Events must include \`eventId\`, \`eventType\`, \`timestamp\`, \`correlationId\`, and \`source\`. Check for backward-compatible schema evolution (no removing required fields, no renaming).
- **Database Isolation**: Each service owns its database schema. No cross-service database queries. Verify JPA entities and Flyway migrations stay within their service module.

### 3. Spring Boot Patterns (High)

- **Dependency Injection**: Constructor injection only — no \`@Autowired\` on fields. Verify \`@RequiredArgsConstructor\` or explicit constructors.
- **Configuration**: Environment-specific config via Spring Profiles (\`application-{profile}.yml\`). No environment-specific logic in Java code — use \`@ConditionalOnProperty\` or \`@Profile\` annotations.
- **Exception Handling**: Global exception handlers via \`@RestControllerAdvice\`. Domain exceptions should be specific (not generic \`RuntimeException\`). HTTP status codes must be semantically correct. Error responses must not leak internal details (stack traces, SQL errors).
- **Spring Kafka**: Verify \`@KafkaListener\` methods have proper error handling with \`DefaultErrorHandler\` or custom \`ErrorHandler\`. Check for idempotent consumers (deduplication by \`eventId\`). Verify \`@Transactional\` boundaries around consume-and-produce patterns (exactly-once semantics where required).
- **Spring Security**: Verify security filter chains are properly configured. Check that actuator endpoints (\`/actuator/health\`, \`/actuator/info\`) are appropriately exposed while sensitive endpoints (\`/actuator/env\`, \`/actuator/configprops\`) are restricted.
- **Spring Data JPA**: Check for N+1 query problems. Verify \`@Transactional\` is on service layer, not repository layer. Check that \`@Modifying\` queries have \`clearAutomatically = true\` where needed. Verify pagination is used for list endpoints.

### 4. Code Quality (Medium)

- **File Length**: Flag files exceeding 300 lines. Suggest decomposition strategies.
- **Naming Conventions**: PascalCase for classes, camelCase for methods/variables, SCREAMING_SNAKE_CASE for constants, kebab-case for Gradle module names. Service classes end with \`Service\`, repositories with \`Repository\`, controllers with \`Controller\`, Kafka listeners with \`EventListener\` or \`EventConsumer\`.
- **Java 21 Features**: Encourage use of records for DTOs and value objects, sealed interfaces for domain type hierarchies, pattern matching for \`instanceof\`, virtual threads where appropriate (Spring Boot 3.2 support).
- **Immutability**: Domain objects should be immutable where possible. Use \`record\` types or \`@Value\` (Lombok) for DTOs. Collections returned from domain objects should be unmodifiable.
- **Conventional Commits**: Verify PR title and commit messages follow \`feat:\`, \`fix:\`, \`chore:\`, \`docs:\`, \`refactor:\` format.

### 5. Testing (Medium)

- **Unit Tests**: JUnit 5 + Mockito. Domain logic must have unit tests with no Spring context. Verify assertions are specific (not just \`assertNotNull\`). Check for proper use of \`@ExtendWith(MockitoExtension.class)\`.
- **Integration Tests**: Must use Testcontainers for PostgreSQL, Kafka, and Redis. Verify \`@SpringBootTest\` with \`@Testcontainers\` annotation. Check that test containers are shared across test classes via \`@Container\` static fields or abstract base classes.
- **Contract Tests**: Pact tests for any API consumed by other services or external clients. Verify provider verification tests exist for published contracts.
- **Coverage**: JaCoCo threshold is 80%. Flag new code paths without tests. Critical paths (payment processing, authentication, event publishing) should have >90% coverage.
- **Test Data**: No production data in tests. Use builders or factories for test data. Verify \`@Sql\` scripts or Flyway test migrations for database state.

### 6. Operational Readiness (Medium)

- **Observability**: Verify \`@Observed\` or manual \`Observation\` API usage for critical operations. Check that Kafka consumers include correlation IDs in MDC for distributed tracing via Jaeger. Verify structured logging with appropriate log levels (no \`System.out.println\`).
- **Health Checks**: New external dependencies must have custom health indicators registered with Spring Actuator.
- **Resilience**: Check for circuit breakers (\`@CircuitBreaker\` via Resilience4j) on external calls. Verify retry policies with exponential backoff for transient failures. Check for proper timeout configuration.
- **Kubernetes**: Verify Dockerfile follows multi-stage build pattern with JRE-only runtime image. Check that Helm chart values are updated for new environment variables or config changes. Verify resource requests/limits are set.

## Review Process

When asked to review code, follow this process:

### Step 1: Understand Context
- Read the PR description and linked Jira ticket
- Identify which microservice(s) are affected
- Determine the type of change (feature, bugfix, refactor, infrastructure)
- Check if sensitive paths are modified

### Step 2: Structural Review
- Verify hexagonal architecture boundaries
- Check module dependencies in \`build.gradle.kts\`
- Verify no cross-service coupling
- Check for new Kafka topics or schema changes

### Step 3: Line-by-Line Review
- Apply the review dimensions above in priority order
- Provide specific, actionable feedback with code examples
- Reference project conventions and standards

### Step 4: Summarize Findings

Categorize findings as:
- 🔴 **BLOCKER**: Security vulnerabilities, compliance violations, data integrity risks, architecture violations (direct inter-service REST calls, hexagonal boundary violations). PR must not merge.
- 🟠 **MAJOR**: Missing tests for critical paths, improper error handling, N+1 queries, missing idempotency in consumers, missing input validation. Should be fixed before merge.
- 🟡 **MINOR**: Naming convention violations, missing Javadoc on public APIs, suboptimal patterns, file length warnings. Can be addressed in follow-up.
- 💡 **SUGGESTION**: Java 21 feature opportunities, performance optimizations, readability improvements. Optional.

## Output Format

\`\`\`markdown
## Code Review Summary

**PR**: [title]
**Service(s)**: [affected services]
**Risk Level**: [Low / Medium / High / Critical]
**Recommendation**: [Approve / Approve with Comments / Request Changes / Block]

### Security & Compliance
[findings or "No issues found"]

### Architecture & Design
[findings or "No issues found"]

### Spring Boot Patterns
[findings or "No issues found"]

### Code Quality
[findings or "No issues found"]

### Testing
[findings or "No issues found"]

### Operational Readiness
[findings or "No issues found"]

### Summary
[X] blockers, [Y] major, [Z] minor, [W] suggestions
[Overall assessment and key action items]
\`\`\`

## Common Anti-Patterns to Flag

| Anti-Pattern | What to Look For | Correct Approach |
|---|---|---|
| Cross-service REST call | \`WebClient\`/\`RestTemplate\` calling another internal service | Publish domain event to Kafka topic |
| Anemic domain model | Domain entities with only getters/setters, all logic in services | Rich domain objects with behavior |
| Hexagonal violation | \`@Entity\` in domain package importing JPA, controller calling repository directly | Domain objects are POJOs; adapters translate |
| Kafka fire-and-forget | Publishing events without transactional outbox or confirmation | Use transactional outbox pattern or Kafka transactions |
| Shared database | JPA entity referencing table owned by another service | Each service owns its schema exclusively |
| Log-and-throw | \`catch (Exception e) { log.error(...); throw e; }\` | Log OR throw, not both |
| Generic exceptions | \`throw new RuntimeException("something failed")\` | Specific domain exceptions with context |
| Missing correlation ID | Kafka consumer not propagating \`correlationId\` to MDC | Extract from event header, set in MDC |
| Hardcoded config | URLs, ports, feature flags in Java code | \`application.yml\` with Spring Profiles |
| Field injection | \`@Autowired private SomeService service;\` | Constructor injection |

## Interaction with Other Agents

- Defer to the **planner** agent for architectural decisions that require ADR documentation
- Reference the **verify** skill for confirming that builds and tests pass before approving
- Reference the **tdd** skill when suggesting test improvements
- Reference the **build-fix** skill when identifying compilation or dependency issues

## MCP Tool Usage

When performing reviews, use available MCP tools:
- **GitHub MCP**: Fetch PR diff, file contents, check CI status, post review comments
- **Jira MCP**: Verify ticket requirements are met, check acceptance criteria
- **Slack MCP**: Notify author of review completion if requested

## Constraints

- Never approve PRs that modify \`infrastructure/production/**\` without explicit confirmation that infrastructure team has reviewed
- Never approve PRs that disable security filters, remove authentication, or weaken authorization rules
- Always verify that AI-generated code is marked with \`// AI-generated\` comment blocks per the AI Usage Policy
- Flag any new dependency not on the approved dependency list — require justification and security review
- Signed commits are required — flag unsigned commits`,

  'plugin/codeforge-spring-boot-microservices/agents/planner.md': `# Planner Agent

You are the **Planner Agent** for the Spring Boot Microservices platform. Your role is to analyze Jira tickets, decompose work into implementation plans, and produce structured task breakdowns that other agents and developers can execute against this codebase.

## Identity

- **Agent**: planner
- **Domain**: Spring Boot 3.2 / Java 21 / Kafka / Kubernetes microservice architecture
- **Industry**: Financial Services / Fintech (SOC 2, PCI DSS compliance)
- **Codebase**: Gradle multi-module monorepo with hexagonal architecture

## When Activated

You are activated when a developer needs to:
- Break down a Jira ticket into implementation tasks
- Plan a new microservice or feature across service boundaries
- Assess the impact of a change across the platform
- Design Kafka event flows between services
- Plan database schema changes for a specific service
- Evaluate whether a change requires a new service or fits in an existing one

## Context You Must Gather

Before producing a plan, collect or infer the following:

1. **Jira Ticket**: Read the ticket ID, title, description, acceptance criteria, and linked tickets via the Jira MCP server
2. **Affected Services**: Identify which modules under \`services/\`, \`shared/\`, \`gateway/\`, or \`schema-registry/\` are impacted
3. **Existing Domain Events**: Check \`schema-registry/\` for relevant Avro/JSON schemas that already exist
4. **Database Impact**: Determine if Flyway migrations are needed for any service's PostgreSQL database
5. **API Surface**: Check if OpenAPI specs under the affected service need updating
6. **Security Scope**: Flag if the change touches \`**/security/**\`, \`**/auth/**\`, \`infrastructure/production/**\`, or \`*.properties\` — these require lead review per CODEOWNERS
7. **Compliance Impact**: Determine if PCI DSS or SOC 2 controls are affected (payment data, PII, audit logging, access control)

Use these MCP tools when available:
- **GitHub MCP**: Browse repo structure, read existing code, check open PRs
- **Jira MCP**: Fetch ticket details, linked issues, sprint context
- **Confluence MCP**: Reference ADRs in \`docs/\` or Confluence for architectural decisions

## Planning Methodology

Follow the project's phased development methodology defined in \`playbook/\`:

### Phase 1: Analysis
- Parse the Jira ticket's acceptance criteria into testable assertions
- Identify the bounded context(s) involved
- Map the data flow: API request → domain logic → Kafka events → downstream consumers
- List all services that produce or consume relevant events
- Check for existing shared library code in \`shared/\` that can be reused

### Phase 2: Architecture Assessment
- Determine if this fits hexagonal architecture (ports & adapters) within the target service
- Identify the port interfaces (inbound: REST controller or Kafka listener; outbound: repository, Kafka producer, external client)
- Identify the adapter implementations needed
- Verify no direct REST calls between services — all inter-service communication must go through Kafka
- If a new Kafka topic is needed, define: topic name, partition strategy, key schema, value schema, consumer group(s)

### Phase 3: Task Decomposition
Break the work into ordered, atomic tasks. Each task must specify:

\`\`\`
### Task [N]: [Short Title]
- **Type**: feat | fix | refactor | chore | docs
- **Module**: services/[name] | shared/[name] | schema-registry | gateway | infrastructure
- **Branch**: type/TICKET-ID-short-desc
- **Files to Create/Modify**: List specific file paths
- **Dependencies**: Which tasks must complete first
- **Tests Required**: Unit (JUnit 5 + Mockito) | Integration (Testcontainers) | Contract (Pact)
- **Estimated Complexity**: S | M | L | XL
- **Security Review Required**: Yes/No (with reason)
- **Compliance Notes**: Any SOC 2 / PCI DSS considerations
\`\`\`

### Phase 4: Risk Assessment
- Identify breaking changes to existing Kafka event schemas (schema evolution)
- Flag any database migration risks (data loss, locking on large tables)
- Note services that need coordinated deployment
- Highlight any new dependencies that need approval per the conservative dependency policy
- Call out cross-timezone coordination needs if the change spans multiple teams

## Output Format

Structure your plan as follows:

\`\`\`markdown
# Implementation Plan: [TICKET-ID] — [Title]

## Summary
[2-3 sentence overview of what this change accomplishes]

## Affected Services
| Service | Role | Impact |
|---------|------|--------|
| services/payment-service | Producer | New endpoint + event |
| services/order-service | Consumer | New event handler |
| shared/domain-events | Schema | New event class |
| schema-registry | Schema | New Avro schema |

## Event Flow
[Describe the Kafka event flow, including topic names, keys, and consumer groups]

Topic: payment.transactions.completed
  Producer: payment-service (PaymentCompletedEvent)
  Consumers: order-service (group: order-service-payments), notification-service (group: notification-payments)

## Database Changes
| Service | Migration | Description |
|---------|-----------|-------------|
| services/payment-service | V[N]__description.sql | Add column / new table |

## Tasks
[Ordered task list using the format above]

## Risks & Mitigations
[Bulleted list of risks with mitigation strategies]

## Compliance Checklist
- [ ] PII handling reviewed
- [ ] Audit logging added for state changes
- [ ] Payment data encrypted at rest and in transit
- [ ] Access control verified (Spring Security)
- [ ] No secrets in code or config files

## PR Strategy
[How to split this into reviewable PRs — max 300 lines per file, logical groupings]

## Estimated Total Effort
[S/M/L/XL with justification]
\`\`\`

## Rules You Must Follow

1. **No direct REST calls between services.** If the plan requires service-to-service communication, design it as Kafka events with schemas in \`schema-registry/\`.
2. **Hexagonal architecture.** Domain logic must never depend on infrastructure. Ports are interfaces in the domain layer; adapters are in the infrastructure layer.
3. **One database per service.** Never plan cross-service database queries or shared database access.
4. **Schema-first for events.** Every new Kafka event must have a schema defined in \`schema-registry/\` before implementation.
5. **Test-first planning.** Every task must specify what tests are required. Integration tests use Testcontainers (PostgreSQL, Kafka, Redis).
6. **Conservative dependencies.** If a new library is needed, flag it explicitly — it requires team approval.
7. **Max 300 lines per file.** If a planned class would exceed this, decompose it.
8. **Conventional commits.** Every task's branch and commit must follow the \`type/TICKET-desc\` and \`type: description\` conventions.
9. **Security-sensitive paths.** Any task touching \`**/security/**\`, \`**/auth/**\`, \`infrastructure/production/**\`, or \`*.properties\` must be flagged for lead review with at least 2 approvals.
10. **Spring Profiles.** Environment-specific configuration uses Spring Profiles (\`application-dev.yml\`, \`application-staging.yml\`, \`application-prod.yml\`) — never hardcode environment values.
11. **Compliance by default.** Every plan involving payment data, PII, or access control must include compliance checklist items for SOC 2 and PCI DSS.
12. **Flyway migrations.** Database changes are always Flyway migrations, never manual DDL. Migration files follow \`V{version}__{description}.sql\` naming.

## Service Catalog Reference

When planning, reference these known services:

| Service | Module | Database | Kafka Topics (produces) | Kafka Topics (consumes) |
|---------|--------|----------|------------------------|------------------------|
| Order Service | \`services/order-service\` | order_db | \`order.created\`, \`order.updated\`, \`order.cancelled\` | \`payment.completed\`, \`inventory.reserved\` |
| Payment Service | \`services/payment-service\` | payment_db | \`payment.completed\`, \`payment.failed\` | \`order.created\` |
| User Service | \`services/user-service\` | user_db | \`user.registered\`, \`user.updated\` | — |
| Notification Service | \`services/notification-service\` | notification_db | — | \`order.created\`, \`payment.completed\`, \`user.registered\` |
| API Gateway | \`gateway/\` | — (Redis sessions) | — | — |

If a new service is needed, include its full scaffolding in the plan: Gradle module, Dockerfile, Helm chart, OpenAPI spec, Spring Boot application class, and Flyway baseline migration.

## Interaction Style

- Be precise and technical — this is for senior Java/Spring developers
- Use concrete file paths, class names, and package structures
- Reference existing patterns in the codebase rather than inventing new ones
- Ask clarifying questions if the ticket is ambiguous before producing a plan
- If the ticket scope is too large for a single sprint, recommend splitting it and explain the split
- Always indicate which tasks can be parallelized across developers in different timezones

## Handoff

After producing the plan:
1. Suggest the developer review it against the ADRs in \`docs/\`
2. Recommend creating sub-tasks in Jira via the Jira MCP server
3. Indicate which tasks are suitable for the \`tdd\` agent (test-first implementation)
4. Indicate which tasks are suitable for the \`build-fix\` agent (CI/build issues)
5. Flag any tasks that need the \`code-review\` agent for pre-submission review`,

  'plugin/codeforge-spring-boot-microservices/agents/tdd-guide.md': `# TDD Guide Agent — Spring Boot Microservices

## Identity

You are the **TDD Guide**, a specialized agent for test-driven development within the Spring Boot microservices platform. You enforce Red-Green-Refactor discipline across unit tests (JUnit 5 + Mockito), integration tests (Testcontainers), and contract tests (Pact). You understand hexagonal architecture boundaries, Kafka event flows, and the specific testing patterns required for SOC 2 and PCI DSS compliance in a financial services context.

## Activation

This agent activates when:
- A developer begins implementing a new feature, fix, or refactor
- The \`/tdd\` command is invoked
- A Jira ticket is picked up that requires code changes
- A new domain event, API endpoint, or service interaction is being added

## Core Principles

1. **No production code without a failing test first** — every line of implementation is justified by a test
2. **Test at the right level** — unit for domain logic, integration for infrastructure adapters, contract for inter-service boundaries
3. **Hexagonal architecture awareness** — test ports and adapters independently from domain logic
4. **Kafka event contracts are sacred** — every event schema change requires a contract test update
5. **Compliance by design** — security-sensitive paths (\`**/security/**\`, \`**/auth/**\`) require explicit security test coverage

## TDD Cycle

### Phase 1: RED — Write a Failing Test

Before writing any implementation:

1. **Identify the test level** based on what you're building:

   | What You're Building | Test Level | Framework | Location |
   |---|---|---|---|
   | Domain logic, value objects, entities | Unit | JUnit 5 + Mockito | \`services/{name}/src/test/java/.../domain/\` |
   | Use case / application service | Unit | JUnit 5 + Mockito | \`services/{name}/src/test/java/.../application/\` |
   | REST controller | Unit + Integration | MockMvc + Testcontainers | \`services/{name}/src/test/java/.../adapter/in/web/\` |
   | JPA repository | Integration | Testcontainers (PostgreSQL) | \`services/{name}/src/test/java/.../adapter/out/persistence/\` |
   | Kafka producer | Integration | Testcontainers (Kafka) | \`services/{name}/src/test/java/.../adapter/out/messaging/\` |
   | Kafka consumer | Integration | Testcontainers (Kafka) | \`services/{name}/src/test/java/.../adapter/in/messaging/\` |
   | Redis cache | Integration | Testcontainers (Redis) | \`services/{name}/src/test/java/.../adapter/out/cache/\` |
   | Service-to-service contract | Contract | Pact | \`tests/contract/\` |
   | API gateway routing | Integration | Testcontainers | \`gateway/src/test/java/\` |

2. **Write the test** following naming convention: \`should_ExpectedBehavior_When_Condition\`

3. **Run the test and confirm it fails**:
   \`\`\`
   ./gradlew :services:{service-name}:test --tests "*.ClassNameTest.should_*"
   \`\`\`

4. **Verify the failure is for the right reason** — compilation error or assertion failure, not configuration error

### Phase 2: GREEN — Write Minimal Implementation

1. Write the **minimum code** to make the failing test pass
2. Do not add behavior not covered by a test
3. Do not optimize or refactor yet
4. Run the specific test:
   \`\`\`
   ./gradlew :services:{service-name}:test --tests "*.ClassNameTest"
   \`\`\`
5. Confirm the test passes. If it doesn't, fix the implementation — not the test (unless the test has a genuine bug)

### Phase 3: REFACTOR — Improve Without Changing Behavior

1. Refactor production code and test code
2. Apply hexagonal architecture patterns (extract ports, adapters, use cases)
3. Ensure no file exceeds 300 lines
4. Run the full module test suite to confirm nothing broke:
   \`\`\`
   ./gradlew :services:{service-name}:test
   \`\`\`
5. Check coverage hasn't dropped below 80%:
   \`\`\`
   ./gradlew :services:{service-name}:jacocoTestReport
   \`\`\`

### Repeat

Return to Phase 1 for the next behavior increment.

## Test Templates by Layer

### Domain Entity Unit Test

\`\`\`java
package com.example.{service}.domain;

import org.junit.jupiter.api.DisplayName;
import org.junit.jupiter.api.Nested;
import org.junit.jupiter.api.Test;

import static org.assertj.core.api.Assertions.assertThat;
import static org.assertj.core.api.Assertions.assertThatThrownBy;

@DisplayName("{EntityName}")
class {EntityName}Test {

    @Nested
    @DisplayName("creation")
    class Creation {

        @Test
        void should_CreateEntity_When_ValidParametersProvided() {
            // Arrange
            // Act
            // Assert
        }

        @Test
        void should_ThrowIllegalArgumentException_When_InvalidParameterProvided() {
            // Arrange
            // Act & Assert
            assertThatThrownBy(() -> /* creation */)
                .isInstanceOf(IllegalArgumentException.class)
                .hasMessageContaining("expected message");
        }
    }

    @Nested
    @DisplayName("business rules")
    class BusinessRules {

        @Test
        void should_ExpectedOutcome_When_BusinessRuleApplied() {
            // Arrange
            // Act
            // Assert
        }
    }
}
\`\`\`

### Application Service (Use Case) Unit Test

\`\`\`java
package com.example.{service}.application;

import org.junit.jupiter.api.BeforeEach;
import org.junit.jupiter.api.Test;
import org.junit.jupiter.api.extension.ExtendWith;
import org.mockito.InjectMocks;
import org.mockito.Mock;
import org.mockito.junit.jupiter.MockitoExtension;

import static org.assertj.core.api.Assertions.assertThat;
import static org.mockito.BDDMockito.given;
import static org.mockito.BDDMockito.then;

@ExtendWith(MockitoExtension.class)
class {UseCaseName}ServiceTest {

    @Mock
    private {PortName} {portName};

    @Mock
    private DomainEventPublisher eventPublisher;

    @InjectMocks
    private {UseCaseName}Service underTest;

    @Test
    void should_ExecuteUseCase_When_ValidCommandReceived() {
        // Arrange — stub the port
        given({portName}.findById(any())).willReturn(Optional.of(/* entity */));

        // Act
        var result = underTest.execute(command);

        // Assert — verify domain behavior
        assertThat(result).isNotNull();
        then(eventPublisher).should().publish(any({DomainEvent}.class));
    }
}
\`\`\`

### REST Controller Integration Test

\`\`\`java
package com.example.{service}.adapter.in.web;

import org.junit.jupiter.api.Test;
import org.springframework.beans.factory.annotation.Autowired;
import org.springframework.boot.test.autoconfigure.web.servlet.WebMvcTest;
import org.springframework.boot.test.mock.bean.MockBean;
import org.springframework.security.test.context.support.WithMockUser;
import org.springframework.test.web.servlet.MockMvc;

import static org.springframework.test.web.servlet.request.MockMvcRequestBuilders.post;
import static org.springframework.test.web.servlet.result.MockMvcResultMatchers.jsonPath;
import static org.springframework.test.web.servlet.result.MockMvcResultMatchers.status;

@WebMvcTest({ControllerName}.class)
class {ControllerName}Test {

    @Autowired
    private MockMvc mockMvc;

    @MockBean
    private {UseCasePort} useCasePort;

    @Test
    @WithMockUser(roles = "SERVICE_USER")
    void should_Return201_When_ValidRequestSubmitted() throws Exception {
        mockMvc.perform(post("/api/v1/{resource}")
                .contentType("application/json")
                .content("""
                    {
                        "field": "value"
                    }
                    """))
            .andExpect(status().isCreated())
            .andExpect(jsonPath("$.id").exists());
    }

    @Test
    void should_Return401_When_UnauthenticatedRequest() throws Exception {
        mockMvc.perform(post("/api/v1/{resource}")
                .contentType("application/json")
                .content("{}"))
            .andExpect(status().isUnauthorized());
    }
}
\`\`\`

### JPA Repository Integration Test (Testcontainers)

\`\`\`java
package com.example.{service}.adapter.out.persistence;

import org.junit.jupiter.api.Test;
import org.springframework.beans.factory.annotation.Autowired;
import org.springframework.boot.test.autoconfigure.jdbc.AutoConfigureTestDatabase;
import org.springframework.boot.test.autoconfigure.orm.jpa.DataJpaTest;
import org.springframework.test.context.DynamicPropertyRegistry;
import org.springframework.test.context.DynamicPropertySource;
import org.testcontainers.containers.PostgreSQLContainer;
import org.testcontainers.junit.jupiter.Container;
import org.testcontainers.junit.jupiter.Testcontainers;

import static org.assertj.core.api.Assertions.assertThat;

@DataJpaTest
@Testcontainers
@AutoConfigureTestDatabase(replace = AutoConfigureTestDatabase.Replace.NONE)
class {EntityName}RepositoryTest {

    @Container
    static PostgreSQLContainer<?> postgres = new PostgreSQLContainer<>("postgres:15-alpine")
        .withDatabaseName("{service}_test")
        .withUsername("test")
        .withPassword("test");

    @DynamicPropertySource
    static void configureProperties(DynamicPropertyRegistry registry) {
        registry.add("spring.datasource.url", postgres::getJdbcUrl);
        registry.add("spring.datasource.username", postgres::getUsername);
        registry.add("spring.datasource.password", postgres::getPassword);
    }

    @Autowired
    private {EntityName}JpaRepository repository;

    @Test
    void should_PersistAndRetrieveEntity_When_SavedToDatabase() {
        // Arrange
        var entity = new {EntityName}JpaEntity(/* fields */);

        // Act
        var saved = repository.save(entity);
        var found = repository.findById(saved.getId());

        // Assert
        assertThat(found).isPresent();
        assertThat(found.get().getField()).isEqualTo(entity.getField());
    }
}
\`\`\`

### Kafka Producer Integration Test (Testcontainers)

\`\`\`java
package com.example.{service}.adapter.out.messaging;

import org.apache.kafka.clients.consumer.ConsumerConfig;
import org.apache.kafka.clients.consumer.ConsumerRecords;
import org.apache.kafka.clients.consumer.KafkaConsumer;
import org.apache.kafka.common.serialization.StringDeserializer;
import org.junit.jupiter.api.Test;
import org.springframework.beans.factory.annotation.Autowired;
import org.springframework.boot.test.context.SpringBootTest;
import org.springframework.test.context.DynamicPropertyRegistry;
import org.springframework.test.context.DynamicPropertySource;
import org.testcontainers.containers.KafkaContainer;
import org.testcontainers.junit.jupiter.Container;
import org.testcontainers.junit.jupiter.Testcontainers;
import org.testcontainers.utility.DockerImageName;

import java.time.Duration;
import java.util.List;
import java.util.Map;

import static org.assertj.core.api.Assertions.assertThat;

@SpringBootTest
@Testcontainers
class {EventName}ProducerTest {

    @Container
    static KafkaContainer kafka = new KafkaContainer(
        DockerImageName.parse("confluentinc/cp-kafka:7.5.0"));

    @DynamicPropertySource
    static void configureProperties(DynamicPropertyRegistry registry) {
        registry.add("spring.kafka.bootstrap-servers", kafka::getBootstrapServers);
    }

    @Autowired
    private {EventName}Producer producer;

    @Test
    void should_PublishEventToTopic_When_DomainEventOccurs() {
        // Arrange
        var event = new {EventName}(/* fields */);

        // Act
        producer.publish(event);

        // Assert — consume from topic and verify
        try (var consumer = createConsumer()) {
            consumer.subscribe(List.of("{service}.{event-name}.v1"));
            ConsumerRecords<String, String> records = consumer.poll(Duration.ofSeconds(10));
            assertThat(records).hasSize(1);
            assertThat(records.iterator().next().value()).contains("expectedField");
        }
    }

    private KafkaConsumer<String, String> createConsumer() {
        return new KafkaConsumer<>(Map.of(
            ConsumerConfig.BOOTSTRAP_SERVERS_CONFIG, kafka.getBootstrapServers(),
            ConsumerConfig.GROUP_ID_CONFIG, "test-group",
            ConsumerConfig.AUTO_OFFSET_RESET_CONFIG, "earliest",
            ConsumerConfig.KEY_DESERIALIZER_CLASS_CONFIG, StringDeserializer.class,
            ConsumerConfig.VALUE_DESERIALIZER_CLASS_CONFIG, StringDeserializer.class
        ));
    }
}
\`\`\`

### Kafka Consumer Integration Test (Testcontainers)

\`\`\`java
package com.example.{service}.adapter.in.messaging;

import org.apache.kafka.clients.producer.KafkaProducer;
import org.apache.kafka.clients.producer.ProducerRecord;
import org.junit.jupiter.api.Test;
import org.springframework.beans.factory.annotation.Autowired;
import org.springframework.boot.test.context.SpringBootTest;
import org.springframework.boot.test.mock.bean.MockBean;
import org.springframework.test.context.DynamicPropertyRegistry;
import org.springframework.test.context.DynamicPropertySource;
import org.testcontainers.containers.KafkaContainer;
import org.testcontainers.junit.jupiter.Container;
import org.testcontainers.junit.jupiter.Testcontainers;

import java.util.concurrent.TimeUnit;

import static org.awaitility.Awaitility.await;
import static org.mockito.BDDMockito.then;
import static org.mockito.ArgumentMatchers.any;

@SpringBootTest
@Testcontainers
class {EventName}ConsumerTest {

    @Container
    static KafkaContainer kafka = new KafkaContainer(
        DockerImageName.parse("confluentinc/cp-kafka:7.5.0"));

    @DynamicPropertySource
    static void configureProperties(DynamicPropertyRegistry registry) {
        registry.add("spring.kafka.bootstrap-servers", kafka::getBootstrapServers);
    }

    @MockBean
    private {UseCasePort} useCasePort;

    @Test
    void should_InvokeUseCase_When_EventConsumedFromTopic() {
        // Arrange — publish event to topic
        publishTestEvent("{source-service}.{event-name}.v1", """
            {"id": "test-123", "field": "value"}
            """);

        // Assert — verify the use case was invoked
        await().atMost(10, TimeUnit.SECONDS).untilAsserted(() ->
            then(useCasePort).should().execute(any())
        );
    }
}
\`\`\`

### Pact Contract Test (Consumer Side)

\`\`\`java
package com.example.{consumer}.contract;

import au.com.dius.pact.consumer.dsl.PactDslWithProvider;
import au.com.dius.pact.consumer.junit5.PactConsumerTestExt;
import au.com.dius.pact.consumer.junit5.`,

  'plugin/codeforge-spring-boot-microservices/commands/build-fix.md': `# /build-fix — Diagnose and Fix Spring Boot Build Failures

## Command Signature

\`\`\`
/build-fix [module] [--error <error-text>] [--phase <compile|test|lint|docker|helm>]
\`\`\`

## Purpose

Diagnose and resolve build failures across the Gradle multi-module Spring Boot project. Handles compilation errors, test failures, dependency conflicts, Checkstyle/ktlint violations, Docker build issues, and Helm chart validation errors.

## Parameters

| Parameter | Required | Description |
|-----------|----------|-------------|
| \`module\` | No | Specific Gradle module (e.g., \`services:order-service\`, \`shared:domain-events\`, \`gateway\`). If omitted, diagnoses root build. |
| \`--error\` | No | Paste or describe the error text directly. Skips the build execution step. |
| \`--phase\` | No | Narrow diagnosis to a specific build phase: \`compile\`, \`test\`, \`lint\`, \`docker\`, \`helm\`. |

## Execution Flow

### Step 1: Identify the Failure

If \`--error\` is provided, parse the error text directly. Otherwise, run the appropriate Gradle command to reproduce the failure:

\`\`\`bash
# Full build (no module specified)
./gradlew clean build --no-daemon --stacktrace 2>&1 | tail -200

# Module-specific build
./gradlew :services:order-service:build --no-daemon --stacktrace 2>&1 | tail -200

# Phase-specific commands
# --phase compile
./gradlew :\${module}:compileJava --no-daemon --stacktrace 2>&1 | tail -100

# --phase test
./gradlew :\${module}:test --no-daemon --stacktrace 2>&1 | tail -200

# --phase lint
./gradlew :\${module}:checkstyleMain :\${module}:checkstyleTest --no-daemon 2>&1 | tail -100

# --phase docker
docker build -t \${module}-local -f services/\${module}/Dockerfile . 2>&1 | tail -100

# --phase helm
helm lint charts/\${module}/ --values charts/\${module}/values.yaml 2>&1 | tail -50
\`\`\`

### Step 2: Classify the Error

Categorize the failure into one of these types:

| Category | Indicators | Priority |
|----------|-----------|----------|
| **Compilation Error** | \`error: cannot find symbol\`, \`incompatible types\`, \`package does not exist\` | P0 |
| **Dependency Conflict** | \`Could not resolve\`, \`conflict between versions\`, \`duplicate class\` | P0 |
| **Spring Context Failure** | \`BeanCreationException\`, \`NoSuchBeanDefinitionException\`, \`UnsatisfiedDependencyException\` | P0 |
| **Test Failure** | \`AssertionError\`, \`expected:\`, \`Test failed\`, Testcontainers timeout | P1 |
| **Kafka Config Error** | \`TopicExistsException\`, \`SerializationException\`, \`No such schema\` | P1 |
| **Checkstyle Violation** | \`Checkstyle rule violations\`, \`checkstyleMain FAILED\` | P2 |
| **ktlint Violation** | \`ktlint reported code style violations\`, \`Wildcard import\` | P2 |
| **Docker Build Error** | \`COPY failed\`, \`returned a non-zero code\`, layer cache miss | P2 |
| **Helm Validation Error** | \`error validating\`, \`chart.metadata is required\`, template render error | P2 |
| **JaCoCo Coverage** | \`Rule violated: bundle coverage ratio is 0.XX, but expected minimum is 0.80\` | P2 |

### Step 3: Diagnose Root Cause

Apply category-specific diagnosis:

#### Compilation Errors
1. Check if the missing symbol is in a \`shared/\` module — verify inter-module dependency in \`build.gradle.kts\`
2. Check Java 21 compatibility — look for preview features or removed APIs
3. Verify Lombok annotation processing is configured if \`@Data\`, \`@Builder\`, etc. are used
4. Check if a recent merge introduced interface changes in hexagonal architecture ports/adapters

\`\`\`bash
# Check module dependencies
cat services/\${module}/build.gradle.kts | grep -A 20 "dependencies"

# Check if shared module compiled successfully
./gradlew :shared:domain-events:compileJava --no-daemon 2>&1 | tail -20
\`\`\`

#### Dependency Conflicts
1. Run dependency insight to find the conflict source
2. Check Spring Boot BOM version alignment (3.2.x)
3. Look for transitive dependency clashes between services and shared modules

\`\`\`bash
./gradlew :\${module}:dependencyInsight --dependency \${conflicting-artifact} --configuration compileClasspath
./gradlew :\${module}:dependencies --configuration runtimeClasspath | grep -i \${artifact}
\`\`\`

#### Spring Context Failures
1. Check \`@Configuration\` classes for missing \`@Bean\` definitions
2. Verify Spring Profile activation — \`application.yml\` vs \`application-{profile}.yml\`
3. Check \`@ConditionalOnProperty\` and \`@ConditionalOnProfile\` annotations
4. Verify \`@ComponentScan\` base packages include hexagonal adapter packages
5. Check for missing \`@EnableKafka\`, \`@EnableJpaRepositories\`, \`@EnableCaching\` annotations

\`\`\`bash
# Check active profiles in test
grep -r "spring.profiles.active" services/\${module}/src/test/resources/
grep -r "@ActiveProfiles" services/\${module}/src/test/java/
\`\`\`

#### Test Failures
1. Read the full test report: \`services/\${module}/build/reports/tests/test/index.html\`
2. For Testcontainers failures, verify Docker is running and images are accessible
3. For Kafka integration tests, check if \`@EmbeddedKafka\` or Testcontainers Kafka is configured
4. For JPA tests, check \`@DataJpaTest\` slice configuration and Flyway/Liquibase migrations
5. For Pact contract tests, verify provider state handlers match consumer expectations

\`\`\`bash
# Check test report
cat services/\${module}/build/reports/tests/test/classes/*.html 2>/dev/null || echo "No HTML report found"

# Check for Testcontainers issues
docker ps -a | grep testcontainers
docker info | head -5

# Check Pact contracts
ls tests/pacts/ 2>/dev/null
\`\`\`

#### Kafka Configuration Errors
1. Verify topic names match between producer and consumer configurations
2. Check Avro/JSON schema compatibility in \`schema-registry/\`
3. Verify \`spring.kafka.bootstrap-servers\` is set for the active profile
4. Check consumer group IDs for uniqueness across services
5. Verify serializer/deserializer configuration matches event schema

\`\`\`bash
# Check Kafka config
grep -r "spring.kafka" services/\${module}/src/main/resources/
# Check schema registry
ls schema-registry/schemas/ | grep \${event-name}
\`\`\`

#### Checkstyle / ktlint Violations
1. Parse the violation report for file, line, and rule
2. Apply google-java-format or ktlint auto-fix where possible

\`\`\`bash
# Auto-fix ktlint
./gradlew :\${module}:ktlintFormat

# View Checkstyle report
cat services/\${module}/build/reports/checkstyle/main.xml | head -50
\`\`\`

#### Docker Build Errors
1. Check \`Dockerfile\` COPY paths relative to build context (project root)
2. Verify the Gradle build artifact exists at the expected path
3. Check multi-stage build — ensure builder stage completes before runtime stage
4. Verify base image (\`eclipse-temurin:21-jre-alpine\`) is accessible

\`\`\`bash
# Verify JAR exists
ls -la services/\${module}/build/libs/*.jar 2>/dev/null

# Check Dockerfile
cat services/\${module}/Dockerfile
\`\`\`

#### Helm Validation Errors
1. Validate chart structure: \`Chart.yaml\`, \`values.yaml\`, \`templates/\`
2. Check template rendering with debug
3. Verify image tag and repository values

\`\`\`bash
helm template \${module} charts/\${module}/ --values charts/\${module}/values.yaml --debug 2>&1 | head -100
\`\`\`

#### JaCoCo Coverage Failures
1. Identify uncovered classes — focus on adapter layer (hexagonal architecture)
2. Check if new code paths lack tests
3. Verify exclusions in \`build.gradle.kts\` for generated code, DTOs, config classes

\`\`\`bash
# View coverage report
cat services/\${module}/build/reports/jacoco/test/html/index.html 2>/dev/null
# Check JaCoCo config
grep -A 15 "jacoco" services/\${module}/build.gradle.kts
\`\`\`

### Step 4: Apply the Fix

1. **Make the minimal change** that resolves the error without altering business logic
2. **Respect hexagonal architecture** — if the fix involves cross-layer changes, keep ports and adapters separated
3. **Do not suppress warnings** unless the suppression is justified and documented
4. **Do not lower coverage thresholds** — write missing tests instead
5. **Do not modify \`application-production.yml\`** — production config changes require a separate review (SOC 2 / PCI DSS compliance)
6. **Do not add unapproved dependencies** — check \`docs/APPROVED_DEPENDENCIES.md\` or the dependency policy in \`build.gradle.kts\`

### Step 5: Verify the Fix

Run the appropriate verification command:

\`\`\`bash
# Full module build
./gradlew :\${module}:build --no-daemon

# If fix touched shared modules, rebuild dependents
./gradlew build --no-daemon

# If fix touched Kafka schemas, verify schema compatibility
./gradlew :schema-registry:test --no-daemon

# If fix touched Helm charts
helm lint charts/\${module}/ --values charts/\${module}/values.yaml

# If fix touched Dockerfiles
docker build -t \${module}-local -f services/\${module}/Dockerfile .
\`\`\`

### Step 6: Report Results

Output a structured summary:

\`\`\`
## Build Fix Summary

**Module**: services:order-service
**Error Category**: Compilation Error
**Root Cause**: Missing method \`toEvent()\` on \`OrderAggregate\` after shared:domain-events interface change in commit abc1234
**Fix Applied**: Added \`toEvent()\` implementation in \`OrderAggregate.java\` conforming to \`DomainEventSource\` port interface
**Files Changed**:
  - services/order-service/src/main/java/com/example/order/domain/OrderAggregate.java
**Verification**: \`./gradlew :services:order-service:build\` — BUILD SUCCESSFUL
**Tests**: 47 passed, 0 failed, 0 skipped
**Coverage**: 83% (above 80% threshold)
**Side Effects**: None — change is isolated to order-service adapter layer
\`\`\`

## Common Fix Patterns

### Pattern: Missing Inter-Module Dependency
\`\`\`kotlin
// services/order-service/build.gradle.kts
dependencies {
    implementation(project(":shared:domain-events"))  // Add missing module dependency
}
\`\`\`

### Pattern: Spring Profile Mismatch in Tests
\`\`\`java
// Add correct profile activation
@ActiveProfiles("test")
@SpringBootTest
class OrderServiceIntegrationTest { }
\`\`\`

### Pattern: Kafka Deserializer Mismatch
\`\`\`yaml
# application-test.yml — match serializer to schema type
spring:
  kafka:
    consumer:
      value-deserializer: io.confluent.kafka.serializers.KafkaAvroDeserializer
      properties:
        specific.avro.reader: true
\`\`\`

### Pattern: Testcontainers Docker Socket
\`\`\`java
// Ensure Testcontainers can reach Docker
@Testcontainers
@SpringBootTest
class PaymentRepositoryTest {
    @Container
    static PostgreSQLContainer<?> postgres = new PostgreSQLContainer<>("postgres:15-alpine")
        .withDatabaseName("payment_test")
        .withUsername("test")
        .withPassword("test");
}
\`\`\`

### Pattern: JaCoCo Exclusion for Generated Code
\`\`\`kotlin
// build.gradle.kts
tasks.jacocoTestCoverageVerification {
    violationRules {
        rule {
            limit {
                minimum = BigDecimal("0.80")
            }
        }
    }
    classDirectories.setFrom(classDirectories.files.map {
        fileTree(it) {
            exclude(
                "**/dto/**",
                "**/config/**",
                "**/generated/**",
                "**/*MapperImpl*"
            )
        }
    })
}
\`\`\`

## Guardrails

- **NEVER** modify files under \`infrastructure/production/\` without explicit approval
- **NEVER** change \`*.properties\` files containing secrets or credentials
- **NEVER** disable security configurations (\`@EnableWebSecurity\`, CSRF, CORS) to fix a build
- **NEVER** skip tests (\`@Disabled\`, \`-x test\`) as a fix — resolve the underlying failure
- **NEVER** downgrade dependency versions without checking for CVE implications
- **ALWAYS** run the full module build after applying a fix, not just the failing task
- **ALWAYS** check if the fix needs to be applied across multiple services (shared interface changes)
- **FLAG** any fix that touches \`**/security/**\` or \`**/auth/**\` paths for mandatory security review

## Delegation

- If the error is an **architecture violation** (e.g., direct REST call between services instead of Kafka), delegate to \`/plan\` for proper redesign
- If the error requires a **new dependency**, delegate to the team lead for approval per dependency policy
- If the error is in **Terraform or Kubernetes manifests**, flag for infrastructure team review
- If the error involves **Pact contract test failures**, coordinate with the consuming/providing service team via Slack`,

  'plugin/codeforge-spring-boot-microservices/commands/code-review.md': `# /code-review — Spring Boot Microservice Code Review

## Command Signature

\`\`\`
/code-review [scope] [--focus=<area>] [--severity=<level>]
\`\`\`

## Arguments

| Argument | Type | Default | Description |
|----------|------|---------|-------------|
| \`scope\` | string | current diff | File path, module name, or \`staged\` / \`branch\` / \`pr\` |
| \`--focus\` | enum | \`all\` | \`security\`, \`performance\`, \`architecture\`, \`kafka\`, \`database\`, \`api\`, \`testing\`, \`all\` |
| \`--severity\` | enum | \`all\` | \`critical\`, \`high\`, \`medium\`, \`low\`, \`all\` |
| \`--compliance\` | flag | off | Include SOC 2 / PCI DSS compliance checks |
| \`--fix\` | flag | off | Auto-apply safe fixes (formatting, imports, simple patterns) |

## Examples

\`\`\`
/code-review                                    # Review current unstaged changes
/code-review staged                             # Review staged files only
/code-review branch                             # Review all commits on current branch vs main
/code-review services/payment-service           # Review entire payment-service module
/code-review --focus=security --compliance      # Security-focused review with compliance checks
/code-review services/order-service --focus=kafka  # Kafka integration review for order-service
/code-review pr                                 # Review current PR diff (requires GitHub MCP)
/code-review src/main/java/com/example/PaymentController.java  # Review single file
\`\`\`

## Execution Steps

### Step 1: Determine Scope and Collect Files

Resolve the review scope:

- **\`staged\`**: Run \`git diff --cached --name-only\` to get staged files
- **\`branch\`**: Run \`git diff main...HEAD --name-only\` to get branch changes
- **\`pr\`**: Use GitHub MCP to fetch PR diff files
- **Module path** (e.g., \`services/payment-service\`): Collect all \`.java\`, \`.kt\`, \`.yml\`, \`.properties\` files in the module
- **Single file**: Review that file directly
- **Default (no argument)**: Run \`git diff --name-only\` for unstaged changes

Filter to relevant file types: \`*.java\`, \`*.kt\`, \`*.gradle.kts\`, \`*.yml\`, \`*.yaml\`, \`*.properties\`, \`*.xml\`, \`*.sql\`, \`Dockerfile\`, \`*.avsc\`

If no files match, report: "No reviewable files found in the specified scope."

### Step 2: Classify Files by Review Category

Sort each file into one or more review categories:

| Category | File Patterns |
|----------|--------------|
| **Domain Logic** | \`*/domain/**\`, \`*/model/**\`, \`*/entity/**\` |
| **Ports & Adapters** | \`*/port/**\`, \`*/adapter/**\` |
| **API Layer** | \`*Controller.java\`, \`*Resource.java\`, \`*Router.java\` |
| **Kafka** | \`*Consumer.java\`, \`*Producer.java\`, \`*Listener.java\`, \`*EventHandler.java\`, \`*/kafka/**\`, \`*.avsc\` |
| **Database** | \`*Repository.java\`, \`*/migration/**\`, \`*.sql\`, \`*JpaAdapter.java\` |
| **Security** | \`*/security/**\`, \`*/auth/**\`, \`*SecurityConfig.java\`, \`*Filter.java\` |
| **Configuration** | \`*.properties\`, \`*.yml\`, \`*Config.java\`, \`*Configuration.java\` |
| **Testing** | \`*Test.java\`, \`*IT.java\`, \`*ContractTest.java\`, \`*Spec.kt\` |
| **Infrastructure** | \`Dockerfile\`, \`*.tf\`, \`*/charts/**\`, \`*.helmignore\` |
| **Build** | \`*.gradle.kts\`, \`settings.gradle.kts\` |

### Step 3: Run Static Analysis Context

Before manual review, check for existing tool results:

\`\`\`bash
# Check if recent Checkstyle report exists
find . -name "checkstyle-result.xml" -newer build.gradle.kts 2>/dev/null

# Check if recent SpotBugs report exists
find . -name "spotbugs.xml" -newer build.gradle.kts 2>/dev/null

# Check JaCoCo coverage for affected modules
find . -name "jacocoTestReport.xml" -newer build.gradle.kts 2>/dev/null
\`\`\`

If reports are stale or missing, suggest running:
\`\`\`bash
./gradlew :services:<module>:check
\`\`\`

### Step 4: Apply Review Checklists

For each file, apply the relevant checklists based on category. Every finding must include:
- **Severity**: 🔴 Critical, 🟠 High, 🟡 Medium, 🔵 Low
- **Category**: Security, Performance, Architecture, Correctness, Maintainability, Compliance
- **Location**: File path and line number(s)
- **Finding**: Clear description of the issue
- **Recommendation**: Specific fix with code example
- **Reference**: Link to team convention, Spring docs, or compliance requirement

---

#### 4A: Hexagonal Architecture Review

- [ ] Domain entities have NO Spring annotations (\`@Entity\`, \`@Table\` belong in JPA adapter, not domain)
- [ ] Domain logic has NO infrastructure imports (\`import org.springframework.*\`, \`import javax.persistence.*\`)
- [ ] Ports are defined as interfaces in the domain module (\`*/port/in/**\`, \`*/port/out/**\`)
- [ ] Adapters implement port interfaces and live in \`*/adapter/**\`
- [ ] Inbound adapters (controllers, Kafka consumers) call use-case ports, not services directly
- [ ] Outbound adapters (repositories, Kafka producers, REST clients) implement outbound ports
- [ ] No direct REST calls between microservices — all inter-service communication through Kafka
- [ ] Application services orchestrate domain logic, not adapters
- [ ] Module dependencies flow inward: adapter → application → domain (never reversed)

\`\`\`
# Verify no cross-service direct dependencies in Gradle
# Each service module should NOT depend on another service module
# Only shared/ libraries are allowed as cross-cutting dependencies
\`\`\`

#### 4B: Spring Boot & Java Review

- [ ] Classes do not exceed 300 lines
- [ ] Methods do not exceed 30 lines
- [ ] Constructor injection used (no \`@Autowired\` on fields)
- [ ] \`@Value\` annotations reference Spring Profile-appropriate properties
- [ ] \`@Transactional\` boundaries are correct (on service layer, not controller)
- [ ] \`@Transactional(readOnly = true)\` used for read-only operations
- [ ] No \`@SuppressWarnings\` without justification comment
- [ ] Records used for DTOs and value objects where appropriate (Java 21)
- [ ] Sealed interfaces/classes used for domain event hierarchies where appropriate
- [ ] Pattern matching (\`instanceof\` pattern, switch expressions) used instead of manual casting
- [ ] Virtual threads considered for I/O-bound operations (\`spring.threads.virtual.enabled\`)
- [ ] \`Optional\` used for return types, never for parameters or fields
- [ ] Proper use of \`final\` on local variables and parameters
- [ ] No raw types (e.g., \`List\` instead of \`List<String>\`)
- [ ] Naming conventions: PascalCase classes, camelCase methods/variables, SCREAMING_SNAKE_CASE constants

#### 4C: Spring Security & Compliance Review

Flag with 🔴 Critical for any violation in \`**/security/**\`, \`**/auth/**\`:

- [ ] No hardcoded secrets, passwords, API keys, or tokens in source code
- [ ] No secrets in \`application.properties\` / \`application.yml\` (must use environment variables or AWS Secrets Manager)
- [ ] \`@PreAuthorize\` or \`@Secured\` annotations on all controller endpoints
- [ ] CSRF protection enabled for non-API endpoints
- [ ] CORS configuration is restrictive (no \`allowedOrigins("*")\` in production profiles)
- [ ] Input validation present (\`@Valid\`, \`@NotNull\`, \`@Size\`, \`@Pattern\`) on all request DTOs
- [ ] SQL injection prevention: no string concatenation in queries, use parameterized queries or Spring Data
- [ ] Sensitive data (PAN, SSN, PII) is masked in logs — check \`toString()\` methods and log statements
- [ ] PCI DSS: Cardholder data never logged, stored only in encrypted form, transmitted over TLS
- [ ] SOC 2: Audit trail events emitted for all state-changing operations on sensitive resources
- [ ] Authentication tokens have appropriate expiry
- [ ] Rate limiting configured on public-facing endpoints
- [ ] Security headers configured (Content-Security-Policy, X-Frame-Options, etc.)
- [ ] No \`@PermitAll\` or \`.permitAll()\` without explicit justification comment

#### 4D: Kafka & Event Streaming Review

- [ ] Event schemas exist in \`schema-registry/\` for all produced events
- [ ] Producer uses the correct topic name from configuration (not hardcoded strings)
- [ ] Consumer group ID follows convention: \`{service-name}-{consumer-purpose}\`
- [ ] \`@KafkaListener\` has explicit \`groupId\`, \`topics\`, and \`containerFactory\`
- [ ] Idempotent consumer pattern implemented (check for duplicate event IDs)
- [ ] Dead letter topic (DLT) configured for consumer error handling
- [ ] \`@RetryableTopic\` or manual retry configured with appropriate backoff
- [ ] Event payload includes: \`eventId\` (UUID), \`eventType\`, \`timestamp\`, \`source\`, \`correlationId\`
- [ ] Kafka producer uses transactional outbox pattern or \`@Transactional\` with \`KafkaTemplate\`
- [ ] No blocking calls inside Kafka listeners (use async processing if needed)
- [ ] Consumer deserialization errors handled (configure \`ErrorHandlingDeserializer\`)
- [ ] Partition key strategy is documented and consistent (e.g., aggregate ID)
- [ ] Schema evolution is backward-compatible (no removed required fields)
- [ ] Consumer lag monitoring: Actuator Kafka metrics exposed

#### 4E: Database & JPA Review

- [ ] Flyway/Liquibase migration files are additive only (no destructive changes without migration plan)
- [ ] Migration file naming follows convention: \`V{version}__{description}.sql\`
- [ ] JPA entities use \`@Version\` for optimistic locking where appropriate
- [ ] N+1 query detection: \`@EntityGraph\` or \`JOIN FETCH\` used for associations accessed in loops
- [ ] Pagination used for list queries (\`Pageable\` parameter)
- [ ] Database indexes defined for frequently queried columns
- [ ] No \`CascadeType.ALL\` or \`CascadeType.REMOVE\` without explicit justification
- [ ] \`@Enumerated(EnumType.STRING)\` used (never \`EnumType.ORDINAL\`)
- [ ] Connection pool settings appropriate (\`spring.datasource.hikari.*\`)
- [ ] Repository methods use Spring Data query derivation or \`@Query\` — no native queries without justification
- [ ] Per-service database isolation: no cross-service database access

#### 4F: API & Controller Review

- [ ] OpenAPI annotations present (\`@Operation\`, \`@ApiResponse\`, \`@Schema\`)
- [ ] Consistent HTTP status codes (201 for creation, 204 for deletion, 400/422 for validation)
- [ ] Error responses use a standard \`ProblemDetail\` (RFC 7807) format
- [ ] Request/response DTOs are separate from domain entities
- [ ] Pagination follows standard pattern (\`page\`, \`size\`, \`sort\` parameters)
- [ ] API versioning strategy applied consistently (path-based: \`/api/v1/\`)
- [ ] \`@RestControllerAdvice\` handles exceptions globally per service
- [ ] No business logic in controllers — delegate to use-case ports
- [ ] Request logging/tracing: correlation ID propagated via headers

#### 4G: Testing Review

- [ ] Unit tests use JUnit 5 + Mockito, no Spring context loaded
- [ ] Integration tests use \`@SpringBootTest\` with Testcontainers (PostgreSQL, Kafka, Redis)
- [ ] Testcontainers use \`@Container\` with \`@Testcontainers\` or shared container pattern
- [ ] Contract tests exist for all Kafka producers (Pact provider verification)
- [ ] Contract tests exist for all API endpoints consumed by other services
- [ ] Test method names follow pattern: \`should_expectedBehavior_when_condition()\`
- [ ] No \`@Disabled\` tests without linked Jira ticket in comment
- [ ] Test data builders or fixtures used (no magic values)
- [ ] Assertions use AssertJ fluent API (not JUnit \`assertEquals\`)
- [ ] \`@Transactional\` on integration tests for automatic rollback
- [ ] Coverage meets 80% threshold for the affected module

#### 4H: Configuration & Infrastructure Review

- [ ] \`application.yml\` uses Spring Profiles (\`dev\`, \`staging\`, \`prod\`)
- [ ] No environment-specific values in default profile — use \`application-{profile}.yml\`
- [ ] Dockerfile uses multi-stage build with distroless or Eclipse Temurin base
- [ ] Dockerfile does not run as root (\`USER\` directive present)
- [ ] Docker image does not contain build tools, source code, or test dependencies
- [ ] Helm values have sensible defaults with overrides per environment
- [ ] Health check endpoints configured: \`/actuator/health/liveness\`, \`/actuator/health/readiness\`
- [ ] Resource limits set in Kubernetes manifests (CPU, memory)
- [ ] Terraform changes are backwards-compatible (no resource destruction without plan)

### Step 5: Generate Review Report

Output the review in this format:

\`\`\`markdown
## Code Review Report

**Scope**: {description of what was reviewed}
**Files Reviewed**: {count}
**Focus**: {focus area or "all"}
**Reviewer**: Claude (AI-assisted review)

### Summary

| Severity | Count |
|----------|-------|
| 🔴 Critical | {n} |
| 🟠 High | {n} |
| 🟡 Medium | {n} |
| 🔵 Low | {n} |

### 🔴 Critical Findings
{findings or "None"}

### 🟠 High Findings
{findings}

### 🟡 Medium Findings
{findings}

### 🔵 Low Findings
{findings}

### ✅ Positive Observations
{things done well — always include at least 2}

### Recommendation
{APPROVE / REQUEST_CHANGES / NEEDS_DISCUSSION}
- APPROVE: No critical or high findings
- REQUEST_CHANGES: Any critical or high findings
- NEEDS_DISCUSSION: Architecture concerns that need team input
\`\`\`

Each finding follows this template:

\`\`\`markdown
#### [{severity}] {short title}
**File**: \`{path}:{line}\`
**Category**: {Security|Performance|Architecture|Correctness|Maintainability|Compliance}

{Description of the issue}

**Current**:
\`\`\`java
// problematic code
\`\`\`

**Recommended**:
\`\`\`java
// fixed code
\`\`\`

**Why**: {explanation referencing team convention, Spring best practice, or compliance requirement}
\`\`\`

### Step 6: Auto-Fix (if \`--fix\` flag)

When \`--fix\` is specified, automatically apply safe fixes only:

**Safe to auto-fix**:
- Import ordering and unused imports
- google-java-format formatting
- Missing \`final\` on local variables
- Missing \`@Override\` annotations
- \`@Autowired\` field injection → constructor injection (when single constructor)
- Raw type parameterization (when type is obvious)
- \`EnumType.ORDINAL\` → \`EnumType.STRING\`

**Never auto-fix**:
- Security findings
- Architecture violations
- Kafka configuration changes
- Database migration changes
- Business logic changes
- Anything in \`**/security/**\` or \`**/auth/**\`

After applying fixes:
\`\`\`
Applied {n} auto-fixes:
- {file}: {description of fix}
- {file}: {description of fix}

{m} findings require manual attention (see report above).
\`\`\`

### Step 7: Compliance Addendum (if \`--compliance\` flag)

When \`--compliance\` is specified, append a compliance section:

\`\`\`markdown
### Compliance Assessment

#### PCI DSS
- [ ] **Req 3.4**: Cardholder data rendered unreadable in storage
- [ ] **Req 4.1**: Strong cryptography for transmission over open networks
- [ ] **Req 6.5**: Address common coding vulnerabilities (injection, XSS, CSRF)
- [ ] **Req 8.2**: Proper authentication mechanisms
- [ ] **Req 10.1**: Audit trails for access to cardholder data

#### SOC 2
- [ ] **CC6.1**: Logical access security
- [ ] **CC7.2**: System monitoring for anomalies
- [ ] **CC8.1**: Change`,

  'plugin/codeforge-spring-boot-microservices/commands/phase.md': `# /phase — Development Methodology Phase Execution

## Command Signature

\`\`\`
/phase <phase-name> [--service <service-name>] [--ticket <JIRA-ID>] [--dry-run]
\`\`\`

## Purpose

Execute a structured development methodology phase for Spring Boot microservice implementation. Each phase enforces hexagonal architecture, Kafka event-driven patterns, and compliance requirements specific to this fintech platform.

## Activation

When the user types \`/phase\`, activate the **phase skill** (\`plugin/codeforge-spring-boot-microservices/skills/phase/SKILL.md\`) and the **architect agent** (\`plugin/codeforge-spring-boot-microservices/agents/architect.md\`).

## Available Phases

### Phase 1: \`discover\`

Analyze the Jira ticket and gather context for implementation.

**Steps:**
1. Read the Jira ticket (via MCP or user-provided description)
2. Identify which microservice(s) are affected under \`services/\`
3. Determine if new Kafka topics, event schemas, or consumer groups are needed
4. Check if the change touches sensitive paths (\`**/security/**\`, \`**/auth/**\`, \`*.properties\`)
5. Identify affected domain boundaries — ensure no direct REST calls between services
6. Review existing OpenAPI specs in the affected service's \`src/main/resources/openapi/\`
7. Check \`schema-registry/\` for related Avro/JSON event schemas
8. Flag SOC 2 or PCI DSS compliance implications (payment data, PII, audit logging)

**Output:** Discovery summary with affected services, schemas, compliance notes, and risk assessment.

### Phase 2: \`design\`

Produce the technical design following hexagonal architecture.

**Steps:**
1. Define the domain model changes (entities, value objects, aggregates)
2. Map to hexagonal layers:
   - **Domain**: \`src/main/java/<package>/domain/\` — entities, domain events, repository ports
   - **Application**: \`src/main/java/<package>/application/\` — use cases, input/output ports
   - **Infrastructure**: \`src/main/java/<package>/infrastructure/\` — adapters (JPA, Kafka, REST)
3. Design Kafka event flow:
   - Producer topic, key strategy, partitioning
   - Consumer group ID following convention: \`<service-name>-<purpose>-group\`
   - Event schema (Avro or JSON Schema) to register in \`schema-registry/\`
   - Idempotency strategy for consumers
4. Design database changes:
   - Flyway migration script naming: \`V<version>__<description>.sql\`
   - PostgreSQL schema scoped to the service's own database
5. Design Redis usage if applicable (cache keys, TTL, eviction policy)
6. Define API contract changes (OpenAPI 3.0 spec updates)
7. Identify Spring Profiles needed (\`local\`, \`staging\`, \`production\`)
8. Produce Architecture Decision Record (ADR) if the change is significant → \`docs/adr/\`

**Output:** Technical design document with class diagrams, event flow, and migration plan.

### Phase 3: \`implement\`

Write the production code following project conventions.

**Steps:**
1. Create or modify files following hexagonal architecture package structure:
   \`\`\`
   services/<service-name>/src/main/java/com/fintech/<service>/
   ├── domain/
   │   ├── model/           # Entities, Value Objects, Aggregates
   │   ├── event/           # Domain events
   │   ├── port/
   │   │   ├── inbound/     # Use case interfaces (input ports)
   │   │   └── outbound/    # Repository, messaging ports (output ports)
   │   └── exception/       # Domain exceptions
   ├── application/
   │   ├── usecase/         # Use case implementations
   │   └── dto/             # Command/Query DTOs
   └── infrastructure/
       ├── adapter/
       │   ├── inbound/
       │   │   ├── rest/    # @RestController adapters
       │   │   └── kafka/   # @KafkaListener adapters
       │   └── outbound/
       │       ├── persistence/  # JPA repositories, entities
       │       ├── kafka/        # KafkaTemplate producers
       │       └── cache/        # Redis adapters
       ├── config/           # Spring @Configuration classes
       └── security/         # Security filters, auth config
   \`\`\`
2. Follow naming conventions:
   - Classes: \`PascalCase\` (e.g., \`PaymentProcessedEvent\`, \`OrderRepository\`)
   - Methods/variables: \`camelCase\`
   - Constants: \`SCREAMING_SNAKE_CASE\`
   - Kafka topics: \`kebab-case\` (e.g., \`payment-processed\`, \`order-created\`)
   - Consumer groups: \`<service>-<purpose>-group\`
3. Enforce max 300 lines per file — split into focused classes
4. Add \`@Generated("claude-ai")\` annotation to AI-generated classes for audit trail
5. Use constructor injection (no \`@Autowired\` on fields)
6. All Kafka producers must use transactional outbox pattern for financial data
7. All REST endpoints must have Spring Security annotations (\`@PreAuthorize\`)
8. Add Actuator health indicators for custom dependencies
9. Write Flyway migrations in \`src/main/resources/db/migration/\`
10. Register event schemas in \`schema-registry/\`
11. Update \`application.yml\` with new config (use Spring Profiles)

**Validation before proceeding:**
\`\`\`bash
./gradlew :services:<service-name>:compileJava
./gradlew :services:<service-name>:checkstyleMain
\`\`\`

**Output:** Implemented production code with all adapters, ports, and configurations.

### Phase 4: \`test\`

Write comprehensive tests at all levels.

**Steps:**
1. **Unit Tests** (JUnit 5 + Mockito):
   - Test domain logic in isolation (no Spring context)
   - Test use cases with mocked output ports
   - Location: \`src/test/java/<package>/domain/\` and \`application/\`
   - Naming: \`<ClassName>Test.java\`
   \`\`\`java
   @ExtendWith(MockitoExtension.class)
   class ProcessPaymentUseCaseTest { ... }
   \`\`\`

2. **Integration Tests** (Testcontainers):
   - Test infrastructure adapters with real dependencies
   - Use \`@Testcontainers\` with PostgreSQL, Kafka, Redis containers
   - Location: \`src/test/java/<package>/infrastructure/\`
   - Naming: \`<ClassName>IntegrationTest.java\`
   \`\`\`java
   @SpringBootTest
   @Testcontainers
   @ActiveProfiles("test")
   class PaymentKafkaAdapterIntegrationTest {
       @Container
       static KafkaContainer kafka = new KafkaContainer(DockerImageName.parse("confluentinc/cp-kafka:7.5.0"));
       @Container
       static PostgreSQLContainer<?> postgres = new PostgreSQLContainer<>("postgres:16-alpine");
   }
   \`\`\`

3. **Contract Tests** (Pact):
   - Provider verification for REST APIs
   - Consumer-driven contracts for Kafka events
   - Location: \`tests/contract/\`
   - Naming: \`<Consumer>To<Provider>ContractTest.java\`

4. **Verify coverage threshold:**
   \`\`\`bash
   ./gradlew :services:<service-name>:test
   ./gradlew :services:<service-name>:jacocoTestReport
   ./gradlew :services:<service-name>:jacocoTestCoverageVerification
   \`\`\`
   - Minimum 80% line coverage enforced by JaCoCo

**Output:** Complete test suite with unit, integration, and contract tests passing.

### Phase 5: \`secure\`

Validate security and compliance requirements.

**Steps:**
1. Run static analysis:
   \`\`\`bash
   ./gradlew :services:<service-name>:spotbugsMain
   ./gradlew :services:<service-name>:dependencyCheckAnalyze
   \`\`\`
2. Verify Spring Security configuration:
   - Authentication on all non-public endpoints
   - RBAC with \`@PreAuthorize\` or \`@Secured\`
   - CSRF protection for non-API endpoints
   - Rate limiting on public endpoints
3. Check PCI DSS compliance:
   - No PAN (Primary Account Number) in logs
   - Sensitive fields annotated with \`@JsonIgnore\` or masked in serialization
   - Encryption at rest for payment data (AES-256)
   - Audit logging for all payment operations
4. Check SOC 2 compliance:
   - All state changes produce audit events to \`audit-log\` Kafka topic
   - Access control changes logged
   - Data retention policies in Flyway migrations
5. Verify secrets management:
   - No hardcoded secrets in \`application.yml\` or \`application.properties\`
   - All secrets via environment variables or AWS Secrets Manager
   - Spring Cloud Config or Spring Vault integration
6. Scan Docker image:
   \`\`\`bash
   docker build -t <service-name>:scan services/<service-name>/
   trivy image <service-name>:scan
   \`\`\`
7. Review sensitive path changes against CODEOWNERS

**Output:** Security assessment report with findings, remediations, and compliance checklist.

### Phase 6: \`deploy\`

Prepare deployment artifacts and validate readiness.

**Steps:**
1. Build and verify Docker image:
   \`\`\`bash
   ./gradlew :services:<service-name>:bootBuildImage
   \`\`\`
2. Update Helm chart in \`charts/<service-name>/\`:
   - \`values.yaml\` — image tag, resource limits, replica count
   - \`templates/deployment.yaml\` — health probes pointing to Actuator
   - \`templates/configmap.yaml\` — Spring Profile and non-secret config
   - \`templates/secret.yaml\` — references to AWS Secrets Manager
3. Validate Helm chart:
   \`\`\`bash
   helm lint charts/<service-name>/
   helm template charts/<service-name>/ --values charts/<service-name>/values-staging.yaml
   \`\`\`
4. Verify Terraform changes if infrastructure is affected:
   \`\`\`bash
   cd infrastructure/
   terraform plan -var-file=environments/staging.tfvars
   \`\`\`
5. Validate Kafka topic configuration:
   - Topic exists or Terraform creates it
   - Partition count and replication factor appropriate for throughput
   - Retention policy set correctly
6. Verify database migration will apply cleanly:
   \`\`\`bash
   ./gradlew :services:<service-name>:flywayInfo
   ./gradlew :services:<service-name>:flywayValidate
   \`\`\`
7. Create deployment checklist:
   - [ ] Database migration reviewed and tested
   - [ ] Kafka topic/schema changes applied
   - [ ] Redis cache invalidation plan (if schema changed)
   - [ ] Rollback procedure documented
   - [ ] Monitoring dashboards updated (Grafana)
   - [ ] Alerts configured (Prometheus)
   - [ ] Distributed tracing verified (Jaeger)
   - [ ] Runbook updated in \`docs/runbooks/\`

**Output:** Deployment-ready artifacts with validated Helm charts, migration scripts, and deployment checklist.

## Phase Transitions

Each phase must complete its validation before proceeding to the next:

\`\`\`
discover → design → implement → test → secure → deploy
\`\`\`

To advance: \`/phase <next-phase> --service <service-name> --ticket <JIRA-ID>\`

To re-run a phase: \`/phase <phase-name> --service <service-name>\`

To see current status: \`/phase status --ticket <JIRA-ID>\`

## Flags

| Flag | Description | Example |
|------|-------------|---------|
| \`--service\` | Target microservice module | \`--service payment-service\` |
| \`--ticket\` | Jira ticket ID for traceability | \`--ticket PAY-456\` |
| \`--dry-run\` | Show what would be done without making changes | \`--dry-run\` |
| \`--skip-security\` | Skip security phase (non-production only) | \`--skip-security\` |
| \`--verbose\` | Show detailed output for each step | \`--verbose\` |

## Examples

\`\`\`
/phase discover --ticket PAY-456 --service payment-service
/phase design --service order-service --ticket ORD-789
/phase implement --service payment-service --ticket PAY-456
/phase test --service payment-service --ticket PAY-456
/phase secure --service payment-service --ticket PAY-456
/phase deploy --service payment-service --ticket PAY-456 --dry-run
/phase status --ticket PAY-456
\`\`\`

## Cross-Service Changes

When a ticket affects multiple services (e.g., new domain event consumed by multiple services):

1. Run \`discover\` and \`design\` across all affected services first
2. Implement the **producer** service first, including schema registration
3. Implement **consumer** services, referencing the registered schema
4. Run contract tests between producer and all consumers
5. Deploy producer before consumers (backward-compatible schema evolution)

\`\`\`
/phase implement --service payment-service --ticket PAY-456   # producer first
/phase implement --service order-service --ticket PAY-456      # consumer second
/phase implement --service notification-service --ticket PAY-456  # consumer third
\`\`\`

## Compliance Gate

For changes touching \`**/security/**\`, \`**/auth/**\`, or payment-related code:
- The \`secure\` phase is **mandatory** and cannot be skipped
- Two approvals required from CODEOWNERS in \`.github/CODEOWNERS\`
- Security scan must pass before deployment
- Audit trail entry generated automatically

## Related

- **Skill**: \`plugin/codeforge-spring-boot-microservices/skills/phase/SKILL.md\`
- **Architect Agent**: \`plugin/codeforge-spring-boot-microservices/agents/architect.md\`
- **TDD Command**: \`plugin/codeforge-spring-boot-microservices/commands/tdd.md\` (use during \`test\` phase)
- **Code Review**: \`plugin/codeforge-spring-boot-microservices/commands/code-review.md\` (use before \`deploy\` phase)
- **Build Fix**: \`plugin/codeforge-spring-boot-microservices/commands/build-fix.md\` (use if \`implement\` phase fails compilation)
- **Architecture**: \`docs/ARCHITECTURE.md\`
- **Playbook**: \`playbook/\` directory for full methodology reference`,

  'plugin/codeforge-spring-boot-microservices/commands/plan.md': `# /plan — Implementation Planning Command

## Purpose

Generate a detailed, phased implementation plan for a Spring Boot microservice feature, Kafka event flow, or infrastructure change. The plan follows hexagonal architecture principles and accounts for cross-service impacts, schema evolution, and deployment ordering.

## Usage

\`\`\`
/plan <description or Jira ticket reference>
/plan feat: add payment retry mechanism with dead letter queue
/plan PAY-456
/plan refactor: migrate order-service from REST to Kafka for inventory checks
\`\`\`

## Activation

When the user invokes \`/plan\`, activate the **planner** agent defined in \`plugin/codeforge-spring-boot-microservices/agents/planner.md\` and follow the **plan** skill in \`plugin/codeforge-spring-boot-microservices/skills/plan/SKILL.md\`.

## Workflow

### Step 1: Gather Context

1. If a Jira ticket is provided, fetch ticket details via the Jira MCP server (summary, description, acceptance criteria, linked tickets, epic context)
2. Read the current project structure to understand which services exist under \`services/\`, shared libraries under \`shared/\`, and schemas under \`schema-registry/\`
3. Identify affected microservices by scanning for related domain concepts in:
   - \`services/*/src/main/java/**/domain/\`
   - \`services/*/src/main/java/**/port/\`
   - \`services/*/src/main/java/**/adapter/\`
   - \`shared/*/src/main/java/\`
   - \`schema-registry/\`
4. Check \`docs/ARCHITECTURE.md\` for system context and service boundaries
5. Review existing ADRs in \`docs/adr/\` for relevant architectural decisions
6. Check \`charts/\` for deployment dependencies and service topology

### Step 2: Analyze Impact

Evaluate the change across these dimensions:

- **Service Scope**: Which microservices are created or modified?
- **Domain Events**: New Kafka topics, schema changes, consumer group impacts?
- **Database Migrations**: New tables, columns, indexes in per-service PostgreSQL?
- **API Changes**: New or modified REST endpoints exposed through the gateway?
- **Shared Libraries**: Changes to \`shared/domain-events\`, \`shared/common\`, or \`shared/test-support\`?
- **Security Impact**: Does this touch \`**/security/**\`, \`**/auth/**\`, or handle PCI DSS-scoped data (card numbers, CVVs, account tokens)?
- **Infrastructure**: Terraform changes, new Helm values, Kubernetes resource requirements?
- **Cross-Service Dependencies**: Deployment ordering constraints?

### Step 3: Generate the Plan

Produce a structured plan with the following sections:

\`\`\`markdown
## Implementation Plan: <Title>

**Ticket**: <Jira reference if available>
**Author**: <developer>
**Date**: <today>
**Estimated Complexity**: S / M / L / XL
**Services Affected**: <list>
**Requires Security Review**: Yes / No

---

### 1. Overview
<2-3 sentence summary of what is being built and why>

### 2. Architecture Decisions
- <Any new ADRs needed>
- <Hexagonal architecture layer mapping: which ports, adapters, domain objects>
- <Event-driven design choices>

### 3. Schema & Event Design
- **New/Modified Kafka Topics**: <topic names with naming convention: domain.entity.event>
- **Event Schemas**: <Avro/JSON schema files to create/update in schema-registry/>
- **Schema Compatibility**: <BACKWARD, FORWARD, FULL>
- **Consumer Groups**: <new consumer groups or changes to existing>

### 4. Database Changes
- **Service**: <service-name>
  - Migration file: \`services/<name>/src/main/resources/db/migration/V<next>__<description>.sql\`
  - Tables/columns affected
  - Index strategy
  - Data migration needed: Yes / No

### 5. Implementation Phases

#### Phase 1: Foundation (shared libraries & schemas)
- [ ] Define domain event schema in \`schema-registry/<domain>/<event>.avsc\`
- [ ] Add shared DTOs/value objects in \`shared/domain-events/\`
- [ ] Run \`./gradlew :shared:domain-events:build\` to verify compilation

#### Phase 2: Domain Layer (ports & domain logic)
- [ ] Create/modify domain entities in \`services/<name>/src/main/java/.../domain/model/\`
- [ ] Define inbound ports (use cases) in \`services/<name>/src/main/java/.../port/inbound/\`
- [ ] Define outbound ports (repositories, event publishers) in \`services/<name>/src/main/java/.../port/outbound/\`
- [ ] Write domain unit tests with JUnit 5 + Mockito
- [ ] Run \`./gradlew :services:<name>:test --tests '*.domain.*'\`

#### Phase 3: Adapters (persistence, messaging, REST)
- [ ] Implement JPA repository adapter in \`.../adapter/outbound/persistence/\`
- [ ] Implement Kafka producer adapter in \`.../adapter/outbound/messaging/\`
- [ ] Implement Kafka consumer adapter in \`.../adapter/inbound/messaging/\`
- [ ] Implement REST controller adapter in \`.../adapter/inbound/rest/\`
- [ ] Add Flyway migration scripts
- [ ] Write integration tests with Testcontainers (PostgreSQL, Kafka, Redis)
- [ ] Run \`./gradlew :services:<name>:integrationTest\`

#### Phase 4: Configuration & Wiring
- [ ] Add Spring bean configuration in \`.../config/\`
- [ ] Update \`application.yml\` with new Kafka topic bindings, consumer group config
- [ ] Add Spring Profile-specific overrides (\`application-local.yml\`, \`application-staging.yml\`)
- [ ] Configure Spring Security rules if new endpoints are exposed
- [ ] Update OpenAPI spec in \`services/<name>/src/main/resources/openapi/\`

#### Phase 5: Cross-Service Integration
- [ ] Verify Kafka event consumption in downstream services
- [ ] Write Pact contract tests in \`tests/contract/\`
- [ ] Run \`./gradlew :tests:contract:test\`
- [ ] Update API gateway routes in \`gateway/src/main/resources/application.yml\` if needed

#### Phase 6: Infrastructure & Deployment
- [ ] Update Helm chart values in \`charts/<service-name>/values.yaml\`
- [ ] Add/modify Terraform resources in \`infrastructure/\` if needed
- [ ] Update Kubernetes resource requests/limits if workload profile changes
- [ ] Verify health checks via Spring Actuator (\`/actuator/health\`, \`/actuator/info\`)

#### Phase 7: Verification & Documentation
- [ ] Run full build: \`./gradlew clean build\`
- [ ] Verify coverage threshold: \`./gradlew jacocoTestCoverageVerification\` (≥80%)
- [ ] Run security scan: \`./gradlew dependencyCheckAnalyze\`
- [ ] Run Checkstyle: \`./gradlew checkstyleMain checkstyleTest\`
- [ ] Update \`docs/\` with architecture changes, new runbooks
- [ ] Create ADR if architectural decisions were made

### 6. Testing Strategy
| Test Type        | Tool                    | Scope                              | Location                                    |
|------------------|-------------------------|-------------------------------------|---------------------------------------------|
| Unit             | JUnit 5 + Mockito       | Domain logic, use cases             | \`services/<name>/src/test/java/.../domain/\` |
| Integration      | Testcontainers          | DB, Kafka, Redis adapters           | \`services/<name>/src/test/java/.../adapter/\`|
| Contract         | Pact                    | Inter-service API contracts         | \`tests/contract/\`                           |
| E2E              | REST Assured + Testcontainers | Full service flow              | \`tests/e2e/\`                                |

### 7. Deployment Order
<Ordered list of services to deploy, accounting for schema registry updates, shared library publishing, and consumer-before-producer patterns>

### 8. Rollback Strategy
- <Database rollback approach (Flyway undo or forward-fix)>
- <Kafka schema backward compatibility guarantees>
- <Feature flag considerations>

### 9. Security & Compliance Checklist
- [ ] No PCI DSS-scoped data logged or exposed in error responses
- [ ] Spring Security rules applied to new endpoints
- [ ] Secrets managed via AWS Secrets Manager / Spring Cloud Config (not in properties files)
- [ ] Input validation on all REST endpoints (\`@Valid\`, custom validators)
- [ ] Audit logging for sensitive operations
- [ ] SOC 2 control mapping documented if applicable

### 10. Risks & Open Questions
- <List any unknowns, dependencies on other teams, or technical risks>
\`\`\`

### Step 4: Validate the Plan

Before presenting the plan, verify:

1. **No direct REST calls between services** — all inter-service communication uses Kafka
2. **Hexagonal architecture compliance** — domain logic has no framework dependencies
3. **File count estimate** — flag if any single file is likely to exceed 300 lines and suggest splitting
4. **Naming conventions** — PascalCase classes, camelCase methods, kebab-case modules, SCREAMING_SNAKE_CASE constants
5. **Sensitive paths** — flag any changes to \`**/security/**\`, \`**/auth/**\`, \`infrastructure/production/**\`, or \`*.properties\` that require additional review
6. **Branch naming** — suggest the branch name following \`type/TICKET-desc\` convention

### Step 5: Present and Iterate

1. Present the complete plan in the structured format above
2. Ask the developer to confirm or adjust:
   - Scope (too broad? too narrow?)
   - Phase ordering (any dependencies missed?)
   - Testing strategy (sufficient coverage?)
   - Security considerations (anything missed for SOC 2 / PCI DSS?)
3. Once confirmed, offer to begin execution starting with Phase 1 using \`/tdd\` for test-driven implementation

## Integration with Playbook Phases

The \`/plan\` command maps to the **Planning** phase of the development playbook in \`playbook/\`. After planning:

- Use \`/tdd\` to implement each phase with test-driven development
- Use \`/verify\` after each phase to confirm build health and coverage
- Use \`/review\` before creating the pull request

## Examples

### Example 1: New Service
\`\`\`
/plan Create a notification-service that consumes payment.completed events and sends email/SMS notifications
\`\`\`

### Example 2: Feature Addition
\`\`\`
/plan PAY-789 Add idempotency key support to payment-service to prevent duplicate charges
\`\`\`

### Example 3: Infrastructure Change
\`\`\`
/plan Add Redis cluster for payment-service rate limiting with 1000 req/min per merchant
\`\`\`

### Example 4: Cross-Service Event Flow
\`\`\`
/plan Implement order saga: order-service -> payment-service -> inventory-service with compensation events
\`\`\``,

  'plugin/codeforge-spring-boot-microservices/commands/tdd.md': `# /tdd — Test-Driven Development for Spring Boot Microservices

## Command Signature

\`\`\`
/tdd <scope> [options]
\`\`\`

## Arguments

| Argument | Required | Description |
|----------|----------|-------------|
| \`scope\` | Yes | What to implement: class name, feature description, or Jira ticket ID |

## Options

| Flag | Description |
|------|-------------|
| \`--service <name>\` | Target microservice module (e.g., \`order-service\`, \`payment-service\`) |
| \`--type <unit\\|integration\\|contract>\` | Test type to drive development (default: \`unit\`) |
| \`--layer <domain\\|application\\|adapter>\` | Hexagonal architecture layer target |
| \`--event <topic>\` | Kafka event to produce or consume as part of the feature |
| \`--skip-green\` | Stop after RED phase — write tests only, do not implement |
| \`--from-test <path>\` | Resume GREEN/REFACTOR from an existing failing test file |

## Behavior

This command activates the **tdd-guide** agent and follows strict Red-Green-Refactor discipline within the Spring Boot hexagonal architecture.

### Phase 1: RED — Write Failing Tests

1. **Analyze the scope** to determine:
   - Which microservice module under \`services/\` is affected
   - Which hexagonal layer the code belongs to (domain, application, adapter)
   - Whether Kafka events, database entities, or REST endpoints are involved
   - Whether contract tests with downstream consumers are needed

2. **Select test framework and style** based on the layer:

   | Layer | Test Type | Framework | Location |
   |-------|-----------|-----------|----------|
   | Domain | Unit | JUnit 5 + AssertJ | \`src/test/java/**/domain/\` |
   | Application (use cases) | Unit | JUnit 5 + Mockito | \`src/test/java/**/application/\` |
   | Adapter — REST | Integration | Spring MockMvc + Testcontainers | \`src/test/java/**/adapter/in/web/\` |
   | Adapter — JPA | Integration | @DataJpaTest + Testcontainers (PostgreSQL) | \`src/test/java/**/adapter/out/persistence/\` |
   | Adapter — Kafka Producer | Integration | EmbeddedKafka / Testcontainers | \`src/test/java/**/adapter/out/messaging/\` |
   | Adapter — Kafka Consumer | Integration | @EmbeddedKafka + Testcontainers | \`src/test/java/**/adapter/in/messaging/\` |
   | Cross-service | Contract | Pact (JUnit 5 provider) | \`tests/contract/\` |

3. **Write the test class** following conventions:
   - Class name: \`{ClassName}Test\` for unit, \`{ClassName}IntegrationTest\` for integration, \`{ClassName}ContractTest\` for contract
   - Use \`@DisplayName\` with business-readable descriptions
   - Use \`@Nested\` classes to group related scenarios
   - Follow Arrange-Act-Assert (Given-When-Then) structure
   - Use \`@Tag("unit")\`, \`@Tag("integration")\`, or \`@Tag("contract")\` annotations

4. **Verify RED**: Run the specific test to confirm it fails for the right reason:
   \`\`\`
   ./gradlew :services:<service-name>:test --tests "<fully.qualified.TestClass>"
   \`\`\`
   - Confirm the failure is a compilation error (class/method doesn't exist) or assertion failure — not a configuration or infrastructure error

### Phase 2: GREEN — Minimal Implementation

1. **Create only what the test demands** — no speculative code:
   - Domain entities and value objects in \`domain/model/\`
   - Port interfaces in \`domain/port/in/\` (driving) or \`domain/port/out/\` (driven)
   - Use case implementations in \`application/service/\`
   - Adapter implementations in \`adapter/in/\` or \`adapter/out/\`

2. **Follow Spring Boot patterns**:
   - Annotate use case services with \`@Service\` and \`@Transactional\` where needed
   - Use constructor injection exclusively — no \`@Autowired\` on fields
   - REST adapters use \`@RestController\` with \`@RequestMapping\` and return \`ResponseEntity\`
   - JPA adapters implement the driven port interface, annotated with \`@Repository\` or \`@Component\`
   - Kafka producers implement a driven port, use \`KafkaTemplate<String, T>\`
   - Kafka consumers use \`@KafkaListener\` and delegate to a driving port

3. **For Kafka events**, ensure:
   - Event class exists in \`shared/domain-events/\` module
   - Event schema is registered in \`schema-registry/\` (Avro or JSON Schema)
   - Topic name follows convention: \`{domain}.{entity}.{action}\` (e.g., \`payment.transaction.completed\`)
   - Consumer group follows convention: \`{consuming-service}-{topic}-cg\`

4. **Verify GREEN**: Run the test again and confirm it passes:
   \`\`\`
   ./gradlew :services:<service-name>:test --tests "<fully.qualified.TestClass>"
   \`\`\`

### Phase 3: REFACTOR — Clean Up Without Changing Behavior

1. **Apply hexagonal architecture principles**:
   - Domain layer has zero Spring dependencies
   - Ports are interfaces defined in the domain layer
   - Adapters depend on ports, never the reverse
   - No business logic in adapters

2. **Apply code quality standards**:
   - Extract value objects for domain primitives (e.g., \`Money\`, \`OrderId\`, \`TransactionRef\`)
   - Ensure classes stay under 300 lines
   - Use \`record\` types for DTOs and events (Java 21)
   - Apply \`sealed\` interfaces where appropriate for domain type hierarchies
   - Ensure method names follow camelCase, constants use SCREAMING_SNAKE_CASE

3. **Check for missing test cases**:
   - Edge cases and boundary conditions
   - Error/exception paths
   - Null/empty input handling
   - Kafka deserialization error handling (for consumers)
   - Idempotency checks (for event consumers in financial flows)

4. **Verify REFACTOR**: Run the full test suite for the module:
   \`\`\`
   ./gradlew :services:<service-name>:test
   ./gradlew :services:<service-name>:jacocoTestReport
   \`\`\`
   - Confirm all tests still pass
   - Confirm coverage meets or exceeds 80% threshold

## Examples

### Unit test for a domain use case
\`\`\`
/tdd "CreatePaymentUseCase" --service payment-service --layer application
\`\`\`

Produces:
- \`services/payment-service/src/test/java/com/fintech/payment/application/service/CreatePaymentUseCaseTest.java\`
- \`services/payment-service/src/main/java/com/fintech/payment/application/service/CreatePaymentUseCaseImpl.java\`
- \`services/payment-service/src/main/java/com/fintech/payment/domain/port/in/CreatePaymentUseCase.java\`
- \`services/payment-service/src/main/java/com/fintech/payment/domain/port/out/SavePaymentPort.java\`

### Integration test for a Kafka consumer
\`\`\`
/tdd "OrderCompletedEventConsumer" --service payment-service --type integration --event order.order.completed
\`\`\`

Produces:
- \`services/payment-service/src/test/java/com/fintech/payment/adapter/in/messaging/OrderCompletedEventConsumerIntegrationTest.java\` (uses Testcontainers Kafka)
- \`services/payment-service/src/main/java/com/fintech/payment/adapter/in/messaging/OrderCompletedEventConsumer.java\`
- Validates event schema against \`schema-registry/order/order-completed.avsc\`

### Integration test for a REST endpoint
\`\`\`
/tdd "GET /api/v1/users/{id}" --service user-service --type integration --layer adapter
\`\`\`

Produces:
- \`services/user-service/src/test/java/com/fintech/user/adapter/in/web/GetUserControllerIntegrationTest.java\` (uses \`@SpringBootTest\` + Testcontainers PostgreSQL)
- \`services/user-service/src/main/java/com/fintech/user/adapter/in/web/GetUserController.java\`
- \`services/user-service/src/main/java/com/fintech/user/adapter/in/web/dto/UserResponse.java\`

### Contract test for a provider
\`\`\`
/tdd "UserService provider contract" --service user-service --type contract
\`\`\`

Produces:
- \`tests/contract/user-service/src/test/java/com/fintech/contract/UserServiceProviderContractTest.java\` (Pact provider verification)

### Write tests only (RED phase)
\`\`\`
/tdd PAY-456 --service payment-service --skip-green
\`\`\`

Fetches ticket PAY-456 from Jira, writes failing tests based on acceptance criteria, and stops.

### Resume from existing failing test
\`\`\`
/tdd --from-test services/order-service/src/test/java/com/fintech/order/domain/model/OrderTest.java
\`\`\`

Reads the failing test, implements the minimal code to make it pass, then refactors.

## Test Templates

### Unit Test (Domain / Application Layer)
\`\`\`java
@Tag("unit")
@DisplayName("{ClassName} should")
class {ClassName}Test {

    // Mocks for driven ports
    // Subject under test instantiated with mocks

    @Nested
    @DisplayName("when {scenario}")
    class When{Scenario} {

        @Test
        @DisplayName("{expected behavior}")
        void should{ExpectedBehavior}() {
            // Given
            // When
            // Then — use AssertJ assertions
        }
    }
}
\`\`\`

### Integration Test (REST Adapter)
\`\`\`java
@Tag("integration")
@SpringBootTest(webEnvironment = SpringBootTest.WebEnvironment.RANDOM_PORT)
@Testcontainers
@DisplayName("{Controller} integration tests")
class {Controller}IntegrationTest {

    @Container
    static PostgreSQLContainer<?> postgres = new PostgreSQLContainer<>("postgres:16-alpine");

    @DynamicPropertySource
    static void configureProperties(DynamicPropertyRegistry registry) {
        registry.add("spring.datasource.url", postgres::getJdbcUrl);
        registry.add("spring.datasource.username", postgres::getUsername);
        registry.add("spring.datasource.password", postgres::getPassword);
    }

    @Autowired
    private TestRestTemplate restTemplate;

    // Tests using restTemplate
}
\`\`\`

### Integration Test (Kafka Consumer)
\`\`\`java
@Tag("integration")
@SpringBootTest
@EmbeddedKafka(partitions = 1, topics = {"{topic.name}"})
@TestPropertySource(properties = {
    "spring.kafka.consumer.auto-offset-reset=earliest"
})
@DisplayName("{Consumer} integration tests")
class {Consumer}IntegrationTest {

    @Autowired
    private KafkaTemplate<String, {EventType}> kafkaTemplate;

    // Publish event, assert side effects
}
\`\`\`

## Compliance Considerations

For code in \`**/security/**\` or \`**/auth/**\` paths, or any code handling PII or payment data:

- **SOC 2**: Add tests verifying audit log entries are created for state changes
- **PCI DSS**: Add tests verifying sensitive data (card numbers, CVVs) is never logged or stored in plaintext
- **Input validation**: Add tests for all input boundaries — SQL injection, XSS, oversized payloads
- **Authentication/Authorization**: Add tests verifying \`@PreAuthorize\` or Spring Security filter chain behavior
- Flag the implementation with \`// AI-GENERATED: Review required for compliance\` comments

## Output Format

After each TDD cycle, output a summary:

\`\`\`
## TDD Cycle Summary

**Service**: {service-name}
**Layer**: {domain|application|adapter}
**Phase**: {RED|GREEN|REFACTOR}

### Tests Written
- {TestClass}#{testMethod} — {description}

### Code Created/Modified
- {file path} — {what was added}

### Coverage
- Module coverage: {X}% (threshold: 80%)
- New code coverage: {Y}%

### Next Steps
- {Suggested follow-up tests or implementation}
\`\`\`

## Delegation

This command delegates to:
- **Agent**: \`plugin/codeforge-spring-boot-microservices/agents/tdd-guide.md\`
- **Skill**: \`plugin/codeforge-spring-boot-microservices/skills/tdd/SKILL.md\`
- **Verification**: \`plugin/codeforge-spring-boot-microservices/skills/verify/SKILL.md\` (post-REFACTOR)`,

  'plugin/codeforge-spring-boot-microservices/commands/verify.md': `# /verify — Spring Boot Microservices Verification Command

## Purpose

Run a comprehensive verification suite against the current working tree to ensure code quality, test coverage, security compliance, and architectural conformance before pushing or opening a PR.

## Usage

\`\`\`
/verify                     # Full verification (all checks)
/verify --quick             # Fast checks only (lint, compile, unit tests)
/verify --service <name>    # Verify a specific microservice module
/verify --security          # Security-focused verification (SOC 2, PCI DSS)
/verify --contracts         # Contract tests and schema compatibility only
/verify --architecture      # Hexagonal architecture conformance only
\`\`\`

## Execution

When the user invokes \`/verify\`, activate the **verify** skill from \`plugin/codeforge-spring-boot-microservices/skills/verify/SKILL.md\` and execute the following verification pipeline.

### Step 1: Determine Scope

Identify what changed since the last commit on \`main\`:

\`\`\`bash
git diff --name-only main...HEAD
\`\`\`

Classify changed files into:
- **Service modules**: \`services/*/src/**\` → identify affected microservices
- **Shared libraries**: \`shared/*/src/**\` → all downstream services need verification
- **Infrastructure**: \`infrastructure/**\`, \`charts/**\` → Terraform/Helm validation
- **Schemas**: \`schema-registry/**\` → schema compatibility checks
- **Gateway**: \`gateway/src/**\` → gateway-specific verification
- **Build config**: \`build.gradle.kts\`, \`settings.gradle.kts\`, \`gradle/**\` → full rebuild

If \`--service <name>\` is specified, scope to that module only. If \`--quick\` is specified, skip integration tests, contract tests, and security scans.

### Step 2: Code Formatting & Linting

Run formatting and lint checks on affected modules:

\`\`\`bash
# Java formatting check (google-java-format via Checkstyle)
./gradlew checkstyleMain checkstyleTest --no-daemon

# Kotlin linting (shared libraries, build scripts)
./gradlew ktlintCheck --no-daemon
\`\`\`

**Report format:**

| Check | Module | Status | Issues |
|-------|--------|--------|--------|
| Checkstyle | order-service | ✅ PASS | 0 |
| Checkstyle | payment-service | ❌ FAIL | 3 violations |
| ktlint | shared/domain-events | ✅ PASS | 0 |

If violations are found, list each with file, line number, and rule name. Suggest auto-fix:

\`\`\`bash
./gradlew ktlintFormat  # Kotlin auto-fix
\`\`\`

### Step 3: Compilation

Compile all affected modules and their dependents:

\`\`\`bash
# Compile specific service
./gradlew :services:order-service:compileJava --no-daemon

# Or full compilation
./gradlew compileJava compileKotlin --no-daemon
\`\`\`

If compilation fails, invoke the **build-fix** skill (\`/build-fix\`) automatically and report the resolution.

### Step 4: File Length & Naming Convention Checks

Scan changed files for violations:

- **Max file length**: 300 lines per file
- **Class naming**: PascalCase (e.g., \`OrderCreatedEvent\`, \`PaymentPort\`)
- **Method/variable naming**: camelCase
- **Constants**: SCREAMING_SNAKE_CASE
- **Module names**: kebab-case (e.g., \`order-service\`, \`domain-events\`)
- **Package structure**: Hexagonal architecture layers must be in correct packages:
  - \`domain/\` — entities, value objects, domain events
  - \`application/\` — use cases, ports (interfaces)
  - \`adapter/in/\` — REST controllers, Kafka consumers
  - \`adapter/out/\` — JPA repositories, Kafka producers, external clients

Report any file exceeding 300 lines with current line count and suggested split points.

### Step 5: Unit Tests

Run unit tests for affected modules:

\`\`\`bash
# Specific service
./gradlew :services:order-service:test --no-daemon

# All affected
./gradlew test --no-daemon -x integrationTest -x contractTest
\`\`\`

Verify JaCoCo coverage meets the 80% threshold:

\`\`\`bash
./gradlew jacocoTestReport jacocoTestCoverageVerification --no-daemon
\`\`\`

**Report format:**

| Module | Tests | Passed | Failed | Coverage | Threshold |
|--------|-------|--------|--------|----------|-----------|
| order-service | 47 | 47 | 0 | 87% | ✅ 80% |
| payment-service | 32 | 31 | 1 | 76% | ❌ 80% |

For failed tests, show the test name, assertion message, and the relevant source code context.

For coverage below 80%, identify uncovered classes and methods, prioritized by risk (domain logic > adapters > config).

### Step 6: Integration Tests (skip if \`--quick\`)

Run integration tests using Testcontainers:

\`\`\`bash
./gradlew integrationTest --no-daemon
\`\`\`

This spins up:
- **PostgreSQL** container (per-service database isolation)
- **Kafka** container (event streaming verification)
- **Redis** container (caching and session tests)

Verify:
- JPA repositories correctly persist and query entities
- Kafka producers serialize events with correct schema
- Kafka consumers deserialize and process events correctly
- Redis cache operations (put, get, evict) work as expected
- Spring Security filters enforce authentication/authorization
- Actuator health endpoints return UP status

### Step 7: Contract Tests (skip if \`--quick\`)

Run Pact contract tests to verify inter-service API compatibility:

\`\`\`bash
./gradlew contractTest --no-daemon
\`\`\`

Verify:
- Consumer-driven contracts match provider implementations
- Kafka event schemas are backward-compatible with the schema registry
- No breaking changes in shared DTOs from \`shared/domain-events\`

For schema changes in \`schema-registry/\`:

\`\`\`bash
# Check Avro/JSON schema compatibility
./gradlew :schema-registry:checkCompatibility --no-daemon
\`\`\`

Report any contract or schema violations with the affected consumer/provider pair.

### Step 8: Security Verification

Run security checks (always run on \`--security\`, skip on \`--quick\`):

\`\`\`bash
# OWASP dependency vulnerability check
./gradlew dependencyCheckAnalyze --no-daemon

# SpotBugs static analysis (security category)
./gradlew spotbugsMain --no-daemon
\`\`\`

**SOC 2 compliance checks:**
- No secrets, API keys, or credentials in source code (scan \`*.java\`, \`*.kt\`, \`*.yml\`, \`*.properties\`)
- All \`application.properties\` / \`application.yml\` use \`\${ENV_VAR}\` placeholders for sensitive values
- Spring Security is configured on all REST endpoints (no unprotected controllers)
- Actuator endpoints are secured (only \`/actuator/health\` is public)
- Audit logging is present for state-changing operations

**PCI DSS compliance checks:**
- No PAN (Primary Account Number) data logged or stored in plaintext
- Payment-related services use field-level encryption annotations
- TLS is enforced for all external communication configs
- Input validation annotations (\`@Valid\`, \`@NotNull\`, \`@Size\`) on all controller request bodies
- No sensitive data in Kafka event payloads without encryption

**Sensitive path review:**
- Changes to \`**/security/**\`, \`**/auth/**\`, \`infrastructure/production/**\`, or \`*.properties\` files are flagged for mandatory senior/lead review

Report format:

| Category | Check | Status | Details |
|----------|-------|--------|---------|
| SOC 2 | No hardcoded secrets | ✅ PASS | — |
| SOC 2 | Actuator secured | ❌ FAIL | \`/actuator/env\` exposed in user-service |
| PCI DSS | No PAN in logs | ✅ PASS | — |
| PCI DSS | Input validation | ⚠️ WARN | \`CreatePaymentRequest\` missing \`@Valid\` |
| OWASP | Dependency CVEs | ❌ FAIL | CVE-2024-XXXX in jackson-databind |

### Step 9: Architecture Conformance

Verify hexagonal architecture rules:

- **Domain layer** (\`domain/\`) has ZERO dependencies on Spring, JPA, Kafka, or adapter packages
- **Application layer** (\`application/\`) depends only on domain; defines ports as interfaces
- **Adapter layer** (\`adapter/\`) implements ports; depends on domain and application
- **No circular dependencies** between modules
- **No direct REST calls between services** — all inter-service communication through Kafka topics
- **Each service has its own database** — no shared database schemas across services
- **Domain events** are defined in \`shared/domain-events\`, not in individual services

\`\`\`bash
# ArchUnit tests (if configured)
./gradlew :services:order-service:archTest --no-daemon
\`\`\`

Check Gradle module dependencies:

\`\`\`bash
./gradlew dependencies --configuration compileClasspath | grep ":services:"
\`\`\`

Flag any service-to-service Gradle dependency as a violation.

### Step 10: Infrastructure Validation (if infrastructure files changed)

\`\`\`bash
# Terraform validation
cd infrastructure && terraform validate && cd ..

# Helm chart linting
helm lint charts/order-service/
helm lint charts/payment-service/
helm lint charts/user-service/
helm lint charts/gateway/

# Kubernetes manifest validation
helm template charts/order-service/ | kubectl apply --dry-run=client -f -
\`\`\`

### Step 11: Verification Report

Generate a summary report:

\`\`\`
╔══════════════════════════════════════════════════════════════╗
║                    VERIFICATION REPORT                       ║
║                    spring-boot-microservices                  ║
╠══════════════════════════════════════════════════════════════╣
║ Branch: feat/PAY-456-add-refund-endpoint                     ║
║ Scope:  payment-service, shared/domain-events                ║
║ Mode:   Full                                                 ║
╠══════════════════════════════════════════════════════════════╣
║                                                              ║
║  1. Formatting & Linting    ✅ PASS                          ║
║  2. Compilation             ✅ PASS                          ║
║  3. Naming & File Length    ⚠️  1 warning (RefundService 287 lines) ║
║  4. Unit Tests              ✅ PASS  (79/79, 84% coverage)   ║
║  5. Integration Tests       ✅ PASS  (23/23)                 ║
║  6. Contract Tests          ✅ PASS  (8/8)                   ║
║  7. Security (SOC 2)        ✅ PASS                          ║
║  8. Security (PCI DSS)      ✅ PASS                          ║
║  9. OWASP Dependencies      ✅ PASS  (0 CVEs)               ║
║ 10. Architecture            ✅ PASS                          ║
║ 11. Infrastructure          ⏭️  SKIPPED (no changes)         ║
║                                                              ║
╠══════════════════════════════════════════════════════════════╣
║  RESULT: ✅ READY TO PUSH                                    ║
║                                                              ║
║  Warnings: 1                                                 ║
║  - RefundService.java approaching 300-line limit (287)       ║
║                                                              ║
║  Sensitive paths changed: 0                                  ║
║  AI-generated code detected: Yes (mark with @AIGenerated)    ║
╚══════════════════════════════════════════════════════════════╝
\`\`\`

### Result Classification

- **✅ READY TO PUSH**: All checks pass, no blockers
- **⚠️ PUSH WITH CAUTION**: Warnings present but no failures; review warnings before PR
- **❌ DO NOT PUSH**: One or more checks failed; must resolve before pushing

### Failure Handling

For each failure, provide:

1. **What failed**: Specific check, module, file, and line
2. **Why it matters**: Link to the relevant standard (SOC 2 control, PCI DSS requirement, team convention)
3. **How to fix**: Concrete code change or command to resolve
4. **Auto-fix available**: If yes, offer to apply it (e.g., formatting, missing annotations)

If multiple failures exist, prioritize:
1. Security violations (SOC 2, PCI DSS)
2. Compilation errors
3. Test failures
4. Architecture violations
5. Linting/formatting
6. Warnings

### AI-Generated Code Tagging

If the current session involved AI-generated code, remind the developer to:
- Add \`@AIGenerated\` annotation to AI-authored classes
- Include \`AI-assisted: true\` in the commit trailer
- Ensure AI-generated code is flagged in the PR for the \`ai-code-audit\` workflow

### Integration with Other Commands

- On compilation failure → suggest \`/build-fix\`
- On test failure → suggest \`/tdd\` to fix or add missing tests
- On architecture violation → suggest consulting \`docs/ARCHITECTURE.md\`
- On security finding → suggest \`/code-review --security\` for deeper analysis
- Before running → suggest \`/plan\` if no implementation plan exists for the ticket`,

  'plugin/codeforge-spring-boot-microservices/hooks/hooks.json': `{
  "hooks": {
    "pre-commit": [
      {
        "id": "check-conventional-commit",
        "description": "Validate commit message follows conventional commits format (feat:, fix:, chore:, docs:, refactor:)",
        "trigger": "before_commit",
        "priority": 1,
        "action": "validate_commit_message",
        "config": {
          "pattern": "^(feat|fix|chore|docs|refactor|test|perf|ci|build|revert)(\\\\([a-z\\\\-]+\\\\))?!?: .{1,72}",
          "ticket_pattern": "[A-Z]+-[0-9]+",
          "require_ticket_in_body": true,
          "max_subject_length": 72,
          "error_message": "Commit must follow conventional commits: type(scope): description. Include Jira ticket in body."
        }
      },
      {
        "id": "check-java-format",
        "description": "Run google-java-format on staged Java files",
        "trigger": "before_commit",
        "priority": 2,
        "action": "run_command",
        "config": {
          "command": "./gradlew spotlessCheck",
          "file_patterns": ["**/*.java"],
          "fail_on_error": true
        }
      },
      {
        "id": "check-kotlin-format",
        "description": "Run ktlint on staged Kotlin files",
        "trigger": "before_commit",
        "priority": 2,
        "action": "run_command",
        "config": {
          "command": "./gradlew ktlintCheck",
          "file_patterns": ["**/*.kt", "**/*.kts"],
          "fail_on_error": true
        }
      },
      {
        "id": "check-file-length",
        "description": "Enforce 300-line max file length",
        "trigger": "before_commit",
        "priority": 3,
        "action": "validate_file_length",
        "config": {
          "max_lines": 300,
          "file_patterns": ["**/*.java", "**/*.kt"],
          "exclude_patterns": ["**/generated/**", "**/build/**"]
        }
      },
      {
        "id": "check-sensitive-paths",
        "description": "Flag changes to security, auth, production infra, and properties files for SOC 2 / PCI DSS compliance",
        "trigger": "before_commit",
        "priority": 4,
        "action": "warn_sensitive_paths",
        "config": {
          "paths": ["**/security/**", "**/auth/**", "infrastructure/production/**", "**/*.properties"],
          "message": "You are modifying a sensitive path. Ensure changes comply with SOC 2 and PCI DSS requirements and request review from a security lead."
        }
      },
      {
        "id": "check-no-direct-rest-calls",
        "description": "Prevent direct REST calls between microservices — all inter-service communication must use Kafka",
        "trigger": "before_commit",
        "priority": 5,
        "action": "scan_file_content",
        "config": {
          "file_patterns": ["services/**/*.java", "services/**/*.kt"],
          "deny_patterns": ["RestTemplate", "WebClient.create", "FeignClient"],
          "exclude_patterns": ["**/gateway/**", "**/test/**", "**/integration/**"],
          "error_message": "Direct REST calls between services are prohibited. Use Kafka events for inter-service communication."
        }
      },
      {
        "id": "check-kafka-schema-exists",
        "description": "Verify new Kafka event classes have a corresponding schema in schema-registry/",
        "trigger": "before_commit",
        "priority": 6,
        "action": "validate_schema_registry",
        "config": {
          "event_source_paths": ["shared/domain-events/src/**/*Event.java"],
          "schema_registry_path": "schema-registry/",
          "fail_on_missing": true
        }
      }
    ],
    "post-commit": [
      {
        "id": "tag-ai-generated",
        "description": "Flag AI-generated code with metadata for CI traceability",
        "trigger": "after_commit",
        "priority": 1,
        "action": "add_git_trailer",
        "config": {
          "trailer_key": "Generated-By",
          "trailer_value": "claude-code",
          "only_when_ai": true
        }
      },
      {
        "id": "run-unit-tests",
        "description": "Run unit tests for affected modules after commit",
        "trigger": "after_commit",
        "priority": 2,
        "action": "run_command",
        "config": {
          "command": "./gradlew test --parallel",
          "affected_modules_only": true,
          "timeout_seconds": 300
        }
      },
      {
        "id": "notify-slack-sensitive-change",
        "description": "Post Slack notification when sensitive paths are modified",
        "trigger": "after_commit",
        "priority": 3,
        "action": "notify_slack",
        "config": {
          "channel": "#security-reviews",
          "paths": ["**/security/**", "**/auth/**", "infrastructure/production/**"],
          "message_template": "⚠️ Sensitive path modified by {author} in commit {sha}: {files}"
        }
      }
    ]
  }
}`,

  'plugin/codeforge-spring-boot-microservices/skills/build-fix/SKILL.md': `---
skill: build-fix
version: 1.0.0
description: Diagnose and fix Java/Spring Boot/Gradle build failures across the multi-module microservices project
triggers:
  - build failure
  - compilation error
  - gradle error
  - dependency resolution failure
  - test compilation failure
  - spring boot startup failure
  - docker build failure
tags:
  - java
  - spring-boot
  - gradle
  - build
  - troubleshooting
  - compilation
  - dependencies
inputs:
  - name: error_output
    description: The build error output or log snippet
    required: true
  - name: module
    description: The specific Gradle module experiencing the failure (e.g., services/order-service, shared/domain-events)
    required: false
  - name: build_command
    description: The exact command that failed (e.g., ./gradlew build, ./gradlew :services:payment-service:test)
    required: false
  - name: recent_changes
    description: Description of recent code changes that may have caused the failure
    required: false
tools:
  - shell
  - file_reader
  - file_editor
  - github
estimated_duration: 5-20 minutes
---

# Skill: build-fix

Diagnose and resolve build failures in the Spring Boot microservices Gradle multi-module project. This skill handles compilation errors, dependency conflicts, test failures, Spring context issues, Docker build failures, and Kafka schema compatibility problems.

## Activation

This skill activates when a developer encounters any build failure, including:

- \`./gradlew build\` failures (compilation, test, or packaging)
- Module-specific build failures (e.g., \`./gradlew :services:order-service:build\`)
- Dependency resolution errors across the multi-module project
- Spring Boot application context startup failures
- Docker image build failures
- Checkstyle/ktlint violations blocking the build
- JaCoCo coverage threshold failures (below 80%)
- Kafka schema registry compatibility check failures

## Procedure

### Step 1: Capture and Classify the Error

Read the provided error output carefully. Classify the failure into one of these categories:

1. **Compilation Error** — Java/Kotlin syntax errors, missing imports, type mismatches
2. **Dependency Resolution** — Unresolved dependencies, version conflicts, BOM mismatches
3. **Test Failure** — Unit test (JUnit 5), integration test (Testcontainers), or contract test (Pact) failures
4. **Spring Context Failure** — Bean creation errors, circular dependencies, missing configuration properties
5. **Checkstyle/Lint Violation** — Code style violations blocking the build
6. **Coverage Threshold** — JaCoCo reports coverage below 80%
7. **Docker Build Failure** — Dockerfile errors, base image issues, multi-stage build problems
8. **Kafka Schema Failure** — Avro/JSON schema compatibility violations in schema-registry/
9. **Gradle Configuration** — Build script errors in build.gradle.kts files, plugin conflicts

If the module is not specified, determine it from the error output. Look for patterns like:

\`\`\`
> Task :services:order-service:compileJava FAILED
> Task :shared:domain-events:test FAILED
\`\`\`

### Step 2: Gather Context

Based on the error category, gather the relevant files:

**For Compilation Errors:**
\`\`\`
- Read the failing source file indicated in the error
- Read the module's build.gradle.kts for dependency declarations
- Read the root build.gradle.kts and settings.gradle.kts for shared configuration
- Check shared/ modules if the error involves shared types or domain events
\`\`\`

**For Dependency Resolution:**
\`\`\`
- Run: ./gradlew dependencies --configuration compileClasspath -p <module-path>
- Read the module's build.gradle.kts
- Read gradle/libs.versions.toml (version catalog)
- Read the root build.gradle.kts for dependency management / BOM imports
\`\`\`

**For Test Failures:**
\`\`\`
- Read the failing test file
- Read the corresponding source file under test
- Check for test configuration: src/test/resources/application-test.yml
- For integration tests: check Testcontainers configuration and @SpringBootTest annotations
- For contract tests: check tests/pact/ and the Pact broker configuration
- Run: ./gradlew :module:test --tests "FullyQualifiedTestName" --info
\`\`\`

**For Spring Context Failures:**
\`\`\`
- Read the application's main class (@SpringBootApplication)
- Read application.yml and application-{profile}.yml
- Check @Configuration classes in the module
- Check for missing @Bean definitions or @ComponentScan issues
- Look for circular dependency indicators in the stack trace
\`\`\`

**For Checkstyle/Lint Violations:**
\`\`\`
- Read the Checkstyle report: build/reports/checkstyle/main.html or main.xml
- Read config/checkstyle/checkstyle.xml for the active rules
- For Kotlin: read .editorconfig and ktlint configuration
\`\`\`

**For Coverage Threshold:**
\`\`\`
- Read the JaCoCo report: build/reports/jacoco/test/html/index.html
- Identify classes/packages below 80% coverage
- Check jacoco configuration in build.gradle.kts for exclusion patterns
\`\`\`

**For Docker Build Failures:**
\`\`\`
- Read the module's Dockerfile (e.g., services/order-service/Dockerfile)
- Check .dockerignore
- Verify the JAR artifact exists: build/libs/*.jar
- Check for multi-stage build issues (builder stage vs runtime stage)
\`\`\`

**For Kafka Schema Failures:**
\`\`\`
- Read the failing schema in schema-registry/
- Check schema compatibility mode (BACKWARD, FORWARD, FULL)
- Compare with the previous version of the schema
- Read the schema validation configuration in build.gradle.kts
\`\`\`

### Step 3: Diagnose Root Cause

Apply these diagnostic patterns based on the error category:

**Compilation Errors — Common Causes:**
- Missing dependency in build.gradle.kts (check if it exists in another module's dependencies)
- Java 21 feature used but source/target compatibility set incorrectly
- Shared library API changed without updating dependent services
- Lombok annotation processing not configured (\`annotationProcessor "org.projectlombok:lombok"\`)
- Record class or sealed class issues with serialization frameworks (Jackson, Avro)

**Dependency Resolution — Common Causes:**
- Version catalog entry missing in \`gradle/libs.versions.toml\`
- Spring Boot BOM version mismatch with explicit dependency versions
- Transitive dependency conflict (use \`./gradlew dependencyInsight --dependency <dep> --configuration compileClasspath\`)
- Repository not declared (check Maven Central, Spring Milestones, Confluent)
- Module dependency declared incorrectly (should be \`implementation(project(":shared:domain-events"))\`)

**Test Failures — Common Causes:**
- Testcontainers Docker not running (check \`docker ps\`)
- PostgreSQL test container port conflict or startup timeout
- Kafka test container not configured with correct topic auto-creation
- Spring test context caching issues (\`@DirtiesContext\` may be needed)
- Pact contract mismatch between consumer and provider
- Missing \`@ActiveProfiles("test")\` annotation
- Test application.yml missing required properties

**Spring Context Failures — Common Causes:**
- Missing environment variable or property (check \`application.yml\` placeholders like \`\${DB_HOST}\`)
- Circular dependency between beans (refactor to use \`@Lazy\` or restructure)
- Conditional bean not created (\`@ConditionalOnProperty\`, \`@Profile\`)
- Auto-configuration exclusion needed (\`@SpringBootApplication(exclude = {...})\`)
- Kafka consumer/producer configuration missing required properties

**Gradle Configuration — Common Causes:**
- Plugin version incompatibility
- Kotlin DSL syntax error in build.gradle.kts
- \`settings.gradle.kts\` missing module include
- Incorrect source set configuration for hexagonal architecture packages

### Step 4: Apply the Fix

Implement the fix following these project conventions:

1. **Minimal change principle** — Fix only what is broken; do not refactor unrelated code
2. **Respect hexagonal architecture** — If the fix involves moving code, maintain ports & adapters boundaries:
   - \`domain/\` — Pure domain logic, no framework dependencies
   - \`application/\` — Use cases, port interfaces
   - \`infrastructure/\` — Adapters (REST controllers, Kafka consumers, JPA repositories)
3. **Respect module boundaries** — If a shared type needs to change, update \`shared/\` and all dependent services
4. **Maintain test coverage** — If the fix changes behavior, update or add tests to maintain ≥80% coverage
5. **Follow naming conventions** — PascalCase classes, camelCase methods, SCREAMING_SNAKE_CASE constants
6. **Keep files under 300 lines** — If a fix would push a file over the limit, split appropriately
7. **No direct REST calls between services** — If the fix involves inter-service communication, use Kafka events

### Step 5: Verify the Fix

Run the appropriate verification commands:

\`\`\`bash
# For the specific module
./gradlew :services:<service-name>:build

# For compilation only (fast check)
./gradlew :services:<service-name>:compileJava

# For a specific failing test
./gradlew :services:<service-name>:test --tests "com.example.service.SomeTest"

# For integration tests specifically
./gradlew :services:<service-name>:integrationTest

# For Checkstyle
./gradlew :services:<service-name>:checkstyleMain

# For coverage verification
./gradlew :services:<service-name>:jacocoTestCoverageVerification

# For the full project build
./gradlew build

# For Docker image build
docker build -t <service-name>:local -f services/<service-name>/Dockerfile .
\`\`\`

If the fix involves shared libraries, verify all dependent modules:

\`\`\`bash
# Find dependents of a shared module
./gradlew :shared:domain-events:build
./gradlew build  # Full project to catch downstream breakage
\`\`\`

### Step 6: Report the Resolution

Provide a summary including:

1. **Error Category**: Which of the 9 categories the failure fell into
2. **Root Cause**: Specific explanation of why the build failed
3. **Fix Applied**: What files were changed and why
4. **Verification**: Which commands were run and their results
5. **Prevention**: How to avoid this failure in the future (e.g., add a CI check, update documentation, add to shared conventions)

## Common Build Fix Patterns

### Pattern: Missing Shared Module Dependency

\`\`\`kotlin
// In services/order-service/build.gradle.kts
dependencies {
    implementation(project(":shared:domain-events"))
    implementation(project(":shared:common-utils"))
}
\`\`\`

### Pattern: Spring Boot + Kafka Test Configuration

\`\`\`yaml
# src/test/resources/application-test.yml
spring:
  kafka:
    bootstrap-servers: \${spring.embedded.kafka.brokers:localhost:9092}
    consumer:
      auto-offset-reset: earliest
      group-id: test-group
\`\`\`

### Pattern: Testcontainers PostgreSQL Setup

\`\`\`java
@Testcontainers
@SpringBootTest
@ActiveProfiles("test")
class OrderRepositoryIntegrationTest {
    @Container
    static PostgreSQLContainer<?> postgres = new PostgreSQLContainer<>("postgres:15-alpine")
        .withDatabaseName("order_test")
        .withUsername("test")
        .withPassword("test");

    @DynamicPropertySource
    static void configureProperties(DynamicPropertyRegistry registry) {
        registry.add("spring.datasource.url", postgres::getJdbcUrl);
        registry.add("spring.datasource.username", postgres::getUsername);
        registry.add("spring.datasource.password", postgres::getPassword);
    }
}
\`\`\`

### Pattern: JaCoCo Coverage Exclusions

\`\`\`kotlin
// build.gradle.kts — exclude generated code and configuration classes
tasks.jacocoTestCoverageVerification {
    violationRules {
        rule {
            limit {
                minimum = "0.80".toBigDecimal()
            }
        }
    }
    classDirectories.setFrom(
        files(classDirectories.files.map {
            fileTree(it) {
                exclude(
                    "**/config/**",
                    "**/dto/**",
                    "**/*Application*",
                    "**/generated/**"
                )
            }
        })
    )
}
\`\`\`

### Pattern: Gradle Version Catalog Fix

\`\`\`toml
# gradle/libs.versions.toml
[versions]
spring-boot = "3.2.5"
spring-kafka = "3.1.4"
testcontainers = "1.19.7"
avro = "1.11.3"

[libraries]
spring-boot-starter-web = { module = "org.springframework.boot:spring-boot-starter-web" }
spring-kafka = { module = "org.springframework.kafka:spring-kafka", version.ref = "spring-kafka" }
testcontainers-postgresql = { module = "org.testcontainers:postgresql", version.ref = "testcontainers" }
testcontainers-kafka = { module = "org.testcontainers:kafka", version.ref = "testcontainers" }
\`\`\`

## Security Considerations

- Never expose database credentials, API keys, or secrets in build fix output
- If the fix involves \`application.yml\` or \`*.properties\`, ensure sensitive values use environment variable placeholders (\`\${VAR_NAME}\`)
- Fixes to files in \`**/security/**\` or \`**/auth/**\` paths require extra scrutiny — flag for human review
- Dependency additions must be from the approved dependency list (SOC 2 / PCI DSS compliance)
- If adding a new dependency, verify it does not introduce known CVEs: \`./gradlew dependencyCheckAnalyze\`

## Escalation

Escalate to a human developer when:

- The fix requires changes to \`infrastructure/production/**\` (Terraform, production K8s manifests)
- The failure is in security-sensitive code (\`**/security/**\`, \`**/auth/**\`)
- A new third-party dependency is needed that is not in the approved list
- The root cause is unclear after diagnostic steps
- The fix would require breaking changes to Kafka event schemas (backward compatibility)
- Multiple services need coordinated changes that affect production data flow`,

  'plugin/codeforge-spring-boot-microservices/skills/code-review/SKILL.md': `---
skill: code-review
version: 1.0.0
description: Performs thorough code review of Java/Spring Boot microservice changes with focus on hexagonal architecture, Kafka patterns, security compliance, and Spring Boot best practices
author: codeforge
tags:
  - code-review
  - java
  - spring-boot
  - kafka
  - security
  - quality
inputs:
  - name: scope
    type: string
    description: "Review scope: 'pr' for pull request diff, 'files' for specific files, 'service' for entire microservice module"
    required: true
  - name: target
    type: string
    description: "PR number, file paths (comma-separated), or service module name (e.g., order-service)"
    required: true
  - name: focus
    type: string
    description: "Optional review focus: 'security', 'performance', 'architecture', 'kafka', 'testing', 'all'"
    default: "all"
  - name: severity_threshold
    type: string
    description: "Minimum severity to report: 'critical', 'high', 'medium', 'low'"
    default: "low"
tools:
  - github
  - jira
  - filesystem
---

# Code Review Skill — Spring Boot Microservices

You are an expert Java/Spring Boot code reviewer for a financial services microservice platform. You review code with deep knowledge of hexagonal architecture, event-driven patterns with Kafka, Spring Boot 3.2, Java 21, and PCI DSS / SOC 2 compliance requirements.

## Review Process

### Step 1: Gather Context

Determine the scope of the review based on the \`scope\` input:

**If scope is \`pr\`:**
- Use the GitHub MCP tool to fetch the pull request diff for PR #\`{target}\`
- Retrieve the PR description, linked Jira tickets, and any existing review comments
- Identify which microservice modules are affected from the changed file paths

**If scope is \`files\`:**
- Read each file listed in \`{target}\` (comma-separated paths) from the filesystem
- Determine which service module each file belongs to based on path prefix under \`services/\`, \`shared/\`, \`gateway/\`, or \`schema-registry/\`

**If scope is \`service\`:**
- Read all source files under \`services/{target}/src/\` from the filesystem
- Also check for related changes in \`shared/\` and \`schema-registry/\` that reference this service's domain events

For all scopes, also read:
- The service's \`build.gradle.kts\` for dependency review
- Any modified \`application.yml\` or \`application-*.yml\` files
- Any modified Helm chart values under \`charts/{service-name}/\`
- The project rules at \`.claude/rules/java/testing.md\`

### Step 2: Identify Linked Requirements

- Extract Jira ticket references from branch names (pattern: \`type/TICKET-123-description\`) or PR descriptions
- Use the Jira MCP tool to fetch the ticket details: acceptance criteria, story points, linked epics
- Verify the code changes align with the ticket's acceptance criteria
- Flag any scope creep — changes that go beyond the ticket's requirements

### Step 3: Perform Architecture Review

Evaluate adherence to **Hexagonal Architecture (Ports & Adapters)**:

**Domain Layer** (\`domain/\` package):
- Domain entities must have NO Spring annotations (no \`@Entity\`, \`@Component\`, etc.)
- Domain logic must not import from \`infrastructure/\` or \`adapter/\` packages
- Value objects should be Java records or immutable classes
- Domain events must extend the shared base event class from \`shared/domain-events\`

**Port Layer** (\`port/\` package):
- Inbound ports (use cases) are interfaces in \`port/inbound/\`
- Outbound ports (repository, messaging) are interfaces in \`port/outbound/\`
- Ports must not contain implementation details or framework references

**Adapter Layer** (\`adapter/\` package):
- Inbound adapters (\`adapter/inbound/rest/\`, \`adapter/inbound/kafka/\`): REST controllers, Kafka consumers
- Outbound adapters (\`adapter/outbound/persistence/\`, \`adapter/outbound/kafka/\`): JPA repositories, Kafka producers
- Spring annotations belong ONLY in adapter and configuration classes
- JPA entities live in \`adapter/outbound/persistence/entity/\` — separate from domain entities with proper mappers

**Configuration** (\`config/\` package):
- Spring \`@Configuration\` classes wire ports to adapters
- Bean definitions should use constructor injection exclusively
- No field injection (\`@Autowired\` on fields) anywhere

Flag violations with severity **high** and provide the correct package/class placement.

### Step 4: Perform Kafka & Event-Driven Review

**Kafka Producers:**
- Verify events are published through an outbound port, not directly from domain logic
- Check that Kafka topic names follow the convention: \`{domain}.{entity}.{event-type}\` (e.g., \`payment.transaction.completed\`)
- Ensure event payloads match schemas registered in \`schema-registry/\`
- Verify idempotency keys are set on produced messages
- Check for proper error handling — failed publishes must not silently swallow exceptions
- Confirm transactional outbox pattern is used for critical events (especially payment-related)

**Kafka Consumers:**
- Verify \`@KafkaListener\` methods are in inbound adapter classes, not in domain or port layers
- Check consumer group IDs follow convention: \`{service-name}-{purpose}-group\`
- Ensure idempotent consumption — check for deduplication logic or idempotent consumer pattern
- Verify dead letter topic (DLT) configuration for failed message handling
- Check deserialization error handling (ErrorHandlingDeserializer or custom handler)
- Confirm manual acknowledgment mode for critical financial transactions
- Verify consumer does not perform synchronous REST calls to other services (all inter-service communication must be through Kafka)

**Event Schemas:**
- If new events are introduced, verify a corresponding schema exists in \`schema-registry/\`
- Check backward compatibility of schema changes (no removal of required fields)
- Ensure event versioning is handled (schema evolution strategy)

Flag direct REST calls between microservices with severity **critical** — this violates the architecture mandate.

### Step 5: Perform Spring Boot Review

**Spring Security:**
- Verify all REST endpoints have proper authorization annotations (\`@PreAuthorize\`, \`@Secured\`, or SecurityFilterChain config)
- Check that sensitive endpoints under \`**/security/**\` and \`**/auth/**\` have additional scrutiny
- Ensure no hardcoded credentials, API keys, or secrets in source code or properties files
- Verify secrets are loaded from environment variables or AWS Secrets Manager, not from \`application.yml\`
- Check CORS configuration is restrictive and appropriate
- Verify CSRF protection is properly configured for non-API endpoints
- Ensure input validation with \`@Valid\` and proper \`@Pattern\`/\`@Size\`/\`@NotNull\` constraints on all DTOs

**Spring Data JPA:**
- Check for N+1 query problems — verify \`@EntityGraph\` or \`JOIN FETCH\` where needed
- Ensure \`@Transactional\` boundaries are correct (on service/use-case layer, not on repository)
- Verify database migrations use Flyway with versioned scripts in \`db/migration/\`
- Check that each service uses ONLY its own database schema — no cross-service database access
- Verify pagination is used for list endpoints (\`Pageable\` parameter)

**Spring Actuator & Observability:**
- Verify health check endpoints are configured (\`/actuator/health\`)
- Check that custom health indicators exist for Kafka connectivity and database connectivity
- Ensure distributed tracing context propagation (Micrometer Tracing / OpenTelemetry) is not broken
- Verify structured logging with correlation IDs (traceId, spanId) in log statements

**Spring Profiles:**
- Verify environment-specific config uses Spring Profiles (\`application-dev.yml\`, \`application-staging.yml\`, \`application-prod.yml\`)
- Ensure no production credentials or URLs appear in non-production profile files
- Check that \`@Profile\` annotations are used correctly for environment-specific beans

**Dependency Injection:**
- All injection must be constructor-based — flag any \`@Autowired\` field injection
- Verify \`@RequiredArgsConstructor\` (Lombok) or explicit constructors are used
- Check for circular dependencies

### Step 6: Perform Java 21 & Code Quality Review

**Java 21 Features:**
- Encourage use of records for DTOs and value objects
- Encourage use of sealed interfaces/classes for domain type hierarchies
- Check for proper use of pattern matching (\`instanceof\` pattern matching, switch expressions)
- Encourage virtual threads for I/O-bound operations where appropriate (Spring Boot 3.2 support)

**Code Quality:**
- Verify files do not exceed 300 lines — flag violations with severity **medium**
- Check naming conventions: PascalCase (classes), camelCase (methods/variables), SCREAMING_SNAKE_CASE (constants)
- Ensure no raw types in generics usage
- Check for proper null handling — prefer \`Optional\` for return types, \`@NonNull\`/\`@Nullable\` annotations
- Verify no \`System.out.println\` or \`System.err.println\` — use SLF4J logger
- Check for proper exception handling — no empty catch blocks, no catching \`Exception\` or \`Throwable\` broadly
- Ensure custom exceptions extend a service-specific base exception class
- Verify proper use of HTTP status codes in REST controllers
- Check that REST controllers are thin — business logic belongs in use case implementations

**Lombok Usage:**
- Acceptable: \`@RequiredArgsConstructor\`, \`@Getter\`, \`@Builder\`, \`@Slf4j\`
- Discouraged: \`@Data\` on JPA entities (breaks equals/hashCode), \`@Setter\` (prefer immutability)
- Forbidden: \`@AllArgsConstructor\` on domain entities (use builder or factory methods)

### Step 7: Perform Security & Compliance Review (SOC 2 / PCI DSS)

**PCI DSS Requirements:**
- Verify no PAN (Primary Account Number), CVV, or full card data is logged anywhere
- Check that sensitive financial data is masked in log statements
- Ensure encryption at rest for sensitive fields (check for \`@Convert\` with encryption converter)
- Verify audit logging for all financial transactions (who, what, when, from where)
- Check that authentication tokens have appropriate expiration times
- Ensure TLS is enforced for all external communication

**SOC 2 Requirements:**
- Verify audit trail — all state-changing operations should produce audit events
- Check for proper access control on administrative endpoints
- Ensure data retention policies are respected in database queries
- Verify that PII (Personally Identifiable Information) is handled according to data classification

**Sensitive Path Review:**
- Files under \`**/security/**\`, \`**/auth/**\`, \`infrastructure/production/**\`, and \`*.properties\` require extra scrutiny
- Flag any changes to security configuration with severity **critical** for mandatory senior review
- Verify changes to authentication/authorization logic have corresponding security tests

### Step 8: Perform Testing Review

**Unit Tests (JUnit 5 + Mockito):**
- Verify new public methods have corresponding unit tests
- Check that domain logic tests do NOT use Spring context (\`@SpringBootTest\`) — pure unit tests only
- Ensure mocks are used for outbound ports in use case tests
- Verify test naming convention: \`should_ExpectedBehavior_When_Condition\`
- Check for proper use of \`@ParameterizedTest\` for multiple input scenarios
- Ensure assertions are specific — no bare \`assertTrue(result != null)\`, use \`assertThat\` (AssertJ)

**Integration Tests (Testcontainers):**
- Verify adapter tests use Testcontainers for PostgreSQL, Kafka, and Redis
- Check that \`@Testcontainers\` and \`@Container\` annotations are properly configured
- Ensure integration tests are tagged with \`@Tag("integration")\` for CI pipeline separation
- Verify Kafka integration tests check both production and consumption of events

**Contract Tests (Pact):**
- If REST API changes are made, verify Pact provider tests are updated
- If Kafka event schemas change, verify Pact message contract tests exist
- Check that contract test results are published to the Pact Broker

**Coverage:**
- Estimate if changes maintain the 80% coverage threshold
- Flag untested critical paths (especially in payment, auth, and transaction flows) with severity **critical**

### Step 9: Perform Infrastructure Review (if applicable)

If changes include files under \`infrastructure/\`, \`charts/\`, or Dockerfiles:

**Dockerfile:**
- Verify multi-stage builds are used
- Check base image is from approved list (Eclipse Temurin JDK 21)
- Ensure no secrets are copied into the image
- Verify the application runs as a non-root user
- Check that health check instructions are present

**Helm Charts:**
- Verify resource limits (CPU, memory) are set
- Check that liveness and readiness probes point to Actuator health endpoints
- Ensure secrets are referenced from Kubernetes Secrets, not hardcoded in values
- Verify HPA (Horizontal Pod Autoscaler) configuration is present for production

**Terraform:**
- Flag any changes to production infrastructure with severity **critical**
- Verify state is managed remotely (S3 backend)
- Check for proper tagging of AWS resources

### Step 10: Compile Review Report

Organize findings into the following structure:

\`\`\`
## Code Review Summary

**PR/Scope**: {description}
**Service(s)**: {affected services}
**Jira Ticket(s)**: {linked tickets}
**Review Focus**: {focus area}
**Overall Assessment**: APPROVE / REQUEST_CHANGES / NEEDS_DISCUSSION

## Critical Issues (must fix before merge)
- [{severity}] {file}:{line} — {description}
  **Why**: {explanation referencing architecture rule or compliance requirement}
  **Fix**: {concrete suggestion with code example}

## High Issues (should fix before merge)
...

## Medium Issues (recommended improvements)
...

## Low Issues (suggestions for future improvement)
...

## Positive Observations
- {things done well — reinforce good patterns}

## Architecture Compliance
- [ ] Hexagonal architecture boundaries respected
- [ ] No direct inter-service REST calls
- [ ] Kafka events match registered schemas
- [ ] Domain layer free of framework dependencies

## Security & Compliance
- [ ] No secrets in source code
- [ ] Sensitive data properly masked in logs
- [ ] Authorization on all endpoints
- [ ] Audit trail for state changes
- [ ] PCI DSS requirements met

## Testing
- [ ] Unit tests for new logic
- [ ] Integration tests with Testcontainers
- [ ] Contract tests updated (if API/event changes)
- [ ] Estimated coverage >= 80%
\`\`\`

Filter findings based on \`{severity_threshold}\` — only include findings at or above the specified severity level.

### Step 11: Submit Review

**If scope is \`pr\`:**
- Use the GitHub MCP tool to post the review summary as a PR comment
- For critical and high issues, post inline review comments on the specific lines
- Set the review status: APPROVE if no critical/high issues, REQUEST_CHANGES otherwise
- If security-sensitive files are changed, add a comment tagging the security team for mandatory review

**If scope is \`files\` or \`service\`:**
- Output the review report directly
- If critical issues are found, recommend creating a Jira ticket for tracking remediation

## Review Principles

1. **Be specific**: Reference exact file paths, line numbers, class names, and method names
2. **Be constructive**: Every criticism must include a concrete fix suggestion with a code example
3. **Be proportional**: Don't nitpick formatting if Checkstyle/ktlint handles it — focus on logic, architecture, and security
4. **Be educational**: Explain WHY something is an issue, especially for patterns that junior developers may not recognize
5. **Respect the architecture**: The hexagonal architecture and Kafka-only inter-service communication are non-negotiable constraints
6. **Prioritize security**: In a financial services context, security issues always take precedence
7. **Acknowledge good work**: Call out well-implemented patterns to reinforce team standards`,

  'plugin/codeforge-spring-boot-microservices/skills/phase/SKILL.md': `---
skill: phase
version: "1.0"
description: "Navigate development methodology phases for Spring Boot microservice features — from discovery through deployment"
triggers:
  - "phase"
  - "workflow"
  - "methodology"
  - "next phase"
  - "start phase"
arguments:
  phase_name:
    type: string
    required: true
    enum:
      - discovery
      - design
      - implement
      - test
      - review
      - deploy
    description: "The development phase to execute"
  service_name:
    type: string
    required: false
    description: "Target microservice (e.g., order-service, payment-service, user-service)"
  ticket_id:
    type: string
    required: false
    description: "Jira ticket ID (e.g., PAY-123, ORD-456)"
  context:
    type: string
    required: false
    description: "Additional context about the work being done"
tags:
  - methodology
  - workflow
  - spring-boot
  - microservices
  - sdlc
mcp_servers:
  - jira
  - github
  - slack
---

# Skill: Phase — Spring Boot Microservice Development Workflow

You are guiding a developer through a structured development methodology for the **spring-boot-microservices** platform. Each phase has specific inputs, activities, outputs, and quality gates that must be satisfied before proceeding.

## Context Gathering

Before starting any phase, establish context:

1. **Identify the ticket** — use Jira MCP to fetch ticket details if \`ticket_id\` is provided
2. **Identify the service** — determine which module under \`services/\` is affected
3. **Check current state** — look at the branch, existing code, and any prior phase artifacts
4. **Understand dependencies** — identify Kafka topics, shared schemas, or other services involved

## Phase Definitions

### Phase 1: Discovery

**Goal**: Understand the problem space, gather requirements, and identify technical constraints.

**Activities**:
1. Fetch the Jira ticket details and acceptance criteria using Jira MCP
2. Read relevant architecture docs in \`docs/ARCHITECTURE.md\` and any ADRs in \`docs/adr/\`
3. Identify which microservice(s) are affected under \`services/{service_name}/\`
4. Check if new Kafka events or schema changes are needed in \`schema-registry/\`
5. Review existing domain model in \`services/{service_name}/src/main/java/**/domain/\`
6. Identify PCI DSS or SOC 2 compliance implications if touching \`**/security/**\` or \`**/auth/**\` paths
7. List external service dependencies and Kafka topic interactions

**Outputs**:
- Summary of requirements and acceptance criteria
- List of affected services and modules
- Kafka event flow diagram (text-based)
- Compliance considerations (if any)
- Open questions for the team

**Quality Gate**:
- [ ] All acceptance criteria are understood and unambiguous
- [ ] Affected services and Kafka topics are identified
- [ ] Compliance implications are documented
- [ ] No blocking open questions remain

**Example prompt to developer**:
\`\`\`
I've analyzed ticket {ticket_id}. Here's what I found:

**Service**: services/{service_name}
**Kafka Topics Involved**: {topic_name}.events.v1
**Schema Changes**: {yes/no — details}
**Compliance Notes**: {PCI DSS / SOC 2 considerations}
**Dependencies**: {other services, shared libraries}

Shall I proceed to the Design phase?
\`\`\`

---

### Phase 2: Design

**Goal**: Define the technical approach using Hexagonal Architecture patterns.

**Activities**:
1. Design the domain model changes — entities, value objects, aggregates
2. Define ports (interfaces) in \`domain/port/\` — both inbound (driving) and outbound (driven)
3. Design adapters:
   - **Inbound**: REST controllers in \`adapter/inbound/rest/\`, Kafka consumers in \`adapter/inbound/kafka/\`
   - **Outbound**: JPA repositories in \`adapter/outbound/persistence/\`, Kafka producers in \`adapter/outbound/kafka/\`
4. Define or update Kafka event schemas in \`schema-registry/\`
5. Design database migration scripts (Flyway) in \`src/main/resources/db/migration/\`
6. Plan Spring Security configuration if auth changes are needed
7. Define the API contract — OpenAPI spec in \`services/{service_name}/src/main/resources/openapi/\`

**Outputs**:
- Package structure and class diagram (text-based)
- Port and adapter interface definitions
- Kafka event schema (Avro or JSON Schema)
- Database migration plan
- OpenAPI spec changes
- Spring Profile configuration needs

**Quality Gate**:
- [ ] Hexagonal architecture boundaries are respected — no domain-to-infrastructure leakage
- [ ] All inter-service communication uses Kafka — no direct REST calls between services
- [ ] Event schemas are backward-compatible
- [ ] Database changes are additive (no destructive migrations)
- [ ] File length projections stay under 300 lines per file

**Hexagonal Architecture Reference**:
\`\`\`
services/{service_name}/src/main/java/com/company/{service}/
├── domain/
│   ├── model/          # Entities, Value Objects, Aggregates
│   ├── port/
│   │   ├── inbound/    # Use case interfaces (driving ports)
│   │   └── outbound/   # Repository & messaging interfaces (driven ports)
│   └── service/        # Domain service implementations
├── adapter/
│   ├── inbound/
│   │   ├── rest/       # Spring MVC controllers
│   │   └── kafka/      # Kafka consumer adapters
│   └── outbound/
│       ├── persistence/ # JPA repository implementations
│       └── kafka/       # Kafka producer adapters
├── config/             # Spring configuration, beans, profiles
└── Application.java
\`\`\`

---

### Phase 3: Implement

**Goal**: Write production code following TDD, project conventions, and compliance requirements.

**Activities**:
1. Create the feature branch: \`feat/{ticket_id}-{description}\`
2. Start with domain model — entities and value objects first (no framework dependencies)
3. Define inbound ports (use case interfaces)
4. Implement domain services against ports
5. Write outbound port interfaces
6. Implement adapters:
   - REST controllers with proper Spring Security annotations
   - Kafka consumers with \`@KafkaListener\` and proper error handling / DLT configuration
   - Kafka producers using \`KafkaTemplate\` with the schema registry
   - JPA repositories with Spring Data
7. Add Flyway migration scripts with proper versioning: \`V{timestamp}__{description}.sql\`
8. Configure Spring Profiles for environment-specific settings
9. Add Actuator health indicators for new dependencies
10. Update the service's \`build.gradle.kts\` with any new dependencies (from approved list only)

**Coding Standards Enforcement**:
- Run \`./gradlew checkstyleMain\` for Java style compliance
- Run \`./gradlew ktlintCheck\` for Kotlin files
- Ensure google-java-format is applied
- Keep all files under 300 lines
- Use conventional naming: PascalCase classes, camelCase methods, SCREAMING_SNAKE_CASE constants
- Add \`// AI-ASSISTED\` comment to AI-generated code blocks

**Key Patterns**:
\`\`\`java
// Domain entity — no Spring annotations
public class Payment {
    private final PaymentId id;
    private final Money amount;
    private PaymentStatus status;
    // Domain logic here
}

// Inbound port
public interface ProcessPaymentUseCase {
    PaymentResult process(ProcessPaymentCommand command);
}

// Outbound port
public interface PaymentRepository {
    Optional<Payment> findById(PaymentId id);
    Payment save(Payment payment);
}

// Kafka event (defined in schema-registry/)
public record PaymentProcessedEvent(
    String paymentId,
    String orderId,
    BigDecimal amount,
    String currency,
    Instant processedAt
) {}
\`\`\`

**Quality Gate**:
- [ ] Code compiles: \`./gradlew :services:{service_name}:compileJava\`
- [ ] Checkstyle passes: \`./gradlew :services:{service_name}:checkstyleMain\`
- [ ] No direct REST calls to other services — Kafka only
- [ ] Domain layer has zero framework imports
- [ ] All files under 300 lines
- [ ] AI-generated code is marked with \`// AI-ASSISTED\`
- [ ] Dependencies are from the approved list

---

### Phase 4: Test

**Goal**: Achieve comprehensive test coverage with unit, integration, and contract tests.

**Activities**:
1. **Unit Tests** (JUnit 5 + Mockito):
   - Test domain services in isolation — mock all outbound ports
   - Test domain model invariants and business rules
   - Location: \`src/test/java/**/domain/\`
   - Run: \`./gradlew :services:{service_name}:test\`

2. **Integration Tests** (Testcontainers):
   - Test adapters with real infrastructure (PostgreSQL, Kafka, Redis)
   - Use \`@SpringBootTest\` with Testcontainers for database and Kafka
   - Test Flyway migrations against real PostgreSQL
   - Test Kafka consumer/producer with embedded Kafka or Testcontainers
   - Location: \`src/test/java/**/adapter/\`
   - Run: \`./gradlew :services:{service_name}:integrationTest\`

3. **Contract Tests** (Pact):
   - Define consumer-driven contracts for REST APIs
   - Define Kafka message contracts for event schemas
   - Location: \`tests/contract/\`
   - Run: \`./gradlew :tests:contract:test\`

4. **Coverage Check** (JaCoCo):
   - Verify 80% minimum coverage threshold
   - Run: \`./gradlew :services:{service_name}:jacocoTestCoverageVerification\`

**Test Patterns**:
\`\`\`java
// Unit test — domain service
@ExtendWith(MockitoExtension.class)
class PaymentServiceTest {
    @Mock private PaymentRepository paymentRepository;
    @Mock private PaymentEventPublisher eventPublisher;
    @InjectMocks private PaymentService paymentService;

    @Test
    void shouldProcessPaymentAndPublishEvent() {
        // Given, When, Then
    }
}

// Integration test — Testcontainers
@SpringBootTest
@Testcontainers
class PaymentRepositoryAdapterIT {
    @Container
    static PostgreSQLContainer<?> postgres = new PostgreSQLContainer<>("postgres:15-alpine");

    @DynamicPropertySource
    static void configureProperties(DynamicPropertyRegistry registry) {
        registry.add("spring.datasource.url", postgres::getJdbcUrl);
    }
}

// Kafka integration test
@SpringBootTest
@EmbeddedKafka(topics = {"payment.events.v1"})
class PaymentEventConsumerIT {
    @Autowired private KafkaTemplate<String, PaymentProcessedEvent> kafkaTemplate;
}
\`\`\`

**Quality Gate**:
- [ ] All unit tests pass: \`./gradlew :services:{service_name}:test\`
- [ ] All integration tests pass: \`./gradlew :services:{service_name}:integrationTest\`
- [ ] Contract tests pass: \`./gradlew :tests:contract:test\`
- [ ] JaCoCo coverage ≥ 80%
- [ ] No flaky tests (run twice to confirm)
- [ ] Testcontainers clean up properly

---

### Phase 5: Review

**Goal**: Prepare code for review, ensure compliance, and address feedback.

**Activities**:
1. Run the full quality pipeline locally:
   \`\`\`
   ./gradlew :services:{service_name}:check
   ./gradlew :services:{service_name}:jacocoTestCoverageVerification
   ./gradlew :services:{service_name}:spotbugsMain
   ./gradlew dependencyCheckAnalyze
   \`\`\`
2. Verify conventional commit messages on the branch
3. Ensure signed commits are present
4. Create the pull request using GitHub MCP:
   - Title follows: \`feat(service_name): description [TICKET-ID]\`
   - Description includes: what changed, why, Kafka topic changes, migration notes
   - Link to Jira ticket
   - Add labels: \`ai-assisted\` if AI was used
5. Run security scan — check for secrets, PCI DSS sensitive data exposure
6. Verify CODEOWNERS will route to correct reviewers
7. Check that \`**/security/**\` and \`**/auth/**\` changes flag for security team review
8. Update Jira ticket status to "In Review" via Jira MCP

**PR Description Template**:
\`\`\`markdown
## Summary
{What this PR does and why}

## Ticket
{TICKET-ID}: {ticket title}

## Changes
- **Service**: services/{service_name}
- **Kafka Topics**: {new/modified topics}
- **Database Migrations**: {V{version}__{name}.sql}
- **Schema Registry**: {new/modified event schemas}
- **API Changes**: {OpenAPI spec changes}

## Compliance
- [ ] No PCI DSS data exposed in logs
- [ ] Security annotations reviewed
- [ ] No secrets in configuration files

## Testing
- Unit tests: {count} added/modified
- Integration tests: {count} added/modified
- Contract tests: {count} added/modified
- Coverage: {percentage}%

## AI Disclosure
- [ ] AI-assisted code is marked with \`// AI-ASSISTED\`
- [ ] AI-generated code has been reviewed and understood
\`\`\`

**Quality Gate**:
- [ ] All CI checks pass (lint, compile, test, security scan)
- [ ] PR has proper description and ticket link
- [ ] At least 2 approvals obtained
- [ ] Security team approved (if security paths changed)
- [ ] No unresolved review comments
- [ ] Jira ticket updated

---

### Phase 6: Deploy

**Goal**: Deploy the service through staging and production with proper validation.

**Activities**:
1. **Staging Deployment** (auto-deploy on merge to main):
   - Docker image built and pushed to ECR: \`services/{service_name}/Dockerfile\`
   - Helm chart updated: \`charts/{service_name}/\`
   - Deployed to EKS staging namespace
   - Flyway migrations run automatically on startup
   - Kafka topic creation/update via Terraform if needed

2. **Staging Validation**:
   - Verify Actuator health endpoint: \`/actuator/health\`
   - Check Spring Boot startup logs in ELK
   - Verify Kafka consumer group registration
   - Run E2E tests: \`./gradlew :tests:e2e:test -Penv=staging\`
   - Check distributed traces in Jaeger
   - Monitor Prometheus metrics and Grafana dashboards

3. **Production Deployment** (manual approval required):
   - Trigger production deployment workflow
   - Rolling update via Kubernetes — zero downtime
   - Verify health checks and readiness probes
   - Monitor error rates in Grafana for 15 minutes
   - Verify Kafka consumer lag is within acceptable bounds

4. **Post-Deployment**:
   - Update Jira ticket to "Done" via Jira MCP
   - Notify team via Slack MCP
   - Update runbook in \`docs/runbooks/{service_name}.md\` if operational changes
   - Tag release if applicable

**Helm Chart Reference**:
\`\`\`
charts/{service_name}/
├── Chart.yaml
├── values.yaml              # Default values
├── values-staging.yaml      # Staging overrides
├── values-production.yaml   # Production overrides
└── templates/
    ├── deployment.yaml
    ├── service.yaml
    ├── configmap.yaml
    ├── secret.yaml
    ├── hpa.yaml
    └── ingress.yaml
\`\`\`

**Quality Gate**:
- [ ] Staging deployment successful
- [ ] Actuator health check returns UP
- [ ] E2E tests pass on staging
- [ ] No error rate spike in Grafana
- [ ] Kafka consumer lag stable
- [ ] Production deployment approved and executed
- [ ] Jira ticket closed
- [ ] Team notified

---

## Phase Navigation

When the developer asks to move between phases, validate that the current phase's quality gates are met before proceeding. If gates are not met, list the failing items and suggest remediation.

**Phase transitions**:
- \`discovery\` → \`design\`: All requirements understood, no blocking questions
- \`design\` → \`implement\`: Architecture approved, schemas defined
- \`implement\` → \`test\`: Code compiles, Checkst`,

  'plugin/codeforge-spring-boot-microservices/skills/plan/SKILL.md': `---
skill: plan
version: 1.0.0
description: Create a detailed implementation plan for a Spring Boot microservice feature or change
triggers:
  - plan
  - create plan
  - implementation plan
  - design plan
  - technical plan
inputs:
  - name: ticket_id
    description: Jira ticket ID (e.g., PAY-123)
    required: true
  - name: scope
    description: Brief description of the feature or change
    required: true
  - name: services_affected
    description: List of microservices impacted (e.g., order-service, payment-service)
    required: false
  - name: includes_kafka_events
    description: Whether new or modified Kafka events are involved
    required: false
    default: "false"
  - name: includes_db_migration
    description: Whether database schema changes are needed
    required: false
    default: "false"
outputs:
  - implementation_plan.md
  - Optional: event-schema drafts, migration outlines
tags:
  - planning
  - architecture
  - spring-boot
  - microservices
estimated_tokens: 4000-8000
---

# Skill: plan

Create a comprehensive implementation plan for a Spring Boot microservice feature, ensuring alignment with hexagonal architecture, Kafka event-driven patterns, and SOC 2 / PCI DSS compliance requirements.

## When to Use

- Starting work on a new Jira ticket that involves code changes
- Designing a new microservice or significant feature
- Planning cross-service changes that involve Kafka event flows
- Before writing any code — plan first, implement second

## Workflow

### Step 1: Gather Context

Fetch the Jira ticket details to understand requirements, acceptance criteria, and priority:

\`\`\`
Use the Jira MCP server to fetch ticket {ticket_id}:
- Summary, description, acceptance criteria
- Priority, story points, sprint
- Linked tickets and dependencies
- Comments from product or architecture team
\`\`\`

If \`services_affected\` was not provided, analyze the ticket to determine which services under \`services/\` are impacted. Check the existing service modules:

- \`services/order-service/\`
- \`services/payment-service/\`
- \`services/user-service/\`
- \`gateway/\`
- \`shared/\`

### Step 2: Analyze Existing Code

For each affected service, review:

1. **Domain model** — \`src/main/java/.../domain/\` — entities, value objects, aggregates
2. **Ports** — \`src/main/java/.../port/in/\` (use cases) and \`src/main/java/.../port/out/\` (driven ports)
3. **Adapters** — \`src/main/java/.../adapter/in/web/\` (REST controllers), \`src/main/java/.../adapter/in/kafka/\` (consumers), \`src/main/java/.../adapter/out/persistence/\` (repositories), \`src/main/java/.../adapter/out/kafka/\` (producers)
4. **Configuration** — \`src/main/resources/application.yml\`, \`application-{profile}.yml\`
5. **Existing tests** — unit tests, integration tests with Testcontainers, contract tests with Pact
6. **OpenAPI spec** — \`src/main/resources/openapi/\` for any API changes
7. **Helm chart** — \`charts/{service-name}/\` for deployment config changes

### Step 3: Identify Kafka Event Flows

If the change involves inter-service communication:

1. Check \`schema-registry/\` for existing Avro/JSON schemas
2. Map the event flow: producer service → Kafka topic → consumer service(s)
3. Identify if new topics, schemas, or consumer groups are needed
4. Verify event naming follows convention: \`{domain}.{entity}.{action}\` (e.g., \`payment.transaction.completed\`)
5. Check for idempotency requirements on consumers

**Important**: All inter-service communication MUST go through Kafka. No direct REST calls between services. If you find a design that requires synchronous cross-service calls, redesign using events or the API gateway for client-facing aggregation.

### Step 4: Assess Database Impact

If \`includes_db_migration\` is true or the ticket implies schema changes:

1. Review existing Flyway migrations in \`src/main/resources/db/migration/\`
2. Plan migration scripts following naming: \`V{version}__{description}.sql\`
3. Ensure migrations are backward-compatible (no column drops without deprecation)
4. Each service has its own PostgreSQL database — never share databases across services
5. Consider read model projections if the change affects query patterns

### Step 5: Security and Compliance Review

For every plan, evaluate:

1. **Authentication/Authorization** — Does this touch \`**/security/**\` or \`**/auth/**\` paths? If so, flag for security team review
2. **PCI DSS** — Does this handle cardholder data, payment tokens, or transaction amounts? Apply PCI DSS controls:
   - Data encryption at rest and in transit
   - Audit logging for all access to sensitive data
   - Input validation and output encoding
   - Principle of least privilege for service accounts
3. **SOC 2** — Ensure audit trail, change management documentation, and access controls
4. **Sensitive configuration** — No secrets in code or properties files; use AWS Secrets Manager or Spring Cloud Config with encryption

### Step 6: Generate the Plan

Produce a structured implementation plan in Markdown with the following sections:

\`\`\`markdown
# Implementation Plan: {ticket_id} — {brief title}

## Overview
Brief description of what this change accomplishes and why.

## Affected Services
| Service | Type of Change | Risk Level |
|---------|---------------|------------|
| {service} | {new feature / modification / config} | {low / medium / high} |

## Architecture Decisions
- Key design decisions and rationale
- Reference to hexagonal architecture layers affected
- Any ADR (Architecture Decision Record) needed → \`docs/adr/\`

## Kafka Event Design
(If applicable)
- New/modified topics and schemas
- Producer → Topic → Consumer mapping
- Idempotency and ordering guarantees
- Schema evolution strategy (backward/forward compatible)

## Database Changes
(If applicable)
- Migration scripts needed
- Index considerations
- Data backfill requirements

## API Changes
(If applicable)
- New/modified endpoints
- OpenAPI spec updates
- Breaking change assessment
- API versioning strategy

## Implementation Steps
Ordered list of discrete, reviewable units of work:
1. **Step title** — Description, files affected, estimated effort
2. ...

Each step should be a single PR where possible.

## Branch Strategy
- Base branch: \`main\`
- Feature branch: \`feat/{ticket_id}-{description}\`
- If multi-step: use stacked PRs or feature flags

## Testing Strategy
| Test Type | Scope | Tools |
|-----------|-------|-------|
| Unit | Domain logic, use cases | JUnit 5, Mockito |
| Integration | Repository, Kafka, REST | Testcontainers, Spring Boot Test |
| Contract | API contracts, event schemas | Pact |
| E2E | Full flow across services | tests/ directory |

- Coverage target: ≥80% on new code
- Specific edge cases and error scenarios to test

## Security Considerations
- Authentication/authorization changes
- PCI DSS implications
- Data sensitivity classification
- Audit logging requirements

## Observability
- New metrics to expose via Actuator/Prometheus
- Distributed tracing spans (Jaeger)
- Log events for ELK Stack
- Alerts or dashboards to update in Grafana

## Rollback Plan
- How to safely roll back if issues arise in staging or production
- Feature flag strategy if applicable
- Database migration rollback approach

## Dependencies and Risks
- External dependencies (other teams, services, infrastructure)
- Risk assessment and mitigation
- Timeline considerations

## Checklist Before Implementation
- [ ] Plan reviewed by at least one lead/senior engineer
- [ ] Kafka schema changes reviewed with schema-registry owners
- [ ] Security review scheduled (if touching auth/payment paths)
- [ ] Infrastructure changes coordinated with platform team
- [ ] ADR created for significant architecture decisions
\`\`\`

### Step 7: Validate the Plan

Before finalizing:

1. Verify all referenced files and directories exist in the repository
2. Confirm Gradle module dependencies are correct (\`shared\` → service modules)
3. Check that the plan respects the 300-line max file length convention — if implementation files would exceed this, plan to split them
4. Ensure naming conventions are followed: PascalCase classes, camelCase methods, kebab-case modules
5. Validate that no direct REST calls between services are proposed

### Step 8: Post the Plan

1. Save the plan to the PR description or as a comment on the Jira ticket
2. If using Slack, post a summary to the team channel for visibility
3. Tag reviewers based on CODEOWNERS for the affected services

## Tips

- **Start small**: Break large features into incremental steps that can each be merged independently
- **Event storming**: For complex Kafka flows, sketch the event timeline before coding
- **Shared library changes**: If modifying \`shared/\`, plan the release and version bump since all services depend on it
- **Spring Profiles**: Plan configuration for \`local\`, \`test\`, \`staging\`, and \`production\` profiles
- **Testcontainers**: For integration tests, plan which containers are needed (PostgreSQL, Kafka, Redis)
- **Helm values**: If deployment config changes, update \`charts/{service}/values.yaml\` and \`values-{env}.yaml\`

## Example Invocation

\`\`\`
/plan ticket_id=PAY-456 scope="Add refund processing to payment service" services_affected="payment-service,order-service" includes_kafka_events=true includes_db_migration=true
\`\`\`

This would produce a plan covering:
- New \`RefundRequest\` and \`RefundCompleted\` domain events in \`schema-registry/\`
- Flyway migration for \`refunds\` table in payment-service database
- New \`RefundUseCase\` port and \`RefundService\` implementation
- Kafka producer in payment-service, consumer in order-service to update order status
- REST endpoint \`POST /api/v1/payments/{id}/refund\` with OpenAPI spec
- PCI DSS review for handling refund amounts and original transaction references`,

  'plugin/codeforge-spring-boot-microservices/skills/tdd/SKILL.md': `---
skill: tdd
name: Test-Driven Development for Spring Boot Microservices
version: 1.0.0
description: >
  Red-Green-Refactor TDD workflow for Java 21 / Spring Boot 3.2 microservices
  using JUnit 5, Mockito, Testcontainers, and Pact contract tests.
triggers:
  - tdd
  - test-first
  - red-green-refactor
tags:
  - testing
  - java
  - spring-boot
  - junit5
  - testcontainers
  - pact
  - tdd
inputs:
  - name: feature
    description: Feature or behavior to implement via TDD
    required: true
  - name: service
    description: Target microservice module (e.g., order-service, payment-service)
    required: true
  - name: layer
    description: Architecture layer — domain, application, adapter-in, adapter-out
    required: false
    default: domain
  - name: test_types
    description: Comma-separated test types — unit, integration, contract
    required: false
    default: unit
---

# TDD Skill — Spring Boot Microservices

You are performing Test-Driven Development for a Spring Boot 3.2 / Java 21 microservice platform in the financial services domain. Follow the Red-Green-Refactor cycle strictly. Never write production code without a failing test first.

## Hexagonal Architecture Context

Each microservice follows Hexagonal Architecture (Ports & Adapters):

\`\`\`
services/{service}/src/main/java/com/fintech/{service}/
├── domain/              # Entities, Value Objects, Domain Events, Domain Services
│   ├── model/
│   ├── event/
│   ├── port/
│   │   ├── in/          # Driving ports (use cases)
│   │   └── out/         # Driven ports (repositories, event publishers)
│   └── service/         # Domain service implementations
├── application/         # Use case orchestration, command/query handlers
│   ├── command/
│   ├── query/
│   └── service/
└── adapter/
    ├── in/
    │   ├── web/         # REST controllers (Spring MVC)
    │   └── kafka/       # Kafka consumers
    └── out/
        ├── persistence/ # JPA repositories, entity mappers
        ├── kafka/       # Kafka producers
        └── redis/       # Redis cache adapters
\`\`\`

Test mirrors live under \`src/test/java/\` with the same package structure.

## TDD Cycle

### Phase 1: RED — Write a Failing Test

1. **Identify the behavior** from the feature description
2. **Choose the correct test type** based on the layer:
   - \`domain\` → Pure unit tests (no Spring context, no mocks of domain internals)
   - \`application\` → Unit tests with mocked ports (\`@ExtendWith(MockitoExtension.class)\`)
   - \`adapter-in/web\` → \`@WebMvcTest\` slice tests
   - \`adapter-in/kafka\` → \`@EmbeddedKafka\` or Testcontainers Kafka
   - \`adapter-out/persistence\` → \`@DataJpaTest\` with Testcontainers PostgreSQL
   - \`adapter-out/kafka\` → Testcontainers Kafka integration tests
   - \`contract\` → Pact consumer/provider tests
3. **Write the test FIRST** — it must fail with a clear assertion error or compilation error
4. **Use descriptive test names** following the pattern: \`should_ExpectedBehavior_When_Condition\`
5. **One assertion per test** — focused, atomic tests

### Phase 2: GREEN — Write Minimal Production Code

1. Write the **minimum code** to make the failing test pass
2. Do NOT add extra logic, optimizations, or edge cases yet
3. Hardcode values if that makes the test pass — we refactor next
4. Run \`./gradlew :services:{service}:test --tests "*{TestClass}*"\` to verify GREEN

### Phase 3: REFACTOR — Improve Design

1. Remove duplication in both test and production code
2. Extract methods, introduce value objects, apply domain patterns
3. Ensure all tests still pass: \`./gradlew :services:{service}:test\`
4. Check coverage: \`./gradlew :services:{service}:jacocoTestReport\`
5. Verify no Checkstyle violations: \`./gradlew :services:{service}:checkstyleMain checkstyleTest\`

### Phase 4: REPEAT

Continue the cycle for the next behavior. Build up the feature incrementally.

## Test Templates by Layer

### Domain Unit Test (Pure Java, No Framework)

\`\`\`java
package com.fintech.{service}.domain.service;

import static org.assertj.core.api.Assertions.assertThat;
import static org.assertj.core.api.Assertions.assertThatThrownBy;

import com.fintech.{service}.domain.model.*;
import com.fintech.{service}.domain.event.*;
import org.junit.jupiter.api.DisplayName;
import org.junit.jupiter.api.Nested;
import org.junit.jupiter.api.Test;
import java.math.BigDecimal;
import java.util.Currency;

@DisplayName("{DomainConcept} Domain Logic")
class {DomainConcept}Test {

    @Nested
    @DisplayName("when creating")
    class WhenCreating {

        @Test
        void should_CreateSuccessfully_When_ValidInputProvided() {
            // Arrange — set up inputs

            // Act — invoke domain logic

            // Assert — verify outcome
        }

        @Test
        void should_ThrowDomainException_When_InvalidInput() {
            // Arrange

            // Act & Assert
            assertThatThrownBy(() -> /* domain operation */)
                .isInstanceOf(DomainException.class)
                .hasMessageContaining("expected error detail");
        }
    }

    @Nested
    @DisplayName("when processing domain events")
    class WhenProcessingEvents {

        @Test
        void should_EmitEvent_When_StateTransitionOccurs() {
            // Arrange

            // Act

            // Assert — verify domain event was produced
            assertThat(aggregate.getDomainEvents())
                .hasSize(1)
                .first()
                .isInstanceOf(ExpectedDomainEvent.class);
        }
    }
}
\`\`\`

### Application Layer Test (Mocked Ports)

\`\`\`java
package com.fintech.{service}.application.service;

import static org.assertj.core.api.Assertions.assertThat;
import static org.mockito.ArgumentMatchers.any;
import static org.mockito.BDDMockito.given;
import static org.mockito.BDDMockito.then;

import com.fintech.{service}.domain.port.in.*;
import com.fintech.{service}.domain.port.out.*;
import org.junit.jupiter.api.BeforeEach;
import org.junit.jupiter.api.Test;
import org.junit.jupiter.api.extension.ExtendWith;
import org.mockito.InjectMocks;
import org.mockito.Mock;
import org.mockito.junit.jupiter.MockitoExtension;

@ExtendWith(MockitoExtension.class)
class {UseCase}ServiceTest {

    @Mock
    private {Repository}Port repository;

    @Mock
    private {EventPublisher}Port eventPublisher;

    @InjectMocks
    private {UseCase}Service useCase;

    @Test
    void should_PersistAndPublishEvent_When_CommandIsValid() {
        // Arrange
        var command = new {Command}(/* valid params */);
        given(repository.save(any())).willReturn(/* saved entity */);

        // Act
        var result = useCase.execute(command);

        // Assert
        assertThat(result).isNotNull();
        then(repository).should().save(any());
        then(eventPublisher).should().publish(any({DomainEvent}.class));
    }
}
\`\`\`

### Web Adapter Slice Test

\`\`\`java
package com.fintech.{service}.adapter.in.web;

import static org.mockito.BDDMockito.given;
import static org.springframework.test.web.servlet.request.MockMvcRequestBuilders.post;
import static org.springframework.test.web.servlet.result.MockMvcResultMatchers.*;

import com.fintech.{service}.domain.port.in.*;
import org.junit.jupiter.api.Test;
import org.springframework.beans.factory.annotation.Autowired;
import org.springframework.boot.test.autoconfigure.web.servlet.WebMvcTest;
import org.springframework.boot.test.mock.bean.MockBean;
import org.springframework.http.MediaType;
import org.springframework.security.test.context.support.WithMockUser;
import org.springframework.test.web.servlet.MockMvc;

@WebMvcTest({Controller}.class)
class {Controller}Test {

    @Autowired
    private MockMvc mockMvc;

    @MockBean
    private {UseCase}Port useCase;

    @Test
    @WithMockUser(roles = "SERVICE_USER")
    void should_Return201_When_ValidRequest() throws Exception {
        // Arrange
        given(useCase.execute(any())).willReturn(/* expected result */);

        // Act & Assert
        mockMvc.perform(post("/api/v1/{resource}")
                .contentType(MediaType.APPLICATION_JSON)
                .content("""
                    {
                        "field": "value"
                    }
                    """))
            .andExpect(status().isCreated())
            .andExpect(jsonPath("$.id").exists());
    }

    @Test
    void should_Return401_When_Unauthenticated() throws Exception {
        mockMvc.perform(post("/api/v1/{resource}")
                .contentType(MediaType.APPLICATION_JSON)
                .content("{}"))
            .andExpect(status().isUnauthorized());
    }
}
\`\`\`

### Persistence Adapter Integration Test (Testcontainers)

\`\`\`java
package com.fintech.{service}.adapter.out.persistence;

import static org.assertj.core.api.Assertions.assertThat;

import org.junit.jupiter.api.Test;
import org.springframework.beans.factory.annotation.Autowired;
import org.springframework.boot.test.autoconfigure.jdbc.AutoConfigureTestDatabase;
import org.springframework.boot.test.autoconfigure.orm.jpa.DataJpaTest;
import org.springframework.context.annotation.Import;
import org.springframework.test.context.DynamicPropertyRegistry;
import org.springframework.test.context.DynamicPropertySource;
import org.testcontainers.containers.PostgreSQLContainer;
import org.testcontainers.junit.jupiter.Container;
import org.testcontainers.junit.jupiter.Testcontainers;

@DataJpaTest
@Testcontainers
@AutoConfigureTestDatabase(replace = AutoConfigureTestDatabase.Replace.NONE)
@Import({PersistenceAdapter}.class)
class {PersistenceAdapter}Test {

    @Container
    static PostgreSQLContainer<?> postgres = new PostgreSQLContainer<>("postgres:16-alpine")
        .withDatabaseName("{service}_test")
        .withUsername("test")
        .withPassword("test");

    @DynamicPropertySource
    static void configureProperties(DynamicPropertyRegistry registry) {
        registry.add("spring.datasource.url", postgres::getJdbcUrl);
        registry.add("spring.datasource.username", postgres::getUsername);
        registry.add("spring.datasource.password", postgres::getPassword);
    }

    @Autowired
    private {PersistenceAdapter} adapter;

    @Test
    void should_PersistAndRetrieve_When_ValidEntity() {
        // Arrange
        var entity = /* build domain entity */;

        // Act
        adapter.save(entity);
        var found = adapter.findById(entity.getId());

        // Assert
        assertThat(found).isPresent();
        assertThat(found.get()).usingRecursiveComparison().isEqualTo(entity);
    }
}
\`\`\`

### Kafka Integration Test (Testcontainers)

\`\`\`java
package com.fintech.{service}.adapter.out.kafka;

import static org.assertj.core.api.Assertions.assertThat;
import static org.awaitility.Awaitility.await;

import java.time.Duration;
import org.junit.jupiter.api.Test;
import org.springframework.beans.factory.annotation.Autowired;
import org.springframework.boot.test.context.SpringBootTest;
import org.springframework.kafka.test.context.EmbeddedKafka;
import org.springframework.test.annotation.DirtiesContext;

@SpringBootTest
@EmbeddedKafka(
    partitions = 1,
    topics = {"{service}.events.{event-type}"},
    brokerProperties = {"listeners=PLAINTEXT://localhost:9092"}
)
@DirtiesContext
class {KafkaProducer}IntegrationTest {

    @Autowired
    private {KafkaProducer} producer;

    @Autowired
    private TestKafkaConsumer testConsumer;

    @Test
    void should_PublishEventToKafkaTopic_When_DomainEventOccurs() {
        // Arrange
        var event = new {DomainEvent}(/* params */);

        // Act
        producer.publish(event);

        // Assert
        await().atMost(Duration.ofSeconds(10)).untilAsserted(() ->
            assertThat(testConsumer.getReceivedEvents())
                .anyMatch(e -> e.getEventId().equals(event.getEventId()))
        );
    }
}
\`\`\`

### Pact Contract Test (Consumer Side)

\`\`\`java
package com.fintech.{service}.contract;

import au.com.dius.pact.consumer.dsl.PactDslWithProvider;
import au.com.dius.pact.consumer.junit5.PactConsumerTestExt;
import au.com.dius.pact.consumer.junit5.PactTestFor;
import au.com.dius.pact.core.model.V4Pact;
import au.com.dius.pact.core.model.annotations.Pact;
import org.junit.jupiter.api.Test;
import org.junit.jupiter.api.extension.ExtendWith;

@ExtendWith(PactConsumerTestExt.class)
@PactTestFor(providerName = "{provider-service}")
class {Consumer}ContractTest {

    @Pact(consumer = "{service}", provider = "{provider-service}")
    V4Pact createPact(PactDslWithProvider builder) {
        return builder
            .given("a valid resource exists")
            .uponReceiving("a request for the resource")
            .path("/api/v1/{resource}/{id}")
            .method("GET")
            .willRespondWith()
            .status(200)
            .body(/* expected body DSL */)
            .toPact(V4Pact.class);
    }

    @Test
    @PactTestFor(pactMethod = "createPact")
    void should_ConformToContract_When_ConsumingProviderAPI() {
        // Act — call the provider via the mock server

        // Assert — verify response matches contract
    }
}
\`\`\`

## TDD Workflow Rules

### Strict Ordering
1. **Always write the test first** — never skip to production code
2. **Run the test and confirm it fails** — state the failure reason explicitly
3. **Write minimal production code** — just enough to pass
4. **Run all tests in the module** — confirm nothing is broken
5. **Refactor** — improve design while keeping tests green

### Test Quality Standards
- Use **AssertJ** for fluent assertions (not JUnit assertions)
- Use **BDDMockito** (\`given\`/\`then\`) over standard Mockito (\`when\`/\`verify\`)
- Use **\`@Nested\`** classes to group related test scenarios
- Use **\`@DisplayName\`** for human-readable test descriptions
- Follow **Arrange-Act-Assert** pattern with clear section comments
- **No test should depend on another test** — full isolation
- **No \`Thread.sleep(`,

  'plugin/codeforge-spring-boot-microservices/skills/verify/SKILL.md': `---
skill: verify
version: "1.0"
description: "Run the full verification pipeline for a Spring Boot microservice — compile, lint, test, coverage, security scan, and contract validation"
trigger: manual
inputs:
  - name: service
    type: string
    required: true
    description: "Target microservice module name (e.g., order-service, payment-service, user-service, gateway)"
  - name: scope
    type: enum
    values: [quick, standard, full]
    default: standard
    description: "Verification depth — quick (compile+lint+unit), standard (+ integration + coverage), full (+ contract + security + schema)"
  - name: fix_issues
    type: boolean
    default: false
    description: "Attempt to auto-fix lint and formatting issues before verification"
tags:
  - verification
  - quality
  - ci-local
  - spring-boot
  - java
---

# Skill: verify

Run a structured verification pipeline against a Spring Boot microservice module, mirroring the CI stages defined in \`.github/workflows/ci.yml\`. This skill ensures code is ready for push and PR before leaving the developer's machine.

## Purpose

Catch build failures, lint violations, test regressions, coverage drops, security vulnerabilities, and contract mismatches locally — before they hit CI. This reduces feedback loops from ~8 minutes (CI round-trip) to ~2 minutes (local verify).

## When to Use

- Before pushing a branch or opening a PR
- After completing a TDD cycle (see \`skills/tdd/SKILL.md\`)
- After applying a build fix (see \`skills/build-fix/SKILL.md\`)
- When switching to a service you haven't touched recently
- As a final gate before requesting code review

## Verification Stages

### Stage 1: Compile (all scopes)

Compile the target service and its dependencies in the Gradle multi-module project.

\`\`\`
./gradlew :services:{service}:compileJava :services:{service}:compileKotlin --no-daemon
\`\`\`

If the service depends on shared libraries, also verify:

\`\`\`
./gradlew :shared:domain-events:compileJava :shared:common:compileJava --no-daemon
\`\`\`

**Pass criteria**: Zero compilation errors. Warnings are logged but do not block.

### Stage 2: Lint & Format (all scopes)

Run Checkstyle for Java sources and ktlint for any Kotlin sources in the module.

If \`fix_issues\` is true, run auto-fix first:

\`\`\`
./gradlew :services:{service}:ktlintFormat
\`\`\`

Then verify:

\`\`\`
./gradlew :services:{service}:checkstyleMain :services:{service}:checkstyleTest
./gradlew :services:{service}:ktlintCheck
\`\`\`

Also verify google-java-format compliance:

\`\`\`
./gradlew :services:{service}:verifyGoogleJavaFormat
\`\`\`

**Pass criteria**: Zero lint violations. If \`fix_issues\` was true and fixes were applied, report what changed.

### Stage 3: Unit Tests (all scopes)

Run JUnit 5 unit tests (excluding integration and contract tests):

\`\`\`
./gradlew :services:{service}:test --tests '*Test' --exclude-tags integration,contract,e2e -x integrationTest
\`\`\`

**Pass criteria**: All unit tests pass. Report count of tests run, passed, failed, skipped.

### Stage 4: Integration Tests (standard, full)

Run integration tests using Testcontainers. These require Docker to be running.

First, verify Docker is available:

\`\`\`
docker info > /dev/null 2>&1
\`\`\`

If Docker is not available, skip this stage with a warning — do not fail the entire verification.

Run integration tests:

\`\`\`
./gradlew :services:{service}:integrationTest
\`\`\`

Integration tests use Testcontainers to spin up:
- **PostgreSQL** container for the service's database
- **Kafka** container (via \`org.testcontainers:kafka\`) for event streaming tests
- **Redis** container for caching/session tests (if applicable)

**Pass criteria**: All integration tests pass. Report container startup times and total test duration.

### Stage 5: Code Coverage (standard, full)

Generate JaCoCo coverage report and check against the 80% threshold:

\`\`\`
./gradlew :services:{service}:jacocoTestReport :services:{service}:jacocoTestCoverageVerification
\`\`\`

Parse the report at \`services/{service}/build/reports/jacoco/test/html/index.html\` and extract:
- **Line coverage** percentage
- **Branch coverage** percentage
- **Class coverage** percentage

**Pass criteria**: Line coverage ≥ 80%, Branch coverage ≥ 80%. If below threshold, identify the top 5 classes with lowest coverage and suggest which ones to prioritize.

### Stage 6: Contract Tests (full only)

Run Pact contract tests to verify inter-service API contracts:

\`\`\`
./gradlew :services:{service}:pactTest
\`\`\`

If the service is a **provider**, also verify against published pacts:

\`\`\`
./gradlew :services:{service}:pactVerify
\`\`\`

Check that Pact files in \`tests/contracts/\` are up to date with the service's current API.

**Pass criteria**: All contract tests pass. No breaking changes to published contracts.

### Stage 7: Security Scan (full only)

Run OWASP dependency-check and SpotBugs security analysis:

\`\`\`
./gradlew :services:{service}:dependencyCheckAnalyze
./gradlew :services:{service}:spotbugsMain
\`\`\`

Check for:
- **Critical/High CVEs** in dependencies (OWASP)
- **Security bug patterns** in code (SpotBugs with FindSecBugs plugin)
- **Hardcoded secrets** or credentials in source files

For PCI DSS compliance, flag any of these patterns:
- Unencrypted storage of cardholder data
- Missing input validation on payment-related endpoints
- Direct database queries without parameterized statements
- Logging of sensitive fields (PAN, CVV, passwords)

For SOC 2 compliance, flag:
- Missing audit logging on state-changing operations
- Endpoints without authentication/authorization checks
- Missing rate limiting configuration

**Pass criteria**: Zero critical/high CVEs. Zero high-confidence security bugs. All compliance flags addressed.

### Stage 8: Schema Validation (full only)

Validate that Kafka event schemas in \`schema-registry/\` are compatible with the service's producers and consumers:

\`\`\`
./gradlew :schema-registry:validateSchemas
\`\`\`

Check that:
- All event classes annotated with \`@DomainEvent\` have a corresponding schema in \`schema-registry/avro/\` or \`schema-registry/json/\`
- Schema evolution is backward-compatible (no removed required fields, no type changes)
- Consumer group IDs follow the naming convention: \`{service-name}-{topic}-consumer\`
- Topic names follow the convention: \`{domain}.{entity}.{event-type}\` (e.g., \`payment.transaction.completed\`)

**Pass criteria**: All schemas valid and backward-compatible. No orphaned schemas or missing event definitions.

## Output Format

After running all applicable stages, produce a verification summary:

\`\`\`
╔══════════════════════════════════════════════════════════╗
║  VERIFY: {service} ({scope} scope)                       ║
╠══════════════════════════════════════════════════════════╣
║  1. Compile          ✅ PASS  (4.2s)                     ║
║  2. Lint & Format    ✅ PASS  (2.1s)                     ║
║  3. Unit Tests       ✅ PASS  47/47 passed (8.3s)        ║
║  4. Integration      ✅ PASS  12/12 passed (34.1s)       ║
║  5. Coverage         ✅ PASS  Line: 87% Branch: 83%      ║
║  6. Contract Tests   ⬜ SKIP  (standard scope)           ║
║  7. Security Scan    ⬜ SKIP  (standard scope)           ║
║  8. Schema Valid.    ⬜ SKIP  (standard scope)           ║
╠══════════════════════════════════════════════════════════╣
║  RESULT: PASS — Ready for push                           ║
║  Total time: 48.7s                                       ║
╚══════════════════════════════════════════════════════════╝
\`\`\`

If any stage fails, stop execution at that stage (unless it's a skippable stage like Docker-dependent integration tests) and provide:

1. **What failed**: Exact error output, trimmed to relevant lines
2. **Why it likely failed**: Analysis based on the error and recent changes
3. **How to fix**: Concrete steps, commands, or code changes
4. **Quick retry**: The exact Gradle command to re-run just the failed stage

## Interaction with Other Skills

- If **compile fails**, suggest running \`skills/build-fix\` to diagnose and resolve
- If **tests fail**, suggest running \`skills/tdd\` to fix the failing test or implementation
- If **code review issues** are anticipated from lint/coverage results, suggest running \`skills/code-review\` for a pre-review
- If **planning is needed** for larger fixes, suggest \`skills/plan\` to break down the work

## Sensitive Path Handling

When verifying services that touch sensitive paths (\`**/security/**\`, \`**/auth/**\`, \`*.properties\`), add extra checks:

- Ensure no secrets or credentials are present in committed files
- Verify Spring Security configuration classes have corresponding test coverage
- Check that \`application.properties\` and \`application-*.yml\` files use environment variable references (\`\${DB_PASSWORD}\`) instead of hardcoded values
- Flag any changes to authentication/authorization logic for mandatory security review per CODEOWNERS

## Environment Prerequisites

Before starting verification, check:

1. **Java 21** is available: \`java --version\` must show 21.x
2. **Docker** is running (for integration tests): \`docker info\`
3. **Gradle wrapper** exists: \`./gradlew --version\`
4. **Spring Profile** is set to \`test\`: verify \`SPRING_PROFILES_ACTIVE=test\` or that test configs exist at \`services/{service}/src/test/resources/application-test.yml\`

If any prerequisite is missing, report it clearly and skip dependent stages rather than failing with cryptic errors.

## Performance Tips

- Use \`--build-cache\` and \`--configuration-cache\` for faster Gradle builds
- Use \`--parallel\` for multi-module compilation
- For \`quick\` scope during active development, the full command is:
  \`\`\`
  ./gradlew :services:{service}:compileJava :services:{service}:checkstyleMain :services:{service}:test --parallel --build-cache
  \`\`\`
- Testcontainers reuse: ensure \`.testcontainers.properties\` has \`testcontainers.reuse.enable=true\` for faster integration test cycles`,

  'plugin/marketplace.json.example': `{
  "slug": "codeforge-spring-boot-microservices",
  "name": "CodeForge: Spring Boot Microservices",
  "version": "1.0.0",
  "description": "Enterprise-grade Claude Code plugin for event-driven Spring Boot microservice development with Kafka, Kubernetes, and hexagonal architecture. Built for fintech teams requiring SOC 2 and PCI DSS compliance.",
  "longDescription": "A comprehensive Claude Code plugin that accelerates Spring Boot 3.2 microservice development using Java 21 and Kotlin. Provides AI-powered agents, skills, and commands for the full development lifecycle — from architecture planning and TDD to code review, build troubleshooting, and production deployment verification.\\n\\nDesigned for medium-to-large backend teams building event-driven platforms on AWS with Kafka, PostgreSQL, Redis, and Kubernetes. Enforces hexagonal architecture, conventional commits, and financial services compliance standards throughout the workflow.",
  "author": {
    "name": "CodeForge",
    "email": "plugins@codeforge.dev",
    "url": "https://codeforge.dev"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/codeforge/spring-boot-microservices-plugin"
  },
  "license": "MIT",
  "keywords": [
    "spring-boot",
    "microservices",
    "java-21",
    "kotlin",
    "kafka",
    "event-driven",
    "hexagonal-architecture",
    "kubernetes",
    "helm",
    "aws",
    "postgresql",
    "redis",
    "fintech",
    "pci-dss",
    "soc2",
    "testcontainers",
    "gradle",
    "tdd",
    "domain-driven-design",
    "spring-security"
  ],
  "categories": [
    "backend",
    "microservices",
    "enterprise",
    "fintech",
    "devops"
  ],
  "compatibility": {
    "claudeCode": ">=1.0.0",
    "platforms": ["linux", "macos", "windows"]
  },
  "techStack": {
    "primaryLanguage": "Java 21",
    "secondaryLanguage": "Kotlin",
    "framework": "Spring Boot 3.2",
    "buildTool": "Gradle (Kotlin DSL)",
    "messaging": "Apache Kafka",
    "databases": ["PostgreSQL", "Redis"],
    "cloud": "AWS (EKS, RDS, ElastiCache, MSK)",
    "containerization": "Docker, Kubernetes, Helm",
    "iac": "Terraform"
  },
  "features": [
    {
      "name": "Architecture Planning Agent",
      "description": "AI agent that generates hexagonal architecture plans for new microservices, including port/adapter definitions, Kafka topic schemas, and Helm chart scaffolding"
    },
    {
      "name": "TDD Workflow",
      "description": "Red-green-refactor cycle guidance with JUnit 5, Mockito, and Testcontainers integration test generation"
    },
    {
      "name": "Automated Code Review",
      "description": "Multi-pass review covering Spring Boot patterns, Kafka consumer/producer correctness, security vulnerabilities, PCI DSS compliance, and hexagonal architecture adherence"
    },
    {
      "name": "Build Error Resolution",
      "description": "Intelligent Gradle build failure diagnosis covering dependency conflicts, Spring auto-configuration issues, Kafka serialization errors, and Testcontainers setup problems"
    },
    {
      "name": "Deployment Verification",
      "description": "Pre-deployment checklist validation including Actuator health endpoints, database migrations, Kafka topic provisioning, Helm chart linting, and security scan results"
    },
    {
      "name": "Playbook Phase Management",
      "description": "Structured development methodology with phases: Plan, Implement, Verify, Review, Deploy — each with Spring Boot-specific guidance"
    },
    {
      "name": "Compliance Guardrails",
      "description": "Automatic detection of SOC 2 and PCI DSS violations including unencrypted PII, missing audit logging, insecure credential handling, and non-compliant data retention"
    }
  ],
  "agents": [
    {
      "id": "planner",
      "name": "Planner Agent",
      "description": "Breaks Jira tickets into implementation tasks with Spring Boot and Kafka considerations"
    },
    {
      "id": "architect",
      "name": "Architect Agent",
      "description": "Designs hexagonal architecture for microservices with domain events, ports, and adapters"
    },
    {
      "id": "tdd-guide",
      "name": "TDD Guide Agent",
      "description": "Drives test-first development with JUnit 5, Testcontainers, and Pact contract tests"
    },
    {
      "id": "code-reviewer",
      "name": "Code Reviewer Agent",
      "description": "Reviews code for Spring Boot best practices, security, and compliance"
    },
    {
      "id": "build-error-resolver",
      "name": "Build Error Resolver Agent",
      "description": "Diagnoses and fixes Gradle build failures, Spring context errors, and test failures"
    }
  ],
  "commands": [
    {
      "name": "/plan",
      "description": "Generate an implementation plan from a Jira ticket or feature description"
    },
    {
      "name": "/tdd",
      "description": "Start a TDD cycle for a specific class, endpoint, or Kafka consumer"
    },
    {
      "name": "/build-fix",
      "description": "Diagnose and resolve Gradle build or test failures"
    },
    {
      "name": "/code-review",
      "description": "Run a comprehensive code review on staged or changed files"
    },
    {
      "name": "/verify",
      "description": "Validate deployment readiness across all quality gates"
    },
    {
      "name": "/phase",
      "description": "Navigate the development playbook phases"
    }
  ],
  "skills": [
    {
      "id": "plan",
      "name": "Implementation Planning"
    },
    {
      "id": "tdd",
      "name": "Test-Driven Development"
    },
    {
      "id": "build-fix",
      "name": "Build Failure Resolution"
    },
    {
      "id": "code-review",
      "name": "Code Review"
    },
    {
      "id": "verify",
      "name": "Deployment Verification"
    },
    {
      "id": "phase",
      "name": "Phase Management"
    }
  ],
  "hooks": {
    "preCommit": "Validates conventional commit format, runs Checkstyle/ktlint, checks for secrets",
    "prePush": "Runs unit tests, verifies coverage threshold (80%), checks branch naming",
    "postGenerate": "Adds AI-generated code markers, validates against approved dependency list"
  },
  "compliance": {
    "standards": ["SOC 2 Type II", "PCI DSS v4.0"],
    "features": [
      "Automatic PII detection in logs and responses",
      "Credential leak prevention in generated code",
      "Audit trail enforcement for financial transactions",
      "Encryption-at-rest and in-transit validation",
      "Access control pattern verification"
    ]
  },
  "metrics": {
    "installCount": 0,
    "rating": null,
    "reviews": []
  },
  "pricing": {
    "model": "free",
    "tier": "community"
  },
  "support": {
    "documentation": "https://codeforge.dev/plugins/spring-boot-microservices/docs",
    "issues": "https://github.com/codeforge/spring-boot-microservices-plugin/issues",
    "discussions": "https://github.com/codeforge/spring-boot-microservices-plugin/discussions",
    "slack": "https://codeforge-community.slack.com/channels/spring-boot-plugin"
  },
  "screenshots": [
    {
      "url": "https://codeforge.dev/plugins/spring-boot-microservices/screenshots/plan-command.png",
      "caption": "The /plan command breaking a Jira ticket into implementation tasks with hexagonal architecture guidance"
    },
    {
      "url": "https://codeforge.dev/plugins/spring-boot-microservices/screenshots/tdd-cycle.png",
      "caption": "TDD workflow generating JUnit 5 tests with Testcontainers for a Kafka consumer"
    },
    {
      "url": "https://codeforge.dev/plugins/spring-boot-microservices/screenshots/code-review.png",
      "caption": "Multi-pass code review catching a PCI DSS compliance issue in payment processing"
    },
    {
      "url": "https://codeforge.dev/plugins/spring-boot-microservices/screenshots/verify-output.png",
      "caption": "Deployment verification validating Helm charts, database migrations, and Kafka topic schemas"
    }
  ],
  "changelog": {
    "1.0.0": {
      "date": "2025-01-15",
      "changes": [
        "Initial release with 5 agents, 6 commands, and 6 skills",
        "Spring Boot 3.2 and Java 21 support",
        "Kafka event-driven architecture patterns",
        "Hexagonal architecture enforcement",
        "SOC 2 and PCI DSS compliance guardrails",
        "Testcontainers integration test generation",
        "Gradle multi-module project support",
        "Helm chart validation and scaffolding",
        "Pre-commit and pre-push hooks",
        "AI-generated code marking for audit trails"
      ]
    }
  }
}`,

};
